export const etaAlert = [
  '88 88',
  `
  <path fill-rule="evenodd" clip-rule="evenodd" d="M77 11V36.6667H51.3333L62.15 25.85C57.4933 21.23 51.0767 18.3333 44 18.3333C29.8467 18.3333 18.3333 29.8467 18.3333 44C18.3333 58.1533 29.8467 69.6667 44 69.6667C58.1533 69.6667 69.6667 58.1533 69.6667 44H77C77 62.2233 62.2233 77 44 77C25.7767 77 11 62.2233 11 44C11 25.7767 25.7767 11 44 11C53.13 11 61.38 14.7033 67.32 20.68L77 11ZM40.3333 47.6667V29.3333H45.8333V44.55L58.74 52.2133L55.9167 56.9067L40.3333 47.6667Z" fill="#EB5757" />
`,
];

export const successAlert = [
  '88 88',
  `
  <path fill-rule="evenodd" clip-rule="evenodd" d="M44.0002 7.33325C23.7497 7.33325 7.3335 23.7495 7.3335 43.9999C7.3335 64.2504 23.7497 80.6666 44.0002 80.6666C64.2506 80.6666 80.6668 64.2504 80.6668 43.9999C80.6668 23.7495 64.2506 7.33325 44.0002 7.33325ZM44.0002 73.3332C27.7998 73.3332 14.6668 60.2003 14.6668 43.9999C14.6668 27.7996 27.7998 14.6666 44.0002 14.6666C60.2005 14.6666 73.3335 27.7996 73.3335 43.9999C73.3335 60.2003 60.2005 73.3332 44.0002 73.3332ZM40.0401 49.0972L53.9001 30.7639H53.8635C55.0987 29.1438 57.4134 28.8319 59.0335 30.0672C60.6535 31.3025 60.9654 33.6172 59.7301 35.2372L42.9735 57.2372C42.2812 58.1364 41.2116 58.6645 40.0768 58.6672C38.9483 58.6733 37.8798 58.1593 37.1801 57.2739L28.2701 45.8705C27.0247 44.2707 27.312 41.9643 28.9118 40.7189C30.5116 39.4735 32.8181 39.7607 34.0635 41.3605L40.0401 49.0972Z" fill="#3AB876"/>
`,
];

export const sendMail = [
  '88 88',
  `
  <path d="M73.3332 14.6667H21.9998C17.9555 14.6667 14.6665 17.9557 14.6665 22.0001V40.3334H21.9998V29.3334L45.4665 46.9334C46.1014 47.4089 46.8733 47.6658 47.6665 47.6658C48.4597 47.6658 49.2316 47.4089 49.8665 46.9334L73.3332 29.3334V62.3334H43.9998V69.6667H73.3332C77.3775 69.6667 80.6665 66.3777 80.6665 62.3334V22.0001C80.6665 17.9557 77.3775 14.6667 73.3332 14.6667ZM47.6665 39.4167L24.4418 22.0001H70.8912L47.6665 39.4167Z" fill="#1E90FF"/>
  <path d="M7.3335 44H33.0002V51.3333H7.3335V44ZM14.6668 55H36.6668V62.3333H14.6668V55ZM25.6668 66H40.3335V73.3333H25.6668V66Z" fill="#1E90FF"/>
`,
];

export const finishRoute = [
  '48 48',
  `
  <g filter="url(#filter0_d)">
    <path fill="#333" fill-rule="evenodd" d="M43.5129 18.5933C41.5059 9.66774 33.5316 3 24 3 12.9543 3 4 11.9543 4 23s8.9543 20 20 20c9.5316 0 17.5059-6.6678 19.5129-15.5933v-8.8134z" clip-rule="evenodd"/>
    <path fill="#fff" fill-rule="evenodd" d="M4.15527 20.4956c.45385-3.6331 1.88219-6.9634 4.01514-9.7211 1.49866.3979 3.08319.5954 4.79229.5954.2016 0 .4032-.0138.6048-.0277.1512-.0104.3024-.0207.4536-.0253h.0104v10.5527c-4.47949 0-8.54281-1.0067-9.87623-1.374zM14.0322 32.4365V21.8732c4.581 0 9.8347-1.3751 10.3018-1.4973.0217-.0057.0331-.0087.0336-.0087v10.5633s-5.9045 1.506-10.3354 1.506zM24.3357 42.9973c-.1116.0018-.2233.0027-.3353.0027-1.6218 0-3.1985-.193-4.7084-.5574 2.6321-.4114 4.7233-.9587 5.0101-1.0338.0218-.0057.0332-.0086.0336-.0086v1.5971zM24.3354 3.00275C24.2238 3.00092 24.112 3 24 3c-3.6429 0-7.0583.97394-10 2.67564v5.39366c4.4309 0 10.3354-1.50603 10.3354-1.50603V3.00275z" clip-rule="evenodd"/>
    <path fill="#fff" d="M34.6941 8.26462c-.1453 0-.2698-.02121-.4151-.02121-3.3517 0-6.6723.66816-9.9099 1.37874V20.3763s3.1961-1.506 10.3354-1.506V8.26462h-.0104z"/>
    <path fill="#fff" fill-rule="evenodd" d="M14.0218 40.337c-3.5201-2.0303-6.3639-5.1018-8.11067-8.7938 1.82225.4166 4.65837.8922 8.11067.8922v7.9016z" clip-rule="evenodd"/>
    <path fill="#fff" d="M24.3522 41.3546c3.414-.753 6.6619-1.4424 9.9099-1.4424.1452 0 .2801.0212.415.0212V29.4126c-6.6411 0-10.3353 1.506-10.3353 1.506v10.436h.0104z"/>
    <path fill="#fff" fill-rule="evenodd" d="M42.5279 30.545c-1.827-.5386-4.5666-1.1238-7.8502-1.1238V18.8579c4.0781 0 7.1601.7954 8.8515 1.3681v7.1077c-.2447 1.1077-.5813 2.181-1.0013 3.2113zM37.8182 8.54074c-.9745-.11006-2.0259-.17743-3.14-.17743V6.08588c1.128.71357 2.1796 1.53686 3.14 2.45486z" clip-rule="evenodd"/>
  </g>
  <defs>
  <filter id="filter0_d" width="47.5292" height="48" x="0" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
    <feOffset dy="1"/>
    <feGaussianBlur stdDeviation="2"/>
    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
  </filter>
  </defs> 
`,
];

export const bell = [
  '48 48',
  `
  <path fill="#BD851D" d="M28.9892 36.9675c9.6303-3.9618 16.7681-8.7998 15.9428-10.8059-.8253-2.0061-9.3012-.4207-18.9314 3.5411-9.6303 3.9619-16.76808 8.7998-15.9428 10.8059.8253 2.0061 9.3012.4207 18.9314-3.5411z"/>
  <path fill="#844F15" d="M27.8254 34.104c4.709-1.9362 8.0456-4.6751 7.4526-6.1174-.5931-1.4424-4.8912-1.042-9.6002.8942-4.709 1.9362-8.0457 4.675-7.4526 6.1174.593 1.4423 4.8912 1.042 9.6002-.8942z"/>
  <path fill="#FBB041" d="M22.2588 36.06l-.6742-4.5225c-.1193-.798-1.1535-1.3088-2.3153-1.1348-1.1617.174-2.004.9615-1.8847 1.7618l.6757 4.5225c-2.2147.9337-3.6262 2.7045-3.3577 4.4932.3442 2.3085 3.3262 3.7725 6.666 3.2723 3.333-.498 5.7585-2.769 5.4165-5.0768-.2685-1.7902-2.136-3.069-4.53-3.3157"/>
  <path fill="#E09734" d="M17.0831 40.8225c-.267-1.7902 1.1475-3.561 3.357-4.4932l-.6758-4.5225c-.0727-.495.2265-.9863.7328-1.3283-.3983-.1172-.8178-.1438-1.2278-.078-1.1617.174-2.004.9615-1.8847 1.7618l.6757 4.5225c-2.2147.9337-3.6262 2.7045-3.3577 4.4932.3442 2.3085 3.3262 3.7725 6.666 3.2723.3982-.0606.7921-.1473 1.179-.2595-2.8253.0315-5.1608-1.344-5.4645-3.3683z"/>
  <path fill="#F9C178" d="M25.9798 39.5498c.0825.5595.0045 1.0987-.1935 1.5577-.0502.1125-.1072.2228-.1725.324-.237.3473-.882.951-.9885.4583-.0441-.2124-.1014-.4219-.1717-.627-.0357-.1005-.074-.2001-.1148-.2985-.459-1.395-1.4647-1.1925-2.2807-1.7303-.4043-.2437-.1178-.7942.099-1.056.072-.0997.1477-.189.225-.2707.3127-.3285.666-.531 1.0612-.5655.1165-.0167.2341-.0235.3518-.0203 1.056.0435 1.9957.9698 2.1847 2.2283"/>
  <path fill="#FBB041" d="M20.245 5.10676c.5423 1.317-.5655 3.0225-2.472 3.80475-1.911.7875-3.8947.354-4.437-.96375-.5422-1.317.564-3.0225 2.4758-3.807 1.9042-.78375 3.891-.35175 4.4332.966"/>
  <path fill="#F9C178" d="M19.1631 4.86075c.102.24675.0802.5235-.039.789-.0314.06734-.0672.13248-.1073.195-.1567.22125-.6052.663-.72.45375-.0723-.13992-.1674-.26689-.2812-.37575-.4448-.555-1.1963-.22125-1.8495-.28425-.324-.01875-.1448-.35025.0015-.5265.0487-.0645.099-.1245.156-.18225.2095-.23241.4715-.41138.7642-.522.0882-.03466.1778-.06568.2685-.093.8025-.22875 1.5788-.00975 1.8068.546"/>
  <path fill="#E09734" d="M16.0199 6.19724c-.2857-.693-.1732-1.4805.24-2.21625-.1518.04723-.3017.10053-.4492.15975-1.911.786-3.015 2.49-2.4758 3.807.5423 1.317 2.526 1.7505 4.437.96375.7013-.28725 1.2953-.70125 1.7385-1.17375-1.6095.1725-3.0225-.39675-3.4905-1.5405"/>
  <path fill="#FBB041" fill-rule="evenodd" d="M37.6423 22.5375c-2.964-1.4332-5.031-3.6405-6.6278-6.2992-1.5075-2.5178-2.7225-5.1773-3.8925-7.84879-.7087-1.6125-1.8937-2.2065-3.7395-2.07525-1.2673.09346-2.5226.30921-3.7485.64425-.7042.25425-1.404.51825-2.112.7875-.7575.333-1.5.66525-2.241 1.011-.3787.17775-.7575.357-1.1332.53775-.9575.56697-1.865 1.21434-2.7128 1.93504-1.404 1.2037-1.8292 2.4592-1.1977 4.1055 1.0477 2.7202 2.0557 5.463 2.7547 8.3175.7373 3.015.819 6.0375-.2782 9.141-.564 1.5952-1.245 3.1515-1.911 4.7137-.4275.9998-.83625 2.0025-.759 3.0743.1425.0817.2437.0397.3157-.1058.9225-1.845 2.6168-3.0487 4.2968-4.233 2.8935-2.04 6.045-3.6667 9.264-5.1735.7387-.3472 1.4865-.6757 2.241-1.0087.7702-.2963 1.5345-.5865 2.304-.8595 3.351-1.197 6.732-2.2575 10.224-2.8418 2.0257-.3412 4.0777-.6757 6.03-.0157.1552.054.255.0135.297-.144-.6968-.8153-1.6965-1.2413-2.7008-1.6515-1.5735-.6428-3.1515-1.2713-4.674-2.007" clip-rule="evenodd"/>
  <path fill="#F9C178" fill-rule="evenodd" d="M42.3079 24.5325c-1.5735-.6412-3.1515-1.2712-4.674-2.0055-2.964-1.4332-5.031-3.6412-6.6292-6.3007-1.5075-2.5178-2.7225-5.1773-3.8918-7.8473-.7087-1.614-1.8937-2.2065-3.7402-2.0745-1.2669.09222-2.5218.30748-3.747.64275-.7035.255-1.4033.519-2.112.789-.4223.18525-.8408.37875-1.2608.567.2685-.1005.5393-.204.8115-.303 1.2308-.3315 2.475-.552 3.7485-.64425 1.845-.1305 3.03.4635 3.7388 2.07825 1.1715 2.67075 2.385 5.32955 3.8917 7.84575 1.5983 2.6625 3.6653 4.8675 6.6293 6.3008 1.5225.7357 3.1012 1.3642 4.674 2.0055.3472.141.69.2925 1.023.453 1.3305-.144 2.658-.1425 3.942.291.1537.051.2542.0112.297-.1448-.6968-.819-1.6965-1.2442-2.7008-1.653z" clip-rule="evenodd"/>
  <path fill="#E09734" fill-rule="evenodd" d="M16.0875 34.4573c.6667-1.5638 1.347-3.1208 1.911-4.7145 1.0972-3.1035 1.0155-6.1268.2767-9.141-.6975-2.8508-1.707-5.592-2.7532-8.3175-.6315-1.6455-.2055-2.90179 1.1992-4.10704.0863-.07575.1778-.14625.267-.21825-.5752.258-1.1505.50775-1.716.77475-.3802.17775-.759.357-1.1347.537-.9571.56631-1.8641 1.21314-2.7113 1.93354-1.4055 1.2037-1.83072 2.4615-1.1977 4.1055 1.047 2.7225 2.0557 5.4667 2.754 8.3175.7387 3.015.8205 6.0375-.2783 9.1395-.564 1.596-1.2435 3.1515-1.9095 4.7167-.4275.9983-.83622 2.001-.759 3.0713.1425.0832.2415.0397.3143-.105.924-1.8443 2.6167-3.0473 4.2967-4.233.3375-.2355.6803-.4688 1.0245-.6968.1238-.357.2655-.7125.4163-1.065" clip-rule="evenodd"/>
  <path fill="#27AAE1" d="M46.6276 20.6647c-.261-.3787-.5198-.7575-.7778-1.1287-.0397-.06-.0547-.111-.0832-.165-.0345-.0585-.0728-.1178-.0975-.1838-.0405-.0989-.066-.2033-.0758-.3097-.0015-.0203-.0127-.039-.0157-.063-.2895-3.81-2.3798-7.6208-5.7623-10.299-1.8172-1.43925-2.208-.94575-3.552-2.898-.5482-.798-.1995-1.476.462-1.2225 6.0668 2.313 11.2095 9.78 11.2058 16.2712.0007.7088-.7575.7935-1.3035-.0015"/>
  <path fill="#27AAE1" d="M42.9072 21.3337l-.6383-.9255c-.033-.0502-.0457-.0862-.0712-.135-.0263-.0487-.0593-.099-.081-.1522-.0311-.0812-.0513-.1662-.06-.2528-.0015-.0172-.0098-.0345-.0128-.0517-.2355-3.1358-1.9582-6.2723-4.743-8.478-1.4932-1.1805-1.8142-.7793-2.919-2.38276-.453-.6585-.1672-1.2165.3788-1.00875 4.9935 1.9065 9.2227 8.04671 9.2212 13.39201.0008.5842-.6225.6502-1.0747-.0053M5.99097 35.7682l-.27225-1.3425c-.01425-.0705-.0405-.1177-.06-.1755-.01725-.0645-.0345-.1335-.0645-.198-.04388-.0972-.10147-.1876-.171-.2685-.01275-.0157-.02025-.0367-.033-.0547-2.541-2.8545-3.83175-7.0043-3.41025-11.295.2265-2.307.8535-2.2463.38175-4.569-.195-.9495-.9225-1.1693-1.20075-.5168-2.54925 5.9723-.749997 14.856 3.92625 19.3628.51075.4935 1.095.006.90375-.9405"/>
  <path fill="#27AAE1" d="M9.05248 33.5587c-.07575-.3645-.15075-.7387-.2235-1.1002-.01425-.06-.0315-.0945-.05025-.1448-.01575-.0532-.0285-.1125-.05175-.165-.03663-.0789-.08408-.1524-.141-.2182-.01125-.015-.01725-.0315-.027-.0473-2.09325-2.346-3.153-5.7652-2.80725-9.2977.18825-1.8953.69975-1.848.31275-3.7575-.15825-.7823-.759-.9653-.9885-.4275-2.097 4.9162-.6165 12.225 3.231 15.9352.42225.405.903.0023.7455-.7785"/>
`,
];

export const newBell = [
  '21.104 21.104',
  `
  <defs>
    <clipPath id="clip-path">
      <path
        style="fill: none"
        d="M-1376.954-332.113h1251.311v967.279h-1251.311z"
      />
    </clipPath>
    <style>
      .cls-4 {
        fill: none;
        stroke: #1e1e32;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.75px;
      }
      .cls-5 {
        fill: #e83679;
      }
    </style>
  </defs>
  <g style="clip-path: url(#clip-path)">
    <g style="opacity: 0.7">
      <path
        style="fill: none; stroke: #1e1e32; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.75px;"
        class="cls-4"
        d="M6.265 2.154 6.146.538C3.497-2.908-2.01-10.47-4.213-14.16M10.939-17.272C18.113-8.336 28.412 4.624 34.961 14.14c.06 2.806.209 11.497.804 14.12"
      />
    </g>
  </g>
  <path
    style="fill: #e83679"
    class="cls-5"
    d="M10.552 1A9.552 9.552 0 1 1 1 10.552 9.552 9.552 0 0 1 10.552 1m0-1a10.552 10.552 0 1 0 10.552 10.552A10.564 10.564 0 0 0 10.552 0Z"
  />
  <path
    style="fill: #e83679"
    class="cls-5"
    d="M3.806 9.72c.028-.213.05-.428.087-.64a5.648 5.648 0 0 1 1.543-3.016.343.343 0 1 1 .488.466 5.04 5.04 0 0 0-1.12 1.753 5.098 5.098 0 0 0-.325 1.765.343.343 0 0 1-.311.362c-.15.015-.268-.071-.362-.263ZM13.412 11.183c0 .306-.002.613.003.92a.465.465 0 0 0 .045.191c.199.406.39.816.608 1.211a.36.36 0 0 1-.352.562c-.433-.016-.867-.001-1.301-.005-.085-.001-.12.02-.143.108a1.775 1.775 0 0 1-3.442-.007c-.022-.088-.061-.101-.138-.1-.437.002-.875-.01-1.313.004a.359.359 0 0 1-.345-.559c.217-.396.41-.805.608-1.211a.486.486 0 0 0 .047-.202c.006-.595-.02-1.191.015-1.784a2.741 2.741 0 0 1 1.49-2.34.728.728 0 0 0 .395-.425 1.01 1.01 0 0 1 1.04-.645 1.07 1.07 0 0 1 .958.83.198.198 0 0 0 .093.119 2.833 2.833 0 0 1 1.732 2.66c.005.224 0 .448 0 .673ZM7.858 13.38h5.39c-.146-.29-.291-.563-.419-.845a.944.944 0 0 1-.086-.363c-.01-.602.009-1.204-.013-1.806a2.172 2.172 0 0 0-1.483-1.96c-.248-.083-.304-.165-.315-.424a.535.535 0 0 0-.061-.232.365.365 0 0 0-.418-.163.379.379 0 0 0-.284.36c-.012.317-.047.364-.342.471a2.18 2.18 0 0 0-1.458 2.003c-.013.41-.026.824.001 1.233a2.129 2.129 0 0 1-.32 1.344 3.878 3.878 0 0 0-.192.382Zm3.733.693H9.513a1.09 1.09 0 0 0 2.078 0ZM17.298 9.93v.129a.336.336 0 1 1-.672.007 5.27 5.27 0 0 0-.15-1.21 5.035 5.035 0 0 0-1.26-2.292.737.737 0 0 1-.156-.215.332.332 0 0 1 .555-.334 8.81 8.81 0 0 1 .615.727 5.654 5.654 0 0 1 1.068 3.189ZM5.247 9.871A4.307 4.307 0 0 1 6.48 7.06a.347.347 0 0 1 .355-.113.316.316 0 0 1 .238.244.35.35 0 0 1-.114.345 3.582 3.582 0 0 0-.637.877 3.644 3.644 0 0 0-.4 1.583.784.784 0 0 1-.015.167.337.337 0 0 1-.345.248.342.342 0 0 1-.314-.326c-.004-.07 0-.142 0-.213ZM15.857 9.874v.191a.344.344 0 0 1-.34.346.335.335 0 0 1-.332-.34 3.748 3.748 0 0 0-.332-1.51 3.62 3.62 0 0 0-.71-1.029.347.347 0 0 1-.111-.345.316.316 0 0 1 .24-.242.343.343 0 0 1 .345.108A4.168 4.168 0 0 1 15.7 8.936c.079.306.118.622.175.934Z"
  />
`,
];

export const listView = [
  '18 12',
  `
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7071 1.7071C2.09763 1.31658 2.09763 0.683417 1.7071 0.292893C1.31658 -0.097631 0.683417 -0.097631 0.292893 0.292893C-0.097631 0.683413 -0.097631 1.31658 0.292893 1.7071C0.683413 2.09763 1.31658 2.09763 1.7071 1.7071ZM1.7071 6.70711C2.09763 6.31659 2.09763 5.68343 1.7071 5.2929C1.31658 4.90238 0.683417 4.90238 0.292893 5.2929C-0.097631 5.68342 -0.097631 6.31659 0.292893 6.70711C0.683413 7.09764 1.31658 7.09764 1.7071 6.70711ZM1.7071 10.2929C2.09763 10.6834 2.09763 11.3166 1.7071 11.7071C1.31658 12.0976 0.683413 12.0976 0.292893 11.7071C-0.097631 11.3166 -0.097631 10.6834 0.292893 10.2929C0.683417 9.90238 1.31658 9.90238 1.7071 10.2929ZM3.99999 6.06C3.99999 6.57915 4.42085 7 4.93999 7H17.06C17.5791 7 18 6.57915 18 6.06V5.94C18 5.42086 17.5791 5 17.06 5H4.93999C4.42085 5 3.99999 5.42086 3.99999 5.94V6.06ZM4.93999 12C4.42085 12 3.99999 11.5791 3.99999 11.06V10.94C3.99999 10.4209 4.42085 10 4.93999 10H17.06C17.5791 10 18 10.4209 18 10.94V11.06C18 11.5791 17.5791 12 17.06 12H4.93999ZM3.99999 1.06C3.99999 1.57915 4.42085 2 4.93999 2H17.06C17.5791 2 18 1.57915 18 1.06V0.940003C18 0.42086 17.5791 3.00745e-06 17.06 3.00745e-06H4.93999C4.42085 3.00745e-06 3.99999 0.42086 3.99999 0.940003V1.06Z" fill="#E0E0E0"/>
`,
];

export const cardView = [
  '18 18',
  `
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0H6C7.10457 0 8 0.89543 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2C0 0.895431 0.89543 0 2 0ZM12 0H16C17.1046 0 18 0.89543 18 2V6C18 7.10457 17.1046 8 16 8H12C10.8954 8 10 7.10457 10 6V2C10 0.895431 10.8954 0 12 0ZM6 10H2C0.89543 10 0 10.8954 0 12V16C0 17.1046 0.895431 18 2 18H6C7.10457 18 8 17.1046 8 16V12C8 10.8954 7.10457 10 6 10ZM12 10H16C17.1046 10 18 10.8954 18 12V16C18 17.1046 17.1046 18 16 18H12C10.8954 18 10 17.1046 10 16V12C10 10.8954 10.8954 10 12 10Z" fill="#E0E0E0"/>
`,
];

export const calendar = [
  '25 28',
  `
<path xmlns="http://www.w3.org/2000/svg" d="M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"/>
`,
];

export const location = [
  '25 28',
  `
  <path d="M12 4c1.93 0 5 1.4 5 5.15 0 2.16-1.72 4.67-5 7.32-3.28-2.65-5-5.17-5-7.32C7 5.4 10.07 4 12 4m0-2C8.73 2 5 4.46 5 9.15c0 3.12 2.33 6.41 7 9.85 4.67-3.44 7-6.73 7-9.85C19 4.46 15.27 2 12 2z"/><path d="M12 7c-1.1 0-2 .9-2 2s.9 2 2 2a2 2 0 1 0 0-4zM5 20h14v2H5v-2z"/>
`,
];

export const map = [
  '25 28',
  `
  <path d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM10 5.47l4 1.4v11.66l-4-1.4V5.47zm-5 .99l3-1.01v11.7l-3 1.16V6.46zm14 11.08l-3 1.01V6.86l3-1.16v11.84z"/>
`,
];

export const newItem = [
  '18 17',
  `
  <path d="M17.0021 11.6283V1.90218C17.0021 0.94048 16.2225 0.160889 15.2608 0.160889H2.49129C1.52959 0.160889 0.75 0.94048 0.75 1.90218V14.6712C0.75 15.6329 1.52959 16.4125 2.49129 16.4125H12.2178C12.6796 16.4125 13.1225 16.2291 13.4491 15.9025L16.4921 12.8595C16.8186 12.533 17.0021 12.0901 17.0021 11.6283ZM12.3586 14.5304V11.7691H15.12L12.3586 14.5304ZM15.2608 1.90218V10.0278H11.488C11.0071 10.0278 10.6173 10.4176 10.6173 10.8984V14.6712H2.49129V1.90218H15.2608Z" fill="#FFCF74"/>
`,
];

export const people = [
  '25 28',
  `
  <path d="M16.67,13.13C18.04,14.06,19,15.32,19,17v3h4v-3C23,14.82,19.43,13.53,16.67,13.13z"/><path d="M15,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4c-0.47,0-0.91,0.1-1.33,0.24C14.5,5.27,15,6.58,15,8s-0.5,2.73-1.33,3.76 C14.09,11.9,14.53,12,15,12z"/><path d="M9,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4S5,5.79,5,8C5,10.21,6.79,12,9,12z M9,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2 S7,9.1,7,8C7,6.9,7.9,6,9,6z"/><path d="M9,13c-2.67,0-8,1.34-8,4v3h16v-3C17,14.34,11.67,13,9,13z M15,18H3l0-0.99C3.2,16.29,6.3,15,9,15s5.8,1.29,6,2V18z"/>
`,
];

export const sendMessage = [
  '19 18',
  `
  <path d="M18.5875 8.33263L2.08754 0.0826268C1.95821 0.0179519 1.81295 -0.00796197 1.66924 0.00800564C1.52554 0.0239732 1.38951 0.0811415 1.27754 0.172627C1.1706 0.262246 1.09079 0.379917 1.04707 0.51241C1.00334 0.644903 0.997446 0.786965 1.03004 0.922627L3.25004 9.00013L1.00004 17.0551C0.969455 17.1684 0.965886 17.2873 0.989614 17.4022C1.01334 17.5172 1.06371 17.6249 1.13665 17.7168C1.2096 17.8087 1.3031 17.8823 1.40964 17.9315C1.51617 17.9807 1.63276 18.0042 1.75004 18.0001C1.86744 17.9994 1.98304 17.9712 2.08754 17.9176L18.5875 9.66763C18.7104 9.60469 18.8135 9.50907 18.8855 9.39129C18.9575 9.27352 18.9956 9.13816 18.9956 9.00013C18.9956 8.86209 18.9575 8.72674 18.8855 8.60896C18.8135 8.49119 18.7104 8.39557 18.5875 8.33263ZM2.91254 15.8326L4.57004 9.75013H11.5V8.25013H4.57004L2.91254 2.16763L16.57 9.00013L2.91254 15.8326Z" fill="#115FFB"/>
`,
];

export const phone = [
  '20 20',
  `
  <path d="M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.84.84 0 0 0-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1z"/>
  `,
];

export const starEmpty = [
  '14.49 13.786',
  `<path
    d="M11.692 13.786a.05.05 0 0 1-.024-.006l-4.423-2.325-4.423 2.325a.049.049 0 0 1-.053-.004.048.048 0 0 1-.02-.049l.845-4.925L.015 5.314a.05.05 0 0 1 .027-.086L4.99 4.51 7.2.027a.053.053 0 0 1 .09 0L9.502 4.51l4.946.72a.05.05 0 0 1 .027.085l-3.579 3.488.845 4.925a.048.048 0 0 1-.02.05.047.047 0 0 1-.03.009Zm-4.447-2.438a.05.05 0 0 1 .024.006l4.356 2.29-.832-4.85a.05.05 0 0 1 .015-.045l3.525-3.436-4.872-.708a.052.052 0 0 1-.037-.027L7.245.163 5.067 4.578a.052.052 0 0 1-.038.027l-4.872.708L3.682 8.75a.05.05 0 0 1 .015.045l-.832 4.85 4.357-2.29a.05.05 0 0 1 .023-.006Z"
    style="fill:#c6c6c6"
    data-name="Layer 4"
  />`,
];

export const starFull = [
  '15.89 15.186',
  `<path
    d="M12.392 15.186a.75.75 0 0 1-.35-.086l-4.097-2.154L3.848 15.1a.75.75 0 0 1-1.089-.79l.783-4.563L.226 6.515a.75.75 0 0 1 .416-1.28l4.582-.665L7.273.417a.78.78 0 0 1 1.345 0l2.049 4.153 4.581.666a.75.75 0 0 1 .416 1.28l-3.315 3.23.782 4.563a.75.75 0 0 1-.739.877Zm-4.447-3.838a.747.747 0 0 1 .35.086l3.1 1.631-.591-3.453a.75.75 0 0 1 .215-.664l2.51-2.446-3.468-.504a.748.748 0 0 1-.565-.41l-1.55-3.144-1.552 3.143a.748.748 0 0 1-.565.41l-3.467.504L4.87 8.948a.75.75 0 0 1 .216.664l-.592 3.453 3.101-1.63a.747.747 0 0 1 .35-.087Z"
    style="fill:#f7dc38"
    data-name="Layer 4"
  />`,
];

export const time = [
  '25 28',
  `
<path xmlns="http://www.w3.org/2000/svg" d="M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zm4.837-6.19l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"/>
`,
];

export const eta = [
  '25 28',
  `
  <path d="M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 6h10.29l1.04 3H5.81l1.04-3zM19 16H5v-4.66l.12-.34h13.77l.11.34V16z"/><circle cx="7.5" cy="13.5" r="1.5"/><circle cx="16.5" cy="13.5" r="1.5"/>
`,
];

export const person = [
  '15 15',
  `
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.97593 4.63032C9.97593 5.91257 8.93646 6.95204 7.6542 6.95204C6.37195 6.95204 5.33248 5.91257 5.33248 4.63032C5.33248 3.34806 6.37195 2.30859 7.6542 2.30859C8.93646 2.30859 9.97593 3.34806 9.97593 4.63032ZM11.7172 12.1759C11.7172 12.4965 11.4574 12.7564 11.1368 12.7564H4.17162C3.85105 12.7564 3.59119 12.4965 3.59119 12.1759C3.59119 9.93198 5.41026 8.11291 7.6542 8.11291C9.89815 8.11291 11.7172 9.93198 11.7172 12.1759Z" fill="white"/>
`,
];

export const close = [
  '24 24',
  `
  <path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
`,
];

export const openNew = [
  '24 24',
  `
  <path d="M0 0h24v24H0z" fill="none"/><path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>
`,
];

export const opositeChevrons = [
  '7.1 11.1',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.4"
      d="M.4 4.4c.1 0 .2 0 .3-.1l2.9-3.2 2.9 3.2c.1.1.4.2.5 0 .1-.1.2-.4 0-.5L3.5 0 .1 3.8c-.1.1-.1.4 0 .5.1 0 .2.1.3.1zM6.4 6.9l-2.9 3.2L.6 6.9c-.1-.1-.4-.2-.5 0-.1.1-.1.3 0 .5l3.4 3.8L7 7.4c.1-.1.1-.4 0-.5-.2-.2-.4-.2-.6 0z" />
</g>
`,
];

export const reservations = [
  '25 25',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.7" d="M12.50043.01914A12.481,12.481,0,1,0,24.9809,12.4996,12.49533,12.49533,0,0,0,12.50043.01914Zm0,23.96191A11.481,11.481,0,1,1,23.9809,12.4996,11.49424,11.49424,0,0,1,12.50043,23.98105Z"/><path class="cls-1" d="M16.37512,11.83792c-.66467-.00213-1.67279-.00067-2.51227-.0014h-.69793l.00036-.72058c.00031-.82721.00067-1.8357-.00183-2.49176a.66557.66557,0,0,0-.66-.70624h-.0025a.67345.67345,0,0,0-.66248.6933l-.00073,3.22528-.89923.00073-2.272-.00146H8.66187a.68084.68084,0,0,0-.689.40826.63008.63008,0,0,0,.04584.60382.74947.74947,0,0,0,.63391.31513c.63385.0014,1.58789.00073,2.40045.00073h.78467l.00073,3.11566a1.42942,1.42942,0,0,0,.01752.25995.65766.65766,0,0,0,.64355.543l.01611-.00074a.6556.6556,0,0,0,.62958-.53649,1.35729,1.35729,0,0,0,.019-.26142l.00074-3.11993h3.14215a1.15963,1.15963,0,0,0,.17975-.00788.6614.6614,0,0,0-.1117-1.31793Z"/>
</g>
  `,
];

export const dashboard = [
  '25 25',
  `
  <defs>
    <style>
      .cls-1{fill:#fff;}
    </style>
  </defs>
  <path class="cls-1" d="M12.49985.01891a12.481,12.481,0,1,0,12.48144,12.481A12.49491,12.49491,0,0,0,12.49985.01891Zm0,23.96191a11.481,11.481,0,1,1,11.48144-11.481A11.49392,11.49392,0,0,1,12.49985,23.98082Z"/><path class="cls-1" d="M19.38254,11.56017c-.05078-.00391-.09863-.00391-.17871-.00391h-.63574c-.72559,0-1.45118-.001-2.19922.002-.083-.28907-.17188-.57618-.26172-.86329L15.14426,7.5631a.56808.56808,0,0,0-.54492-.44434.59383.59383,0,0,0-.59668.4336L11.73215,15.485,9.6677,10.5797a.58984.58984,0,0,0-.55664-.38867H9.10617a.5817.5817,0,0,0-.55468.39551l-.36329.90722c-.2832.70606-.5664,1.41211-.82812,2.11328-.53809-.00586-1.0791-.00586-1.61914-.00195a.58775.58775,0,0,0-.63281.585.57134.57134,0,0,0,.165.41113.64729.64729,0,0,0,.46485.18165l1.96777.00195a.61236.61236,0,0,0,.60156-.40527l.81739-2.043,1.5459,3.67382q.30176.72071.60644,1.43946a.65571.65571,0,0,0,.41309.38965.49411.49411,0,0,0,.14453.02148.51863.51863,0,0,0,.30078-.09766.83921.83921,0,0,0,.29883-.44043q.82031-2.84619,1.62988-5.69531l.52637-1.83887.75293,2.43848a.61486.61486,0,0,0,.6875.50879h3.24316a1.07866,1.07866,0,0,0,.126-.00293.59265.59265,0,0,0,.53711-.5957A.5829.5829,0,0,0,19.38254,11.56017ZM14.21579,7.7116l-.00024-.00006h.00024Z"/>
`,
];

export const driverShifts = [
  '25 25',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.7" d="M24.98151,7.12693A4.42123,4.42123,0,0,0,21.3631,2.741a9.321,9.321,0,0,0-1.68225-.10077c-.26081-.001-.51862.001-.77741-.00885-.09387-.003-.18866-.003-.2865-.002l-.25579.001-.00989-.21826c-.002-.0415-.004-.07312-.004-.10571-.001-.20056,0-.40106.001-.60156.001-.40009.002-.80018-.0069-1.2002A.52757.52757,0,0,0,17.809-.02486a.536.536,0,0,0-.5285.53436c-.00592.10376-.005.20746-.004.31122V2.61357H7.71985L7.71936,1.7028c0-.405-.00049-.809-.00446-1.214A.48174.48174,0,0,0,7.39484.02354a.437.437,0,0,0-.53931.08392.9308.9308,0,0,0-.19464.50873c-.0202.44062-.01679.8772-.01331,1.34052.00147.18072.003.36249.003.54724v.1264H5.94379c-.18525,0-.3675-.001-.54828-.001-.27411,0-.54425.001-.81494.002a4.53,4.53,0,0,0-4.56867,4.54c-.01581,4.21008-.01581,8.53577-.00049,13.22491A4.51384,4.51384,0,0,0,4.5401,24.94615c5.44629.02173,10.80719.02075,15.93-.001a4.49036,4.49036,0,0,0,4.51142-4.50244C25.00616,16.202,25.00616,11.72123,24.98151,7.12693ZM11.22662,23.86845q-2.53226,0-5.06384-.00152l.354-.43268A7.74734,7.74734,0,0,1,12.5014,20.6793a7.72446,7.72446,0,0,1,5.98175,2.75507l.37153.43164Q15.04086,23.86811,11.22662,23.86845ZM23.87115,11.65312l.0188.23608c.00788.079.0138.14814.0138.21729l.001,2.05371q.00293,3.08048-.002,6.161A3.40426,3.40426,0,0,1,21.043,23.81706a4.1352,4.1352,0,0,1-.73492.04846l-.155.00006-.83368-.99652c-.02875-.0332-.05994-.06079-.08887-.09344l-.02118-.02759-.00293.00226a8.67745,8.67745,0,0,0-6.705-3.071,8.69951,8.69951,0,0,0-6.709,3.07239l.0199-.02222-.059.06311c-.02368.02674-.03992.05561-.06348.08271l-.7962.99127-.205-.00006A3.43085,3.43085,0,0,1,1.139,20.9929a3.85044,3.85044,0,0,1-.045-.67169q-.00368-4.10733-.001-8.21472c0-.06616.004-.13135.00842-.21039l.01282-.23309H6.09155V10.607h-4.954l-.02563-.19953a1.24158,1.24158,0,0,1-.01831-.18274l-.00244-.82678c-.003-.74188-.00592-1.48273.00445-2.22461a3.39612,3.39612,0,0,1,3.23016-3.4494c.49189-.03558.976-.02667,1.49012-.01782.2326.00494.4682.00891.70825.00891h.12646v1.9223c.00049.26666.06964.71417.52845.722a.45.45,0,0,0,.35168-.12543.84486.84486,0,0,0,.18915-.60748V3.72984h9.55664l-.001,1.4679c-.001.1936-.002.3872.004.57983a.53992.53992,0,0,0,.53735.58179.54744.54744,0,0,0,.52753-.59857c.00391-.37739.00293-.7547.00293-1.13209l-.001-.94433.13434.00793c.33588.02173.67761.0138,1.01056.00391a6.183,6.183,0,0,1,2.00031.17291,3.38157,3.38157,0,0,1,2.40136,3.14813c.01783.78632.01386,1.55488.00891,2.36884-.00195.35852-.004.72009-.004,1.08459v.12647h-4.992v1.056Z"/><path class="cls-1" d="M12.45941,8.0001l-.05762.00049a5.03306,5.03306,0,0,0-3.498,8.6416,4.97443,4.97443,0,0,0,3.50293,1.43555h.07324A5.0391,5.0391,0,0,0,12.45941,8.0001Zm2.85742,7.84131a4.03,4.03,0,0,1-2.85058,1.23633h-.05957A3.98759,3.98759,0,0,1,9.603,15.92735a4.03312,4.03312,0,0,1,2.81054-6.92676l.0459-.00049A4.03591,4.03591,0,0,1,16.45648,12.984,3.98663,3.98663,0,0,1,15.31683,15.84141Z"/>
  </g>
`,
];

export const shuttles = [
  '25 25',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.7" d="M12.52219.01914A12.481,12.481,0,1,0,25.00363,12.4996,12.49449,12.49449,0,0,0,12.52219.01914Zm0,23.96191A11.481,11.481,0,1,1,24.00363,12.4996,11.494,11.494,0,0,1,12.52219,23.98105Z"/>
  <path stroke-width="0.7" d="M14.9968,5.77481q-2.47531-.00431-4.95172.00214a3.05661,3.05661,0,0,0-.69153.07953A2.969,2.969,0,0,0,7.04581,8.79166Q7.041,10.85224,7.044,12.91434l.00073,1.4425-.00214.56012c-.00286.45771-.00573.91535.00788,1.373a1.68664,1.68664,0,0,0,1.08191,1.56281,1.53546,1.53546,0,0,0,.15362.05664l-.00036.13818c-.00037.22064-.0011.43909.00213.6568a.49545.49545,0,0,0,.48273.52289h.01471a.481.481,0,0,0,.33374-.12964.54963.54963,0,0,0,.16046-.39038c.0036-.16474.00287-.3302.00214-.49561l-.00037-.22565H15.765l-.00037.56373.00037.131a.50376.50376,0,0,0,.49206.54651h.00641a.47267.47267,0,0,0,.361-.15833.57854.57854,0,0,0,.13428-.38318c.00324-.25641.0036-.51355.00037-.7821a1.6902,1.6902,0,0,0,1.23944-1.666l.0011-.56939c.00537-2.31348.01037-4.62622-.00324-6.9397A2.96062,2.96062,0,0,0,14.9968,5.77481Zm2.0166,10.40845a.75606.75606,0,0,1-.80328.80865H8.83463a.75024.75024,0,0,1-.80219-.79571l-.00073-1.48407.00037-.46484H17.0134l.00037.40252ZM8.04135,13.24741V10.51065l8.96057-.0022v2.73609Zm8.97242-3.7395H8.02988c-.00031-.05091,0-.10175.00287-.15186.00647-.11462.00824-.22992.01043-.34521a3.64093,3.64093,0,0,1,.06373-.75354,1.94832,1.94832,0,0,1,1.91131-1.49262c1.796-.01147,3.43256-.01147,5.00507,0a2.00048,2.00048,0,0,1,1.99048,2.02338l.00036.59234Z"/><path class="cls-1" d="M10.03861,14.81021h-.01a.8134.8134,0,0,0-.80616.79651.81122.81122,0,0,0,.79932.81653h.005a.80655.80655,0,0,0,.01184-1.613Z"/>
  <path stroke-width="0.7" d="M15.01688,14.81021h-.00183a.80966.80966,0,0,0-.80536.80579.807.807,0,0,0,.80285.80725h.00184a.80652.80652,0,1,0,.0025-1.613Z"/>
  </g>
  `,
];

export const liveMap = [
  '25 25',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.5"  d="M21.45551,3.621A11.92067,11.92067,0,0,0,12.4848.01646,11.9428,11.9428,0,0,0,3.45551,3.663,9.98718,9.98718,0,0,0,.98773,11.56236c.9043,9.36523,11.21582,13.37988,11.31934,13.41992l.19824.0752.19238-.09082c.43067-.20215,10.54981-5.05274,11.28418-13.40821A10.10537,10.10537,0,0,0,21.45551,3.621ZM12.46527,23.96666a21.83958,21.83958,0,0,1-5.79-3.74555,7.701,7.701,0,0,1,5.77661-2.542,7.65283,7.65283,0,0,1,5.63166,2.39532A27.46146,27.46146,0,0,1,12.46527,23.96666Zm10.52051-12.4961a13.06427,13.06427,0,0,1-4.1817,7.919,8.6072,8.6072,0,0,0-6.35224-2.71039A8.65317,8.65317,0,0,0,5.95721,19.533a13.264,13.264,0,0,1-3.97338-8.06634A9.00828,9.00828,0,0,1,4.19574,4.3358,10.96051,10.96051,0,0,1,12.4848,1.01646a10.94026,10.94026,0,0,1,8.2334,3.2793A9.13249,9.13249,0,0,1,22.98578,11.47056Z"/><path class="cls-1" d="M12.40985,4.99992l-.05762.00049a5.03306,5.03306,0,0,0-3.498,8.6416,4.97451,4.97451,0,0,0,3.50293,1.43555h.07324a5.0391,5.0391,0,0,0-.02051-10.07764Zm2.85742,7.84131a4.03,4.03,0,0,1-2.85058,1.23633h-.05957a3.98759,3.98759,0,0,1-2.80371-1.15039A4.03312,4.03312,0,0,1,12.364,6.00041l.0459-.00049a4.03591,4.03591,0,0,1,3.99707,3.98389A3.98666,3.98666,0,0,1,15.26727,12.84123Z"/>
  </g>
  `,
];

export const vehicles = [
  '25 25',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.7" d="M12.49965.01914A12.481,12.481,0,1,0,24.9811,12.4996,12.4945,12.4945,0,0,0,12.49965.01914Zm0,23.96191A11.481,11.481,0,1,1,23.9811,12.4996,11.494,11.494,0,0,1,12.49965,23.98105Z"/>
  <path stroke-width="0.5" d="M16.81539,12.323q-4.39756-.005-8.79676,0a1.67245,1.67245,0,0,0-1.684,1.67853c-.005.73242-.00372,1.46563,0,2.19891a1.67052,1.67052,0,0,0,1.10358,1.57172q-.00375.31559.00165.63293a.5716.5716,0,0,0,.56793.57337h.00665a.5775.5775,0,0,0,.56586-.57251l.00085-.52527h7.6745l.00043.493a.5718.5718,0,1,0,1.14173.00079c.00207-.2005.00286-.401.00079-.604a1.66988,1.66988,0,0,0,1.104-1.58661q.00439-1.08618-.00042-2.17236A1.65827,1.65827,0,0,0,16.81539,12.323Zm-.04682,4.41016H8.06252a.54112.54112,0,0,1-.58533-.58905q-.0031-1.03894-.00043-2.07795a.5427.5427,0,0,1,.59778-.60229h8.69318a.537.537,0,0,1,.56756.3902.82993.82993,0,0,1,.02362.2055q.00368,1.03895.0008,2.07788A.54163.54163,0,0,1,16.76857,16.73319Z"/>
  <path stroke-width="0.5" d="M8.797,12.04794l.65326-2.55761a.5187.5187,0,0,1,.54187-.43085q2.42835-.00248,4.85633,0a.51812.51812,0,0,1,.5365.42169l.64911,2.59412h1.18109l-.28174-1.12848c-.14954-.60315-.29743-1.2005-.45569-1.79535a1.59642,1.59642,0,0,0-1.2738-1.20135,2.68591,2.68591,0,0,0-.55182-.03895q-2.30531-.00493-4.61237-.00164A1.67579,1.67579,0,0,0,8.331,9.24423l-.70837,2.83765h.94287Z"/>
  <path stroke-width="0.5" d="M9.11434,14.2543H9.11183a.84682.84682,0,0,0-.6015,1.44159.98818.98818,0,0,0,.60273.2461.84385.84385,0,1,0,.00128-1.68769Z"/>
  <path stroke-width="0.5" d="M15.7292,14.2543a.84387.84387,0,1,0-.01245,1.68769h.00916a.83552.83552,0,0,0,.84466-.8335.84428.84428,0,0,0-.24072-.60486A.89286.89286,0,0,0,15.7292,14.2543Z"/>
  </g>
  `,
];

export const reports = [
  '25 25',

  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.5" d="M12.49978.01939A12.481,12.481,0,1,0,24.98122,12.49986,12.4945,12.4945,0,0,0,12.49978.01939Zm0,23.96192A11.481,11.481,0,1,1,23.98122,12.49986,11.494,11.494,0,0,1,12.49978,23.98131Z"/>
  <path stroke-width="0.5" d="M16.08279,8.91881c-.05665-.00489-.11524-.00489-.20606-.00489H9.09841a1.27723,1.27723,0,0,0-.18359.00586A.59554.59554,0,0,0,8.78,10.077a.91124.91124,0,0,0,.28809.03808l6.89257.001h.01661a.90164.90164,0,0,0,.15527-.01074.60877.60877,0,0,0,.49609-.60352A.6017.6017,0,0,0,16.08279,8.91881Z"/>
  <path stroke-width="0.5" d="M14.6697,15.9647c-.0459-.0039-.09277-.0039-.17285-.0039H9.06911c-.04882.001-.0957-.001-.14062.0039A.59859.59859,0,0,0,8.93825,17.159a1.69151,1.69151,0,0,0,.18262.00391h4.97852c.05957.001.11816.001.17773.001.12109,0,.24219-.001.36426-.00488a.58953.58953,0,0,0,.57617-.58594A.60253.60253,0,0,0,14.6697,15.9647Z"/><path class="cls-1" d="M9.08376,13.64244q1.17334.00145,2.34668.00195.832,0,1.66406-.001a1.10879,1.10879,0,0,0,.25489-.02539.59692.59692,0,0,0,.0039-1.1582,1.1349,1.1349,0,0,0-.2705-.02539l-1.48633-.001-2.50879.001a1.03922,1.03922,0,0,0-.27539.03125.58317.58317,0,0,0-.43653.56836.5908.5908,0,0,0,.42969.57617A1.058,1.058,0,0,0,9.08376,13.64244Z"/>
  </g>
  `,
];

export const drivers = [
  '25 25',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.7" d="M24.72719,9.98772A12.50207,12.50207,0,0,0,12.50075.01891h-.001L12.497.019c-.38342.00012-.76111.02326-1.13574.05756-.11707.01062-.23249.02557-.34864.03949q-.399.048-.78979.12085c-.12073.02234-.24176.04272-.36127.06854C9.5201.37969,9.18239.464,8.852.56566c-.11511.03528-.226.07959-.33966.11811-.22247.07556-.44318.15429-.65979.24194-.15686.06317-.31073.13086-.46436.20019-.16943.07666-.33581.158-.50116.24183-.15631.07916-.31323.15618-.46569.24157-.23615.13257-.46631.27429-.69275.42133A12.56039,12.56039,0,0,0,1.883,5.97155c-.05249.0849-.10492.16949-.1554.25561-.118.202-.23126.40625-.33807.61517-.05738.11188-.10993.22632-.16406.34009-.09473.2-.191.39844-.27521.604q-.18319.445-.33246.90655C.5707,8.83971.53371,8.99035.492,9.13939c-.06085.2154-.11871.43183-.168.6518-.03241.14569-.06061.29236-.08789.43988-.0456.24475-.08259.492-.11347.74151-.01544.126-.03339.25086-.0451.37793-.0351.379-.05823.76129-.05823,1.14936a12.47322,12.47322,0,0,0,12.48047,12.481h.001A12.48716,12.48716,0,0,0,24.72719,9.98772ZM6.2582,2.87731l.00006.00012A11.60545,11.60545,0,0,1,7.44594,2.207c.11145-.05493.22248-.11066.33594-.162q.2472-.11242.50049-.213c.15546-.06171.31342-.1181.47217-.17316.142-.0495.28222-.10247.42663-.14648q.43974-.13313.89386-.23047c.11426-.02484.23066-.04352.34613-.06488.23468-.04321.4715-.08026.71094-.10883.10846-.01312.2168-.02649.32611-.0365.34271-.031.68823-.05261,1.03888-.05267l.00311-.00012A11.439,11.439,0,0,1,23.90237,13.79924c-.01447.12787-.03931.25245-.058.379-.04474.30194-.09662.6015-.16455.89527-.03052.1325-.06641.26281-.10144.39355-.079.29285-.1676.5816-.2688.86469-.03876.109-.07745.218-.11938.3255q-.19455.49612-.43213.96942c-.02454.049-.04621.09948-.07141.148A11.602,11.602,0,0,1,19.32155,21.713l-.00189.00141a8.70332,8.70332,0,0,0-6.81793-3.18964l-.02887.00146-.02936-.00146a8.69951,8.69951,0,0,0-6.709,3.07239l.0199-.02216-.059.06305c-.01545.01746-.0282.03577-.04145.054a11.5993,11.5993,0,0,1-3.34045-3.918c-.02484-.04786-.0462-.09772-.07044-.14594q-.23886-.47332-.43292-.97125c-.04187-.10724-.08038-.21594-.11908-.32471-.10125-.28332-.19006-.57232-.2691-.86542-.035-.13055-.07086-.26068-.10132-.393-.068-.294-.11987-.59369-.16461-.89581-.01862-.12647-.04346-.25092-.05792-.37867a11.47,11.47,0,0,1-.07886-1.29937c0-.35669.02154-.70826.05353-1.05677.01031-.11157.02557-.22161.03906-.33221q.04339-.35706.10821-.70728c.023-.12347.04566-.24694.07264-.369.05163-.235.1134-.46613.17926-.69556.02929-.10156.053-.20551.08508-.306.094-.2962.20251-.58582.31946-.87116.061-.14849.12964-.2929.19671-.43817.06885-.14965.13941-.29828.21442-.44439.08069-.15686.16394-.3122.25153-.46479.07275-.12695.15033-.25061.22778-.37451.09656-.15442.19086-.31042.29443-.4599h0A11.56488,11.56488,0,0,1,6.2582,2.87731ZM16.26113,23.33513c-.17993.0633-.361.12433-.54492.17871-.27081.07923-.54407.15265-.82276.212-.10662.023-.21606.03821-.32379.05823-.23816.04358-.47815.08172-.72113.11035-.10547.01263-.21118.02447-.3175.03412-.34021.03045-.68286.05224-1.03083.05224l-.00274-.00012c-.34619-.00006-.68726-.02173-1.02576-.05194-.10858-.00989-.21649-.022-.32416-.03491-.23877-.0282-.47442-.06574-.70849-.1084-.11164-.02063-.225-.03644-.33539-.0603-.27606-.0589-.54681-.13172-.81519-.21015-.18841-.05572-.3739-.118-.55816-.183-.08893-.03107-.17694-.064-.26483-.09717a11.61829,11.61829,0,0,1-1.94837-.95514,7.81411,7.81411,0,0,1,11.90814.00012l.03022.01593a11.61509,11.61509,0,0,1-1.911.93549C16.45046,23.26683,16.35628,23.302,16.26113,23.33513Z"/><path class="cls-1" d="M12.34878,16.92321h.13147a5.0391,5.0391,0,0,0-.02051-10.07764L12.406,6.846l-.00452-.00043-.05762.00049a5.03306,5.03306,0,0,0-3.498,8.6416A4.97451,4.97451,0,0,0,12.34878,16.92321Zm.05822-1a3.98763,3.98763,0,0,1-2.80371-1.15039,4.01949,4.01949,0,1,1,6.79529-2.94336,3.98666,3.98666,0,0,1-1.13965,2.85742,4.03,4.03,0,0,1-2.85058,1.23633Z"/>
  </g>
  `,
];

export const timeline = [
  '25 25',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.7" d="M12.49609.01914A12.481,12.481,0,1,0,24.97656,12.4996,12.49491,12.49491,0,0,0,12.49609.01914Zm0,23.96191A11.481,11.481,0,1,1,23.97656,12.4996,11.49413,11.49413,0,0,1,12.49609,23.98105Z"/>
  <path stroke-width="0.5" d="M17.47107,14.65305a2.96921,2.96921,0,0,0-.391-.1554l-.01038-.31872c.00037-.39106.00067-.78217-.00183-1.17395a1.401,1.401,0,0,0-.0462-.3653,1.162,1.162,0,0,0-1.175-.85663l-2.225-.0014-.61847.00073V10.06626a1.93524,1.93524,0,1,0-2.389-2.31208,1.87405,1.87405,0,0,0,.16723,1.33368,1.90316,1.90316,0,0,0,1.21149.9784v1.71612l-.61951-.00073-2.21716.0014A1.17741,1.17741,0,0,0,7.92572,13.01v1.4848A1.91292,1.91292,0,0,0,6.5813,15.77115a2.324,2.324,0,0,0-.06482.2428l-.02936.15472.00647.43976.01538.07092c.01325.06159.02649.1239.04437.18262A1.93769,1.93769,0,0,0,8.1001,18.27725l.5766.01361.1239-.02935a1.93614,1.93614,0,0,0,.116-3.76886l.00036-1.4748c0-.18548.05512-.23919.24457-.23919h6.67218c.192,0,.24463.05444.24463.25067v1.464a1.93591,1.93591,0,0,0-.00574,3.74023l.11957.03223.62067.02508.12176-.02648a1.93289,1.93289,0,0,0,.53644-3.61133ZM9.09033,15.69376A.94077.94077,0,1,1,7.75665,17.021a.94129.94129,0,0,1,.66181-1.60651h.00537A.93589.93589,0,0,1,9.09033,15.69376Zm3.4093-6.54645a.93631.93631,0,0,1-.66717-.27649.94822.94822,0,0,1-.274-.67755.94221.94221,0,0,1,.93146-.93182h.009a.943.943,0,0,1,.0025,1.88586ZM17.23,17.02884a.93367.93367,0,0,1-.65784.27075h-.00933a.943.943,0,0,1,.01544-1.88586H16.579a.93352.93352,0,0,1,.66431.2829.91792.91792,0,0,1,.27258.65606A.9513.9513,0,0,1,17.23,17.02884Z"/>
  </g>
  `,
];

export const trips = [
  '25 25',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.7" d="M12.49978.01914A12.481,12.481,0,1,0,24.98122,12.4996,12.49449,12.49449,0,0,0,12.49978.01914Zm0,23.96191A11.481,11.481,0,1,1,23.98122,12.4996,11.494,11.494,0,0,1,12.49978,23.98105Z"/>
  <path stroke-width="0.5" d="M18.08285,8.22543q-1.819-1.10119-3.64783-2.18737l-.82587-.4928A2.145,2.145,0,0,0,12.49972,5.243h-.0011a2.128,2.128,0,0,0-1.09406.29651l-.44909.26788c-1.348.80433-2.69629,1.608-4.03711,2.42518a1.46447,1.46447,0,0,0-.50135.53216,1.26379,1.26379,0,0,0,.53681,1.71613l4.344,2.60144a2.18464,2.18464,0,0,0,2.39368.00787l2.26794-1.35583c.708-.42261,1.416-.84449,2.12012-1.2735a1.32119,1.32119,0,0,0,.65753-1.12378A1.30752,1.30752,0,0,0,18.08285,8.22543Zm-.56263,1.315c-1.48407.89172-2.96777,1.78344-4.459,2.66156a1.646,1.646,0,0,1-.39679.14325c-.05872.01648-.11786.033-.17731.0509-.05761-.01935-.11529-.03729-.1726-.05518a1.95763,1.95763,0,0,1-.40894-.159q-1.82272-1.07656-3.63495-2.16883L7.5032,9.55338a.27632.27632,0,0,1-.159-.212.27356.27356,0,0,1,.15863-.21057q2.20623-1.32359,4.41528-2.64148a1.1395,1.1395,0,0,1,.58484-.1748,1.08531,1.08531,0,0,1,.55792.16333q2.23471,1.32357,4.45862,2.66583a.2111.2111,0,0,1,.00073.39679Z"/>
  <path stroke-width="0.5" d="M17.7795,15.1608a.2987.2987,0,0,0-.284.028c-.16363.096-.32623.19409-.49816.298l-.26783.18982.13178.164.28076.18835c.12213.07379.2439.14685.36493.222a.26649.26649,0,0,1,.15.2113.245.245,0,0,1-.14074.19556q-2.21905,1.33218-4.44355,2.658a1.07006,1.07006,0,0,1-1.1582-.00788q-2.09985-1.24841-4.19287-2.50757l-.22241-.13323a.26877.26877,0,0,1-.15467-.20557.28416.28416,0,0,1,.16327-.21845l.88025-.52789-.4032-.24206c-.17407-.10389-.33917-.20343-.50494-.29938a.2832.2832,0,0,0-.28473.00354c-.05194.03583-.106.06952-.16009.10315a2.006,2.006,0,0,0-.43549.3302,1.21633,1.21633,0,0,0-.322,1.01135,1.37883,1.37883,0,0,0,.67542.97406l4.35839,2.60858a2.1745,2.1745,0,0,0,2.37683.00214q.87992-.52424,1.75837-1.05145l.66467-.39753c.6654-.39679,1.33081-.79358,1.99225-1.19684a1.27309,1.27309,0,0,0,.57763-1.45825A1.55363,1.55363,0,0,0,17.7795,15.1608Z"/>
  <path stroke-width="0.5" d="M17.79061,11.609a.32871.32871,0,0,0-.29651.02576c-.15869.09027-.31555.18481-.47418.28009l-.25214.18261.10749.20917.62634.38245a.27493.27493,0,0,1,.15539.21417.25831.25831,0,0,1-.14929.2027q-2.21274,1.32787-4.43,2.64935a1.08664,1.08664,0,0,1-1.18683-.01788L7.54653,13.13815c-.12891-.07666-.20306-.164-.20306-.23852,0-.07446.07306-.16113.20092-.23706l.84552-.50354-.433-.25995c-.15539-.09387-.30011-.18121-.447-.26575a.33732.33732,0,0,0-.29828-.023,1.64068,1.64068,0,0,0-.85339.82087,1.28707,1.28707,0,0,0,.59479,1.6065L11.296,16.63846a2.194,2.194,0,0,0,2.408.00214l2.77759-1.66169c.54724-.3266,1.09442-.65319,1.637-.987a1.267,1.267,0,0,0,.56262-1.449A1.562,1.562,0,0,0,17.79061,11.609Z"/>
  </g>
  `,
];

export const passengers = [
  '25 25',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path stroke-width="0.5" d="M12.539.019A12.481,12.481,0,1,0,25.01947,12.5,12.49534,12.49534,0,0,0,12.539.019Zm0,23.96192A11.481,11.481,0,1,1,24.01947,12.5,11.494,11.494,0,0,1,12.539,23.981Z"/><path class="cls-1" d="M18.7793,8.507H14.67365c0-.19672.00225-.367-.00116-.53723A1.35875,1.35875,0,0,0,13.2713,6.58587c-.47278-.00226-.94556-.00116-1.41724,0A1.36285,1.36285,0,0,0,10.4046,8.02843V8.507h-.19671c-1.3321,0-2.66425-.00232-3.9975.00116A1.34855,1.34855,0,0,0,4.81616,9.90929q-.00174,3.55288.0011,7.10468a1.5708,1.5708,0,0,0,.04718.38763,1.35089,1.35089,0,0,0,1.36548,1.01233h8.76465c1.29645,0,2.59411.00464,3.89172-.00226a1.32038,1.32038,0,0,0,1.26886-.83289,2.63456,2.63456,0,0,0,.10693-.34283V9.66314c-.00573-.0069-.01611-.01386-.01837-.02192A1.35267,1.35267,0,0,0,18.7793,8.507Zm-7.459-.62238a.43146.43146,0,0,1,.44171-.39227q.77655-.00687,1.5542,0a.42873.42873,0,0,1,.44055.39227c.01954.19788.00464.39917.00464.61084H11.31683C11.31683,8.2838,11.30188,8.08251,11.32031,7.88463ZM7.462,17.49828a.99312.99312,0,0,1-.1001.01031c-.38764,0-.77417.00232-1.16187,0a.45138.45138,0,0,1-.47851-.48431q-.00174-3.56672,0-7.13342a.44385.44385,0,0,1,.4682-.47736c.421-.00348.842-.00116,1.27228-.00116Zm9.23168,0H8.37994V9.425h8.31372Zm2.66309-.54993c0,.39575-.16217.56024-.55444.56024H17.61743V9.41808c.45783,0,.90991-.00922,1.35974.00458a.424.424,0,0,1,.37842.40728c.00348.04487.00116.09082.00116.13575Z"/>
  </g>
  `,
];

export const onlineDrivers = [
  '25 25',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
  <path  stroke-width="0.7" d="M4.14667,5.79674a1.894,1.894,0,1,0-1.894-1.894A1.8962,1.8962,0,0,0,4.14667,5.79674Z"/>
  <path  stroke-width="0.7" d="M12.50043.01891A12.40275,12.40275,0,0,0,5.632,2.08959a2.35426,2.35426,0,0,1,.626.78784A11.46606,11.46606,0,0,1,19.3194,21.71453a8.70276,8.70276,0,0,0-6.818-3.18976l-.02459.00128-.025-.00128a8.69951,8.69951,0,0,0-6.709,3.07239l.0199-.02216-.059.06305c-.01673.01886-.03028.03882-.0448.05841A11.43186,11.43186,0,0,1,3.0611,5.98015a2.35671,2.35671,0,0,1-.76728-.64093A12.47019,12.47019,0,1,0,12.50043.01891ZM6.51678,22.27971a7.823,7.823,0,0,1,11.91681.00012l.02576.01362a11.37,11.37,0,0,1-11.94257-.01374Z"/>
  <path  stroke-width="0.7" d="M12.40668,16.92321h.07324a5.0391,5.0391,0,0,0-.02051-10.07764l-.04571.00037-.00385-.00037-.05762.00049a5.03306,5.03306,0,0,0-3.498,8.6416,4.97451,4.97451,0,0,0,3.50293,1.43555Zm0-1A3.98759,3.98759,0,0,1,9.603,14.77282a4.03312,4.03312,0,0,1,2.81054-6.92676h.001a4.03569,4.03569,0,0,1,3.99237,3.9834,3.98666,3.98666,0,0,1-1.13965,2.85742,4.03,4.03,0,0,1-2.85058,1.23633Z"/>
  </g>
  `,
];

export const language = [
  '25 25',
  `
  <defs>
    <style>
      .cls-1{fill:#fff;}
    </style>
  </defs>
  <path class="cls-1" d="M12.65,3.91392a8.33252,8.33252,0,1,0,8.333,8.332A8.34092,8.34092,0,0,0,12.65,3.91392Zm7.18555,8.332A7.18506,7.18506,0,1,1,12.65,5.06138,7.194,7.194,0,0,1,19.83559,12.246Z"/>
  <polygon class="cls-1" points="7.517 15.039 11.486 15.039 11.486 13.914 8.935 13.914 8.935 12.757 11.328 12.757 11.328 11.64 8.935 11.64 8.935 10.579 11.486 10.579 11.486 9.454 7.517 9.454 7.517 15.039"/>
  <polygon class="cls-1" points="16.422 12.647 13.863 9.454 12.801 9.454 12.801 15.039 14.156 15.039 14.156 11.846 16.707 15.039 17.784 15.039 17.784 9.454 16.422 9.454 16.422 12.647"/>
`,
];

export const logout = [
  '24.3 24.6',
  `
  
  <style>
  .st0 {
      fill: #fff
  }
</style>
<path class="st0"
  d="M21.6 10.9c-.3-1.7-1.1-3.2-2.4-4.4-1.1-1.1-2.4-1.7-4-2-.2-.1-.3-.1-.5-.1h-1.6c-.2 0-.3.1-.5.1-.4 0-.8.1-1.1.2-2.2.7-3.8 2.2-4.8 4.2-.1.2-.2.5-.2.7l-.1.2c-.1.2 0 .3.1.4 0 .2.2.3.4.3.3 0 .6-.2.6-.4h-.2l.2.1.1-.3c1.4-3.3 5.2-5 8.6-3.7 3.2 1.2 5 4.6 4.1 7.9-.9 3.3-4.3 5.5-7.7 4.8-2.4-.5-4.1-1.9-5-4.2l-.1-.2h-.1c-.1-.2-.2-.3-.3-.3-.1-.1-.3-.1-.5 0s-.4.4-.3.9h.1c.4 1.2 1.1 2.3 2.1 3.1 1.5 1.4 3.3 2.1 5.2 2.1.5 0 .9 0 1.4-.1 1.8-.2 3.4-1.1 4.6-2.5 1-1.1 1.7-2.4 1.9-3.9.1-.2.1-.4.1-.6v-1.5c0-.3-.1-.6-.1-.8zm-14.7-1z" />
<path class="st0"
  d="M4.7 12.9h8.4c.2-.1.4-.3.4-.6s-.1-.5-.4-.6H4.7l.7-.8c.3-.2.3-.6.1-.8-.1-.1-.2-.2-.4-.2s-.4 0-.5.1l-.4.4-1.3 1.3c-.3.4-.3.7 0 1l1.6 1.7c.2.1.3.2.5.2.1 0 .2 0 .3-.1.2-.1.3-.2.3-.4s-.1-.4-.2-.5l-.7-.7z" />

  `,
];

export const myProfile = [
  '32.6 34',
  `
<style>
  .st0 {
    fill: #fff
  }
</style>
<g id="Layer_2_00000142155206685185793500000010447250275728534678_">
  <path class="st0"
    d="M16.3 0c6.4 0 11.5 5.1 11.5 11.5S22.6 23 16.2 23C10 23 4.8 17.8 4.8 11.6 4.8 5.2 9.9 0 16.3 0zm-5.5 20.1c.8-1.8 2.5-3.5 5.5-3.5 3.2-.1 4.7 1.7 5.5 3.5 3.3-2 5.6-6.4 4.5-11.1-1.1-4.6-5.3-7.8-10-7.8-4.8 0-8.9 3.3-9.9 8-1.2 4.5 1.1 8.9 4.4 10.9z" />
  <path class="st0" d="M16.3 6.8c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.9-3.8 3.9-3.9-1.7-3.9-3.8c.1-2.1 1.8-3.9 3.9-3.9z" />
</g>
`,
];

export const myProfileWithInput = [
  '39.7 45.9',
  `
<style>
  .st0 {
    fill: #fff
  }
</style>
<g id="Layer_2_00000173158043098331488090000014209262846489482664_">
  <path class="st0"
    d="M23.4 11.9c6.4 0 11.5 5.1 11.5 11.5s-5.2 11.5-11.6 11.5c-6.2 0-11.4-5.2-11.4-11.4 0-6.4 5.1-11.6 11.5-11.6zm-5.5 20.2c.8-1.8 2.5-3.5 5.5-3.5 3.2-.1 4.7 1.7 5.5 3.5 3.3-2 5.6-6.4 4.5-11.1-1.1-4.6-5.3-7.8-10-7.8-4.8 0-8.9 3.3-9.9 8-1.2 4.5 1.1 8.8 4.4 10.9z" />
  <path class="st0" d="M23.4 18.7c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.9-3.8 3.9-3.9-1.7-3.9-3.8c.1-2.1 1.8-3.8 3.9-3.9z" />
  <circle cx="13.1" cy="13.1" r="7" style="fill:#e83578" />
  <g>
    <path
      d="M14.4 12.6c.3.2.5.4.6.6.2.3.2.6.2.9 0 .4-.1.7-.3 1s-.5.5-.8.7-.7.2-1.2.2c-.4 0-.7-.1-1.1-.2-.4-.1-.6-.3-.9-.4l.5-1c.5.3 1 .5 1.5.5.3 0 .5-.1.7-.2s.2-.3.2-.6c0-.2-.1-.4-.2-.6-.2-.1-.4-.2-.6-.2-.1 0-.3 0-.5.1s-.3.1-.5.2h-.8v-3.3H15v1.1h-2.3v1c.2-.1.5-.1.8-.1.4 0 .7.1.9.3z"
      style="fill:#1d1d1b" />
  </g>
</g>
`,
];

export const rightArrowCircle = [
  '14.1 14.1',
  `

<style>
    .st10 {
        fill: #fff
    }
</style>
<g id="Layer_2">
    <path class="st10"
        d="M12 2C11 1 9.7.3 8.2.1 8 .1 7.8 0 7.7 0H6.4c-.2 0-.4 0-.5.1-1.6.3-2.9 1-4 2.2C.9 3.4.3 4.8.1 6.3v1.3c0 .2 0 .4.1.5.4 2.1 1.5 3.7 3.3 4.8 1.1.7 2.3 1 3.5 1h.4c2-.1 3.7-.9 5-2.4 1-1.1 1.6-2.5 1.7-3.9.2-2.1-.5-4-2.1-5.6zm1 5.1c0 3.3-2.7 6-6 6s-6-2.7-6-6c0-1.6.6-3.1 1.8-4.2C4 1.7 5.5 1.1 7 1.1c3.3 0 6 2.7 6 6z" />
    <path class="st10"
        d="M5.8 3.4c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l3.1 2.8-3.1 2.9c-.2.2-.2.5 0 .7.1.1.2.2.4.2.1 0 .2 0 .3-.1L9.5 7v-.2L5.8 3.4z" />
</g>
`,
];

export const trash = [
  '13.4 14.2',
  `
  <path d="M13.2 2.2c-.1-.1-.2-.1-.4-.1H9.3v-.7C9.3.6 8.7 0 7.9 0H5.5c-.8 0-1.4.6-1.4 1.4V2H.5c-.3.1-.5.3-.5.6s.2.5.6.5h.7c.1 0 .1 0 .1.1 0 .5.1 1 .1 1.5.1 1 .1 2.1.2 3.1L2 12c.1 1.1.9 2 2.1 2h5.3c1.1 0 2-.9 2.1-2 .1-1.4.2-2.7.3-4.1l.3-4.8c0-.1 0-.1.1-.1h.8c.2 0 .4-.2.5-.4 0-.1-.1-.3-.3-.4zm-8-.9c0-.2.2-.2.4-.2H8c.3 0 .4.1.4.4V2H5.3c-.1-.2-.1-.4-.1-.7zm5.8 2c-.1 1.3-.2 2.6-.2 3.9-.1 1.1-.1 2.2-.2 3.3 0 .5-.1 1.1-.1 1.6 0 .6-.5 1-1.1 1H4c-.6-.1-1-.5-1-1-.1-2.2-.3-4.5-.4-6.7 0-.7-.1-1.4-.1-2.1v-.2H11v.2z"/><path d="M4.2 11c.1.3.3.4.6.4s.4-.3.4-.5V5.5c0-.3-.2-.6-.5-.6s-.6.2-.6.5v5.4c0 .1 0 .1.1.2zm2.5.4c.3 0 .5-.2.5-.5V5.3c0-.3-.3-.5-.5-.5-.3 0-.5.2-.5.5v5.4c0 .5.2.7.5.7zm2.1 0c.3 0 .5-.2.5-.5V5.3c-.1-.3-.3-.5-.6-.5s-.5.2-.5.5v5.5c.1.4.3.6.6.6z"/>
`,
];

export const clearFilter = [
  '16.5 13.9',
  `
<g id="Layer_2">
    <path fill="var(--ci-primary-color, currentColor)"
        d="m13.8 10.8.8-.8c.1-.1.1-.3 0-.4-.1-.1-.3-.1-.4 0l-.8.8-.8-.8c-.1-.1-.3-.1-.4 0-.1.1-.1.3 0 .4l.8.8-.8.8c-.1.1-.1.3 0 .4.1.1.1.1.2.1s.2 0 .2-.1l.8-.8.8.8c.1.1.1.1.2.1s.2 0 .2-.1c.1-.1.1-.3 0-.4l-.8-.8z" />
    <path fill="var(--ci-primary-color, currentColor)"
        d="M15.5 8.6c-.5-.5-1-.7-1.7-.8h-1c-.7.1-1.3.5-1.8 1-.4.5-.7 1.1-.8 1.7v.8c.2.9.7 1.6 1.5 2.1.5.3 1 .4 1.5.4h.2c.9 0 1.6-.4 2.2-1 .4-.5.7-1.1.8-1.7.1-1-.2-1.8-.9-2.5zm.4 2.2c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5c0-.7.3-1.3.7-1.7.5-.5 1.1-.7 1.7-.7 1.5-.1 2.6 1 2.6 2.4zM10.6 5.1l.8-1.1c.7-.9 1.3-1.9 2-2.8.1-.1.2-.4.2-.7-.2-.2-.3-.5-.9-.5H.7C.4 0 .3.1.1.3c-.1.2-.2.5.1.9l1 1.3c1.1 1.6 2.2 3.2 3.4 4.7.2.3.3.6.3.9v4.8c0 .2 0 .4.2.6l.2.2s.1 0 .1.1h.3l2.6-1c.4-.2.5-.3.5-.8V8.1c0-.3.1-.6.3-.9.4-.6 1-1.4 1.5-2.1zm-2.8 5.3V12l-1.5.6-.5.2V8.2c0-.5-.2-1-.5-1.5-1-1.4-2-2.9-3-4.3L1.2 1h11.1l-.8 1.1c-1.1 1.6-2.2 3.1-3.3 4.7-.3.4-.4.9-.4 1.4v2.2z" />
</g>
`,
];

export const eye = [
  '16.4 10.4',
  `
<style>
    .st10 {
        fill: #fff
    }
</style>
<g id="Layer_2">
    <path class="st10"
        d="M16.2 4.8c-1.3-1.7-2.9-3.1-4.8-4C10.5.3 9.5.1 8.5 0 7-.1 5.6.4 4.3 1.1 2.7 2 1.3 3.3.2 4.8c-.2.3-.2.5 0 .8.5.7 1.1 1.4 1.8 2 1.1 1 2.3 1.9 3.7 2.4.9.4 1.9.5 2.9.5 1.2-.2 2.4-.6 3.4-1.2 1.6-.9 2.9-2.2 4.1-3.6.1-.1.2-.3.2-.4v-.2c0-.1 0-.2-.1-.3zm-2 1.5c-.9.9-1.9 1.7-3 2.3-1 .5-2.1.8-3.2.8-.8 0-1.5-.2-2.2-.5-1.4-.7-2.6-1.6-3.6-2.7-.3-.3-.6-.7-.9-1 0-.1.1-.2.3-.4.9-1 1.9-2 3.1-2.7.9-.5 1.9-.9 2.9-1 .8-.1 1.7 0 2.4.3 1.3.4 2.4 1.2 3.4 2.1.6.5 1.1 1 1.6 1.5 0 0 .1.1.1.2-.3.4-.6.7-.9 1.1z" />
    <path class="st10"
        d="M8.2 2C6.4 2 5 3.4 4.9 5.2c0 1.8 1.4 3.2 3.2 3.2 1.8 0 3.2-1.4 3.3-3.2C11.4 3.4 10 2 8.2 2zm0 5.4C7 7.4 6 6.4 6 5.2 6 4 7 3.1 8.2 3.1c1.2 0 2.2 1 2.2 2.1-.1 1.2-1 2.2-2.2 2.2z" />
</g>
`,
];

export const more = [
  '13.9 13.9',
  `
    <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
        <path stroke-width="0.7"  d="M6.5 0h.8c.3 0 .5.1.7.1 1.5.2 2.7.9 3.8 1.9 1.6 1.6 2.2 3.4 2 5.6-.1 1.5-.7 2.8-1.7 3.9-1.3 1.5-2.9 2.3-4.9 2.4-1.4.1-2.7-.3-3.8-1C1.6 11.8.5 10.2.1 8.1c0-.2-.1-.5-.1-.8V6.2c.2-1.5.7-2.8 1.7-3.9C2.8 1.1 4.1.4 5.7.1c.3 0 .6-.1.8-.1zm.4 13c3.4 0 6.1-2.7 6.1-6.1C13 3.5 10.3.8 6.9.8 3.5.8.8 3.5.8 6.9.9 10.3 3.6 13 6.9 13z" />
        <circle class="st4" cx="6.9" cy="4.1" r=".9" />
        <circle class="st4" cx="6.9" cy="6.9" r=".9" />
        <circle class="st4" cx="6.9" cy="9.8" r=".9" />
    </g>
`,
];

export const paginationDoubleArrowLeft = [
  '13.9 13.9',
  `
  
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
      <path stroke-width="0.2"
          d="M8.1.1c1.6.3 2.9 1 4 2.2 1 1.1 1.6 2.4 1.7 3.9v1.1c0 .3-.1.5-.1.8-.4 2.1-1.5 3.7-3.3 4.8-1.2.7-2.5 1-3.8 1-2-.1-3.6-.9-4.9-2.4C.7 10.4.1 9.1 0 7.6-.2 5.4.5 3.5 2 2 3 1 4.3.3 5.7.1c.4 0 .6-.1.8-.1h.8c.3 0 .6.1.8.1zM13 6.9C13 3.5 10.3.8 6.9.8 3.5.8.8 3.5.8 6.9c0 3.4 2.7 6.1 6.1 6.1 3.4 0 6.1-2.7 6.1-6.1z" />
      <path stroke-width="0.2"
          d="M9.5 10.4c.1 0 .2 0 .3-.1.1-.1.1-.4 0-.5l-3.3-3 3.2-2.9c.1-.1.2-.4 0-.5-.1-.1-.4-.2-.5 0L5.4 6.8l3.8 3.4c.1.1.2.2.3.2z" />
      <path stroke-width="0.2"
          d="M6.9 10.4c.1 0 .2 0 .3-.1.1-.1.1-.4 0-.5l-3.3-3 3.2-2.9c.1-.1.2-.4 0-.5-.1-.1-.3-.1-.4 0L2.9 6.8l3.8 3.4c0 .1.1.2.2.2z" />
  </g>
</g>

  `,
];

export const paginationArrowLeft = [
  '13.9 13.9',
  `

  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
    <path stroke-width="0.2"
        d="M8.1.1c1.6.3 2.9 1 4 2.2 1 1.1 1.6 2.4 1.7 3.9v1.1c0 .3-.1.5-.1.8-.4 2.1-1.5 3.7-3.3 4.8-1.2.7-2.5 1-3.8 1-2-.1-3.6-.9-4.9-2.4C.7 10.4.1 9.1 0 7.6-.2 5.4.5 3.5 2 2 3 1 4.3.3 5.7.1c.4 0 .6-.1.8-.1h.8c.3 0 .6.1.8.1zM13 6.9C13 3.5 10.3.8 6.9.8 3.5.8.8 3.5.8 6.9c0 3.4 2.7 6.1 6.1 6.1 3.4 0 6.1-2.7 6.1-6.1z" />
    <path stroke-width="0.2"
        d="M8.5 10.4c.1 0 .2 0 .3-.1.1-.1.1-.4 0-.5l-3.2-3 3.2-2.9c.1-.1.2-.4 0-.5-.1-.1-.4-.2-.5 0L4.5 6.8l3.8 3.4.2.2z" />
</g>
</g>
`,
];

export const paginationArrowRight = [
  '13.9 13.9',
  `
  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
    <path stroke-width="0.2"
        d="M6.5 0h.8c.3 0 .5.1.7.1 1.5.2 2.7.9 3.8 1.9 1.6 1.6 2.2 3.4 2 5.6-.1 1.5-.7 2.8-1.7 3.9-1.3 1.5-2.9 2.3-4.9 2.4-1.4.1-2.7-.3-3.8-1C1.6 11.8.5 10.2.1 8.1c0-.2-.1-.5-.1-.8V6.2c.2-1.5.7-2.8 1.7-3.9C2.8 1.1 4.1.4 5.7.1c.3 0 .6-.1.8-.1zm.4 13c3.4 0 6.1-2.7 6.1-6.1C13 3.5 10.3.8 6.9.8 3.5.8.8 3.5.8 6.9.9 10.3 3.6 13 6.9 13z" />
    <path stroke-width="0.2"
        d="M5.3 10.4c-.1 0-.2 0-.3-.1-.1-.1-.1-.4 0-.5l3.2-2.9-3.1-3c-.1-.1-.2-.4 0-.5.1-.1.4-.2.5 0l3.8 3.4-3.8 3.4c-.1.1-.2.2-.3.2z" />
</g>
</g>
`,
];

export const paginationDoubleArrowRight = [
  '13.9 13.9',
  `

  <g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
    <path stroke-width="0.2"
        d="M6.5 0h.8c.3 0 .5.1.7.1 1.5.2 2.7.9 3.8 1.9 1.6 1.6 2.2 3.4 2 5.6-.1 1.5-.7 2.8-1.7 3.9-1.3 1.5-2.9 2.3-4.9 2.4-1.4.1-2.7-.3-3.8-1C1.6 11.8.5 10.2.1 8.1c0-.2-.1-.5-.1-.8V6.2c.2-1.5.7-2.8 1.7-3.9C2.8 1.1 4.1.4 5.7.1c.3 0 .6-.1.8-.1zm.4 13c3.4 0 6.1-2.7 6.1-6.1C13 3.5 10.3.8 6.9.8 3.5.8.8 3.5.8 6.9.9 10.3 3.6 13 6.9 13z" />
    <path stroke-width="0.2"
        d="M4.4 10.4c-.1 0-.2 0-.3-.1-.1-.2-.1-.4.1-.6l3.2-2.9-3.2-2.9c-.2-.1-.2-.3-.1-.5.1-.1.4-.2.5 0l3.8 3.4-3.8 3.4c0 .1-.1.2-.2.2z" />
    <path stroke-width="0.2"
        d="M6.9 10.4c-.1 0-.2 0-.3-.1-.1-.1-.1-.4 0-.5l3.2-2.9-3.1-3c-.1-.1-.2-.4 0-.5.1-.1.4-.2.5 0L11 6.8l-3.8 3.4c-.1.1-.2.2-.3.2z" />
</g>
</g>`,
];

export const toastSuccess = [
  '19.2 19.2',
  `
  <style>
    .st0 {
        fill: #fff
    }
</style>
<path class="st0"
    d="M13.9 6.1 8.1 12 5.3 9.1c-.2-.1-.6-.1-.8 0s-.2.5 0 .7l3.6 3.6 6.6-6.6c.2-.2.2-.5 0-.7s-.6-.1-.8 0z" />
<path class="st0"
    d="M9.6 0C4.3 0 0 4.3 0 9.6s4.3 9.6 9.6 9.6 9.6-4.3 9.6-9.6S14.9 0 9.6 0zm0 18.2C4.9 18.2 1 14.3 1 9.6 1 4.9 4.9 1 9.6 1c4.7 0 8.6 3.9 8.6 8.6 0 4.7-3.9 8.6-8.6 8.6z" />
  `,
];

export const toastError = [
  '19.2 19.2',
  `
<style>
    .st0 {
        fill: #fff
    }
</style>
<path class="st0"
    d="M13.1 6.1c-.2-.2-.5-.2-.7 0L9.6 8.9 6.9 6.1c-.2-.1-.6-.1-.8 0s-.1.6 0 .8l2.7 2.7-2.7 2.7c-.2.2-.2.5 0 .7.1.1.2.1.4.1s.3 0 .4-.1l2.7-2.7 2.7 2.7c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7l-2.7-2.7 2.7-2.7c.1-.2.1-.6 0-.8z" />
<path class="st0"
    d="M9.6 0C4.3 0 0 4.3 0 9.6s4.3 9.6 9.6 9.6 9.6-4.3 9.6-9.6S14.9 0 9.6 0zm0 18.2C4.9 18.2 1 14.3 1 9.6 1 4.9 4.9 1 9.6 1c4.7 0 8.6 3.9 8.6 8.6 0 4.7-3.9 8.6-8.6 8.6z" />
`,
];

export const colapse = [
  '27.5 27.5',
  `
  <g data-name="Layer 2">
    <g style="opacity:.8">
      <circle cx="13.75" cy="13.73" r="13.75" style="fill:#706f6f"/>
    </g>
    <path d="M15.57 20.83Zm4.64-5.69H15a.62.62 0 0 0-.62.37 1.07 1.07 0 0 0-.05.34V21a.61.61 0 0 0 .37.62.57.57 0 0 0 .54 0 .67.67 0 0 0 .29-.57v-4.71h4.74a.6.6 0 0 0-.1-1.19Zm-8.28-8.47Zm1.2-.19a.61.61 0 0 0-.37-.62.57.57 0 0 0-.54 0 .67.67 0 0 0-.29.57v4.69H7.19a.6.6 0 0 0 .1 1.19h5.17a.61.61 0 0 0 .62-.37.72.72 0 0 0 .05-.33V6.49Z" style="fill:#fff"/>
  </g>
`,
];

export const extend = [
  '27.5 27.5',
  `
  <defs>
    <path id="a" d="M-2147.2-423.6h1924.6V657.9h-1924.6z"/>
  </defs>
  <clipPath id="b">
    <use xlink:href="#a" style="overflow:visible"/>
  </clipPath>
  <g style="opacity:.7;clip-path:url(#b)">
    <path d="M-222.6-113.4c4.6 12.3 23.9 25.8 33.1 34.8l-4.7 4.8c4.2 4.4 8.9 11.5 13.8 15.3 2 .5 101.7 8.1 103.6 9.1 7 18.1 15.6 43.8 22.1 62.2.8 2.1 2.9 3.5 5.1 3.7L31.1 22c.7.2 2.4 1 3.2 1.3.8.4 2.6.3 3.6.5" style="fill:none;stroke:#1e1e32;stroke-width:.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10"/>
  </g>
  <g style="opacity:.8">
    <circle cx="13.8" cy="13.8" r="13.8" style="fill:#706f6f"/>
  </g>
  <path d="M14.7 8.8H9.5c-.4 0-.5.2-.6.4 0 .1-.1.2 0 .3v5.1c0 .4.2.6.4.6.2.1.4.1.5 0 .1 0 .2-.2.2-.5V10h4.7c.3 0 .6-.3.5-.6.1-.3-.2-.6-.5-.6zm-1.9 9.9H18c.4 0 .6-.2.6-.4 0-.1.1-.2 0-.3v-5.2c0-.4-.2-.6-.4-.6-.2-.1-.4-.1-.5 0-.2.1-.3.3-.3.6v4.6h-4.7c-.3 0-.6.3-.5.6 0 .4.3.7.6.7z" style="fill:#fff"/>
`,
];

export const minus = [
  '13.9 13.9',
  `
  <style>
  .st4 {
      fill: #fff
  }
</style>
<g id="Layer_2">
  <defs>
      <path id="SVGID_00000147918636914304953440000012613217576109573794_"
          d="M-2145.1-496.9h1924.6V584.6h-1924.6z" />
  </defs>
  <clipPath id="SVGID_00000000918896208553474040000017313289224981337743_">
      <use xlink:href="#SVGID_00000147918636914304953440000012613217576109573794_" style="overflow:visible" />
  </clipPath>
  <g style="opacity:.7;clip-path:url(#SVGID_00000000918896208553474040000017313289224981337743_)">
      <path d="M34.4 16.4C-27.7-2.7-97.5-4.2-161.9-9.5"
          style="fill:none;stroke:#1e1e32;stroke-width:.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10" />
  </g>
  <g>
      <path class="st4"
          d="M6.5 0h.8c.3 0 .5.1.7.1 1.5.2 2.7.9 3.8 1.9 1.6 1.6 2.2 3.4 2 5.6-.1 1.5-.7 2.8-1.7 3.9-1.3 1.5-2.9 2.3-4.9 2.4-1.4.1-2.7-.3-3.8-1C1.6 11.8.5 10.2.1 8.1c0-.2-.1-.5-.1-.8V6.2c.2-1.5.7-2.8 1.7-3.9C2.8 1.1 4.1.4 5.7.1c.3 0 .6-.1.8-.1zm.4 13c3.4 0 6.1-2.7 6.1-6.1C13 3.5 10.3.8 6.9.8 3.5.8.8 3.5.8 6.9.9 10.3 3.6 13 6.9 13z" />
      <path class="st4"
          d="M7.4 7.4H9.7c.3 0 .4-.2.4-.5s-.2-.4-.5-.4H4.3c-.3 0-.4.2-.5.3-.1.1-.1.3 0 .4 0 .1.2.2.4.2H7.4z" />
  </g>
</g>
`,
];

export const plus = [
  '13.9 13.9',
  `
  <style>
  .st4 {
      fill: #fff
  }
</style>
<g id="Layer_2">
  <defs>
      <path id="SVGID_00000147918636914304953440000012613217576109573794_"
          d="M-2232.4-496.9h1924.6V584.6h-1924.6z" />
  </defs>
  <clipPath id="SVGID_00000073695371903003913100000015717804357519316136_">
      <use xlink:href="#SVGID_00000147918636914304953440000012613217576109573794_" style="overflow:visible" />
  </clipPath>
  <g>
      <path class="st4"
          d="M9.7 6.5H7.4V4.2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2.3H4.2c-.3 0-.4.2-.5.3-.1.1-.1.3 0 .4.1.1.3.2.5.2h2.3V9.8c0 .2.2.4.5.4.2 0 .4-.2.5-.4V7.4H9.8c.3 0 .4-.2.4-.5s-.2-.4-.5-.4z" />
      <path class="st4"
          d="M6.5 0h.8c.3 0 .5.1.7.1 1.5.2 2.7.9 3.8 1.9 1.6 1.6 2.2 3.4 2 5.6-.1 1.5-.7 2.8-1.7 3.9-1.3 1.5-2.9 2.3-4.9 2.4-1.4.1-2.7-.3-3.8-1C1.6 11.8.5 10.2.1 8.1c0-.2-.1-.5-.1-.8V6.2c.2-1.5.7-2.8 1.7-3.9C2.8 1.1 4.1.4 5.7.1c.3 0 .6-.1.8-.1zm.4 13c3.4 0 6.1-2.7 6.1-6.1C13 3.5 10.3.8 6.9.8 3.5.8.8 3.5.8 6.9.9 10.3 3.6 13 6.9 13z" />
  </g>
</g>
`,
];

export const mapPlusControl = [
  '27.5 27.5',
  `
  <defs>
    <path id="a" d="M-2147.2-347.3h1924.6V734.2h-1924.6z"/>
  </defs>
  <clipPath id="b">
    <use xlink:href="#a" style="overflow:visible"/>
  </clipPath>
  <g style="opacity:.7;clip-path:url(#b)">
    <path d="M-222.6-37.1c4.6 12.3 23.9 25.8 33.1 34.8l-4.7 4.8c4.2 4.4 8.9 11.5 13.8 15.3 2 .5 101.7 8.1 103.6 9.1 7 18.1 15.6 43.8 22.1 62.2.8 2.1 2.9 3.5 5.1 3.7l80.9 5.4c.7.2 2.4 1 3.2 1.3.8.4 2.6.3 3.6.5" style="fill:none;stroke:#1e1e32;stroke-width:.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10"/>
  </g>
  <g style="opacity:.8">
    <circle cx="13.8" cy="13.8" r="13.8" style="fill:#706f6f"/>
  </g>
  <path d="M18.2 13.1h-3.6V9.5c0-.5-.3-.8-.7-.8-.4 0-.7.3-.7.8v3.6H9.7c-.5 0-.7.2-.8.5-.1.2-.1.5.1.7.1.2.4.4.7.4h3.6v3.8c.1.4.4.6.7.6.3 0 .6-.3.7-.6v-3.8h3.7c.4-.1.7-.4.7-.8-.2-.5-.5-.8-.9-.8z" style="fill:#fff"/>
`,
];

export const mapMinusControl = [
  '27.5 27.5',
  `
  <defs>
    <path id="a" d="M-2147.2-385.1h1924.6V696.4h-1924.6z"/>
  </defs>
  <clipPath id="b">
    <use xlink:href="#a" style="overflow:visible"/>
  </clipPath>
  <g style="opacity:.7;clip-path:url(#b)">
    <path d="M-222.6-75c4.6 12.3 23.9 25.8 33.1 34.8l-4.7 4.8c4.2 4.4 8.9 11.5 13.8 15.3 2 .5 101.7 8.1 103.6 9.1 7 18.1 15.6 43.8 22.1 62.2.8 2.1 2.9 3.5 5.1 3.7l80.9 5.4c.7.2 2.4 1 3.2 1.3.8.4 2.6.3 3.6.5" style="fill:none;stroke:#1e1e32;stroke-width:.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10"/>
  </g>
  <g style="opacity:.8">
    <circle cx="13.8" cy="13.8" r="13.8" style="fill:#706f6f"/>
  </g>
  <path d="M14.6 14.2h3.7c.4-.1.7-.4.7-.8s-.4-.7-.8-.7H9.6c-.5 0-.7.2-.8.5-.1.2-.1.5.1.7.1.1.3.3.6.3h5.1z" style="fill:#fff"/>
`,
];

export const resetDate = [
  '25,25',

  `
<g fill="var(--ci-primary-color, currentColor)" stroke="var(--ci-primary-color, currentColor)">
<path  stroke-width="0.4"
d="M13.792 2.472a.713.713 0 1 0 0 1.426 9.203 9.203 0 1 1-9.203 9.203.669.669 0 0 0-.014-.073v-.016l.017.047 1.336 1.315a.673.673 0 0 0 .933.057.659.659 0 0 0 .234-.471.715.715 0 0 0-.22-.531c-.157-.158-.82-.816-.98-.972l-1.46-1.424a.679.679 0 0 0-1.071.006l-2.307 2.352a.75.75 0 0 0-.236.532.674.674 0 0 0 .581.648.72.72 0 0 0 .59-.222c.25-.253.927-.937 1.174-1.191A10.627 10.627 0 1 0 13.792 2.472ZM6.65 13.652Z" />
</g>
`,
];

export const info = [
  '110.808 110.808',
  `
<defs>
<style>
    .cls-1 {
        fill: #fff
    }
</style>
</defs>
<path class="cls-1"
d="M62.114 65.328c0 5.192-.042 10.385.024 15.576a3.78 3.78 0 0 1-2.079 3.619 9.008 9.008 0 0 1-8.955.177 3.973 3.973 0 0 1-2.291-3.887q.082-15.512.003-31.026a3.84 3.84 0 0 1 2.558-3.944 10.35 10.35 0 0 1 8.362.126 3.733 3.733 0 0 1 2.4 3.783c-.065 5.191-.022 10.384-.022 15.576ZM55.573 37.242a7.24 7.24 0 0 1-5.739-2.507 5.41 5.41 0 0 1 .072-7.372 7.593 7.593 0 0 1 10.786-.22 5.236 5.236 0 0 1 1.395 5.586 6.56 6.56 0 0 1-5.4 4.414 8.884 8.884 0 0 1-1.114.1Z" />
<path class="cls-1"
d="M55.404 110.808a55.404 55.404 0 1 1 55.404-55.404 55.466 55.466 0 0 1-55.404 55.404Zm0-100.473a45.069 45.069 0 1 0 45.069 45.069 45.12 45.12 0 0 0-45.07-45.07Z" />
`,
];

export const slowCharge = [
  '6 9.602',

  `
  <path
  d="M2.3 5.4h-.163c-.59 0-1.18-.002-1.771.001a.325.325 0 0 1-.332-.162.33.33 0 0 1 .068-.376Q1.859 2.518 3.614.17a.315.315 0 0 1 .398-.143.314.314 0 0 1 .166.379q-.243 1.49-.49 2.98l-.031.213h.16c.6 0 1.2.002 1.8 0a.341.341 0 0 1 .353.175.336.336 0 0 1-.079.374l-4.04 5.247c-.025.033-.05.067-.078.098a.3.3 0 0 1-.357.081.284.284 0 0 1-.162-.326c.033-.164.083-.326.127-.488l.89-3.235c.01-.035.016-.071.028-.125Zm-.037 2.422.03.016 2.796-3.634H4.9c-.515 0-1.03.002-1.546 0-.251-.002-.384-.15-.347-.383l.18-1.081.198-1.224-.022-.01L.9 4.802h1.748a.305.305 0 0 1 .328.423c-.106.398-.217.794-.326 1.191l-.386 1.406Z"
  style="fill:#c6c6c6" data-name="Layer 2" />
  
  `,
];

export const slowChargeBlack = [
  '6 9.602',

  `
  <path
  d="M2.3 5.4h-.163c-.59 0-1.18-.002-1.771.001a.325.325 0 0 1-.332-.162.33.33 0 0 1 .068-.376Q1.859 2.518 3.614.17a.315.315 0 0 1 .398-.143.314.314 0 0 1 .166.379q-.243 1.49-.49 2.98l-.031.213h.16c.6 0 1.2.002 1.8 0a.341.341 0 0 1 .353.175.336.336 0 0 1-.079.374l-4.04 5.247c-.025.033-.05.067-.078.098a.3.3 0 0 1-.357.081.284.284 0 0 1-.162-.326c.033-.164.083-.326.127-.488l.89-3.235c.01-.035.016-.071.028-.125Zm-.037 2.422.03.016 2.796-3.634H4.9c-.515 0-1.03.002-1.546 0-.251-.002-.384-.15-.347-.383l.18-1.081.198-1.224-.022-.01L.9 4.802h1.748a.305.305 0 0 1 .328.423c-.106.398-.217.794-.326 1.191l-.386 1.406Z"
  style="fill:#000000" data-name="Layer 2" />
  
  `,
];

export const fastCharge = [
  '14 10.061',

  `
  <defs>
</defs>
<g id="Layer_2" data-name="Layer 2">
  <path style="fill: #c6c6c6"
      d="M14 5.468c-.037.27-.063.542-.112.81a6.895 6.895 0 0 1-1.912 3.67.293.293 0 1 1-.414-.407 5.958 5.958 0 0 0 1.333-1.982A6.316 6.316 0 0 0 11.883.876c-.1-.124-.215-.236-.322-.354a.297.297 0 0 1-.02-.437.29.29 0 0 1 .435.028 6.888 6.888 0 0 1 1.944 3.873c.031.202.054.405.08.608ZM6.323 5.612h-.157c-.574 0-1.147-.002-1.721 0a.316.316 0 0 1-.322-.157.321.321 0 0 1 .066-.365Q5.896 2.812 7.6.532a.306.306 0 0 1 .387-.14.305.305 0 0 1 .16.369q-.235 1.447-.474 2.894l-.031.207h.155c.583 0 1.165.002 1.748 0a.331.331 0 0 1 .344.17.327.327 0 0 1-.077.364Q7.85 6.943 5.89 9.492c-.025.032-.05.066-.077.096a.291.291 0 0 1-.347.078.276.276 0 0 1-.157-.316c.032-.16.08-.317.124-.475l.864-3.142c.009-.034.015-.069.027-.121Zm-.035 2.352.029.016 2.716-3.53H8.85c-.5 0-1.002.002-1.502 0-.244-.002-.373-.146-.337-.372l.174-1.05q.098-.594.193-1.19l-.021-.008-2.394 3.2 1.698.001a.296.296 0 0 1 .319.41c-.104.387-.21.772-.317 1.158l-.375 1.365ZM0 5.172A7.053 7.053 0 0 1 1.994.151a.977.977 0 0 1 .079-.076.288.288 0 0 1 .416.395c-.122.147-.26.28-.383.427a6.21 6.21 0 0 0-1.47 3.405A6.297 6.297 0 0 0 2.01 9.05c.133.168.283.321.427.48a.305.305 0 0 1 .03.447.295.295 0 0 1-.444-.036A6.851 6.851 0 0 1 .089 6.078C.038 5.732.019 5.38 0 5.172Z" />
  <path style="fill: #c6c6c6"
      d="M11.669 4.977a4.604 4.604 0 0 0-1.251-3.122c-.037-.04-.077-.078-.113-.12a.293.293 0 0 1 .002-.416.273.273 0 0 1 .413.015 8.868 8.868 0 0 1 .785 1.01 5.226 5.226 0 0 1-.745 6.35c-.08.081-.172.162-.284.124a.458.458 0 0 1-.233-.181.269.269 0 0 1 .062-.313 9.672 9.672 0 0 0 .642-.813 4.56 4.56 0 0 0 .722-2.534ZM1.755 4.937a5.166 5.166 0 0 1 1.5-3.576.295.295 0 0 1 .391-.084.275.275 0 0 1 .128.33.632.632 0 0 1-.138.197 4.505 4.505 0 0 0-1.201 2.304 4.587 4.587 0 0 0 1.144 4.087c.037.04.076.078.113.12a.297.297 0 0 1 .01.427.283.283 0 0 1-.433-.03 8.479 8.479 0 0 1-.636-.784 5.21 5.21 0 0 1-.878-2.99Z" />
</g>
  
  `,
];

export const fastChargeBlack = [
  '17 21.98',
  `
  <g id="Layer_2" data-name="Layer 2">
  <path style="fill: #22d3bd;"
      d="M13.087 8.938c-.024.177-.041.355-.073.53a4.519 4.519 0 0 1-1.254 2.407.192.192 0 1 1-.27-.268 3.905 3.905 0 0 0 .873-1.299 4.14 4.14 0 0 0-.664-4.38c-.065-.081-.14-.154-.21-.232a.195.195 0 0 1-.025-.274l.011-.012a.19.19 0 0 1 .27 0l.015.018a4.514 4.514 0 0 1 1.275 2.539c.02.132.035.265.052.398ZM8.056 9.032H6.825a.207.207 0 0 1-.211-.103.21.21 0 0 1 .043-.239q1.119-1.493 2.236-2.987a.195.195 0 0 1 .359.15L8.94 7.75c-.007.04-.012.082-.02.136h.102l1.145-.001a.217.217 0 0 1 .226.112.214.214 0 0 1-.05.238l-2.572 3.34c-.016.021-.032.043-.05.063a.191.191 0 0 1-.228.051.18.18 0 0 1-.103-.207c.022-.105.053-.208.081-.311l.567-2.06.018-.079Zm-.023 1.542.019.01 1.78-2.313H8.727c-.16-.002-.244-.096-.22-.244.037-.23.076-.46.114-.688l.126-.78-.014-.006-1.569 2.098h1.113a.194.194 0 0 1 .21.27l-.208.758-.247.895ZM3.911 8.744a4.622 4.622 0 0 1 1.307-3.291.639.639 0 0 1 .052-.05.189.189 0 0 1 .273.26c-.08.096-.17.183-.251.279a4.07 4.07 0 0 0-.964 2.232 4.127 4.127 0 0 0 .9 3.111c.088.11.186.21.28.314a.2.2 0 0 1 .031.281l-.01.012a.194.194 0 0 1-.274-.002l-.018-.021A4.49 4.49 0 0 1 3.97 9.338c-.034-.227-.045-.457-.059-.594Z" />
  <path style="fill: #22d3bd;"
      d="M11.56 8.616a3.018 3.018 0 0 0-.82-2.046l-.074-.079a.192.192 0 0 1-.001-.27l.002-.003a.179.179 0 0 1 .252-.01l.018.02a5.812 5.812 0 0 1 .515.663 3.425 3.425 0 0 1-.488 4.16c-.053.054-.113.107-.186.083a.3.3 0 0 1-.153-.12.176.176 0 0 1 .04-.204 6.337 6.337 0 0 0 .421-.533 2.989 2.989 0 0 0 .473-1.661ZM5.062 8.59a3.386 3.386 0 0 1 .983-2.344.194.194 0 0 1 .256-.055.18.18 0 0 1 .084.216.414.414 0 0 1-.09.13 2.953 2.953 0 0 0-.788 1.51 3.007 3.007 0 0 0 .75 2.678c.024.027.05.052.074.078a.195.195 0 0 1 .012.275l-.005.005a.185.185 0 0 1-.284-.02 5.558 5.558 0 0 1-.417-.513 3.415 3.415 0 0 1-.575-1.96Z" />
</g>
<path style="fill: #22d3bd;" d="m9.548 13.597-1.046 1.046-1.046-1.046h2.092z" />
  `,
];

export const heatMap = [
  '44.277 33.464',

  `
  <defs>
</defs>
<g id="Layer_2" data-name="Layer 2">
  <circle style="fill: #E83578; opacity: 0.3;" class="cls-1" cx="16.732" cy="16.732" r="16.732" />
  <circle style="fill: #E83578; opacity: 0.3;" cx="34.755" cy="22.66" r="9.522" />
</g>
  
  `,
];

export const dots = [
  '27.84 27.6',
  `
  <defs>
</defs>
<g id="Layer_2" data-name="Layer 2">
  <image style="opacity:0.8;" class="cls-1" width="84" height="84" transform="matrix(.24 0 0 .24 0 6.24)"
      xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEnElEQVR4Xu2aTY7UMBCFXxAL7sEpuP+CU3APdmGB3GNq6ueVXXYayZ8UJSk7if3leYYe+rrvG4c6vkQdDjmO0GKO0GKO0GKO0GKO0GKO0GKO0GKO0GK+Rh128vvXjyvqo/Ht+8+3+bh3PfnRc1Sgx9NyHxG6QqTGE3K3Ct0lUrJT7BahBSIvANMD3SF2qdABkdn+wIDolWKXCE2KzPSNoCezSmq50ITMkX7sYNl+5WLLhBaJZO/R402Amlyl1BKhpMwZkewvJatPeG2V1B0fPS/YwrS2S9m8unYtW39BhiJk+qNnMBBPJFOTdZkiq63Vrf4ladSYWvKOzExdSyiLNviZ2vTS37HkAX9p98dWH2upe7Ue5kUCCFdcyPCST6TTO4/6Wsh+d1drCYvOl7A6oVZyvHRaqdS2hnXvdm6hts2kdCihZDqj42jS3qRk6lrtEsd9P+24nNUJBXyZWrKs9Fk1615WzTt+MZrSdEIH0ilr1l4ea2jtVjLbvkerlbI6oZFELUn9ubfJviD2PeGLHElpSuhgOqNJSqmRWK0NA/slpIQm8VLBSLVektaH3UusZwxTIdQblDYhZtKWNE92tLdqLtllTwtN3ljry0rwxGptIPbyuIfpQ0MLNWAGY/WJJu9dx9yHfW4ps0I12AlpfTVZbJu2945pMqtzhVCLaJKWLLYtkukxco1KlVBrELLODDyT0AzRSyyBEmpE3qtlB6qlzBNupXJGeAmU0ElGUtpzddso2WcOs0MoC5Myb9luk+axUmhWDEtVf29Mw6wUOgszwYp0av2z93jxlFDmT2iZPn1f5roe+j/wGFYKZScppUSTidolVn9Zz95XZaVQi8zAb/wrWntJ2ZRmnp+mWmh2+VhSqtMzez0NJdT4z38vEewy85CJ1OqjKV0GJXSC0XRKMf3W1zNo12bvEbJCKJNOa0KaSIkllklpZmwvMl/PqRQayZHHXrt2btXh7OVxDy0pAy2U+Dlqwcr0hMmad89IqnbPMmihSSJxWi0S69WivXfcMy03/UUHhRsfH9X6Y62P1rdNQmuP8F5YJFU7/0Tm5yeQTGjy5szErJTJrb9O1q17aHt53JOZm0lFQoG/g/FSqrW3CVxKrWGl1TtnpGrnn0gGCECdUAspl5XJLnsreazURvQcmqGvhA98Jcf7M9vMn94AXqpV086H0gmsTahMZ6sBejK1Jd/qDSZhzHHPkDiLoYQCQyn12rR7eWnVBu2lzhNblk5gbUKBzyntz61ksj8/gVhsJI95RorhhAJ0Sq1adK7V2WUbibb6TKUTSP47VOI8nJ2QTJOsZetevy2sXPI3/F9KstbXswKYFxjVp9MJTC75BvFlKmY5Z9qAvDB3ohUygckl3yAGYy07aznLNm2z+rP1JZQktEEktRH1i9ob3uDpiRGBoCkVCqSkAry4DPSEKkU2yoU2HhCbmsgKmcBCoUBaag9z3dDAV4lsLBXamBBbxmqRjS1CG0+I3SWysVVoz2q5u0U2HhPaUyX3KYk9byFUwgh+B3kabyn0f6bko+fhgyO0mCO0mCO0mCO0mCO0mCO0mCO0mD9mdB4kI6CO7wAAAABJRU5ErkJggg==" />
  <ellipse style="fill: #f7dc38;" class="cls-2" cx="10.04" cy="16.402" rx=".99" ry=".986" />
  <image style="opacity:0.8;" class="cls-1" width="84" height="85" transform="matrix(.24 0 0 .24 5.76 7.2)"
      xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABVCAYAAADXN8NkAAAACXBIWXMAAC4jAAAuIwF4pT92AAAElElEQVR4Xu2aS24bMRBES0EWuUdOkfsvcgrfwztlYwZ0uz/VzeaMDPABAjkk59PPJSaS/Xg+nzj08SNacMhxhDZzhDZzhDZzhDZzhDZzhDZzhDbzLYS+v/15vL/9eUTrXoHHK31Sqkr79fvvyxRxq9CqwIg7Bd8idJdIyR1iLxV6lUjJlWIvEbooUp5bfuArxG4VWhCZXT9IFbFT7BahSZGZtQx0QTvEtgrdINJawzw0swZAr9g2oQmZ3jr2GhKvCKrALqktQkmZ1pqK4IrAsNAOqT+jBQ1kRWZ/OFLCmGPHW1lOaJBObW5lbEZ78JUxAOspXRLqyGQFybFIooUsgpWoFr8i9Yq3POCLY0RbjMLlFqC9vR9wktlFOaGJdFryIqneOPMPD9PXjgHUU9qd0KxMRuo8pyVyIJM5J9Lqa8dLlBJKpjPqZ6V6aAmULdv/TyWlnQmNJO+SaiVzbuWcpC2l6V+BLP4nfp7TWinWe8l1cFqNsA6y1k+khRpYN44KtaR6YrVxFFpJWp5Gag9N7p2rLYu1Z2Zb2f9PZi/t2EMZAVYS5zFtXYS2V3rzkRhmjUuH0BlZVCTLS2ckVZMoxWkypbRliTP0HprcoC0xrFQ5P7/kOJQ2GpN9l0zttFAD7wGjQjwhmsCBnPN+INEzMHMpVoVqMEVYgrU57TXPa22l38IOoR5RYVrKouOMzO1QQo09xHvozFwkJjqWbebe7By9j1JCE1g39R7ewltTOZ99tiW6hWaIkjbPzS/2nFvYKZRNiId2Tsd1Kteg2CmUwUscw0ulE9gjdHXvG7zadSh2CPU+xmU+4r3adSh2CM2gfdOTKZL+xugqdgqVhVUK1c7puE7lGhQ7hUZ46ZRz84s95xa6hVqFVBKyuvex92SuRUMJNb6x9hKRmYuSFh3LNnNvdo7+1p4S2oj10IyY7A9C629nh1CmsEjmPKe95nmtrfRbWBXqPVxUhJcyTd5AzlnnzmNeP5pLQQtl95APokK8MSnyKV5yHEobjcm+S6b27l/SPfH549x8PPrW2Iw2psFK80Qy96HpEColemssgSDmLayUeum1YNa4pP7QAaC+vZ+Pq+2MHNMeOJIYtYMv18683YHEHhpg3TQqRGuf07Ecs8ZRaCUpcRbphALLKWXnWKRkrY3mtON0OoGePXTwhC5jjI+Hk3ulNpeFFbc1nUAxoUA6pVafTeaY8x7Wk+r1teNSOoHehAJfUzofa/0omZZIJmlMXzteopxQgP7zxuiYSbqF9vAZeWrx1XQC/Qm10JILfE0m89bWYERlr1liKaFA+BcVbPrYsRlWGjsGYC2dQINQoCS1Mm7B7KfM+LJM4Jq3/Pz2zoxrc9oadm5ZFkNLQoEwpTOVNEdUBH+iI51Ao1AgJRXg5FUSOmDWAOiTCTQLHWwQm4EuqFPkYIvQQVIsUJebKmKHyMFWoYOC2BnvH60UO0UOLhE6WBRb5gqRg0uFDq4Se6XIwS1CB7vE3iFycKtQSVXwnQIlLyXUYoh+JXEW30Lod6Lrl3SHD47QZo7QZo7QZo7QZo7QZo7QZo7QZv4BRnNSqN3wsU4AAAAASUVORK5CYII=" />
  <ellipse style="fill: #f7dc38;" class="cls-2" cx="15.835" cy="17.387" rx=".99" ry=".986" />
  <image style="opacity:0.8;" class="cls-1" width="84" height="84" transform="translate(7.68) scale(.24)"
      xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEjklEQVR4Xu2aS67bMAxFb4oOuo+uovsfdBXdR2fp4EEvLMvPpUTZQaEDBJIp2jWPaePFzeP5fOLQx5cs4VDjCG3mCG3mCG3mCG3mCG3mCG3mCG3ma5ZwB79//XhkOYNv33++1TeTxzt8U6oIzLhb8G1COyV63CH3cqFXiNRcKfYyoXeI1FwhdrvQSZGVfcoF7BS7TeiEyGq+RamYHWK3CC3IZPOq0EV1S20V2igyW5dEBVDFdUptE0rKjHKY/TO8YtIiu6S2CCVkzojMjgnUBYbFdki94rt8JEyvPWDHPbx87xjhsYnGSFnu0OAkKnE2prFOfiUGYK1Tr3w5wkhjcmSxcm3ER8zK07FpcR5LHVrozmg7y2XQRcjtaM3aBjDfpTs6lJUXSfViGq8rH+DW2pnuULI7s3km1Ytnz8SV+SczXdrdoYwULXPmltc5TxGz5pd0JzDZoQvdmY0DRuog6zpvjOafVLu0s0Mzyew4yKRaz0irM71xC+UOLXbn7CjRMfb5aY3bu7Trm1LWTUAuUY7yo7HW9dwavVgrJaHkVzOdExWUFZ99YMyt0Yt5OdOUhDp4J+GdaFa8FCS3tUidy8iU0PLIRgLQI1TCXn1WQrQ/c7xoLmFyKLqFDionbo2evGxNjsx8SZ4FLdRpe+bK6jgjdcwjIZkg5tzaoYUWyIrzYLuQOW6UM7MP/RzdIZSBlcKseWNGNZ9it1BGnMTrbvmpwHZnG7uFRjCyrbi135Zum6FLKNsJTMG7cpgLuMyK0Kx7opi1xl4Uzdt0J7AmNHtJEcUsdF51PzZ/KytCJawMJo8Rw+TcQpfQVdgL4K1nr+WytTZ2C2UL1DG939OYvyW7hTKw3eltr3Zp6wXaIbRamI553RnFNDO3d7gP+9Z+VWjXiVujJdaTnXXbzHlOQQtlr5CBV4wnIRLpiY1GCyZnClpoEeuEMwmsOC8/GvVcw+aldAhlTiaTqUdPnrcGYozmIZW7syS0cmDEBWXjmGdyZZwZ9dzaXqIkNIC58lmxcvRE6m0ZZ0c9lyzL7fzliMUTHy8tKiPwetGRFajXM5levkvxrqx3aPAPZB2QFam7jfkM9L7MqCmJ89jdocDHiepXayMmR6i5RO7PCGEkpgKr3QlMdCgw1aWyMKtYPZcxHbdi2fHlPhZlcR67O/SJv5+Hej4K0Z3JPkOBf3Oyi6rnJjPdCUx2KEB3abTmdZbc9jowiiOYj23JlDiP3R0KvE5Yd521rYvznp3MxbRyKJmz3QksdChQ7lKrGC0gilnr1n5RznbKP7i1IH+Em8XZ/8xbuYhZfKk7gf23/Dg5688mHZeFePkWFZHh2qpMYPGWHxAn4t1yWdy7nXVc72cRrbXRcssP2B9Ugb+9WaY6UkI0BUWrUKAkFeDlMc9QDZXXJXLQLnSwSSwDXVC3TGCjUKAsdTCzT6mIHSIHW4UOJsVqvBcnNDtFDi4ROmgSW+YKkYNLhQ6uEnulyMEtQiU75N4hcnC7UMms3DsFat5K6P9Ay1fPw4sjtJkjtJkjtJkjtJkjtJkjtJkjtJkjtJk/ObGEfr4T8ioAAAAASUVORK5CYII=" />
  <ellipse style="fill: #f7dc38;" class="cls-2" cx="17.815" cy="9.988" rx=".99" ry=".986" />
</g>`,
];

export const arrowUp = [
  '13.11 13.11',
  `
<defs>
<style>
    .cls-1 {
        fill: #c6c6c6
    }
</style>
</defs>
<g id="Layer_4" data-name="Layer 4">
<path class="cls-1"
    d="M6.555 13.11a6.555 6.555 0 1 1 6.555-6.555 6.562 6.562 0 0 1-6.555 6.555Zm0-12.195a5.64 5.64 0 1 0 5.64 5.64 5.647 5.647 0 0 0-5.64-5.64Z" />
<path class="cls-1"
    d="M9.525 6.252 6.555 2.98l-2.97 3.27a.306.306 0 1 0 .454.413l2.214-2.438v5.6a.303.303 0 0 0 .605 0v-5.6L9.07 6.664a.306.306 0 0 0 .454-.412Z" />
</g>
`,
];

export const arrowDown = [
  '13.11 13.11',
  `
  <defs>
  <style>
      .cls-1 {
          fill: #c6c6c6
      }
  </style>
</defs>
<g id="Layer_4" data-name="Layer 4">
  <path class="cls-1"
      d="M13.11 6.555A6.555 6.555 0 1 1 6.555 0a6.562 6.562 0 0 1 6.555 6.555Zm-.914 0a5.64 5.64 0 1 0-5.64 5.64 5.647 5.647 0 0 0 5.64-5.64Z" />
  <path class="cls-1"
      d="m9.525 6.858-2.97 3.271-2.97-3.27a.306.306 0 0 1 .454-.413l2.214 2.439V3.283a.303.303 0 0 1 .605 0v5.602L9.07 6.447a.306.306 0 0 1 .454.411Z" />
</g>
  
  `,
];

export const kpiPizza1 = [
  '39.019 39.019',
  `
  <defs>
  <linearGradient id="a" x1=".05" y1="19.51" x2="38.969" y2="19.51" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#3c3c3b" />
      <stop offset=".434" stop-color="#3f3f3e" />
      <stop offset=".741" stop-color="#484847" />
      <stop offset="1" stop-color="#575756" />
  </linearGradient>
</defs>
<g data-name="Layer 2">
  <path d="M19.51 19.51V.05A19.46 19.46 0 1 1 .05 19.51 19.007 19.007 0 0 1 10.675 2.17Z"
      style="fill:url(#a);stroke:#878787;stroke-miterlimit:10;stroke-width:.1px" />
  <path d="M19.51 19.51V.05A19.46 19.46 0 1 1 .05 19.51 19.007 19.007 0 0 1 10.675 2.17Z"
      style="fill:none;stroke:#878787;stroke-miterlimit:10;stroke-width:.1px" />
</g>
  `,
];

export const kpiPizza2 = [
  '39.019 39.019',
  `
  <defs>
  <linearGradient id="linear-gradient" x1=".05" y1="19.51" x2="38.969" y2="19.51" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#3c3c3b" />
      <stop offset=".434" stop-color="#3f3f3e" />
      <stop offset=".741" stop-color="#484847" />
      <stop offset="1" stop-color="#575756" />
  </linearGradient>
  <style>
      .cls-2 {
          fill: none;
          stroke: #878787;
          stroke-miterlimit: 10;
          stroke-width: .1px
      }
  </style>
</defs>
<g id="Layer_2" data-name="Layer 2">
  <path d="M19.51 19.51V.05A19.46 19.46 0 1 1 .05 19.51a18.05 18.05 0 0 1 2.44-9.435Z"
      style="fill:url(#linear-gradient)" />
  <path class="cls-2" d="M19.51 19.51V.05A19.46 19.46 0 1 1 .05 19.51a18.05 18.05 0 0 1 2.44-9.435Z" />
  <path class="cls-2" d="M19.51 19.51V.05A19.46 19.46 0 1 1 .05 19.51a18.05 18.05 0 0 1 2.44-9.435Z" />
</g>
  `,
];

export const kpiPizza3 = [
  '39.95 39.949',
  `
<defs>
<linearGradient id="a" x1=".05" y1="19.975" x2="39.9" y2="19.975" gradientUnits="userSpaceOnUse">
    <stop offset="0" stop-color="#3c3c3b" />
    <stop offset=".434" stop-color="#3f3f3e" />
    <stop offset=".741" stop-color="#484847" />
    <stop offset="1" stop-color="#575756" />
</linearGradient>
</defs>
<path d="M19.975 19.975V.05A19.925 19.925 0 1 1 .05 19.975a17.505 17.505 0 0 1 .303-3.46Z"
style="stroke:#878787;stroke-miterlimit:10;stroke-width:.1px;fill:url(#a)" data-name="Layer 2" />
`,
];

export const kpiDown = [
  '40.551 40.551',
  `
<defs>
<linearGradient id="linear-gradient" y1="20.276" x2="40.551" y2="20.276" gradientUnits="userSpaceOnUse">
    <stop offset="0" stop-color="#3c3c3b" />
    <stop offset=".434" stop-color="#3f3f3e" />
    <stop offset=".741" stop-color="#484847" />
    <stop offset="1" stop-color="#575756" />
</linearGradient>
<linearGradient id="linear-gradient-2" x1="10.846" y1="20.276" x2="29.707" y2="20.276"
    xlink:href="#linear-gradient" />
<linearGradient id="linear-gradient-3" x1="85.8" y1="106.831" x2="126.351" y2="106.831"
    gradientTransform="translate(-85.8 -86.556)" xlink:href="#linear-gradient" />
<style>
    .cls-3 {
        fill: url(#linear-gradient-3)
    }

    .cls-4 {
        fill: none;
        stroke: #878787;
        stroke-miterlimit: 10;
        stroke-width: .1px
    }
</style>
</defs>
<g id="Layer_2" data-name="Layer 2">
<path
    d="M40.551 20.276A20.276 20.276 0 1 1 20.275 0a20.298 20.298 0 0 1 20.276 20.276Zm-2.124 0a18.151 18.151 0 1 0-18.151 18.15 18.173 18.173 0 0 0 18.15-18.15Z"
    style="fill:url(#linear-gradient)" />
<path
    d="m29.461 21.213-9.186 10.118-9.186-10.118a.948.948 0 1 1 1.405-1.273l6.846 7.541V10.156a.936.936 0 0 1 1.871 0V27.48l6.846-7.541a.948.948 0 0 1 1.404 1.273Z"
    style="fill:url(#linear-gradient-2)" />
<path class="cls-3"
    d="M40.551 20.276A20.276 20.276 0 1 1 20.275 0a20.298 20.298 0 0 1 20.276 20.276Zm-2.124 0a18.151 18.151 0 1 0-18.151 18.15 18.173 18.173 0 0 0 18.15-18.15Z" />
<path class="cls-3"
    d="m29.461 21.213-9.186 10.118-9.186-10.118a.948.948 0 1 1 1.405-1.273l6.846 7.541V10.156a.936.936 0 0 1 1.871 0V27.48l6.846-7.541a.948.948 0 0 1 1.404 1.273Z" />
<path class="cls-4"
    d="M40.551 20.276A20.276 20.276 0 1 1 20.275 0a20.298 20.298 0 0 1 20.276 20.276Zm-2.124 0a18.151 18.151 0 1 0-18.151 18.15 18.173 18.173 0 0 0 18.15-18.15Z" />
<path class="cls-4"
    d="m29.461 21.213-9.186 10.118-9.186-10.118a.948.948 0 1 1 1.405-1.273l6.846 7.541V10.156a.936.936 0 0 1 1.871 0V27.48l6.846-7.541a.948.948 0 0 1 1.404 1.273Z" />
</g>
`,
];

export const kpiUp = [
  '40.551 40.551',
  `
  <defs>
  <linearGradient id="linear-gradient" y1="-676.184" x2="40.551" y2="-676.184"
      gradientTransform="matrix(1 0 0 -1 0 -655.908)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#3c3c3b" />
      <stop offset=".434" stop-color="#3f3f3e" />
      <stop offset=".741" stop-color="#484847" />
      <stop offset="1" stop-color="#575756" />
  </linearGradient>
  <linearGradient id="linear-gradient-2" x1="10.846" y1="-676.183" x2="29.707" y2="-676.183"
      xlink:href="#linear-gradient" />
  <linearGradient id="linear-gradient-3" x1="84.751" y1="-882.439" x2="125.302" y2="-882.439"
      gradientTransform="matrix(1 0 0 -1 -84.751 -862.163)" xlink:href="#linear-gradient" />
  <style>
      .cls-3 {
          fill: url(#linear-gradient-3)
      }

      .cls-4 {
          fill: none;
          stroke: #878787;
          stroke-miterlimit: 10;
          stroke-width: .1px
      }
  </style>
</defs>
<g id="Layer_2" data-name="Layer 2">
  <path
      d="M20.276 40.551A20.276 20.276 0 1 1 40.55 20.275a20.298 20.298 0 0 1-20.276 20.276Zm0-38.427a18.151 18.151 0 1 0 18.15 18.152 18.173 18.173 0 0 0-18.15-18.152Z"
      style="fill:url(#linear-gradient)" />
  <path
      d="M29.461 19.338 20.275 9.22 11.09 19.338a.948.948 0 1 0 1.405 1.273l6.846-7.541v17.325a.936.936 0 0 0 1.871 0V13.07l6.846 7.541a.948.948 0 0 0 1.404-1.273Z"
      style="fill:url(#linear-gradient-2)" />
  <path class="cls-3"
      d="M20.276 40.551A20.276 20.276 0 1 1 40.55 20.275a20.298 20.298 0 0 1-20.276 20.276Zm0-38.427a18.151 18.151 0 1 0 18.15 18.152 18.173 18.173 0 0 0-18.15-18.152Z" />
  <path class="cls-3"
      d="M29.461 19.338 20.275 9.22 11.09 19.338a.948.948 0 1 0 1.405 1.273l6.846-7.541v17.325a.936.936 0 0 0 1.871 0V13.07l6.846 7.541a.948.948 0 0 0 1.404-1.273Z" />
  <path class="cls-4"
      d="M20.276 40.551A20.276 20.276 0 1 1 40.55 20.275a20.298 20.298 0 0 1-20.276 20.276Zm0-38.427a18.151 18.151 0 1 0 18.15 18.152 18.173 18.173 0 0 0-18.15-18.152Z" />
  <path class="cls-4"
      d="M29.461 19.338 20.275 9.22 11.09 19.338a.948.948 0 1 0 1.405 1.273l6.846-7.541v17.325a.936.936 0 0 0 1.871 0V13.07l6.846 7.541a.948.948 0 0 0 1.404-1.273Z" />
</g>
  `,
];

export const circleArrowUp = [
  '21.5 21.493',
  `
  <defs>
  <style>
      .cls-1 {
          fill: #dadada
      }
  </style>
</defs>
<g id="Layer_4" data-name="Layer 4">
  <path class="cls-1"
      d="M21.333 12.595a10.545 10.545 0 0 1-3.416 6.147 10.62 10.62 0 0 1-6.084 2.7l-.453.051h-1.26c-.407-.054-.817-.092-1.22-.167a10.592 10.592 0 0 1-7.388-5.105 10.22 10.22 0 0 1-1.499-5.93 10.523 10.523 0 0 1 3.648-7.614A10.26 10.26 0 0 1 9.669.052a10.5 10.5 0 0 1 8.744 3.17 10.462 10.462 0 0 1 2.95 5.812c.06.357.092.72.137 1.079v1.26c-.055.407-.095.817-.167 1.222Zm-10.589 7.58a9.433 9.433 0 1 0-9.427-9.432 9.44 9.44 0 0 0 9.427 9.433Z" />
  <path class="cls-1"
      d="M5.446 13.247a.55.55 0 0 0 .957.37l4.516-4.975 4.515 4.975a.55.55 0 0 0 .815-.74l-5.33-5.87-5.331 5.87a.55.55 0 0 0-.142.37Z" />
</g>

  `,
];

export const circleArrowDown = [
  '21.5 21.493',
  `

  <defs>
  <style>
      .cls-1 {
          fill: #dadada
      }
  </style>
</defs>
<g id="Layer_4" data-name="Layer 4">
  <path class="cls-1"
      d="M21.5 10.12v1.26c-.045.36-.077.722-.137 1.08a10.462 10.462 0 0 1-2.95 5.811 10.5 10.5 0 0 1-8.744 3.17 10.26 10.26 0 0 1-6.008-2.625 10.523 10.523 0 0 1-3.648-7.614 10.221 10.221 0 0 1 1.499-5.93A10.592 10.592 0 0 1 8.9.168C9.303.092 9.713.055 10.12 0h1.26l.453.051a10.62 10.62 0 0 1 6.084 2.7A10.545 10.545 0 0 1 21.333 8.9c.072.404.112.814.167 1.222Zm-20.183.63a9.433 9.433 0 1 0 9.427-9.432 9.437 9.437 0 0 0-9.427 9.433Z" />
  <path class="cls-1"
      d="M5.446 8.246a.55.55 0 0 1 .957-.37l4.516 4.975 4.515-4.974a.55.55 0 0 1 .815.739l-5.33 5.871-5.331-5.871a.55.55 0 0 1-.142-.37Z" />
</g>
  `,
];

export const circleSuccess = [
  '21.684 21.684',
  `
  <defs>

  </defs>
  <g id="Layer_4"
      data-name="Layer 4">
      <path style="  fill: none; stroke: #95c11f;  stroke-linecap: round;   stroke-miterlimit: 10"  class="cls-1" d="m16.23 7.28-7.123 7.124-3.654-3.654" />
      <circle style="  fill: none; stroke: #95c11f;  stroke-linecap: round;   stroke-miterlimit: 10"  class="cls-1" cx="10.842" cy="10.842" r="10.342" />
  </g>
  `,
];

export const uploadFile = [
  '35 41.077',
  `
  <defs>
</defs>
<g id="Layer_4" data-name="Layer 4">
  <path class="cls-1"
      style="fill: #fff"
      d="M0 18.978V4.1A3.816 3.816 0 0 1 4.1.01Q12.133.007 20.166 0a1.409 1.409 0 0 1 1.187.537q4.328 5.085 8.69 10.142a1.527 1.527 0 0 1 .39 1.074c-.01 4.358-.002 8.715-.013 13.072a.655.655 0 0 0 .386.66 8.349 8.349 0 0 1-3.14 15.52 8.127 8.127 0 0 1-7.2-2.64.954.954 0 0 0-.775-.329q-7.796.014-15.591.007A3.818 3.818 0 0 1 0 33.95V18.978Zm28.872 5.648V12.18c-1.728 0-3.422.003-5.116-.001a3.8 3.8 0 0 1-3.977-3.974c-.004-2.044-.001-4.088-.001-6.132V1.53H4.047a2.304 2.304 0 0 0-2.525 2.542v29.9a2.308 2.308 0 0 0 2.565 2.55H19.134c-1.42-3.278-1.21-6.36 1.045-9.1 2.257-2.744 5.24-3.549 8.693-2.796Zm-2.251 1.246a6.846 6.846 0 1 0 6.849 6.867 6.852 6.852 0 0 0-6.85-6.867ZM21.299 2.826c0 1.92-.005 3.693.002 5.466a2.275 2.275 0 0 0 2.367 2.365c1.314.007 2.63.002 3.944 0 .1 0 .202-.018.37-.035Z" />
  <path class="cls-1"
      style="fill: #fff"
      d="M15.166 16.744H7.18a2.33 2.33 0 0 1-.427-.013.755.755 0 0 1 0-1.497 2.35 2.35 0 0 1 .426-.011h16.068a2.367 2.367 0 0 1 .427.011.755.755 0 0 1 0 1.497 2.328 2.328 0 0 1-.426.012h-8.082ZM15.203 21.308H7.217a3.772 3.772 0 0 1-.428-.008.756.756 0 0 1 .02-1.508 3.27 3.27 0 0 1 .333-.005h16.163c.095 0 .19-.005.285.003a.757.757 0 1 1-.02 1.515c-.126.009-.253.003-.38.003h-7.987ZM10.65 12.18c-1.204 0-2.408.002-3.613-.001-.599-.002-.947-.286-.947-.76 0-.474.347-.76.946-.76q3.613-.003 7.225 0c.6 0 .948.285.949.76 0 .472-.35.758-.947.76-1.205.003-2.409 0-3.613 0ZM27.385 31.651v3.34c0 .206.002.412-.001.618-.01.561-.294.903-.752.909-.46.005-.764-.338-.767-.892-.005-1.172-.002-2.344-.002-3.516v-.463l-.117-.09c-.226.251-.439.515-.681.749a.76.76 0 0 1-1.138.043.751.751 0 0 1 .057-1.104q1.011-1.038 2.049-2.05a.745.745 0 0 1 1.17-.012q1.041 1.008 2.05 2.049a.76.76 0 0 1 .046 1.139.775.775 0 0 1-1.14-.085c-.231-.216-.456-.438-.685-.657-.006-.005-.027.006-.09.022Z" />
</g>
  `,
];

export const commumity = [
  '111.322 111.322',
  `
  <defs>
</defs>
<g id="Layer_2" data-name="Layer 2">
  <path
  style="fill: #706f6f"
    class="cls-1"
    d="M31.478 60.855c.085-.364.148-.735.259-1.092a6.904 6.904 0 0 1 6.02-5.117 26.062 26.062 0 0 1 7.387-.035 1.506 1.506 0 0 1 1.35 1.725 1.528 1.528 0 0 1-1.753 1.266 22.404 22.404 0 0 0-7.004.122 3.914 3.914 0 0 0-3.235 3.915c-.004.313 0 .625 0 .999h.535c2.015 0 4.03-.006 6.045.004a1.506 1.506 0 1 1 .055 3.01q-4.085.026-8.17.003a1.65 1.65 0 0 1-1.489-1.116Z"
  />
  <path
  style="fill: #706f6f"
    class="cls-1"
    d="M55.608 70.371H45.174c-1.26 0-1.826-.556-1.824-1.804.002-1.59-.036-3.18.027-4.768a8.365 8.365 0 0 1 7.02-7.77 34.624 34.624 0 0 1 10.528 0 8.365 8.365 0 0 1 7.013 7.776c.065 1.65.033 3.304.025 4.957a1.51 1.51 0 0 1-1.685 1.607c-2.061.006-4.123.002-6.184.002h-4.486Zm9.33-3.046c0-1.076.028-2.097-.006-3.117a5.39 5.39 0 0 0-4.81-5.25 32.849 32.849 0 0 0-9.026.013 5.255 5.255 0 0 0-4.586 4.31 29.833 29.833 0 0 0-.114 3.948c0 .025.031.05.061.096ZM55.655 53.582a6.316 6.316 0 1 1 6.321-6.298 6.333 6.333 0 0 1-6.32 6.298Zm.01-3.023a3.292 3.292 0 1 0-3.302-3.305 3.308 3.308 0 0 0 3.303 3.305Z"
  />
  <path
  style="fill: #706f6f"
    class="cls-1"
    d="M76.78 62.638c.24-2.476-.843-4.309-2.887-4.84a9.524 9.524 0 0 0-2.329-.32c-1.679-.008-3.359.06-5.036.14a1.588 1.588 0 0 1-1.702-1.235 1.49 1.49 0 0 1 1.203-1.75 24.095 24.095 0 0 1 8.446.19 6.928 6.928 0 0 1 5.358 6.599 94.1 94.1 0 0 1 .003 2.643 1.509 1.509 0 0 1-1.607 1.593q-3.964.01-7.928 0a1.514 1.514 0 0 1-1.613-1.535 1.495 1.495 0 0 1 1.608-1.483c1.982-.007 3.964-.002 5.946-.002h.538ZM36.265 48.02a5.327 5.327 0 1 1 5.282 5.358 5.315 5.315 0 0 1-5.282-5.358Zm3.022.017a2.303 2.303 0 1 0 2.303-2.301 2.287 2.287 0 0 0-2.303 2.3ZM75.053 48.07a5.326 5.326 0 1 1-5.27-5.356 5.35 5.35 0 0 1 5.27 5.356Zm-3.025-.045a2.303 2.303 0 0 0-4.606.027 2.303 2.303 0 1 0 4.606-.027Z"
  />
  <path
  style="fill: #706f6f"
    class="cls-1"
    d="M55.66 111.322a55.661 55.661 0 1 1 55.662-55.66 55.724 55.724 0 0 1-55.661 55.66Zm0-107.207a51.546 51.546 0 1 0 51.547 51.546A51.604 51.604 0 0 0 55.66 4.115Z"
  />
</g>
  `,
];

export const commumityColoured = [
  '111.322 111.322',
  `
  <defs>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
    style="fill: #b3d1c7"
      class="cls-1"
      d="M31.478 60.855c.085-.364.148-.735.259-1.092a6.904 6.904 0 0 1 6.02-5.117 26.062 26.062 0 0 1 7.387-.035 1.506 1.506 0 0 1 1.35 1.725 1.528 1.528 0 0 1-1.753 1.266 22.404 22.404 0 0 0-7.004.122 3.914 3.914 0 0 0-3.235 3.915c-.004.313 0 .625 0 .999h.535c2.015 0 4.03-.006 6.045.004a1.506 1.506 0 1 1 .055 3.01q-4.085.026-8.17.003a1.65 1.65 0 0 1-1.489-1.116Z"
    />
    <path
    style="fill: #b3d1c7"
      class="cls-1"
      d="M55.608 70.371H45.174c-1.26 0-1.826-.556-1.824-1.804.002-1.59-.036-3.18.027-4.768a8.365 8.365 0 0 1 7.02-7.77 34.624 34.624 0 0 1 10.528 0 8.365 8.365 0 0 1 7.013 7.776c.065 1.65.033 3.304.025 4.957a1.51 1.51 0 0 1-1.685 1.607c-2.061.006-4.123.002-6.184.002h-4.486Zm9.33-3.046c0-1.076.028-2.097-.006-3.117a5.39 5.39 0 0 0-4.81-5.25 32.849 32.849 0 0 0-9.026.013 5.255 5.255 0 0 0-4.586 4.31 29.833 29.833 0 0 0-.114 3.948c0 .025.031.05.061.096ZM55.655 53.582a6.316 6.316 0 1 1 6.321-6.298 6.333 6.333 0 0 1-6.32 6.298Zm.01-3.023a3.292 3.292 0 1 0-3.302-3.305 3.308 3.308 0 0 0 3.303 3.305Z"
    />
    <path
    style="fill: #b3d1c7"
      class="cls-1"
      d="M76.78 62.638c.24-2.476-.843-4.309-2.887-4.84a9.524 9.524 0 0 0-2.329-.32c-1.679-.008-3.359.06-5.036.14a1.588 1.588 0 0 1-1.702-1.235 1.49 1.49 0 0 1 1.203-1.75 24.095 24.095 0 0 1 8.446.19 6.928 6.928 0 0 1 5.358 6.599 94.1 94.1 0 0 1 .003 2.643 1.509 1.509 0 0 1-1.607 1.593q-3.964.01-7.928 0a1.514 1.514 0 0 1-1.613-1.535 1.495 1.495 0 0 1 1.608-1.483c1.982-.007 3.964-.002 5.946-.002h.538ZM36.265 48.02a5.327 5.327 0 1 1 5.282 5.358 5.315 5.315 0 0 1-5.282-5.358Zm3.022.017a2.303 2.303 0 1 0 2.303-2.301 2.287 2.287 0 0 0-2.303 2.3ZM75.053 48.07a5.326 5.326 0 1 1-5.27-5.356 5.35 5.35 0 0 1 5.27 5.356Zm-3.025-.045a2.303 2.303 0 0 0-4.606.027 2.303 2.303 0 1 0 4.606-.027Z"
    />
    <path
    style="fill: #b3d1c7"
      class="cls-1"
      d="M55.66 111.322a55.661 55.661 0 1 1 55.662-55.66 55.724 55.724 0 0 1-55.661 55.66Zm0-107.207a51.546 51.546 0 1 0 51.547 51.546A51.604 51.604 0 0 0 55.66 4.115Z"
    />
  </g>
  `,
];

export const education = [
  '111.322 111.322',
  `
  <defs>
  <clipPath id="clip-path">
    <path style="fill: none" d="M-2462.044-567.388h1920V514.151h-1920z" />
  </clipPath>
</defs>
<g id="Layer_2" data-name="Layer 2">
  <g style="clip-path: url(#clip-path)">
    <g style="opacity: 0.7">
      <path
        d="M-578.125 22.343c36.66 2.989 75.417 13.297 111.985 16.956 38.788 5.154 86.703-1.19 125.552 2.928 58.38 2.683 123.88 11.558 182.139 5.702 11.895-2.988 23.699-10.46 36.354-9.575 25.433 1.616 55.43 14.851 80.528 18.724 31.67 4.087 76.542 15.004 107.664 20.25 14.177 1.28 36.537 2.226 50.35 4.056a2.594 2.594 0 0 0 .364-1.25"
        style="
          stroke: #1e1e32;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 0.75px;
          fill: none;
        "
      />
    </g>
  </g>
  <path
    class="cls-5"
    style="fill: #706f6f"
    d="M30.74 43.295a1.376 1.376 0 0 1 1.409-.722c.839.035 1.68.008 2.59.008 0-.7-.003-1.358 0-2.017a1.12 1.12 0 0 1 .845-1.258 19.468 19.468 0 0 1 13.887-.152 25.053 25.053 0 0 1 3.211 1.378c1.024.516 1.99 1.147 2.939 1.702 1.312-.722 2.596-1.515 3.952-2.157a20.948 20.948 0 0 1 11.008-2.032 17.935 17.935 0 0 1 5.22 1.28 1.161 1.161 0 0 1 .786 1.209c-.013.662-.003 1.325-.003 2.048.946 0 1.85.004 2.754-.002a1.022 1.022 0 0 1 1.02.429 2.039 2.039 0 0 1 .216.92q.017 12.217.009 24.435v3.602c0 1.05-.347 1.398-1.399 1.398H43.895c-3.926 0-7.853-.007-11.779.008a1.336 1.336 0 0 1-1.377-.774Zm43.764 24.228V54.641q0-6.571.007-13.142c0-.322-.063-.529-.402-.596a34.645 34.645 0 0 0-4.089-.794 19.977 19.977 0 0 0-12.917 3.738.83.83 0 0 0-.403.794q.015 12.533.008 25.066v.59c5.57-3.344 11.397-4.625 17.796-2.774Zm-19.916 2.76c.014-.14.025-.204.025-.268q.002-12.771-.012-25.542a.828.828 0 0 0-.33-.567 20.857 20.857 0 0 0-4.925-2.604 18.059 18.059 0 0 0-12.007-.445.623.623 0 0 0-.532.702q.023 12.722.012 25.445c0 .168.016.336.025.513 6.365-1.842 12.189-.568 17.744 2.766Zm-2.576.967c-.181-.119-.23-.16-.287-.187-5-2.477-10.122-3.196-15.457-1.114a1.515 1.515 0 0 1-1.05-.065c-.449-.197-.483-.674-.483-1.134q.007-11.73.003-23.458v-.602h-1.897v26.56Zm26.465-.003v-26.56h-1.893V68.608c0 .162.01.325-.006.486a1.036 1.036 0 0 1-1.397.922c-.215-.07-.42-.168-.634-.245a17.992 17.992 0 0 0-13.588.656c-.523.22-1.029.483-1.543.726l.04.095Z"
  />
  <path
    class="cls-5"
    style="fill: #706f6f"
    d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.661 55.724 55.724 0 0 1-55.66 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.66 4.115Z"
  />
</g>
  `,
];

export const educationColoured = [
  '111.322 111.322',
  `
  <defs>
    <clipPath id="clip-path">
      <path style="fill: none" d="M-2462.044-777.041h1920V304.498h-1920z" />
    </clipPath>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
      style="fill: #f0b394"
      class="cls-4"
      d="M30.74 43.295a1.376 1.376 0 0 1 1.409-.722c.839.035 1.68.008 2.59.008 0-.7-.003-1.358 0-2.017a1.12 1.12 0 0 1 .845-1.258 19.468 19.468 0 0 1 13.887-.152 25.053 25.053 0 0 1 3.211 1.378c1.024.516 1.99 1.147 2.939 1.702 1.312-.722 2.596-1.515 3.952-2.157a20.948 20.948 0 0 1 11.008-2.032 17.935 17.935 0 0 1 5.22 1.28 1.161 1.161 0 0 1 .786 1.209c-.013.662-.003 1.325-.003 2.048.946 0 1.85.004 2.754-.002a1.022 1.022 0 0 1 1.02.429 2.039 2.039 0 0 1 .216.92q.017 12.217.009 24.435v3.602c0 1.05-.347 1.398-1.399 1.398H43.895c-3.926 0-7.853-.007-11.779.008a1.336 1.336 0 0 1-1.377-.774Zm43.764 24.228V54.641q0-6.571.007-13.142c0-.322-.063-.529-.402-.596a34.645 34.645 0 0 0-4.089-.794 19.977 19.977 0 0 0-12.917 3.738.83.83 0 0 0-.403.794q.015 12.533.008 25.066v.59c5.57-3.344 11.397-4.625 17.796-2.774Zm-19.916 2.76c.014-.14.025-.204.025-.268q.002-12.771-.012-25.542a.828.828 0 0 0-.33-.567 20.857 20.857 0 0 0-4.925-2.604 18.059 18.059 0 0 0-12.007-.445.623.623 0 0 0-.532.702q.023 12.722.012 25.445c0 .168.016.336.025.513 6.365-1.842 12.189-.568 17.744 2.766Zm-2.576.967c-.181-.119-.23-.16-.287-.187-5-2.477-10.122-3.196-15.457-1.114a1.515 1.515 0 0 1-1.05-.065c-.449-.197-.483-.674-.483-1.134q.007-11.73.003-23.458v-.602h-1.897v26.56Zm26.465-.003v-26.56h-1.893V68.608c0 .162.01.325-.006.486a1.036 1.036 0 0 1-1.397.922c-.215-.07-.42-.168-.634-.245a17.992 17.992 0 0 0-13.588.656c-.523.22-1.029.483-1.543.726l.04.095Z"
    />
    <path
      style="fill: #f0b394"
      class="cls-4"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.661 55.724 55.724 0 0 1-55.66 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.66 4.115Z"
    />
  </g>
  `,
];

export const healthcare = [
  '111.322 111.322',
  `
  <defs>
    <clipPath id="clip-path">
      <path style="fill: none" d="M-2287.646-567.388h1920V514.151h-1920z" />
    </clipPath>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <g style="clip-path: url(#clip-path)">
      <g style="opacity: 0.7">
        <path
          d="M-403.726 22.344c36.658 2.988 75.416 13.296 111.984 16.955 38.788 5.154 86.703-1.189 125.553 2.928 58.38 2.684 123.88 11.558 182.138 5.703 11.895-2.989 23.699-10.46 36.354-9.576 25.433 1.616 55.43 14.852 80.528 18.724 31.67 4.087 76.543 15.004 107.665 20.25 14.176 1.28 36.537 2.226 50.349 4.056a2.594 2.594 0 0 0 .365-1.25"
          style="
            stroke: #1e1e32;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 0.75px;
            fill: none;
          "
        />
      </g>
    </g>
    <path
      class="cls-5"
      style="fill: #706f6f"
      d="M62.786 62.786V72.214c-.002 1.486-.465 1.945-1.956 1.946q-5.191.002-10.383 0c-1.444-.001-1.908-.469-1.91-1.927q-.005-4.294-.001-8.588v-.859h-9.387c-1.544-.001-1.986-.442-1.987-1.978q-.002-5.192 0-10.383c.002-1.404.48-1.885 1.885-1.887q4.327-.007 8.653-.002h.836v-9.409c.002-1.509.45-1.964 1.936-1.964q5.192-.003 10.384 0c1.459 0 1.927.46 1.929 1.907q.006 4.294.001 8.589v.877H72.217c1.405.002 1.942.536 1.942 1.933q.004 5.192 0 10.384c0 1.483-.457 1.931-1.967 1.933q-4.263.003-8.525 0ZM51.401 40.04v.717l-.001 8.72c-.002 1.409-.519 1.922-1.938 1.923q-4.36.004-8.72 0h-.702v8.522h9.436c1.41.002 1.923.52 1.924 1.938q.003 4.36 0 8.72v.702h8.521v-.716l.001-8.72c.002-1.41.519-1.922 1.937-1.924q4.392-.003 8.784-.002c.245 0 .49-.023.718-.034V51.4H61.955c-1.443-.002-1.937-.49-1.938-1.91q-.002-4.392 0-8.783v-.668Z"
    />
    <path
      class="cls-5"
      style="fill: #706f6f"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.66 55.724 55.724 0 0 1-55.661 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.66 4.115Z"
    />
  </g>
  `,
];

export const healthcareColoured = [
  '111.322 111.322',
  `
  <defs>
    <clipPath id="clip-path">
      <path style="fill: none" d="M-2287.646-777.041h1920V304.498h-1920z" />
    </clipPath>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
      style="fill: #e83578"
      class="cls-4"
      d="M62.786 62.786V72.214c-.002 1.486-.465 1.945-1.956 1.946q-5.191.002-10.383 0c-1.444-.001-1.908-.469-1.91-1.927q-.005-4.294-.001-8.588v-.859h-9.387c-1.544-.001-1.986-.442-1.987-1.978q-.002-5.192 0-10.383c.002-1.404.48-1.885 1.885-1.887q4.327-.007 8.653-.002h.836v-9.409c.002-1.509.45-1.964 1.936-1.964q5.192-.003 10.384 0c1.459 0 1.927.46 1.929 1.907q.006 4.294.001 8.589v.877H72.217c1.405.002 1.942.536 1.942 1.933q.004 5.192 0 10.384c0 1.483-.457 1.931-1.967 1.933q-4.263.003-8.525 0ZM51.401 40.04v.717l-.001 8.72c-.002 1.409-.519 1.922-1.938 1.923q-4.36.004-8.72 0h-.702v8.522h9.436c1.41.002 1.923.52 1.924 1.938q.003 4.36 0 8.72v.702h8.521v-.716l.001-8.72c.002-1.41.519-1.922 1.937-1.924q4.392-.003 8.784-.002c.245 0 .49-.023.718-.034V51.4H61.955c-1.443-.002-1.937-.49-1.938-1.91q-.002-4.392 0-8.783v-.668Z"
    />
    <path
      style="fill: #e83578"
      class="cls-4"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.66 55.724 55.724 0 0 1-55.661 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.66 4.115Z"
    />
  </g>
  `,
];

export const work = [
  '111.322 111.322',
  `
  <defs>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
      style="fill: #706f6f"
      class="cls-1"
      d="M36.124 69.787V43.916a1.47 1.47 0 0 1 1.537-.85c3.179.024 6.358.01 9.537.01h.45c0-.417-.008-.773.002-1.128a3.403 3.403 0 0 1 3.408-3.438c3.063-.04 6.128-.035 9.192-.002a3.353 3.353 0 0 1 3.384 3.086 12.779 12.779 0 0 1 .009 1.482H73.876a1.151 1.151 0 0 1 1.32 1.303q.004 12.454-.013 24.909a3.845 3.845 0 0 1-.345 1.58 3.352 3.352 0 0 1-3.292 1.972h-20.79l-10.986.001a3.33 3.33 0 0 1-2.958-1.427 8.91 8.91 0 0 1-.688-1.627Zm36.784-18.282-.065-.008c-.033.093-.067.185-.098.278l-1.593 4.768a3.464 3.464 0 0 1-3.549 2.56q-2.899.002-5.798 0h-.42c0 .397.005.74-.002 1.081a1.139 1.139 0 0 1-1.195 1.205q-4.52.01-9.042 0a1.145 1.145 0 0 1-1.208-1.23c-.005-.34 0-.68 0-1.056H43.73a3.465 3.465 0 0 1-3.568-2.584l-1.326-3.974c-.118-.354-.24-.706-.361-1.06l-.063.016v17.615c0 1.026.407 1.434 1.428 1.434h31.627c1.044 0 1.44-.402 1.44-1.46V51.886Zm-22.97 5.307c0-.377-.005-.717 0-1.057a1.145 1.145 0 0 1 1.21-1.229q4.52-.008 9.041.001a1.138 1.138 0 0 1 1.194 1.206c.007.351.001.703.001 1.08h6.144a1.273 1.273 0 0 0 1.48-1.072l3.321-9.973c.041-.123.078-.248.118-.375h-33.58l.612 1.836 2.852 8.563c.237.71.575 1.013 1.211 1.016 2.111.011 4.222.004 6.395.004Zm-.001-13.768h11.446c0-.37.01-.736-.002-1.101a1.143 1.143 0 0 0-1.167-1.154c-.28-.009-.559-.002-.838-.002h-8.157a1.16 1.16 0 0 0-1.281 1.273c-.004.318-.001.635-.001.984Zm9.14 13.79h-6.825v2.24h6.824Z"
    />
    <path
      style="fill: #706f6f"
      class="cls-1"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.66 55.724 55.724 0 0 1-55.66 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.661 4.115Z"
    />
  </g>
  `,
];

export const workColoured = [
  '111.322 111.322',
  `
  <defs>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
      style="fill: #f7dc38"
      class="cls-1"
      d="M36.124 69.787V43.916a1.47 1.47 0 0 1 1.537-.85c3.179.024 6.358.01 9.537.01h.45c0-.417-.008-.773.002-1.128a3.403 3.403 0 0 1 3.408-3.438c3.063-.04 6.128-.035 9.192-.002a3.353 3.353 0 0 1 3.384 3.086 12.779 12.779 0 0 1 .009 1.482H73.876a1.151 1.151 0 0 1 1.32 1.303q.004 12.454-.013 24.909a3.845 3.845 0 0 1-.345 1.58 3.352 3.352 0 0 1-3.292 1.972h-20.79l-10.986.001a3.33 3.33 0 0 1-2.958-1.427 8.91 8.91 0 0 1-.688-1.627Zm36.784-18.282-.065-.008c-.033.093-.067.185-.098.278l-1.593 4.768a3.464 3.464 0 0 1-3.549 2.56q-2.899.002-5.798 0h-.42c0 .397.005.74-.002 1.081a1.139 1.139 0 0 1-1.195 1.205q-4.52.01-9.042 0a1.145 1.145 0 0 1-1.208-1.23c-.005-.34 0-.68 0-1.056H43.73a3.465 3.465 0 0 1-3.568-2.584l-1.326-3.974c-.118-.354-.24-.706-.361-1.06l-.063.016v17.615c0 1.026.407 1.434 1.428 1.434h31.627c1.044 0 1.44-.402 1.44-1.46V51.886Zm-22.97 5.307c0-.377-.005-.717 0-1.057a1.145 1.145 0 0 1 1.21-1.229q4.52-.008 9.041.001a1.138 1.138 0 0 1 1.194 1.206c.007.351.001.703.001 1.08h6.144a1.273 1.273 0 0 0 1.48-1.072l3.321-9.973c.041-.123.078-.248.118-.375h-33.58l.612 1.836 2.852 8.563c.237.71.575 1.013 1.211 1.016 2.111.011 4.222.004 6.395.004Zm-.001-13.768h11.446c0-.37.01-.736-.002-1.101a1.143 1.143 0 0 0-1.167-1.154c-.28-.009-.559-.002-.838-.002h-8.157a1.16 1.16 0 0 0-1.281 1.273c-.004.318-.001.635-.001.984Zm9.14 13.79h-6.825v2.24h6.824Z"
    />
    <path
      style="fill: #f7dc38"
      class="cls-1"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.66 55.724 55.724 0 0 1-55.66 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.661 4.115Z"
    />
  </g>
  `,
];

export const event = [
  '111.322 111.322',
  `
  <defs>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
      style="fill: #706f6f"
      class="cls-1"
      d="M65.83 76.323H40.568a.629.629 0 0 0-.142-.065 5.443 5.443 0 0 1-4.66-5.532q-.014-13.538.001-27.076a5.448 5.448 0 0 1 5.63-5.587h2.013c0-.506-.006-.973.001-1.44A1.548 1.548 0 0 1 44.951 35a1.531 1.531 0 0 1 1.52 1.634c.003.466 0 .932 0 1.4h18.38v-.425c0-.35-.005-.7.001-1.05a1.526 1.526 0 1 1 3.052-.06c.026.505.004 1.014.004 1.564.7 0 1.356-.014 2.01.006a7.108 7.108 0 0 1 1.321.123 5.457 5.457 0 0 1 4.317 5.534q.01 11.137.007 22.274a1.994 1.994 0 0 1-.624 1.508c-2.682 2.664-5.345 5.346-8.029 8.007a9.422 9.422 0 0 1-1.08.809ZM43.41 41.126h-1.996a2.422 2.422 0 0 0-2.592 2.6q-.006 13.458 0 26.916a2.43 2.43 0 0 0 2.62 2.616q10.33.002 20.66 0h.44c0-1.841-.006-3.616.004-5.391a4.898 4.898 0 0 1 .104-1.08 3.498 3.498 0 0 1 3.544-2.715c1.937-.012 3.874-.003 5.811-.003h.496v-.501L72.5 43.835a4.09 4.09 0 0 0-.041-.643 2.154 2.154 0 0 0-1.693-1.94 19.24 19.24 0 0 0-2.854-.167c0 .544.004.986-.001 1.43a1.536 1.536 0 1 1-3.06-.01c-.003-.451 0-.903 0-1.346H46.47c0 .475.003.918 0 1.36a1.55 1.55 0 0 1-1.534 1.666 1.566 1.566 0 0 1-1.527-1.684c-.003-.441 0-.883 0-1.375Zm22.193 31.125 5.113-5.116c-1.456 0-3.052-.006-4.648.006-.326.002-.465.23-.465.544v4.566Z"
    />
    <path
      style="fill: #706f6f"
      class="cls-1"
      d="M46.862 64.075a1.916 1.916 0 1 1-1.919 1.894 1.933 1.933 0 0 1 1.919-1.894ZM46.86 56.43a1.912 1.912 0 1 1-1.917 1.89 1.916 1.916 0 0 1 1.917-1.89ZM63.69 48.782a1.907 1.907 0 1 1-1.9 1.89 1.886 1.886 0 0 1 1.9-1.89ZM57.19 65.987a1.909 1.909 0 1 1-1.896-1.912 1.928 1.928 0 0 1 1.897 1.912ZM65.6 58.347a1.905 1.905 0 1 1-1.917-1.919 1.905 1.905 0 0 1 1.917 1.92ZM46.87 48.783a1.906 1.906 0 1 1-1.927 1.914 1.908 1.908 0 0 1 1.927-1.914ZM53.373 58.341a1.909 1.909 0 1 1 3.818-.004 1.909 1.909 0 1 1-3.818.004ZM55.268 48.783a1.907 1.907 0 1 1-1.895 1.894 1.9 1.9 0 0 1 1.895-1.894Z"
    />
    <path
      style="fill: #706f6f"
      class="cls-1"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.66 55.724 55.724 0 0 1-55.661 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.66 4.115Z"
    />
  </g>
  `,
];

export const eventColoured = [
  '111.322 111.322',
  `
  <defs>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
      style="fill: #e83578"
      class="cls-1"
      d="M65.83 76.323H40.568a.629.629 0 0 0-.142-.065 5.443 5.443 0 0 1-4.66-5.532q-.014-13.538.001-27.076a5.448 5.448 0 0 1 5.63-5.587h2.013c0-.506-.006-.973.001-1.44A1.548 1.548 0 0 1 44.951 35a1.531 1.531 0 0 1 1.52 1.634c.003.466 0 .932 0 1.4h18.38v-.425c0-.35-.005-.7.001-1.05a1.526 1.526 0 1 1 3.052-.06c.026.505.004 1.014.004 1.564.7 0 1.356-.014 2.01.006a7.108 7.108 0 0 1 1.321.123 5.457 5.457 0 0 1 4.317 5.534q.01 11.137.007 22.274a1.994 1.994 0 0 1-.624 1.508c-2.682 2.664-5.345 5.346-8.029 8.007a9.422 9.422 0 0 1-1.08.809ZM43.41 41.126h-1.996a2.422 2.422 0 0 0-2.592 2.6q-.006 13.458 0 26.916a2.43 2.43 0 0 0 2.62 2.616q10.33.002 20.66 0h.44c0-1.841-.006-3.616.004-5.391a4.898 4.898 0 0 1 .104-1.08 3.498 3.498 0 0 1 3.544-2.715c1.937-.012 3.874-.003 5.811-.003h.496v-.501L72.5 43.835a4.09 4.09 0 0 0-.041-.643 2.154 2.154 0 0 0-1.693-1.94 19.24 19.24 0 0 0-2.854-.167c0 .544.004.986-.001 1.43a1.536 1.536 0 1 1-3.06-.01c-.003-.451 0-.903 0-1.346H46.47c0 .475.003.918 0 1.36a1.55 1.55 0 0 1-1.534 1.666 1.566 1.566 0 0 1-1.527-1.684c-.003-.441 0-.883 0-1.375Zm22.193 31.125 5.113-5.116c-1.456 0-3.052-.006-4.648.006-.326.002-.465.23-.465.544v4.566Z"
    />
    <path
      style="fill: #e83578"
      class="cls-1"
      d="M46.862 64.075a1.916 1.916 0 1 1-1.919 1.894 1.933 1.933 0 0 1 1.919-1.894ZM46.86 56.43a1.912 1.912 0 1 1-1.917 1.89 1.916 1.916 0 0 1 1.917-1.89ZM63.69 48.782a1.907 1.907 0 1 1-1.9 1.89 1.886 1.886 0 0 1 1.9-1.89ZM57.19 65.987a1.909 1.909 0 1 1-1.896-1.912 1.928 1.928 0 0 1 1.897 1.912ZM65.6 58.347a1.905 1.905 0 1 1-1.917-1.919 1.905 1.905 0 0 1 1.917 1.92ZM46.87 48.783a1.906 1.906 0 1 1-1.927 1.914 1.908 1.908 0 0 1 1.927-1.914ZM53.373 58.341a1.909 1.909 0 1 1 3.818-.004 1.909 1.909 0 1 1-3.818.004ZM55.268 48.783a1.907 1.907 0 1 1-1.895 1.894 1.9 1.9 0 0 1 1.895-1.894Z"
    />
    <path
      style="fill: #e83578"
      class="cls-1"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.66 55.724 55.724 0 0 1-55.661 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.66 4.115Z"
    />
  </g>
  `,
];

export const ecommerece = [
  '111.322 111.322',
  `
  <defs>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
    style="fill: #706f6f"
      class="cls-1"
      d="M48.499 68.682c-.668 0-1.335.004-2.002 0a4.218 4.218 0 0 1-4.338-4.337 22.956 22.956 0 0 0-.685-5.672c-1.467-6.463-2.884-12.938-4.33-19.406a4.291 4.291 0 0 0-.416-1.116 1.442 1.442 0 0 0-1.483-.845 15.062 15.062 0 0 1-1.648.007 1.428 1.428 0 0 1-1.437-1.445 1.413 1.413 0 0 1 1.435-1.4 13.896 13.896 0 0 1 2.577.055A4.56 4.56 0 0 1 39.8 38.15c.403 1.44.67 2.918 1 4.38.034.155.077.31.122.49h32.087c.133 0 .267-.002.4 0a1.415 1.415 0 0 1 1.452 1.847q-1.629 6.562-3.272 13.12c-.083.331-.16.664-.244.994a5.254 5.254 0 0 1-5.148 3.998q-10.313.004-20.627.001h-.563a16.363 16.363 0 0 0 .012 1.662 1.395 1.395 0 0 0 1.315 1.185c.163.011.327.005.49.005l26.374.001a2.883 2.883 0 0 1 .62.038 1.42 1.42 0 0 1-.3 2.807c-1.486.014-2.97.005-4.456.005a3.092 3.092 0 0 0-.498.028 4.463 4.463 0 0 1 2.77 1.849 4.201 4.201 0 0 1 .654 3.27 4.274 4.274 0 0 1-8.42-.294c-.355-2.144.932-3.935 3.508-4.837H50.001c2.657.903 3.891 2.737 3.457 5.096a4.274 4.274 0 0 1-8.444-.4 4.394 4.394 0 0 1 3.485-4.712Zm23.167-22.784h-30.1c.023.147.035.265.06.38.993 4.458 1.993 8.914 2.969 13.375.084.388.227.484.605.483q10.448-.017 20.895-.008a2.415 2.415 0 0 0 2.508-1.957q1.143-4.574 2.29-9.147c.259-1.034.512-2.068.773-3.126ZM49.23 74.384a1.425 1.425 0 1 0-1.387-1.45 1.438 1.438 0 0 0 1.387 1.45Zm18.609-2.849a1.425 1.425 0 1 0 1.387 1.45 1.441 1.441 0 0 0-1.387-1.45Z"
    />
    <path
    style="fill: #706f6f"
      class="cls-1"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.661 55.724 55.724 0 0 1-55.66 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.661 4.115Z"
    />
  </g>
  `,
];

export const ecommereceColoured = [
  '111.322 111.322',
  `
  <defs>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
    style="fill: #f0b394"
      class="cls-1"
      d="M48.499 68.682c-.668 0-1.335.004-2.002 0a4.218 4.218 0 0 1-4.338-4.337 22.956 22.956 0 0 0-.685-5.672c-1.467-6.463-2.884-12.938-4.33-19.406a4.291 4.291 0 0 0-.416-1.116 1.442 1.442 0 0 0-1.483-.845 15.062 15.062 0 0 1-1.648.007 1.428 1.428 0 0 1-1.437-1.445 1.413 1.413 0 0 1 1.435-1.4 13.896 13.896 0 0 1 2.577.055A4.56 4.56 0 0 1 39.8 38.15c.403 1.44.67 2.918 1 4.38.034.155.077.31.122.49h32.087c.133 0 .267-.002.4 0a1.415 1.415 0 0 1 1.452 1.847q-1.629 6.562-3.272 13.12c-.083.331-.16.664-.244.994a5.254 5.254 0 0 1-5.148 3.998q-10.313.004-20.627.001h-.563a16.363 16.363 0 0 0 .012 1.662 1.395 1.395 0 0 0 1.315 1.185c.163.011.327.005.49.005l26.374.001a2.883 2.883 0 0 1 .62.038 1.42 1.42 0 0 1-.3 2.807c-1.486.014-2.97.005-4.456.005a3.092 3.092 0 0 0-.498.028 4.463 4.463 0 0 1 2.77 1.849 4.201 4.201 0 0 1 .654 3.27 4.274 4.274 0 0 1-8.42-.294c-.355-2.144.932-3.935 3.508-4.837H50.001c2.657.903 3.891 2.737 3.457 5.096a4.274 4.274 0 0 1-8.444-.4 4.394 4.394 0 0 1 3.485-4.712Zm23.167-22.784h-30.1c.023.147.035.265.06.38.993 4.458 1.993 8.914 2.969 13.375.084.388.227.484.605.483q10.448-.017 20.895-.008a2.415 2.415 0 0 0 2.508-1.957q1.143-4.574 2.29-9.147c.259-1.034.512-2.068.773-3.126ZM49.23 74.384a1.425 1.425 0 1 0-1.387-1.45 1.438 1.438 0 0 0 1.387 1.45Zm18.609-2.849a1.425 1.425 0 1 0 1.387 1.45 1.441 1.441 0 0 0-1.387-1.45Z"
    />
    <path
    style="fill: #f0b394"
      class="cls-1"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.661 55.724 55.724 0 0 1-55.66 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.661 4.115Z"
    />
  </g>
  `,
];

export const sharing = [
  '111.322 111.322',
  `
  <defs>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
      style="fill: #706f6f"
      class="cls-1"
      d="M66.982 77.781a20.445 20.445 0 0 1-1.997-.508 8.304 8.304 0 0 1-5.174-10.258c.064-.217.126-.375-.146-.529q-4.795-2.7-9.576-5.425a1.125 1.125 0 0 0-.143-.054 8.291 8.291 0 0 1-7.256 2.942 7.887 7.887 0 0 1-5.163-2.517 8.256 8.256 0 0 1 .002-11.546 7.978 7.978 0 0 1 6.323-2.552 8.294 8.294 0 0 1 6.102 2.987c.136-.073.249-.132.36-.195q4.615-2.622 9.235-5.238a.446.446 0 0 0 .257-.633 8.34 8.34 0 1 1 9.125 5.875 8.003 8.003 0 0 1-7.163-2.512.616.616 0 0 0-.923-.125Q56.338 50.09 51.8 52.63a.492.492 0 0 0-.273.702 7.994 7.994 0 0 1 .016 4.636c-.043.15-.083.302-.129.471.133.081.251.159.374.228q4.598 2.61 9.193 5.226a.455.455 0 0 0 .681-.095 8.336 8.336 0 1 1 7.332 13.892 3.66 3.66 0 0 0-.37.091ZM48.948 55.689a5.419 5.419 0 1 0-5.47 5.397 5.433 5.433 0 0 0 5.47-5.397Zm13.425-13.825a5.419 5.419 0 1 0 5.457-5.4 5.41 5.41 0 0 0-5.457 5.4Zm0 27.572a5.42 5.42 0 1 0 5.437-5.422 5.412 5.412 0 0 0-5.438 5.422Z"
    />
    <path
      style="fill: #706f6f"
      class="cls-1"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.66 55.724 55.724 0 0 1-55.661 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.66 4.115Z"
    />
  </g>
  `,
];

export const sharingColoured = [
  '111.322 111.322',
  `
  <defs>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <path
      style="fill: #f7dc38"
      class="cls-1"
      d="M66.982 77.781a20.445 20.445 0 0 1-1.997-.508 8.304 8.304 0 0 1-5.174-10.258c.064-.217.126-.375-.146-.529q-4.795-2.7-9.576-5.425a1.125 1.125 0 0 0-.143-.054 8.291 8.291 0 0 1-7.256 2.942 7.887 7.887 0 0 1-5.163-2.517 8.256 8.256 0 0 1 .002-11.546 7.978 7.978 0 0 1 6.323-2.552 8.294 8.294 0 0 1 6.102 2.987c.136-.073.249-.132.36-.195q4.615-2.622 9.235-5.238a.446.446 0 0 0 .257-.633 8.34 8.34 0 1 1 9.125 5.875 8.003 8.003 0 0 1-7.163-2.512.616.616 0 0 0-.923-.125Q56.338 50.09 51.8 52.63a.492.492 0 0 0-.273.702 7.994 7.994 0 0 1 .016 4.636c-.043.15-.083.302-.129.471.133.081.251.159.374.228q4.598 2.61 9.193 5.226a.455.455 0 0 0 .681-.095 8.336 8.336 0 1 1 7.332 13.892 3.66 3.66 0 0 0-.37.091ZM48.948 55.689a5.419 5.419 0 1 0-5.47 5.397 5.433 5.433 0 0 0 5.47-5.397Zm13.425-13.825a5.419 5.419 0 1 0 5.457-5.4 5.41 5.41 0 0 0-5.457 5.4Zm0 27.572a5.42 5.42 0 1 0 5.437-5.422 5.412 5.412 0 0 0-5.438 5.422Z"
    />
    <path
      style="fill: #f7dc38"
      class="cls-1"
      d="M55.661 111.322a55.661 55.661 0 1 1 55.661-55.66 55.724 55.724 0 0 1-55.661 55.66Zm0-107.207a51.546 51.546 0 1 0 51.546 51.546A51.604 51.604 0 0 0 55.66 4.115Z"
    />
  </g>
  `,
];

export const traveling = [
  '111.184 111.342',
  `
  <defs>
    <clipPath id="clip-path">
      <path style="fill: none" d="M-2113.385-567.378h1920V514.161h-1920z" />
    </clipPath>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <g style="clip-path: url(#clip-path)">
      <g style="opacity: 0.7">
        <path
          d="M-229.466 22.353c36.659 2.989 75.417 13.297 111.984 16.956 38.788 5.154 86.704-1.19 125.553 2.928 58.38 2.683 123.88 11.558 182.138 5.702 11.895-2.988 23.699-10.46 36.355-9.575 25.433 1.616 55.429 14.851 80.527 18.724 31.67 4.087 76.543 15.004 107.665 20.25 14.177 1.28 36.537 2.226 50.349 4.055a2.595 2.595 0 0 0 .365-1.25"
          style="
            stroke: #1e1e32;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 0.75px;
            fill: none;
          "
        />
      </g>
    </g>
    <path
      style="fill: #706f6f"
      class="cls-5"
      d="M0 53.136c.266-2.218.377-4.468.823-6.649C5.47 23.797 18.693 8.581 41.02 2.214c17.631-5.028 34-1.359 48.682 9.655.26.195.517.394.783.58.045.03.13.004.315.004v-1.036c0-1.846-.03-3.693.015-5.538a1.897 1.897 0 0 1 1.848-2.019 1.857 1.857 0 0 1 1.827 2.014q.034 5.374.002 10.749a1.812 1.812 0 0 1-2.02 2.024q-5.374.041-10.748-.001a1.82 1.82 0 0 1-2.007-1.82 1.882 1.882 0 0 1 2-1.854c1.843-.051 3.688-.013 5.659-.237-1.111-.797-2.19-1.643-3.338-2.385a50.024 50.024 0 0 0-19.85-7.755C46.547 1.958 31.223 6.83 18.58 19.451a49.574 49.574 0 0 0-14.59 31.095A50.743 50.743 0 0 0 13.48 85.99c.463.647.965 1.268 1.404 1.93a1.867 1.867 0 0 1-.299 2.703 1.824 1.824 0 0 1-2.66-.522c-1.778-2.591-3.64-5.144-5.18-7.875A52.024 52.024 0 0 1 .822 65.215c-.3-1.78-.432-3.588-.645-5.382-.05-.424-.117-.845-.177-1.267ZM52.342 111.342c-2.037-.274-4.083-.494-6.109-.831a54.394 54.394 0 0 1-24.57-10.768c-.287-.22-.571-.444-.86-.662a2.245 2.245 0 0 0-.303-.143 7.325 7.325 0 0 0-.095.813c-.008 1.882.012 3.764-.01 5.645-.017 1.367-.766 2.231-1.866 2.228-1.106-.004-1.822-.855-1.826-2.238q-.018-5.158 0-10.315c.006-1.584.652-2.234 2.246-2.241q5.158-.024 10.315 0c1.404.007 2.22.71 2.22 1.833-.001 1.106-.84 1.838-2.223 1.86a53.36 53.36 0 0 0-5.438.226c1.112.798 2.194 1.644 3.342 2.387a49.96 49.96 0 0 0 19.85 7.753c17.64 2.64 32.962-2.237 45.607-14.857a49.582 49.582 0 0 0 14.587-31.094 50.709 50.709 0 0 0-9.425-35.355c-.461-.648-.953-1.276-1.389-1.941a1.84 1.84 0 1 1 2.957-2.18 56.054 56.054 0 0 1 7.307 12.264 55.635 55.635 0 0 1-3.265 50.35 55.347 55.347 0 0 1-43.482 27.074 9.833 9.833 0 0 0-1.055.192Z"
    />
    <path
      style="fill: #706f6f"
      class="cls-5"
      d="M55.63 33.153a22.519 22.519 0 1 1-22.533 22.042A22.515 22.515 0 0 1 55.63 33.153ZM35.21 56.735a5.45 5.45 0 0 0 .002.556c.072.614.132 1.231.236 1.84a19.952 19.952 0 0 0 3.951 9.003c.094.12.35.247.461.2 1.597-.662 3.183-1.354 4.85-2.073a39.403 39.403 0 0 1-1.37-9.526Zm8.134-2.127a39.397 39.397 0 0 1 1.363-9.529c-1.662-.71-3.223-1.361-4.766-2.052-.365-.163-.455.059-.609.26a20.342 20.342 0 0 0-3.993 9.56c-.085.58-.11 1.17-.163 1.761Zm23.116-9.524a39.178 39.178 0 0 1 1.374 9.514h8.192c-.098-.786-.17-1.518-.285-2.243a19.78 19.78 0 0 0-3.959-9.124.59.59 0 0 0-.505-.198c-1.581.651-3.15 1.334-4.817 2.05Zm9.519 11.655h-8.151a39.432 39.432 0 0 1-1.362 9.535c1.605.682 3.115 1.3 4.6 1.973.404.183.572.099.818-.228a20.446 20.446 0 0 0 3.302-6.536 18.35 18.35 0 0 0 .793-4.744ZM46.753 45.608a34.94 34.94 0 0 0-1.353 8.996h9.11v-8.05Zm9.88 8.991h9.152a35.424 35.424 0 0 0-1.37-8.987l-7.783.943Zm-11.241 2.122a35.528 35.528 0 0 0 1.362 9.018l7.751-.944V56.72Zm20.39.037h-9.126v8.035l7.764.948a35.817 35.817 0 0 0 1.362-8.983ZM54.522 66.85l-7.09.869a16.67 16.67 0 0 0 3.876 6.447 6.158 6.158 0 0 0 3.214 1.815Zm2.129 9.083c2.845-.312 5.86-4.413 7.062-8.233l-7.062-.84Zm-2.13-40.51c-2.813.302-5.824 4.333-7.065 8.225l7.065.842Zm9.316 8.206c-.526-1.115-.937-2.09-1.436-3.017a12.068 12.068 0 0 0-3.48-4.214 4.791 4.791 0 0 0-2.257-1.001v9.096Zm-14.626-7.322a19.7 19.7 0 0 0-8.231 5.054l4.384 1.709a21.611 21.611 0 0 1 3.848-6.763Zm20.987 5.055a19.688 19.688 0 0 0-8.237-5.053 21.467 21.467 0 0 1 3.85 6.76Zm-20.87 33.72a20.503 20.503 0 0 1-3.976-6.804l-4.35 1.711a19.622 19.622 0 0 0 8.326 5.093Zm12.633-.039a19.718 19.718 0 0 0 8.233-5.054l-4.391-1.711a21.391 21.391 0 0 1-3.842 6.765Z"
    />
  </g>
  `,
];

export const travelingColoured = [
  '111.184 111.342',
  `
  <defs>
    <clipPath id="clip-path">
      <path style="fill: none" d="M-2113.385-567.378h1920V514.161h-1920z" />
    </clipPath>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <g style="clip-path: url(#clip-path)">
      <g style="opacity: 0.7">
        <path
          d="M-229.466 22.353c36.659 2.989 75.417 13.297 111.984 16.956 38.788 5.154 86.704-1.19 125.553 2.928 58.38 2.683 123.88 11.558 182.138 5.702 11.895-2.988 23.699-10.46 36.355-9.575 25.433 1.616 55.429 14.851 80.527 18.724 31.67 4.087 76.543 15.004 107.665 20.25 14.177 1.28 36.537 2.226 50.349 4.055a2.595 2.595 0 0 0 .365-1.25"
          style="
            stroke: #1e1e32;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 0.75px;
            fill: none;
          "
        />
      </g>
    </g>
    <path
      style="fill: #b3d1c7"
      class="cls-5"
      d="M0 53.136c.266-2.218.377-4.468.823-6.649C5.47 23.797 18.693 8.581 41.02 2.214c17.631-5.028 34-1.359 48.682 9.655.26.195.517.394.783.58.045.03.13.004.315.004v-1.036c0-1.846-.03-3.693.015-5.538a1.897 1.897 0 0 1 1.848-2.019 1.857 1.857 0 0 1 1.827 2.014q.034 5.374.002 10.749a1.812 1.812 0 0 1-2.02 2.024q-5.374.041-10.748-.001a1.82 1.82 0 0 1-2.007-1.82 1.882 1.882 0 0 1 2-1.854c1.843-.051 3.688-.013 5.659-.237-1.111-.797-2.19-1.643-3.338-2.385a50.024 50.024 0 0 0-19.85-7.755C46.547 1.958 31.223 6.83 18.58 19.451a49.574 49.574 0 0 0-14.59 31.095A50.743 50.743 0 0 0 13.48 85.99c.463.647.965 1.268 1.404 1.93a1.867 1.867 0 0 1-.299 2.703 1.824 1.824 0 0 1-2.66-.522c-1.778-2.591-3.64-5.144-5.18-7.875A52.024 52.024 0 0 1 .822 65.215c-.3-1.78-.432-3.588-.645-5.382-.05-.424-.117-.845-.177-1.267ZM52.342 111.342c-2.037-.274-4.083-.494-6.109-.831a54.394 54.394 0 0 1-24.57-10.768c-.287-.22-.571-.444-.86-.662a2.245 2.245 0 0 0-.303-.143 7.325 7.325 0 0 0-.095.813c-.008 1.882.012 3.764-.01 5.645-.017 1.367-.766 2.231-1.866 2.228-1.106-.004-1.822-.855-1.826-2.238q-.018-5.158 0-10.315c.006-1.584.652-2.234 2.246-2.241q5.158-.024 10.315 0c1.404.007 2.22.71 2.22 1.833-.001 1.106-.84 1.838-2.223 1.86a53.36 53.36 0 0 0-5.438.226c1.112.798 2.194 1.644 3.342 2.387a49.96 49.96 0 0 0 19.85 7.753c17.64 2.64 32.962-2.237 45.607-14.857a49.582 49.582 0 0 0 14.587-31.094 50.709 50.709 0 0 0-9.425-35.355c-.461-.648-.953-1.276-1.389-1.941a1.84 1.84 0 1 1 2.957-2.18 56.054 56.054 0 0 1 7.307 12.264 55.635 55.635 0 0 1-3.265 50.35 55.347 55.347 0 0 1-43.482 27.074 9.833 9.833 0 0 0-1.055.192Z"
    />
    <path
      style="fill: #b3d1c7"
      class="cls-5"
      d="M55.63 33.153a22.519 22.519 0 1 1-22.533 22.042A22.515 22.515 0 0 1 55.63 33.153ZM35.21 56.735a5.45 5.45 0 0 0 .002.556c.072.614.132 1.231.236 1.84a19.952 19.952 0 0 0 3.951 9.003c.094.12.35.247.461.2 1.597-.662 3.183-1.354 4.85-2.073a39.403 39.403 0 0 1-1.37-9.526Zm8.134-2.127a39.397 39.397 0 0 1 1.363-9.529c-1.662-.71-3.223-1.361-4.766-2.052-.365-.163-.455.059-.609.26a20.342 20.342 0 0 0-3.993 9.56c-.085.58-.11 1.17-.163 1.761Zm23.116-9.524a39.178 39.178 0 0 1 1.374 9.514h8.192c-.098-.786-.17-1.518-.285-2.243a19.78 19.78 0 0 0-3.959-9.124.59.59 0 0 0-.505-.198c-1.581.651-3.15 1.334-4.817 2.05Zm9.519 11.655h-8.151a39.432 39.432 0 0 1-1.362 9.535c1.605.682 3.115 1.3 4.6 1.973.404.183.572.099.818-.228a20.446 20.446 0 0 0 3.302-6.536 18.35 18.35 0 0 0 .793-4.744ZM46.753 45.608a34.94 34.94 0 0 0-1.353 8.996h9.11v-8.05Zm9.88 8.991h9.152a35.424 35.424 0 0 0-1.37-8.987l-7.783.943Zm-11.241 2.122a35.528 35.528 0 0 0 1.362 9.018l7.751-.944V56.72Zm20.39.037h-9.126v8.035l7.764.948a35.817 35.817 0 0 0 1.362-8.983ZM54.522 66.85l-7.09.869a16.67 16.67 0 0 0 3.876 6.447 6.158 6.158 0 0 0 3.214 1.815Zm2.129 9.083c2.845-.312 5.86-4.413 7.062-8.233l-7.062-.84Zm-2.13-40.51c-2.813.302-5.824 4.333-7.065 8.225l7.065.842Zm9.316 8.206c-.526-1.115-.937-2.09-1.436-3.017a12.068 12.068 0 0 0-3.48-4.214 4.791 4.791 0 0 0-2.257-1.001v9.096Zm-14.626-7.322a19.7 19.7 0 0 0-8.231 5.054l4.384 1.709a21.611 21.611 0 0 1 3.848-6.763Zm20.987 5.055a19.688 19.688 0 0 0-8.237-5.053 21.467 21.467 0 0 1 3.85 6.76Zm-20.87 33.72a20.503 20.503 0 0 1-3.976-6.804l-4.35 1.711a19.622 19.622 0 0 0 8.326 5.093Zm12.633-.039a19.718 19.718 0 0 0 8.233-5.054l-4.391-1.711a21.391 21.391 0 0 1-3.842 6.765Z"
    />
  </g>
  `,
];

export const carDrivingPic = [
  '500 500',
  `
  <g id="freepik--City--inject-3">
    <g id="freepik--city--inject-3">
      <polygon
        points="486.43 328.96 486.43 111.11 450.75 90.51 423.98 105.96 423.98 159.41 410.6 151.69 410.6 131.08 397.22 123.36 397.22 76.45 357.07 53.27 339.23 63.57 339.23 93.28 321.38 82.98 303.54 93.28 303.54 137.93 285.69 148.2 285.69 105.39 267.85 95.09 245.54 107.97 245.54 141.95 223.24 129.07 223.24 27.04 196.47 11.58 165.25 29.61 165.25 96.48 151.86 104.2 151.86 131.28 134.02 141.58 134.02 67.25 111.72 54.38 84.95 69.83 84.95 91.83 71.57 99.55 71.57 194.63 53.72 204.93 53.72 98.09 26.96 82.63 13.57 90.36 13.57 328.96 486.43 328.96"
        style="fill: #f0f0f0"
      ></polygon>
      <polygon
        points="324.85 208.04 328.63 205.85 328.63 202.54 324.85 204.73 324.85 208.04"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 220.22 328.63 218.04 328.63 214.73 324.85 216.92 324.85 220.22"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 201.94 328.63 199.75 328.63 196.45 324.85 198.64 324.85 201.94"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 195.43 328.63 193.24 328.63 189.93 324.85 192.12 324.85 195.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 214.13 328.63 211.94 328.63 208.64 324.85 210.83 324.85 214.13"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 171.05 328.63 168.86 328.63 165.56 324.85 167.74 324.85 171.05"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 164.96 328.63 162.77 328.63 159.46 324.85 161.65 324.85 164.96"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 177.14 328.63 174.96 328.63 171.65 324.85 173.84 324.85 177.14"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 189.33 328.63 187.14 328.63 183.84 324.85 186.03 324.85 189.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 183.24 328.63 181.05 328.63 177.75 324.85 179.93 324.85 183.24"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 238.51 328.63 236.32 328.63 233.01 324.85 235.2 324.85 238.51"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 269.4 328.63 267.21 328.63 263.91 324.85 266.1 324.85 269.4"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 256.79 328.63 254.6 328.63 251.3 324.85 253.49 324.85 256.79"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 263.31 328.63 261.12 328.63 257.81 324.85 260 324.85 263.31"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 281.59 328.63 279.4 328.63 276.1 324.85 278.28 324.85 281.59"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 275.5 328.63 273.31 328.63 270 324.85 272.19 324.85 275.5"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 232.41 328.63 230.23 328.63 226.92 324.85 229.11 324.85 232.41"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 250.69 328.63 248.51 328.63 245.2 324.85 247.39 324.85 250.69"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 226.32 328.63 224.13 328.63 220.83 324.85 223.01 324.85 226.32"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 158.86 328.63 156.67 328.63 153.37 324.85 155.56 324.85 158.86"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 244.6 328.63 242.41 328.63 239.11 324.85 241.3 324.85 244.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 283.14 336.49 280.95 336.49 277.65 332.7 279.84 332.7 283.14"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 277.05 336.49 274.86 336.49 271.56 332.7 273.74 332.7 277.05"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 289.24 336.49 287.05 336.49 283.74 332.7 285.93 332.7 289.24"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 295.33 336.49 293.14 336.49 289.84 332.7 292.02 332.7 295.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 287.68 328.63 285.5 328.63 282.19 324.85 284.38 324.85 287.68"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 133.61 328.63 131.43 328.63 128.12 324.85 130.31 324.85 133.61"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 127.09 328.63 124.91 328.63 121.6 324.85 123.79 324.85 127.09"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 140.58 328.63 138.39 328.63 135.09 324.85 137.27 324.85 140.58"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 120.13 328.63 117.94 328.63 114.64 324.85 116.82 324.85 120.13"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 146.67 328.63 144.49 328.63 141.18 324.85 143.37 324.85 146.67"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 152.77 328.63 150.58 328.63 147.27 324.85 149.46 324.85 152.77"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 114.03 328.63 111.85 328.63 108.54 324.85 110.73 324.85 114.03"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 107.94 328.63 105.75 328.63 102.45 324.85 104.64 324.85 107.94"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 87.66 394.62 85.47 394.62 82.16 390.83 84.35 390.83 87.66"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 198.77 394.62 196.59 394.62 193.28 390.83 195.47 390.83 198.77"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 192.68 394.62 190.49 394.62 187.19 390.83 189.38 390.83 192.68"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 186.59 394.62 184.4 394.62 181.09 390.83 183.28 390.83 186.59"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 204.87 394.62 202.68 394.62 199.38 390.83 201.56 390.83 204.87"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 210.96 394.62 208.77 394.62 205.47 390.83 207.66 390.83 210.96"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 149.15 394.62 146.96 394.62 143.66 390.83 145.84 390.83 149.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 162.21 394.62 160.02 394.62 156.72 390.83 158.9 390.83 162.21"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 180.49 394.62 178.3 394.62 175 390.83 177.19 390.83 180.49"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 156.12 394.62 153.93 394.62 150.62 390.83 152.81 390.83 156.12"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 168.3 394.62 166.12 394.62 162.81 390.83 165 390.83 168.3"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 217.48 394.62 215.29 394.62 211.99 390.83 214.18 390.83 217.48"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 174.4 394.62 172.21 394.62 168.91 390.83 171.09 390.83 174.4"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 266.23 394.62 264.05 394.62 260.74 390.83 262.93 390.83 266.23"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 260.14 394.62 257.95 394.62 254.65 390.83 256.83 390.83 260.14"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 278.84 394.62 276.66 394.62 273.35 390.83 275.54 390.83 278.84"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 254.04 394.62 251.86 394.62 248.55 390.83 250.74 390.83 254.04"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 272.33 394.62 270.14 394.62 266.83 390.83 269.02 390.83 272.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 235.76 394.62 233.57 394.62 230.27 390.83 232.46 390.83 235.76"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 247.95 394.62 245.76 394.62 242.46 390.83 244.65 390.83 247.95"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 229.67 394.62 227.48 394.62 224.18 390.83 226.36 390.83 229.67"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 223.57 394.62 221.39 394.62 218.08 390.83 220.27 390.83 223.57"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 241.85 394.62 239.67 394.62 236.36 390.83 238.55 390.83 241.85"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 93.75 394.62 91.56 394.62 88.26 390.83 90.44 390.83 93.75"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 143.06 394.62 140.87 394.62 137.56 390.83 139.75 390.83 143.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 124.65 394.62 122.47 394.62 119.16 390.83 121.35 390.83 124.65"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 118.56 394.62 116.37 394.62 113.07 390.83 115.25 390.83 118.56"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 136.84 394.62 134.66 394.62 131.35 390.83 133.54 390.83 136.84"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 130.75 394.62 128.56 394.62 125.26 390.83 127.44 390.83 130.75"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 112.03 394.62 109.84 394.62 106.54 390.83 108.73 390.83 112.03"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="324.85 293.78 328.63 291.59 328.63 288.29 324.85 290.47 324.85 293.78"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 270.95 336.49 268.77 336.49 265.46 332.7 267.65 332.7 270.95"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 99.84 394.62 97.66 394.62 94.35 390.83 96.54 390.83 99.84"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 105.94 394.62 103.75 394.62 100.45 390.83 102.63 390.83 105.94"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 69.07 197.7 66.88 197.7 63.58 193.91 65.77 193.91 69.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 154.88 197.7 152.69 197.7 149.38 193.91 151.57 193.91 154.88"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 167.06 197.7 164.88 197.7 161.57 193.91 163.76 193.91 167.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 185.35 197.7 183.16 197.7 179.85 193.91 182.04 193.91 185.35"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 173.16 197.7 170.97 197.7 167.66 193.91 169.85 193.91 173.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 179.25 197.7 177.06 197.7 173.76 193.91 175.95 193.91 179.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 160.97 197.7 158.78 197.7 155.48 193.91 157.66 193.91 160.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 117.82 197.7 115.64 197.7 112.33 193.91 114.52 193.91 117.82"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 123.92 197.7 121.73 197.7 118.42 193.91 120.61 193.91 123.92"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 130.01 197.7 127.82 197.7 124.52 193.91 126.71 193.91 130.01"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 136.59 197.7 134.41 197.7 131.1 193.91 133.29 193.91 136.59"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 142.69 197.7 140.5 197.7 137.19 193.91 139.38 193.91 142.69"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 148.78 197.7 146.59 197.7 143.29 193.91 145.48 193.91 148.78"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 228.43 197.7 226.24 197.7 222.94 193.91 225.12 193.91 228.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 234.52 197.7 232.33 197.7 229.03 193.91 231.22 193.91 234.52"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 240.62 197.7 238.43 197.7 235.12 193.91 237.31 193.91 240.62"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 246.71 197.7 244.52 197.7 241.22 193.91 243.41 193.91 246.71"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 222.33 197.7 220.15 197.7 216.84 193.91 219.03 193.91 222.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 210.15 197.7 207.96 197.7 204.65 193.91 206.84 193.91 210.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 204.05 197.7 201.86 197.7 198.56 193.91 200.75 193.91 204.05"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 216.24 197.7 214.05 197.7 210.75 193.91 212.94 193.91 216.24"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 197.96 197.7 195.77 197.7 192.47 193.91 194.65 193.91 197.96"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 191.44 197.7 189.25 197.7 185.95 193.91 188.13 193.91 191.44"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 252.8 197.7 250.62 197.7 247.31 193.91 249.5 193.91 252.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 291.34 205.56 289.16 205.56 285.85 201.77 288.04 201.77 291.34"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 111.73 197.7 109.54 197.7 106.24 193.91 108.42 193.91 111.73"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 285.25 205.56 283.06 205.56 279.76 201.77 281.95 201.77 285.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 266.97 205.56 264.78 205.56 261.48 201.77 263.66 201.77 266.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 273.06 205.56 270.87 205.56 267.57 201.77 269.76 201.77 273.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 279.16 205.56 276.97 205.56 273.66 201.77 275.85 201.77 279.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 50.79 197.7 48.6 197.7 45.3 193.91 47.48 193.91 50.79"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 93.45 197.7 91.26 197.7 87.95 193.91 90.14 193.91 93.45"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 87.35 197.7 85.16 197.7 81.86 193.91 84.05 193.91 87.35"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 105.63 197.7 103.45 197.7 100.14 193.91 102.33 193.91 105.63"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 99.54 197.7 97.35 197.7 94.05 193.91 96.23 193.91 99.54"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 81.26 197.7 79.07 197.7 75.77 193.91 77.95 193.91 81.26"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 62.98 197.7 60.79 197.7 57.48 193.91 59.67 193.91 62.98"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 75.16 197.7 72.98 197.7 69.67 193.91 71.86 193.91 75.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 56.88 197.7 54.69 197.7 51.39 193.91 53.58 193.91 56.88"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 284.94 394.62 282.75 394.62 279.44 390.83 281.63 390.83 284.94"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 166.51 336.49 164.32 336.49 161.01 332.7 163.2 332.7 166.51"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 172.6 336.49 170.41 336.49 167.11 332.7 169.3 332.7 172.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 259.32 197.7 257.13 197.7 253.83 193.91 256.02 193.91 259.32"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 184.79 336.49 182.6 336.49 179.3 332.7 181.48 332.7 184.79"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 190.88 336.49 188.7 336.49 185.39 332.7 187.58 332.7 190.88"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 197.4 336.49 195.21 336.49 191.91 332.7 194.1 332.7 197.4"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 148.22 336.49 146.04 336.49 142.73 332.7 144.92 332.7 148.22"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 142.13 336.49 139.94 336.49 136.64 332.7 138.83 332.7 142.13"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 136.04 336.49 133.85 336.49 130.54 332.7 132.73 332.7 136.04"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 154.32 336.49 152.13 336.49 148.83 332.7 151.01 332.7 154.32"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 160.41 336.49 158.23 336.49 154.92 332.7 157.11 332.7 160.41"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 246.15 336.49 243.97 336.49 240.66 332.7 242.85 332.7 246.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 203.5 336.49 201.31 336.49 198 332.7 200.19 332.7 203.5"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 252.25 336.49 250.06 336.49 246.76 332.7 248.94 332.7 252.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 233.97 336.49 231.78 336.49 228.47 332.7 230.66 332.7 233.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 258.76 336.49 256.58 336.49 253.27 332.7 255.46 332.7 258.76"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 240.06 336.49 237.87 336.49 234.57 332.7 236.75 332.7 240.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 209.59 336.49 207.4 336.49 204.1 332.7 206.28 332.7 209.59"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 227.87 336.49 225.68 336.49 222.38 332.7 224.57 332.7 227.87"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 215.68 336.49 213.5 336.49 210.19 332.7 212.38 332.7 215.68"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 221.78 336.49 219.59 336.49 216.28 332.7 218.47 332.7 221.78"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 178.69 336.49 176.51 336.49 173.2 332.7 175.39 332.7 178.69"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 295.89 197.7 293.7 197.7 290.39 193.91 292.58 193.91 295.89"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 289.79 197.7 287.61 197.7 284.3 193.91 286.49 193.91 289.79"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 264.86 336.49 262.67 336.49 259.37 332.7 261.55 332.7 264.86"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 129.07 336.49 126.88 336.49 123.58 332.7 125.77 332.7 129.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 271.51 197.7 269.32 197.7 266.02 193.91 268.2 193.91 271.51"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 277.6 197.7 275.42 197.7 272.11 193.91 274.3 193.91 277.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 283.7 197.7 281.51 197.7 278.21 193.91 280.39 193.91 283.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="193.91 265.42 197.7 263.23 197.7 259.92 193.91 262.11 193.91 265.42"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 103.4 336.49 101.21 336.49 97.91 332.7 100.09 332.7 103.4"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 109.49 336.49 107.31 336.49 104 332.7 106.19 332.7 109.49"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 115.59 336.49 113.4 336.49 110.09 332.7 112.28 332.7 115.59"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="332.7 122.55 336.49 120.37 336.49 117.06 332.7 119.25 332.7 122.55"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 283.95 467.24 281.76 467.24 278.46 463.45 280.65 463.45 283.95"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 291.03 394.62 288.84 394.62 285.54 390.83 287.73 390.83 291.03"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 254.61 475.1 252.42 475.1 249.12 471.31 251.31 471.31 254.61"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 267.22 475.1 265.04 475.1 261.73 471.31 263.92 471.31 267.22"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 248.52 475.1 246.33 475.1 243.02 471.31 245.21 471.31 248.52"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 273.32 475.1 271.13 475.1 267.82 471.31 270.01 471.31 273.32"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 236.33 475.1 234.14 475.1 230.84 471.31 233.02 471.31 236.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 218.05 475.1 215.86 475.1 212.55 471.31 214.74 471.31 218.05"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 224.14 475.1 221.95 475.1 218.65 471.31 220.84 471.31 224.14"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 230.23 475.1 228.05 475.1 224.74 471.31 226.93 471.31 230.23"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 279.41 475.1 277.22 475.1 273.92 471.31 276.11 471.31 279.41"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 291.6 475.1 289.41 475.1 286.11 471.31 288.29 471.31 291.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 297.69 475.1 295.5 475.1 292.2 471.31 294.39 471.31 297.69"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 285.5 475.1 283.32 475.1 280.01 471.31 282.2 471.31 285.5"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 211.95 475.1 209.76 475.1 206.46 471.31 208.65 471.31 211.95"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 242.42 475.1 240.24 475.1 236.93 471.31 239.12 471.31 242.42"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 205.86 475.1 203.67 475.1 200.37 471.31 202.55 471.31 205.86"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 132.1 475.1 129.91 475.1 126.6 471.31 128.79 471.31 132.1"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 138.19 475.1 136 475.1 132.7 471.31 134.88 471.31 138.19"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 125.98 475.1 123.79 475.1 120.48 471.31 122.67 471.31 125.98"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 181.06 475.1 178.87 475.1 175.57 471.31 177.75 471.31 181.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 144.49 475.1 142.31 475.1 139 471.31 141.19 471.31 144.49"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 187.15 475.1 184.97 475.1 181.66 471.31 183.85 471.31 187.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 199.34 475.1 197.15 475.1 193.85 471.31 196.04 471.31 199.34"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 193.25 475.1 191.06 475.1 187.75 471.31 189.94 471.31 193.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 174.96 475.1 172.78 475.1 169.47 471.31 171.66 471.31 174.96"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 150.59 475.1 148.4 475.1 145.09 471.31 147.28 471.31 150.59"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 156.68 475.1 154.49 475.1 151.19 471.31 153.38 471.31 156.68"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 162.78 475.1 160.59 475.1 157.28 471.31 159.47 471.31 162.78"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 168.87 475.1 166.68 475.1 163.38 471.31 165.56 471.31 168.87"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 246.96 467.24 244.78 467.24 241.47 463.45 243.66 463.45 246.96"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 277.86 467.24 275.67 467.24 272.37 463.45 274.55 463.45 277.86"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 260.87 205.56 258.69 205.56 255.38 201.77 257.57 201.77 260.87"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 296.14 467.24 293.95 467.24 290.65 463.45 292.83 463.45 296.14"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 265.25 467.24 263.06 467.24 259.75 463.45 261.94 463.45 265.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 259.15 467.24 256.96 467.24 253.66 463.45 255.85 463.45 259.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 271.76 467.24 269.58 467.24 266.27 463.45 268.46 463.45 271.76"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 253.06 467.24 250.87 467.24 247.57 463.45 249.75 463.45 253.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 290.05 467.24 287.86 467.24 284.55 463.45 286.74 463.45 290.05"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 240.87 467.24 238.68 467.24 235.38 463.45 237.56 463.45 240.87"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 149.03 467.24 146.85 467.24 143.54 463.45 145.73 463.45 149.03"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 142.73 467.24 140.54 467.24 137.24 463.45 139.43 463.45 142.73"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 161.22 467.24 159.04 467.24 155.73 463.45 157.92 463.45 161.22"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 167.32 467.24 165.13 467.24 161.82 463.45 164.01 463.45 167.32"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 130.52 467.24 128.33 467.24 125.03 463.45 127.21 463.45 130.52"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 173.41 467.24 171.22 467.24 167.92 463.45 170.11 463.45 173.41"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 136.64 467.24 134.45 467.24 131.15 463.45 133.33 463.45 136.64"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 155.13 467.24 152.94 467.24 149.64 463.45 151.82 463.45 155.13"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 216.49 467.24 214.31 467.24 211 463.45 213.19 463.45 216.49"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 222.59 467.24 220.4 467.24 217.1 463.45 219.28 463.45 222.59"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 228.68 467.24 226.49 467.24 223.19 463.45 225.38 463.45 228.68"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 210.4 467.24 208.21 467.24 204.91 463.45 207.09 463.45 210.4"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 234.78 467.24 232.59 467.24 229.28 463.45 231.47 463.45 234.78"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 203.88 467.24 201.69 467.24 198.39 463.45 200.58 463.45 203.88"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 185.6 467.24 183.41 467.24 180.11 463.45 182.29 463.45 185.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 191.69 467.24 189.51 467.24 186.2 463.45 188.39 463.45 191.69"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 197.79 467.24 195.6 467.24 192.3 463.45 194.48 463.45 197.79"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="463.45 179.51 467.24 177.32 467.24 174.01 463.45 176.2 463.45 179.51"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="471.31 260.7 475.1 258.52 475.1 255.21 471.31 257.4 471.31 260.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 197.22 386.76 195.03 386.76 191.73 382.98 193.92 382.98 197.22"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 191.13 386.76 188.94 386.76 185.63 382.98 187.82 382.98 191.13"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 203.31 386.76 201.13 386.76 197.82 382.98 200.01 382.98 203.31"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 209.41 386.76 207.22 386.76 203.92 382.98 206.1 382.98 209.41"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 147.6 386.76 145.41 386.76 142.1 382.98 144.29 382.98 147.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 178.94 386.76 176.75 386.76 173.45 382.98 175.63 382.98 178.94"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 160.66 386.76 158.47 386.76 155.16 382.98 157.35 382.98 160.66"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 215.5 386.76 213.32 386.76 210.01 382.98 212.2 382.98 215.5"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 153.69 386.76 151.5 386.76 148.2 382.98 150.39 382.98 153.69"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 166.75 386.76 164.56 386.76 161.26 382.98 163.45 382.98 166.75"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 172.84 386.76 170.66 386.76 167.35 382.98 169.54 382.98 172.84"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 185.03 386.76 182.85 386.76 179.54 382.98 181.73 382.98 185.03"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 258.58 386.76 256.4 386.76 253.09 382.98 255.28 382.98 258.58"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 252.49 386.76 250.3 386.76 247 382.98 249.19 382.98 252.49"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 264.68 386.76 262.49 386.76 259.19 382.98 261.38 382.98 264.68"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 276.87 386.76 274.68 386.76 271.38 382.98 273.56 382.98 276.87"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 270.77 386.76 268.59 386.76 265.28 382.98 267.47 382.98 270.77"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 228.12 386.76 225.93 386.76 222.62 382.98 224.81 382.98 228.12"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 222.02 386.76 219.83 386.76 216.53 382.98 218.72 382.98 222.02"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 234.21 386.76 232.02 386.76 228.72 382.98 230.9 382.98 234.21"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 246.4 386.76 244.21 386.76 240.91 382.98 243.09 382.98 246.4"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 240.3 386.76 238.12 386.76 234.81 382.98 237 382.98 240.3"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 283.38 386.76 281.2 386.76 277.89 382.98 280.08 382.98 283.38"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="390.83 297.13 394.62 294.94 394.62 291.63 390.83 293.82 390.83 297.13"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 141.38 386.76 139.2 386.76 135.89 382.98 138.08 382.98 141.38"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 123.1 386.76 120.92 386.76 117.61 382.98 119.8 382.98 123.1"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 116.57 386.76 114.39 386.76 111.08 382.98 113.27 382.98 116.57"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 129.2 386.76 127.01 386.76 123.7 382.98 125.89 382.98 129.2"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 110.48 386.76 108.29 386.76 104.99 382.98 107.17 382.98 110.48"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 135.29 386.76 133.1 386.76 129.8 382.98 131.99 382.98 135.29"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 92.2 386.76 90.01 386.76 86.71 382.98 88.89 382.98 92.2"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 98.29 386.76 96.11 386.76 92.8 382.98 94.99 382.98 98.29"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 104.39 386.76 102.2 386.76 98.89 382.98 101.08 382.98 104.39"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 219.6 482.95 217.41 482.95 214.11 479.16 216.29 479.16 219.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 182.61 482.95 180.42 482.95 177.12 479.16 179.31 479.16 182.61"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 231.79 482.95 229.6 482.95 226.29 479.16 228.48 479.16 231.79"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 237.88 482.95 235.69 482.95 232.39 479.16 234.58 479.16 237.88"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 243.97 482.95 241.79 482.95 238.48 479.16 240.67 479.16 243.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 213.5 482.95 211.32 482.95 208.01 479.16 210.2 479.16 213.5"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 188.71 482.95 186.52 482.95 183.21 479.16 185.4 479.16 188.71"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 207.41 482.95 205.22 482.95 201.92 479.16 204.1 479.16 207.41"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 194.8 482.95 192.61 482.95 189.31 479.16 191.49 479.16 194.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 201.32 482.95 199.13 482.95 195.82 479.16 198.01 479.16 201.32"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 225.69 482.95 223.5 482.95 220.2 479.16 222.39 479.16 225.69"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 287.06 482.95 284.87 482.95 281.56 479.16 283.75 479.16 287.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 250.07 482.95 247.88 482.95 244.58 479.16 246.76 479.16 250.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 280.96 482.95 278.77 482.95 275.47 479.16 277.66 479.16 280.96"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 293.15 482.95 290.96 482.95 287.66 479.16 289.85 479.16 293.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 256.16 482.95 253.98 482.95 250.67 479.16 252.86 479.16 256.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 262.68 482.95 260.49 482.95 257.19 479.16 259.38 479.16 262.68"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 289.48 386.76 287.29 386.76 283.99 382.98 286.17 382.98 289.48"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 274.87 482.95 272.68 482.95 269.38 479.16 271.56 479.16 274.87"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 268.77 482.95 266.59 482.95 263.28 479.16 265.47 479.16 268.77"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 176.52 482.95 174.33 482.95 171.02 479.16 173.21 479.16 176.52"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="382.98 295.57 386.76 293.39 386.76 290.08 382.98 292.27 382.98 295.57"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 158.23 482.95 156.05 482.95 152.74 479.16 154.93 479.16 158.23"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 152.14 482.95 149.95 482.95 146.65 479.16 148.84 479.16 152.14"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 146.05 482.95 143.86 482.95 140.55 479.16 142.74 479.16 146.05"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 164.33 482.95 162.14 482.95 158.84 479.16 161.02 479.16 164.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 170.42 482.95 168.24 482.95 164.93 479.16 167.12 479.16 170.42"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 121.44 482.95 119.25 482.95 115.94 479.16 118.13 479.16 121.44"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 139.95 482.95 137.76 482.95 134.46 479.16 136.65 479.16 139.95"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 127.56 482.95 125.37 482.95 122.06 479.16 124.25 479.16 127.56"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="479.16 133.65 482.95 131.46 482.95 128.16 479.16 130.34 479.16 133.65"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 261.36 36.73 263.55 36.73 260.24 32.94 258.06 32.94 261.36"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 86.31 131.03 84.13 131.03 80.82 127.24 83.01 127.24 86.31"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 92.41 131.03 90.22 131.03 86.92 127.24 89.1 127.24 92.41"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 80.22 131.03 78.03 131.03 74.73 127.24 76.92 127.24 80.22"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 98.5 131.03 96.31 131.03 93.01 127.24 95.2 127.24 98.5"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 104.6 131.03 102.41 131.03 99.11 127.24 101.29 127.24 104.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 110.69 131.03 108.5 131.03 105.2 127.24 107.39 127.24 110.69"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 283.17 21.02 285.36 21.02 282.05 17.23 279.87 17.23 283.17"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 295.36 21.02 297.55 21.02 294.24 17.23 292.06 17.23 295.36"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 289.26 21.02 291.45 21.02 288.15 17.23 285.96 17.23 289.26"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 159.44 131.03 157.26 131.03 153.95 127.24 156.14 127.24 159.44"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 116.78 131.03 114.6 131.03 111.29 127.24 113.48 127.24 116.78"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 165.54 131.03 163.35 131.03 160.05 127.24 162.23 127.24 165.54"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 171.63 131.03 169.44 131.03 166.14 127.24 168.33 127.24 171.63"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 147.26 131.03 145.07 131.03 141.76 127.24 143.95 127.24 147.26"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 153.35 131.03 151.16 131.03 147.86 127.24 150.04 127.24 153.35"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 122.88 131.03 120.69 131.03 117.39 127.24 119.57 127.24 122.88"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 128.97 131.03 126.79 131.03 123.48 127.24 125.67 127.24 128.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 141.16 131.03 138.97 131.03 135.67 127.24 137.86 127.24 141.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 135.07 131.03 132.88 131.03 129.57 127.24 131.76 127.24 135.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 277.08 21.02 279.26 21.02 275.96 17.23 273.77 17.23 277.08"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 190.91 21.02 193.1 21.02 189.8 17.23 187.61 17.23 190.91"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 178.72 21.02 180.91 21.02 177.61 17.23 175.42 17.23 178.72"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 184.82 21.02 187.01 21.02 183.7 17.23 181.51 17.23 184.82"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 178.15 131.03 175.96 131.03 172.66 127.24 174.84 127.24 178.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 197.43 21.02 199.62 21.02 196.31 17.23 194.13 17.23 197.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 166.54 21.02 168.72 21.02 165.42 17.23 163.23 17.23 166.54"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 154.35 21.02 156.54 21.02 153.23 17.23 151.04 17.23 154.35"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 172.63 21.02 174.82 21.02 171.51 17.23 169.33 17.23 172.63"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 160.44 21.02 162.63 21.02 159.32 17.23 157.14 17.23 160.44"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 209.62 21.02 211.81 21.02 208.5 17.23 206.31 17.23 209.62"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 203.52 21.02 205.71 21.02 202.41 17.23 200.22 17.23 203.52"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 246.18 21.02 248.37 21.02 245.07 17.23 242.88 17.23 246.18"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 148.25 21.02 150.44 21.02 147.14 17.23 144.95 17.23 148.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 258.8 21.02 260.98 21.02 257.68 17.23 255.49 17.23 258.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 264.89 21.02 267.08 21.02 263.77 17.23 261.58 17.23 264.89"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 215.71 21.02 217.9 21.02 214.59 17.23 212.41 17.23 215.71"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 270.98 21.02 273.17 21.02 269.87 17.23 267.68 17.23 270.98"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 221.81 21.02 223.99 21.02 220.69 17.23 218.5 17.23 221.81"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 227.9 21.02 230.09 21.02 226.78 17.23 224.6 17.23 227.9"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 234 21.02 236.18 21.02 232.88 17.23 230.69 17.23 234"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 240.09 21.02 242.28 21.02 238.97 17.23 236.78 17.23 240.09"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 252.28 21.02 254.47 21.02 251.16 17.23 248.97 17.23 252.28"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 127.42 123.17 125.23 123.17 121.93 119.38 124.12 119.38 127.42"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 121.33 123.17 119.14 123.17 115.83 119.38 118.02 119.38 121.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 133.51 123.17 131.33 123.17 128.02 119.38 130.21 119.38 133.51"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 139.61 123.17 137.42 123.17 134.12 119.38 136.3 119.38 139.61"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 145.7 123.17 143.52 123.17 140.21 119.38 142.4 119.38 145.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 90.86 123.17 88.67 123.17 85.36 119.38 87.55 119.38 90.86"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 184.24 131.03 182.06 131.03 178.75 127.24 180.94 127.24 184.24"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 115.23 123.17 113.05 123.17 109.74 119.38 111.93 119.38 115.23"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 151.8 123.17 149.61 123.17 146.31 119.38 148.49 119.38 151.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 109.14 123.17 106.95 123.17 103.65 119.38 105.83 119.38 109.14"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 103.05 123.17 100.86 123.17 97.55 119.38 99.74 119.38 103.05"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 200.97 123.17 198.79 123.17 195.48 119.38 197.67 119.38 200.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 188.78 123.17 186.6 123.17 183.29 119.38 185.48 119.38 188.78"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 194.88 123.17 192.69 123.17 189.39 119.38 191.57 119.38 194.88"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 84.76 123.17 82.58 123.17 79.27 119.38 81.46 119.38 84.76"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 207.07 123.17 204.88 123.17 201.57 119.38 203.76 119.38 207.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 213.16 123.17 210.97 123.17 207.67 119.38 209.86 119.38 213.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 163.99 123.17 161.8 123.17 158.49 119.38 160.68 119.38 163.99"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 157.89 123.17 155.7 123.17 152.4 119.38 154.59 119.38 157.89"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 170.08 123.17 167.89 123.17 164.59 119.38 166.78 119.38 170.08"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 182.69 123.17 180.5 123.17 177.2 119.38 179.39 119.38 182.69"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 176.17 123.17 173.99 123.17 170.68 119.38 172.87 119.38 176.17"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 96.95 123.17 94.76 123.17 91.46 119.38 93.65 119.38 96.95"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 245.61 131.03 243.42 131.03 240.12 127.24 242.3 127.24 245.61"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 233 131.03 230.81 131.03 227.5 127.24 229.69 127.24 233"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 214.71 131.03 212.53 131.03 209.22 127.24 211.41 127.24 214.71"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 239.51 131.03 237.33 131.03 234.02 127.24 236.21 127.24 239.51"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 226.9 131.03 224.72 131.03 221.41 127.24 223.6 127.24 226.9"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 196.43 131.03 194.24 131.03 190.94 127.24 193.13 127.24 196.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 190.34 131.03 188.15 131.03 184.85 127.24 187.03 127.24 190.34"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 202.53 131.03 200.34 131.03 197.03 127.24 199.22 127.24 202.53"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 208.62 131.03 206.43 131.03 203.13 127.24 205.31 127.24 208.62"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 220.81 131.03 218.62 131.03 215.32 127.24 217.5 127.24 220.81"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 294.36 131.03 292.17 131.03 288.87 127.24 291.06 127.24 294.36"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 288.27 131.03 286.08 131.03 282.77 127.24 284.96 127.24 288.27"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 282.17 131.03 279.99 131.03 276.68 127.24 278.87 127.24 282.17"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 257.8 131.03 255.61 131.03 252.3 127.24 254.49 127.24 257.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 251.7 131.03 249.51 131.03 246.21 127.24 248.4 127.24 251.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 263.89 131.03 261.7 131.03 258.4 127.24 260.59 127.24 263.89"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 269.99 131.03 267.8 131.03 264.49 127.24 266.68 127.24 269.99"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="127.24 276.08 131.03 273.89 131.03 270.59 127.24 272.77 127.24 276.08"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 249.17 36.73 251.36 36.73 248.06 32.94 245.87 32.94 249.17"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 243.08 36.73 245.27 36.73 241.96 32.94 239.77 32.94 243.08"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 236.98 36.73 239.17 36.73 235.87 32.94 233.68 32.94 236.98"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 255.27 36.73 257.45 36.73 254.15 32.94 251.96 32.94 255.27"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 267.88 36.73 270.06 36.73 266.76 32.94 264.57 32.94 267.88"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 206.51 36.73 208.7 36.73 205.4 32.94 203.21 32.94 206.51"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 273.97 36.73 276.16 36.73 272.86 32.94 270.67 32.94 273.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 230.89 36.73 233.08 36.73 229.77 32.94 227.59 32.94 230.89"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 212.61 36.73 214.79 36.73 211.49 32.94 209.3 32.94 212.61"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 218.7 36.73 220.89 36.73 217.58 32.94 215.4 32.94 218.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 224.8 36.73 226.98 36.73 223.68 32.94 221.49 32.94 224.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 254.78 205.56 252.59 205.56 249.29 201.77 251.47 201.77 254.78"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 280.07 36.73 282.25 36.73 278.95 32.94 276.76 32.94 280.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 219.26 123.17 217.07 123.17 213.76 119.38 215.95 119.38 219.26"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 286.16 36.73 288.35 36.73 285.04 32.94 282.86 32.94 286.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 292.25 36.73 294.44 36.73 291.14 32.94 288.95 32.94 292.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 200 36.73 202.18 36.73 198.88 32.94 196.69 32.94 200"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 193.9 36.73 196.09 36.73 192.78 32.94 190.6 32.94 193.9"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 126.38 36.73 128.57 36.73 125.26 32.94 123.07 32.94 126.38"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 120.28 36.73 122.47 36.73 119.17 32.94 116.98 32.94 120.28"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 169.53 36.73 171.71 36.73 168.41 32.94 166.22 32.94 169.53"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 175.62 36.73 177.81 36.73 174.5 32.94 172.31 32.94 175.62"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 163.43 36.73 165.62 36.73 162.31 32.94 160.13 32.94 163.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 181.71 36.73 183.9 36.73 180.6 32.94 178.41 32.94 181.71"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 187.81 36.73 190 36.73 186.69 32.94 184.5 32.94 187.81"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 151.24 36.73 153.43 36.73 150.13 32.94 147.94 32.94 151.24"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 138.57 36.73 140.75 36.73 137.45 32.94 135.26 32.94 138.57"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 145.15 36.73 147.34 36.73 144.03 32.94 141.84 32.94 145.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 132.47 36.73 134.66 36.73 131.36 32.94 129.17 32.94 132.47"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="32.94 157.34 36.73 159.53 36.73 156.22 32.94 154.03 32.94 157.34"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 208.07 28.87 210.25 28.87 206.95 25.08 204.76 25.08 208.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 275.52 28.87 277.71 28.87 274.41 25.08 272.22 25.08 275.52"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 287.71 28.87 289.9 28.87 286.6 25.08 284.41 25.08 287.71"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 293.81 28.87 295.99 28.87 292.69 25.08 290.5 25.08 293.81"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 269.43 28.87 271.62 28.87 268.31 25.08 266.13 25.08 269.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 250.72 28.87 252.91 28.87 249.61 25.08 247.42 25.08 250.72"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 256.82 28.87 259.01 28.87 255.7 25.08 253.51 25.08 256.82"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 263.34 28.87 265.52 28.87 262.22 25.08 260.03 25.08 263.34"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 123.39 21.02 125.58 21.02 122.27 17.23 120.08 17.23 123.39"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 117.3 21.02 119.48 21.02 116.18 17.23 113.99 17.23 117.3"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 129.48 21.02 131.67 21.02 128.37 17.23 126.18 17.23 129.48"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 136.07 21.02 138.25 21.02 134.95 17.23 132.76 17.23 136.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 111.2 21.02 113.39 21.02 110.08 17.23 107.9 17.23 111.2"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 244.63 28.87 246.82 28.87 243.51 25.08 241.33 25.08 244.63"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 281.62 28.87 283.81 28.87 280.5 25.08 278.31 25.08 281.62"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 152.8 28.87 154.98 28.87 151.68 25.08 149.49 25.08 152.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 146.7 28.87 148.89 28.87 145.58 25.08 143.4 25.08 146.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 158.89 28.87 161.08 28.87 157.77 25.08 155.59 25.08 158.89"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 164.98 28.87 167.17 28.87 163.87 25.08 161.68 25.08 164.98"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 140.61 28.87 142.79 28.87 139.49 25.08 137.3 25.08 140.61"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 171.08 28.87 173.27 28.87 169.96 25.08 167.77 25.08 171.08"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 238.54 28.87 240.72 28.87 237.42 25.08 235.23 25.08 238.54"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 134.03 28.87 136.21 28.87 132.91 25.08 130.72 25.08 134.03"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 115.74 28.87 117.93 28.87 114.63 25.08 112.44 25.08 115.74"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 127.93 28.87 130.12 28.87 126.81 25.08 124.63 25.08 127.93"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 121.84 28.87 124.03 28.87 120.72 25.08 118.53 25.08 121.84"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 214.16 28.87 216.35 28.87 213.04 25.08 210.85 25.08 214.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 142.16 21.02 144.35 21.02 141.04 17.23 138.85 17.23 142.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 220.25 28.87 222.44 28.87 219.14 25.08 216.95 25.08 220.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 226.35 28.87 228.54 28.87 225.23 25.08 223.04 25.08 226.35"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 177.17 28.87 179.36 28.87 176.06 25.08 173.87 25.08 177.17"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 232.44 28.87 234.63 28.87 231.32 25.08 229.14 25.08 232.44"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 183.27 28.87 185.45 28.87 182.15 25.08 179.96 25.08 183.27"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 201.97 28.87 204.16 28.87 200.85 25.08 198.67 25.08 201.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 189.36 28.87 191.55 28.87 188.24 25.08 186.06 25.08 189.36"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 195.46 28.87 197.64 28.87 194.34 25.08 192.15 25.08 195.46"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 157.98 213.41 155.79 213.41 152.49 209.62 154.68 209.62 157.98"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 164.07 213.41 161.89 213.41 158.58 209.62 160.77 209.62 164.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 170.17 213.41 167.98 213.41 164.68 209.62 166.86 209.62 170.17"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 182.36 213.41 180.17 213.41 176.86 209.62 179.05 209.62 182.36"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 176.26 213.41 174.07 213.41 170.77 209.62 172.96 209.62 176.26"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 133.6 213.41 131.42 213.41 128.11 209.62 130.3 209.62 133.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 188.87 213.41 186.69 213.41 183.38 209.62 185.57 209.62 188.87"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 127.51 213.41 125.32 213.41 122.02 209.62 124.2 209.62 127.51"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 145.79 213.41 143.6 213.41 140.3 209.62 142.49 209.62 145.79"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 139.7 213.41 137.51 213.41 134.21 209.62 136.39 209.62 139.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 151.89 213.41 149.7 213.41 146.39 209.62 148.58 209.62 151.89"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 194.97 213.41 192.78 213.41 189.48 209.62 191.66 209.62 194.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 237.63 213.41 235.44 213.41 232.13 209.62 234.32 209.62 237.63"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 231.53 213.41 229.34 213.41 226.04 209.62 228.23 209.62 231.53"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 243.72 213.41 241.53 213.41 238.23 209.62 240.42 209.62 243.72"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 120.93 213.41 118.74 213.41 115.44 209.62 117.62 209.62 120.93"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 225.44 213.41 223.25 213.41 219.95 209.62 222.13 209.62 225.44"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 250.24 213.41 248.05 213.41 244.75 209.62 246.93 209.62 250.24"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 207.16 213.41 204.97 213.41 201.66 209.62 203.85 209.62 207.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 201.06 213.41 198.87 213.41 195.57 209.62 197.76 209.62 201.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 213.25 213.41 211.06 213.41 207.76 209.62 209.94 209.62 213.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 219.34 213.41 217.16 213.41 213.85 209.62 216.04 209.62 219.34"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 282.26 221.27 280.07 221.27 276.77 217.48 278.96 217.48 282.26"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 294.45 221.27 292.26 221.27 288.96 217.48 291.14 217.48 294.45"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 41.7 213.41 39.52 213.41 36.21 209.62 38.4 209.62 41.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 288.36 221.27 286.17 221.27 282.86 217.48 285.05 217.48 288.36"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 47.8 213.41 45.61 213.41 42.31 209.62 44.49 209.62 47.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 263.98 221.27 261.79 221.27 258.49 217.48 260.67 217.48 263.98"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 270.07 221.27 267.88 221.27 264.58 217.48 266.77 217.48 270.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 114.83 213.41 112.65 213.41 109.34 209.62 111.53 209.62 114.83"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 256.33 213.41 254.15 213.41 250.84 209.62 253.03 209.62 256.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 276.17 221.27 273.98 221.27 270.68 217.48 272.86 217.48 276.17"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 53.89 213.41 51.7 213.41 48.4 209.62 50.59 209.62 53.89"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 84.36 213.41 82.17 213.41 78.87 209.62 81.06 209.62 84.36"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 90.46 213.41 88.27 213.41 84.97 209.62 87.15 209.62 90.46"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 108.74 213.41 106.55 213.41 103.25 209.62 105.43 209.62 108.74"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 102.64 213.41 100.46 213.41 97.15 209.62 99.34 209.62 102.64"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 96.55 213.41 94.36 213.41 91.06 209.62 93.25 209.62 96.55"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 66.08 213.41 63.89 213.41 60.59 209.62 62.77 209.62 66.08"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 78.27 213.41 76.08 213.41 72.78 209.62 74.96 209.62 78.27"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 59.99 213.41 57.8 213.41 54.49 209.62 56.68 209.62 59.99"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 72.17 213.41 69.99 213.41 66.68 209.62 68.87 209.62 72.17"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 292.9 213.41 290.71 213.41 287.4 209.62 289.59 209.62 292.9"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 262.43 213.41 260.24 213.41 256.93 209.62 259.12 209.62 262.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 162.52 205.56 160.33 205.56 157.03 201.77 159.22 201.77 162.52"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 156.43 205.56 154.24 205.56 150.94 201.77 153.12 201.77 156.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 225.35 123.17 223.16 123.17 219.86 119.38 222.04 119.38 225.35"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 174.71 205.56 172.52 205.56 169.22 201.77 171.41 201.77 174.71"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 150.33 205.56 148.15 205.56 144.84 201.77 147.03 201.77 150.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 132.05 205.56 129.86 205.56 126.56 201.77 128.75 201.77 132.05"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 138.15 205.56 135.96 205.56 132.65 201.77 134.84 201.77 138.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 144.24 205.56 142.05 205.56 138.75 201.77 140.93 201.77 144.24"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 186.9 205.56 184.71 205.56 181.41 201.77 183.59 201.77 186.9"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 180.8 205.56 178.62 205.56 175.31 201.77 177.5 201.77 180.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 223.89 205.56 221.7 205.56 218.39 201.77 220.58 201.77 223.89"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 236.07 205.56 233.89 205.56 230.58 201.77 232.77 201.77 236.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 229.98 205.56 227.79 205.56 224.49 201.77 226.68 201.77 229.98"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 242.17 205.56 239.98 205.56 236.68 201.77 238.86 201.77 242.17"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 248.26 205.56 246.07 205.56 242.77 201.77 244.96 201.77 248.26"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 199.51 205.56 197.32 205.56 194.02 201.77 196.21 201.77 199.51"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 205.6 205.56 203.42 205.56 200.11 201.77 202.3 201.77 205.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 193.41 205.56 191.23 205.56 187.92 201.77 190.11 201.77 193.41"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 217.79 205.56 215.6 205.56 212.3 201.77 214.49 201.77 217.79"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 211.7 205.56 209.51 205.56 206.21 201.77 208.39 201.77 211.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 168.62 205.56 166.43 205.56 163.12 201.77 165.31 201.77 168.62"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 257.88 221.27 255.7 221.27 252.39 217.48 254.58 217.48 257.88"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 52.34 205.56 50.15 205.56 46.85 201.77 49.03 201.77 52.34"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 46.24 205.56 44.06 205.56 40.75 201.77 42.94 201.77 46.24"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 268.52 213.41 266.33 213.41 263.03 209.62 265.22 209.62 268.52"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 274.61 213.41 272.43 213.41 269.12 209.62 271.31 209.62 274.61"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 280.71 213.41 278.52 213.41 275.22 209.62 277.4 209.62 280.71"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="209.62 286.8 213.41 284.62 213.41 281.31 209.62 283.5 209.62 286.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 88.9 205.56 86.72 205.56 83.41 201.77 85.6 201.77 88.9"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 95 205.56 92.81 205.56 89.51 201.77 91.69 201.77 95"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 101.09 205.56 98.91 205.56 95.6 201.77 97.79 201.77 101.09"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 119.38 205.56 117.19 205.56 113.88 201.77 116.07 201.77 119.38"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 113.28 205.56 111.09 205.56 107.79 201.77 109.98 201.77 113.28"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 107.19 205.56 105 205.56 101.69 201.77 103.88 201.77 107.19"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 82.81 205.56 80.62 205.56 77.32 201.77 79.5 201.77 82.81"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 64.53 205.56 62.34 205.56 59.04 201.77 61.22 201.77 64.53"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 70.62 205.56 68.44 205.56 65.13 201.77 67.32 201.77 70.62"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 58.43 205.56 56.25 205.56 52.94 201.77 55.13 201.77 58.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 76.72 205.56 74.53 205.56 71.22 201.77 73.41 201.77 76.72"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="201.77 125.47 205.56 123.28 205.56 119.98 201.77 122.16 201.77 125.47"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 156.34 115.31 154.15 115.31 150.85 111.53 153.03 111.53 156.34"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 162.43 115.31 160.25 115.31 156.94 111.53 159.13 111.53 162.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 168.53 115.31 166.34 115.31 163.03 111.53 165.22 111.53 168.53"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 174.62 115.31 172.43 115.31 169.13 111.53 171.32 111.53 174.62"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 180.72 115.31 178.53 115.31 175.22 111.53 177.41 111.53 180.72"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 125.87 115.31 123.68 115.31 120.38 111.53 122.56 111.53 125.87"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 131.96 115.31 129.78 115.31 126.47 111.53 128.66 111.53 131.96"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 187.23 115.31 185.05 115.31 181.74 111.53 183.93 111.53 187.23"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 150.25 115.31 148.06 115.31 144.75 111.53 146.94 111.53 150.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 138.06 115.31 135.87 115.31 132.56 111.53 134.75 111.53 138.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 251.79 221.27 249.6 221.27 246.3 217.48 248.49 217.48 251.79"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 235.99 115.31 233.8 115.31 230.49 111.53 232.68 111.53 235.99"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 193.33 115.31 191.14 115.31 187.84 111.53 190.02 111.53 193.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 229.89 115.31 227.7 115.31 224.4 111.53 226.59 111.53 229.89"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 248.6 115.31 246.41 115.31 243.1 111.53 245.29 111.53 248.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 242.08 115.31 239.89 115.31 236.59 111.53 238.78 111.53 242.08"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 223.8 115.31 221.61 115.31 218.31 111.53 220.49 111.53 223.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 119.77 115.31 117.59 115.31 114.28 111.53 116.47 111.53 119.77"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 205.51 115.31 203.33 115.31 200.02 111.53 202.21 111.53 205.51"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 199.42 115.31 197.23 115.31 193.93 111.53 196.12 111.53 199.42"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 211.61 115.31 209.42 115.31 206.12 111.53 208.31 111.53 211.61"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 217.7 115.31 215.52 115.31 212.21 111.53 214.4 111.53 217.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 280.62 123.17 278.43 123.17 275.13 119.38 277.31 119.38 280.62"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 113.68 115.31 111.49 115.31 108.19 111.53 110.38 111.53 113.68"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 268.43 123.17 266.25 123.17 262.94 119.38 265.13 119.38 268.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 262.34 123.17 260.15 123.17 256.85 119.38 259.03 119.38 262.34"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 254.69 115.31 252.5 115.31 249.2 111.53 251.39 111.53 254.69"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 274.53 123.17 272.34 123.17 269.03 119.38 271.22 119.38 274.53"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 237.54 123.17 235.35 123.17 232.05 119.38 234.23 119.38 237.54"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 286.71 123.17 284.53 123.17 281.22 119.38 283.41 119.38 286.71"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 231.44 123.17 229.26 123.17 225.95 119.38 228.14 119.38 231.44"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 250.15 123.17 247.96 123.17 244.66 119.38 246.84 119.38 250.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 244.06 123.17 241.87 123.17 238.56 119.38 240.75 119.38 244.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 256.24 123.17 254.06 123.17 250.75 119.38 252.94 119.38 256.24"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 89.3 115.31 87.12 115.31 83.81 111.53 86 111.53 89.3"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="119.38 292.81 123.17 290.62 123.17 287.32 119.38 289.5 119.38 292.81"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 95.4 115.31 93.21 115.31 89.91 111.53 92.09 111.53 95.4"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 101.49 115.31 99.31 115.31 96 111.53 98.19 111.53 101.49"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 107.59 115.31 105.4 115.31 102.09 111.53 104.28 111.53 107.59"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 144.15 115.31 141.96 115.31 138.66 111.53 140.85 111.53 144.15"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 165.63 221.27 163.44 221.27 160.13 217.48 162.32 217.48 165.63"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 153.44 221.27 151.25 221.27 147.95 217.48 150.13 217.48 153.44"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 159.53 221.27 157.34 221.27 154.04 217.48 156.23 217.48 159.53"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 177.81 221.27 175.63 221.27 172.32 217.48 174.51 217.48 177.81"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 122.97 221.27 120.78 221.27 117.47 217.48 119.66 217.48 122.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 171.72 221.27 169.53 221.27 166.23 217.48 168.42 217.48 171.72"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 129.06 221.27 126.87 221.27 123.57 217.48 125.76 217.48 129.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 147.34 221.27 145.16 221.27 141.85 217.48 144.04 217.48 147.34"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 135.16 221.27 132.97 221.27 129.66 217.48 131.85 217.48 135.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 141.25 221.27 139.06 221.27 135.76 217.48 137.94 217.48 141.25"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 260.79 115.31 258.6 115.31 255.29 111.53 257.48 111.53 260.79"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 233.09 221.27 230.9 221.27 227.59 217.48 229.78 217.48 233.09"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 220.9 221.27 218.71 221.27 215.41 217.48 217.59 217.48 220.9"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 226.99 221.27 224.8 221.27 221.5 217.48 223.69 217.48 226.99"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 239.18 221.27 236.99 221.27 233.69 217.48 235.87 217.48 239.18"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 245.7 221.27 243.51 221.27 240.2 217.48 242.39 217.48 245.7"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 196.52 221.27 194.33 221.27 191.03 217.48 193.22 217.48 196.52"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 202.61 221.27 200.43 221.27 197.12 217.48 199.31 217.48 202.61"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 190.43 221.27 188.24 221.27 184.93 217.48 187.12 217.48 190.43"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 214.8 221.27 212.62 221.27 209.31 217.48 211.5 217.48 214.8"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 208.71 221.27 206.52 221.27 203.22 217.48 205.4 217.48 208.71"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 184.33 221.27 182.15 221.27 178.84 217.48 181.03 217.48 184.33"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 116.39 221.27 114.2 221.27 110.89 217.48 113.08 217.48 116.39"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 297.35 115.31 295.16 115.31 291.86 111.53 294.05 111.53 297.35"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 49.35 221.27 47.16 221.27 43.86 217.48 46.05 217.48 49.35"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 43.26 221.27 41.07 221.27 37.76 217.48 39.95 217.48 43.26"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 37.16 221.27 34.98 221.27 31.67 217.48 33.86 217.48 37.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 266.88 115.31 264.69 115.31 261.39 111.53 263.57 111.53 266.88"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 272.97 115.31 270.79 115.31 267.48 111.53 269.67 111.53 272.97"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 279.07 115.31 276.88 115.31 273.57 111.53 275.76 111.53 279.07"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 285.16 115.31 282.98 115.31 279.67 111.53 281.86 111.53 285.16"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="111.53 291.26 115.31 289.07 115.31 285.76 111.53 287.95 111.53 291.26"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 98.1 221.27 95.92 221.27 92.61 217.48 94.8 217.48 98.1"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 85.92 221.27 83.73 221.27 80.42 217.48 82.61 217.48 85.92"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 92.01 221.27 89.82 221.27 86.52 217.48 88.7 217.48 92.01"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 104.2 221.27 102.01 221.27 98.7 217.48 100.89 217.48 104.2"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 110.29 221.27 108.1 221.27 104.8 217.48 106.99 217.48 110.29"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 61.54 221.27 59.35 221.27 56.05 217.48 58.23 217.48 61.54"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 55.45 221.27 53.26 221.27 49.95 217.48 52.14 217.48 55.45"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 67.63 221.27 65.45 221.27 62.14 217.48 64.33 217.48 67.63"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 73.73 221.27 71.54 221.27 68.23 217.48 70.42 217.48 73.73"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="217.48 79.82 221.27 77.63 221.27 74.33 217.48 76.52 217.48 79.82"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="354.65 98 358.44 100.19 358.44 96.88 354.65 94.69 354.65 98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 91.91 358.44 94.09 358.44 90.79 354.65 88.6 354.65 91.91"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 104.09 358.44 106.28 358.44 102.98 354.65 100.79 354.65 104.09"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 110.82 358.44 113 358.44 109.7 354.65 107.51 354.65 110.82"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 116.91 358.44 119.1 358.44 115.79 354.65 113.61 354.65 116.91"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 190.53 358.44 192.72 358.44 189.41 354.65 187.22 354.65 190.53"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 123 358.44 125.19 358.44 121.89 354.65 119.7 354.65 123"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 79.41 358.44 81.6 358.44 78.29 354.65 76.11 354.65 79.41"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 184.43 358.44 186.62 358.44 183.32 354.65 181.13 354.65 184.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 201.16 366.29 203.35 366.29 200.05 362.51 197.86 362.51 201.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 160.06 358.44 162.25 358.44 158.94 354.65 156.75 354.65 160.06"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 166.15 358.44 168.34 358.44 165.03 354.65 162.85 354.65 166.15"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 178.34 358.44 180.53 358.44 177.22 354.65 175.03 354.65 178.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 129.1 358.44 131.29 358.44 127.98 354.65 125.79 354.65 129.1"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 135.19 358.44 137.38 358.44 134.08 354.65 131.89 354.65 135.19"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 141.29 358.44 143.47 358.44 140.17 354.65 137.98 354.65 141.29"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 147.87 358.44 150.06 358.44 146.75 354.65 144.56 354.65 147.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 153.96 358.44 156.15 358.44 152.85 354.65 150.66 354.65 153.96"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 85.75 358.44 87.94 358.44 84.63 354.65 82.45 354.65 85.75"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 238.15 366.29 240.34 366.29 237.03 362.51 234.85 362.51 238.15"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 244.25 366.29 246.43 366.29 243.13 362.51 240.94 362.51 244.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 250.34 366.29 252.53 366.29 249.22 362.51 247.03 362.51 250.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 232.06 366.29 234.25 366.29 230.94 362.51 228.75 362.51 232.06"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 256.43 366.29 258.62 366.29 255.32 362.51 253.13 362.51 256.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 207.26 366.29 209.45 366.29 206.14 362.51 203.95 362.51 207.26"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 262.53 366.29 264.72 366.29 261.41 362.51 259.22 362.51 262.53"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 213.78 366.29 215.96 366.29 212.66 362.51 210.47 362.51 213.78"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 219.87 366.29 222.06 366.29 218.75 362.51 216.56 362.51 219.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 225.96 366.29 228.15 366.29 224.85 362.51 222.66 362.51 225.96"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 281.23 366.29 283.42 366.29 280.12 362.51 277.93 362.51 281.23"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 268.62 366.29 270.81 366.29 267.5 362.51 265.32 362.51 268.62"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 293.42 366.29 295.61 366.29 292.31 362.51 290.12 362.51 293.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 275.14 366.29 277.33 366.29 274.02 362.51 271.83 362.51 275.14"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 287.33 366.29 289.52 366.29 286.21 362.51 284.02 362.51 287.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 172.25 358.44 174.43 358.44 171.13 354.65 168.94 354.65 172.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 87.36 350.58 89.55 350.58 86.25 346.79 84.06 346.79 87.36"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 93.46 350.58 95.65 350.58 92.34 346.79 90.15 346.79 93.46"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 99.55 350.58 101.74 350.58 98.44 346.79 96.25 346.79 99.55"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 118.46 350.58 120.65 350.58 117.35 346.79 115.16 346.79 118.46"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 106.28 350.58 108.46 350.58 105.16 346.79 102.97 346.79 106.28"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 74.87 350.58 77.06 350.58 73.75 346.79 71.56 346.79 74.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 81.21 350.58 83.4 350.58 80.09 346.79 77.9 346.79 81.21"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 112.37 350.58 114.56 350.58 111.25 346.79 109.06 346.79 112.37"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 167.7 350.58 169.89 350.58 166.59 346.79 164.4 346.79 167.7"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 155.52 350.58 157.7 350.58 154.4 346.79 152.21 346.79 155.52"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 161.61 350.58 163.8 350.58 160.49 346.79 158.31 346.79 161.61"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 173.8 350.58 175.99 350.58 172.68 346.79 170.49 346.79 173.8"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 124.56 350.58 126.75 350.58 123.44 346.79 121.25 346.79 124.56"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 179.89 350.58 182.08 350.58 178.78 346.79 176.59 346.79 179.89"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 136.75 350.58 138.93 350.58 135.63 346.79 133.44 346.79 136.75"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 130.65 350.58 132.84 350.58 129.53 346.79 127.35 346.79 130.65"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 149.42 350.58 151.61 350.58 148.31 346.79 146.12 346.79 149.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 143.33 350.58 145.51 350.58 142.21 346.79 140.02 346.79 143.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 239.7 358.44 241.89 358.44 238.59 354.65 236.4 354.65 239.7"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 233.61 358.44 235.8 358.44 232.49 354.65 230.31 354.65 233.61"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 227.52 358.44 229.7 358.44 226.4 354.65 224.21 354.65 227.52"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 245.8 358.44 247.99 358.44 244.68 354.65 242.49 354.65 245.8"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 257.99 358.44 260.17 358.44 256.87 354.65 254.68 354.65 257.99"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 251.89 358.44 254.08 358.44 250.78 354.65 248.59 354.65 251.89"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 202.72 358.44 204.9 358.44 201.6 354.65 199.41 354.65 202.72"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 221.42 358.44 223.61 358.44 220.31 354.65 218.12 354.65 221.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 209.23 358.44 211.42 358.44 208.12 354.65 205.93 354.65 209.23"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 215.33 358.44 217.51 358.44 214.21 354.65 212.02 354.65 215.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 282.79 358.44 284.97 358.44 281.67 354.65 279.48 354.65 282.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 294.98 358.44 297.16 358.44 293.86 354.65 291.67 354.65 294.98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 196.62 358.44 198.81 358.44 195.5 354.65 193.32 354.65 196.62"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 276.69 358.44 278.88 358.44 275.57 354.65 273.39 354.65 276.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 288.88 358.44 291.07 358.44 287.76 354.65 285.58 354.65 288.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 264.08 358.44 266.27 358.44 262.96 354.65 260.78 354.65 264.08"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="354.65 270.6 358.44 272.79 358.44 269.48 354.65 267.29 354.65 270.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 291.87 374.15 294.06 374.15 290.75 370.36 288.56 370.36 291.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 113.18 374.15 115.36 374.15 112.06 370.36 109.87 370.36 113.18"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 119.9 374.15 122.09 374.15 118.78 370.36 116.6 370.36 119.9"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 125.99 374.15 128.18 374.15 124.88 370.36 122.69 370.36 125.99"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 132.09 374.15 134.28 374.15 130.97 370.36 128.78 370.36 132.09"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 107.08 374.15 109.27 374.15 105.97 370.36 103.78 370.36 107.08"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 88.49 374.15 90.68 374.15 87.38 370.36 85.19 370.36 88.49"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 100.99 374.15 103.18 374.15 99.87 370.36 97.68 370.36 100.99"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 138.18 374.15 140.37 374.15 137.06 370.36 134.88 370.36 138.18"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 94.83 374.15 97.02 374.15 93.72 370.36 91.53 370.36 94.83"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 144.28 374.15 146.46 374.15 143.16 370.36 140.97 370.36 144.28"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 181.33 374.15 183.52 374.15 180.21 370.36 178.02 370.36 181.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 199.61 374.15 201.8 374.15 198.49 370.36 196.31 370.36 199.61"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 175.24 374.15 177.42 374.15 174.12 370.36 171.93 370.36 175.24"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 193.52 374.15 195.71 374.15 192.4 370.36 190.21 370.36 193.52"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 187.42 374.15 189.61 374.15 186.31 370.36 184.12 370.36 187.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 169.14 374.15 171.33 374.15 168.02 370.36 165.84 370.36 169.14"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 150.37 374.15 152.56 374.15 149.25 370.36 147.07 370.36 150.37"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 156.95 374.15 159.14 374.15 155.84 370.36 153.65 370.36 156.95"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 163.05 374.15 165.23 374.15 161.93 370.36 159.74 370.36 163.05"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 238.9 252.78 241.09 252.78 237.78 248.99 235.6 248.99 238.9"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 245.42 252.78 247.61 252.78 244.3 248.99 242.11 248.99 245.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 232.81 252.78 235 252.78 231.69 248.99 229.5 248.99 232.81"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 251.51 252.78 253.7 252.78 250.4 248.99 248.21 248.99 251.51"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 257.61 252.78 259.79 252.78 256.49 248.99 254.3 248.99 257.61"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 226.71 252.78 228.9 252.78 225.6 248.99 223.41 248.99 226.71"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 208.43 252.78 210.62 252.78 207.31 248.99 205.13 248.99 208.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 214.53 252.78 216.71 252.78 213.41 248.99 211.22 248.99 214.53"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 269.8 252.78 271.98 252.78 268.68 248.99 266.49 248.99 269.8"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 220.62 252.78 222.81 252.78 219.5 248.99 217.31 248.99 220.62"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 205.71 374.15 207.89 374.15 204.59 370.36 202.4 370.36 205.71"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 195.07 366.29 197.26 366.29 193.95 362.51 191.76 362.51 195.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 281.98 252.78 284.17 252.78 280.87 248.99 278.68 248.99 281.98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 275.89 252.78 278.08 252.78 274.77 248.99 272.58 248.99 275.89"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 288.08 252.78 290.26 252.78 286.96 248.99 284.77 248.99 288.08"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 294.17 252.78 296.36 252.78 293.05 248.99 290.87 248.99 294.17"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 108.64 366.29 110.82 366.29 107.52 362.51 105.33 362.51 108.64"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 102.54 366.29 104.73 366.29 101.42 362.51 99.24 362.51 102.54"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 121.45 366.29 123.64 366.29 120.33 362.51 118.15 362.51 121.45"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 115.36 366.29 117.55 366.29 114.24 362.51 112.05 362.51 115.36"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 127.55 366.29 129.73 366.29 126.43 362.51 124.24 362.51 127.55"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 96.45 366.29 98.64 366.29 95.33 362.51 93.14 362.51 96.45"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 90.29 366.29 92.48 366.29 89.17 362.51 86.99 362.51 90.29"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 83.95 366.29 86.14 366.29 82.83 362.51 80.65 362.51 83.95"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 158.5 366.29 160.69 366.29 157.39 362.51 155.2 362.51 158.5"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 133.64 366.29 135.83 366.29 132.52 362.51 130.34 362.51 133.64"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 170.69 366.29 172.88 366.29 169.58 362.51 167.39 362.51 170.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 182.88 366.29 185.07 366.29 181.76 362.51 179.58 362.51 182.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 164.6 366.29 166.79 366.29 163.48 362.51 161.29 362.51 164.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 188.98 366.29 191.16 366.29 187.86 362.51 185.67 362.51 188.98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 176.79 366.29 178.97 366.29 175.67 362.51 173.48 362.51 176.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 145.83 366.29 148.02 366.29 144.71 362.51 142.52 362.51 145.83"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 211.8 374.15 213.99 374.15 210.68 370.36 208.5 370.36 211.8"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 202.34 252.78 204.52 252.78 201.22 248.99 199.03 248.99 202.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 139.74 366.29 141.92 366.29 138.62 362.51 136.43 362.51 139.74"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 254.88 374.15 257.07 374.15 253.76 370.36 251.58 370.36 254.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 248.79 374.15 250.97 374.15 247.67 370.36 245.48 370.36 248.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 267.07 374.15 269.26 374.15 265.95 370.36 263.76 370.36 267.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 260.98 374.15 263.16 374.15 259.86 370.36 257.67 370.36 260.98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 273.16 374.15 275.35 374.15 272.05 370.36 269.86 370.36 273.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 242.69 374.15 244.88 374.15 241.58 370.36 239.39 370.36 242.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 218.32 374.15 220.5 374.15 217.2 370.36 215.01 370.36 218.32"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 236.6 374.15 238.79 374.15 235.48 370.36 233.29 370.36 236.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 230.5 374.15 232.69 374.15 229.39 370.36 227.2 370.36 230.5"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 224.41 374.15 226.6 374.15 223.29 370.36 221.11 370.36 224.41"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 285.78 374.15 287.96 374.15 284.66 370.36 282.47 370.36 285.78"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 185.99 350.58 188.17 350.58 184.87 346.79 182.68 346.79 185.99"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="370.36 279.68 374.15 281.87 374.15 278.56 370.36 276.38 370.36 279.68"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="362.51 152.41 366.29 154.6 366.29 151.29 362.51 149.11 362.51 152.41"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 186.52 440 188.71 440 185.4 436.21 183.21 436.21 186.52"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 192.61 440 194.8 440 191.49 436.21 189.31 436.21 192.61"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 199.13 440 201.32 440 198.01 436.21 195.82 436.21 199.13"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 205.22 440 207.41 440 204.1 436.21 201.92 436.21 205.22"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 211.32 440 213.5 440 210.2 436.21 208.01 436.21 211.32"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 217.41 440 219.6 440 216.29 436.21 214.11 436.21 217.41"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 156.05 440 158.23 440 154.93 436.21 152.74 436.21 156.05"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 162.14 440 164.33 440 161.02 436.21 158.84 436.21 162.14"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 168.24 440 170.42 440 167.12 436.21 164.93 436.21 168.24"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 174.33 440 176.52 440 173.21 436.21 171.02 436.21 174.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 180.42 440 182.61 440 179.31 436.21 177.12 436.21 180.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 229.6 440 231.79 440 228.48 436.21 226.29 436.21 229.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 223.5 440 225.69 440 222.39 436.21 220.2 436.21 223.5"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 266.59 440 268.77 440 265.47 436.21 263.28 436.21 266.59"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 260.49 440 262.68 440 259.38 436.21 257.19 436.21 260.49"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 278.77 440 280.96 440 277.66 436.21 275.47 436.21 278.77"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 272.68 440 274.87 440 271.56 436.21 269.38 436.21 272.68"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 253.98 440 256.16 440 252.86 436.21 250.67 436.21 253.98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 149.95 440 152.14 440 148.84 436.21 146.65 436.21 149.95"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 235.69 440 237.88 440 234.58 436.21 232.39 436.21 235.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 241.79 440 243.97 440 240.67 436.21 238.48 436.21 241.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 247.88 440 250.07 440 246.76 436.21 244.58 436.21 247.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 295.5 447.86 297.69 447.86 294.39 444.07 292.2 444.07 295.5"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 284.87 440 287.06 440 283.75 436.21 281.56 436.21 284.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 258.52 447.86 260.7 447.86 257.4 444.07 255.21 444.07 258.52"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 192.08 350.58 194.27 350.58 190.96 346.79 188.78 346.79 192.08"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 265.04 447.86 267.22 447.86 263.92 444.07 261.73 444.07 265.04"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 283.32 447.86 285.5 447.86 282.2 444.07 280.01 444.07 283.32"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 271.13 447.86 273.32 447.86 270.01 444.07 267.82 444.07 271.13"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 277.22 447.86 279.41 447.86 276.11 444.07 273.92 444.07 277.22"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 124.74 440 126.93 440 123.62 436.21 121.44 436.21 124.74"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 119.25 440 121.44 440 118.13 436.21 115.94 436.21 119.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 143.86 440 146.05 440 142.74 436.21 140.55 436.21 143.86"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 137.76 440 139.95 440 136.65 436.21 134.46 436.21 137.76"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 130.84 440 133.02 440 129.72 436.21 127.53 436.21 130.84"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 289.41 447.86 291.6 447.86 288.29 444.07 286.11 444.07 289.41"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 218.96 432.14 221.15 432.14 217.85 428.36 215.66 428.36 218.96"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 225.06 432.14 227.25 432.14 223.94 428.36 221.75 428.36 225.06"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 231.15 432.14 233.34 432.14 230.03 428.36 227.85 428.36 231.15"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 243.34 432.14 245.53 432.14 242.22 428.36 240.03 428.36 243.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 237.25 432.14 239.43 432.14 236.13 428.36 233.94 428.36 237.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 206.78 432.14 208.96 432.14 205.66 428.36 203.47 428.36 206.78"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 194.59 432.14 196.77 432.14 193.47 428.36 191.28 428.36 194.59"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 212.87 432.14 215.06 432.14 211.75 428.36 209.56 428.36 212.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 200.68 432.14 202.87 432.14 199.56 428.36 197.38 428.36 200.68"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 249.43 432.14 251.62 432.14 248.32 428.36 246.13 428.36 249.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 292.52 432.14 294.7 432.14 291.4 428.36 289.21 428.36 292.52"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 188.07 432.14 190.26 432.14 186.95 428.36 184.76 428.36 188.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 286.42 432.14 288.61 432.14 285.31 428.36 283.12 428.36 286.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 268.14 432.14 270.33 432.14 267.02 428.36 264.83 428.36 268.14"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 280.33 432.14 282.51 432.14 279.21 428.36 277.02 428.36 280.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 262.05 432.14 264.23 432.14 260.93 428.36 258.74 428.36 262.05"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 255.95 432.14 258.14 432.14 254.83 428.36 252.65 428.36 255.95"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 274.23 432.14 276.42 432.14 273.12 428.36 270.93 428.36 274.23"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 114.71 432.14 116.89 432.14 113.59 428.36 111.4 428.36 114.71"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="436.21 290.96 440 293.15 440 289.85 436.21 287.66 436.21 290.96"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 181.98 432.14 184.16 432.14 180.86 428.36 178.67 428.36 181.98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 157.6 432.14 159.79 432.14 156.48 428.36 154.29 428.36 157.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 163.69 432.14 165.88 432.14 162.58 428.36 160.39 428.36 163.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 169.79 432.14 171.97 432.14 168.67 428.36 166.48 428.36 169.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 151.5 432.14 153.69 432.14 150.39 428.36 148.2 428.36 151.5"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 175.88 432.14 178.07 432.14 174.76 428.36 172.58 428.36 175.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 139.32 432.14 141.5 432.14 138.2 428.36 136.01 428.36 139.32"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 145.41 432.14 147.6 432.14 144.29 428.36 142.11 428.36 145.41"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 133.22 432.14 135.41 432.14 132.1 428.36 129.92 428.36 133.22"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 126.29 432.14 128.48 432.14 125.18 428.36 122.99 428.36 126.29"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="428.36 120.2 432.14 122.39 432.14 119.08 428.36 116.89 428.36 120.2"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 165.13 455.71 167.32 455.71 164.01 451.92 161.82 451.92 165.13"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 133.82 455.71 136.01 455.71 132.71 451.92 130.52 451.92 133.82"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 139.92 455.71 142.1 455.71 138.8 451.92 136.61 451.92 139.92"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 152.94 455.71 155.13 455.71 151.82 451.92 149.64 451.92 152.94"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 159.04 455.71 161.22 455.71 157.92 451.92 155.73 451.92 159.04"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 146.85 455.71 149.03 455.71 145.73 451.92 143.54 451.92 146.85"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 232.59 455.71 234.78 455.71 231.47 451.92 229.28 451.92 232.59"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 128.33 455.71 130.52 455.71 127.21 451.92 125.03 451.92 128.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 208.21 455.71 210.4 455.71 207.09 451.92 204.91 451.92 208.21"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 214.31 455.71 216.49 455.71 213.19 451.92 211 451.92 214.31"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 220.4 455.71 222.59 455.71 219.28 451.92 217.1 451.92 220.4"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 201.69 455.71 203.88 455.71 200.58 451.92 198.39 451.92 201.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 226.49 455.71 228.68 455.71 225.38 451.92 223.19 451.92 226.49"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 177.32 455.71 179.51 455.71 176.2 451.92 174.01 451.92 177.32"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 171.22 455.71 173.41 455.71 170.11 451.92 167.92 451.92 171.22"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 183.41 455.71 185.6 455.71 182.29 451.92 180.11 451.92 183.41"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 195.6 455.71 197.79 455.71 194.48 451.92 192.3 451.92 195.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 189.51 455.71 191.69 455.71 188.39 451.92 186.2 451.92 189.51"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 229.07 350.58 231.26 350.58 227.95 346.79 225.76 346.79 229.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 235.16 350.58 237.35 350.58 234.04 346.79 231.86 346.79 235.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 247.35 350.58 249.54 350.58 246.23 346.79 244.05 346.79 247.35"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 241.26 350.58 243.44 350.58 240.14 346.79 237.95 346.79 241.26"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 253.44 350.58 255.63 350.58 252.33 346.79 250.14 346.79 253.44"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 204.69 350.58 206.88 350.58 203.57 346.79 201.39 346.79 204.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 198.18 350.58 200.36 350.58 197.06 346.79 194.87 346.79 198.18"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 210.79 350.58 212.97 350.58 209.67 346.79 207.48 346.79 210.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 216.88 350.58 219.07 350.58 215.76 346.79 213.58 346.79 216.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 222.97 350.58 225.16 350.58 221.86 346.79 219.67 346.79 222.97"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 252.42 447.86 254.61 447.86 251.31 444.07 249.12 444.07 252.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 290.43 350.58 292.62 350.58 289.31 346.79 287.13 346.79 290.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 259.54 350.58 261.73 350.58 258.42 346.79 256.23 346.79 259.54"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 266.06 350.58 268.24 350.58 264.94 346.79 262.75 346.79 266.06"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 272.15 350.58 274.34 350.58 271.03 346.79 268.85 346.79 272.15"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 278.25 350.58 280.43 350.58 277.13 346.79 274.94 346.79 278.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="346.79 284.34 350.58 286.53 350.58 283.22 346.79 281.03 346.79 284.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 160.59 447.86 162.78 447.86 159.47 444.07 157.28 444.07 160.59"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 166.68 447.86 168.87 447.86 165.56 444.07 163.38 444.07 166.68"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 178.87 447.86 181.06 447.86 177.75 444.07 175.57 444.07 178.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 154.49 447.86 156.68 447.86 153.38 444.07 151.19 444.07 154.49"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 172.78 447.86 174.96 447.86 171.66 444.07 169.47 444.07 172.78"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 129.28 447.86 131.47 447.86 128.16 444.07 125.98 444.07 129.28"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 184.97 447.86 187.15 447.86 183.85 444.07 181.66 444.07 184.97"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 135.38 447.86 137.56 447.86 134.26 444.07 132.07 444.07 135.38"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 148.4 447.86 150.59 447.86 147.28 444.07 145.09 444.07 148.4"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 142.31 447.86 144.49 447.86 141.19 444.07 139 444.07 142.31"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 209.76 447.86 211.95 447.86 208.65 444.07 206.46 444.07 209.76"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 228.05 447.86 230.23 447.86 226.93 444.07 224.74 444.07 228.05"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 234.14 447.86 236.33 447.86 233.02 444.07 230.84 444.07 234.14"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 221.95 447.86 224.14 447.86 220.84 444.07 218.65 444.07 221.95"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 240.24 447.86 242.42 447.86 239.12 444.07 236.93 444.07 240.24"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 246.33 447.86 248.52 447.86 245.21 444.07 243.02 444.07 246.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 191.06 447.86 193.25 447.86 189.94 444.07 187.75 444.07 191.06"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 215.86 447.86 218.05 447.86 214.74 444.07 212.55 444.07 215.86"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 197.15 447.86 199.34 447.86 196.04 444.07 193.85 444.07 197.15"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 203.67 447.86 205.86 447.86 202.55 444.07 200.37 444.07 203.67"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="444.07 123.79 447.86 125.98 447.86 122.67 444.07 120.48 444.07 123.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 281.76 455.71 283.95 455.71 280.65 451.92 278.46 451.92 281.76"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 275.67 455.71 277.86 455.71 274.55 451.92 272.37 451.92 275.67"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 238.68 455.71 240.87 455.71 237.56 451.92 235.38 451.92 238.68"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 269.58 455.71 271.76 455.71 268.46 451.92 266.27 451.92 269.58"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 293.95 455.71 296.14 455.71 292.83 451.92 290.65 451.92 293.95"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 287.86 455.71 290.05 455.71 286.74 451.92 284.55 451.92 287.86"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 244.78 455.71 246.96 455.71 243.66 451.92 241.47 451.92 244.78"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 250.87 455.71 253.06 455.71 249.75 451.92 247.57 451.92 250.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 263.06 455.71 265.25 455.71 261.94 451.92 259.75 451.92 263.06"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="451.92 256.96 455.71 259.15 455.71 255.85 451.92 253.66 451.92 256.96"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 263.7 252.78 265.89 252.78 262.58 248.99 260.4 248.99 263.7"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 295.16 102.86 297.35 102.86 294.05 99.07 291.86 99.07 295.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 264.69 102.86 266.88 102.86 263.57 99.07 261.39 99.07 264.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 270.79 102.86 272.97 102.86 269.67 99.07 267.48 99.07 270.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 258.6 102.86 260.79 102.86 257.48 99.07 255.29 99.07 258.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 282.98 102.86 285.16 102.86 281.86 99.07 279.67 99.07 282.98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 289.07 102.86 291.26 102.86 287.95 99.07 285.76 99.07 289.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 276.88 102.86 279.07 102.86 275.76 99.07 273.57 99.07 276.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 125.23 95.01 127.42 95.01 124.12 91.22 121.93 91.22 125.23"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 119.14 95.01 121.33 95.01 118.02 91.22 115.83 91.22 119.14"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 131.33 95.01 133.51 95.01 130.21 91.22 128.02 91.22 131.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 113.05 95.01 115.23 95.01 111.93 91.22 109.74 91.22 113.05"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 137.42 95.01 139.61 95.01 136.3 91.22 134.12 91.22 137.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 106.95 95.01 109.14 95.01 105.83 91.22 103.65 91.22 106.95"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 88.67 95.01 90.86 95.01 87.55 91.22 85.36 91.22 88.67"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 82.58 95.01 84.76 95.01 81.46 91.22 79.27 91.22 82.58"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 94.76 95.01 96.95 95.01 93.65 91.22 91.46 91.22 94.76"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 100.86 95.01 103.05 95.01 99.74 91.22 97.55 91.22 100.86"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 154.15 102.86 156.34 102.86 153.03 99.07 150.85 99.07 154.15"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 160.25 102.86 162.43 102.86 159.13 99.07 156.94 99.07 160.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 166.34 102.86 168.53 102.86 165.22 99.07 163.03 99.07 166.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 143.52 95.01 145.7 95.01 142.4 91.22 140.21 91.22 143.52"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 172.43 102.86 174.62 102.86 171.32 99.07 169.13 99.07 172.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 252.5 102.86 254.69 102.86 251.39 99.07 249.2 99.07 252.5"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 185.05 102.86 187.23 102.86 183.93 99.07 181.74 99.07 185.05"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 148.06 102.86 150.25 102.86 146.94 99.07 144.75 99.07 148.06"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 129.78 102.86 131.96 102.86 128.66 99.07 126.47 99.07 129.78"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 135.87 102.86 138.06 102.86 134.75 99.07 132.56 99.07 135.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 141.96 102.86 144.15 102.86 140.85 99.07 138.66 99.07 141.96"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 178.53 102.86 180.72 102.86 177.41 99.07 175.22 99.07 178.53"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 233.8 102.86 235.99 102.86 232.68 99.07 230.49 99.07 233.8"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 227.7 102.86 229.89 102.86 226.59 99.07 224.4 99.07 227.7"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 239.89 102.86 242.08 102.86 238.78 99.07 236.59 99.07 239.89"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 191.14 102.86 193.33 102.86 190.02 99.07 187.84 99.07 191.14"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 221.61 102.86 223.8 102.86 220.49 99.07 218.31 99.07 221.61"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 246.41 102.86 248.6 102.86 245.29 99.07 243.1 99.07 246.41"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 203.33 102.86 205.51 102.86 202.21 99.07 200.02 99.07 203.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 197.23 102.86 199.42 102.86 196.12 99.07 193.93 99.07 197.23"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 215.52 102.86 217.7 102.86 214.4 99.07 212.21 99.07 215.52"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 209.42 102.86 211.61 102.86 208.31 99.07 206.12 99.07 209.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 126.93 188.62 129.12 188.62 125.81 184.83 123.63 184.83 126.93"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 59.9 188.62 62.08 188.62 58.78 184.83 56.59 184.83 59.9"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 53.8 188.62 55.99 188.62 52.69 184.83 50.5 184.83 53.8"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 65.99 188.62 68.18 188.62 64.87 184.83 62.69 184.83 65.99"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 78.18 188.62 80.37 188.62 77.06 184.83 74.87 184.83 78.18"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 72.08 188.62 74.27 188.62 70.97 184.83 68.78 184.83 72.08"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 47.71 188.62 49.9 188.62 46.59 184.83 44.4 184.83 47.71"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 290.62 95.01 292.81 95.01 289.5 91.22 287.32 91.22 290.62"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 284.53 95.01 286.71 95.01 283.41 91.22 281.22 91.22 284.53"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 120.84 188.62 123.03 188.62 119.72 184.83 117.53 184.83 120.84"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 123.68 102.86 125.87 102.86 122.56 99.07 120.38 99.07 123.68"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 139.61 188.62 141.8 188.62 138.49 184.83 136.3 184.83 139.61"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 149.61 95.01 151.8 95.01 148.49 91.22 146.31 91.22 149.61"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 84.27 188.62 86.46 188.62 83.16 184.83 80.97 184.83 84.27"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 133.51 188.62 135.7 188.62 132.4 184.83 130.21 184.83 133.51"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 108.65 188.62 110.84 188.62 107.53 184.83 105.34 184.83 108.65"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 96.46 188.62 98.65 188.62 95.34 184.83 93.16 184.83 96.46"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 90.37 188.62 92.56 188.62 89.25 184.83 87.06 184.83 90.37"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 102.56 188.62 104.74 188.62 101.44 184.83 99.25 184.83 102.56"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 114.74 188.62 116.93 188.62 113.63 184.83 111.44 184.83 114.74"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 180.5 95.01 182.69 95.01 179.39 91.22 177.2 91.22 180.5"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 192.69 95.01 194.88 95.01 191.57 91.22 189.39 91.22 192.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 186.6 95.01 188.78 95.01 185.48 91.22 183.29 91.22 186.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 198.79 95.01 200.97 95.01 197.67 91.22 195.48 91.22 198.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 204.88 95.01 207.07 95.01 203.76 91.22 201.57 91.22 204.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 173.99 95.01 176.17 95.01 172.87 91.22 170.68 91.22 173.99"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 155.7 95.01 157.89 95.01 154.59 91.22 152.4 91.22 155.7"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 161.8 95.01 163.99 95.01 160.68 91.22 158.49 91.22 161.8"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 167.89 95.01 170.08 95.01 166.78 91.22 164.59 91.22 167.89"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 210.97 95.01 213.16 95.01 209.86 91.22 207.67 91.22 210.97"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 272.34 95.01 274.53 95.01 271.22 91.22 269.03 91.22 272.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 254.06 95.01 256.24 95.01 252.94 91.22 250.75 91.22 254.06"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 260.15 95.01 262.34 95.01 259.03 91.22 256.85 91.22 260.15"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 247.96 95.01 250.15 95.01 246.84 91.22 244.66 91.22 247.96"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 278.43 95.01 280.62 95.01 277.31 91.22 275.13 91.22 278.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 266.25 95.01 268.43 95.01 265.13 91.22 262.94 91.22 266.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 235.35 95.01 237.54 95.01 234.23 91.22 232.05 91.22 235.35"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 241.87 95.01 244.06 95.01 240.75 91.22 238.56 91.22 241.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 229.26 95.01 231.44 95.01 228.14 91.22 225.95 91.22 229.26"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 223.16 95.01 225.35 95.01 222.04 91.22 219.86 91.22 223.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="91.22 217.07 95.01 219.26 95.01 215.95 91.22 213.76 91.22 217.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 252.38 45.17 250.19 45.17 246.89 41.38 249.08 41.38 252.38"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 273.05 52.29 270.86 52.29 267.56 48.5 269.75 48.5 273.05"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 248.25 52.29 246.06 52.29 242.76 48.5 244.95 48.5 248.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 266.96 52.29 264.77 52.29 261.46 48.5 263.65 48.5 266.96"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 260.44 52.29 258.25 52.29 254.95 48.5 257.13 48.5 260.44"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 205.59 52.29 203.41 52.29 200.1 48.5 202.29 48.5 205.59"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 211.69 52.29 209.5 52.29 206.19 48.5 208.38 48.5 211.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 217.78 52.29 215.59 52.29 212.29 48.5 214.48 48.5 217.78"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 229.97 52.29 227.78 52.29 224.48 48.5 226.66 48.5 229.97"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 223.87 52.29 221.69 52.29 218.38 48.5 220.57 48.5 223.87"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 236.06 52.29 233.88 52.29 230.57 48.5 232.76 48.5 236.06"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 254.34 52.29 252.16 52.29 248.85 48.5 251.04 48.5 254.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 279.14 52.29 276.96 52.29 273.65 48.5 275.84 48.5 279.14"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 291.33 52.29 289.15 52.29 285.84 48.5 288.03 48.5 291.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 285.24 52.29 283.05 52.29 279.75 48.5 281.93 48.5 285.24"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 297.43 52.29 295.24 52.29 291.94 48.5 294.12 48.5 297.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 242.16 52.29 239.97 52.29 236.66 48.5 238.85 48.5 242.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 125.46 52.29 123.27 52.29 119.97 48.5 122.15 48.5 125.46"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 131.55 52.29 129.36 52.29 126.06 48.5 128.25 48.5 131.55"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 119.36 52.29 117.18 52.29 113.87 48.5 116.06 48.5 119.36"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 156.42 52.29 154.23 52.29 150.92 48.5 153.11 48.5 156.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 180.79 52.29 178.6 52.29 175.3 48.5 177.49 48.5 180.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 174.7 52.29 172.51 52.29 169.21 48.5 171.39 48.5 174.7"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 192.98 52.29 190.79 52.29 187.49 48.5 189.68 48.5 192.98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 168.6 52.29 166.42 52.29 163.11 48.5 165.3 48.5 168.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 186.89 52.29 184.7 52.29 181.39 48.5 183.58 48.5 186.89"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 144.23 52.29 142.04 52.29 138.74 48.5 140.92 48.5 144.23"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 150.32 52.29 148.13 52.29 144.83 48.5 147.02 48.5 150.32"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 137.65 52.29 135.46 52.29 132.15 48.5 134.34 48.5 137.65"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 199.07 52.29 196.89 52.29 193.58 48.5 195.77 48.5 199.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="48.5 162.51 52.29 160.32 52.29 157.02 48.5 159.21 48.5 162.51"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 184.92 45.17 182.73 45.17 179.43 41.38 181.62 41.38 184.92"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 289.37 45.17 287.18 45.17 283.88 41.38 286.06 41.38 289.37"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 283.27 45.17 281.09 45.17 277.78 41.38 279.97 41.38 283.27"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 295.46 45.17 293.27 45.17 289.97 41.38 292.16 41.38 295.46"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 277.18 45.17 274.99 45.17 271.69 41.38 273.88 41.38 277.18"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 271.09 45.17 268.9 45.17 265.59 41.38 267.78 41.38 271.09"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 145.7 188.62 147.89 188.62 144.59 184.83 142.4 184.83 145.7"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 258.48 45.17 256.29 45.17 252.98 41.38 255.17 41.38 258.48"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 264.57 45.17 262.38 45.17 259.08 41.38 261.26 41.38 264.57"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 111.49 102.86 113.68 102.86 110.38 99.07 108.19 99.07 111.49"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 99.31 102.86 101.49 102.86 98.19 99.07 96 99.07 99.31"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 105.4 102.86 107.59 102.86 104.28 99.07 102.09 99.07 105.4"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 246.29 45.17 244.1 45.17 240.79 41.38 242.98 41.38 246.29"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 87.12 102.86 89.3 102.86 86 99.07 83.81 99.07 87.12"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 93.21 102.86 95.4 102.86 92.09 99.07 89.91 99.07 93.21"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 228 45.17 225.82 45.17 222.51 41.38 224.7 41.38 228"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 141.78 45.17 139.59 45.17 136.28 41.38 138.47 41.38 141.78"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 148.36 45.17 146.17 45.17 142.87 41.38 145.05 41.38 148.36"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 154.45 45.17 152.26 45.17 148.96 41.38 151.15 41.38 154.45"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 166.64 45.17 164.45 45.17 161.15 41.38 163.34 41.38 166.64"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 160.55 45.17 158.36 45.17 155.05 41.38 157.24 41.38 160.55"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 172.73 45.17 170.55 45.17 167.24 41.38 169.43 41.38 172.73"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 123.49 45.17 121.31 45.17 118 41.38 120.19 41.38 123.49"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="32.94 114.21 36.73 116.4 36.73 113.09 32.94 110.91 32.94 114.21"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 105.13 21.02 107.32 21.02 104.01 17.23 101.82 17.23 105.13"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 109.67 28.87 111.86 28.87 108.55 25.08 106.36 25.08 109.67"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="48.5 113.29 52.29 111.1 52.29 107.8 48.5 109.98 48.5 113.29"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 117.42 45.17 115.23 45.17 111.93 41.38 114.11 41.38 117.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="32.94 108.14 36.73 110.33 36.73 107.02 32.94 104.83 32.94 108.14"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="17.23 99.06 21.02 101.24 21.02 97.94 17.23 95.75 17.23 99.06"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="25.08 103.6 28.87 105.78 28.87 102.48 25.08 100.29 25.08 103.6"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="48.5 107.22 52.29 105.03 52.29 101.72 48.5 103.91 48.5 107.22"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 111.35 45.17 109.16 45.17 105.85 41.38 108.04 41.38 111.35"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 135.68 45.17 133.49 45.17 130.19 41.38 132.38 41.38 135.68"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 129.59 45.17 127.4 45.17 124.09 41.38 126.28 41.38 129.59"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 203.2 45.17 201.02 45.17 197.71 41.38 199.9 41.38 203.2"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 209.72 45.17 207.53 45.17 204.23 41.38 206.42 41.38 209.72"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 221.91 45.17 219.72 45.17 216.42 41.38 218.6 41.38 221.91"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 215.81 45.17 213.63 45.17 210.32 41.38 212.51 41.38 215.81"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 178.83 45.17 176.64 45.17 173.34 41.38 175.52 41.38 178.83"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 234.1 45.17 231.91 45.17 228.61 41.38 230.79 41.38 234.1"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="99.07 117.59 102.86 119.77 102.86 116.47 99.07 114.28 99.07 117.59"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 191.02 45.17 188.83 45.17 185.52 41.38 187.71 41.38 191.02"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 197.11 45.17 194.92 45.17 191.62 41.38 193.81 41.38 197.11"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="41.38 240.19 45.17 238 45.17 234.7 41.38 236.89 41.38 240.19"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 159.25 252.78 161.44 252.78 158.14 248.99 155.95 248.99 159.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 265.44 172.9 267.63 172.9 264.32 169.12 262.14 169.12 265.44"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 283.72 172.9 285.91 172.9 282.61 169.12 280.42 169.12 283.72"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 271.54 172.9 273.72 172.9 270.42 169.12 268.23 169.12 271.54"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 277.63 172.9 279.82 172.9 276.51 169.12 274.32 169.12 277.63"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 289.82 172.9 292.01 172.9 288.7 169.12 286.51 169.12 289.82"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 139.42 260.64 141.61 260.64 138.3 256.85 136.12 256.85 139.42"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 145.51 260.64 147.7 260.64 144.4 256.85 142.21 256.85 145.51"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 133.33 260.64 135.51 260.64 132.21 256.85 130.02 256.85 133.33"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 157.7 260.64 159.89 260.64 156.59 256.85 154.4 256.85 157.7"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 151.8 188.62 153.98 188.62 150.68 184.83 148.49 184.83 151.8"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 121.14 260.64 123.33 260.64 120.02 256.85 117.83 256.85 121.14"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 127.23 260.64 129.42 260.64 126.11 256.85 123.93 256.85 127.23"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 191.89 172.9 194.08 172.9 190.77 169.12 188.58 169.12 191.89"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 167.09 172.9 169.28 172.9 165.97 169.12 163.78 169.12 167.09"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 173.18 172.9 175.37 172.9 172.07 169.12 169.88 169.12 173.18"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 179.28 172.9 181.47 172.9 178.16 169.12 175.97 169.12 179.28"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 185.79 172.9 187.98 172.9 184.68 169.12 182.49 169.12 185.79"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 130.53 172.9 132.71 172.9 129.41 169.12 127.22 169.12 130.53"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 161 172.9 163.18 172.9 159.88 169.12 157.69 169.12 161"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 142.71 172.9 144.9 172.9 141.6 169.12 139.41 169.12 142.71"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 259.35 172.9 261.54 172.9 258.23 169.12 256.04 169.12 259.35"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 148.81 172.9 151 172.9 147.69 169.12 145.5 169.12 148.81"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 154.9 172.9 157.09 172.9 153.78 169.12 151.6 169.12 154.9"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 136.62 172.9 138.81 172.9 135.5 169.12 133.31 169.12 136.62"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 240.64 172.9 242.83 172.9 239.53 169.12 237.34 169.12 240.64"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 234.55 172.9 236.74 172.9 233.43 169.12 231.24 169.12 234.55"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 253.25 172.9 255.44 172.9 252.14 169.12 249.95 169.12 253.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 247.16 172.9 249.35 172.9 246.04 169.12 243.85 169.12 247.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 228.45 172.9 230.64 172.9 227.34 169.12 225.15 169.12 228.45"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 210.17 172.9 212.36 172.9 209.05 169.12 206.87 169.12 210.17"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 222.36 172.9 224.55 172.9 221.24 169.12 219.06 169.12 222.36"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 204.08 172.9 206.26 172.9 202.96 169.12 200.77 169.12 204.08"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 197.98 172.9 200.17 172.9 196.87 169.12 194.68 169.12 197.98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 216.27 172.9 218.45 172.9 215.15 169.12 212.96 169.12 216.27"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 163.8 260.64 165.98 260.64 162.68 256.85 160.49 256.85 163.8"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 128.78 252.78 130.97 252.78 127.67 248.99 125.48 248.99 128.78"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 122.69 252.78 124.88 252.78 121.57 248.99 119.39 248.99 122.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 116.6 252.78 118.78 252.78 115.48 248.99 113.29 248.99 116.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 165.35 252.78 167.54 252.78 164.23 248.99 162.04 248.99 165.35"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 134.88 252.78 137.07 252.78 133.76 248.99 131.57 248.99 134.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 177.54 252.78 179.72 252.78 176.42 248.99 174.23 248.99 177.54"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 184.05 252.78 186.24 252.78 182.94 248.99 180.75 248.99 184.05"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 190.15 252.78 192.34 252.78 189.03 248.99 186.84 248.99 190.15"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 171.44 252.78 173.63 252.78 170.33 248.99 168.14 248.99 171.44"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 196.24 252.78 198.43 252.78 195.13 248.99 192.94 248.99 196.24"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 147.07 252.78 149.25 252.78 145.95 248.99 143.76 248.99 147.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 140.97 252.78 143.16 252.78 139.85 248.99 137.67 248.99 140.97"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="248.99 153.16 252.78 155.35 252.78 152.04 248.99 149.86 248.99 153.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 286.52 260.64 288.71 260.64 285.41 256.85 283.22 256.85 286.52"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 212.97 260.64 215.16 260.64 211.85 256.85 209.67 256.85 212.97"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 206.88 260.64 209.07 260.64 205.76 256.85 203.57 256.85 206.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 225.16 260.64 227.35 260.64 224.04 256.85 221.86 256.85 225.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 200.78 260.64 202.97 260.64 199.67 256.85 197.48 256.85 200.78"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 219.07 260.64 221.25 260.64 217.95 256.85 215.76 256.85 219.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 175.99 260.64 178.17 260.64 174.87 256.85 172.68 256.85 175.99"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 182.08 260.64 184.27 260.64 180.96 256.85 178.77 256.85 182.08"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 231.25 260.64 233.44 260.64 230.14 256.85 227.95 256.85 231.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 188.6 260.64 190.78 260.64 187.48 256.85 185.29 256.85 188.6"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 194.69 260.64 196.88 260.64 193.57 256.85 191.38 256.85 194.69"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 169.89 260.64 172.08 260.64 168.77 256.85 166.59 256.85 169.89"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 274.34 260.64 276.52 260.64 273.22 256.85 271.03 256.85 274.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 280.43 260.64 282.62 260.64 279.31 256.85 277.13 256.85 280.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 237.35 260.64 239.54 260.64 236.23 256.85 234.04 256.85 237.35"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 292.62 260.64 294.81 260.64 291.5 256.85 289.31 256.85 292.62"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 268.24 260.64 270.43 260.64 267.13 256.85 264.94 256.85 268.24"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 249.96 260.64 252.15 260.64 248.84 256.85 246.66 256.85 249.96"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 262.15 260.64 264.34 260.64 261.03 256.85 258.84 256.85 262.15"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 243.44 260.64 245.63 260.64 242.33 256.85 240.14 256.85 243.44"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 256.06 260.64 258.24 260.64 254.94 256.85 252.75 256.85 256.06"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="256.85 151.61 260.64 153.8 260.64 150.49 256.85 148.3 256.85 151.61"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 67.54 180.76 69.73 180.76 66.43 176.97 64.24 176.97 67.54"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 43.17 180.76 45.35 180.76 42.05 176.97 39.86 176.97 43.17"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 49.26 180.76 51.45 180.76 48.14 176.97 45.96 176.97 49.26"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 61.45 180.76 63.64 180.76 60.33 176.97 58.15 176.97 61.45"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 55.35 180.76 57.54 180.76 54.24 176.97 52.05 176.97 55.35"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 286.71 188.62 288.9 188.62 285.6 184.83 283.41 184.83 286.71"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 292.81 188.62 295 188.62 291.69 184.83 289.5 184.83 292.81"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 104.11 180.76 106.3 180.76 102.99 176.97 100.8 176.97 104.11"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 116.3 180.76 118.48 180.76 115.18 176.97 112.99 176.97 116.3"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 110.2 180.76 112.39 180.76 109.08 176.97 106.9 176.97 110.2"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 128.97 180.76 131.16 180.76 127.86 176.97 125.67 176.97 128.97"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 122.39 180.76 124.58 180.76 121.27 176.97 119.09 176.97 122.39"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 85.83 180.76 88.01 180.76 84.71 176.97 82.52 176.97 85.83"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 79.73 180.76 81.92 180.76 78.61 176.97 76.43 176.97 79.73"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 73.64 180.76 75.83 180.76 72.52 176.97 70.33 176.97 73.64"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 91.92 180.76 94.11 180.76 90.8 176.97 88.61 176.97 91.92"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 98.01 180.76 100.2 180.76 96.9 176.97 94.71 176.97 98.01"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 200.97 188.62 203.16 188.62 199.85 184.83 197.67 184.83 200.97"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 182.27 188.62 184.45 188.62 181.15 184.83 178.96 184.83 182.27"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 213.16 188.62 215.35 188.62 212.04 184.83 209.86 184.83 213.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 188.36 188.62 190.55 188.62 187.24 184.83 185.06 184.83 188.36"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 135.07 180.76 137.25 180.76 133.95 176.97 131.76 176.97 135.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 207.07 188.62 209.25 188.62 205.95 184.83 203.76 184.83 207.07"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 194.88 188.62 197.07 188.62 193.76 184.83 191.57 184.83 194.88"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 157.89 188.62 160.08 188.62 156.77 184.83 154.59 184.83 157.89"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 176.17 188.62 178.36 188.62 175.06 184.83 172.87 184.83 176.17"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 163.99 188.62 166.17 188.62 162.87 184.83 160.68 184.83 163.99"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 170.08 188.62 172.27 188.62 168.96 184.83 166.77 184.83 170.08"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 249.72 188.62 251.91 188.62 248.61 184.83 246.42 184.83 249.72"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 256.24 188.62 258.43 188.62 255.13 184.83 252.94 184.83 256.24"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 280.62 188.62 282.81 188.62 279.5 184.83 277.31 184.83 280.62"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 219.25 188.62 221.44 188.62 218.14 184.83 215.95 184.83 219.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 268.43 188.62 270.62 188.62 267.31 184.83 265.13 184.83 268.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 274.52 188.62 276.71 188.62 273.41 184.83 271.22 184.83 274.52"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 262.34 188.62 264.52 188.62 261.22 184.83 259.03 184.83 262.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 243.63 188.62 245.82 188.62 242.51 184.83 240.33 184.83 243.63"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 225.35 188.62 227.54 188.62 224.23 184.83 222.04 184.83 225.35"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 231.44 188.62 233.63 188.62 230.33 184.83 228.14 184.83 231.44"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="184.83 237.54 188.62 239.72 188.62 236.42 184.83 234.23 184.83 237.54"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 165.54 180.76 167.72 180.76 164.42 176.97 162.23 176.97 165.54"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 38.63 172.9 40.81 172.9 37.51 169.12 35.32 169.12 38.63"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 44.72 172.9 46.91 172.9 43.6 169.12 41.41 169.12 44.72"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 50.81 172.9 53 172.9 49.7 169.12 47.51 169.12 50.81"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 56.91 172.9 59.09 172.9 55.79 169.12 53.6 169.12 56.91"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 282.17 180.76 284.36 180.76 281.05 176.97 278.87 176.97 282.17"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 288.27 180.76 290.45 180.76 287.15 176.97 284.96 176.97 288.27"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 294.36 180.76 296.55 180.76 293.24 176.97 291.06 176.97 294.36"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 99.57 172.9 101.75 172.9 98.45 169.12 96.26 169.12 99.57"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 93.47 172.9 95.66 172.9 92.36 169.12 90.17 169.12 93.47"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 105.66 172.9 107.85 172.9 104.54 169.12 102.36 169.12 105.66"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 276.08 180.76 278.26 180.76 274.96 176.97 272.77 176.97 276.08"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 117.85 172.9 120.04 172.9 116.73 169.12 114.54 169.12 117.85"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 111.75 172.9 113.94 172.9 110.64 169.12 108.45 169.12 111.75"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 63 172.9 65.19 172.9 61.88 169.12 59.7 169.12 63"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 69.1 172.9 71.28 172.9 67.98 169.12 65.79 169.12 69.1"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 75.19 172.9 77.38 172.9 74.07 169.12 71.89 169.12 75.19"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 81.28 172.9 83.47 172.9 80.17 169.12 77.98 169.12 81.28"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 87.38 172.9 89.57 172.9 86.26 169.12 84.07 169.12 87.38"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 159.44 180.76 161.63 180.76 158.32 176.97 156.14 176.97 159.44"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 177.72 180.76 179.91 180.76 176.61 176.97 174.42 176.97 177.72"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 202.53 180.76 204.71 180.76 201.41 176.97 199.22 176.97 202.53"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 190.34 180.76 192.52 180.76 189.22 176.97 187.03 176.97 190.34"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 171.63 180.76 173.82 180.76 170.51 176.97 168.33 176.97 171.63"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 196.43 180.76 198.62 180.76 195.31 176.97 193.13 176.97 196.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 183.82 180.76 186.01 180.76 182.7 176.97 180.51 176.97 183.82"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 147.25 180.76 149.44 180.76 146.14 176.97 143.95 176.97 147.25"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="169.12 124.43 172.9 126.62 172.9 123.31 169.12 121.13 169.12 124.43"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 153.35 180.76 155.54 180.76 152.23 176.97 150.04 176.97 153.35"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 141.16 180.76 143.35 180.76 140.04 176.97 137.86 176.97 141.16"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 239.09 180.76 241.28 180.76 237.97 176.97 235.78 176.97 239.09"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 269.98 180.76 272.17 180.76 268.87 176.97 266.68 176.97 269.98"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 245.18 180.76 247.37 180.76 244.07 176.97 241.88 176.97 245.18"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 251.7 180.76 253.89 180.76 250.58 176.97 248.4 176.97 251.7"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 257.8 180.76 259.98 180.76 256.68 176.97 254.49 176.97 257.8"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 263.89 180.76 266.08 180.76 262.77 176.97 260.58 176.97 263.89"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 220.81 180.76 223 180.76 219.69 176.97 217.5 176.97 220.81"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 208.62 180.76 210.81 180.76 207.5 176.97 205.31 176.97 208.62"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 233 180.76 235.18 180.76 231.88 176.97 229.69 176.97 233"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 214.71 180.76 216.9 180.76 213.6 176.97 211.41 176.97 214.71"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="176.97 226.9 180.76 229.09 180.76 225.78 176.97 223.6 176.97 226.9"
        style="fill: #e6e6e6"
      ></polygon>
      <polygon
        points="53.72 98.09 26.96 82.61 13.57 90.34 40.34 105.79 53.72 98.09"
        style="fill: #fafafa"
      ></polygon>
      <polygon
        points="134.03 67.26 111.7 54.38 84.94 69.83 107.26 82.71 134.03 67.26"
        style="fill: #fafafa"
      ></polygon>
      <polygon
        points="84.95 91.83 84.95 107.27 71.57 99.55 84.95 91.83"
        style="fill: #fafafa"
      ></polygon>
      <polygon
        points="223.24 27.03 196.47 11.58 165.25 29.61 192.01 45.06 223.24 27.03"
        style="fill: #fafafa"
      ></polygon>
      <polygon
        points="397.22 76.45 357.07 53.27 339.23 63.57 379.38 86.75 397.22 76.45"
        style="fill: #fafafa"
      ></polygon>
      <polygon
        points="486.43 111.11 450.76 90.5 423.96 105.97 459.63 126.58 486.43 111.11"
        style="fill: #fafafa"
      ></polygon>
      <polygon
        points="285.7 105.39 267.85 95.09 245.54 107.97 263.38 118.27 285.7 105.39"
        style="fill: #fafafa"
      ></polygon>
      <polygon
        points="339.23 93.28 321.38 82.97 303.53 93.28 321.38 103.58 339.23 93.28"
        style="fill: #fafafa"
      ></polygon>
      <polygon
        points="165.24 96.48 165.24 111.92 151.86 104.2 165.24 96.48"
        style="fill: #fafafa"
      ></polygon>
      <polygon
        points="397.22 138.8 397.22 123.36 410.6 131.07 397.22 138.8"
        style="fill: #fafafa"
      ></polygon>
    </g>
  </g>
  <g id="freepik--Floor--inject-3">
    <path
      id="freepik--floor--inject-3"
      d="M77.66,237.82c-95.18,54.95-95.17,144.05,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,182.87,77.66,237.82Z"
      style="fill: #f5f5f5"
    ></path>
  </g>
  <g id="freepik--Clouds--inject-3">
    <path
      id="freepik--Cloud--inject-3"
      d="M322.69,31.91c0-3.24-3.55-5.49-7.57-5.87-4.73-.45-8.09,1.66-8.2,5.39-3.1-1.27-6.36-.45-6.12,3-.8-.93-3.82-.9-4.9-.64A4.21,4.21,0,0,0,293.21,36a3.12,3.12,0,0,0-.28,1.75c-1.81-.59-5.91-1-6.94.7-1.83,3,5.47,3,6.94,2.15.32,2.29,8.16,2.67,10.06.55,1.49,1.5,3.62,1.83,5.92,2,3.88.23,6.26-1.08,9.29-2.63,3.29,2.79,9,2.84,11.95-.35.76.72,2.84.94,4.51.54,1.1-.26,1.35-.73,1.35-.73a9.66,9.66,0,0,0,2,.6c2.16.45,6.16,0,4.48-2a5,5,0,0,0-3.55-.87c-.94-1.85-4.71-3.6-6.87-2-.09-2.24-2.13-4-5-4.43C326.11,31.12,323.79,31,322.69,31.91Z"
      style="fill: #f5f5f5"
    ></path>
    <path
      id="freepik--cloud--inject-3"
      d="M66.43,40.82c0-3.89-4.26-6.59-9.09-7-5.69-.54-9.72,2-9.86,6.48-2.65-2.14-7.64-.55-7.34,3.54-1-1.12-4.59-1.08-5.89-.77A5.1,5.1,0,0,0,31,45.78a3.74,3.74,0,0,0-.33,2.09c-2.17-.71-7.1-1.14-8.34.84-2.19,3.54,6.58,3.66,8.35,2.59.37,2.75,9.8,3.2,12.08.66a12.09,12.09,0,0,0,7.55,3.12C55,55.36,59.63,53.2,61,51.16c4,3.35,10.8,3.41,14.36-.42.91.85,3.41,1.12,5.42.64,1.32-.31,1.62-.88,1.62-.88a11.24,11.24,0,0,0,2.42.73c2.59.54,7.4,0,5.38-2.36-.69-.79-3.21-1.29-4.27-1-1.13-2.22-5.66-4.32-8.25-2.44-.1-2.69-2.56-4.79-6-5.33C70.53,39.88,67.75,39.72,66.43,40.82Z"
      style="fill: #f5f5f5"
    ></path>
    <path
      id="freepik--cloud--inject-3"
      d="M312.08,65.22a8.59,8.59,0,0,0-3-.55c-1-.08-1.26-.27-1.45-.48a7.08,7.08,0,0,0-8.51-2.51,5.43,5.43,0,0,0-6.42-3.63c.1-3-3.72-6.21-7.15-6.94s-6.16-.41-8,1.76c-2-3.93-9.9-5-14.17-3-2.45,1.19-4.53,2.42-5.55,4.67a9.35,9.35,0,0,0-.92,4.47c-1.66-1.47-5-1.86-7.21-1-2.4.92-2.58,2.73-2.7,4.56a8.4,8.4,0,0,0-4.36-.08c-1.51.45-2.37,1.63-2.17,2.59-1.19-.06-4,.9-3.71,2.16s3.62,1.27,4.83,1.23A22.66,22.66,0,0,0,245,68a5.25,5.25,0,0,0,1.77.34c2.07,0,2.94-.9,3.27-1.67,1,2.12,4.6,3.74,7.14,4.39,4.78,1.23,11.55.48,14.49-3.09a5.32,5.32,0,0,0,1.43,1.73,8.18,8.18,0,0,0,4.42,1.79c2,.19,7.23.44,8.71-2.68,1.06,2.07,5.75,3,9.31,2.51a14.84,14.84,0,0,0,4-1.2,23.93,23.93,0,0,0,2.29-1.38,1.9,1.9,0,0,1,2-.13,11.76,11.76,0,0,0,7.79,0C313.53,67.73,314,66.06,312.08,65.22Z"
      style="fill: #f5f5f5"
    ></path>
  </g>
  <g id="freepik--Sun--inject-3">
    <g id="freepik--sun--inject-3">
      <ellipse
        cx="427.15"
        cy="44.6"
        rx="17.57"
        ry="17.49"
        style="fill: #ffbda7"
      ></ellipse>
    </g>
  </g>
  <g id="freepik--Shadows--inject-3">
    <path
      id="freepik--Shadow--inject-3"
      d="M187.13,211.09,65.54,281c-17.16,9.87-15.12,27.06,4.56,38.41L264.7,431.48c98.4,57,262.66-61.34,184-105.45L244.93,208.19C225.25,196.84,204.29,201.23,187.13,211.09Z"
      style="fill: #e0e0e0"
    ></path>
    <path
      id="freepik--shadow--inject-3"
      d="M35,395.6c-3.12,0-6.27,0-9.37-.08s-5.91-1.08-7.41-2.8A4.78,4.78,0,0,1,17.07,389l2.4-19.3c.4-3.33,4.43-6.12,9.56-6.63,18.73-1.86,37.67-2.8,56.31-2.8,3.08,0,6.21,0,9.29.08s5.92,1.07,7.42,2.8a4.8,4.8,0,0,1,1.2,3.74l-2.4,19.3c-.43,3.35-4.46,6.13-9.6,6.63-18.9,1.86-37.81,2.81-56.22,2.81ZM93,382.42a2.28,2.28,0,0,0,.93-.23l1.45-11.59h-.26a2.32,2.32,0,0,0-.93.23l-1.45,11.59Z"
      style="fill: #e0e0e0"
    ></path>
    <path
      id="freepik--shadow--inject-3"
      d="M182.7,435.65l-7.42-1-2.06-2.09-2.21-.67-.07-.59-1.36-.25-1.53-1.48-4.43-1.19-2.54-2.62-3.59-.4-15.78-9.11a28.88,28.88,0,0,1-7,.81h0a31.89,31.89,0,0,1-15-3.6l-14.62-8c-3.08-1.68-4.93-4.09-5.07-6.61a6,6,0,0,1,2.87-5.33,91.84,91.84,0,0,1,13-7.56,16.14,16.14,0,0,1,7-1.44,19.44,19.44,0,0,1,9.92,2.6l13.81,8.45c4,2.43,6.37,5.6,6.74,8.92a8.12,8.12,0,0,1-1.14,5.07l14.56,8.4.67,2,4.36,1.41,2,2.55,2.63.92.54,1,1,0,1,1.07,3.79,1.24,1.91,4.8A1.94,1.94,0,0,1,182.7,435.65Zm-59.12-44.53a6.54,6.54,0,0,0-2.81.55c-2.17,1-4.22,2.11-6.09,3.19s-4,2.42-5.91,3.77c-.25.18-.33.32-.33.34,0,.19.36.75,1.36,1.3l.21.11a7.15,7.15,0,0,1,1.76-1.7,93.58,93.58,0,0,1,12.9-7.5A10,10,0,0,0,123.58,391.12Z"
      style="fill: #e0e0e0"
    ></path>
  </g>
  <g id="freepik--Characters--inject-3">
    <g id="freepik--Vehicle--inject-3">
      <path
        d="M368.77,219.71c8.12,8.57,20.17,23.93-2.23,11.49s-134-65.12-134-65.12V223.3l111.88,62.37s20.89-15.29,31.28-26.31,7.15-24.78,7.15-24.78Z"
      ></path>
      <path
        d="M377.32,227.12h0l1,4.21c2.32,4.35,7.47,9.85,9.31,9.4,1.65-.41,2.66-2.81,3.18-5.77v0a31,31,0,0,0,.43-4.3c.16-4.66-1.92-15.54-8.4-18.43a3.33,3.33,0,0,0-3.83.86,7.63,7.63,0,0,0-1.88,3.09C376.06,219.41,377.17,226.94,377.32,227.12Z"
        style="fill: #263238"
      ></path>
      <path
        d="M378.33,231.33c2.32,4.35,7.47,9.85,9.31,9.4,1.65-.41,2.66-2.81,3.18-5.77v0a31,31,0,0,0,.43-4.3c.16-4.66-1.92-15.54-8.4-18.43a3.33,3.33,0,0,0-3.83.86l.88,2c4.53,1.93,5.75,8.92,5.33,14.24S380.92,234.07,378.33,231.33Z"
        style="fill: #455a64"
      ></path>
      <path
        d="M377.15,216.14c1.64-1.73,5.7-1.82,9.12,2.88s4.54,12.77,4.56,15.9a31.15,31.15,0,0,0,.43-4.3c.16-4.66-1.92-15.54-8.39-18.44C380.16,211,377.93,213.74,377.15,216.14Z"
        style="fill: #37474f"
      ></path>
      <path
        d="M117.3,203l103.75-59.9h0a24.12,24.12,0,0,1,12,19.23l2.82,32.11-103.76,59.9-14.82-8.55Z"
        style="fill: #37474f"
      ></path>
      <path
        d="M117.3,215.33l112.08-64.19a24,24,0,0,0-8.33-8L117.3,203Z"
        style="fill: #455a64"
      ></path>
      <path
        d="M117.3,245.82V203h0a24.14,24.14,0,0,1,12,19.23l2.81,32.11Z"
        style="fill: #263238"
      ></path>
      <polygon
        points="129.3 222.25 132.12 254.38 156.72 268.57 238.25 221.51 233.06 162.36 129.3 222.25"
        style="fill: #37474f"
      ></polygon>
      <polygon
        points="235.53 219.95 341.5 281.13 259.98 328.2 154 267.01 235.53 219.95"
      ></polygon>
      <g id="freepik--codriver-seat--inject-3">
        <path
          d="M275.3,269.56l11.8-.24,18-10.28a13.45,13.45,0,0,1,10.88-.53l21.78,9.82,14.92-.29v8.71h0c0,1-.69,2-2.1,2.8l-39.09,22.57a9.56,9.56,0,0,1-10.05-.8l-24.28-19.71a4.32,4.32,0,0,1-1.78-3.34l0,0Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M350.53,270.84l-39.09,22.57a9.56,9.56,0,0,1-10.05-.8l-24.28-19.7c-2.62-2.13-2.37-5.22.56-6.9l27.39-15.69a13.49,13.49,0,0,1,10.88-.53l34.31,15.48C353.33,266.66,353.45,269.15,350.53,270.84Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M275.29,269.57v8.69l0,0a4.28,4.28,0,0,0,1.79,3.33l24.27,19.71a8.9,8.9,0,0,0,4.75,1.81v-8.71a8.9,8.9,0,0,1-4.75-1.81L277.12,272.9A4.34,4.34,0,0,1,275.29,269.57Z"
          style="fill: #263238"
        ></path>
        <path
          d="M271.53,267a2.17,2.17,0,0,0,.83,2.07l9.95,5.75h0a2.09,2.09,0,0,1-.85-2.07l2.16-48.64a7.45,7.45,0,0,1,3.34-5.5L310.42,205a2.48,2.48,0,0,1,2.47-.2h0l-9.88-5.7h0a2.5,2.5,0,0,0-2.53.16L277,212.84a7.42,7.42,0,0,0-3.34,5.5Z"
          style="fill: #263238"
        ></path>
        <path
          d="M310.42,205,287,218.57a7.49,7.49,0,0,0-3.34,5.5l-2.16,48.66c-.09,2,1.26,2.84,3,1.83l33.39-19.28a5.84,5.84,0,0,0,2.64-5.47l-6.38-43A2.32,2.32,0,0,0,310.42,205Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M274.72,215.22l9.93,5.74a6.94,6.94,0,0,1,2.31-2.38L310.42,205a2.48,2.48,0,0,1,2.47-.2h0l-9.88-5.7h0a2.5,2.5,0,0,0-2.53.16L277,212.84A6.94,6.94,0,0,0,274.72,215.22Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M278.82,208.15V196c0-8.71,5.56-19,12.42-22.94,3.14-1.82,6-2,8.2-.79v0l7.57,4.4-3.36,6.43v10.69a7,7,0,0,1-3.18,5.5l-7.56,4.37-5.69,10.88-7.48-4.35h0A2.23,2.23,0,0,1,278.82,208.15Z"
          style="fill: #263238"
        ></path>
        <path
          d="M291.24,190.34l-9.74-5.62c2.27-5,5.79-9.34,9.74-11.62,3.14-1.82,6-2,8.2-.79v0l7.57,4.4-3.36,6.43v2.1Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M286.27,212.49V200.38c0-8.71,5.56-19,12.42-22.95s12.42-.11,12.42,8.61v12.1a7,7,0,0,1-3.18,5.51l-18.48,10.67C287.69,215.33,286.27,214.51,286.27,212.49Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M309.71,215.34a120.39,120.39,0,0,1,4.11,32.93,8.57,8.57,0,0,1-3,5.92A94,94,0,0,1,292.14,265a2.41,2.41,0,0,1-3.57-2.26,338.74,338.74,0,0,1-.11-35.71,9.13,9.13,0,0,1,3.2-5.89,73.76,73.76,0,0,1,13.64-7.88A3.17,3.17,0,0,1,309.71,215.34Z"
          style="fill: #263238"
        ></path>
        <path
          d="M288.83,263.81a3.23,3.23,0,0,1-.26-1.12,338.74,338.74,0,0,1-.11-35.71,8.43,8.43,0,0,1,1-3.23c1.3-1.85,1.75,13.73,1.75,23.22s-.13,18.89-1.69,17.79a.8.8,0,0,1-.17-.15A4.49,4.49,0,0,1,288.83,263.81Z"
          style="opacity: 0.15"
        ></path>
        <g style="opacity: 0.15">
          <path
            d="M311.64,247.47s-.28.16-.76.48-1.15.75-2,1.28c-1.62,1.05-3.79,2.42-6,3.68s-4.48,2.46-6.21,3.32c-.87.43-1.58.82-2.1,1.06s-.8.41-.8.41.33-.06.88-.19,1.35-.32,2.28-.63a32.57,32.57,0,0,0,3.13-1.18c.56-.26,1.14-.5,1.71-.81s1.15-.6,1.72-.92a36.42,36.42,0,0,0,3.22-2.09,30.21,30.21,0,0,0,2.6-2.1c.74-.64,1.3-1.25,1.7-1.65S311.64,247.47,311.64,247.47Z"
          ></path>
          <path
            d="M311.64,241.32l-.76.48c-.46.33-1.15.75-2,1.28-1.62,1.06-3.79,2.42-6,3.69s-4.48,2.45-6.21,3.31c-.87.43-1.58.82-2.1,1.06s-.8.41-.8.41.33-.06.88-.19,1.35-.32,2.28-.63a30.1,30.1,0,0,0,3.13-1.18c.56-.26,1.14-.5,1.71-.81s1.15-.6,1.72-.91c1.13-.67,2.23-1.37,3.22-2.09a32.2,32.2,0,0,0,2.6-2.11c.74-.64,1.3-1.25,1.7-1.65S311.64,241.32,311.64,241.32Z"
          ></path>
          <path
            d="M310.37,236.23s-.26.15-.7.44-1.08.68-1.82,1.17c-1.5,1-3.5,2.2-5.57,3.31s-4.19,2.13-5.8,2.91l-1.94,1c-.47.23-.74.38-.74.38l.82-.16c.51-.12,1.25-.27,2.11-.53a30.63,30.63,0,0,0,2.92-1c.52-.23,1.07-.43,1.6-.7s1.08-.52,1.61-.8,1.05-.6,1.56-.91,1-.66,1.45-1a25.41,25.41,0,0,0,2.4-2c.67-.6,1.19-1.16,1.55-1.54S310.37,236.23,310.37,236.23Z"
          ></path>
          <path
            d="M309.86,230.5s-.26.14-.68.42-1.05.65-1.77,1.12C306,233,304,234.15,302,235.2s-4.08,2-5.64,2.75l-1.88.93-.71.37s.29,0,.79-.15,1.21-.25,2.05-.49,1.81-.53,2.83-.92c.5-.21,1-.4,1.55-.65s1.05-.49,1.58-.76,1-.57,1.51-.87.95-.63,1.41-.94a23.48,23.48,0,0,0,2.32-1.88c.65-.58,1.14-1.13,1.49-1.49Z"
          ></path>
          <path
            d="M309,225l-.65.39-1.66,1a56,56,0,0,1-5.08,2.93c-1.89,1-3.87,1.8-5.35,2.49s-2.44,1.22-2.44,1.22a25.61,25.61,0,0,0,2.68-.56,28.89,28.89,0,0,0,5.66-2.06c.49-.26,1-.52,1.44-.8s.91-.59,1.34-.88A21.81,21.81,0,0,0,307.1,227,18.06,18.06,0,0,0,309,225Z"
          ></path>
          <path
            d="M307,219.76s-.85.48-2,1.23-2.78,1.7-4.43,2.54-3.32,1.66-4.59,2.3-2.1,1.12-2.1,1.12a17.39,17.39,0,0,0,2.35-.46,24.92,24.92,0,0,0,4.91-1.87c.42-.24.84-.47,1.25-.72s.78-.52,1.15-.78a16.06,16.06,0,0,0,1.89-1.58A15.66,15.66,0,0,0,307,219.76Z"
          ></path>
        </g>
        <path
          d="M319.72,259.59c6.16,1.1,12.26,4.25,18.31,8.79a2.71,2.71,0,0,1,0,4.53,121.23,121.23,0,0,1-23.54,13.51,8.73,8.73,0,0,1-6.66-.18,58.31,58.31,0,0,1-14.07-10,3.13,3.13,0,0,1,.44-4.85,99.14,99.14,0,0,1,18.47-10.83A14.7,14.7,0,0,1,319.72,259.59Z"
          style="fill: #263238"
        ></path>
        <g style="opacity: 0.2">
          <path
            d="M334.74,270.65s-.39.1-1.05.31-1.61.5-2.72.93a58.59,58.59,0,0,0-7.91,3.7,53.23,53.23,0,0,0-7.22,4.91,38,38,0,0,0-2.95,2.66l3.36-2.09c2-1.25,4.69-2.87,7.42-4.41s5.49-3,7.58-4.13l2.53-1.35Z"
          ></path>
          <path
            d="M328.86,267.27s-.38.1-1.05.31-1.61.5-2.72.93a57.32,57.32,0,0,0-7.9,3.7,52.61,52.61,0,0,0-7.22,4.91,37,37,0,0,0-3,2.65l3.35-2.08c2-1.25,4.69-2.88,7.42-4.42s5.5-3,7.59-4.12l2.53-1.35C328.52,267.47,328.86,267.27,328.86,267.27Z"
          ></path>
          <path
            d="M323.81,264.4s-.38.1-1,.31-1.62.5-2.73.93a58.52,58.52,0,0,0-7.9,3.7,52.61,52.61,0,0,0-7.22,4.91A37,37,0,0,0,302,276.9l3.35-2.08c2-1.25,4.69-2.87,7.42-4.41s5.5-3,7.59-4.13l2.53-1.35C323.47,264.6,323.81,264.4,323.81,264.4Z"
          ></path>
          <path
            d="M318.31,262.05s-.36.09-1,.27-1.48.45-2.5.84a51,51,0,0,0-7.27,3.38,47.26,47.26,0,0,0-6.62,4.52,35.15,35.15,0,0,0-2.69,2.46s.32-.18.86-.52l2.24-1.37c1.85-1.13,4.31-2.62,6.82-4s5-2.78,6.95-3.8l2.3-1.26C318,262.24,318.31,262.05,318.31,262.05Z"
          ></path>
        </g>
      </g>
      <g id="freepik--codriver-seat--inject-3">
        <path
          d="M221.4,301.16l11.81-.23,18-10.29a13.48,13.48,0,0,1,10.88-.53l21.77,9.83,14.92-.3v8.71h0c0,1-.69,2-2.11,2.8l-39.09,22.57a9.54,9.54,0,0,1-10-.8l-24.28-19.71a4.3,4.3,0,0,1-1.79-3.33l0,0Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M296.63,302.45,257.54,325a9.54,9.54,0,0,1-10-.79l-24.28-19.71c-2.63-2.13-2.38-5.22.55-6.9l27.4-15.69a13.44,13.44,0,0,1,10.88-.52l34.3,15.47C299.43,298.26,299.55,300.76,296.63,302.45Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M221.4,301.17v8.69l0,0a4.3,4.3,0,0,0,1.79,3.34l24.28,19.7a8.87,8.87,0,0,0,4.74,1.81V326a8.87,8.87,0,0,1-4.74-1.81l-24.28-19.71A4.34,4.34,0,0,1,221.4,301.17Z"
          style="fill: #263238"
        ></path>
        <path
          d="M217.63,298.59a2.16,2.16,0,0,0,.83,2.06l10,5.75h0a2.07,2.07,0,0,1-.86-2.07l2.16-48.64a7.45,7.45,0,0,1,3.34-5.5l23.46-13.54a2.5,2.5,0,0,1,2.47-.2h0l-9.88-5.7h0a2.53,2.53,0,0,0-2.53.16l-23.45,13.54a7.46,7.46,0,0,0-3.34,5.51Z"
          style="fill: #263238"
        ></path>
        <path
          d="M256.52,236.64l-23.46,13.54a7.45,7.45,0,0,0-3.34,5.5l-2.16,48.65c-.09,2,1.26,2.84,3,1.83L264,286.88a5.81,5.81,0,0,0,2.64-5.46l-6.38-43A2.32,2.32,0,0,0,256.52,236.64Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M220.82,246.83l9.93,5.73a6.94,6.94,0,0,1,2.31-2.38l23.46-13.54a2.5,2.5,0,0,1,2.47-.2h0l-9.88-5.7h0a2.53,2.53,0,0,0-2.53.16l-23.45,13.54A7,7,0,0,0,220.82,246.83Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M224.92,239.75v-12.1c0-8.72,5.56-19,12.42-23,3.15-1.82,6-2,8.2-.79h0l7.57,4.4-3.36,6.43v10.68a7,7,0,0,1-3.18,5.5L239,235.28l-5.68,10.89-7.49-4.36h0A2.23,2.23,0,0,1,224.92,239.75Z"
          style="fill: #263238"
        ></path>
        <path
          d="M237.34,221.94l-9.74-5.62c2.28-5,5.79-9.34,9.74-11.62,3.15-1.82,6-2,8.2-.79h0l7.57,4.4-3.36,6.43v2.1Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M232.37,244.09V232c0-8.71,5.56-19,12.42-22.95s12.42-.1,12.42,8.61v12.11a7,7,0,0,1-3.18,5.5l-18.48,10.67C233.79,246.94,232.37,246.12,232.37,244.09Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M255.81,246.94a120,120,0,0,1,4.11,32.93,8.49,8.49,0,0,1-3,5.92,94,94,0,0,1-18.69,10.76,2.4,2.4,0,0,1-3.56-2.26,335.87,335.87,0,0,1-.11-35.7,9,9,0,0,1,3.2-5.89,72.33,72.33,0,0,1,13.64-7.88A3.17,3.17,0,0,1,255.81,246.94Z"
          style="fill: #263238"
        ></path>
        <path
          d="M234.93,295.41a3.23,3.23,0,0,1-.25-1.12,335.87,335.87,0,0,1-.11-35.7,8.28,8.28,0,0,1,1-3.24c1.3-1.85,1.76,13.73,1.75,23.23s-.13,18.88-1.68,17.79l-.18-.15A5.81,5.81,0,0,1,234.93,295.41Z"
          style="opacity: 0.15"
        ></path>
        <g style="opacity: 0.15">
          <path
            d="M257.74,279.07l-.75.48c-.47.33-1.16.75-2,1.28-1.62,1.06-3.78,2.42-6,3.69s-4.49,2.45-6.22,3.32c-.87.43-1.58.81-2.1,1.05l-.79.41.88-.19c.55-.14,1.35-.32,2.28-.62a31.12,31.12,0,0,0,3.12-1.19c.56-.26,1.15-.5,1.71-.8s1.15-.61,1.72-.92c1.13-.67,2.24-1.37,3.22-2.09a32.08,32.08,0,0,0,2.61-2.11c.73-.64,1.29-1.24,1.69-1.65S257.74,279.07,257.74,279.07Z"
          ></path>
          <path
            d="M257.74,272.92l-.75.48c-.47.33-1.16.75-2,1.28-1.62,1.06-3.78,2.42-6,3.69s-4.49,2.45-6.22,3.32c-.87.43-1.58.81-2.1,1.05l-.79.41s.32,0,.88-.18,1.35-.32,2.28-.63a31.12,31.12,0,0,0,3.12-1.19c.56-.26,1.15-.5,1.71-.8s1.15-.61,1.72-.92c1.13-.67,2.24-1.37,3.22-2.09s1.88-1.44,2.61-2.1,1.29-1.25,1.69-1.65S257.74,272.92,257.74,272.92Z"
          ></path>
          <path
            d="M256.47,267.84l-.7.43c-.43.3-1.08.68-1.82,1.17-1.5,1-3.5,2.2-5.57,3.31s-4.19,2.13-5.8,2.91l-1.94,1c-.47.23-.73.38-.73.38s.3,0,.81-.16,1.25-.27,2.11-.52,1.87-.59,2.92-1c.52-.22,1.07-.43,1.6-.69s1.08-.53,1.62-.81,1.05-.59,1.55-.91,1-.66,1.45-1a25.41,25.41,0,0,0,2.4-1.95c.68-.6,1.19-1.16,1.55-1.54S256.47,267.84,256.47,267.84Z"
          ></path>
          <path
            d="M256,262.1s-.26.14-.68.42-1,.65-1.76,1.12c-1.45.93-3.38,2.12-5.39,3.16s-4.08,2-5.63,2.76l-1.88.92-.71.37s.29,0,.78-.14,1.21-.26,2.05-.5a27.77,27.77,0,0,0,2.83-.92c.51-.21,1-.4,1.56-.65s1.05-.49,1.57-.75,1-.57,1.51-.88,1-.63,1.41-.93a23.48,23.48,0,0,0,2.32-1.89c.65-.58,1.14-1.12,1.49-1.49S256,262.1,256,262.1Z"
          ></path>
          <path
            d="M255.08,256.63l-.64.39-1.67,1.05a54.72,54.72,0,0,1-5.08,2.92c-1.89,1-3.87,1.8-5.34,2.49s-2.44,1.23-2.44,1.23,1.09-.16,2.67-.57a28.66,28.66,0,0,0,5.66-2.06c.49-.26,1-.52,1.44-.8s.91-.59,1.34-.88a20.5,20.5,0,0,0,2.18-1.78A18.06,18.06,0,0,0,255.08,256.63Z"
          ></path>
          <path
            d="M253.05,251.36s-.84.48-2,1.23-2.78,1.7-4.42,2.55-3.33,1.65-4.6,2.29-2.09,1.13-2.09,1.13a18.73,18.73,0,0,0,2.34-.47,23.51,23.51,0,0,0,4.91-1.87c.42-.23.84-.47,1.25-.72a12.11,12.11,0,0,0,1.15-.77,17.1,17.1,0,0,0,1.89-1.59A14.52,14.52,0,0,0,253.05,251.36Z"
          ></path>
        </g>
        <path
          d="M265.82,291.19c6.17,1.11,12.26,4.25,18.32,8.8a2.7,2.7,0,0,1,0,4.52A120.72,120.72,0,0,1,260.58,318a8.73,8.73,0,0,1-6.66-.18,58.43,58.43,0,0,1-14.07-10,3.14,3.14,0,0,1,.44-4.85,99.76,99.76,0,0,1,18.48-10.83A14.91,14.91,0,0,1,265.82,291.19Z"
          style="fill: #263238"
        ></path>
        <g style="opacity: 0.2">
          <path
            d="M280.84,302.26s-.39.1-1,.3-1.61.51-2.72.93a56.94,56.94,0,0,0-7.9,3.71,53.7,53.7,0,0,0-7.23,4.9c-1.84,1.52-2.95,2.66-2.95,2.66l3.36-2.09c2-1.25,4.69-2.87,7.42-4.41s5.5-3,7.59-4.13l2.52-1.35C280.5,302.46,280.84,302.26,280.84,302.26Z"
          ></path>
          <path
            d="M275,298.87l-1.05.31c-.66.21-1.61.5-2.72.93a58,58,0,0,0-7.91,3.7,53.23,53.23,0,0,0-7.22,4.91,38,38,0,0,0-2.95,2.66l3.36-2.09c2-1.25,4.68-2.87,7.42-4.41s5.49-3,7.58-4.13L274,299.4Z"
          ></path>
          <path
            d="M269.92,296l-1.05.31c-.66.22-1.61.51-2.72.93a57,57,0,0,0-7.91,3.71,53.25,53.25,0,0,0-7.22,4.9c-1.84,1.52-3,2.66-3,2.66l3.36-2.09c2-1.25,4.69-2.87,7.42-4.41s5.49-3,7.58-4.13l2.53-1.35C269.57,296.21,269.92,296,269.92,296Z"
          ></path>
          <path
            d="M264.41,293.65l-1,.27c-.61.2-1.49.46-2.51.84a50.89,50.89,0,0,0-7.26,3.38,47.26,47.26,0,0,0-6.62,4.52c-1.69,1.41-2.7,2.46-2.7,2.46l.86-.51,2.24-1.37c1.85-1.14,4.31-2.62,6.82-4s5-2.79,7-3.81l2.31-1.26C264.1,293.84,264.41,293.65,264.41,293.65Z"
          ></path>
        </g>
      </g>
      <g id="freepik--Character--inject-3">
        <g id="freepik--Bottom--inject-3">
          <path
            d="M331.57,251.74c5.28,3.22,9.41,5.95,16.24,10.54,7.42,5,13.56,9.16,15.85,13.55,2,3.91,2,9.18-.53,15.57s-15.7,28.37-15.7,28.37l-8.77-8.38s2.46-14.25,4.11-18.18a10.8,10.8,0,0,1,2.51-4.07L321.37,280l-5.51-12.76C317.14,260.28,324.73,253.66,331.57,251.74Z"
            style="fill: #263238"
          ></path>
          <path
            d="M291.62,258.4a99.31,99.31,0,0,0,.73,14c.84,5.08,2.14,9.78,10.2,15.62,7.73,5.61,27.55,14.18,28.45,15.84.52,6.48,1.69,9.93,3.65,13.8,3.65,7.19,7.88,15.56,7.88,15.56,4.68.79,10.63-.67,13.17-3,0,0-2.14-11.47-3.79-19.12-2.82-13.1-3.05-19.43-5.83-22.55s-18-15.61-18-15.61,2.54-1.52,4.18-10.32c.78-4.22,0-11.05,0-11.05S306,261.62,291.62,258.4Z"
            style="fill: #263238"
          ></path>
        </g>
        <g id="freepik--Top--inject-3">
          <path
            d="M319.13,208.77c5.42.87,7.84,3.93,13.5,12.19,5.8,8.47,7.05,10.47,7.05,10.47l20.54,5.4-1.29,8.06s-12.28-.1-16.9-.32-7.68.32-11.28-4.13c-3.41-4.2-10.2-13.49-10.2-13.49Z"
            style="fill: #4567b4"
          ></path>
          <g id="freepik--Chest--inject-3">
            <path
              d="M308.42,208.77c-4.6.34-11.69,4.08-16.82,6.89-3.45,2.72-3.37,12.24-2.74,19.47,1.07,12.09,1.09,14.68,2.13,25.92.57,6.73.74,8.52.74,8.52,13.92,2.24,33.59-2.71,40.49-18,0,0-2.74-7.28-4.89-28.18-1.09-10.65-5.88-13.27-8.2-14.6C316.25,208.08,311.94,208.51,308.42,208.77Z"
              style="fill: #fafafa"
            ></path>
          </g>
          <g id="freepik--Head--inject-3">
            <path
              d="M300.64,205.29c-.45-3-3.36-6.15-4.65-8.77s-2-4.49-1.79-6.84c.11-1.4,1-3.27,2.07-3.65a6.49,6.49,0,0,1,4.9-8,22.12,22.12,0,0,0,2.88-.74c1.13-.45,1.4-1.35,2.32-2.11,1.48-1.21,4.28-1.33,5.11.74a5.56,5.56,0,0,1,3.57-1,3.77,3.77,0,0,1,2.28.85,2.27,2.27,0,0,1,.75,2.23,4.46,4.46,0,0,1,4.36,1.57,3.89,3.89,0,0,1,.11,4.55,3,3,0,0,1-1.8,5.3c.3,0-.35,1.93-.45,2.08a4.34,4.34,0,0,1-1.76,1.53,30.8,30.8,0,0,1-7,1.75l-2.83.53c-.16,0-1,.07-1.12.21Z"
              style="fill: #263238"
            ></path>
            <path
              d="M297.1,201.37a2.89,2.89,0,0,0,3.52,0l-.12,10.5c2.39,3.68,7.85,4.17,10.71,3.5,3.7-.87,2.92-3.71,1.23-5.22l.11-1.71a23.9,23.9,0,0,0,3.12-.11c2.35-.28,4.66-2.7,5.27-4.65a24.79,24.79,0,0,0,.47-10,9.21,9.21,0,0,1-.09-2.46,11.45,11.45,0,0,0-.63-5.28c-2.53-2.11-9.26-2.72-14.87.55.58,3.31.05,5.7-2.37,6.92.09.89.16,3.14-1.3,3.07-1.06,0-1.1-1.37-2.16-2.56s-3.59-1.54-4.6.16A5.7,5.7,0,0,0,297.1,201.37Z"
              style="fill: #b16668"
            ></path>
            <path
              d="M312.55,208.4c-3.7-.51-6.51-1-8.39-3.68a16.27,16.27,0,0,1-1.86-4.28,13.86,13.86,0,0,0,1.19,5.38c.9,1.73,3.21,3.2,9,3.81Z"
              style="fill: #9a4a4d"
            ></path>
            <path
              d="M311.51,193.84a1.12,1.12,0,0,1-1.13,1.1,1.14,1.14,0,1,1,1.13-1.1Z"
              style="fill: #263238"
            ></path>
            <path
              d="M310.58,190.48l-2.22,1.25a1.33,1.33,0,0,1,.5-1.78A1.25,1.25,0,0,1,310.58,190.48Z"
              style="fill: #263238"
            ></path>
            <path
              d="M319.78,191l-2.38-1a1.22,1.22,0,0,1,1.63-.74A1.35,1.35,0,0,1,319.78,191Z"
              style="fill: #263238"
            ></path>
            <path
              d="M319.72,193.51a1.12,1.12,0,0,1-1.13,1.1,1.13,1.13,0,0,1-1.06-1.18,1.1,1.1,0,1,1,2.19.08Z"
              style="fill: #263238"
            ></path>
            <path
              d="M318.75,198.2l-3.66,1.53-1-7.13C315.47,192.14,317.14,195.45,318.75,198.2Z"
              style="fill: #9a4a4d"
            ></path>
            <path
              d="M310.47,200.62l4.34,1a2.2,2.2,0,0,1-2.64,1.74A2.33,2.33,0,0,1,310.47,200.62Z"
              style="fill: #9a4a4d"
            ></path>
            <path
              d="M311,201.35a2.45,2.45,0,0,0-.54,0,2.31,2.31,0,0,0,1.73,2,2,2,0,0,0,.72,0A2,2,0,0,0,311,201.35Z"
              style="fill: #ffa8a7"
            ></path>
          </g>
        </g>
        <path
          d="M280.16,277.68c-1-3.49-1.93-3.29,1.31-4.93,4.3-2.18,8.75-4.32,9.5-3.34s2.16,5.24,2.48,7-6.18,3.25-9,3.75C280.5,280.93,280.75,279.83,280.16,277.68Z"
          style="fill: #4567b4"
        ></path>
        <path
          d="M318.31,208.4c2.3,11.28,4,46.63-29,62.25l2.33,5.79s20.5-3.3,31.56-9.71,12-14.15,12-14.15l-2.93-3s-4.05,13.38-33,20.45c15.74-9.09,29.17-31.88,23.14-61Z"
        ></path>
        <g id="freepik--arm-with-steering-wheel--inject-3">
          <path
            d="M364.9,243.81c-.55-4.07-2.39-7.18-5.34-8.88a9.9,9.9,0,0,0-5-1.33,15.63,15.63,0,0,0-7.74,2.33c-8.78,5.07-15.66,17-15.66,27.13v.16l5.54-3.17a25.64,25.64,0,0,1,1.31-4.94c.33-.85.68-1.7,1.1-2.54,2.38-5,6.18-9.63,10.36-12a10.23,10.23,0,0,1,5.09-1.6,4.85,4.85,0,0,1,2.38.58,4.52,4.52,0,0,1,1,.84,6.3,6.3,0,0,1,1.35,2.53,12.12,12.12,0,0,1,.49,3.63v.25Z"
            style="fill: #455a64"
          ></path>
          <path
            d="M353,250.66l-8.74,5-1,.61a5.67,5.67,0,0,1,.15-.69,11.26,11.26,0,0,1,1-2.57,10.35,10.35,0,0,1,3.76-4.13,3.74,3.74,0,0,1,3.31-.46A2.89,2.89,0,0,1,353,250.66Z"
            style="fill: #455a64"
          ></path>
          <path
            d="M361.54,240.08l-2.25,2.8-6.2,7.72-.08.11a.09.09,0,0,0,0-.05l-8.74,5-.89-.08-5.39-.49-2.4-.21.23-2.63,3.27.3,5.28.46,3.16.28,3.91-4.87,6.51-8.09,1.55-1.92Z"
            style="fill: #455a64"
          ></path>
        </g>
        <path
          d="M363.46,239.07c.6,1.35.73,2-.51,3.34a7.49,7.49,0,0,1-3.34,1.81l-.32-1.34s-1.55,1.2-1.65,2.06c-.07.62.35,1,.27,1.37a2.59,2.59,0,0,0-.18,1.21l10.17-5.3s-.56-1.73-.94-2.6-2.14-3.11-3.21-3.47a5.81,5.81,0,0,0-2.56,0A10.48,10.48,0,0,1,363.46,239.07Z"
          style="fill: #9a4a4d"
        ></path>
        <path
          d="M320,256.29a10.1,10.1,0,0,0,4.58.34c1.2-.22,3.83-2.16,5.55-2.56s2.86-.69,2.86-.69l-.91,2.91a5.07,5.07,0,0,0,2.51.81c1.83.23,3.26-1.57,3.26-1.57l.62-1.58s.58.57,1.21,1.15a3.8,3.8,0,0,1,.8,1.94s-11.26,5.82-17.67,9.69c-1.75,0-3.55-.52-5-.64Z"
          style="fill: #b16668"
        ></path>
        <path
          d="M291.6,215.66c-7.71,4.54-7.87,8.41-6.9,18.45,1,10.6,2.73,20.83,3.75,23.73.52,1.45.59,3.67,5.45,4.61,6.87,1.32,24.2,4.09,24.2,4.09,2.82-2.33,3.7-6.65,2.52-10.52l-19.38-6.18-2-16.38S298.26,218.49,291.6,215.66Z"
          style="fill: #4567b4"
        ></path>
      </g>
      <g id="freepik--character--inject-3">
        <g id="freepik--bottom--inject-3">
          <path
            d="M303.35,303.75c-2.36-2.7-3.92-3.7-13.64-9.17-8.92-5-19.49-9.44-19.49-9.44l-9.27,13,10.75,8.19,15.8,7.6a20,20,0,0,0-3.2,6.35c-.38,1.25-3.55,15-3.55,15l8.69,8.1s9.05-18.18,12.92-27C306,308.22,304.23,304.76,303.35,303.75Z"
            style="fill: #ffa8a7"
          ></path>
          <path
            d="M272.89,279.61c2.68,2,5.56,3.48,12.59,7.75,6.32,3.84,16.61,10.34,18.91,14.72,2.05,3.92,1.53,7.76-1,14.15s-14.38,28.58-14.38,28.58l-8.77-8.38s2.46-14.25,4.11-18.18a10.8,10.8,0,0,1,2.51-4.07L263,305.08l-5.51-12.76C258.76,285.32,266.05,281.53,272.89,279.61Z"
            style="fill: #37474f"
          ></path>
          <path
            d="M289.05,344.81l-8.77-8.38s2.46-14.25,4.11-18.18a15.87,15.87,0,0,1,1.55-2.93c2.14,2.49,3.39,3.87,4.84,10.29.67,2.9,1.51,7.52,2.23,11.71C290.76,341.63,289.05,344.81,289.05,344.81Z"
            style="fill: #263238"
          ></path>
          <path
            d="M270.16,289.42c.56,5.3.58,9.35.58,9.35l13.94,14.57L263,305.08Z"
            style="fill: #263238"
          ></path>
          <path
            d="M283,291.77c3,1.62,10,7.12,11.56,8.43a35.6,35.6,0,0,1,4.63,4.39,9.9,9.9,0,0,1,1.35,2,3.67,3.67,0,0,1,.32,1.06,7.79,7.79,0,0,1,0,1.18,26.88,26.88,0,0,1-1.1,4.89c-.49,1.62-1.06,3.23-1.64,4.83-1.18,3.2-2.43,6.38-3.71,9.56a89.79,89.79,0,0,0,4.51-9.25c.67-1.58,1.27-3.19,1.82-4.83a25.34,25.34,0,0,0,1.18-5.11,8,8,0,0,0,0-1.38,4.17,4.17,0,0,0-.42-1.39,9.52,9.52,0,0,0-1.55-2.21,35.48,35.48,0,0,0-4.76-4.37C292.39,297.34,286.18,293,283,291.77Z"
            style="fill: #263238"
          ></path>
          <path
            d="M235.61,284a34.15,34.15,0,0,0-1.7,12.48c.43,4.67.86,9.95,10.26,16.57,7.81,5.5,27.55,14.18,28.44,15.84.53,6.48,1.7,9.93,3.66,13.81l7.88,15.55c4.68.79,8.9-.27,11.44-2.64,0,0-2.42-11.87-4.07-19.52-2.82-13.1-3.36-17.2-6.14-20.32s-3.74-4.1-3.74-4.1l-12.77-12.38a43.78,43.78,0,0,0,1.29-9.9,37.8,37.8,0,0,0-1.44-9.84S250,287.24,235.61,284Z"
            style="fill: #37474f"
          ></path>
          <path
            d="M243.57,300l-.11-.23c-2.85-3.77-2.39-7.61-1.79-12.63.1-.84.2-1.73.3-2.64a4.52,4.52,0,0,0,.53.06c-.09.92-.2,1.8-.3,2.65-.57,4.8-1,8.49,1.57,12.05,3.5-2.16,2.32-8,1.59-11.61q-.18-.88-.3-1.56l.53-.09c.07.44.18,1,.3,1.55.75,3.7,2,9.79-1.79,12.16a14.37,14.37,0,0,0,1.58,1.69c3.13,2.87,10.94,8.83,17.83,14.1,5.44,4.16,10.14,7.75,11.2,8.8,1.33,1.32,2.33,5.54,3.6,10.88,1,4.37,8.65,20.48,10.49,23.1l-.65,0c-1.93-2.79-9.32-18.61-10.36-23-1.2-5-2.23-9.4-3.46-10.62-1-1-5.72-4.61-11.15-8.76-6.89-5.27-14.71-11.24-17.86-14.12a15.66,15.66,0,0,1-1.7-1.82Z"
            style="fill: #263238"
          ></path>
          <path
            d="M251.56,287.18a17.72,17.72,0,0,0,.59,5.12,26.29,26.29,0,0,0,1.78,4.87,27,27,0,0,0,2.69,4.43,22.88,22.88,0,0,0,3.51,3.78c-1-1.41-1.93-2.81-2.81-4.25a48.69,48.69,0,0,1-2.42-4.42,41.15,41.15,0,0,1-2-4.65A42,42,0,0,1,251.56,287.18Z"
            style="fill: #263238"
          ></path>
          <path
            d="M250.37,287.3a16.62,16.62,0,0,0-.72,4.32,28,28,0,0,0,.14,4.39,29.89,29.89,0,0,0,.81,4.3,17.64,17.64,0,0,0,1.57,4.09c-.3-1.43-.53-2.84-.75-4.26s-.41-2.83-.56-4.26-.29-2.84-.38-4.26S250.36,288.76,250.37,287.3Z"
            style="fill: #263238"
          ></path>
          <path
            d="M273.83,309.74c1.95,2.21,4,4.36,5.89,6.56,1,1.11,1.89,2.23,2.72,3.41a14.5,14.5,0,0,1,2,3.74c.43,1.36.85,2.79,1.25,4.2l1.23,4.23q1.23,4.23,2.6,8.43c-.49-2.9-1.07-5.79-1.76-8.66s-1.41-5.7-2.31-8.54a14.55,14.55,0,0,0-2.2-4,33.69,33.69,0,0,0-2.93-3.37C278.25,313.63,276.05,311.68,273.83,309.74Z"
            style="fill: #263238"
          ></path>
          <path
            d="M295.18,353.82c-1.55,1.88-9,3.86-11.89,2.87l1.42,3.72s2,.74,6.47-.14,4.85-2.74,4.85-2.74Z"
            style="fill: #263238"
          ></path>
          <path
            d="M239.13,280.47c2.69,1.19,7.26,2.43,14.21,1.7s13.6-4.41,15.44-6.61l1.05,3.55s-5.2,5.51-16,6.82-15-2-15-2Z"
            style="fill: #455a64"
          ></path>
        </g>
        <g id="freepik--top--inject-3">
          <path
            d="M259.72,242.41c6.92,1,9.08,2.51,12.23,9.58s7.11,25.34,7.11,25.34l13.65,14.6-19.27-11.67Z"
            style="fill: #ffa8a7"
          ></path>
          <path
            d="M236.62,274.82a23.26,23.26,0,0,0-2.06-7.66c-1.68-3.94-1.66-8.72-2.09-12.15-.65-5.09-.15-7.86,1.4-9a41.16,41.16,0,0,1,4.77-1.94c1.73-.4,4.55-1,8.07-1.65a45.44,45.44,0,0,1,13-.05,38.47,38.47,0,0,1,10,8.85c2.59,3.09,4.53,8.65.2,13.32.18,1,.79,1.16,1.21,8.26,1.42,2.86,2.86,4,2.34,7.42,0,0-5.09,8.17-17.46,9-13.95,1-18.73-3.78-20.22-4.71C233.83,283.3,236.89,277.6,236.62,274.82Z"
            style="fill: #f5f5f5"
          ></path>
          <path
            d="M235.76,284.56a1.37,1.37,0,0,1-.58-.75,3.14,3.14,0,0,1-.14-1,9.47,9.47,0,0,1,.21-1.91c.25-1.25.6-2.48.85-3.71a11.64,11.64,0,0,0,.26-1.84,11.85,11.85,0,0,0-.19-1.83,21.75,21.75,0,0,0-.9-3.64c-.19-.6-.4-1.19-.64-1.78s-.48-1.16-.7-1.78a21.06,21.06,0,0,1-.88-3.75c-.19-1.26-.29-2.53-.37-3.8s-.13-2.54-.21-3.8c.43,2.5.58,5.05,1.06,7.52a23.38,23.38,0,0,0,1,3.63c.21.58.46,1.16.71,1.75s.46,1.2.66,1.81a20.88,20.88,0,0,1,.89,3.75,12.42,12.42,0,0,1,.15,1.95,11,11,0,0,1-.33,1.92c-.32,1.24-.72,2.44-1,3.67a10.59,10.59,0,0,0-.35,1.85A1.91,1.91,0,0,0,235.76,284.56Z"
            style="fill: #e0e0e0"
          ></path>
          <path
            d="M263,266.28c.18-6.09-1.3-8.56-2.86-11.19-.25-.41-.5-.83-.75-1.27l-.58.33c.26.44.51.87.76,1.28,1.58,2.65,2.95,4.94,2.76,10.83-.14,4.84.92,13.85,1.92,21.12l.63-.27C263.87,279.9,262.83,271,263,266.28Z"
            style="fill: #e0e0e0"
          ></path>
          <path
            d="M258.75,266.19s-3.38,4.52-8.77,4.13a9.06,9.06,0,0,1-5.55-2.29.37.37,0,0,0-.55.49,7.83,7.83,0,0,0,6.55,3.28A8.41,8.41,0,0,0,258.75,266.19Z"
            style="fill: #e0e0e0"
          ></path>
          <path
            d="M246.26,206.83c2.13.83,3.07,1.53,4.8-.49a5,5,0,0,1,7,.72c.59.67,1.2,1.56,2.07,1.51.49,0,1.1-.38,2-.52a3.46,3.46,0,0,1,3.4,1.73,5.29,5.29,0,0,1,.07,2.38,2.11,2.11,0,0,0,.94,2,1.25,1.25,0,0,0,1.78-.8,1.93,1.93,0,0,1,0,2.73,3.51,3.51,0,0,1-2.76.87c1.81.21,3.49,2.17,2.69,4.08-.35.85-1.17,1.46-1.32,2.37-.19,1.12.71,2.09,1.05,3.17a3.34,3.34,0,0,1-1.45,3.77c-1,.57-2.28.5-3.26,1.11s-1.59,2-2.42,3c-4.11,4.54-7.09-1.51-11.28.77a9.94,9.94,0,0,0-1.53,1.23,8.14,8.14,0,0,1-.63.54,1.92,1.92,0,0,0-.53.45,1.64,1.64,0,0,1-1.21.73,4.78,4.78,0,0,1-1.41-.07,7,7,0,0,1-4.14-1.7,10.17,10.17,0,0,1-.93-1.23,4.5,4.5,0,0,0-2.24-1.84c-1.07-.31-2.29.06-3.26-.5a3.64,3.64,0,0,1-1.38-2.1,7.12,7.12,0,0,0-1-2.37,2.7,2.7,0,0,0-2.72-.91,4.45,4.45,0,0,1,1.54-2.61,19.19,19.19,0,0,1,1.72-1.09,2.65,2.65,0,0,0,.53-.42,2.83,2.83,0,0,0,.44-.59,4.37,4.37,0,0,0,.46-1.46,5,5,0,0,0,.06-.56c.07-1-.07-2.09,0-3.13a5.32,5.32,0,0,1,2.41-4.17c.64-.36,1.37-.53,2-.84a3.24,3.24,0,0,0,1.23-.91c.13-.18.25-.37.39-.55a2.12,2.12,0,0,0,.29-.56,7.65,7.65,0,0,1,1.05-2.26A4.9,4.9,0,0,1,246.26,206.83Z"
          ></path>
          <path
            d="M259.16,214.62a10.74,10.74,0,0,1,3,7.84c0,1,.53,2.62.57,5.49.1,7.45-1.11,9.22-4,10.35a9.71,9.71,0,0,1-4.46.55l-.15,3.8a15,15,0,0,1,5.28,12.11C246.64,249.57,242.33,243,242.33,243l.2-10.66s-1.07,1.19-3.2-.17c-1.73-1.11-2.66-4.3-1.16-6s3.48-1.28,4.14.58c.6,1.68,2.26,1.67,2.28-1.19s-.51-7.48,3.09-9.82C254.18,215.72,253.1,220.5,259.16,214.62Z"
            style="fill: #ffa8a7"
          ></path>
          <path
            d="M242.34,242.06V243s6.19,4.32,17.09,11.78c-4.45-.37-11.1-.19-13.56-1.68-.53-.32.71-3,.71-3l-8.81-5.75Z"
            style="fill: #e0e0e0"
          ></path>
          <path
            d="M259.42,254.76A6.75,6.75,0,0,0,261,250.5c0-.47-2.21-2.6-2.21-2.6l-.32-5.65-4.25-.77-.05,1.17A18.08,18.08,0,0,1,259.42,254.76Z"
            style="fill: #e0e0e0"
          ></path>
          <path
            d="M252.14,231l3.38,1.23a1.73,1.73,0,0,1-2.25,1.11A1.88,1.88,0,0,1,252.14,231Z"
            style="fill: #b16668"
          ></path>
          <polygon
            points="254.7 222.59 255.14 229.87 258.79 228.94 254.7 222.59"
            style="fill: #f28f8f"
          ></polygon>
          <path
            d="M252.32,225.28a1.16,1.16,0,1,1-1-1.27A1.15,1.15,0,0,1,252.32,225.28Z"
            style="fill: #263238"
          ></path>
          <path
            d="M260.47,224.5a1.16,1.16,0,1,1-.86-1.4A1.16,1.16,0,0,1,260.47,224.5Z"
            style="fill: #263238"
          ></path>
          <path
            d="M260.86,221.11l-2.85-.88a1.49,1.49,0,1,1,2.85.88Z"
            style="fill: #263238"
          ></path>
          <path
            d="M248.89,222.35l2.7-1.25a1.49,1.49,0,1,0-2.7,1.25Z"
            style="fill: #263238"
          ></path>
          <path
            d="M254.29,238.85c-2.61-.21-7.41-.69-10-4.47a8,8,0,0,0,2.64,3.78c2.5,1.58,7.36,1.88,7.36,1.88Z"
            style="fill: #f28f8f"
          ></path>
          <path
            d="M254.06,233.44a1.61,1.61,0,0,0-1.59-1.61,1.29,1.29,0,0,0-.39,0,1.87,1.87,0,0,0,1.19,1.48A1.67,1.67,0,0,0,254.06,233.44Z"
            style="fill: #f28f8f"
          ></path>
          <path
            d="M233.87,246.05c-5.25,2.41-7.69,3.65-9.6,15.38s-2.53,14.28-3,17.66c-.88,5.87-.64,7.42,3.43,11.05a104.16,104.16,0,0,0,9.37,7.22,24.48,24.48,0,0,1,3.83,3c1.27,1.32,3,2,4,3.6.38.6.65,1.27,1.07,1.85a11.57,11.57,0,0,0,2.72,2.34A21.74,21.74,0,0,1,251,314a7.48,7.48,0,0,0,2.56,2.68,1.36,1.36,0,0,0,.47.15c.56,0,.56-.49.54-.87a3.2,3.2,0,0,1,.7.38,1.33,1.33,0,0,0,.88.29,1.1,1.1,0,0,0,.8-1c.06-.45,0-.92.09-1.36a14.13,14.13,0,0,0,.56-2.33,6.64,6.64,0,0,0-.28-2.73c-1-2.71-1.87-5.25-4.09-7.32s-5.29-5-7.55-7S235.32,282,235.32,282l3.53-17.12S240.15,249.31,233.87,246.05Z"
            style="fill: #ffa8a7"
          ></path>
        </g>
        <path
          d="M222.41,241.32c13.06,2.85,29.93,14.05,38.51,20.08S274.72,278,274.72,278l.57,3.37s-3,7.27-14.32,9.14a48.53,48.53,0,0,1-19.45-.45l-4.28-5.46s25.19,4.64,35-4.15c-4.88-7.17-22.11-23.48-49.82-34.13Z"
        ></path>
      </g>
      <path
        d="M309.15,274.18c32.91-19.2,73.58-39.59,73.66-39.6l2.8,2.89a18.84,18.84,0,0,1,2.53,3.32c-1.13,7.25-4.84,13.77-7.52,18.28a105.78,105.78,0,0,1-26.42,29.76c-16.07,12.06-30,17.79-49.41,25.72-23.39,9.57-52.85,4-57.61-1.67C247.18,312.88,283,289.46,309.15,274.18Z"
        style="fill: #455a64"
      ></path>
      <path
        d="M247.18,312.88c1.35-.84,43.76-24.34,64.45-36.78C331.34,264.25,378,237,382.81,234.58c-4.18,1.32-40.75,20.4-73.66,39.6C283,289.46,258.54,304.42,247.18,312.88Z"
        style="fill: #37474f"
      ></path>
      <path
        d="M383.78,249.65a334.23,334.23,0,0,1-46.54,32.49C320,292.08,299,302,283.62,308.94a44.94,44.94,0,0,1-40.86-2.08l-11.59-6.7-17.79-65.1a33.39,33.39,0,0,0,5.31.25c13.17-.39,38.48-15,59.26-27s50.57-29.2,40.57-37.84l2.87,2.57c29.37,26.35,62.82,63.35,64.22,64.43.28.34.54.68.8,1A9.64,9.64,0,0,1,383.78,249.65Z"
        style="opacity: 0.2"
      ></path>
      <path
        d="M318.52,170.47c9.07,6.21,57.87,56.87,60.44,60.09l-.57,1.25c-2-3.11-17.87-19.4-30.77-32.27-11.53-11.49-25.48-24.86-28.24-26.86Z"
      ></path>
      <path
        d="M123.38,231.28l107.79,68.88-17.79-65.1c-10.92-1.34-9.23-.9-26.47-10.85l-30.81-17.8a12.91,12.91,0,0,0-12.92,0l-19.57,11.29A7.91,7.91,0,0,0,123.38,231.28Z"
        style="opacity: 0.5"
      ></path>
      <g style="opacity: 0.2">
        <path
          d="M288.16,306.88c8.88-4,19.13-8.89,29.29-14.07-15.24-27.27-31-50.85-51.52-77.6-9.61,5.43-19.49,10.77-28.23,14.57C257.59,254.86,273.21,279.89,288.16,306.88Z"
          style="fill: #fff"
        ></path>
        <path
          d="M280.22,207,278,208.31l-6,3.45a670.56,670.56,0,0,1,50.79,78.32c2.94-1.54,5.85-3.1,8.69-4.67C315.25,258.75,296.87,228.8,280.22,207Z"
          style="fill: #fff"
        ></path>
      </g>
      <g id="freepik--vehicle--inject-3">
        <polygon
          points="80.8 285.39 120.65 262.94 98.55 250.17 80.86 260.42 80.8 285.39"
          style="fill: #263238"
        ></polygon>
        <path
          d="M242.8,379v6l24.71-14.27,15.15-14.19-22.11-12.77-17.69,10.25v25Z"
          style="fill: #263238"
        ></path>
        <path
          d="M259.25,373.72l-5.72-11.35,13.6-7.87h0c4.33-2.48,10.09-2.2,16.41,1.45,13.43,7.75,24.32,27.76,24.32,44.67,0,8.86-3,15.11-7.76,17.95h0l-.19.11h0l-13.94,8.05-6-12C268.5,406,259.69,388.82,259.25,373.72Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M259.25,373.72l-5.72-11.35,13.6-7.87h0c4.33-2.48,10.09-2.2,16.41,1.45,13.43,7.75,24.32,27.76,24.32,44.67,0,8.86-3,15.11-7.76,17.95h0l-.19.11h0l-13.94,8.05-6-12C268.5,406,259.69,388.82,259.25,373.72Z"
          style="fill: #263238"
        ></path>
        <path
          d="M245.07,380.71c0,14.58,8.1,31.47,18.94,40.81l.05,0a34.92,34.92,0,0,0,5.33,3.82c13.43,7.76,24.33.33,24.32-16.59,0-12.78-6.22-27.33-15-37a.29.29,0,0,1-.07-.08,39.29,39.29,0,0,0-9.2-7.57C256,356.37,245.07,363.79,245.07,380.71Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M269.39,374.33c-8.55-4.94-15.48.21-15.48,11.49s6.93,24.42,15.48,29.35,15.48-.2,15.48-11.48S277.94,379.26,269.39,374.33Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M262.4,391.63c.58,5.61,4.2,11.56,8.05,13.28a3.76,3.76,0,0,0,4.21-.36c1.36-1.16,2-3.53,1.72-6.68-.59-5.61-4.19-11.56-8.05-13.27a4.32,4.32,0,0,0-2.83-.38s0,0,0,0C263.27,384.78,262,387.55,262.4,391.63Z"
          style="fill: #fafafa"
        ></path>
        <path
          d="M263.78,390.91c.58,5.6,4.2,11.55,8.05,13.27a4.36,4.36,0,0,0,2.83.37c1.36-1.16,2-3.53,1.72-6.68-.59-5.61-4.19-11.56-8.05-13.27a4.32,4.32,0,0,0-2.83-.38s0,0,0,0C264.14,385.39,263.45,387.77,263.78,390.91Z"
          style="fill: #e0e0e0"
        ></path>
        <path
          d="M245.07,380.71c0,14.58,8.1,31.47,18.94,40.81-6.42-7-13.07-18.69-15.42-29.85-2.06-9.75-1.29-23.75,7.08-27.29s19.42,3.92,22.92,7.31a39.29,39.29,0,0,0-9.2-7.57C256,356.37,245.07,363.79,245.07,380.71Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M97.24,280.2l-5.71-11.35,13.6-7.87h0c4.32-2.49,10.08-2.2,16.41,1.45,13.43,7.75,24.31,27.75,24.32,44.67,0,8.86-3,15.11-7.76,17.95l-14.16,8.18-6-12C106.5,312.52,97.69,295.29,97.24,280.2Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M97.24,280.2l-5.71-11.35,13.6-7.87h0c4.32-2.49,10.08-2.2,16.41,1.45,13.43,7.75,24.31,27.75,24.32,44.67,0,8.86-3,15.11-7.76,17.95l-14.16,8.18-6-12C106.5,312.52,97.69,295.29,97.24,280.2Z"
          style="fill: #263238"
        ></path>
        <path
          d="M83.07,287.19c0,14.58,8.1,31.46,18.94,40.8l0,.05a36.22,36.22,0,0,0,5.34,3.82c13.43,7.76,24.33.33,24.31-16.59,0-12.78-6.21-27.33-15-37l-.08-.08a39.24,39.24,0,0,0-9.19-7.57C94,262.85,83.07,270.27,83.07,287.19Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M107.39,280.81c-8.55-4.94-15.48.2-15.48,11.48s6.93,24.43,15.48,29.36,15.47-.21,15.47-11.49S115.93,285.74,107.39,280.81Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M100.39,298.11c.59,5.61,4.2,11.55,8.06,13.27a3.76,3.76,0,0,0,4.21-.35c1.36-1.16,2-3.53,1.72-6.68-.59-5.61-4.19-11.56-8.06-13.28a4.3,4.3,0,0,0-2.83-.37h0C101.26,291.25,100,294,100.39,298.11Z"
          style="fill: #fafafa"
        ></path>
        <path
          d="M101.77,297.38c.59,5.61,4.2,11.56,8.06,13.28a4.36,4.36,0,0,0,2.83.37c1.36-1.16,2-3.53,1.72-6.68-.59-5.61-4.19-11.56-8.06-13.28a4.3,4.3,0,0,0-2.83-.37h0C102.14,291.87,101.44,294.24,101.77,297.38Z"
          style="fill: #e0e0e0"
        ></path>
        <path
          d="M83.07,287.19c0,14.58,8.1,31.46,18.94,40.8a69,69,0,0,1-15.43-29.84c-2-9.76-1.28-23.76,7.09-27.29s19.42,3.92,22.91,7.31a39.24,39.24,0,0,0-9.19-7.57C94,262.85,83.07,270.27,83.07,287.19Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M434.57,313.16c-8.25,9.39-18.14,16.65-28.94,22.89-62.41,36-90.78,19.64-143.92-11.05-51.52-29.75-108.89-73.73-113.56-77.1l63.92,40.35a8.81,8.81,0,0,0,13.16-9.8l-11.86-43.38c-2.57-8.78-6.78-10.74-12.74-14.17-11.46-6.56-31.12-17-61.39-34.51-26.16-15.08-38.62-22-41.56-28.73v-.32c0-.27,0-.53,0-.8,0-.6,0-1.19.07-1.83.46-5.33,3.64-11.77,37-31.93,18.86-11.38,35.31-16.93,50.29-16.93s27.87,5.33,42.53,13.34c18.43,10,80.83,42.54,90.95,51.28S298.75,196.31,278,208.31s-46.09,26.61-59.26,27a33.39,33.39,0,0,1-5.31-.25l17.79,65.1,11.59,6.7a44.94,44.94,0,0,0,40.86,2.08C299,302,320,292.08,337.24,282.14a334.23,334.23,0,0,0,46.54-32.49,9.64,9.64,0,0,0,2.63-11.16c-.26-.34-.52-.68-.8-1,5.18,4,17.49,12.12,19,13.17,10.67,7.45,21.7,16,28.26,27.55C438.42,287.93,442.67,303.92,434.57,313.16Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M452.48,350.26c-4.66,17.71-26.09,35.14-42,44.13-24,13.58-50,24.42-77.7,22-10.22-.89-20.41-3.26-29-9.05-4.14-2.79-4.34-4.68-5.66-9.44a71.25,71.25,0,0,0-6.29-15.38c-4.59-8.37-10.76-15.73-17.59-20.47q-1.35-.94-2.73-1.74c-14.8-8.56-27-1.66-28.57,15.32-.09,1.07-.16,2.17-.16,3.33L138.41,318.66s0-1.27-.48-5.2a68.34,68.34,0,0,0-1.27-7.12A72.67,72.67,0,0,0,129.85,289c-4.61-8.37-10.76-15.71-17.6-20.47-.9-.63-1.82-1.2-2.73-1.71-14.81-8.56-27-1.69-28.56,15.29a31.86,31.86,0,0,0-.16,3.3L74.91,282c-14.08-8.14-14.32-22-14.2-32.12v0c.08-1.8.15-3.85.21-6l0-.88c.14-5.1.29-11,.58-16.83.11-2,.22-4,.37-6,.07-.91.14-1.81.21-2.69.2-2.26.43-4.41.7-6.41,1.07-7.76,2.73-11.13,4.57-13.08a16.59,16.59,0,0,1,3.24-2.5A27.1,27.1,0,0,1,73,194c.68-.36,1.34-.69,1.94-1-.71,1.19-1.27,2.14-1.63,2.77l9.5,9c6.07,5.72,15.39,6.37,23,2.93a22.4,22.4,0,0,0,2.07-1.06l18.53-10.7a4.09,4.09,0,0,0,.2-7l-2.85-1.9-1.29-.88-1.32-.91c-4.48-3.07-8.15-5.76-13-9.1-9.2-6.37-10.43-9.52-10.57-14.34,0-1.11,0-2.31,0-3.65s0-2.34.07-3.53c.18,7.81,11.39,14.38,41.54,31.77s49.91,28,61.38,34.51c6,3.44,10.18,5.38,12.75,14.16-10.92-1.33-9.23-.9-26.47-10.85L156.1,206.42a12.89,12.89,0,0,0-12.92,0l-19.57,11.29a7.91,7.91,0,0,0-.23,13.56l106.77,68.23-82-51.6c4.67,3.36,62,47.35,113.56,77.09,53.14,30.69,81.51,47.07,143.92,11.05,6.22-3.59,12.15-7.19,16.91-12.54a33.06,33.06,0,0,0,7.76-18.39c.89-7.92-.46-15.93-2.43-23.66-1.58-6.17-4-13.43-7.66-18.63a139.39,139.39,0,0,1,17.27,15.94c.73.81,1.43,1.63,2.11,2.47a64.32,64.32,0,0,1,13.56,29.33C455.73,324.85,456.57,334.71,452.48,350.26Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M234.66,144.35c7.35,4.1,14.7,8.18,22.14,12.1-7.12-4.47-14.33-8.8-21.55-13.11S224,136.72,216.7,132.63l-11-6.12c-3.71-2-7.38-4-11.11-6,3.55,2.25,7.16,4.42,10.73,6.63l10.81,6.49C223.33,138,227.32,140.26,234.66,144.35Zm-102.48,12.2c3.55,2.25,7.15,4.42,10.73,6.63l10.81,6.49c7.22,4.31,11.21,6.61,18.55,10.71s14.69,8.17,22.13,12.1c-7.12-4.48-14.32-8.81-21.54-13.12s-11.21-6.61-18.55-10.71l-11-6.12C139.58,160.54,135.9,158.5,132.18,156.55ZM216,155.16c7.34,4.1,14.69,8.17,22.13,12.1-7.12-4.48-14.33-8.81-21.55-13.12s-11.2-6.61-18.54-10.71l-11-6.11c-3.7-2-7.38-4-11.11-6,3.55,2.25,7.16,4.42,10.73,6.63l10.81,6.49C204.61,148.77,208.6,151.07,216,155.16Zm-25,14.41c7.34,4.1,14.69,8.17,22.13,12.1-7.12-4.48-14.33-8.81-21.54-13.12s-11.21-6.61-18.55-10.71l-11-6.12c-3.7-2-7.38-4-11.11-6,3.56,2.25,7.16,4.41,10.74,6.63l10.81,6.49C179.65,163.17,183.65,165.48,191,169.57Z"
          style="fill: #263238"
        ></path>
        <path
          d="M314.41,303.5a180.2,180.2,0,0,1,17.36,8.4c5.63,3.09,11.18,6.33,16.48,10a104.87,104.87,0,0,1,11.54,8.32c5.07,4,9.8,8.32,14.55,12.67L371,339.32c-1.11-1.17-2.21-2.36-3.39-3.45-2.35-2.22-4.69-4.44-7.18-6.51A90.93,90.93,0,0,0,349,320.71,166.44,166.44,0,0,0,332.26,311c-2.88-1.45-5.82-2.81-8.77-4.1S317.5,304.44,314.41,303.5Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M362.28,273.19c5.19,3.54,10.21,7.3,15.12,11.19s9.75,7.87,14.38,12.1,5.45,4.64,9.85,9.1,8.65,9.07,12.89,13.71c-1.92-2.48-3.84-5-5.87-7.38s-4.1-4.77-6.26-7.06a110.38,110.38,0,0,0-9.7-9.4c-4.72-4.17-9.59-8.17-14.65-11.91-2.53-1.87-5.11-3.67-7.71-5.43S365,274.7,362.28,273.19Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M126.44,195.89l-18.53,10.7c-7.93,4.58-18.44,4.38-25.07-1.87l-9.5-9c2.63-4.54,15.36-25.88,24.33-34,0,3.65,1.61,7.21,5.75,10.44,6.35,4.95,15.86,11.86,23.22,16.72A4.09,4.09,0,0,1,126.44,195.89Z"
        ></path>
        <path
          d="M251.67,325.16l8.83,5.59a1.41,1.41,0,0,1,.64,1.12l.2,4.37A.86.86,0,0,1,260,337l-8.8-5.49a1.42,1.42,0,0,1-.66-1.13l-.21-4.46A.86.86,0,0,1,251.67,325.16Z"
          style="fill: #4567b4"
        ></path>
        <path
          d="M138.42,318.66v6L242.8,384.92v-6Z"
          style="fill: #37474f"
        ></path>
        <g style="opacity: 0.2">
          <path
            d="M170.29,334.2h0a.57.57,0,0,0,.54-.61c0-.38-2.08-38.85-1-66.13a.58.58,0,0,0-.55-.6h0a.57.57,0,0,0-.57.55c-1.12,27.34.94,65.86,1,66.25A.58.58,0,0,0,170.29,334.2Z"
          ></path>
        </g>
        <path
          d="M111.81,255.22c8,3,14.87,8.62,20.4,15a70.6,70.6,0,0,1,12.9,22.48c1.64,4.6,3.26,9.61,3.36,14.53,0,.45-.74.86-.92.32-.72-2.15-1.19-4.37-1.76-6.56s-1.2-4.24-1.91-6.33a77,77,0,0,0-5.37-12.15,65.75,65.75,0,0,0-15.74-19.06,83.94,83.94,0,0,0-11.24-7.6C111.25,255.72,111.49,255.1,111.81,255.22Z"
          style="opacity: 0.2"
        ></path>
        <path
          d="M218.69,235.31a27,27,0,0,0,4.29-.53c-.84,3,.15,6.92,2,14.06,3,11.94,11.9,41,14.34,48.79s9.78,12,15.14,13.9a44.92,44.92,0,0,1-11.65-4.68l-11.59-6.69-17.79-65.1A33.39,33.39,0,0,0,218.69,235.31Z"
        ></path>
        <path d="M177.22,266l-10.45-6.52,5.71-43.62,7.33,4.23Z"></path>
        <path
          d="M65.67,217.37a14.14,14.14,0,0,1-3.56,0c.2-2.26.43-4.41.7-6.41,1.07-7.76,2.73-11.13,4.57-13.08a1.85,1.85,0,0,0,.25.24c2.8,2.47,6.6,6.65,8.28,10.27a7.59,7.59,0,0,1,.64,2.11C77.26,215.77,69.3,216.94,65.67,217.37Z"
          style="fill: #4567b4"
        ></path>
        <path
          d="M421.67,318.9a308.08,308.08,0,0,1-55.27,31.8c-2.88,1.3-4.32,4.76-2.46,7.31a34,34,0,0,0,10.46,9.24c2.77,1.51,7.79,1,10.74-.08q24.9-9.46,41.51-23.72c2.4-2.06,5.2-6.25,5.3-9.41.15-4.5-.53-10.56-2.07-14.52C428.73,316.58,424.22,317,421.67,318.9Z"
          style="fill: #263238"
        ></path>
        <path
          d="M379.1,364.77a14.62,14.62,0,0,0,4.82-.81c16.16-6.14,29.79-13.92,40.5-23.12,2.05-1.76,4-5.12,4.1-6.91a37.92,37.92,0,0,0-1.79-13c-.55-1.12-2.36.27-3,.76a312.67,312.67,0,0,1-55.88,32.16,2.22,2.22,0,0,0-1.24,1.37.83.83,0,0,0,.13.79,30.35,30.35,0,0,0,9.34,8.25A7,7,0,0,0,379.1,364.77Z"
        ></path>
        <path
          d="M405.77,355.44l3.34-.8a86.42,86.42,0,0,0-7.93-19.93l-3,1.7A84.43,84.43,0,0,1,405.77,355.44Z"
          style="fill: #263238"
        ></path>
        <path
          d="M404.7,344.11A248.19,248.19,0,0,1,370.53,361l.19.54A249,249,0,0,0,405,344.6c13.25-8.13,23.63-15.94,23.73-16l-.34-.46C428.28,328.2,417.92,336,404.7,344.11Zm1.16,1.93a238.18,238.18,0,0,1-33.62,16.55l.19.54a240,240,0,0,0,33.73-16.61c13.25-8.12,22.72-15.39,22.81-15.47l-.35-.45C428.53,330.67,419.09,337.93,405.86,346Zm2.33,3.85a218.86,218.86,0,0,1-32.53,15.92l.19.54a220.13,220.13,0,0,0,32.64-16,215.8,215.8,0,0,0,21-14.38l-.36-.45A212.33,212.33,0,0,1,408.19,349.89ZM407,348A227.89,227.89,0,0,1,374,364.2l.19.54a229.78,229.78,0,0,0,33.18-16.29,254.22,254.22,0,0,0,21.9-14.92l-.36-.45A248.14,248.14,0,0,1,407,348Zm-3.49-5.78a264,264,0,0,1-34.71,17.19l.19.54a265.41,265.41,0,0,0,34.82-17.24c13.25-8.12,24.55-16.48,24.66-16.56l-.34-.46C428,325.73,416.76,334.07,403.53,342.18Zm-38.13,14,.19.54a284.76,284.76,0,0,0,35.91-17.86c13.25-8.13,26.37-17.57,26.51-17.66l-.34-.46c-.13.09-13.24,9.52-26.47,17.63A284,284,0,0,1,365.4,356.14Zm37-15.89a275.43,275.43,0,0,1-35.26,17.51l.19.54a278.29,278.29,0,0,0,35.37-17.56c13.25-8.12,25.46-17,25.58-17.11l-.34-.46C427.79,323.26,415.6,332.15,402.37,340.25Z"
          style="fill: #263238"
        ></path>
        <path
          d="M409.26,365c-17.72,9.23-40.73,22-66.08,21.58s-48.53-17.22-48.53-17.22A82.14,82.14,0,0,0,343,390.08c29.71,2.15,48.67-10.09,66.88-19.91C428.8,360,445,340.06,447.71,328.12,443.94,337.4,427,355.78,409.26,365Z"
          style="fill: #263238"
        ></path>
        <path
          d="M376.19,402.27c16.27-4.88,27.91-11.92,39.26-19.36s18.65-14.23,22.74-19.9c3.86-5.35,6-12.17,3.49-11.11-4.13,3.92-13.07,12.25-18.84,16.12-17.27,11.63-35.51,25.88-64.52,27.75a23.86,23.86,0,0,0-5.56.69C345.77,398.91,365.13,405.59,376.19,402.27Z"
          style="fill: #263238"
        ></path>
        <path
          d="M315,389.86c1.62-.27,5.69.71,12.6,2.51s8.59,1.93,11.18,3.62c2.19,1.43,8.06,6,10.88,7.33,4.46,2.15.05,3.9-12.22,4.24s-16.57-3.25-19.5-7S311.32,390.47,315,389.86Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M450.29,347.17a12.47,12.47,0,0,1-4.09,2.39c-2.1-.08-.4-3.75,1-9.18s5.69-11.18,7-15.22A83.77,83.77,0,0,1,450.29,347.17Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M348.67,360.44c3.59.16,7,.69,10.25,3s9.07,7.9,5.35,12.21c-1.53,1.77-3.93,2.51-6.23,3a42,42,0,0,1-23-2.13,34.71,34.71,0,0,1-12.81-8.13,9,9,0,0,1-2.41-3.66,3.82,3.82,0,0,1,1.08-4c1.28-1,3.35-1,4.87-.93l12.12.51C341.5,360.38,345.08,360.28,348.67,360.44Z"
          style="fill: #fafafa"
        ></path>
        <path
          d="M335.83,376.75a21.45,21.45,0,0,1-.07-16.06c.07-.18.16-.36.24-.54l-10.22-.43c-1.52-.07-3.59,0-4.87.93a3.82,3.82,0,0,0-1.08,4,9,9,0,0,0,2.41,3.66,34.71,34.71,0,0,0,12.81,8.13Z"
          style="fill: #4567b4"
        ></path>
        <path
          d="M435.1,306.31a42.52,42.52,0,0,0,2.7,19.79,2.62,2.62,0,0,0,.68,1.07c3.28,2.6,7.38-12.19,7.6-13.85.79-6-1.08-14.91-4.09-21.19-1.27-2.66-2.81-3.72-3.95-.5a61.26,61.26,0,0,0-2.34,10C435.44,303.17,435.24,304.74,435.1,306.31Z"
          style="fill: #fafafa"
        ></path>
        <path
          d="M442,292.13c-1.28-2.66-2.82-3.72-4-.5a42.38,42.38,0,0,0-1.41,5.12,20.43,20.43,0,0,1,8.29,8.44c.46.88.85,1.8,1.25,2.72A46.92,46.92,0,0,0,442,292.13Z"
          style="fill: #4567b4"
        ></path>
        <path
          d="M214.29,305.55c2.08,9.91,13.06,12,21.28,11.76,4.36-.13,7.94-.93,9-1.55,3.17-1.84,1.71-5.64,0-7.84-2.88-3.73-15.8-11.22-23.92-11.48C216,296.28,212.84,298.6,214.29,305.55Z"
          style="fill: #263238"
        ></path>
        <path
          d="M214.29,305.55c2.08,9.91,13.06,12,21.28,11.76,4.36-.13,7.94-.93,9-1.55,3.17-1.84,1.71-5.64,0-7.84,1.6,3-6.87,4.89-14.41,2.19s-13.17-8.55-9.51-13.67C216,296.28,212.84,298.6,214.29,305.55Z"
          style="fill: #455a64"
        ></path>
        <path
          d="M214.29,305.55c2.08,9.91,13.06,12,21.28,11.76-8.18-.24-14.71-4.95-17.17-10.1s-.59-10.11,2.3-10.77C216,296.28,212.84,298.6,214.29,305.55Z"
          style="fill: #37474f"
        ></path>
        <path
          d="M66.42,282.49l8.47,4.88V270.8c-12.25-7.07-10.6-5.43-13.83-9.89a10.89,10.89,0,0,1-2.2-5.22C58.86,270.54,59.68,278.6,66.42,282.49Z"
          style="fill: #263238"
        ></path>
        <path
          d="M58.86,255.69a10.89,10.89,0,0,0,2.2,5.22c3.23,4.46,1.58,2.82,13.83,9.89L79.57,268s-1.88-1.18-9.14-5.34-9-7.32-9.44-10a12.17,12.17,0,0,1-.27-2.81C59.16,251.1,58.86,252.82,58.86,255.69Z"
          style="fill: #455a64"
        ></path>
        <polygon
          points="79.57 268.04 79.57 284.67 74.89 287.37 74.89 270.8 79.57 268.04"
          style="fill: #37474f"
        ></polygon>
      </g>
    </g>
  </g>
`,
];

export const hotelBookingPanaPic = [
  '500 500',
  `
  <g id="freepik--background-complete--inject-4">
    <rect x="80.81" y="128.74" width="105.97" height="335.84" style="fill:#f5f5f5"></rect>
    <rect x="133.79" y="128.74" width="52.98" height="334.92" style="fill:#ebebeb"></rect>
    <rect x="92.91" y="95.77" width="37.42" height="32.97" style="fill:#f5f5f5"></rect>
    <rect x="121.41" y="95.77" width="8.92" height="32.97" style="fill:#ebebeb"></rect>
    <polyline points="71.98 128.74 71.98 126.82 189.88 126.82 189.88 128.74" style="fill:#e0e0e0"></polyline>
    <rect x="101.73" y="143.12" width="8.97" height="18.91" style="fill:#fafafa"></rect>
    <path
        d="M133.79,169.46c0,.2-11.86.36-26.49.36s-26.49-.16-26.49-.36,11.86-.36,26.49-.36S133.79,169.26,133.79,169.46Z"
        style="fill:#e0e0e0"></path>
    <rect x="155.17" y="143.12" width="8.97" height="18.91" style="fill:#e0e0e0"></rect>
    <path
        d="M187.24,169.46c0,.2-11.86.36-26.49.36s-26.49-.16-26.49-.36,11.85-.36,26.49-.36S187.24,169.26,187.24,169.46Z"
        style="fill:#e0e0e0"></path>
    <rect x="155.17" y="180.67" width="8.97" height="18.91" style="fill:#e0e0e0"></rect>
    <path d="M187.24,207c0,.2-11.86.36-26.49.36s-26.49-.16-26.49-.36,11.85-.36,26.49-.36S187.24,206.81,187.24,207Z"
        style="fill:#e0e0e0"></path>
    <rect x="155.17" y="219.36" width="8.97" height="18.91" style="fill:#e0e0e0"></rect>
    <path d="M187.24,245.7c0,.19-11.86.36-26.49.36s-26.49-.17-26.49-.36,11.85-.37,26.49-.37S187.24,245.5,187.24,245.7Z"
        style="fill:#e0e0e0"></path>
    <rect x="155.17" y="258.04" width="8.97" height="18.91" style="fill:#e0e0e0"></rect>
    <path
        d="M187.24,284.38c0,.2-11.86.36-26.49.36s-26.49-.16-26.49-.36,11.85-.36,26.49-.36S187.24,284.18,187.24,284.38Z"
        style="fill:#e0e0e0"></path>
    <rect x="155.17" y="295.62" width="8.97" height="18.91" style="fill:#e0e0e0"></rect>
    <path d="M187.24,322c0,.2-11.86.36-26.49.36s-26.49-.16-26.49-.36,11.85-.36,26.49-.36S187.24,321.76,187.24,322Z"
        style="fill:#e0e0e0"></path>
    <rect x="155.17" y="333.35" width="8.97" height="18.91" style="fill:#e0e0e0"></rect>
    <rect x="155.17" y="371.57" width="8.97" height="18.91" style="fill:#e0e0e0"></rect>
    <path
        d="M187.24,359.69c0,.2-11.86.36-26.49.36s-26.49-.16-26.49-.36,11.85-.36,26.49-.36S187.24,359.49,187.24,359.69Z"
        style="fill:#e0e0e0"></path>
    <rect x="101.73" y="181.25" width="8.97" height="18.91" style="fill:#fafafa"></rect>
    <path
        d="M133.79,207.58c0,.2-11.86.37-26.49.37s-26.49-.17-26.49-.37,11.86-.36,26.49-.36S133.79,207.38,133.79,207.58Z"
        style="fill:#e0e0e0"></path>
    <rect x="101.73" y="219.37" width="8.97" height="18.91" style="fill:#fafafa"></rect>
    <path
        d="M133.79,245.71c0,.2-11.86.36-26.49.36s-26.49-.16-26.49-.36,11.86-.36,26.49-.36S133.79,245.51,133.79,245.71Z"
        style="fill:#e0e0e0"></path>
    <rect x="101.73" y="257.5" width="8.97" height="18.91" style="fill:#fafafa"></rect>
    <path
        d="M133.79,283.83c0,.2-11.86.36-26.49.36s-26.49-.16-26.49-.36,11.86-.36,26.49-.36S133.79,283.63,133.79,283.83Z"
        style="fill:#e0e0e0"></path>
    <rect x="101.73" y="295.62" width="8.97" height="18.91" style="fill:#fafafa"></rect>
    <path d="M133.79,322c0,.2-11.86.36-26.49.36s-26.49-.16-26.49-.36,11.86-.36,26.49-.36S133.79,321.76,133.79,322Z"
        style="fill:#e0e0e0"></path>
    <rect x="101.73" y="333.74" width="8.97" height="18.91" style="fill:#fafafa"></rect>
    <path
        d="M133.79,360.08c0,.2-11.86.36-26.49.36s-26.49-.16-26.49-.36,11.86-.36,26.49-.36S133.79,359.88,133.79,360.08Z"
        style="fill:#e0e0e0"></path>
    <rect x="101.73" y="371.87" width="8.97" height="18.91" style="fill:#fafafa"></rect>
    <polygon points="157.62 463.75 35.16 463.75 34.62 270.2 157.09 270.2 157.62 463.75" style="fill:#ebebeb">
    </polygon>
    <rect x="95.86" y="270.2" width="61.23" height="193.55" style="fill:#e0e0e0"></rect>
    <rect x="48.61" y="232.1" width="43.25" height="38.1" style="fill:#ebebeb"></rect>
    <rect x="81.55" y="232.1" width="10.31" height="38.1" style="fill:#e0e0e0"></rect>
    <rect x="24.42" y="267.98" width="136.25" height="2.22" style="fill:#e0e0e0"></rect>
    <rect x="58.8" y="286.82" width="10.37" height="21.86" style="fill:#fff"></rect>
    <path d="M95.86,317.26c0,.23-13.71.42-30.62.42s-30.62-.19-30.62-.42,13.71-.42,30.62-.42S95.86,317,95.86,317.26Z"
        style="fill:#e0e0e0"></path>
    <rect x="120.56" y="286.82" width="10.37" height="21.86" style="fill:#f5f5f5"></rect>
    <path d="M157.62,317.26c0,.23-13.71.42-30.61.42s-30.62-.19-30.62-.42,13.71-.42,30.62-.42S157.62,317,157.62,317.26Z"
        style="fill:#ebebeb"></path>
    <rect x="120.56" y="330.22" width="10.37" height="21.86" style="fill:#f5f5f5"></rect>
    <path
        d="M157.62,360.65c0,.24-13.71.42-30.61.42s-30.62-.18-30.62-.42,13.71-.41,30.62-.41S157.62,360.42,157.62,360.65Z"
        style="fill:#ebebeb"></path>
    <rect x="120.56" y="374.92" width="10.37" height="21.86" style="fill:#f5f5f5"></rect>
    <path
        d="M157.62,405.36c0,.23-13.71.42-30.61.42s-30.62-.19-30.62-.42,13.71-.42,30.62-.42S157.62,405.13,157.62,405.36Z"
        style="fill:#ebebeb"></path>
    <rect x="120.56" y="419.63" width="10.37" height="21.86" style="fill:#f5f5f5"></rect>
    <path
        d="M157.62,450.07c0,.23-13.71.41-30.61.41s-30.62-.18-30.62-.41,13.71-.42,30.62-.42S157.62,449.84,157.62,450.07Z"
        style="fill:#ebebeb"></path>
    <rect x="58.8" y="330.88" width="10.37" height="21.86" style="fill:#fff"></rect>
    <path d="M95.86,361.32c0,.23-13.71.41-30.62.41s-30.62-.18-30.62-.41,13.71-.42,30.62-.42S95.86,361.09,95.86,361.32Z"
        style="fill:#e0e0e0"></path>
    <rect x="58.8" y="374.94" width="10.37" height="21.86" style="fill:#fff"></rect>
    <path d="M95.86,405.38c0,.23-13.71.41-30.62.41s-30.62-.18-30.62-.41S48.33,405,65.24,405,95.86,405.15,95.86,405.38Z"
        style="fill:#e0e0e0"></path>
    <rect x="58.8" y="419" width="10.37" height="21.86" style="fill:#fff"></rect>
    <path d="M95.86,449.43c0,.24-13.71.42-30.62.42s-30.62-.18-30.62-.42S48.33,449,65.24,449,95.86,449.2,95.86,449.43Z"
        style="fill:#e0e0e0"></path>
    <rect x="270.3" y="303.66" width="121.5" height="160.25" style="fill:#ebebeb"></rect>
    <rect x="334.82" y="303.66" width="56.97" height="160.25" style="fill:#e0e0e0"></rect>
    <rect x="295.77" y="325.35" width="10.92" height="26.54" style="fill:#f5f5f5"></rect>
    <rect x="295.77" y="429.23" width="10.92" height="26.54" style="fill:#f5f5f5"></rect>
    <path d="M334.82,362.31c0,.3-14.44.54-32.26.54s-32.26-.24-32.26-.54,14.44-.54,32.26-.54S334.82,362,334.82,362.31Z"
        style="fill:#f5f5f5"></path>
    <rect x="295.77" y="377.69" width="10.92" height="26.54" style="fill:#f5f5f5"></rect>
    <path
        d="M334.82,414.64c0,.3-14.44.54-32.26.54s-32.26-.24-32.26-.54,14.44-.54,32.26-.54S334.82,414.35,334.82,414.64Z"
        style="fill:#f5f5f5"></path>
    <rect x="346.92" y="325.35" width="10.92" height="26.54" style="fill:#f5f5f5"></rect>
    <rect x="370.62" y="325.35" width="10.92" height="26.54" style="fill:#f5f5f5"></rect>
    <rect x="346.92" y="375.72" width="10.92" height="26.54" style="fill:#f5f5f5"></rect>
    <rect x="370.62" y="375.72" width="10.92" height="26.54" style="fill:#f5f5f5"></rect>
    <rect x="346.92" y="426.08" width="10.92" height="26.54" style="fill:#f5f5f5"></rect>
    <rect x="370.62" y="426.08" width="10.92" height="26.54" style="fill:#f5f5f5"></rect>
    <rect x="261.16" y="298.08" width="139.76" height="5.78" style="fill:#e0e0e0"></rect>
    <path d="M392.64,304.4c0,.3-27.16.54-60.65.54s-60.65-.24-60.65-.54,27.15-.54,60.65-.54S392.64,304.1,392.64,304.4Z"
        style="fill:#ebebeb"></path>
    <path
        d="M390.74,70.51c.59-4.28-5.45-7.8-10-8.16-2.16-.18-4.41.15-6.46-.56-4.44-1.55-6.21-7.29-10.54-9.11-3.24-1.37-7-.15-10.11,1.43s-6.24,3.57-9.75,3.79c-3.05.2-6.37-.93-9,.56-2,1.11-3,3.4-4.86,4.75s-4.14,1.6-6.36,1.73-4.53.14-6.56,1.07-3.7,3.07-3.28,5.26Z"
        style="fill:#ebebeb"></path>
    <path
        d="M476.7,120.08c.89-6.43-8.19-11.72-15-12.27-3.25-.27-6.63.23-9.71-.84-6.67-2.33-9.34-11-15.85-13.7-4.87-2-10.48-.22-15.2,2.15s-9.38,5.37-14.65,5.7c-4.59.3-9.57-1.4-13.59.84-3,1.67-4.55,5.11-7.31,7.15s-6.22,2.41-9.56,2.59-6.81.22-9.86,1.61-5.56,4.62-4.93,7.91Z"
        style="fill:#f5f5f5"></path>
    <path
        d="M96.08,58.83c.45-3.27-4.16-5.95-7.63-6.23-1.65-.14-3.37.12-4.93-.43-3.39-1.18-4.75-5.57-8.06-7-2.48-1.05-5.32-.12-7.72,1.09S63,49,60.28,49.2c-2.33.15-4.86-.72-6.9.42-1.52.85-2.32,2.6-3.72,3.64a8.94,8.94,0,0,1-4.86,1.32,13.83,13.83,0,0,0-5,.81c-1.55.71-2.83,2.35-2.51,4Z"
        style="fill:#f5f5f5"></path>
</g>
<g id="freepik--Floor--inject-4">
    <path
        d="M470.18,464.48c0,.15-97.24.26-217.17.26s-217.19-.11-217.19-.26,97.22-.26,217.19-.26S470.18,464.34,470.18,464.48Z"
        style="fill:#263238"></path>
</g>
<g id="freepik--Device--inject-4">
    <path
        d="M302.48,464.48l-144.27-.08A31.43,31.43,0,0,1,126.8,433l.07-361.68a31.42,31.42,0,0,1,31.45-31.42l144.27.08A31.42,31.42,0,0,1,334,71.37l-.07,361.69A31.42,31.42,0,0,1,302.48,464.48Z"
        style="fill:#263238"></path>
    <path
        d="M303.63,52.69h-28a6.94,6.94,0,0,0-6.79,7.09v5.08a6.94,6.94,0,0,1-6.8,7.09l-54.52,0a7,7,0,0,1-6.79-7.1V59.73a7,7,0,0,0-6.79-7.1H159.65a22,22,0,0,0-22,22l-.07,353a22,22,0,0,0,22,22l144,.08a22,22,0,0,0,22-22l.07-353A22,22,0,0,0,303.63,52.69Z"
        style="fill:#fff"></path>
    <path
        d="M303.63,52.69l.76,0a14.45,14.45,0,0,1,2.23.17,20.63,20.63,0,0,1,8.25,2.85,21.22,21.22,0,0,1,5,4.07,22.13,22.13,0,0,1,4.19,6.57,22.79,22.79,0,0,1,1.65,8.94q0,4.88,0,10.37c0,29.33,0,71.76.07,124.18s0,114.86,0,184.18v33a23.53,23.53,0,0,1-.84,6.71,22.24,22.24,0,0,1-2.81,6.2,23.64,23.64,0,0,1-4.59,5.09A22.2,22.2,0,0,1,304.9,450c-4.61.13-9.19,0-13.83.06H263l-57.53,0-29.42,0H161.23a23.21,23.21,0,0,1-14.34-4A22.47,22.47,0,0,1,138.17,434a24.08,24.08,0,0,1-.92-7.44V419.1q0-14.82,0-29.44,0-29.22,0-57.54c0-37.72,0-74.11,0-108.78s0-67.6.05-98.43q0-23.13,0-44.61V75c0-.89.08-1.78.13-2.67s.22-1.77.45-2.62a22.46,22.46,0,0,1,4.63-9.33,22.33,22.33,0,0,1,17.94-8l19.19,0h13.75a7,7,0,0,1,4.33,1.21,7.3,7.3,0,0,1,2.7,3.53,11.77,11.77,0,0,1,.44,4.35v2.14a16.08,16.08,0,0,0,.07,2.1,7,7,0,0,0,1.64,3.69A6.47,6.47,0,0,0,206,71.53a7.24,7.24,0,0,0,2,.2h10l29,.05,12.8,0c1,0,2,0,3,0a6.38,6.38,0,0,0,2.69-1,7,7,0,0,0,3.09-4.43,12.58,12.58,0,0,0,.17-2.67V61.08a14.55,14.55,0,0,1,.12-2.56,7.37,7.37,0,0,1,.83-2.36,6.92,6.92,0,0,1,3.51-3.11,10.85,10.85,0,0,1,4.37-.46l14.28,0,8.78,0,3,0-3,0-8.78,0-14.28,0a10.68,10.68,0,0,0-4.29.47,6.69,6.69,0,0,0-3.4,3,7.25,7.25,0,0,0-.8,2.29,15.07,15.07,0,0,0-.11,2.53v2.64a12,12,0,0,1-.17,2.72,7.23,7.23,0,0,1-3.18,4.6,6.91,6.91,0,0,1-2.8,1c-1,.09-2,0-3,0H208a7.66,7.66,0,0,1-2.07-.2,6.88,6.88,0,0,1-3.56-2.2,7.37,7.37,0,0,1-1.74-3.88,17.23,17.23,0,0,1-.07-2.15V61.52a11.39,11.39,0,0,0-.43-4.21A6.94,6.94,0,0,0,197.59,54a6.65,6.65,0,0,0-4.11-1.13H160.54A21.86,21.86,0,0,0,143,60.64a22.11,22.11,0,0,0-4.53,9.13c-.22.84-.28,1.71-.43,2.57s-.11,1.74-.12,2.62V80.3q0,21.47,0,44.61c0,30.83,0,63.77,0,98.43s0,71.06,0,108.78v57.54q0,14.63,0,29.44v7.42a23.44,23.44,0,0,0,.9,7.27,21.83,21.83,0,0,0,8.48,11.71,22.55,22.55,0,0,0,14,3.85h14.86l29.42,0,57.53,0,28,0c4.62,0,9.25.07,13.8-.06a21.65,21.65,0,0,0,12.37-4.8,23.06,23.06,0,0,0,4.46-4.95,21.53,21.53,0,0,0,2.74-6,23,23,0,0,0,.83-6.55v-6.68q0-13.31,0-26.31c0-69.32.07-131.75.1-184.18s.1-94.85.13-124.18c0-3.66,0-7.12,0-10.37a22.62,22.62,0,0,0-1.6-8.87,21.93,21.93,0,0,0-4.14-6.54,22,22,0,0,0-13.17-7,18.66,18.66,0,0,0-2.22-.2Z"
        style="fill:#263238"></path>
    <path d="M307.89,88.34c0,.1-3.64.2-8.13.24s-8.12,0-8.12-.11,3.63-.2,8.12-.23S307.89,88.25,307.89,88.34Z"
        style="fill:#263238"></path>
    <path d="M307.92,92.5c0,.09-3.63.2-8.12.24s-8.13,0-8.13-.11,3.64-.2,8.13-.24S307.92,92.4,307.92,92.5Z"
        style="fill:#263238"></path>
    <path d="M308,96.66c0,.09-3.64.2-8.13.23s-8.12,0-8.12-.1,3.63-.2,8.12-.24S308,96.56,308,96.66Z"
        style="fill:#263238"></path>
    <path
        d="M160.09,101.4l.34,0,.94,0,3.46-.08-.09.09c0-.77,0-1.61,0-2.51,0-.47,0-.91,0-1.45a1.34,1.34,0,0,1,1.17-1.07c.56,0,1,0,1.66,0a1.35,1.35,0,0,1,1.13,1.34c0,1.17,0,2.4,0,3.67l-.16-.16,4.38,0-.17.17c0-1.77,0-3.59,0-5.46,0-.46,0-.93,0-1.39a1.42,1.42,0,0,0-.61-1l-1.91-1.89-1.85-1.82-.9-.88a2,2,0,0,0-.9-.68,1.17,1.17,0,0,0-1,.19c-.27.23-.55.55-.82.81l-1.57,1.58c-1,1-2,2-2.76,2.85a3,3,0,0,0-.22,1.63c0,.55,0,1.06,0,1.55,0,.94,0,1.77,0,2.48s0,1.16,0,1.59,0,.56,0,.57a3.2,3.2,0,0,1,0-.52c0-.43,0-.94-.05-1.57s0-1.55,0-2.5c0-.5,0-1,0-1.58,0-.28,0-.56,0-.86a1.76,1.76,0,0,1,.25-.91c.81-1,1.77-1.87,2.77-2.93l1.56-1.6c.28-.27.51-.55.84-.83a1.47,1.47,0,0,1,1.27-.25,2.28,2.28,0,0,1,1.05.75l.9.88,1.85,1.81,1.92,1.89a3.65,3.65,0,0,1,.49.53,1.43,1.43,0,0,1,.23.73c0,.47,0,.93,0,1.4,0,1.87,0,3.69,0,5.45v.17h-.17l-4.37,0h-.16v-.16c0-1.27,0-2.49,0-3.67a1.07,1.07,0,0,0-.89-1.06c-.5,0-1.1,0-1.59,0a1.05,1.05,0,0,0-.94.85c0,.44,0,1,0,1.4v2.61h-.09l-3.53,0h-.92A1.45,1.45,0,0,1,160.09,101.4Z"
        style="fill:#263238"></path>
    <path
        d="M222.7,111.64c0,1.16-.92,1.83-2.68,1.83h-3.47v-6.7h3.27c1.68,0,2.54.7,2.54,1.74a1.61,1.61,0,0,1-.89,1.48A1.65,1.65,0,0,1,222.7,111.64Zm-4.61-3.7v1.58h1.54c.76,0,1.17-.27,1.17-.8s-.41-.78-1.17-.78Zm3,3.54c0-.56-.43-.83-1.24-.83h-1.81v1.66h1.81C220.71,112.31,221.14,112.06,221.14,111.48Z"
        style="fill:#263238"></path>
    <path
        d="M223.39,110.9a2.84,2.84,0,1,1,2.84,2.65A2.66,2.66,0,0,1,223.39,110.9Zm4.15,0a1.32,1.32,0,1,0-1.31,1.42A1.31,1.31,0,0,0,227.54,110.9Z"
        style="fill:#263238"></path>
    <path
        d="M229.67,110.9a2.84,2.84,0,1,1,2.83,2.65A2.65,2.65,0,0,1,229.67,110.9Zm4.15,0a1.32,1.32,0,1,0-1.32,1.42A1.31,1.31,0,0,0,233.82,110.9Z"
        style="fill:#263238"></path>
    <path d="M238.54,111.45l-.72.71v1.31h-1.49v-7.11h1.49v4l2.19-2.07h1.78l-2.15,2.18,2.34,3h-1.81Z"
        style="fill:#263238"></path>
    <path d="M242.43,106.77a.86.86,0,0,1,.93-.84.84.84,0,0,1,.93.81.93.93,0,0,1-1.86,0Zm.18,1.55h1.5v5.15h-1.5Z"
        style="fill:#263238"></path>
    <path
        d="M250.77,110.52v3h-1.5v-2.72c0-.83-.38-1.21-1-1.21S247,110,247,110.93v2.54H245.5v-5.15h1.43v.6a2.24,2.24,0,0,1,1.7-.68A2,2,0,0,1,250.77,110.52Z"
        style="fill:#263238"></path>
    <path
        d="M257.5,108.32v4.29c0,1.92-1,2.8-2.9,2.8a4.27,4.27,0,0,1-2.53-.71l.6-1.07a3.11,3.11,0,0,0,1.82.58c1,0,1.51-.48,1.51-1.41v-.22a2.12,2.12,0,0,1-1.63.64,2.49,2.49,0,1,1,0-5,2.07,2.07,0,0,1,1.71.74v-.66ZM256,110.73a1.36,1.36,0,1,0-1.35,1.27A1.25,1.25,0,0,0,256,110.73Z"
        style="fill:#263238"></path>
    <rect x="156.31" y="199.55" width="61.88" height="55.83" rx="2.55" style="fill:#9BCEA9"></rect>
    <path d="M236.49,204.86v5.51h-1.28v-2.26h-2.5v2.26h-1.27v-5.51h1.27V207h2.5v-2.17Z" style="fill:#263238"></path>
    <path
        d="M237.4,208.25a2.33,2.33,0,1,1,2.33,2.18A2.18,2.18,0,0,1,237.4,208.25Zm3.4,0a1.08,1.08,0,1,0-1.07,1.17A1.06,1.06,0,0,0,240.8,208.25Z"
        style="fill:#263238"></path>
    <path
        d="M245.6,210.16a1.68,1.68,0,0,1-1,.27,1.39,1.39,0,0,1-1.58-1.52v-1.74h-.66v-.94H243v-1h1.23v1h1.05v.94h-1.05v1.73a.49.49,0,0,0,.52.56.85.85,0,0,0,.5-.16Z"
        style="fill:#263238"></path>
    <path
        d="M250.29,208.6h-3.21a1.14,1.14,0,0,0,1.21.85,1.49,1.49,0,0,0,1.07-.41l.65.71a2.48,2.48,0,0,1-4.17-1.5,2.16,2.16,0,0,1,2.26-2.18,2.1,2.1,0,0,1,2.21,2.2C250.31,208.36,250.29,208.49,250.29,208.6Zm-3.23-.72h2.09a1.06,1.06,0,0,0-2.09,0Z"
        style="fill:#263238"></path>
    <path d="M251.13,204.53h1.23v5.84h-1.23Z" style="fill:#263238"></path>
    <polygon
        points="258.67 205.83 259.13 206.75 260.14 206.9 259.41 207.62 259.58 208.63 258.67 208.15 257.76 208.63 257.94 207.62 257.2 206.9 258.22 206.75 258.67 205.83"
        style="fill:#9BCEA9"></polygon>
    <polygon
        points="262.63 205.83 263.08 206.75 264.1 206.9 263.37 207.62 263.54 208.63 262.63 208.15 261.72 208.63 261.9 207.62 261.16 206.9 262.18 206.75 262.63 205.83"
        style="fill:#9BCEA9"></polygon>
    <polygon
        points="266.59 205.83 267.05 206.75 268.06 206.9 267.33 207.62 267.5 208.63 266.59 208.15 265.68 208.63 265.86 207.62 265.12 206.9 266.14 206.75 266.59 205.83"
        style="fill:#9BCEA9"></polygon>
    <polygon
        points="270.55 205.83 271.01 206.75 272.02 206.9 271.29 207.62 271.46 208.63 270.55 208.15 269.64 208.63 269.82 207.62 269.08 206.9 270.1 206.75 270.55 205.83"
        style="fill:#9BCEA9"></polygon>
    <polygon
        points="274.51 205.83 274.97 206.75 275.98 206.9 275.25 207.62 275.42 208.63 274.51 208.15 273.6 208.63 273.78 207.62 273.04 206.9 274.06 206.75 274.51 205.83"
        style="fill:#9BCEA9"></polygon>
    <path d="M275.28,215.89c0,.15-9.59.26-21.42.26s-21.42-.11-21.42-.26,9.59-.26,21.42-.26S275.28,215.75,275.28,215.89Z"
        style="fill:#e0e0e0"></path>
    <path d="M309,223.16c0,.14-17.35.26-38.73.26s-38.74-.12-38.74-.26,17.34-.26,38.74-.26S309,223,309,223.16Z"
        style="fill:#263238"></path>
    <path d="M270.35,230.6c0,.14-8.52.26-19,.26s-19-.12-19-.26,8.51-.26,19-.26S270.35,230.45,270.35,230.6Z"
        style="fill:#263238"></path>
    <rect x="230.83" y="238.55" width="45.2" height="14.38" rx="6.01" style="fill:#9BCEA9"></rect>
    <path
        d="M249.86,246.35c0,.69-.53,1.09-1.56,1.09h-1.94v-4.07h1.83c.93,0,1.46.4,1.46,1.06a1,1,0,0,1-.55.9A1,1,0,0,1,249.86,246.35Zm-2.92-2.5v1.3h1.2c.59,0,.93-.22.93-.65s-.34-.65-.93-.65Zm2.33,2.45c0-.47-.34-.68-1-.68h-1.34V247h1.34C248.93,247,249.27,246.77,249.27,246.3Z"
        style="fill:#fff"></path>
    <path
        d="M250.39,245.9a1.61,1.61,0,1,1,1.61,1.58A1.53,1.53,0,0,1,250.39,245.9Zm2.64,0a1,1,0,1,0-2.07,0,1,1,0,1,0,2.07,0Z"
        style="fill:#fff"></path>
    <path
        d="M254.09,245.9a1.6,1.6,0,1,1,1.6,1.58A1.53,1.53,0,0,1,254.09,245.9Zm2.63,0a1,1,0,1,0-2.07,0,1,1,0,1,0,2.07,0Z"
        style="fill:#fff"></path>
    <path d="M259.26,246l-.64.59v.84h-.56v-4.31h.56v2.77l1.68-1.54H261l-1.29,1.28,1.42,1.8h-.69Z" style="fill:#fff">
    </path>
    <path
        d="M195.19,245.44a5.4,5.4,0,0,1,0-.63c0-.43,0-1,0-1.76,0-1.57,0-3.79-.06-6.58,0-5.64-.07-13.57-.12-22.9l.24.23-21.49,0c-.06,0,.49-.49.26-.26h0v8.79c0,2.86,0,5.65,0,8.33,0,5.37,0,10.34,0,14.74l-.21-.21,15.6.11,4.34,0,1.15,0a2,2,0,0,1,.41,0,2.37,2.37,0,0,1-.37,0l-1.11,0-4.29,0-15.73.11h-.2v-.21c0-4.4,0-9.37,0-14.74,0-2.68,0-5.47,0-8.33V218c0-.74,0-1.47,0-2.22v-2.22h0c-.23.23.32-.32.27-.26l21.49,0h.24v.24c-.05,9.39-.09,17.38-.12,23.06,0,2.76-.05,5-.07,6.52,0,.72,0,1.29,0,1.72A3.92,3.92,0,0,1,195.19,245.44Z"
        style="fill:#fff"></path>
    <path
        d="M191,209.33a28.65,28.65,0,0,1,.24,4.24v.23H191l-2.84,0-.26-.27h0V212.4c0-.38,0-.75,0-1.11l0-2v-.21h.21a15.49,15.49,0,0,1,2.84.21,21.23,21.23,0,0,1-2.84.21l.21-.21c0,.62,0,1.27,0,2,0,.36,0,.73,0,1.11v1.15h0c.23.24-.32-.31-.26-.25l2.84,0-.24.24A35.93,35.93,0,0,1,191,209.33Z"
        style="fill:#fff"></path>
    <path
        d="M203.22,245.61a2.71,2.71,0,0,1-.51,0h-1.56l-6,0H195v-.15c-.06-7.17-.1-18.78-.1-31.87v-.26h8.55v.26c0,9.14-.08,17.17-.11,23,0,2.81-.06,5.08-.08,6.7,0,.74,0,1.33,0,1.78a4.17,4.17,0,0,1,0,.6,6.13,6.13,0,0,1,0-.66c0-.47,0-1.08,0-1.84,0-1.63,0-3.92-.07-6.76,0-5.75-.07-13.71-.12-22.78l.26.25h-8l.26-.26c0,13.09,0,24.7-.11,31.87l-.15-.16,5.87.21,1.59.07A4.19,4.19,0,0,1,203.22,245.61Z"
        style="fill:#fff"></path>
    <rect x="177.12" y="217.56" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="182.78" y="217.56" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="188.43" y="217.56" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="177.12" y="223.29" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="182.78" y="223.29" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="188.43" y="223.29" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="177.12" y="229.02" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="182.78" y="229.02" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="188.43" y="229.02" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="177.12" y="234.75" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="182.78" y="234.75" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="188.43" y="234.75" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="197.26" y="217.56" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="197.26" y="223.29" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="197.26" y="229.02" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="197.26" y="234.75" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="183.16" y="240.28" width="3.26" height="5.16" style="fill:#fff"></rect>
    <path d="M210.35,245.44c0,.14-10.34.26-23.1.26s-23.09-.12-23.09-.26,10.34-.26,23.09-.26S210.35,245.3,210.35,245.44Z"
        style="fill:#fff"></path>
    <path
        d="M312.85,263.12a6.15,6.15,0,0,0,1.22-.18,5,5,0,0,0,2.88-2,4.85,4.85,0,0,0,.84-2.47c0-1,0-2.06,0-3.22q0-3.51,0-8.06c0-12.13,0-29.67-.09-51.34a6.44,6.44,0,0,0-.18-2,4.93,4.93,0,0,0-.91-1.76,4.81,4.81,0,0,0-3.51-1.76h-8.68l-18.44,0-40.69,0-93.24,0a4.78,4.78,0,0,0-4.49,3.17,8,8,0,0,0-.28,3v3.07q0,6.12,0,12.16v23.79c0,7.79,0,15.45,0,22.94a4.81,4.81,0,0,0,3,4.07,5,5,0,0,0,1.28.31c.42,0,.89,0,1.36,0h13.64l76.14.06L294,263l14,.05,3.63,0,1.23,0-1.23,0-3.63,0-14,.05-51.34.08-76.14.05H152.91c-.47,0-.92,0-1.41,0a5.77,5.77,0,0,1-1.42-.34,5.29,5.29,0,0,1-3.3-4.49q0-11.26,0-23v-39c0-.52,0-1,0-1.55a5,5,0,0,1,.31-1.58,5.3,5.3,0,0,1,5-3.52l93.24,0,40.69,0h18.44l8.7,0a5.23,5.23,0,0,1,3.78,1.91,5.14,5.14,0,0,1,1,1.9,7,7,0,0,1,.19,2.07c0,21.67-.06,39.21-.08,51.34q0,4.54,0,8.06c0,1.17,0,2.24,0,3.23a5,5,0,0,1-3.84,4.54,3.88,3.88,0,0,1-.91.13Z"
        style="fill:#9BCEA9"></path>
    <rect x="154.48" y="282.09" width="61.88" height="55.83" rx="2.55" style="fill:#9BCEA9"></rect>
    <path d="M234.66,287.4v5.51h-1.28v-2.26h-2.5v2.26H229.6V287.4h1.28v2.17h2.5V287.4Z" style="fill:#263238"></path>
    <path
        d="M235.56,290.79a2.33,2.33,0,1,1,2.33,2.18A2.18,2.18,0,0,1,235.56,290.79Zm3.41,0a1.08,1.08,0,1,0-1.08,1.17A1.07,1.07,0,0,0,239,290.79Z"
        style="fill:#263238"></path>
    <path
        d="M243.77,292.7a1.72,1.72,0,0,1-1,.27,1.4,1.4,0,0,1-1.59-1.52v-1.74h-.65v-.94h.65v-1h1.23v1h1.06v.94h-1.06v1.73a.5.5,0,0,0,.53.56.88.88,0,0,0,.5-.16Z"
        style="fill:#263238"></path>
    <path
        d="M248.45,291.14h-3.2a1.12,1.12,0,0,0,1.21.85,1.45,1.45,0,0,0,1.06-.41l.66.71a2.23,2.23,0,0,1-1.75.68,2.2,2.2,0,0,1-2.42-2.18,2.16,2.16,0,0,1,2.26-2.18,2.09,2.09,0,0,1,2.2,2.2C248.47,290.9,248.46,291,248.45,291.14Zm-3.22-.72h2.09a1.06,1.06,0,0,0-2.09,0Z"
        style="fill:#263238"></path>
    <path d="M249.29,287.07h1.23v5.84h-1.23Z" style="fill:#263238"></path>
    <polygon
        points="256.84 288.37 257.29 289.29 258.31 289.44 257.57 290.16 257.75 291.17 256.84 290.69 255.93 291.17 256.1 290.16 255.37 289.44 256.38 289.29 256.84 288.37"
        style="fill:#9BCEA9"></polygon>
    <polygon
        points="260.8 288.37 261.25 289.29 262.27 289.44 261.53 290.16 261.71 291.17 260.8 290.69 259.89 291.17 260.06 290.16 259.33 289.44 260.34 289.29 260.8 288.37"
        style="fill:#9BCEA9"></polygon>
    <polygon
        points="264.76 288.37 265.21 289.29 266.23 289.44 265.49 290.16 265.67 291.17 264.76 290.69 263.85 291.17 264.02 290.16 263.29 289.44 264.3 289.29 264.76 288.37"
        style="fill:#9BCEA9"></polygon>
    <polygon
        points="268.72 288.37 269.17 289.29 270.19 289.44 269.45 290.16 269.63 291.17 268.72 290.69 267.81 291.17 267.98 290.16 267.25 289.44 268.26 289.29 268.72 288.37"
        style="fill:#e0e0e0"></polygon>
    <polygon
        points="272.68 288.37 273.13 289.29 274.15 289.44 273.41 290.16 273.59 291.17 272.68 290.69 271.77 291.17 271.94 290.16 271.21 289.44 272.22 289.29 272.68 288.37"
        style="fill:#e0e0e0"></polygon>
    <path d="M273.44,298.43c0,.15-9.59.26-21.41.26s-21.42-.11-21.42-.26,9.59-.26,21.42-.26S273.44,298.29,273.44,298.43Z"
        style="fill:#e0e0e0"></path>
    <path d="M307.18,305.7c0,.14-17.34.26-38.73.26s-38.73-.12-38.73-.26,17.34-.26,38.73-.26S307.18,305.55,307.18,305.7Z"
        style="fill:#263238"></path>
    <path d="M268.51,313.14c0,.14-8.51.26-19,.26s-19-.12-19-.26,8.51-.26,19-.26S268.51,313,268.51,313.14Z"
        style="fill:#263238"></path>
    <path
        d="M268.18,335.46s.39,0,1.09-.15a6.05,6.05,0,0,0,2.77-1.38,5.88,5.88,0,0,0,2-4.33c0-1,0-2,0-3.11a6,6,0,0,0-1.32-3.1,5.88,5.88,0,0,0-3.12-1.93,7.28,7.28,0,0,0-2-.16h-2.13l-9.24,0-21.18,0a5.78,5.78,0,0,0-5.65,4.65,16.12,16.12,0,0,0-.11,2.62,7.78,7.78,0,0,0,.26,2.53,5.78,5.78,0,0,0,5.45,4.07l17.29.06,11.66.08,3.17.05.82,0,.28,0a1,1,0,0,1-.28,0l-.82,0-3.17,0-11.66.09-17.3.05a6.27,6.27,0,0,1-5.92-4.4,8.15,8.15,0,0,1-.29-2.68,15.74,15.74,0,0,1,.12-2.72,6.22,6.22,0,0,1,1.15-2.57,6.28,6.28,0,0,1,5-2.5l21.18,0,9.24,0h2.13a8.14,8.14,0,0,1,2.09.19,6.24,6.24,0,0,1,3.32,2.09,6.32,6.32,0,0,1,1.36,3.29c.06,1.15,0,2.16,0,3.15a6.11,6.11,0,0,1-2.17,4.48,5.89,5.89,0,0,1-2.88,1.33,4.94,4.94,0,0,1-.82.07A.94.94,0,0,1,268.18,335.46Z"
        style="fill:#9BCEA9"></path>
    <path
        d="M248,328.88c0,.7-.53,1.1-1.56,1.1h-1.94v-4.07h1.82c.94,0,1.46.4,1.46,1a1,1,0,0,1-.54.91A1,1,0,0,1,248,328.88Zm-2.92-2.5v1.31h1.19c.59,0,.93-.23.93-.66s-.34-.65-.93-.65Zm2.33,2.46c0-.47-.35-.68-1-.68h-1.34v1.35h1.34C247.09,329.51,247.44,329.31,247.44,328.84Z"
        style="fill:#9BCEA9"></path>
    <path
        d="M248.56,328.44a1.6,1.6,0,1,1,1.61,1.58A1.53,1.53,0,0,1,248.56,328.44Zm2.64,0a1,1,0,1,0-2.08,0,1,1,0,1,0,2.08,0Z"
        style="fill:#9BCEA9"></path>
    <path
        d="M252.25,328.44a1.6,1.6,0,1,1,1.61,1.58A1.53,1.53,0,0,1,252.25,328.44Zm2.64,0a1,1,0,1,0-2.07,0,1,1,0,1,0,2.07,0Z"
        style="fill:#9BCEA9"></path>
    <path d="M257.42,328.55l-.64.59V330h-.55v-4.31h.55v2.76l1.68-1.53h.68l-1.3,1.27,1.43,1.81h-.69Z"
        style="fill:#9BCEA9"></path>
    <path
        d="M193.35,328s0-.23,0-.63,0-1,0-1.76c0-1.57,0-3.79-.07-6.58,0-5.64-.07-13.57-.11-22.91l.23.24-21.49,0,.26-.25h0v8.79c0,2.86,0,5.65,0,8.33,0,5.37,0,10.33,0,14.74l-.21-.21,15.59.11,4.35.05,1.15,0a1.79,1.79,0,0,1,.4,0,2.13,2.13,0,0,1-.36,0l-1.11,0-4.3.06-15.72.11h-.21V328c0-4.41,0-9.37,0-14.74,0-2.68,0-5.47,0-8.33v-8.79h0c-.23.23.32-.32.26-.27l21.49,0h.24v.23c-.05,9.4-.09,17.39-.12,23.06,0,2.77,0,5-.06,6.53,0,.72,0,1.29,0,1.72A3.92,3.92,0,0,1,193.35,328Z"
        style="fill:#fff"></path>
    <path
        d="M189.14,291.87a30.26,30.26,0,0,1,.24,4.23v.24h-.24l-2.85,0-.26-.26h0v-1.16c0-.37,0-.74,0-1.1,0-.69,0-1.34,0-2v-.22h.2a15.84,15.84,0,0,1,2.85.21,21.7,21.7,0,0,1-2.85.21l.21-.21,0,2c0,.36,0,.73,0,1.1v1.16h0l-.26-.26,2.85,0-.24.23A35.85,35.85,0,0,1,189.14,291.87Z"
        style="fill:#fff"></path>
    <path
        d="M201.38,328.15a4.44,4.44,0,0,1-.51,0h-1.55l-6,0h-.15V328c-.06-7.17-.11-18.79-.11-31.88v-.26h8.55v.25c0,9.15-.09,17.17-.12,23,0,2.81-.05,5.08-.07,6.7,0,.74,0,1.33,0,1.78a2.41,2.41,0,0,1,0,.6,6.13,6.13,0,0,1,0-.66c0-.47,0-1.08,0-1.84,0-1.64,0-3.92-.07-6.76,0-5.75-.07-13.71-.12-22.79l.25.26h-8l.26-.26c0,13.09,0,24.71-.1,31.88l-.15-.16,5.87.21,1.59.07A3.9,3.9,0,0,1,201.38,328.15Z"
        style="fill:#fff"></path>
    <rect x="175.29" y="300.1" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="180.94" y="300.1" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="186.6" y="300.1" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="175.29" y="305.83" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="180.94" y="305.83" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="186.6" y="305.83" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="175.29" y="311.56" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="180.94" y="311.56" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="186.6" y="311.56" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="175.29" y="317.29" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="180.94" y="317.29" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="186.6" y="317.29" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="195.42" y="300.1" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="195.42" y="305.83" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="195.42" y="311.56" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="195.42" y="317.29" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="181.33" y="322.82" width="3.26" height="5.16" style="fill:#fff"></rect>
    <path d="M208.52,328c0,.14-10.35.26-23.1.26s-23.1-.12-23.1-.26,10.34-.26,23.1-.26S208.52,327.83,208.52,328Z"
        style="fill:#fff"></path>
    <rect x="155.24" y="364.08" width="61.88" height="55.83" rx="2.55" style="fill:#9BCEA9"></rect>
    <path d="M235.42,369.39v5.51h-1.28v-2.26h-2.5v2.26h-1.28v-5.51h1.28v2.17h2.5v-2.17Z" style="fill:#263238">
    </path>
    <path
        d="M236.32,372.78a2.33,2.33,0,1,1,2.33,2.19A2.19,2.19,0,0,1,236.32,372.78Zm3.41,0a1.08,1.08,0,1,0-1.08,1.18A1.07,1.07,0,0,0,239.73,372.78Z"
        style="fill:#263238"></path>
    <path
        d="M244.53,374.7a1.76,1.76,0,0,1-1,.27,1.4,1.4,0,0,1-1.58-1.53v-1.73h-.66v-.95H242v-1h1.22v1h1.06v.95h-1.06v1.72a.5.5,0,0,0,.53.56.88.88,0,0,0,.5-.16Z"
        style="fill:#263238"></path>
    <path
        d="M249.21,373.13H246a1.13,1.13,0,0,0,1.21.85,1.41,1.41,0,0,0,1.06-.41l.66.71a2.24,2.24,0,0,1-1.75.69,2.21,2.21,0,0,1-2.42-2.19A2.16,2.16,0,0,1,247,370.6a2.1,2.1,0,0,1,2.21,2.2C249.24,372.89,249.22,373,249.21,373.13Zm-3.22-.72h2.09a1.06,1.06,0,0,0-2.09,0Z"
        style="fill:#263238"></path>
    <path d="M250.06,369.06h1.22v5.84h-1.22Z" style="fill:#263238"></path>
    <polygon
        points="257.6 370.37 258.05 371.29 259.07 371.43 258.33 372.15 258.51 373.16 257.6 372.68 256.69 373.16 256.87 372.15 256.13 371.43 257.14 371.29 257.6 370.37"
        style="fill:#9BCEA9"></polygon>
    <polygon
        points="261.56 370.37 262.01 371.29 263.03 371.43 262.29 372.15 262.47 373.16 261.56 372.68 260.65 373.16 260.82 372.15 260.09 371.43 261.11 371.29 261.56 370.37"
        style="fill:#9BCEA9"></polygon>
    <polygon
        points="265.52 370.37 265.97 371.29 266.99 371.43 266.25 372.15 266.43 373.16 265.52 372.68 264.61 373.16 264.79 372.15 264.05 371.43 265.07 371.29 265.52 370.37"
        style="fill:#e0e0e0"></polygon>
    <polygon
        points="269.48 370.37 269.93 371.29 270.95 371.43 270.21 372.15 270.39 373.16 269.48 372.68 268.57 373.16 268.75 372.15 268.01 371.43 269.03 371.29 269.48 370.37"
        style="fill:#e0e0e0"></polygon>
    <polygon
        points="273.44 370.37 273.89 371.29 274.91 371.43 274.18 372.15 274.35 373.16 273.44 372.68 272.53 373.16 272.71 372.15 271.97 371.43 272.99 371.29 273.44 370.37"
        style="fill:#e0e0e0"></polygon>
    <path d="M274.21,380.43c0,.14-9.59.26-21.42.26s-21.42-.12-21.42-.26,9.59-.27,21.42-.27S274.21,380.28,274.21,380.43Z"
        style="fill:#e0e0e0"></path>
    <path d="M308,387.69c0,.14-17.35.26-38.74.26s-38.73-.12-38.73-.26,17.34-.26,38.73-.26S308,387.55,308,387.69Z"
        style="fill:#263238"></path>
    <path d="M269.27,395.13c0,.14-8.51.26-19,.26s-19-.12-19-.26,8.51-.26,19-.26S269.27,395,269.27,395.13Z"
        style="fill:#263238"></path>
    <path
        d="M269,417.46s.38,0,1.09-.16a6,6,0,0,0,2.76-1.38,5.9,5.9,0,0,0,2-4.33c0-1,0-2-.05-3.11a5.81,5.81,0,0,0-4.44-5,8.07,8.07,0,0,0-2-.16h-2.14l-9.24,0-21.17,0a5.78,5.78,0,0,0-4.6,2.3,5.55,5.55,0,0,0-1.05,2.35,14.29,14.29,0,0,0-.11,2.63,7.57,7.57,0,0,0,.25,2.53,5.93,5.93,0,0,0,1.21,2.13,5.73,5.73,0,0,0,4.24,1.93l17.29.06,11.66.09,3.17,0,.83,0,.28,0a1.58,1.58,0,0,1-.28,0l-.83,0-3.17.05-11.66.08-17.3.05a6.24,6.24,0,0,1-4.6-2.08,6.33,6.33,0,0,1-1.32-2.31,7.93,7.93,0,0,1-.28-2.68,14.89,14.89,0,0,1,.11-2.73,6.29,6.29,0,0,1,6.16-5.07l21.17,0,9.24,0h2.14a8.18,8.18,0,0,1,2.09.19,6.17,6.17,0,0,1,4.67,5.39c.06,1.14,0,2.16,0,3.15a6.09,6.09,0,0,1-2.17,4.47,5.89,5.89,0,0,1-2.88,1.33,4,4,0,0,1-.82.07A1.16,1.16,0,0,1,269,417.46Z"
        style="fill:#9BCEA9"></path>
    <path
        d="M248.79,410.88c0,.69-.53,1.09-1.56,1.09h-1.94V407.9h1.83c.93,0,1.45.4,1.45,1.06a.94.94,0,0,1-.54.9A1,1,0,0,1,248.79,410.88Zm-2.92-2.5v1.3h1.19c.6,0,.93-.22.93-.65s-.33-.65-.93-.65Zm2.33,2.45c0-.47-.35-.68-1-.68h-1.34v1.35h1.34C247.85,411.5,248.2,411.3,248.2,410.83Z"
        style="fill:#9BCEA9"></path>
    <path
        d="M249.32,410.43a1.61,1.61,0,1,1,1.61,1.58A1.53,1.53,0,0,1,249.32,410.43Zm2.64,0a1,1,0,1,0-1,1.09A1,1,0,0,0,252,410.43Z"
        style="fill:#9BCEA9"></path>
    <path
        d="M253,410.43a1.61,1.61,0,1,1,1.61,1.58A1.53,1.53,0,0,1,253,410.43Zm2.64,0a1,1,0,1,0-2.07,0,1,1,0,1,0,2.07,0Z"
        style="fill:#9BCEA9"></path>
    <path d="M258.19,410.54l-.64.59V412H257v-4.31h.56v2.77l1.68-1.54h.67l-1.3,1.28L260,412h-.69Z" style="fill:#9BCEA9">
    </path>
    <path
        d="M194.12,410a5.4,5.4,0,0,1,0-.63c0-.43,0-1,0-1.76,0-1.57,0-3.79-.06-6.58,0-5.64-.07-13.57-.12-22.9l.24.24-21.49,0c-.07.05.49-.49.25-.26h0v8.79c0,2.87,0,5.65,0,8.34,0,5.36,0,10.33,0,14.73l-.21-.21,15.6.11,4.34.05,1.15,0,.41,0a1.46,1.46,0,0,1-.37,0l-1.11,0-4.29.05-15.73.11h-.2V410c0-4.4,0-9.37,0-14.73q0-4,0-8.34c0-1.43,0-2.88,0-4.35v-4.44h0c-.23.23.32-.32.27-.26l21.49,0h.24v.24c0,9.4-.08,17.38-.11,23.06,0,2.76-.05,5-.07,6.52,0,.72,0,1.29,0,1.72A3.39,3.39,0,0,1,194.12,410Z"
        style="fill:#fff"></path>
    <path
        d="M189.9,373.86a28.65,28.65,0,0,1,.24,4.24v.23h-.24l-2.84,0-.26-.26h0v-1.15c0-.38,0-.75,0-1.11l0-2v-.21h.21a15.78,15.78,0,0,1,2.84.21,21.64,21.64,0,0,1-2.84.21l.2-.21c0,.62,0,1.28,0,2,0,.36,0,.73,0,1.11,0,.19,0,.38,0,.58v.57h0l-.26-.26,2.84,0-.24.24A36.13,36.13,0,0,1,189.9,373.86Z"
        style="fill:#fff"></path>
    <path
        d="M202.15,410.14a2.71,2.71,0,0,1-.51,0h-1.56l-6,0H194V410c-.06-7.17-.1-18.78-.1-31.87v-.26h8.54v.26c0,9.14-.08,17.17-.11,23,0,2.82-.06,5.08-.08,6.7,0,.74,0,1.33,0,1.79a4.08,4.08,0,0,1,0,.59s0-.24,0-.66,0-1.07,0-1.84c0-1.63,0-3.92-.07-6.76,0-5.75-.07-13.71-.12-22.78l.26.25h-8l.26-.26c0,13.09,0,24.7-.11,31.87l-.15-.15L200,410l1.59.07Z"
        style="fill:#fff"></path>
    <rect x="176.05" y="382.09" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="181.7" y="382.09" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="187.36" y="382.09" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="176.05" y="387.82" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="181.7" y="387.82" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="187.36" y="387.82" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="176.05" y="393.55" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="181.7" y="393.55" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="187.36" y="393.55" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="176.05" y="399.28" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="181.7" y="399.28" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="187.36" y="399.28" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="196.19" y="382.09" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="196.19" y="387.82" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="196.19" y="393.55" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="196.19" y="399.28" width="3.33" height="3.33" style="fill:#fff"></rect>
    <rect x="182.09" y="404.81" width="3.26" height="5.16" style="fill:#fff"></rect>
    <path d="M209.28,410c0,.14-10.34.26-23.1.26s-23.1-.12-23.1-.26,10.34-.26,23.1-.26S209.28,409.83,209.28,410Z"
        style="fill:#fff"></path>
    <path
        d="M167.68,125.58H294.87a7.09,7.09,0,0,1,7.09,7.09v7.12a7.1,7.1,0,0,1-7.1,7.1H167.68a7.09,7.09,0,0,1-7.09-7.09v-7.12A7.09,7.09,0,0,1,167.68,125.58Z"
        style="fill:#ebebeb"></path>
    <path
        d="M291,134.84s0-.26-.16-.7a2.88,2.88,0,0,0-3.74-1.93,2.81,2.81,0,1,0,2.66,4.88,2.86,2.86,0,0,0,1.08-1.55c.13-.44.13-.7.16-.7s0,.06,0,.19a1.94,1.94,0,0,1-.05.54,2.92,2.92,0,0,1-1.06,1.71,3.08,3.08,0,1,1,0-4.88,2.93,2.93,0,0,1,1.06,1.7,2,2,0,0,1,.05.55C291.06,134.77,291.05,134.84,291,134.84Z"
        style="fill:#263238"></path>
    <path
        d="M292.66,139.92a5.7,5.7,0,0,1-1.44-1.31,5.63,5.63,0,0,1-1.2-1.55,5.86,5.86,0,0,1,1.45,1.32A5.93,5.93,0,0,1,292.66,139.92Z"
        style="fill:#263238"></path>
    <path d="M174.1,135.16h-1.3v-.47h3.14v.47h-1.3v3.33h-.54Z" style="fill:#263238"></path>
    <path
        d="M175.89,137.05a1.5,1.5,0,1,1,1.5,1.48A1.43,1.43,0,0,1,175.89,137.05Zm2.47,0a1,1,0,1,0-1,1A.95.95,0,0,0,178.36,137.05Z"
        style="fill:#263238"></path>
    <path
        d="M179.36,136a.36.36,0,0,1,.37-.37.35.35,0,0,1,.36.37.36.36,0,0,1-.36.37A.37.37,0,0,1,179.36,136Zm0,2.19a.36.36,0,0,1,.37-.37.35.35,0,0,1,.36.37.36.36,0,0,1-.36.38A.37.37,0,0,1,179.36,138.15Z"
        style="fill:#263238"></path>
    <path d="M263.25,137.17c0,.14-16.21.26-36.2.26s-36.2-.12-36.2-.26,16.21-.26,36.2-.26S263.25,137,263.25,137.17Z"
        style="fill:#263238"></path>
    <rect x="160.58" y="154.22" width="141.38" height="21.31" rx="7.09" style="fill:#ebebeb"></rect>
    <path
        d="M291,164.47s0-.26-.16-.7a2.93,2.93,0,0,0-1.08-1.55,2.81,2.81,0,1,0,0,4.5,2.88,2.88,0,0,0,1.08-1.54c.13-.44.13-.71.16-.71s0,.07,0,.19a2,2,0,0,1-.05.55,2.93,2.93,0,0,1-1.06,1.7,3.05,3.05,0,0,1-2.91.48,3.09,3.09,0,0,1,0-5.83A3.05,3.05,0,0,1,290,162a2.9,2.9,0,0,1,1.06,1.7,1.94,1.94,0,0,1,.05.54C291.06,164.41,291.05,164.47,291,164.47Z"
        style="fill:#263238"></path>
    <path
        d="M292.66,169.56a6.13,6.13,0,0,1-1.44-1.32,5.84,5.84,0,0,1-1.2-1.54,5.86,5.86,0,0,1,1.45,1.32A5.93,5.93,0,0,1,292.66,169.56Z"
        style="fill:#263238"></path>
    <path d="M173.34,162.26H175a1.91,1.91,0,1,1,0,3.8h-1.61Zm1.57,3.33a1.43,1.43,0,1,0,0-2.86h-1v2.86Z"
        style="fill:#263238"></path>
    <path
        d="M180,164.32v1.74h-.5v-.38a1.06,1.06,0,0,1-.94.41c-.65,0-1.07-.35-1.07-.85s.3-.84,1.16-.84h.83v-.1c0-.44-.26-.7-.78-.7a1.45,1.45,0,0,0-.91.31l-.22-.39a1.92,1.92,0,0,1,1.19-.37C179.59,163.15,180,163.53,180,164.32Zm-.52.86v-.4h-.81c-.51,0-.66.2-.66.44s.24.47.64.47A.84.84,0,0,0,179.52,165.18Z"
        style="fill:#263238"></path>
    <path
        d="M182.62,165.89a.93.93,0,0,1-.63.2.82.82,0,0,1-.91-.9v-1.58h-.49v-.43h.49v-.63h.52v.63h.83v.43h-.83v1.56a.42.42,0,0,0,.45.48.69.69,0,0,0,.41-.13Z"
        style="fill:#263238"></path>
    <path
        d="M185.75,164.79h-2.34a1,1,0,0,0,1,.85,1.12,1.12,0,0,0,.84-.35l.28.33a1.41,1.41,0,0,1-1.13.47,1.44,1.44,0,0,1-1.55-1.47,1.41,1.41,0,0,1,1.45-1.47,1.39,1.39,0,0,1,1.42,1.49S185.75,164.74,185.75,164.79Zm-2.34-.37h1.85a.9.9,0,0,0-.92-.83A.91.91,0,0,0,183.41,164.42Z"
        style="fill:#263238"></path>
    <path
        d="M186.24,163.52a.37.37,0,0,1,.37-.37.38.38,0,0,1,0,.75A.37.37,0,0,1,186.24,163.52Zm0,2.2a.36.36,0,0,1,.37-.37.35.35,0,0,1,.35.37.36.36,0,0,1-.35.37A.37.37,0,0,1,186.24,165.72Z"
        style="fill:#263238"></path>
    <path
        d="M204.75,164.8a21.66,21.66,0,0,1-4.77.26,21.72,21.72,0,0,1-4.78-.26,22.47,22.47,0,0,1,4.78-.26A22.42,22.42,0,0,1,204.75,164.8Z"
        style="fill:#263238"></path>
    <path d="M241.24,164.87c0,.15-6.87.26-15.35.26s-15.34-.11-15.34-.26,6.87-.26,15.34-.26S241.24,164.73,241.24,164.87Z"
        style="fill:#263238"></path>
</g>
<g id="freepik--Character--inject-4">
    <path
        d="M447.39,203.76H436.7l-16.24,46.61,24.78,36.7c7.68,1.61,16.65,2.91,22.52-2.29,4.83-4.28,5.66-11.43,5.91-17.89a257,257,0,0,0-.67-31.15c-.64-7.78-1.74-15.81-5.89-22.43S455,201.9,447.39,203.76"
        style="fill:#455a64"></path>
    <path
        d="M457.68,287.77a8.69,8.69,0,0,0,.89-.18,5,5,0,0,0,2.17-1.33,7.33,7.33,0,0,0,1.87-3.56,34.59,34.59,0,0,0,.63-5.41,307.94,307.94,0,0,0,.64-31.68,159.3,159.3,0,0,0-1.31-17.38,53.89,53.89,0,0,0-3.73-13.67,37.43,37.43,0,0,0-4.83-8.24c-.71-.89-1.29-1.55-1.69-2l-.45-.51a1.14,1.14,0,0,1-.15-.18s.07,0,.19.15l.49.47c.43.42,1,1.06,1.76,1.93a35.94,35.94,0,0,1,5,8.22A53.4,53.4,0,0,1,463,228.16a150.7,150.7,0,0,1,1.36,17.43,275.31,275.31,0,0,1-.8,31.73,32.22,32.22,0,0,1-.71,5.46,7.49,7.49,0,0,1-2,3.63,5,5,0,0,1-2.28,1.28A2.79,2.79,0,0,1,457.68,287.77Z"
        style="fill:#263238"></path>
    <path
        d="M474,258.71a8.24,8.24,0,0,1-4.65,1.67,8.33,8.33,0,0,1-4.89-.77,25.67,25.67,0,0,0,4.84.25A27.32,27.32,0,0,0,474,258.71Z"
        style="fill:#263238"></path>
    <path
        d="M473.35,235.64a10.38,10.38,0,0,1-4.71,1.84,10.17,10.17,0,0,1-5.06-.12c0-.16,2.27.1,5-.39S473.28,235.49,473.35,235.64Z"
        style="fill:#263238"></path>
    <path
        d="M448.38,203.56s-1.33-5.24,1.13-5.55,9.59,2.83,8.5,5.63a22.25,22.25,0,0,1-2.44,4.62l-1-1.36s1.7-2.1,1.5-3.54-4.93-3.91-5.65-2.47a6.8,6.8,0,0,0-.72,2.75Z"
        style="fill:#263238"></path>
    <path
        d="M360.11,210.16l-42.73.83-6.91-.6s-15.63-.44-17.13-.67c-1.73-.27-2.28.5-2.33,1.14-.09,1,1,1.9,2.5,2.18.51.09,8.63,1.28,8.63,1.28a19.85,19.85,0,0,0-2.43,1.23c-1.7,1-3,3.65-3.36,6.55s-.2,3.75.92,3.94a1.46,1.46,0,0,0,1.18-.4,4.08,4.08,0,0,0,1.1-2.14c.95-5.53,3.15-5.17,3.15-5.17l1,0s-2.5,2.6-2,5a2.58,2.58,0,0,0,.42,1,3.66,3.66,0,0,0,4.91,4c.58-.22,1.16-.7,1.13-1.32a1.79,1.79,0,0,0-.37-.89,4,4,0,0,1-.24-.46l2.56-.14s5.74-.61,8.27-.59l40.15,1.33c5.71.6,11.9-.61,12.4-6.33h0C371.43,213.61,366.36,209.82,360.11,210.16Z"
        style="fill:#ffbe9d"></path>
    <path
        d="M316.62,212.24a2.13,2.13,0,0,1-1.48,2c-.82.35-1.74.4-2.58.68-2.53.84-4.1,3.59-6.67,4.31-.35.1-.83.11-1-.22s.06-.66.27-.93l5.41-7"
        style="fill:#ffbe9d"></path>
    <path
        d="M310.57,211.1a3.51,3.51,0,0,0-.67.69c-.4.47-1,1.16-1.65,2l-2.41,3-.69.88a1.7,1.7,0,0,0-.55,1.2.74.74,0,0,0,.57.61,1.62,1.62,0,0,0,.73,0,6.3,6.3,0,0,0,1.2-.49,32.53,32.53,0,0,0,3.77-2.91,6.54,6.54,0,0,1,1.74-1c.58-.21,1.18-.3,1.72-.45a3.14,3.14,0,0,0,2.18-1.47,1.16,1.16,0,0,0,.11-1,2.6,2.6,0,0,1-.29.87,3,3,0,0,1-2.09,1.23,17.6,17.6,0,0,0-1.77.39,6.76,6.76,0,0,0-1.87,1,41.44,41.44,0,0,1-3.73,2.84,5.92,5.92,0,0,1-1.09.44c-.36.09-.69,0-.69-.17s.21-.54.44-.84l.68-.88,2.32-3.09c.65-.88,1.18-1.6,1.53-2.11A4.15,4.15,0,0,0,310.57,211.1Z"
        style="fill:#eb996e"></path>
    <path
        d="M303.66,218.31a3.44,3.44,0,0,0-1.64.29,2.82,2.82,0,0,0-1.24,1.25,7.27,7.27,0,0,0-.65,2.14,11.68,11.68,0,0,1-.56,2.26,3.62,3.62,0,0,1-1.11,1.57,1.47,1.47,0,0,1-1.27.27c-.3-.09-.43-.21-.42-.22s.16,0,.45.1a1.4,1.4,0,0,0,1.1-.33,3.65,3.65,0,0,0,1-1.5,12.61,12.61,0,0,0,.52-2.21,7.11,7.11,0,0,1,.71-2.23,2.94,2.94,0,0,1,1.41-1.31,2.58,2.58,0,0,1,1.28-.2C303.51,218.22,303.67,218.29,303.66,218.31Z"
        style="fill:#eb996e"></path>
    <path
        d="M293,212.92a8.78,8.78,0,0,1,1.61.23l3.87.64,3.88.58a11.15,11.15,0,0,1,1.61.28,6.41,6.41,0,0,1-1.63-.05c-1-.09-2.39-.25-3.91-.49s-2.88-.51-3.86-.74A7.53,7.53,0,0,1,293,212.92Z"
        style="fill:#eb996e"></path>
    <path
        d="M305.21,220.42a2.18,2.18,0,0,1-.26.44,1.52,1.52,0,0,0-.25,1.24.82.82,0,0,0,.61.52,4.28,4.28,0,0,0,1.06.09,1.83,1.83,0,0,1,1.24.39,1.58,1.58,0,0,1,.45,1.33,1.78,1.78,0,0,1-.75,1.18,2.15,2.15,0,0,1-1.22.43,7.05,7.05,0,0,1-2.07-.36,4.17,4.17,0,0,1-1.27-.61,1.16,1.16,0,0,1-.34-.39s.14.11.41.28a5,5,0,0,0,1.27.5,7.7,7.7,0,0,0,2,.28,1.74,1.74,0,0,0,1.65-1.35,1.24,1.24,0,0,0-.34-1.06,1.55,1.55,0,0,0-1-.32,4.72,4.72,0,0,1-1.13-.13,1.06,1.06,0,0,1-.75-.71,1.58,1.58,0,0,1,.37-1.38C305.06,220.53,305.19,220.41,305.21,220.42Z"
        style="fill:#eb996e"></path>
    <path
        d="M307.09,225.44a.68.68,0,0,1,.45.12,1.4,1.4,0,0,1,.68,1.07,1.89,1.89,0,0,1-.82,1.69,3.15,3.15,0,0,1-2.26.46,3.75,3.75,0,0,1-2.05-1,3.6,3.6,0,0,1-.94-1.62,3.46,3.46,0,0,1-.1-1.26c0-.29.1-.45.12-.44a5.53,5.53,0,0,0,.2,1.63,3.55,3.55,0,0,0,.93,1.48,3.59,3.59,0,0,0,1.89.92,2.89,2.89,0,0,0,2-.39,1.68,1.68,0,0,0,.76-1.42,1.37,1.37,0,0,0-.52-1C307.24,225.5,307.08,225.47,307.09,225.44Z"
        style="fill:#eb996e"></path>
    <path
        d="M313.37,220.7s-.05-.3.13-.77a3,3,0,0,1,1.28-1.53l0,.28a8.1,8.1,0,0,1-1.06-.34,7,7,0,0,1-3.12-2.2,17,17,0,0,0,3.24,1.89,10.32,10.32,0,0,0,1,.35l.35.11-.32.18a3.21,3.21,0,0,0-1.26,1.34C313.46,220.42,313.41,220.71,313.37,220.7Z"
        style="fill:#eb996e"></path>
    <path d="M299.55,218.72c.05-.07.58.33.78,1.09s-.07,1.37-.15,1.33,0-.59-.17-1.25S299.48,218.78,299.55,218.72Z"
        style="fill:#eb996e"></path>
    <path
        d="M392.36,183.17c-.66.93-29.86,24.05-33.48,25s-37,1.46-37,1.46-2.61,20.53-1.75,21.93c3.17,5.12,41.3,18.67,59.49.32l12.73-46.54"
        style="fill:#9BCEA9"></path>
    <path
        d="M355.71,220.73a5.12,5.12,0,0,1-.36-1.8,16.42,16.42,0,0,1,1.66-8.64,5.19,5.19,0,0,1,1-1.54,37.36,37.36,0,0,0-1.91,5.84A37.88,37.88,0,0,0,355.71,220.73Z"
        style="fill:#263238"></path>
    <path
        d="M358.88,221.53a6.78,6.78,0,0,1-.41-2,42.9,42.9,0,0,1-.2-9.61,6.53,6.53,0,0,1,.34-2c.15,0-.07,3,0,6.77S359,221.51,358.88,221.53Z"
        style="fill:#263238"></path>
    <g style="opacity:0.30000000000000004">
        <path
            d="M357.85,208.79a16.37,16.37,0,0,0-4.76,17.44c.32.94.87,2,1.84,2.15a2.16,2.16,0,0,0,2.17-1.25,6.31,6.31,0,0,0,.5-2.62l.75-16">
        </path>
    </g>
    <polygon points="392.58 186.86 393.35 181.94 387.14 187.41 384.05 198.13 392.58 186.86" style="fill:#263238">
    </polygon>
    <path
        d="M399.28,176.86l-4.36,2.45-14,23.55.06,12.33s-3.3,8.63-3.5,15.55,0,32.26,0,32.26L359.71,380.48l15.15,4.89,30-136.79V175Z"
        style="fill:#9BCEA9"></path>
    <g style="opacity:0.30000000000000004">
        <path
            d="M374.86,385.37l-12-3.87L380,254.06s-2.87-18.68,0-26.86S387.28,207,387.28,207l-5,22.82c.63,17.09-.42,37.49-2.25,59.47h4.58Z">
        </path>
    </g>
    <path
        d="M389.06,189.14a3.45,3.45,0,0,1-.36.62c-.23.41-.63,1-1.08,1.75a53.73,53.73,0,0,0-3.36,6.75,70.86,70.86,0,0,0-3.39,10.66,115.24,115.24,0,0,0-2.25,13.53c-.55,4.85-.88,9.48-1,13.7s-.13,8-.1,11.22,0,5.73,0,7.58c0,.85,0,1.53,0,2.06a4.82,4.82,0,0,1,0,.71,3.14,3.14,0,0,1-.06-.71c0-.52,0-1.21-.07-2.06-.05-1.85-.12-4.42-.2-7.57s-.13-7,0-11.25.45-8.88,1-13.73a112,112,0,0,1,2.3-13.59,67.3,67.3,0,0,1,3.52-10.69,47.24,47.24,0,0,1,3.53-6.72c.47-.75.9-1.31,1.17-1.7A3.52,3.52,0,0,1,389.06,189.14Z"
        style="fill:#263238"></path>
    <g style="opacity:0.30000000000000004">
        <path
            d="M370.55,238a71.86,71.86,0,0,1,7.61-20,104.54,104.54,0,0,1-.83,13.47,5.17,5.17,0,0,1-.88,2.71,5.34,5.34,0,0,1-1.62,1.2l-4.59,2.55">
        </path>
    </g>
    <path
        d="M433.73,142.26a12.84,12.84,0,0,1,5.59-6.2,8.81,8.81,0,0,1,8.17-.09,6.74,6.74,0,0,1,3.38,7.16,9.24,9.24,0,1,1-8.21,16.56c2.33,3.08.34,8.11-3.31,9.35s-7.9-.91-9.72-4.31-1.49-7.65.12-11.16"
        style="fill:#263238"></path>
    <path
        d="M432.09,144.22a4.12,4.12,0,0,1,3.17-2.49,3.31,3.31,0,0,1,3.4,2,2.79,2.79,0,0,1-1.47,3.5,3.87,3.87,0,0,1-1.51,7.4,3.58,3.58,0,0,1-5.31,4.6,4.81,4.81,0,0,1-1.65-3.28,14.4,14.4,0,0,1,.24-3.76c.29-1.88.57-3.77.86-5.65a6.09,6.09,0,0,1,.71-2.39,2.1,2.1,0,0,1,2.1-1.07"
        style="fill:#9BCEA9"></path>
    <path
        d="M386.39,128.76c-1.35-2.42-.51-5.67,1.5-7.59a10.69,10.69,0,0,1,7.69-2.56,31.23,31.23,0,0,1,8.13,1.69,8.86,8.86,0,0,1,15.54,3,5.62,5.62,0,0,1,7.55,6.48l-11.75,5.91L404.64,161A10.85,10.85,0,0,1,387,148.75a9.06,9.06,0,0,1-2.19-2.09,9.48,9.48,0,0,1-5.1-5.27A10,10,0,0,1,386.39,128.76Z"
        style="fill:#263238"></path>
    <path
        d="M400.88,177c.27-3.95.46-6.66.46-6.63s-7.62-1.89-8.43-12.1c-.4-5.08.51-13.27,1.46-20,.86-6,5.45-13.12,11.43-12l18.44,6.24c1.81.34,2.33,1.94,2.15,3.77l.08.88L423.31,166l-1.25,12.85a10.64,10.64,0,0,1-10.74,9.52h0A10.65,10.65,0,0,1,400.88,177Z"
        style="fill:#ffbe9d"></path>
    <path
        d="M396.29,146.29a1.32,1.32,0,0,0,1.15,1.41,1.24,1.24,0,0,0,1.42-1.06,1.3,1.3,0,0,0-1.14-1.41A1.25,1.25,0,0,0,396.29,146.29Z"
        style="fill:#263238"></path>
    <path
        d="M396.06,143.79c.14.18,1.18-.47,2.57-.35s2.36.89,2.52.73-.06-.39-.48-.75a3.55,3.55,0,0,0-2-.79,3.45,3.45,0,0,0-2.06.49C396.15,143.41,396,143.71,396.06,143.79Z"
        style="fill:#263238"></path>
    <path
        d="M408.92,147.31a1.3,1.3,0,0,0,1.15,1.4,1.24,1.24,0,0,0,1.42-1.06,1.29,1.29,0,0,0-1.14-1.4A1.24,1.24,0,0,0,408.92,147.31Z"
        style="fill:#263238"></path>
    <path
        d="M409.36,144.58c.15.18,1.19-.47,2.58-.36s2.35.89,2.52.73-.06-.38-.48-.74a3.59,3.59,0,0,0-2-.8,3.41,3.41,0,0,0-2.07.5C409.46,144.2,409.29,144.49,409.36,144.58Z"
        style="fill:#263238"></path>
    <path
        d="M403.6,154a8.9,8.9,0,0,0-2.22-.59c-.36-.07-.69-.16-.73-.41a1.88,1.88,0,0,1,.32-1l1.27-2.63c1.76-3.73,3.07-6.81,2.92-6.88s-1.71,2.9-3.47,6.63l-1.22,2.64a2.06,2.06,0,0,0-.3,1.38.89.89,0,0,0,.55.57,2.11,2.11,0,0,0,.59.13A9.69,9.69,0,0,0,403.6,154Z"
        style="fill:#263238"></path>
    <path d="M401.34,170.41a25.76,25.76,0,0,0,13.78-2.53s-4,6.84-14,5.1Z" style="fill:#eb996e"></path>
    <path
        d="M409.65,140.8c.14.38,1.53.19,3.17.38s3,.62,3.18.28c.1-.16-.14-.52-.67-.88a5.19,5.19,0,0,0-2.36-.81,5.41,5.41,0,0,0-2.48.3C409.89,140.32,409.59,140.62,409.65,140.8Z"
        style="fill:#263238"></path>
    <path
        d="M396.32,141.06c.26.34,1.42.1,2.79.2s2.5.41,2.79.1c.13-.15,0-.48-.51-.82a4.34,4.34,0,0,0-2.22-.7,4.25,4.25,0,0,0-2.27.46C396.39,140.59,396.2,140.9,396.32,141.06Z"
        style="fill:#263238"></path>
    <path
        d="M419.13,126.61a6.92,6.92,0,0,1-8.66,6.19c-1.52-.4-3.15-1.31-4.54-.59s-1.69,2.86-3,3.85c-1.9,1.4-4.61-.26-6.92.23-1.78.39-3,2-4.26,3.28s-3.1,2.51-4.81,1.86a21.18,21.18,0,0,1,1.05-4.6,6.91,6.91,0,0,1,2.93-3.58c.76-.42,1.62-.64,2.33-1.13,1.54-1.05,2-3.06,3-4.62a7.59,7.59,0,0,1,6.05-3.38c2-.05,4,.7,6,.37,1.45-.25,2.77-1.09,4.24-1.25,2.86-.32,5.33,1.91,7.22,4.08"
        style="fill:#263238"></path>
    <path
        d="M409.8,129.93c1.29-.26,3.94-.88,4.7-1.93a7.77,7.77,0,0,1,7-3.34,6.4,6.4,0,0,1,5.35,5.48,9.2,9.2,0,0,1,7.49,5.68,10.66,10.66,0,0,1-1,9.86A18.75,18.75,0,0,0,432.1,148a15.61,15.61,0,0,1,1.94,2.25c2.67,4.34-2.75,6.83-2.75,6.83.38,3.1-2.48,3.45-4.31,3.68s-2.22,5.24-3.67,5.23l-.49-15.27a2,2,0,0,1-.66.21c-3.44.5-3.38-6.15-2.48-8a19.64,19.64,0,0,1-3.12-3.84,14.19,14.19,0,0,1-1-7C414.3,132.16,409.23,130.05,409.8,129.93Z"
        style="fill:#263238"></path>
    <path
        d="M422.4,151.63a3,3,0,0,1,4.5-2.18c1,.67,1.66,1.92,1.4,4.19-.72,6.05-6.65,4.08-6.64,3.91S422.09,154.13,422.4,151.63Z"
        style="fill:#ffbe9d"></path>
    <path
        d="M423.78,155.48s.1.08.26.18a1.08,1.08,0,0,0,.79.11,2.61,2.61,0,0,0,1.49-2.19,3.6,3.6,0,0,0-.12-1.55,1.21,1.21,0,0,0-.7-.9.53.53,0,0,0-.65.21c-.11.16-.08.29-.11.29s-.12-.11,0-.36a.63.63,0,0,1,.28-.35.81.81,0,0,1,.6-.08,1.49,1.49,0,0,1,1,1.07,3.64,3.64,0,0,1,.17,1.73,2.78,2.78,0,0,1-1.85,2.43,1.14,1.14,0,0,1-.95-.28C423.77,155.62,423.76,155.48,423.78,155.48Z"
        style="fill:#eb996e"></path>
    <path
        d="M389.89,147.48s-.58-.34-1.44-1.16A8.77,8.77,0,0,1,386,142a8.46,8.46,0,0,1-.11-3.42,7.36,7.36,0,0,1,1.67-3.51,8.6,8.6,0,0,1,8.16-2.7,7.22,7.22,0,0,1,.83.23c.27.09.52.21.77.31l.39.16-.05-.4a3,3,0,0,1,.49-2,4.71,4.71,0,0,1,1.53-1.42,6.23,6.23,0,0,1,3.88-.79c2.58.25,4.86,1.12,6.91,1.09a6.44,6.44,0,0,0,4.42-1.49,3.63,3.63,0,0,0,.78-1,2,2,0,0,0,.15-.42,5.1,5.1,0,0,1-1,1.31,6.44,6.44,0,0,1-4.31,1.31,16.13,16.13,0,0,1-3.17-.49,26.87,26.87,0,0,0-3.71-.71,8.11,8.11,0,0,0-2.08.06,6.34,6.34,0,0,0-2.06.76,5.13,5.13,0,0,0-1.69,1.56,3.43,3.43,0,0,0-.57,2.33l.34-.25-.82-.34a8.79,8.79,0,0,0-.88-.24,9.05,9.05,0,0,0-8.61,2.88,7.74,7.74,0,0,0-1.72,3.73,8.77,8.77,0,0,0,.17,3.57,8.58,8.58,0,0,0,2.62,4.37,6.21,6.21,0,0,0,1.14.82A2.73,2.73,0,0,0,389.89,147.48Z"
        style="fill:#455a64"></path>
    <path
        d="M388.44,126.73a6.42,6.42,0,0,1,1.8-.89,5.11,5.11,0,0,1,2.27-.09,4.44,4.44,0,0,1,2.53,1.39l.26.29.09-.38a6.91,6.91,0,0,1,5-4.84,9,9,0,0,1,5.54.85,23.51,23.51,0,0,0,4.51,1.65,6.68,6.68,0,0,0,3.26,0,4.05,4.05,0,0,0,.82-.34c.17-.1.26-.16.25-.18s-.39.18-1.12.34a6.92,6.92,0,0,1-3.13-.11,26.06,26.06,0,0,1-4.42-1.72,14.38,14.38,0,0,0-2.71-.92,7,7,0,0,0-3.11,0A7.23,7.23,0,0,0,395,127l.35-.09a4.71,4.71,0,0,0-2.77-1.44,5,5,0,0,0-2.4.19,4.1,4.1,0,0,0-1.35.73A1.62,1.62,0,0,0,388.44,126.73Z"
        style="fill:#455a64"></path>
    <path
        d="M404.47,157a2,2,0,0,1,1.55-.68,2.37,2.37,0,0,1,1.67.93l0,0s0,0,.06.07h0a1.16,1.16,0,0,1,.26.66,1.67,1.67,0,0,1-.8,1.36,2.12,2.12,0,0,1-2.43,0A1.73,1.73,0,0,1,404.47,157Z"
        style="fill:#9BCEA9"></path>
    <path
        d="M408.07,155.83c-.08,0-.2.3-.5.72a3.27,3.27,0,0,1-3.47,1.34c-.5-.11-.81-.26-.85-.19s.2.33.74.56a3.08,3.08,0,0,0,3.91-1.52C408.15,156.21,408.14,155.84,408.07,155.83Z"
        style="fill:#263238"></path>
    <path
        d="M431.42,139.14a1.73,1.73,0,0,0,.26-.2,6.8,6.8,0,0,0,.68-.67,7,7,0,0,0,1.64-3.11,5.51,5.51,0,0,0,0-2.46,5.09,5.09,0,0,0-1.35-2.47,4,4,0,0,0-2.88-1.17,3.76,3.76,0,0,0-3,1.42l.28.15,0-.07a8.34,8.34,0,0,0-.17-6.34,5.5,5.5,0,0,0-4.08-3.13,4.54,4.54,0,0,0-3.37,1,3.77,3.77,0,0,0-.65.71,1,1,0,0,0-.16.3,5.28,5.28,0,0,1,.89-.91,4.42,4.42,0,0,1,3.26-.82,5.26,5.26,0,0,1,3.85,3,8.13,8.13,0,0,1,.12,6.11l0,.07-.31.93.59-.79a3.43,3.43,0,0,1,2.75-1.29,3.74,3.74,0,0,1,2.67,1.06,4.74,4.74,0,0,1,1.3,2.33,5.16,5.16,0,0,1,0,2.34,7.17,7.17,0,0,1-1.51,3.07C431.75,138.82,431.39,139.12,431.42,139.14Z"
        style="fill:#263238"></path>
    <path
        d="M441.46,159l.17.07.49.18c.43.15,1.07.37,1.91.63a27.23,27.23,0,0,0,3.1.78,14.4,14.4,0,0,0,4.23.19,9.76,9.76,0,0,0,4.78-1.81A7.55,7.55,0,0,0,459,154a11.67,11.67,0,0,0-1-6.41,8,8,0,0,0-2-2.8,5.1,5.1,0,0,0-3.34-1.26,4,4,0,0,0-2.45.79l.22.24a7.08,7.08,0,0,0,1.6-3,8.08,8.08,0,0,0,.13-3.24,7.25,7.25,0,0,0-3.26-5A8.48,8.48,0,0,0,443.6,132a8.18,8.18,0,0,0-4.41,1.69,9.5,9.5,0,0,0-2.5,3,10.07,10.07,0,0,0-1,2.77,8.74,8.74,0,0,0-.16,1.84c0,.2,0,.35,0,.48s0,.16,0,.16a11.81,11.81,0,0,1,.23-2.46,10,10,0,0,1,1-2.71,9.14,9.14,0,0,1,2.47-2.9,8.09,8.09,0,0,1,4.3-1.62,8.36,8.36,0,0,1,5.11,1.27,7,7,0,0,1,3.11,4.83,7.85,7.85,0,0,1-.14,3.12,6.66,6.66,0,0,1-1.52,2.81l.21.23a3.63,3.63,0,0,1,2.25-.72,4.8,4.8,0,0,1,3.13,1.18,7.65,7.65,0,0,1,2,2.69,11.54,11.54,0,0,1,1,6.24,7.29,7.29,0,0,1-2.76,4.88,9.7,9.7,0,0,1-4.65,1.8,14.5,14.5,0,0,1-4.17-.15,28.87,28.87,0,0,1-3.09-.72l-1.93-.57-.5-.15C441.52,159,441.46,159,441.46,159Z"
        style="fill:#263238"></path>
    <path
        d="M432.23,168.66a5.45,5.45,0,0,0,.72.45,14.34,14.34,0,0,0,2.11,1,8.94,8.94,0,0,0,3.39.6,6.2,6.2,0,0,0,3.92-1.53,4.77,4.77,0,0,0,1.23-1.85,6.37,6.37,0,0,0,.35-2,8.85,8.85,0,0,0-.71-3.37,16.88,16.88,0,0,0-1-2.08,3.87,3.87,0,0,0-.45-.72,5.22,5.22,0,0,0,.34.77c.23.5.58,1.2.92,2.11a8.89,8.89,0,0,1,.62,3.29,5,5,0,0,1-1.49,3.65,6,6,0,0,1-3.72,1.46,9.18,9.18,0,0,1-3.31-.51C433.3,169.23,432.26,168.59,432.23,168.66Z"
        style="fill:#263238"></path>
    <path
        d="M429,172.58a2,2,0,0,1-.77-.31,2.18,2.18,0,0,1-.84-2,1.81,1.81,0,0,1,.7-1.29,1.26,1.26,0,0,1,1.55,0,1.14,1.14,0,0,1,.36.78.86.86,0,0,1-.43.74,1.44,1.44,0,0,1-.95.14,2.45,2.45,0,0,1-1-.37,4.41,4.41,0,0,1-1.87-3.5,8.23,8.23,0,0,1,.64-3.35,7,7,0,0,1,1-2.06.94.94,0,0,1,.73-.33.43.43,0,0,0-.22,0,1,1,0,0,0-.6.28,2.7,2.7,0,0,0-.59.84c-.18.35-.38.76-.57,1.22a8.31,8.31,0,0,0-.73,3.45,5.24,5.24,0,0,0,.51,2,4.11,4.11,0,0,0,1.49,1.72,2.25,2.25,0,0,0,2.26.23,1.14,1.14,0,0,0,.57-1,1.43,1.43,0,0,0-.46-1,1.38,1.38,0,0,0-1-.33,1.83,1.83,0,0,0-.92.33,2,2,0,0,0-.76,1.49,2.31,2.31,0,0,0,1,2.12,1.55,1.55,0,0,0,.62.22C428.92,172.61,429,172.59,429,172.58Z"
        style="fill:#263238"></path>
    <path
        d="M449.91,159.44a.82.82,0,0,0,.28,0,2.25,2.25,0,0,0,.78-.1,3.2,3.2,0,0,0,2-2,4.17,4.17,0,0,0-1.12-4.05,6.15,6.15,0,0,0-4.83-1.9,6.83,6.83,0,0,0-1.24.2l.19.21a4.89,4.89,0,0,0-.92-4.65,4.39,4.39,0,0,0-1.71-1.24,4.76,4.76,0,0,0-1.8-.32,4.57,4.57,0,0,0-2.49.73,3.14,3.14,0,0,0-.56.43c-.11.12-.17.18-.16.19s.26-.22.78-.52a4.73,4.73,0,0,1,4.13-.27,4,4,0,0,1,1.59,1.19,4.61,4.61,0,0,1,.84,4.35l-.1.29.29-.08a6.32,6.32,0,0,1,1.18-.19,5.94,5.94,0,0,1,4.6,1.78,4,4,0,0,1,1.12,3.78,3.14,3.14,0,0,1-1.83,2A3.6,3.6,0,0,1,449.91,159.44Z"
        style="fill:#455a64"></path>
    <path
        d="M450.64,140.76a1.21,1.21,0,0,0-.41-.16,3.39,3.39,0,0,0-1.22-.07,4,4,0,0,0-1.76.62,3.83,3.83,0,0,0-1.52,1.81l.26-.05a3.17,3.17,0,0,0-1.92-1,4.51,4.51,0,0,0-3,.7,6.82,6.82,0,0,0-1.81,1.78,11.26,11.26,0,0,0-.89,1.44,1.91,1.91,0,0,0-.26.57c.05,0,.47-.76,1.33-1.88a7.43,7.43,0,0,1,1.79-1.66,4.24,4.24,0,0,1,2.82-.63,2.9,2.9,0,0,1,1.73.87l.17.19.09-.23a3.64,3.64,0,0,1,1.38-1.7,4.12,4.12,0,0,1,1.64-.65A5.88,5.88,0,0,1,450.64,140.76Z"
        style="fill:#455a64"></path>
    <path
        d="M423.16,171.2l-22.63,3.21-1,7.15S388.28,201.23,387.28,207s-6,20-5,30.78S380,289.27,380,289.27h5.75L408.05,235Z"
        style="fill:#263238"></path>
    <path d="M438.78,433.1l5.68,20.55s-19.31,11.16-18.63,15.06l40.57-8.07-7.54-32.38Z" style="fill:#9BCEA9"></path>
    <g style="opacity:0.6000000000000001">
        <path
            d="M456.49,448.94a1.7,1.7,0,0,1,1.58,1.61,1.62,1.62,0,0,1-1.58,1.58,1.78,1.78,0,0,1-1.66-1.71,1.68,1.68,0,0,1,1.82-1.46"
            style="fill:#fff"></path>
    </g>
    <g style="opacity:0.6000000000000001">
        <path d="M466.4,460.64l-.76-3.26-38.9,9.15a2.84,2.84,0,0,0-1.05,2.51Z" style="fill:#fff"></path>
    </g>
    <path d="M443.76,453.6c.06.19,1.06,0,2.18.45s1.83,1.11,2,1-.4-1.18-1.76-1.64S443.68,453.43,443.76,453.6Z"
        style="fill:#263238"></path>
    <path d="M440,456.35c0,.2.93.33,1.79,1s1.27,1.51,1.47,1.45,0-1.19-1-2S439.92,456.16,440,456.35Z"
        style="fill:#263238"></path>
    <path d="M438.77,462c.18,0,.22-1.05-.54-2s-1.78-1.17-1.82-1,.66.62,1.27,1.41S438.57,462,438.77,462Z"
        style="fill:#263238"></path>
    <path d="M443,448.77c.12.16,1-.32,2.09-.51s2.08-.05,2.14-.24-.94-.7-2.27-.45S442.85,448.64,443,448.77Z"
        style="fill:#263238"></path>
    <g style="opacity:0.30000000000000004">
        <polygon points="439.91 437.17 440.92 440.83 460.65 435.94 459.88 432.61 439.91 437.17"></polygon>
    </g>
    <path
        d="M441.92,444.61a3.87,3.87,0,0,0,2-.49,9.57,9.57,0,0,0,1.95-1.15,9.28,9.28,0,0,0,1-.89,3,3,0,0,0,.49-.62.88.88,0,0,0-.16-1.07,1.11,1.11,0,0,0-1-.24,3.09,3.09,0,0,0-.73.28,8.69,8.69,0,0,0-1.15.73,7.22,7.22,0,0,0-1.56,1.66c-.73,1.09-.88,1.9-.8,1.92s.41-.68,1.19-1.62a8.18,8.18,0,0,1,1.56-1.44,7.35,7.35,0,0,1,1.07-.63c.4-.21.76-.3.92-.14s.07.09,0,.24a2.23,2.23,0,0,1-.37.45,10.44,10.44,0,0,1-.92.86,11.2,11.2,0,0,1-1.77,1.21A14.09,14.09,0,0,0,441.92,444.61Z"
        style="fill:#263238"></path>
    <path
        d="M442.24,444.83a3.28,3.28,0,0,0,.07-2.07,7.06,7.06,0,0,0-.8-2.15,7.21,7.21,0,0,0-.81-1.1,1.71,1.71,0,0,0-1.52-.71,1,1,0,0,0-.71.76,2.7,2.7,0,0,0,0,.79,4.84,4.84,0,0,0,.32,1.36,4.7,4.7,0,0,0,1.36,1.88c1,.85,1.91.89,1.91.82s-.74-.33-1.58-1.19a4.71,4.71,0,0,1-1.08-1.74,4.06,4.06,0,0,1-.24-1.17c0-.45,0-.83.21-.82s.61.19.86.49a7.52,7.52,0,0,1,.76,1,7.77,7.77,0,0,1,.87,1.92C442.16,444,442.13,444.82,442.24,444.83Z"
        style="fill:#263238"></path>
    <path d="M379.51,431.86,377,453s-22.1,3-22.94,6.88l40.6,7.89L399.93,435Z" style="fill:#9BCEA9"></path>
    <g style="opacity:0.6000000000000001">
        <path
            d="M389.9,453.22a1.69,1.69,0,0,1,.86,2.09,1.62,1.62,0,0,1-2.06.86,1.77,1.77,0,0,1-.89-2.21,1.68,1.68,0,0,1,2.24-.66"
            style="fill:#fff"></path>
    </g>
    <g style="opacity:0.6000000000000001">
        <path d="M394.65,467.8l.53-3.31-39.47-6.25a2.87,2.87,0,0,0-1.93,1.93Z" style="fill:#fff"></path>
    </g>
    <path d="M376.36,452.72c0,.2,1,.44,1.84,1.24s1.28,1.71,1.47,1.66.08-1.25-1-2.19S376.35,452.53,376.36,452.72Z"
        style="fill:#263238"></path>
    <path d="M371.8,453.82c-.08.19.74.66,1.28,1.61s.61,1.87.81,1.9.5-1.09-.2-2.26S371.83,453.63,371.8,453.82Z"
        style="fill:#263238"></path>
    <path d="M368.57,458.57c.17.07.61-.88.26-2.05s-1.21-1.76-1.32-1.6.38.82.65,1.79S368.37,458.52,368.57,458.57Z"
        style="fill:#263238"></path>
    <path d="M377.47,448c.06.19,1,.06,2.13.31s1.94.74,2.07.59-.6-1-1.92-1.28S377.4,447.78,377.47,448Z"
        style="fill:#263238"></path>
    <g style="opacity:0.30000000000000004">
        <polygon points="379.02 436.05 378.56 439.82 398.68 442.77 399.23 439.39 379.02 436.05"></polygon>
    </g>
    <path
        d="M378.06,443.69a3.75,3.75,0,0,0,2.05.31,9.41,9.41,0,0,0,2.24-.32,10.11,10.11,0,0,0,1.27-.44,2.5,2.5,0,0,0,.7-.39.88.88,0,0,0,.25-1.05,1.12,1.12,0,0,0-.8-.59,3,3,0,0,0-.79,0,7.07,7.07,0,0,0-1.34.24,7.31,7.31,0,0,0-2.08.94c-1.08.73-1.52,1.43-1.46,1.48s.64-.48,1.72-1.05a8.12,8.12,0,0,1,2-.74,7,7,0,0,1,1.24-.18c.45-.05.82,0,.9.21s0,.11-.08.23a2.91,2.91,0,0,1-.51.28c-.4.18-.8.32-1.18.45a12.48,12.48,0,0,1-2.1.45A15.93,15.93,0,0,0,378.06,443.69Z"
        style="fill:#263238"></path>
    <path
        d="M378.27,444c.07,0,.58-.61.85-1.89a6.57,6.57,0,0,0,.07-2.29,6.71,6.71,0,0,0-.33-1.32,1.7,1.7,0,0,0-1.14-1.24,1,1,0,0,0-1,.44,3,3,0,0,0-.32.72,4.47,4.47,0,0,0-.22,1.38,4.82,4.82,0,0,0,.55,2.25c.63,1.18,1.43,1.55,1.45,1.48s-.55-.58-1-1.69a4.67,4.67,0,0,1-.35-2,4.46,4.46,0,0,1,.22-1.17c.13-.43.35-.75.51-.68s.49.41.61.78a6.84,6.84,0,0,1,.33,1.19,7.63,7.63,0,0,1,.08,2.1C378.5,443.26,378.17,444,378.27,444Z"
        style="fill:#263238"></path>
    <path d="M410.17,369.19c0,.75-9.29,73.35-9.29,73.35l-27-5.12,10.85-74.93Z" style="fill:#263238"></path>
    <path d="M443.05,361.43c.25.71,19,74,19,74l-25.66,5.91-22-78.85Z" style="fill:#263238"></path>
    <path
        d="M418.87,173.52l5.28-1.8,9.22,12.6,2.48,40.48-6.37,20.85s18,39.68,18.25,49.53,8.36,101.55,8.36,101.55L373,403.5l15.35-150s2-36.78,4.35-42.28S418.87,173.52,418.87,173.52Z"
        style="fill:#9BCEA9"></path>
    <path
        d="M426,303.89a1,1,0,0,1-.32.16,5.16,5.16,0,0,1-1,.27,7.08,7.08,0,0,1-3.8-.55,10.14,10.14,0,0,1-4.29-3.73,27.43,27.43,0,0,1-2.94-6.31,40.36,40.36,0,0,1-2.14-12.39,36.17,36.17,0,0,1,.17-3.81,6.09,6.09,0,0,1,.22-1.38,8.68,8.68,0,0,1,0,1.39c0,.9-.06,2.2,0,3.79a43.69,43.69,0,0,0,2.26,12.24,28.4,28.4,0,0,0,2.85,6.2,10,10,0,0,0,4,3.66,7.37,7.37,0,0,0,3.62.69C425.52,304,426,303.84,426,303.89Z"
        style="fill:#263238"></path>
    <path
        d="M456.09,396.73l-.41,0-1.22.12-4.69.43-17.45,1.5L373,403.75l-.3,0,0-.31c.66-6.52,1.35-13.27,2.06-20.19,2.94-28.47,5.61-54.24,7.54-72.91,1-9.31,1.78-16.86,2.34-22.09.29-2.59.51-4.61.66-6,.08-.67.14-1.19.19-1.56a5,5,0,0,1,.08-.53s0,.18,0,.53-.07.9-.13,1.57c-.13,1.39-.32,3.42-.57,6-.51,5.24-1.26,12.79-2.18,22.11-1.89,18.68-4.5,44.45-7.38,72.92-.71,6.92-1.4,13.67-2.07,20.19l-.28-.28,59.32-4.74,17.46-1.35,4.7-.34,1.21-.07A3.31,3.31,0,0,1,456.09,396.73Z"
        style="fill:#263238"></path>
    <path
        d="M428.88,178.18s-.07.06-.22.16l-.66.41-2.56,1.56c-1.11.67-2.47,1.5-4,2.5-.78.51-1.61,1.05-2.42,1.68a2.48,2.48,0,0,0-.49.48c0,.21-.06.53-.1.79-.06.55-.13,1.12-.22,1.69a68.23,68.23,0,0,1-1.53,7.48,36.75,36.75,0,0,1-3.11,8.21c-1.51,2.8-4.21,4.81-6.7,7a17,17,0,0,0-3.36,3.72,7.3,7.3,0,0,0-1.1,4.86,26.82,26.82,0,0,0,1.45,5,17.84,17.84,0,0,1,1,5.06,24.09,24.09,0,0,1-1.7,9.54,45.26,45.26,0,0,1-3.92,7.85c-1.43,2.34-2.84,4.47-4.12,6.41-2.57,3.88-4.62,7-5.95,9.28-.66,1.12-1.16,2-1.49,2.59l-.38.68a1.33,1.33,0,0,1-.15.23s0-.09.1-.25l.33-.71c.31-.61.78-1.51,1.42-2.64,1.27-2.28,3.28-5.47,5.81-9.38,1.26-2,2.66-4.09,4.06-6.43a45.19,45.19,0,0,0,3.84-7.79,23.89,23.89,0,0,0,1.64-9.35,17.35,17.35,0,0,0-1-4.93,26.54,26.54,0,0,1-1.47-5.09,7.71,7.71,0,0,1,1.17-5.19,17.22,17.22,0,0,1,3.47-3.83c2.52-2.2,5.15-4.16,6.61-6.85a37.05,37.05,0,0,0,3.11-8.08,68.31,68.31,0,0,0,1.59-7.42q.14-.85.24-1.68c0-.29.05-.52.11-.83a2,2,0,0,1,.61-.66c.85-.64,1.69-1.17,2.47-1.66,1.57-1,2.95-1.79,4.08-2.44l2.61-1.47.69-.37A1.75,1.75,0,0,1,428.88,178.18Z"
        style="fill:#263238"></path>
    <path
        d="M427.65,244.64a8.27,8.27,0,0,1-2.54-.28,19.18,19.18,0,0,1-5.74-2.32,19.45,19.45,0,0,1-4.69-4,7.7,7.7,0,0,1-1.41-2.14,28.1,28.1,0,0,0,6.37,5.73A28.73,28.73,0,0,0,427.65,244.64Z"
        style="fill:#263238"></path>
    <path
        d="M429.28,246.39a6.81,6.81,0,0,1-1.95.49,28.32,28.32,0,0,1-9.66-.07,6.32,6.32,0,0,1-1.94-.53c0-.15,3,.44,6.77.46S429.25,246.23,429.28,246.39Z"
        style="fill:#263238"></path>
    <path
        d="M430.3,181.21s-6.87.1-9.25,4.16-7.16,33.52,7.15,59c.66,1.17,1.28,1.24,1.28,1.24l2.1-6.88s-3.89-28.42-4.47-31.55-1.52-21.5,1.22-21.85a18.14,18.14,0,0,1,2.05-.13,14.06,14.06,0,0,1,9.06,3.21l2,1.59A15.46,15.46,0,0,0,430.3,181.21Z"
        style="fill:#263238"></path>
    <g style="opacity:0.30000000000000004">
        <path
            d="M425.61,193.86c-7.41,13.69-8,30.17-5.33,45.51a11.06,11.06,0,0,0,1.87,5.22c1.16,1.46,3.33,2.3,5,1.37,1.25-.7,2.29-.38,2.76-1.73,1.51-4.25,2.82-9.74,4.33-14C431.42,218,428.38,206.12,425.61,193.86Z">
        </path>
    </g>
    <g style="opacity:0.30000000000000004">
        <path
            d="M411.87,280.18a49.17,49.17,0,0,0,3.74,29.69,17.55,17.55,0,0,0,3.8,5.67,7.85,7.85,0,0,0,6.26,2.24c2.85-.4,5.08-2.84,6.06-5.55.7-2,.78-4.37-.64-5.9-1.72-1.86-4.67-1.55-7.17-2-4.57-.84-8.14-4.68-9.93-9s-2.12-9-2.42-13.67">
        </path>
    </g>
    <path
        d="M460.41,235.08c-.24-6.2-12.06-30.71-12.06-30.71s-5.47-12.18-6.76-14.64c-2.81-5.35-10.65-5.92-13.48-4.29l2.19,30.24,6.49,22-12.64,23.85,15.74,15.5C460.88,274.44,460.64,241.28,460.41,235.08Z"
        style="fill:#9BCEA9"></path>
    <path
        d="M455.27,238.44a7.69,7.69,0,0,1-2.87-.41c-1.75-.44-4-1.46-6.63-2.07a11,11,0,0,0-3.72-.28,7.46,7.46,0,0,0-2.87.93,7.89,7.89,0,0,0-2.07,1.9,1.85,1.85,0,0,1,.33-.71,5.23,5.23,0,0,1,1.54-1.5,7.48,7.48,0,0,1,3-1.1,10.85,10.85,0,0,1,3.89.25c2.7.64,4.93,1.71,6.62,2.22S455.28,238.36,455.27,238.44Z"
        style="fill:#263238"></path>
    <path
        d="M447.91,229.06a11.94,11.94,0,0,1-2.31.41,15.26,15.26,0,0,0-5.28,1.63,7.09,7.09,0,0,0-3.32,4.17,8.1,8.1,0,0,0-.13,2.28s-.13-.2-.23-.61a4.43,4.43,0,0,1,0-1.75,7,7,0,0,1,3.41-4.55,13.48,13.48,0,0,1,5.49-1.53A8.68,8.68,0,0,1,447.91,229.06Z"
        style="fill:#263238"></path>
    <path
        d="M441.87,277.32a5.85,5.85,0,0,1-1.15-.45,28.68,28.68,0,0,1-3-1.55,36,36,0,0,1-4.12-2.82,41.31,41.31,0,0,1-4.49-4.15,42.66,42.66,0,0,1-3.77-4.81,38.22,38.22,0,0,1-2.47-4.34,29.1,29.1,0,0,1-1.3-3.1,5.75,5.75,0,0,1-.35-1.18c.09,0,.68,1.61,2,4.11a41.79,41.79,0,0,0,2.54,4.24,47.75,47.75,0,0,0,3.75,4.73,44.9,44.9,0,0,0,4.41,4.13,41.19,41.19,0,0,0,4,2.87C440.31,276.5,441.91,277.23,441.87,277.32Z"
        style="fill:#263238"></path>
    <path
        d="M436.79,237.71a21.62,21.62,0,0,1-1.24-3.21c-.7-2-1.61-4.79-2.51-7.9s-1.63-5.95-2.1-8a20.86,20.86,0,0,1-.64-3.38,23.74,23.74,0,0,1,1,3.29c.56,2,1.35,4.86,2.25,8s1.71,5.76,2.36,7.93A24.07,24.07,0,0,1,436.79,237.71Z"
        style="fill:#263238"></path>
    <path
        d="M424.15,261.56c-.13-.07,2.6-5.46,6.09-12.05s6.42-11.87,6.55-11.81-2.6,5.47-6.09,12.05S424.28,261.63,424.15,261.56Z"
        style="fill:#263238"></path>
    <path d="M415.74,385c-.14,0,.62-9.65,1.71-21.52S419.53,342,419.67,342s-.62,9.65-1.7,21.52S415.89,385,415.74,385Z"
        style="fill:#263238"></path>
    <path
        d="M425.07,388.88a87.47,87.47,0,0,1-2.16-9.31,87.89,87.89,0,0,1-1.66-9.41,88.08,88.08,0,0,1,2.17,9.31A88.76,88.76,0,0,1,425.07,388.88Z"
        style="fill:#263238"></path>
    <path d="M417.21,364c0,.15-8.78-.08-19.6-.5s-19.59-.87-19.58-1,8.78.08,19.6.49S417.21,363.81,417.21,364Z"
        style="fill:#fafafa"></path>
    <path d="M453.49,368.16c0,.15-8.08.06-18-.19s-18-.57-18-.72,8.08-.05,18.05.2S453.5,368,453.49,368.16Z"
        style="fill:#fafafa"></path>
    <path d="M418,353.45c0,.14-8.83-.15-19.7-.65s-19.69-1-19.68-1.18,8.82.15,19.7.66S418.05,353.31,418,353.45Z"
        style="fill:#fafafa"></path>
    <path d="M452.66,358.08c0,.15-7.76,0-17.31-.29s-17.31-.67-17.3-.81,7.75,0,17.31.29S452.67,357.94,452.66,358.08Z"
        style="fill:#fafafa"></path>
</g>
<g id="freepik--Plant--inject-4">
    <path
        d="M76.26,445c.73-2.85-1.13-5.7-3.22-7.76s-4.58-3.91-5.67-6.63c-1.76-4.42.61-10.13-2.4-13.82-1.76-2.16-4.93-2.89-6.5-5.2a11.89,11.89,0,0,1-1.41-4.14,42.06,42.06,0,0,0-10.45-19.56,36.4,36.4,0,0,0,4.1,18.85c1.21,2.32,2.71,4.57,3.11,7.16.66,4.2-1.69,8.52-.66,12.64,1.18,4.71,6.48,7.87,6.73,12.72.21,4.1-3.36,7.7-3.1,11.8a11.18,11.18,0,0,0,1.83,4.87c3.17,5.27,7.83,8.9,14.89,8.78l8.65.31Z"
        style="fill:#9BCEA9"></path>
    <g style="opacity:0.30000000000000004">
        <path
            d="M76.26,445c.73-2.85-1.13-5.7-3.22-7.76s-4.58-3.91-5.67-6.63c-1.76-4.42.61-10.13-2.4-13.82-1.76-2.16-4.93-2.89-6.5-5.2a11.89,11.89,0,0,1-1.41-4.14,42.06,42.06,0,0,0-10.45-19.56,36.4,36.4,0,0,0,4.1,18.85c1.21,2.32,2.71,4.57,3.11,7.16.66,4.2-1.69,8.52-.66,12.64,1.18,4.71,6.48,7.87,6.73,12.72.21,4.1-3.36,7.7-3.1,11.8a11.18,11.18,0,0,0,1.83,4.87c3.17,5.27,7.83,8.9,14.89,8.78l8.65.31Z">
        </path>
    </g>
    <path
        d="M83.91,465.21a7,7,0,0,0,2.38,0,14.06,14.06,0,0,0,2.81-.71,11.68,11.68,0,0,0,3.47-1.9,4.76,4.76,0,0,0,1.43-1.9,9.06,9.06,0,0,0,.41-2.59,27.13,27.13,0,0,1,.2-2.79,7.65,7.65,0,0,1,1.06-2.78c1-1.8,2.71-3.49,3.26-5.92s.17-5-.24-7.59-.79-5.42.21-8.12,2.82-5.15,3.77-8.2.5-6.39.7-9.66a12.77,12.77,0,0,1,1.13-4.8c.7-1.53,1.67-3,2.43-4.59,1.53-3.26,1.8-6.95,2.22-10.57.21-1.82.42-3.67.62-5.53a27.27,27.27,0,0,1,1-5.53,48.64,48.64,0,0,1,2.06-5.35,17.86,17.86,0,0,0,1-2.8,27.58,27.58,0,0,0,.28-3,36.38,36.38,0,0,0-.23-6c-.24-2-.6-4-.81-6,0-.11,0-.23,0-.34l-.05-.4-.35.18a13.44,13.44,0,0,0-4.66,3.93,21.08,21.08,0,0,0-2.86,5.27c-1.44,3.72-2,7.61-2.69,11.33a30.91,30.91,0,0,1-3.55,10.46c-.95,1.54-2.1,2.94-3.1,4.45a12.31,12.31,0,0,0-2.15,4.93c-.51,3.66,1.5,6.87,1.08,10.11a11.16,11.16,0,0,1-1.57,4.49c-.79,1.38-1.71,2.66-2.59,3.95a25.87,25.87,0,0,0-2.32,4,12.62,12.62,0,0,0-1.06,4.34c-.21,2.91.2,5.68,0,8.29A19.16,19.16,0,0,1,85,441c-1,2.13-2.21,4.06-3.18,5.92a29.89,29.89,0,0,0-1.31,2.76,13,13,0,0,0-.76,2.73,17.16,17.16,0,0,0-.07,4.94,12.44,12.44,0,0,0,2.48,6.3,5.79,5.79,0,0,0,.7.75,3.33,3.33,0,0,0,.57.49l.49.34a10.82,10.82,0,0,1-1.67-1.65,12.5,12.5,0,0,1-2.35-6.26,16.71,16.71,0,0,1,.11-4.86,13.58,13.58,0,0,1,.76-2.67c.37-.9.83-1.8,1.32-2.72,1-1.85,2.16-3.77,3.23-5.91a19.36,19.36,0,0,0,2.21-7.23c.23-2.67-.18-5.45,0-8.3a12.25,12.25,0,0,1,1-4.19,25.55,25.55,0,0,1,2.29-3.91c.88-1.28,1.81-2.57,2.62-4a11.55,11.55,0,0,0,1.65-4.67c.42-3.45-1.58-6.69-1.06-10.09a11.66,11.66,0,0,1,2.07-4.71c1-1.48,2.14-2.88,3.12-4.46A31.43,31.43,0,0,0,102.93,379c.74-3.74,1.26-7.59,2.68-11.23a20.8,20.8,0,0,1,2.78-5.14,12.86,12.86,0,0,1,4.46-3.76l-.39-.22c0,.11,0,.23,0,.35.21,2,.57,4,.81,6a35.43,35.43,0,0,1,.23,5.9c-.06,1-.12,2-.27,2.89a17.36,17.36,0,0,1-1,2.69,50.1,50.1,0,0,0-2.09,5.42,27.46,27.46,0,0,0-1,5.62q-.31,2.79-.61,5.53c-.42,3.63-.69,7.27-2.17,10.41-.73,1.57-1.7,3-2.42,4.6a13.46,13.46,0,0,0-1.16,5c-.18,3.34.25,6.6-.65,9.56s-2.79,5.4-3.74,8.19-.6,5.74-.18,8.32.83,5.14.28,7.44-2.15,4-3.19,5.85a7.93,7.93,0,0,0-1.07,2.89,26,26,0,0,0-.19,2.83,8.77,8.77,0,0,1-.36,2.52,4.85,4.85,0,0,1-1.35,1.82,12.18,12.18,0,0,1-3.38,1.91,15,15,0,0,1-2.78.75,10.74,10.74,0,0,1-1.75.17Z"
        style="fill:#263238"></path>
    <path
        d="M111.24,363.31a.91.91,0,0,0-.08.26c0,.21-.12.47-.19.78-.17.68-.38,1.71-.7,3s-1.13,2.73-1.8,4.51a64.72,64.72,0,0,0-2,6.14c-.66,2.31-1.25,4.87-1.86,7.61a32,32,0,0,1-2.77,8.45c-.71,1.41-1.51,2.83-2.14,4.38a20.7,20.7,0,0,0-1.25,5,99.28,99.28,0,0,1-1.86,10.46c-1.73,7.09-3.39,13.84-4.89,20l-4.1,16.3c-1.14,4.61-2.06,8.36-2.72,11-.3,1.27-.54,2.27-.71,3-.07.32-.12.57-.17.78a.8.8,0,0,0,0,.27A1.09,1.09,0,0,0,84,465l.22-.76.81-3c.7-2.63,1.68-6.36,2.89-10.95S90.56,440.1,92.15,434s3.18-12.9,4.93-20a97.62,97.62,0,0,0,1.86-10.51,20.18,20.18,0,0,1,1.2-4.84c.61-1.51,1.4-2.93,2.11-4.35a32.41,32.41,0,0,0,2.76-8.58c.59-2.75,1.15-5.3,1.78-7.6s1.3-4.36,2-6.13,1.4-3.25,1.72-4.58.46-2.33.6-3c0-.32.1-.58.13-.79A1,1,0,0,0,111.24,363.31Z"
        style="fill:#263238"></path>
    <path
        d="M85.44,465.24c5.65-3.36,7.27-13.55,4.91-19.69s-6.48-11.74-7.12-18.28c-.49-5,1.16-10.19,0-15.11-1.58-6.63-8.06-11.77-8-18.58,0-3.83,2.22-7.43,2-11.25-.21-4.69-3.81-8.41-6-12.54-3.41-6.32-3.63-13.79-4.8-20.88s-3.86-14.68-10.15-18.16c-.92,6-2.51,10.14-2,18.29.18,2.93,3.58,8.53,4,14.95.28,3.83.47,7.67.7,11.51s.47,7.54,1.81,11c1,2.68,2.68,5.11,3.44,7.87,1.43,5.2-.45,10.84.71,16.11,1,4.46,4.07,8.3,4.7,12.83.88,6.36-3.23,13-1.13,19,1,3,3.53,5.43,4.23,8.54.54,2.41,0,5,.44,7.38.8,3.91,8.24,6.94,12.22,6.7"
        style="fill:#9BCEA9"></path>
    <path
        d="M57.85,336.72a1.45,1.45,0,0,0,0,.34l.12,1c.13.87.28,2.15.57,3.8s1.17,3.52,1.86,5.78,1.43,4.83,2.07,7.73,1.18,6.11,1.75,9.56a39.9,39.9,0,0,0,2.89,10.81c.8,1.81,1.69,3.62,2.35,5.54a24.42,24.42,0,0,1,1.19,6.11,124.9,124.9,0,0,0,1.66,13.16l4.88,25.13c1.58,7.7,3,14.64,4.21,20.48s2.19,10.5,2.88,13.79c.34,1.6.62,2.85.81,3.75.09.4.17.72.22,1a1.89,1.89,0,0,0,.1.33,2,2,0,0,0,0-.34c0-.25-.1-.58-.17-1-.17-.9-.41-2.16-.71-3.77-.65-3.3-1.57-8-2.71-13.83s-2.55-12.79-4.09-20.5-3.12-16.21-4.83-25.13a123.67,123.67,0,0,1-1.66-13.11A25.22,25.22,0,0,0,70,381.1c-.68-2-1.58-3.78-2.38-5.57a40.2,40.2,0,0,1-2.91-10.68c-.58-3.45-1.15-6.67-1.82-9.57s-1.41-5.51-2.16-7.75-1.6-4.11-1.94-5.73-.5-2.91-.67-3.77c-.07-.4-.13-.73-.18-1A1.3,1.3,0,0,0,57.85,336.72Z"
        style="fill:#263238"></path>
</g>`,
];

export const busDriverAmicoPic = [
  '500 500',
  `
  <g id="freepik--City--inject-4">
    <g id="freepik--city--inject-4">
        <polygon
            points="477.38 297.43 477.38 73.61 443.07 53.8 417.33 68.66 417.32 93.43 404.45 86 404.45 66.18 391.58 58.75 391.58 43.92 352.97 21.62 335.81 31.53 335.81 51.32 318.65 41.41 301.49 51.32 301.49 110.77 284.33 100.86 284.33 76.09 267.17 66.18 245.71 78.57 245.71 128.11 224.26 115.72 224.26 36.46 198.52 21.6 168.49 38.94 168.49 78.57 155.62 86 155.62 125.63 138.46 135.54 138.46 66.18 117.01 53.8 91.27 68.66 91.27 98.38 78.39 105.81 78.39 125.63 61.23 135.54 61.23 80.97 35.49 66.11 22.62 73.54 22.62 297.43 477.38 297.43"
            style="fill:#f5f5f5"></polygon>
        <polygon points="315.67 153.55 312.02 155.66 312.02 158.84 315.67 156.73 315.67 153.55" style="fill:#fff">
        </polygon>
        <polygon points="315.67 141.83 312.02 143.94 312.02 147.11 315.67 145.01 315.67 141.83" style="fill:#fff">
        </polygon>
        <polygon points="315.67 159.41 312.02 161.52 312.02 164.7 315.67 162.59 315.67 159.41" style="fill:#fff">
        </polygon>
        <polygon points="315.67 165.68 312.02 167.79 312.02 170.97 315.67 168.86 315.67 165.68" style="fill:#fff">
        </polygon>
        <polygon points="315.67 147.69 312.02 149.8 312.02 152.97 315.67 150.87 315.67 147.69" style="fill:#fff">
        </polygon>
        <polygon points="315.67 189.13 312.02 191.23 312.02 194.41 315.67 192.31 315.67 189.13" style="fill:#fff">
        </polygon>
        <polygon points="315.67 194.99 312.02 197.09 312.02 200.27 315.67 198.17 315.67 194.99" style="fill:#fff">
        </polygon>
        <polygon points="315.67 183.26 312.02 185.37 312.02 188.55 315.67 186.44 315.67 183.26" style="fill:#fff">
        </polygon>
        <polygon points="315.67 171.54 312.02 173.65 312.02 176.83 315.67 174.72 315.67 171.54" style="fill:#fff">
        </polygon>
        <polygon points="315.67 177.41 312.02 179.51 312.02 182.69 315.67 180.58 315.67 177.41" style="fill:#fff">
        </polygon>
        <polygon points="315.67 124.25 312.02 126.35 312.02 129.53 315.67 127.43 315.67 124.25" style="fill:#fff">
        </polygon>
        <polygon points="315.67 94.54 312.02 96.64 312.02 99.82 315.67 97.72 315.67 94.54" style="fill:#fff">
        </polygon>
        <polygon points="315.67 106.67 312.02 108.77 312.02 111.95 315.67 109.84 315.67 106.67" style="fill:#fff">
        </polygon>
        <polygon points="315.67 100.4 312.02 102.5 312.02 105.68 315.67 103.58 315.67 100.4" style="fill:#fff">
        </polygon>
        <polygon points="315.67 82.82 312.02 84.92 312.02 88.1 315.67 85.99 315.67 82.82" style="fill:#fff">
        </polygon>
        <polygon points="315.67 88.68 312.02 90.78 312.02 93.96 315.67 91.86 315.67 88.68" style="fill:#fff">
        </polygon>
        <polygon points="315.67 130.11 312.02 132.21 312.02 135.39 315.67 133.29 315.67 130.11" style="fill:#fff">
        </polygon>
        <polygon points="315.67 112.53 312.02 114.63 312.02 117.81 315.67 115.71 315.67 112.53" style="fill:#fff">
        </polygon>
        <polygon points="315.67 135.97 312.02 138.07 312.02 141.25 315.67 139.15 315.67 135.97" style="fill:#fff">
        </polygon>
        <polygon points="315.67 200.85 312.02 202.95 312.02 206.13 315.67 204.03 315.67 200.85" style="fill:#fff">
        </polygon>
        <polygon points="315.67 118.39 312.02 120.49 312.02 123.67 315.67 121.57 315.67 118.39" style="fill:#fff">
        </polygon>
        <polygon points="308.11 63.74 304.47 65.84 304.47 69.02 308.11 66.92 308.11 63.74" style="fill:#fff">
        </polygon>
        <polygon points="308.11 57.88 304.47 59.98 304.47 63.16 308.11 61.06 308.11 57.88" style="fill:#fff">
        </polygon>
        <polygon points="315.67 290.85 312.02 292.95 312.02 296.13 315.67 294.02 315.67 290.85" style="fill:#fff">
        </polygon>
        <polygon points="315.67 273.26 312.02 275.37 312.02 278.55 315.67 276.44 315.67 273.26" style="fill:#fff">
        </polygon>
        <polygon points="315.67 279.12 312.02 281.23 312.02 284.41 315.67 282.3 315.67 279.12" style="fill:#fff">
        </polygon>
        <polygon points="315.67 284.99 312.02 287.09 312.02 290.27 315.67 288.16 315.67 284.99" style="fill:#fff">
        </polygon>
        <polygon points="308.11 52.02 304.47 54.12 304.47 57.3 308.11 55.2 308.11 52.02" style="fill:#fff">
        </polygon>
        <polygon points="308.11 81.32 304.47 83.43 304.47 86.61 308.11 84.5 308.11 81.32" style="fill:#fff">
        </polygon>
        <polygon points="308.11 87.18 304.47 89.29 304.47 92.47 308.11 90.36 308.11 87.18" style="fill:#fff">
        </polygon>
        <polygon points="308.11 75.46 304.47 77.57 304.47 80.74 308.11 78.64 308.11 75.46" style="fill:#fff">
        </polygon>
        <polygon points="308.11 69.6 304.47 71.7 304.47 74.88 308.11 72.78 308.11 69.6" style="fill:#fff"></polygon>
        <polygon points="315.67 76.95 312.02 79.06 312.02 82.24 315.67 80.13 315.67 76.95" style="fill:#fff">
        </polygon>
        <polygon points="315.67 255.68 312.02 257.78 312.02 260.96 315.67 258.86 315.67 255.68" style="fill:#fff">
        </polygon>
        <polygon points="315.67 225.13 312.02 227.23 312.02 230.41 315.67 228.31 315.67 225.13" style="fill:#fff">
        </polygon>
        <polygon points="315.67 231.4 312.02 233.5 312.02 236.68 315.67 234.58 315.67 231.4" style="fill:#fff">
        </polygon>
        <polygon points="315.67 218.43 312.02 220.53 312.02 223.71 315.67 221.61 315.67 218.43" style="fill:#fff">
        </polygon>
        <polygon points="315.67 238.1 312.02 240.2 312.02 243.38 315.67 241.28 315.67 238.1" style="fill:#fff">
        </polygon>
        <polygon points="315.67 212.57 312.02 214.67 312.02 217.85 315.67 215.75 315.67 212.57" style="fill:#fff">
        </polygon>
        <polygon points="315.67 206.71 312.02 208.81 312.02 211.99 315.67 209.89 315.67 206.71" style="fill:#fff">
        </polygon>
        <polygon points="315.67 267.4 312.02 269.51 312.02 272.68 315.67 270.58 315.67 267.4" style="fill:#fff">
        </polygon>
        <polygon points="315.67 261.54 312.02 263.64 312.02 266.82 315.67 264.72 315.67 261.54" style="fill:#fff">
        </polygon>
        <polygon points="315.67 243.96 312.02 246.06 312.02 249.24 315.67 247.14 315.67 243.96" style="fill:#fff">
        </polygon>
        <polygon points="315.67 249.82 312.02 251.92 312.02 255.1 315.67 253 315.67 249.82" style="fill:#fff">
        </polygon>
        <polygon points="342.45 249.43 338.81 251.54 338.81 254.72 342.45 252.61 342.45 249.43" style="fill:#fff">
        </polygon>
        <polygon points="342.45 142.57 338.81 144.67 338.81 147.85 342.45 145.75 342.45 142.57" style="fill:#fff">
        </polygon>
        <polygon points="342.45 148.43 338.81 150.53 338.81 153.71 342.45 151.61 342.45 148.43" style="fill:#fff">
        </polygon>
        <polygon points="342.45 154.29 338.81 156.4 338.81 159.57 342.45 157.47 342.45 154.29" style="fill:#fff">
        </polygon>
        <polygon points="342.45 136.71 338.81 138.81 338.81 141.99 342.45 139.89 342.45 136.71" style="fill:#fff">
        </polygon>
        <polygon points="342.45 130.85 338.81 132.95 338.81 136.13 342.45 134.03 342.45 130.85" style="fill:#fff">
        </polygon>
        <polygon points="342.45 190.29 338.81 192.4 338.81 195.58 342.45 193.47 342.45 190.29" style="fill:#fff">
        </polygon>
        <polygon points="342.45 177.74 338.81 179.84 338.81 183.02 342.45 180.91 342.45 177.74" style="fill:#fff">
        </polygon>
        <polygon points="342.45 160.15 338.81 162.26 338.81 165.43 342.45 163.33 342.45 160.15" style="fill:#fff">
        </polygon>
        <polygon points="342.45 183.6 338.81 185.7 338.81 188.88 342.45 186.77 342.45 183.6" style="fill:#fff">
        </polygon>
        <polygon points="342.45 171.87 338.81 173.98 338.81 177.16 342.45 175.05 342.45 171.87" style="fill:#fff">
        </polygon>
        <polygon points="342.45 124.58 338.81 126.68 338.81 129.86 342.45 127.76 342.45 124.58" style="fill:#fff">
        </polygon>
        <polygon points="342.45 166.01 338.81 168.12 338.81 171.29 342.45 169.19 342.45 166.01" style="fill:#fff">
        </polygon>
        <polygon points="342.45 77.69 338.81 79.8 338.81 82.97 342.45 80.87 342.45 77.69" style="fill:#fff">
        </polygon>
        <polygon points="342.45 83.55 338.81 85.66 338.81 88.83 342.45 86.73 342.45 83.55" style="fill:#fff">
        </polygon>
        <polygon points="342.45 65.56 338.81 67.67 338.81 70.84 342.45 68.74 342.45 65.56" style="fill:#fff">
        </polygon>
        <polygon points="342.45 89.41 338.81 91.52 338.81 94.7 342.45 92.59 342.45 89.41" style="fill:#fff">
        </polygon>
        <polygon points="342.45 71.83 338.81 73.94 338.81 77.11 342.45 75.01 342.45 71.83" style="fill:#fff">
        </polygon>
        <polygon points="342.45 107 338.81 109.1 338.81 112.28 342.45 110.17 342.45 107" style="fill:#fff">
        </polygon>
        <polygon points="342.45 95.28 338.81 97.38 338.81 100.56 342.45 98.45 342.45 95.28" style="fill:#fff">
        </polygon>
        <polygon points="342.45 112.86 338.81 114.96 338.81 118.14 342.45 116.04 342.45 112.86" style="fill:#fff">
        </polygon>
        <polygon points="342.45 118.72 338.81 120.82 338.81 124 342.45 121.9 342.45 118.72" style="fill:#fff">
        </polygon>
        <polygon points="342.45 101.14 338.81 103.24 338.81 106.42 342.45 104.31 342.45 101.14" style="fill:#fff">
        </polygon>
        <polygon points="342.45 243.57 338.81 245.68 338.81 248.86 342.45 246.75 342.45 243.57" style="fill:#fff">
        </polygon>
        <polygon points="342.45 290.46 338.81 292.56 338.81 295.74 342.45 293.64 342.45 290.46" style="fill:#fff">
        </polygon>
        <polygon points="342.45 278.74 338.81 280.84 338.81 284.02 342.45 281.92 342.45 278.74" style="fill:#fff">
        </polygon>
        <polygon points="342.45 284.6 338.81 286.7 338.81 289.88 342.45 287.78 342.45 284.6" style="fill:#fff">
        </polygon>
        <polygon points="342.45 196.16 338.81 198.26 338.81 201.44 342.45 199.33 342.45 196.16" style="fill:#fff">
        </polygon>
        <polygon points="342.45 272.88 338.81 274.98 338.81 278.16 342.45 276.06 342.45 272.88" style="fill:#fff">
        </polygon>
        <polygon points="315.67 53.51 312.02 55.62 312.02 58.79 315.67 56.69 315.67 53.51" style="fill:#fff">
        </polygon>
        <polygon points="315.67 47.65 312.02 49.75 312.02 52.93 315.67 50.83 315.67 47.65" style="fill:#fff">
        </polygon>
        <polygon points="315.67 65.23 312.02 67.34 312.02 70.52 315.67 68.41 315.67 65.23" style="fill:#fff">
        </polygon>
        <polygon points="315.67 59.37 312.02 61.48 312.02 64.65 315.67 62.55 315.67 59.37" style="fill:#fff">
        </polygon>
        <polygon points="342.45 261.16 338.81 263.26 338.81 266.44 342.45 264.33 342.45 261.16" style="fill:#fff">
        </polygon>
        <polygon points="342.45 267.02 338.81 269.12 338.81 272.3 342.45 270.19 342.45 267.02" style="fill:#fff">
        </polygon>
        <polygon points="342.45 213.85 338.81 215.96 338.81 219.13 342.45 217.03 342.45 213.85" style="fill:#fff">
        </polygon>
        <polygon points="342.45 219.71 338.81 221.82 338.81 225 342.45 222.89 342.45 219.71" style="fill:#fff">
        </polygon>
        <polygon points="342.45 202.13 338.81 204.23 338.81 207.41 342.45 205.31 342.45 202.13" style="fill:#fff">
        </polygon>
        <polygon points="342.45 207.99 338.81 210.09 338.81 213.27 342.45 211.17 342.45 207.99" style="fill:#fff">
        </polygon>
        <polygon points="342.45 255.29 338.81 257.4 338.81 260.58 342.45 258.47 342.45 255.29" style="fill:#fff">
        </polygon>
        <polygon points="342.45 225.99 338.81 228.09 338.81 231.27 342.45 229.17 342.45 225.99" style="fill:#fff">
        </polygon>
        <polygon points="315.67 71.09 312.02 73.2 312.02 76.38 315.67 74.27 315.67 71.09" style="fill:#fff">
        </polygon>
        <polygon points="308.11 93.05 304.47 95.15 304.47 98.33 308.11 96.22 308.11 93.05" style="fill:#fff">
        </polygon>
        <polygon points="342.45 237.71 338.81 239.82 338.81 243 342.45 240.89 342.45 237.71" style="fill:#fff">
        </polygon>
        <polygon points="342.45 231.85 338.81 233.96 338.81 237.13 342.45 235.03 342.45 231.85" style="fill:#fff">
        </polygon>
        <polygon points="196.94 261.25 193.29 263.36 193.29 266.53 196.94 264.43 196.94 261.25" style="fill:#fff">
        </polygon>
        <polygon points="196.94 178.73 193.29 180.83 193.29 184.01 196.94 181.91 196.94 178.73" style="fill:#fff">
        </polygon>
        <polygon points="196.94 167.01 193.29 169.11 193.29 172.29 196.94 170.19 196.94 167.01" style="fill:#fff">
        </polygon>
        <polygon points="196.94 149.43 193.29 151.53 193.29 154.71 196.94 152.6 196.94 149.43" style="fill:#fff">
        </polygon>
        <polygon points="196.94 161.15 193.29 163.25 193.29 166.43 196.94 164.33 196.94 161.15" style="fill:#fff">
        </polygon>
        <polygon points="196.94 155.29 193.29 157.39 193.29 160.57 196.94 158.47 196.94 155.29" style="fill:#fff">
        </polygon>
        <polygon points="196.94 172.87 193.29 174.97 193.29 178.15 196.94 176.05 196.94 172.87" style="fill:#fff">
        </polygon>
        <polygon points="196.94 214.37 193.29 216.47 193.29 219.65 196.94 217.54 196.94 214.37" style="fill:#fff">
        </polygon>
        <polygon points="196.94 208.5 193.29 210.61 193.29 213.79 196.94 211.68 196.94 208.5" style="fill:#fff">
        </polygon>
        <polygon points="196.94 202.64 193.29 204.75 193.29 207.93 196.94 205.82 196.94 202.64" style="fill:#fff">
        </polygon>
        <polygon points="196.94 196.31 193.29 198.42 193.29 201.59 196.94 199.49 196.94 196.31" style="fill:#fff">
        </polygon>
        <polygon points="196.94 190.45 193.29 192.56 193.29 195.73 196.94 193.63 196.94 190.45" style="fill:#fff">
        </polygon>
        <polygon points="196.94 184.59 193.29 186.69 193.29 189.87 196.94 187.77 196.94 184.59" style="fill:#fff">
        </polygon>
        <polygon points="196.94 107.99 193.29 110.1 193.29 113.27 196.94 111.17 196.94 107.99" style="fill:#fff">
        </polygon>
        <polygon points="196.94 102.13 193.29 104.23 193.29 107.41 196.94 105.31 196.94 102.13" style="fill:#fff">
        </polygon>
        <polygon points="196.94 96.27 193.29 98.37 193.29 101.55 196.94 99.45 196.94 96.27" style="fill:#fff">
        </polygon>
        <polygon points="196.94 90.41 193.29 92.51 193.29 95.69 196.94 93.59 196.94 90.41" style="fill:#fff">
        </polygon>
        <polygon points="196.94 113.85 193.29 115.96 193.29 119.14 196.94 117.03 196.94 113.85" style="fill:#fff">
        </polygon>
        <polygon points="196.94 125.58 193.29 127.68 193.29 130.86 196.94 128.75 196.94 125.58" style="fill:#fff">
        </polygon>
        <polygon points="196.94 131.44 193.29 133.54 193.29 136.72 196.94 134.61 196.94 131.44" style="fill:#fff">
        </polygon>
        <polygon points="196.94 119.71 193.29 121.82 193.29 125 196.94 122.89 196.94 119.71" style="fill:#fff">
        </polygon>
        <polygon points="196.94 137.3 193.29 139.4 193.29 142.58 196.94 140.47 196.94 137.3" style="fill:#fff">
        </polygon>
        <polygon points="196.94 143.56 193.29 145.67 193.29 148.85 196.94 146.74 196.94 143.56" style="fill:#fff">
        </polygon>
        <polygon points="196.94 84.55 193.29 86.65 193.29 89.83 196.94 87.73 196.94 84.55" style="fill:#fff">
        </polygon>
        <polygon points="189.38 41.62 185.74 43.73 185.74 46.9 189.38 44.8 189.38 41.62" style="fill:#fff">
        </polygon>
        <polygon points="189.38 35.76 185.74 37.87 185.74 41.04 189.38 38.94 189.38 35.76" style="fill:#fff">
        </polygon>
        <polygon points="196.94 284.7 193.29 286.8 193.29 289.98 196.94 287.87 196.94 284.7" style="fill:#fff">
        </polygon>
        <polygon points="189.38 29.9 185.74 32 185.74 35.18 189.38 33.08 189.38 29.9" style="fill:#fff"></polygon>
        <polygon points="189.38 47.48 185.74 49.59 185.74 52.77 189.38 50.66 189.38 47.48" style="fill:#fff">
        </polygon>
        <polygon points="196.94 220.23 193.29 222.33 193.29 225.51 196.94 223.4 196.94 220.23" style="fill:#fff">
        </polygon>
        <polygon points="189.38 53.34 185.74 55.45 185.74 58.63 189.38 56.52 189.38 53.34" style="fill:#fff">
        </polygon>
        <polygon points="189.38 70.93 185.74 73.03 185.74 76.21 189.38 74.11 189.38 70.93" style="fill:#fff">
        </polygon>
        <polygon points="189.38 65.07 185.74 67.17 185.74 70.35 189.38 68.24 189.38 65.07" style="fill:#fff">
        </polygon>
        <polygon points="189.38 59.2 185.74 61.31 185.74 64.49 189.38 62.38 189.38 59.2" style="fill:#fff">
        </polygon>
        <polygon points="196.94 290.96 193.29 293.07 193.29 296.25 196.94 294.14 196.94 290.96" style="fill:#fff">
        </polygon>
        <polygon points="196.94 278.83 193.29 280.94 193.29 284.12 196.94 282.01 196.94 278.83" style="fill:#fff">
        </polygon>
        <polygon points="196.94 237.81 193.29 239.91 193.29 243.09 196.94 240.99 196.94 237.81" style="fill:#fff">
        </polygon>
        <polygon points="196.94 243.67 193.29 245.77 193.29 248.95 196.94 246.85 196.94 243.67" style="fill:#fff">
        </polygon>
        <polygon points="196.94 226.09 193.29 228.19 193.29 231.37 196.94 229.26 196.94 226.09" style="fill:#fff">
        </polygon>
        <polygon points="196.94 231.95 193.29 234.05 193.29 237.23 196.94 235.13 196.94 231.95" style="fill:#fff">
        </polygon>
        <polygon points="196.94 249.53 193.29 251.63 193.29 254.81 196.94 252.71 196.94 249.53" style="fill:#fff">
        </polygon>
        <polygon points="196.94 267.11 193.29 269.22 193.29 272.39 196.94 270.29 196.94 267.11" style="fill:#fff">
        </polygon>
        <polygon points="196.94 255.39 193.29 257.5 193.29 260.67 196.94 258.57 196.94 255.39" style="fill:#fff">
        </polygon>
        <polygon points="196.94 272.97 193.29 275.08 193.29 278.26 196.94 276.15 196.94 272.97" style="fill:#fff">
        </polygon>
        <polygon points="342.45 59.7 338.81 61.81 338.81 64.98 342.45 62.88 342.45 59.7" style="fill:#fff">
        </polygon>
        <polygon points="196.94 37.25 193.29 39.36 193.29 42.54 196.94 40.43 196.94 37.25" style="fill:#fff">
        </polygon>
        <polygon points="308.11 193.49 304.47 195.6 304.47 198.78 308.11 196.67 308.11 193.49" style="fill:#fff">
        </polygon>
        <polygon points="308.11 187.63 304.47 189.74 304.47 192.91 308.11 190.81 308.11 187.63" style="fill:#fff">
        </polygon>
        <polygon points="196.94 78.28 193.29 80.38 193.29 83.56 196.94 81.46 196.94 78.28" style="fill:#fff">
        </polygon>
        <polygon points="308.11 175.91 304.47 178.01 304.47 181.19 308.11 179.09 308.11 175.91" style="fill:#fff">
        </polygon>
        <polygon points="308.11 170.05 304.47 172.15 304.47 175.33 308.11 173.23 308.11 170.05" style="fill:#fff">
        </polygon>
        <polygon points="308.11 163.78 304.47 165.89 304.47 169.06 308.11 166.96 308.11 163.78" style="fill:#fff">
        </polygon>
        <polygon points="308.11 211.08 304.47 213.18 304.47 216.36 308.11 214.26 308.11 211.08" style="fill:#fff">
        </polygon>
        <polygon points="308.11 216.94 304.47 219.04 304.47 222.22 308.11 220.12 308.11 216.94" style="fill:#fff">
        </polygon>
        <polygon points="308.11 222.8 304.47 224.9 304.47 228.08 308.11 225.98 308.11 222.8" style="fill:#fff">
        </polygon>
        <polygon points="308.11 205.22 304.47 207.32 304.47 210.5 308.11 208.4 308.11 205.22" style="fill:#fff">
        </polygon>
        <polygon points="308.11 199.35 304.47 201.46 304.47 204.64 308.11 202.53 308.11 199.35" style="fill:#fff">
        </polygon>
        <polygon points="308.11 116.9 304.47 119 304.47 122.18 308.11 120.07 308.11 116.9" style="fill:#fff">
        </polygon>
        <polygon points="308.11 157.92 304.47 160.03 304.47 163.2 308.11 161.1 308.11 157.92" style="fill:#fff">
        </polygon>
        <polygon points="308.11 111.03 304.47 113.14 304.47 116.32 308.11 114.21 308.11 111.03" style="fill:#fff">
        </polygon>
        <polygon points="308.11 128.62 304.47 130.72 304.47 133.9 308.11 131.8 308.11 128.62" style="fill:#fff">
        </polygon>
        <polygon points="308.11 104.77 304.47 106.87 304.47 110.05 308.11 107.94 308.11 104.77" style="fill:#fff">
        </polygon>
        <polygon points="308.11 122.76 304.47 124.86 304.47 128.04 308.11 125.94 308.11 122.76" style="fill:#fff">
        </polygon>
        <polygon points="308.11 152.06 304.47 154.16 304.47 157.34 308.11 155.24 308.11 152.06" style="fill:#fff">
        </polygon>
        <polygon points="308.11 134.48 304.47 136.58 304.47 139.76 308.11 137.66 308.11 134.48" style="fill:#fff">
        </polygon>
        <polygon points="308.11 146.2 304.47 148.3 304.47 151.48 308.11 149.38 308.11 146.2" style="fill:#fff">
        </polygon>
        <polygon points="308.11 140.34 304.47 142.44 304.47 145.62 308.11 143.52 308.11 140.34" style="fill:#fff">
        </polygon>
        <polygon points="308.11 181.77 304.47 183.88 304.47 187.06 308.11 184.95 308.11 181.77" style="fill:#fff">
        </polygon>
        <polygon points="308.11 297.43 308.11 295.21 304.47 297.32 304.47 297.43 308.11 297.43" style="fill:#fff">
        </polygon>
        <polygon points="196.94 43.12 193.29 45.22 193.29 48.4 196.94 46.29 196.94 43.12" style="fill:#fff">
        </polygon>
        <polygon points="196.94 31.39 193.29 33.5 193.29 36.67 196.94 34.57 196.94 31.39" style="fill:#fff">
        </polygon>
        <polygon points="196.94 25.53 193.29 27.64 193.29 30.81 196.94 28.71 196.94 25.53" style="fill:#fff">
        </polygon>
        <polygon points="196.94 48.98 193.29 51.08 193.29 54.26 196.94 52.15 196.94 48.98" style="fill:#fff">
        </polygon>
        <polygon points="308.11 98.91 304.47 101.01 304.47 104.19 308.11 102.08 308.11 98.91" style="fill:#fff">
        </polygon>
        <polygon points="308.11 229.5 304.47 231.6 304.47 234.78 308.11 232.68 308.11 229.5" style="fill:#fff">
        </polygon>
        <polygon points="196.94 66.56 193.29 68.66 193.29 71.84 196.94 69.74 196.94 66.56" style="fill:#fff">
        </polygon>
        <polygon points="196.94 60.7 193.29 62.8 193.29 65.98 196.94 63.88 196.94 60.7" style="fill:#fff"></polygon>
        <polygon points="196.94 54.84 193.29 56.94 193.29 60.12 196.94 58.02 196.94 54.84" style="fill:#fff">
        </polygon>
        <polygon points="196.94 72.42 193.29 74.52 193.29 77.7 196.94 75.6 196.94 72.42" style="fill:#fff">
        </polygon>
        <polygon points="308.11 254.19 304.47 256.29 304.47 259.47 308.11 257.37 308.11 254.19" style="fill:#fff">
        </polygon>
        <polygon points="308.11 248.33 304.47 250.43 304.47 253.61 308.11 251.5 308.11 248.33" style="fill:#fff">
        </polygon>
        <polygon points="308.11 242.47 304.47 244.57 304.47 247.75 308.11 245.64 308.11 242.47" style="fill:#fff">
        </polygon>
        <polygon points="308.11 235.77 304.47 237.87 304.47 241.05 308.11 238.94 308.11 235.77" style="fill:#fff">
        </polygon>
        <polygon points="308.11 260.05 304.47 262.15 304.47 265.33 308.11 263.23 308.11 260.05" style="fill:#fff">
        </polygon>
        <polygon points="308.11 283.49 304.47 285.6 304.47 288.77 308.11 286.67 308.11 283.49" style="fill:#fff">
        </polygon>
        <polygon points="308.11 277.63 304.47 279.74 304.47 282.91 308.11 280.81 308.11 277.63" style="fill:#fff">
        </polygon>
        <polygon points="308.11 289.35 304.47 291.46 304.47 294.63 308.11 292.53 308.11 289.35" style="fill:#fff">
        </polygon>
        <polygon points="308.11 265.91 304.47 268.01 304.47 271.19 308.11 269.09 308.11 265.91" style="fill:#fff">
        </polygon>
        <polygon points="308.11 271.77 304.47 273.87 304.47 277.05 308.11 274.95 308.11 271.77" style="fill:#fff">
        </polygon>
        <polygon points="439.34 101.91 435.7 104.01 435.7 107.19 439.34 105.09 439.34 101.91" style="fill:#fff">
        </polygon>
        <polygon points="342.45 53.84 338.81 55.95 338.81 59.12 342.45 57.02 342.45 53.84" style="fill:#fff">
        </polygon>
        <polygon points="431.79 130.13 428.15 132.23 428.15 135.41 431.79 133.31 431.79 130.13" style="fill:#fff">
        </polygon>
        <polygon points="431.79 118 428.15 120.1 428.15 123.28 431.79 121.18 431.79 118" style="fill:#fff">
        </polygon>
        <polygon points="431.79 135.99 428.15 138.09 428.15 141.27 431.79 139.17 431.79 135.99" style="fill:#fff">
        </polygon>
        <polygon points="431.79 112.14 428.15 114.24 428.15 117.42 431.79 115.32 431.79 112.14" style="fill:#fff">
        </polygon>
        <polygon points="431.79 147.71 428.15 149.81 428.15 152.99 431.79 150.89 431.79 147.71" style="fill:#fff">
        </polygon>
        <polygon points="431.79 165.29 428.15 167.4 428.15 170.58 431.79 168.47 431.79 165.29" style="fill:#fff">
        </polygon>
        <polygon points="431.79 159.43 428.15 161.54 428.15 164.72 431.79 162.61 431.79 159.43" style="fill:#fff">
        </polygon>
        <polygon points="431.79 153.57 428.15 155.68 428.15 158.85 431.79 156.75 431.79 153.57" style="fill:#fff">
        </polygon>
        <polygon points="431.79 106.28 428.15 108.38 428.15 111.56 431.79 109.46 431.79 106.28" style="fill:#fff">
        </polygon>
        <polygon points="439.34 272.92 435.7 275.02 435.7 278.2 439.34 276.09 439.34 272.92" style="fill:#fff">
        </polygon>
        <polygon points="431.79 94.56 428.15 96.66 428.15 99.84 431.79 97.73 431.79 94.56" style="fill:#fff">
        </polygon>
        <polygon points="431.79 65.25 428.15 67.36 428.15 70.53 431.79 68.43 431.79 65.25" style="fill:#fff">
        </polygon>
        <polygon points="431.79 71.11 428.15 73.22 428.15 76.39 431.79 74.29 431.79 71.11" style="fill:#fff">
        </polygon>
        <polygon points="439.34 290.5 435.7 292.6 435.7 295.78 439.34 293.68 439.34 290.5" style="fill:#fff">
        </polygon>
        <polygon points="439.34 278.78 435.7 280.88 435.7 284.06 439.34 281.95 439.34 278.78" style="fill:#fff">
        </polygon>
        <polygon points="439.34 284.64 435.7 286.74 435.7 289.92 439.34 287.81 439.34 284.64" style="fill:#fff">
        </polygon>
        <polygon points="431.79 76.97 428.15 79.08 428.15 82.25 431.79 80.15 431.79 76.97" style="fill:#fff">
        </polygon>
        <polygon points="431.79 88.69 428.15 90.8 428.15 93.98 431.79 91.87 431.79 88.69" style="fill:#fff">
        </polygon>
        <polygon points="431.79 100.42 428.15 102.52 428.15 105.7 431.79 103.59 431.79 100.42" style="fill:#fff">
        </polygon>
        <polygon points="431.79 171.15 428.15 173.26 428.15 176.44 431.79 174.33 431.79 171.15" style="fill:#fff">
        </polygon>
        <polygon points="431.79 82.83 428.15 84.94 428.15 88.12 431.79 86.01 431.79 82.83" style="fill:#fff">
        </polygon>
        <polygon points="431.79 141.85 428.15 143.95 428.15 147.13 431.79 145.03 431.79 141.85" style="fill:#fff">
        </polygon>
        <polygon points="431.79 259.7 428.15 261.8 428.15 264.98 431.79 262.88 431.79 259.7" style="fill:#fff">
        </polygon>
        <polygon points="431.79 265.56 428.15 267.67 428.15 270.84 431.79 268.74 431.79 265.56" style="fill:#fff">
        </polygon>
        <polygon points="431.79 177.01 428.15 179.12 428.15 182.3 431.79 180.19 431.79 177.01" style="fill:#fff">
        </polygon>
        <polygon points="431.79 247.96 428.15 250.06 428.15 253.24 431.79 251.13 431.79 247.96" style="fill:#fff">
        </polygon>
        <polygon points="431.79 242.09 428.15 244.2 428.15 247.38 431.79 245.27 431.79 242.09" style="fill:#fff">
        </polygon>
        <polygon points="431.79 271.42 428.15 273.52 428.15 276.7 431.79 274.6 431.79 271.42" style="fill:#fff">
        </polygon>
        <polygon points="431.79 277.28 428.15 279.39 428.15 282.56 431.79 280.46 431.79 277.28" style="fill:#fff">
        </polygon>
        <polygon points="431.79 289 428.15 291.11 428.15 294.29 431.79 292.18 431.79 289" style="fill:#fff">
        </polygon>
        <polygon points="431.79 297.43 431.79 294.87 428.15 296.97 428.15 297.43 431.79 297.43" style="fill:#fff">
        </polygon>
        <polygon points="431.79 283.14 428.15 285.25 428.15 288.43 431.79 286.32 431.79 283.14" style="fill:#fff">
        </polygon>
        <polygon points="431.79 253.84 428.15 255.94 428.15 259.12 431.79 257.02 431.79 253.84" style="fill:#fff">
        </polygon>
        <polygon points="431.79 200.87 428.15 202.97 428.15 206.15 431.79 204.04 431.79 200.87" style="fill:#fff">
        </polygon>
        <polygon points="431.79 236.03 428.15 238.13 428.15 241.31 431.79 239.21 431.79 236.03" style="fill:#fff">
        </polygon>
        <polygon points="431.79 195 428.15 197.11 428.15 200.29 431.79 198.18 431.79 195" style="fill:#fff">
        </polygon>
        <polygon points="431.79 183.28 428.15 185.39 428.15 188.56 431.79 186.46 431.79 183.28" style="fill:#fff">
        </polygon>
        <polygon points="431.79 189.14 428.15 191.25 428.15 194.43 431.79 192.32 431.79 189.14" style="fill:#fff">
        </polygon>
        <polygon points="431.79 206.73 428.15 208.83 428.15 212.01 431.79 209.91 431.79 206.73" style="fill:#fff">
        </polygon>
        <polygon points="431.79 230.17 428.15 232.27 428.15 235.45 431.79 233.35 431.79 230.17" style="fill:#fff">
        </polygon>
        <polygon points="431.79 224.31 428.15 226.41 428.15 229.59 431.79 227.49 431.79 224.31" style="fill:#fff">
        </polygon>
        <polygon points="431.79 218.45 428.15 220.55 428.15 223.73 431.79 221.63 431.79 218.45" style="fill:#fff">
        </polygon>
        <polygon points="431.79 212.59 428.15 214.69 428.15 217.87 431.79 215.77 431.79 212.59" style="fill:#fff">
        </polygon>
        <polygon points="439.34 66.74 435.7 68.85 435.7 72.03 439.34 69.92 439.34 66.74" style="fill:#fff">
        </polygon>
        <polygon points="439.34 137.48 435.7 139.59 435.7 142.76 439.34 140.66 439.34 137.48" style="fill:#fff">
        </polygon>
        <polygon points="439.34 107.77 435.7 109.87 435.7 113.05 439.34 110.95 439.34 107.77" style="fill:#fff">
        </polygon>
        <polygon points="189.38 76.79 185.74 78.89 185.74 82.07 189.38 79.97 189.38 76.79" style="fill:#fff">
        </polygon>
        <polygon points="439.34 84.33 435.7 86.43 435.7 89.61 439.34 87.5 439.34 84.33" style="fill:#fff"></polygon>
        <polygon points="439.34 90.19 435.7 92.29 435.7 95.47 439.34 93.37 439.34 90.19" style="fill:#fff">
        </polygon>
        <polygon points="439.34 119.9 435.7 122 435.7 125.18 439.34 123.08 439.34 119.9" style="fill:#fff">
        </polygon>
        <polygon points="439.34 125.76 435.7 127.86 435.7 131.04 439.34 128.94 439.34 125.76" style="fill:#fff">
        </polygon>
        <polygon points="439.34 113.63 435.7 115.73 435.7 118.91 439.34 116.81 439.34 113.63" style="fill:#fff">
        </polygon>
        <polygon points="439.34 131.62 435.7 133.72 435.7 136.9 439.34 134.8 439.34 131.62" style="fill:#fff">
        </polygon>
        <polygon points="439.34 78.47 435.7 80.57 435.7 83.75 439.34 81.64 439.34 78.47" style="fill:#fff">
        </polygon>
        <polygon points="439.34 96.05 435.7 98.15 435.7 101.33 439.34 99.23 439.34 96.05" style="fill:#fff">
        </polygon>
        <polygon points="105.44 297.43 105.44 295.39 101.92 297.43 105.44 297.43" style="fill:#fff"></polygon>
        <polygon points="439.34 72.61 435.7 74.71 435.7 77.89 439.34 75.78 439.34 72.61" style="fill:#fff">
        </polygon>
        <polygon points="189.38 297.43 189.38 295.33 185.74 297.43 189.38 297.43" style="fill:#fff"></polygon>
        <polygon points="439.34 60.88 435.7 62.99 435.7 66.17 439.34 64.06 439.34 60.88" style="fill:#fff">
        </polygon>
        <polygon points="424.23 69.62 420.59 71.72 420.59 74.9 424.23 72.8 424.23 69.62" style="fill:#fff">
        </polygon>
        <polygon points="439.34 143.34 435.7 145.45 435.7 148.63 439.34 146.52 439.34 143.34" style="fill:#fff">
        </polygon>
        <polygon points="439.34 267.05 435.7 269.16 435.7 272.34 439.34 270.23 439.34 267.05" style="fill:#fff">
        </polygon>
        <polygon points="439.34 231.66 435.7 233.77 435.7 236.95 439.34 234.84 439.34 231.66" style="fill:#fff">
        </polygon>
        <polygon points="439.34 237.73 435.7 239.83 435.7 243.01 439.34 240.9 439.34 237.73" style="fill:#fff">
        </polygon>
        <polygon points="439.34 219.94 435.7 222.04 435.7 225.22 439.34 223.12 439.34 219.94" style="fill:#fff">
        </polygon>
        <polygon points="439.34 214.08 435.7 216.19 435.7 219.36 439.34 217.26 439.34 214.08" style="fill:#fff">
        </polygon>
        <polygon points="439.34 249.47 435.7 251.57 435.7 254.75 439.34 252.65 439.34 249.47" style="fill:#fff">
        </polygon>
        <polygon points="439.34 261.19 435.7 263.3 435.7 266.48 439.34 264.37 439.34 261.19" style="fill:#fff">
        </polygon>
        <polygon points="439.34 255.33 435.7 257.44 435.7 260.61 439.34 258.51 439.34 255.33" style="fill:#fff">
        </polygon>
        <polygon points="439.34 208.22 435.7 210.32 435.7 213.5 439.34 211.4 439.34 208.22" style="fill:#fff">
        </polygon>
        <polygon points="439.34 243.59 435.7 245.69 435.7 248.87 439.34 246.76 439.34 243.59" style="fill:#fff">
        </polygon>
        <polygon points="439.34 225.8 435.7 227.91 435.7 231.09 439.34 228.98 439.34 225.8" style="fill:#fff">
        </polygon>
        <polygon points="439.34 166.79 435.7 168.89 435.7 172.07 439.34 169.97 439.34 166.79" style="fill:#fff">
        </polygon>
        <polygon points="439.34 160.93 435.7 163.03 435.7 166.21 439.34 164.1 439.34 160.93" style="fill:#fff">
        </polygon>
        <polygon points="439.34 155.06 435.7 157.17 435.7 160.35 439.34 158.24 439.34 155.06" style="fill:#fff">
        </polygon>
        <polygon points="439.34 172.65 435.7 174.75 435.7 177.93 439.34 175.83 439.34 172.65" style="fill:#fff">
        </polygon>
        <polygon points="439.34 149.2 435.7 151.31 435.7 154.49 439.34 152.38 439.34 149.2" style="fill:#fff">
        </polygon>
        <polygon points="439.34 178.91 435.7 181.02 435.7 184.2 439.34 182.09 439.34 178.91" style="fill:#fff">
        </polygon>
        <polygon points="439.34 196.5 435.7 198.6 435.7 201.78 439.34 199.68 439.34 196.5" style="fill:#fff">
        </polygon>
        <polygon points="439.34 190.64 435.7 192.74 435.7 195.92 439.34 193.81 439.34 190.64" style="fill:#fff">
        </polygon>
        <polygon points="439.34 184.78 435.7 186.88 435.7 190.06 439.34 187.96 439.34 184.78" style="fill:#fff">
        </polygon>
        <polygon points="439.34 202.36 435.7 204.46 435.7 207.64 439.34 205.54 439.34 202.36" style="fill:#fff">
        </polygon>
        <polygon points="431.79 124.27 428.15 126.37 428.15 129.55 431.79 127.45 431.79 124.27" style="fill:#fff">
        </polygon>
        <polygon points="350.01 144.06 346.36 146.17 346.36 149.34 350.01 147.24 350.01 144.06" style="fill:#fff">
        </polygon>
        <polygon points="350.01 149.92 346.36 152.03 346.36 155.21 350.01 153.1 350.01 149.92" style="fill:#fff">
        </polygon>
        <polygon points="350.01 138.2 346.36 140.31 346.36 143.48 350.01 141.38 350.01 138.2" style="fill:#fff">
        </polygon>
        <polygon points="350.01 132.34 346.36 134.44 346.36 137.62 350.01 135.52 350.01 132.34" style="fill:#fff">
        </polygon>
        <polygon points="350.01 191.79 346.36 193.89 346.36 197.07 350.01 194.97 350.01 191.79" style="fill:#fff">
        </polygon>
        <polygon points="350.01 161.65 346.36 163.75 346.36 166.93 350.01 164.82 350.01 161.65" style="fill:#fff">
        </polygon>
        <polygon points="350.01 179.23 346.36 181.33 346.36 184.51 350.01 182.41 350.01 179.23" style="fill:#fff">
        </polygon>
        <polygon points="350.01 126.48 346.36 128.58 346.36 131.76 350.01 129.66 350.01 126.48" style="fill:#fff">
        </polygon>
        <polygon points="350.01 185.93 346.36 188.03 346.36 191.21 350.01 189.1 350.01 185.93" style="fill:#fff">
        </polygon>
        <polygon points="350.01 173.37 346.36 175.47 346.36 178.65 350.01 176.54 350.01 173.37" style="fill:#fff">
        </polygon>
        <polygon points="350.01 167.51 346.36 169.61 346.36 172.79 350.01 170.68 350.01 167.51" style="fill:#fff">
        </polygon>
        <polygon points="350.01 155.78 346.36 157.89 346.36 161.07 350.01 158.96 350.01 155.78" style="fill:#fff">
        </polygon>
        <polygon points="350.01 85.05 346.36 87.15 346.36 90.33 350.01 88.22 350.01 85.05" style="fill:#fff">
        </polygon>
        <polygon points="350.01 90.91 346.36 93.01 346.36 96.19 350.01 94.08 350.01 90.91" style="fill:#fff">
        </polygon>
        <polygon points="350.01 79.19 346.36 81.29 346.36 84.47 350.01 82.36 350.01 79.19" style="fill:#fff">
        </polygon>
        <polygon points="350.01 67.46 346.36 69.57 346.36 72.75 350.01 70.64 350.01 67.46" style="fill:#fff">
        </polygon>
        <polygon points="350.01 73.32 346.36 75.43 346.36 78.61 350.01 76.5 350.01 73.32" style="fill:#fff">
        </polygon>
        <polygon points="350.01 114.35 346.36 116.45 346.36 119.63 350.01 117.53 350.01 114.35" style="fill:#fff">
        </polygon>
        <polygon points="350.01 120.21 346.36 122.31 346.36 125.49 350.01 123.39 350.01 120.21" style="fill:#fff">
        </polygon>
        <polygon points="350.01 108.49 346.36 110.59 346.36 113.77 350.01 111.67 350.01 108.49" style="fill:#fff">
        </polygon>
        <polygon points="350.01 96.77 346.36 98.87 346.36 102.05 350.01 99.95 350.01 96.77" style="fill:#fff">
        </polygon>
        <polygon points="350.01 102.63 346.36 104.73 346.36 107.91 350.01 105.81 350.01 102.63" style="fill:#fff">
        </polygon>
        <polygon points="342.45 42.12 338.81 44.22 338.81 47.4 342.45 45.3 342.45 42.12" style="fill:#fff">
        </polygon>
        <polygon points="350.01 286.09 346.36 288.2 346.36 291.38 350.01 289.27 350.01 286.09" style="fill:#fff">
        </polygon>
        <polygon points="350.01 291.95 346.36 294.06 346.36 297.24 350.01 295.13 350.01 291.95" style="fill:#fff">
        </polygon>
        <polygon points="350.01 280.23 346.36 282.34 346.36 285.51 350.01 283.41 350.01 280.23" style="fill:#fff">
        </polygon>
        <polygon points="350.01 268.51 346.36 270.61 346.36 273.79 350.01 271.69 350.01 268.51" style="fill:#fff">
        </polygon>
        <polygon points="424.23 75.48 420.59 77.58 420.59 80.76 424.23 78.66 424.23 75.48" style="fill:#fff">
        </polygon>
        <polygon points="350.01 61.2 346.36 63.3 346.36 66.48 350.01 64.37 350.01 61.2" style="fill:#fff"></polygon>
        <polygon points="342.45 47.98 338.81 50.08 338.81 53.26 342.45 51.16 342.45 47.98" style="fill:#fff">
        </polygon>
        <polygon points="350.01 262.65 346.36 264.75 346.36 267.93 350.01 265.83 350.01 262.65" style="fill:#fff">
        </polygon>
        <polygon points="350.01 197.76 346.36 199.87 346.36 203.04 350.01 200.94 350.01 197.76" style="fill:#fff">
        </polygon>
        <polygon points="342.45 30.4 338.81 32.5 338.81 35.68 342.45 33.58 342.45 30.4" style="fill:#fff"></polygon>
        <polygon points="342.45 36.26 338.81 38.36 338.81 41.54 342.45 39.44 342.45 36.26" style="fill:#fff">
        </polygon>
        <polygon points="350.01 215.34 346.36 217.45 346.36 220.63 350.01 218.52 350.01 215.34" style="fill:#fff">
        </polygon>
        <polygon points="350.01 221.62 346.36 223.73 346.36 226.91 350.01 224.8 350.01 221.62" style="fill:#fff">
        </polygon>
        <polygon points="350.01 209.48 346.36 211.59 346.36 214.77 350.01 212.66 350.01 209.48" style="fill:#fff">
        </polygon>
        <polygon points="350.01 227.48 346.36 229.59 346.36 232.77 350.01 230.66 350.01 227.48" style="fill:#fff">
        </polygon>
        <polygon points="350.01 203.62 346.36 205.73 346.36 208.91 350.01 206.8 350.01 203.62" style="fill:#fff">
        </polygon>
        <polygon points="350.01 250.93 346.36 253.03 346.36 256.21 350.01 254.11 350.01 250.93" style="fill:#fff">
        </polygon>
        <polygon points="350.01 256.79 346.36 258.89 346.36 262.07 350.01 259.97 350.01 256.79" style="fill:#fff">
        </polygon>
        <polygon points="350.01 245.07 346.36 247.17 346.36 250.35 350.01 248.25 350.01 245.07" style="fill:#fff">
        </polygon>
        <polygon points="350.01 239.21 346.36 241.31 346.36 244.49 350.01 242.38 350.01 239.21" style="fill:#fff">
        </polygon>
        <polygon points="350.01 233.34 346.36 235.45 346.36 238.63 350.01 236.52 350.01 233.34" style="fill:#fff">
        </polygon>
        <polygon points="350.01 274.37 346.36 276.48 346.36 279.65 350.01 277.55 350.01 274.37" style="fill:#fff">
        </polygon>
        <polygon points="424.23 163.8 420.59 165.9 420.59 169.08 424.23 166.98 424.23 163.8" style="fill:#fff">
        </polygon>
        <polygon points="424.23 199.37 420.59 201.48 420.59 204.66 424.23 202.55 424.23 199.37" style="fill:#fff">
        </polygon>
        <polygon points="424.23 152.08 420.59 154.18 420.59 157.36 424.23 155.26 424.23 152.08" style="fill:#fff">
        </polygon>
        <polygon points="424.23 146.22 420.59 148.32 420.59 151.5 424.23 149.4 424.23 146.22" style="fill:#fff">
        </polygon>
        <polygon points="424.23 140.36 420.59 142.46 420.59 145.64 424.23 143.53 424.23 140.36" style="fill:#fff">
        </polygon>
        <polygon points="424.23 169.66 420.59 171.76 420.59 174.94 424.23 172.84 424.23 169.66" style="fill:#fff">
        </polygon>
        <polygon points="424.23 193.51 420.59 195.62 420.59 198.79 424.23 196.69 424.23 193.51" style="fill:#fff">
        </polygon>
        <polygon points="424.23 175.52 420.59 177.63 420.59 180.8 424.23 178.7 424.23 175.52" style="fill:#fff">
        </polygon>
        <polygon points="424.23 187.65 420.59 189.75 420.59 192.93 424.23 190.83 424.23 187.65" style="fill:#fff">
        </polygon>
        <polygon points="424.23 181.38 420.59 183.49 420.59 186.66 424.23 184.56 424.23 181.38" style="fill:#fff">
        </polygon>
        <polygon points="424.23 157.94 420.59 160.04 420.59 163.22 424.23 161.12 424.23 157.94" style="fill:#fff">
        </polygon>
        <polygon points="424.23 98.92 420.59 101.03 420.59 104.21 424.23 102.1 424.23 98.92" style="fill:#fff">
        </polygon>
        <polygon points="424.23 134.5 420.59 136.6 420.59 139.78 424.23 137.67 424.23 134.5" style="fill:#fff">
        </polygon>
        <polygon points="424.23 81.34 420.59 83.44 420.59 86.62 424.23 84.52 424.23 81.34" style="fill:#fff">
        </polygon>
        <polygon points="424.23 104.78 420.59 106.89 420.59 110.07 424.23 107.96 424.23 104.78" style="fill:#fff">
        </polygon>
        <polygon points="424.23 87.2 420.59 89.31 420.59 92.48 424.23 90.38 424.23 87.2" style="fill:#fff">
        </polygon>
        <polygon points="424.23 93.06 420.59 95.17 420.59 98.34 424.23 96.24 424.23 93.06" style="fill:#fff">
        </polygon>
        <polygon points="424.23 128.63 420.59 130.74 420.59 133.92 424.23 131.81 424.23 128.63" style="fill:#fff">
        </polygon>
        <polygon points="424.23 122.37 420.59 124.47 420.59 127.65 424.23 125.55 424.23 122.37" style="fill:#fff">
        </polygon>
        <polygon points="350.01 55.33 346.36 57.44 346.36 60.62 350.01 58.51 350.01 55.33" style="fill:#fff">
        </polygon>
        <polygon points="424.23 110.64 420.59 112.75 420.59 115.93 424.23 113.82 424.23 110.64" style="fill:#fff">
        </polygon>
        <polygon points="424.23 116.51 420.59 118.61 420.59 121.79 424.23 119.69 424.23 116.51" style="fill:#fff">
        </polygon>
        <polygon points="422.71 297.43 424.23 296.55 424.23 293.37 420.59 295.48 420.59 297.43 422.71 297.43"
            style="fill:#fff"></polygon>
        <polygon points="424.23 287.51 420.59 289.62 420.59 292.79 424.23 290.69 424.23 287.51" style="fill:#fff">
        </polygon>
        <polygon points="350.01 26.03 346.36 28.13 346.36 31.31 350.01 29.21 350.01 26.03" style="fill:#fff">
        </polygon>
        <polygon points="424.23 205.23 420.59 207.34 420.59 210.52 424.23 208.41 424.23 205.23" style="fill:#fff">
        </polygon>
        <polygon points="424.23 281.65 420.59 283.75 420.59 286.93 424.23 284.83 424.23 281.65" style="fill:#fff">
        </polygon>
        <polygon points="350.01 49.47 346.36 51.58 346.36 54.76 350.01 52.65 350.01 49.47" style="fill:#fff">
        </polygon>
        <polygon points="424.23 269.93 420.59 272.03 420.59 275.21 424.23 273.11 424.23 269.93" style="fill:#fff">
        </polygon>
        <polygon points="350.01 43.61 346.36 45.72 346.36 48.9 350.01 46.79 350.01 43.61" style="fill:#fff">
        </polygon>
        <polygon points="350.01 37.75 346.36 39.85 346.36 43.03 350.01 40.93 350.01 37.75" style="fill:#fff">
        </polygon>
        <polygon points="350.01 31.89 346.36 33.99 346.36 37.17 350.01 35.07 350.01 31.89" style="fill:#fff">
        </polygon>
        <polygon points="424.23 275.79 420.59 277.89 420.59 281.07 424.23 278.97 424.23 275.79" style="fill:#fff">
        </polygon>
        <polygon points="424.23 222.82 420.59 224.92 420.59 228.1 424.23 226 424.23 222.82" style="fill:#fff">
        </polygon>
        <polygon points="424.23 228.68 420.59 230.78 420.59 233.96 424.23 231.86 424.23 228.68" style="fill:#fff">
        </polygon>
        <polygon points="424.23 264.07 420.59 266.17 420.59 269.35 424.23 267.25 424.23 264.07" style="fill:#fff">
        </polygon>
        <polygon points="424.23 234.54 420.59 236.64 420.59 239.82 424.23 237.72 424.23 234.54" style="fill:#fff">
        </polygon>
        <polygon points="424.23 216.96 420.59 219.06 420.59 222.24 424.23 220.13 424.23 216.96" style="fill:#fff">
        </polygon>
        <polygon points="424.23 211.09 420.59 213.2 420.59 216.38 424.23 214.27 424.23 211.09" style="fill:#fff">
        </polygon>
        <polygon points="424.23 258.21 420.59 260.31 420.59 263.49 424.23 261.38 424.23 258.21" style="fill:#fff">
        </polygon>
        <polygon points="424.23 240.4 420.59 242.5 420.59 245.68 424.23 243.58 424.23 240.4" style="fill:#fff">
        </polygon>
        <polygon points="424.23 252.32 420.59 254.43 420.59 257.6 424.23 255.5 424.23 252.32" style="fill:#fff">
        </polygon>
        <polygon points="424.23 246.46 420.59 248.56 420.59 251.74 424.23 249.64 424.23 246.46" style="fill:#fff">
        </polygon>
        <polygon points="43.05 114.44 39.41 112.33 39.41 115.51 43.05 117.61 43.05 114.44" style="fill:#fff">
        </polygon>
        <polygon points="97.89 270.05 94.25 272.15 94.25 275.33 97.89 273.23 97.89 270.05" style="fill:#fff">
        </polygon>
        <polygon points="97.89 264.19 94.25 266.29 94.25 269.47 97.89 267.37 97.89 264.19" style="fill:#fff">
        </polygon>
        <polygon points="97.89 275.91 94.25 278.01 94.25 281.19 97.89 279.09 97.89 275.91" style="fill:#fff">
        </polygon>
        <polygon points="97.89 258.33 94.25 260.43 94.25 263.61 97.89 261.51 97.89 258.33" style="fill:#fff">
        </polygon>
        <polygon points="97.89 252.47 94.25 254.57 94.25 257.75 97.89 255.65 97.89 252.47" style="fill:#fff">
        </polygon>
        <polygon points="97.89 246.61 94.25 248.71 94.25 251.89 97.89 249.78 97.89 246.61" style="fill:#fff">
        </polygon>
        <polygon points="58.16 93.46 54.52 91.36 54.52 94.53 58.16 96.64 58.16 93.46" style="fill:#fff"></polygon>
        <polygon points="58.16 81.74 54.52 79.63 54.52 82.81 58.16 84.92 58.16 81.74" style="fill:#fff"></polygon>
        <polygon points="58.16 87.6 54.52 85.5 54.52 88.67 58.16 90.78 58.16 87.6" style="fill:#fff"></polygon>
        <polygon points="97.89 287.63 94.25 289.74 94.25 292.92 97.89 290.81 97.89 287.63" style="fill:#fff">
        </polygon>
        <polygon points="97.28 297.43 97.89 297.08 97.89 293.9 94.25 296 94.25 297.43 97.28 297.43" style="fill:#fff">
        </polygon>
        <polygon points="97.89 281.77 94.25 283.88 94.25 287.05 97.89 284.95 97.89 281.77" style="fill:#fff">
        </polygon>
        <polygon points="97.89 199.72 94.25 201.82 94.25 205 97.89 202.9 97.89 199.72" style="fill:#fff"></polygon>
        <polygon points="97.89 240.75 94.25 242.85 94.25 246.03 97.89 243.92 97.89 240.75" style="fill:#fff">
        </polygon>
        <polygon points="97.89 193.86 94.25 195.96 94.25 199.14 97.89 197.04 97.89 193.86" style="fill:#fff">
        </polygon>
        <polygon points="97.89 188 94.25 190.1 94.25 193.28 97.89 191.18 97.89 188" style="fill:#fff"></polygon>
        <polygon points="97.89 211.44 94.25 213.54 94.25 216.72 97.89 214.62 97.89 211.44" style="fill:#fff">
        </polygon>
        <polygon points="97.89 205.58 94.25 207.68 94.25 210.86 97.89 208.76 97.89 205.58" style="fill:#fff">
        </polygon>
        <polygon points="97.89 234.88 94.25 236.99 94.25 240.17 97.89 238.06 97.89 234.88" style="fill:#fff">
        </polygon>
        <polygon points="97.89 229.02 94.25 231.13 94.25 234.31 97.89 232.2 97.89 229.02" style="fill:#fff">
        </polygon>
        <polygon points="97.89 217.3 94.25 219.41 94.25 222.58 97.89 220.48 97.89 217.3" style="fill:#fff">
        </polygon>
        <polygon points="97.89 223.16 94.25 225.27 94.25 228.44 97.89 226.34 97.89 223.16" style="fill:#fff">
        </polygon>
        <polygon points="58.16 99.32 54.52 97.22 54.52 100.39 58.16 102.5 58.16 99.32" style="fill:#fff"></polygon>
        <polygon points="58.16 182.19 54.52 180.08 54.52 183.26 58.16 185.37 58.16 182.19" style="fill:#fff">
        </polygon>
        <polygon points="58.16 193.91 54.52 191.81 54.52 194.98 58.16 197.09 58.16 193.91" style="fill:#fff">
        </polygon>
        <polygon points="58.16 188.05 54.52 185.94 54.52 189.12 58.16 191.23 58.16 188.05" style="fill:#fff">
        </polygon>
        <polygon points="97.89 181.73 94.25 183.83 94.25 187.01 97.89 184.91 97.89 181.73" style="fill:#fff">
        </polygon>
        <polygon points="58.16 175.92 54.52 173.81 54.52 176.99 58.16 179.1 58.16 175.92" style="fill:#fff">
        </polygon>
        <polygon points="58.16 205.63 54.52 203.53 54.52 206.71 58.16 208.81 58.16 205.63" style="fill:#fff">
        </polygon>
        <polygon points="58.16 217.35 54.52 215.25 54.52 218.43 58.16 220.53 58.16 217.35" style="fill:#fff">
        </polygon>
        <polygon points="58.16 199.77 54.52 197.67 54.52 200.84 58.16 202.95 58.16 199.77" style="fill:#fff">
        </polygon>
        <polygon points="58.16 211.49 54.52 209.39 54.52 212.57 58.16 214.67 58.16 211.49" style="fill:#fff">
        </polygon>
        <polygon points="58.16 164.2 54.52 162.09 54.52 165.27 58.16 167.38 58.16 164.2" style="fill:#fff">
        </polygon>
        <polygon points="58.16 170.06 54.52 167.95 54.52 171.13 58.16 173.24 58.16 170.06" style="fill:#fff">
        </polygon>
        <polygon points="58.16 129.03 54.52 126.93 54.52 130.11 58.16 132.21 58.16 129.03" style="fill:#fff">
        </polygon>
        <polygon points="58.16 223.21 54.52 221.11 54.52 224.29 58.16 226.39 58.16 223.21" style="fill:#fff">
        </polygon>
        <polygon points="58.16 116.9 54.52 114.8 54.52 117.98 58.16 120.08 58.16 116.9" style="fill:#fff"></polygon>
        <polygon points="58.16 111.04 54.52 108.94 54.52 112.12 58.16 114.22 58.16 111.04" style="fill:#fff">
        </polygon>
        <polygon points="58.16 158.34 54.52 156.23 54.52 159.41 58.16 161.51 58.16 158.34" style="fill:#fff">
        </polygon>
        <polygon points="58.16 105.18 54.52 103.08 54.52 106.26 58.16 108.36 58.16 105.18" style="fill:#fff">
        </polygon>
        <polygon points="58.16 152.48 54.52 150.37 54.52 153.55 58.16 155.65 58.16 152.48" style="fill:#fff">
        </polygon>
        <polygon points="58.16 146.61 54.52 144.51 54.52 147.69 58.16 149.79 58.16 146.61" style="fill:#fff">
        </polygon>
        <polygon points="58.16 140.75 54.52 138.65 54.52 141.83 58.16 143.93 58.16 140.75" style="fill:#fff">
        </polygon>
        <polygon points="58.16 134.89 54.52 132.79 54.52 135.97 58.16 138.07 58.16 134.89" style="fill:#fff">
        </polygon>
        <polygon points="58.16 123.17 54.52 121.07 54.52 124.25 58.16 126.35 58.16 123.17" style="fill:#fff">
        </polygon>
        <polygon points="105.44 230.52 101.8 232.62 101.8 235.8 105.44 233.69 105.44 230.52" style="fill:#fff">
        </polygon>
        <polygon points="105.44 236.38 101.8 238.48 101.8 241.66 105.44 239.56 105.44 236.38" style="fill:#fff">
        </polygon>
        <polygon points="105.44 224.66 101.8 226.76 101.8 229.94 105.44 227.83 105.44 224.66" style="fill:#fff">
        </polygon>
        <polygon points="105.44 218.79 101.8 220.9 101.8 224.08 105.44 221.97 105.44 218.79" style="fill:#fff">
        </polygon>
        <polygon points="105.44 212.93 101.8 215.04 101.8 218.22 105.44 216.11 105.44 212.93" style="fill:#fff">
        </polygon>
        <polygon points="105.44 265.68 101.8 267.79 101.8 270.96 105.44 268.86 105.44 265.68" style="fill:#fff">
        </polygon>
        <polygon points="97.89 175.87 94.25 177.97 94.25 181.15 97.89 179.05 97.89 175.87" style="fill:#fff">
        </polygon>
        <polygon points="105.44 242.24 101.8 244.34 101.8 247.52 105.44 245.42 105.44 242.24" style="fill:#fff">
        </polygon>
        <polygon points="105.44 207.07 101.8 209.18 101.8 212.35 105.44 210.25 105.44 207.07" style="fill:#fff">
        </polygon>
        <polygon points="105.44 248.1 101.8 250.2 101.8 253.38 105.44 251.28 105.44 248.1" style="fill:#fff">
        </polygon>
        <polygon points="105.44 253.96 101.8 256.06 101.8 259.24 105.44 257.14 105.44 253.96" style="fill:#fff">
        </polygon>
        <polygon points="105.44 159.78 101.8 161.88 101.8 165.06 105.44 162.96 105.44 159.78" style="fill:#fff">
        </polygon>
        <polygon points="105.44 171.5 101.8 173.6 101.8 176.78 105.44 174.68 105.44 171.5" style="fill:#fff">
        </polygon>
        <polygon points="105.44 165.64 101.8 167.74 101.8 170.92 105.44 168.82 105.44 165.64" style="fill:#fff">
        </polygon>
        <polygon points="105.44 271.54 101.8 273.65 101.8 276.82 105.44 274.72 105.44 271.54" style="fill:#fff">
        </polygon>
        <polygon points="105.44 153.92 101.8 156.02 101.8 159.2 105.44 157.1 105.44 153.92" style="fill:#fff">
        </polygon>
        <polygon points="105.44 148.06 101.8 150.16 101.8 153.34 105.44 151.24 105.44 148.06" style="fill:#fff">
        </polygon>
        <polygon points="105.44 195.35 101.8 197.46 101.8 200.63 105.44 198.53 105.44 195.35" style="fill:#fff">
        </polygon>
        <polygon points="105.44 201.21 101.8 203.32 101.8 206.49 105.44 204.39 105.44 201.21" style="fill:#fff">
        </polygon>
        <polygon points="105.44 189.49 101.8 191.59 101.8 194.77 105.44 192.67 105.44 189.49" style="fill:#fff">
        </polygon>
        <polygon points="105.44 177.36 101.8 179.47 101.8 182.64 105.44 180.54 105.44 177.36" style="fill:#fff">
        </polygon>
        <polygon points="105.44 183.63 101.8 185.73 101.8 188.91 105.44 186.81 105.44 183.63" style="fill:#fff">
        </polygon>
        <polygon points="105.44 259.82 101.8 261.93 101.8 265.1 105.44 263 105.44 259.82" style="fill:#fff">
        </polygon>
        <polygon points="97.89 116.85 94.25 118.96 94.25 122.14 97.89 120.03 97.89 116.85" style="fill:#fff">
        </polygon>
        <polygon points="105.44 277.4 101.8 279.51 101.8 282.69 105.44 280.58 105.44 277.4" style="fill:#fff">
        </polygon>
        <polygon points="97.89 128.98 94.25 131.09 94.25 134.26 97.89 132.16 97.89 128.98" style="fill:#fff">
        </polygon>
        <polygon points="97.89 146.56 94.25 148.67 94.25 151.85 97.89 149.74 97.89 146.56" style="fill:#fff">
        </polygon>
        <polygon points="97.89 122.71 94.25 124.82 94.25 128 97.89 125.89 97.89 122.71" style="fill:#fff"></polygon>
        <polygon points="97.89 134.84 94.25 136.95 94.25 140.12 97.89 138.02 97.89 134.84" style="fill:#fff">
        </polygon>
        <polygon points="97.89 164.15 94.25 166.25 94.25 169.43 97.89 167.32 97.89 164.15" style="fill:#fff">
        </polygon>
        <polygon points="97.89 170.01 94.25 172.11 94.25 175.29 97.89 173.19 97.89 170.01" style="fill:#fff">
        </polygon>
        <polygon points="97.89 158.29 94.25 160.39 94.25 163.57 97.89 161.46 97.89 158.29" style="fill:#fff">
        </polygon>
        <polygon points="97.89 152.43 94.25 154.53 94.25 157.71 97.89 155.6 97.89 152.43" style="fill:#fff">
        </polygon>
        <polygon points="97.89 140.7 94.25 142.81 94.25 145.99 97.89 143.88 97.89 140.7" style="fill:#fff">
        </polygon>
        <polygon points="97.89 69.97 94.25 72.07 94.25 75.25 97.89 73.14 97.89 69.97" style="fill:#fff"></polygon>
        <polygon points="97.89 75.83 94.25 77.93 94.25 81.11 97.89 79 97.89 75.83" style="fill:#fff"></polygon>
        <polygon points="105.44 289.53 101.8 291.64 101.8 294.81 105.44 292.71 105.44 289.53" style="fill:#fff">
        </polygon>
        <polygon points="105.44 283.26 101.8 285.37 101.8 288.55 105.44 286.44 105.44 283.26" style="fill:#fff">
        </polygon>
        <polygon points="97.89 81.69 94.25 83.79 94.25 86.97 97.89 84.86 97.89 81.69" style="fill:#fff"></polygon>
        <polygon points="97.89 105.13 94.25 107.23 94.25 110.41 97.89 108.31 97.89 105.13" style="fill:#fff">
        </polygon>
        <polygon points="97.89 110.99 94.25 113.09 94.25 116.27 97.89 114.17 97.89 110.99" style="fill:#fff">
        </polygon>
        <polygon points="97.89 99.27 94.25 101.37 94.25 104.55 97.89 102.45 97.89 99.27" style="fill:#fff">
        </polygon>
        <polygon points="97.89 93.41 94.25 95.51 94.25 98.69 97.89 96.59 97.89 93.41" style="fill:#fff"></polygon>
        <polygon points="97.89 87.55 94.25 89.65 94.25 92.83 97.89 90.73 97.89 87.55" style="fill:#fff"></polygon>
        <polygon points="50.61 272.06 46.96 269.96 46.96 273.14 50.61 275.24 50.61 272.06" style="fill:#fff">
        </polygon>
        <polygon points="43.05 126.16 39.41 124.05 39.41 127.23 43.05 129.34 43.05 126.16" style="fill:#fff">
        </polygon>
        <polygon points="43.05 132.02 39.41 129.91 39.41 133.09 43.05 135.2 43.05 132.02" style="fill:#fff">
        </polygon>
        <polygon points="43.05 137.88 39.41 135.78 39.41 138.95 43.05 141.06 43.05 137.88" style="fill:#fff">
        </polygon>
        <polygon points="43.05 120.3 39.41 118.19 39.41 121.37 43.05 123.47 43.05 120.3" style="fill:#fff">
        </polygon>
        <polygon points="43.05 108.17 39.41 106.06 39.41 109.24 43.05 111.35 43.05 108.17" style="fill:#fff">
        </polygon>
        <polygon points="43.05 167.18 39.41 165.08 39.41 168.26 43.05 170.36 43.05 167.18" style="fill:#fff">
        </polygon>
        <polygon points="43.05 102.31 39.41 100.2 39.41 103.38 43.05 105.48 43.05 102.31" style="fill:#fff">
        </polygon>
        <polygon points="43.05 143.74 39.41 141.64 39.41 144.81 43.05 146.92 43.05 143.74" style="fill:#fff">
        </polygon>
        <polygon points="43.05 161.32 39.41 159.22 39.41 162.4 43.05 164.5 43.05 161.32" style="fill:#fff">
        </polygon>
        <polygon points="43.05 155.46 39.41 153.36 39.41 156.54 43.05 158.64 43.05 155.46" style="fill:#fff">
        </polygon>
        <polygon points="43.05 149.6 39.41 147.5 39.41 150.68 43.05 152.78 43.05 149.6" style="fill:#fff"></polygon>
        <polygon points="43.05 78.86 39.41 76.76 39.41 79.94 43.05 82.04 43.05 78.86" style="fill:#fff"></polygon>
        <polygon points="50.61 289.65 46.96 287.54 46.96 290.72 50.61 292.82 50.61 289.65" style="fill:#fff">
        </polygon>
        <polygon points="189.38 82.65 185.74 84.75 185.74 87.93 189.38 85.83 189.38 82.65" style="fill:#fff">
        </polygon>
        <polygon points="43.05 96.44 39.41 94.34 39.41 97.52 43.05 99.62 43.05 96.44" style="fill:#fff"></polygon>
        <polygon points="50.61 277.92 46.96 275.82 46.96 279 50.61 281.1 50.61 277.92" style="fill:#fff"></polygon>
        <polygon points="105.44 142.2 101.8 144.3 101.8 147.48 105.44 145.37 105.44 142.2" style="fill:#fff">
        </polygon>
        <polygon points="50.61 266.2 46.96 264.1 46.96 267.28 50.61 269.38 50.61 266.2" style="fill:#fff"></polygon>
        <polygon points="43.05 90.58 39.41 88.48 39.41 91.66 43.05 93.76 43.05 90.58" style="fill:#fff"></polygon>
        <polygon points="43.05 84.72 39.41 82.62 39.41 85.8 43.05 87.9 43.05 84.72" style="fill:#fff"></polygon>
        <polygon points="43.05 73 39.41 70.9 39.41 74.08 43.05 76.18 43.05 73" style="fill:#fff"></polygon>
        <polygon points="43.05 173.45 39.41 171.35 39.41 174.53 43.05 176.63 43.05 173.45" style="fill:#fff">
        </polygon>
        <polygon points="50.61 283.78 46.96 281.68 46.96 284.86 50.61 286.96 50.61 283.78" style="fill:#fff">
        </polygon>
        <polygon points="43.05 261.83 39.41 259.73 39.41 262.91 43.05 265.01 43.05 261.83" style="fill:#fff">
        </polygon>
        <polygon points="43.05 179.31 39.41 177.21 39.41 180.39 43.05 182.49 43.05 179.31" style="fill:#fff">
        </polygon>
        <polygon points="43.05 267.69 39.41 265.59 39.41 268.77 43.05 270.87 43.05 267.69" style="fill:#fff">
        </polygon>
        <polygon points="43.05 255.97 39.41 253.87 39.41 257.05 43.05 259.15 43.05 255.97" style="fill:#fff">
        </polygon>
        <polygon points="43.05 244.25 39.41 242.15 39.41 245.33 43.05 247.43 43.05 244.25" style="fill:#fff">
        </polygon>
        <polygon points="43.05 250.11 39.41 248.01 39.41 251.19 43.05 253.29 43.05 250.11" style="fill:#fff">
        </polygon>
        <polygon points="43.05 297.43 43.05 297 39.41 294.9 39.41 297.43 43.05 297.43" style="fill:#fff"></polygon>
        <polygon points="43.05 279.42 39.41 277.31 39.41 280.49 43.05 282.6 43.05 279.42" style="fill:#fff">
        </polygon>
        <polygon points="43.05 291.14 39.41 289.04 39.41 292.21 43.05 294.32 43.05 291.14" style="fill:#fff">
        </polygon>
        <polygon points="43.05 285.28 39.41 283.17 39.41 286.35 43.05 288.46 43.05 285.28" style="fill:#fff">
        </polygon>
        <polygon points="43.05 273.56 39.41 271.45 39.41 274.63 43.05 276.73 43.05 273.56" style="fill:#fff">
        </polygon>
        <polygon points="43.05 202.76 39.41 200.65 39.41 203.83 43.05 205.93 43.05 202.76" style="fill:#fff">
        </polygon>
        <polygon points="43.05 196.9 39.41 194.79 39.41 197.97 43.05 200.07 43.05 196.9" style="fill:#fff">
        </polygon>
        <polygon points="43.05 208.62 39.41 206.51 39.41 209.69 43.05 211.79 43.05 208.62" style="fill:#fff">
        </polygon>
        <polygon points="43.05 191.03 39.41 188.93 39.41 192.11 43.05 194.21 43.05 191.03" style="fill:#fff">
        </polygon>
        <polygon points="43.05 185.17 39.41 183.07 39.41 186.25 43.05 188.35 43.05 185.17" style="fill:#fff">
        </polygon>
        <polygon points="43.05 220.34 39.41 218.24 39.41 221.41 43.05 223.52 43.05 220.34" style="fill:#fff">
        </polygon>
        <polygon points="43.05 232.53 39.41 230.43 39.41 233.6 43.05 235.71 43.05 232.53" style="fill:#fff">
        </polygon>
        <polygon points="43.05 226.2 39.41 224.1 39.41 227.27 43.05 229.38 43.05 226.2" style="fill:#fff"></polygon>
        <polygon points="43.05 238.39 39.41 236.29 39.41 239.47 43.05 241.57 43.05 238.39" style="fill:#fff">
        </polygon>
        <polygon points="43.05 214.48 39.41 212.37 39.41 215.55 43.05 217.66 43.05 214.48" style="fill:#fff">
        </polygon>
        <polygon points="50.61 165.69 46.96 163.59 46.96 166.76 50.61 168.87 50.61 165.69" style="fill:#fff">
        </polygon>
        <polygon points="50.61 100.81 46.96 98.71 46.96 101.89 50.61 103.99 50.61 100.81" style="fill:#fff">
        </polygon>
        <polygon points="50.61 89.09 46.96 86.99 46.96 90.17 50.61 92.27 50.61 89.09" style="fill:#fff"></polygon>
        <polygon points="58.16 294.01 54.52 291.91 54.52 295.09 58.16 297.19 58.16 294.01" style="fill:#fff">
        </polygon>
        <polygon points="50.61 77.37 46.96 75.27 46.96 78.44 50.61 80.55 50.61 77.37" style="fill:#fff"></polygon>
        <polygon points="50.61 83.23 46.96 81.13 46.96 84.31 50.61 86.41 50.61 83.23" style="fill:#fff"></polygon>
        <polygon points="50.61 260.34 46.96 258.24 46.96 261.42 50.61 263.52 50.61 260.34" style="fill:#fff">
        </polygon>
        <polygon points="50.61 106.67 46.96 104.57 46.96 107.75 50.61 109.85 50.61 106.67" style="fill:#fff">
        </polygon>
        <polygon points="50.61 124.66 46.96 122.56 46.96 125.74 50.61 127.84 50.61 124.66" style="fill:#fff">
        </polygon>
        <polygon points="50.61 118.8 46.96 116.7 46.96 119.88 50.61 121.98 50.61 118.8" style="fill:#fff"></polygon>
        <polygon points="50.61 112.53 46.96 110.43 46.96 113.61 50.61 115.71 50.61 112.53" style="fill:#fff">
        </polygon>
        <polygon points="58.16 264.71 54.52 262.61 54.52 265.78 58.16 267.89 58.16 264.71" style="fill:#fff">
        </polygon>
        <polygon points="58.16 247.13 54.52 245.02 54.52 248.2 58.16 250.31 58.16 247.13" style="fill:#fff">
        </polygon>
        <polygon points="58.16 288.15 54.52 286.05 54.52 289.23 58.16 291.33 58.16 288.15" style="fill:#fff">
        </polygon>
        <polygon points="58.16 252.99 54.52 250.88 54.52 254.06 58.16 256.17 58.16 252.99" style="fill:#fff">
        </polygon>
        <polygon points="58.16 241.26 54.52 239.16 54.52 242.34 58.16 244.44 58.16 241.26" style="fill:#fff">
        </polygon>
        <polygon points="58.16 234.94 54.52 232.83 54.52 236.01 58.16 238.11 58.16 234.94" style="fill:#fff">
        </polygon>
        <polygon points="58.16 258.85 54.52 256.74 54.52 259.92 58.16 262.03 58.16 258.85" style="fill:#fff">
        </polygon>
        <polygon points="50.61 130.53 46.96 128.42 46.96 131.6 50.61 133.7 50.61 130.53" style="fill:#fff">
        </polygon>
        <polygon points="58.16 276.43 54.52 274.33 54.52 277.5 58.16 279.61 58.16 276.43" style="fill:#fff">
        </polygon>
        <polygon points="58.16 282.29 54.52 280.19 54.52 283.37 58.16 285.47 58.16 282.29" style="fill:#fff">
        </polygon>
        <polygon points="58.16 270.57 54.52 268.47 54.52 271.64 58.16 273.75 58.16 270.57" style="fill:#fff">
        </polygon>
        <polygon points="50.61 94.95 46.96 92.85 46.96 96.03 50.61 98.13 50.61 94.95" style="fill:#fff"></polygon>
        <polygon points="50.61 218.84 46.96 216.74 46.96 219.92 50.61 222.02 50.61 218.84" style="fill:#fff">
        </polygon>
        <polygon points="50.61 224.71 46.96 222.6 46.96 225.78 50.61 227.88 50.61 224.71" style="fill:#fff">
        </polygon>
        <polygon points="50.61 212.99 46.96 210.88 46.96 214.06 50.61 216.16 50.61 212.99" style="fill:#fff">
        </polygon>
        <polygon points="50.61 207.12 46.96 205.02 46.96 208.2 50.61 210.3 50.61 207.12" style="fill:#fff">
        </polygon>
        <polygon points="50.61 230.57 46.96 228.46 46.96 231.64 50.61 233.75 50.61 230.57" style="fill:#fff">
        </polygon>
        <polygon points="50.61 201.26 46.96 199.16 46.96 202.34 50.61 204.44 50.61 201.26" style="fill:#fff">
        </polygon>
        <polygon points="50.61 136.39 46.96 134.28 46.96 137.46 50.61 139.56 50.61 136.39" style="fill:#fff">
        </polygon>
        <polygon points="50.61 236.9 46.96 234.79 46.96 237.97 50.61 240.08 50.61 236.9" style="fill:#fff">
        </polygon>
        <polygon points="50.61 254.48 46.96 252.38 46.96 255.56 50.61 257.66 50.61 254.48" style="fill:#fff">
        </polygon>
        <polygon points="50.61 242.76 46.96 240.65 46.96 243.83 50.61 245.94 50.61 242.76" style="fill:#fff">
        </polygon>
        <polygon points="50.61 248.62 46.96 246.52 46.96 249.69 50.61 251.8 50.61 248.62" style="fill:#fff">
        </polygon>
        <polygon points="50.61 159.83 46.96 157.73 46.96 160.9 50.61 163.01 50.61 159.83" style="fill:#fff">
        </polygon>
        <polygon points="58.16 229.07 54.52 226.97 54.52 230.15 58.16 232.25 58.16 229.07" style="fill:#fff">
        </polygon>
        <polygon points="50.61 153.97 46.96 151.87 46.96 155.04 50.61 157.15 50.61 153.97" style="fill:#fff">
        </polygon>
        <polygon points="50.61 148.11 46.96 146 46.96 149.18 50.61 151.29 50.61 148.11" style="fill:#fff"></polygon>
        <polygon points="50.61 195.4 46.96 193.3 46.96 196.48 50.61 198.58 50.61 195.4" style="fill:#fff"></polygon>
        <polygon points="50.61 142.25 46.96 140.14 46.96 143.32 50.61 145.43 50.61 142.25" style="fill:#fff">
        </polygon>
        <polygon points="50.61 189.54 46.96 187.44 46.96 190.62 50.61 192.72 50.61 189.54" style="fill:#fff">
        </polygon>
        <polygon points="50.61 171.55 46.96 169.45 46.96 172.63 50.61 174.73 50.61 171.55" style="fill:#fff">
        </polygon>
        <polygon points="50.61 183.68 46.96 181.58 46.96 184.75 50.61 186.86 50.61 183.68" style="fill:#fff">
        </polygon>
        <polygon points="50.61 177.82 46.96 175.72 46.96 178.89 50.61 181 50.61 177.82" style="fill:#fff"></polygon>
        <polygon points="50.61 297.43 50.61 295.51 46.96 293.4 46.96 296.58 48.44 297.43 50.61 297.43"
            style="fill:#fff"></polygon>
        <polygon points="181.82 175.74 178.18 177.85 178.18 181.03 181.82 178.92 181.82 175.74" style="fill:#fff">
        </polygon>
        <polygon points="181.82 169.88 178.18 171.99 178.18 175.16 181.82 173.06 181.82 169.88" style="fill:#fff">
        </polygon>
        <polygon points="181.82 164.02 178.18 166.13 178.18 169.3 181.82 167.2 181.82 164.02" style="fill:#fff">
        </polygon>
        <polygon points="181.82 152.3 178.18 154.4 178.18 157.58 181.82 155.48 181.82 152.3" style="fill:#fff">
        </polygon>
        <polygon points="181.82 158.16 178.18 160.26 178.18 163.44 181.82 161.34 181.82 158.16" style="fill:#fff">
        </polygon>
        <polygon points="181.82 199.19 178.18 201.29 178.18 204.47 181.82 202.37 181.82 199.19" style="fill:#fff">
        </polygon>
        <polygon points="181.82 146.03 178.18 148.14 178.18 151.31 181.82 149.21 181.82 146.03" style="fill:#fff">
        </polygon>
        <polygon points="181.82 205.05 178.18 207.15 178.18 210.33 181.82 208.23 181.82 205.05" style="fill:#fff">
        </polygon>
        <polygon points="181.82 187.47 178.18 189.57 178.18 192.75 181.82 190.64 181.82 187.47" style="fill:#fff">
        </polygon>
        <polygon points="181.82 193.33 178.18 195.43 178.18 198.61 181.82 196.5 181.82 193.33" style="fill:#fff">
        </polygon>
        <polygon points="181.82 181.6 178.18 183.71 178.18 186.89 181.82 184.78 181.82 181.6" style="fill:#fff">
        </polygon>
        <polygon points="181.82 140.17 178.18 142.28 178.18 145.45 181.82 143.35 181.82 140.17" style="fill:#fff">
        </polygon>
        <polygon points="181.82 99.14 178.18 101.25 178.18 104.43 181.82 102.32 181.82 99.14" style="fill:#fff">
        </polygon>
        <polygon points="181.82 105.01 178.18 107.11 178.18 110.29 181.82 108.18 181.82 105.01" style="fill:#fff">
        </polygon>
        <polygon points="181.82 93.28 178.18 95.39 178.18 98.57 181.82 96.46 181.82 93.28" style="fill:#fff">
        </polygon>
        <polygon points="181.82 211.38 178.18 213.48 178.18 216.66 181.82 214.56 181.82 211.38" style="fill:#fff">
        </polygon>
        <polygon points="181.82 110.87 178.18 112.97 178.18 116.15 181.82 114.05 181.82 110.87" style="fill:#fff">
        </polygon>
        <polygon points="181.82 87.02 178.18 89.12 178.18 92.3 181.82 90.19 181.82 87.02" style="fill:#fff">
        </polygon>
        <polygon points="181.82 128.45 178.18 130.55 178.18 133.73 181.82 131.63 181.82 128.45" style="fill:#fff">
        </polygon>
        <polygon points="181.82 134.31 178.18 136.41 178.18 139.59 181.82 137.49 181.82 134.31" style="fill:#fff">
        </polygon>
        <polygon points="181.82 122.59 178.18 124.69 178.18 127.87 181.82 125.77 181.82 122.59" style="fill:#fff">
        </polygon>
        <polygon points="181.82 116.73 178.18 118.83 178.18 122.01 181.82 119.91 181.82 116.73" style="fill:#fff">
        </polygon>
        <polygon points="174.27 56.22 170.63 58.32 170.63 61.5 174.27 59.4 174.27 56.22" style="fill:#fff">
        </polygon>
        <polygon points="174.27 38.64 170.63 40.74 170.63 43.92 174.27 41.81 174.27 38.64" style="fill:#fff">
        </polygon>
        <polygon points="174.27 44.5 170.63 46.6 170.63 49.78 174.27 47.67 174.27 44.5" style="fill:#fff"></polygon>
        <polygon points="181.82 287.57 178.18 289.67 178.18 292.85 181.82 290.75 181.82 287.57" style="fill:#fff">
        </polygon>
        <polygon points="174.27 50.36 170.63 52.46 170.63 55.64 174.27 53.54 174.27 50.36" style="fill:#fff">
        </polygon>
        <polygon points="181.82 281.71 178.18 283.81 178.18 286.99 181.82 284.89 181.82 281.71" style="fill:#fff">
        </polygon>
        <polygon points="180.4 297.43 181.82 296.61 181.82 293.43 178.18 295.54 178.18 297.43 180.4 297.43"
            style="fill:#fff"></polygon>
        <polygon points="174.27 73.8 170.63 75.91 170.63 79.08 174.27 76.98 174.27 73.8" style="fill:#fff">
        </polygon>
        <polygon points="174.27 67.94 170.63 70.04 170.63 73.22 174.27 71.12 174.27 67.94" style="fill:#fff">
        </polygon>
        <polygon points="181.82 217.24 178.18 219.34 178.18 222.52 181.82 220.42 181.82 217.24" style="fill:#fff">
        </polygon>
        <polygon points="181.82 81.16 178.18 83.26 178.18 86.44 181.82 84.33 181.82 81.16" style="fill:#fff">
        </polygon>
        <polygon points="174.27 62.08 170.63 64.18 170.63 67.36 174.27 65.26 174.27 62.08" style="fill:#fff">
        </polygon>
        <polygon points="181.82 275.85 178.18 277.95 178.18 281.13 181.82 279.03 181.82 275.85" style="fill:#fff">
        </polygon>
        <polygon points="181.82 246.54 178.18 248.65 178.18 251.83 181.82 249.72 181.82 246.54" style="fill:#fff">
        </polygon>
        <polygon points="181.82 240.68 178.18 242.79 178.18 245.97 181.82 243.86 181.82 240.68" style="fill:#fff">
        </polygon>
        <polygon points="181.82 223.1 178.18 225.2 178.18 228.38 181.82 226.28 181.82 223.1" style="fill:#fff">
        </polygon>
        <polygon points="181.82 228.96 178.18 231.06 178.18 234.24 181.82 232.14 181.82 228.96" style="fill:#fff">
        </polygon>
        <polygon points="181.82 234.82 178.18 236.93 178.18 240.1 181.82 238 181.82 234.82" style="fill:#fff">
        </polygon>
        <polygon points="181.82 264.13 178.18 266.23 178.18 269.41 181.82 267.31 181.82 264.13" style="fill:#fff">
        </polygon>
        <polygon points="181.82 252.41 178.18 254.51 178.18 257.69 181.82 255.58 181.82 252.41" style="fill:#fff">
        </polygon>
        <polygon points="181.82 269.99 178.18 272.09 178.18 275.27 181.82 273.17 181.82 269.99" style="fill:#fff">
        </polygon>
        <polygon points="181.82 258.27 178.18 260.37 178.18 263.55 181.82 261.44 181.82 258.27" style="fill:#fff">
        </polygon>
        <polygon points="181.82 45.99 178.18 48.09 178.18 51.27 181.82 49.17 181.82 45.99" style="fill:#fff">
        </polygon>
        <polygon points="181.82 75.3 178.18 77.4 178.18 80.58 181.82 78.47 181.82 75.3" style="fill:#fff"></polygon>
        <polygon points="189.38 171.38 185.74 173.48 185.74 176.66 189.38 174.56 189.38 171.38" style="fill:#fff">
        </polygon>
        <polygon points="189.38 177.24 185.74 179.34 185.74 182.52 189.38 180.42 189.38 177.24" style="fill:#fff">
        </polygon>
        <polygon points="105.44 136.34 101.8 138.44 101.8 141.62 105.44 139.51 105.44 136.34" style="fill:#fff">
        </polygon>
        <polygon points="189.38 159.65 185.74 161.76 185.74 164.94 189.38 162.83 189.38 159.65" style="fill:#fff">
        </polygon>
        <polygon points="189.38 183.1 185.74 185.2 185.74 188.38 189.38 186.28 189.38 183.1" style="fill:#fff">
        </polygon>
        <polygon points="189.38 200.68 185.74 202.78 185.74 205.96 189.38 203.86 189.38 200.68" style="fill:#fff">
        </polygon>
        <polygon points="189.38 194.82 185.74 196.92 185.74 200.1 189.38 198 189.38 194.82" style="fill:#fff">
        </polygon>
        <polygon points="189.38 188.96 185.74 191.06 185.74 194.24 189.38 192.14 189.38 188.96" style="fill:#fff">
        </polygon>
        <polygon points="189.38 147.93 185.74 150.04 185.74 153.22 189.38 151.11 189.38 147.93" style="fill:#fff">
        </polygon>
        <polygon points="189.38 153.79 185.74 155.9 185.74 159.07 189.38 156.97 189.38 153.79" style="fill:#fff">
        </polygon>
        <polygon points="189.38 112.36 185.74 114.46 185.74 117.64 189.38 115.54 189.38 112.36" style="fill:#fff">
        </polygon>
        <polygon points="189.38 100.64 185.74 102.74 185.74 105.92 189.38 103.82 189.38 100.64" style="fill:#fff">
        </polygon>
        <polygon points="189.38 106.5 185.74 108.6 185.74 111.78 189.38 109.68 189.38 106.5" style="fill:#fff">
        </polygon>
        <polygon points="189.38 94.78 185.74 96.88 185.74 100.06 189.38 97.96 189.38 94.78" style="fill:#fff">
        </polygon>
        <polygon points="189.38 88.92 185.74 91.02 185.74 94.2 189.38 92.09 189.38 88.92" style="fill:#fff">
        </polygon>
        <polygon points="189.38 135.8 185.74 137.91 185.74 141.09 189.38 138.98 189.38 135.8" style="fill:#fff">
        </polygon>
        <polygon points="189.38 129.94 185.74 132.05 185.74 135.22 189.38 133.12 189.38 129.94" style="fill:#fff">
        </polygon>
        <polygon points="189.38 141.66 185.74 143.77 185.74 146.95 189.38 144.84 189.38 141.66" style="fill:#fff">
        </polygon>
        <polygon points="189.38 118.22 185.74 120.33 185.74 123.5 189.38 121.4 189.38 118.22" style="fill:#fff">
        </polygon>
        <polygon points="189.38 124.08 185.74 126.19 185.74 129.36 189.38 127.26 189.38 124.08" style="fill:#fff">
        </polygon>
        <polygon points="189.38 165.51 185.74 167.62 185.74 170.8 189.38 168.69 189.38 165.51" style="fill:#fff">
        </polygon>
        <polygon points="181.82 34.27 178.18 36.37 178.18 39.55 181.82 37.45 181.82 34.27" style="fill:#fff">
        </polygon>
        <polygon points="174.27 79.66 170.63 81.77 170.63 84.94 174.27 82.84 174.27 79.66" style="fill:#fff">
        </polygon>
        <polygon points="181.82 40.13 178.18 42.23 178.18 45.41 181.82 43.31 181.82 40.13" style="fill:#fff">
        </polygon>
        <polygon points="189.38 289.06 185.74 291.17 185.74 294.35 189.38 292.24 189.38 289.06" style="fill:#fff">
        </polygon>
        <polygon points="189.38 277.34 185.74 279.44 185.74 282.62 189.38 280.52 189.38 277.34" style="fill:#fff">
        </polygon>
        <polygon points="189.38 283.2 185.74 285.31 185.74 288.49 189.38 286.38 189.38 283.2" style="fill:#fff">
        </polygon>
        <polygon points="181.82 69.43 178.18 71.54 178.18 74.72 181.82 72.61 181.82 69.43" style="fill:#fff">
        </polygon>
        <polygon points="181.82 63.57 178.18 65.68 178.18 68.86 181.82 66.75 181.82 63.57" style="fill:#fff">
        </polygon>
        <polygon points="181.82 57.71 178.18 59.81 178.18 62.99 181.82 60.89 181.82 57.71" style="fill:#fff">
        </polygon>
        <polygon points="181.82 51.85 178.18 53.95 178.18 57.13 181.82 55.03 181.82 51.85" style="fill:#fff">
        </polygon>
        <polygon points="189.38 242.18 185.74 244.28 185.74 247.46 189.38 245.35 189.38 242.18" style="fill:#fff">
        </polygon>
        <polygon points="189.38 236.31 185.74 238.42 185.74 241.6 189.38 239.49 189.38 236.31" style="fill:#fff">
        </polygon>
        <polygon points="189.38 230.45 185.74 232.56 185.74 235.74 189.38 233.63 189.38 230.45" style="fill:#fff">
        </polygon>
        <polygon points="189.38 212.87 185.74 214.97 185.74 218.15 189.38 216.05 189.38 212.87" style="fill:#fff">
        </polygon>
        <polygon points="189.38 218.73 185.74 220.84 185.74 224.01 189.38 221.91 189.38 218.73" style="fill:#fff">
        </polygon>
        <polygon points="189.38 224.59 185.74 226.7 185.74 229.88 189.38 227.77 189.38 224.59" style="fill:#fff">
        </polygon>
        <polygon points="189.38 248.04 185.74 250.14 185.74 253.32 189.38 251.22 189.38 248.04" style="fill:#fff">
        </polygon>
        <polygon points="189.38 265.62 185.74 267.72 185.74 270.9 189.38 268.8 189.38 265.62" style="fill:#fff">
        </polygon>
        <polygon points="189.38 259.76 185.74 261.86 185.74 265.04 189.38 262.94 189.38 259.76" style="fill:#fff">
        </polygon>
        <polygon points="189.38 271.48 185.74 273.58 185.74 276.76 189.38 274.66 189.38 271.48" style="fill:#fff">
        </polygon>
        <polygon points="189.38 253.9 185.74 256 185.74 259.18 189.38 257.08 189.38 253.9" style="fill:#fff">
        </polygon>
        <polygon points="189.38 207.01 185.74 209.11 185.74 212.29 189.38 210.19 189.38 207.01" style="fill:#fff">
        </polygon>
        <polygon points="113 202.71 109.36 204.81 109.36 207.99 113 205.88 113 202.71" style="fill:#fff"></polygon>
        <polygon points="113 196.84 109.36 198.95 109.36 202.13 113 200.02 113 196.84" style="fill:#fff"></polygon>
        <polygon points="113 190.98 109.36 193.09 109.36 196.27 113 194.16 113 190.98" style="fill:#fff"></polygon>
        <polygon points="113 185.12 109.36 187.23 109.36 190.41 113 188.3 113 185.12" style="fill:#fff"></polygon>
        <polygon points="113 179.26 109.36 181.37 109.36 184.54 113 182.44 113 179.26" style="fill:#fff"></polygon>
        <polygon points="113 232.01 109.36 234.11 109.36 237.29 113 235.19 113 232.01" style="fill:#fff"></polygon>
        <polygon points="113 226.15 109.36 228.25 109.36 231.43 113 229.33 113 226.15" style="fill:#fff"></polygon>
        <polygon points="113 172.99 109.36 175.1 109.36 178.28 113 176.17 113 172.99" style="fill:#fff"></polygon>
        <polygon points="113 208.57 109.36 210.67 109.36 213.85 113 211.75 113 208.57" style="fill:#fff"></polygon>
        <polygon points="113 220.29 109.36 222.39 109.36 225.57 113 223.47 113 220.29" style="fill:#fff"></polygon>
        <polygon points="174.27 85.52 170.63 87.63 170.63 90.81 174.27 88.7 174.27 85.52" style="fill:#fff">
        </polygon>
        <polygon points="113 126.11 109.36 128.21 109.36 131.39 113 129.28 113 126.11" style="fill:#fff"></polygon>
        <polygon points="113 167.13 109.36 169.24 109.36 172.41 113 170.31 113 167.13" style="fill:#fff"></polygon>
        <polygon points="113 131.97 109.36 134.07 109.36 137.25 113 135.15 113 131.97" style="fill:#fff"></polygon>
        <polygon points="113 113.98 109.36 116.08 109.36 119.26 113 117.16 113 113.98" style="fill:#fff"></polygon>
        <polygon points="113 120.25 109.36 122.35 109.36 125.53 113 123.42 113 120.25" style="fill:#fff"></polygon>
        <polygon points="113 137.83 109.36 139.93 109.36 143.11 113 141.01 113 137.83" style="fill:#fff"></polygon>
        <polygon points="113 237.87 109.36 239.97 109.36 243.15 113 241.05 113 237.87" style="fill:#fff"></polygon>
        <polygon points="113 155.41 109.36 157.51 109.36 160.69 113 158.59 113 155.41" style="fill:#fff"></polygon>
        <polygon points="113 161.27 109.36 163.38 109.36 166.55 113 164.45 113 161.27" style="fill:#fff"></polygon>
        <polygon points="113 149.55 109.36 151.65 109.36 154.83 113 152.73 113 149.55" style="fill:#fff"></polygon>
        <polygon points="113 143.69 109.36 145.79 109.36 148.97 113 146.87 113 143.69" style="fill:#fff"></polygon>
        <polygon points="105.44 83.18 101.8 85.28 101.8 88.46 105.44 86.36 105.44 83.18" style="fill:#fff">
        </polygon>
        <polygon points="113 243.73 109.36 245.84 109.36 249.01 113 246.91 113 243.73" style="fill:#fff"></polygon>
        <polygon points="105.44 94.9 101.8 97.01 101.8 100.18 105.44 98.08 105.44 94.9" style="fill:#fff"></polygon>
        <polygon points="105.44 100.76 101.8 102.87 101.8 106.05 105.44 103.94 105.44 100.76" style="fill:#fff">
        </polygon>
        <polygon points="113 108.12 109.36 110.22 109.36 113.4 113 111.3 113 108.12" style="fill:#fff"></polygon>
        <polygon points="105.44 89.04 101.8 91.14 101.8 94.32 105.44 92.22 105.44 89.04" style="fill:#fff">
        </polygon>
        <polygon points="105.44 124.61 101.8 126.72 101.8 129.9 105.44 127.79 105.44 124.61" style="fill:#fff">
        </polygon>
        <polygon points="105.44 77.32 101.8 79.42 101.8 82.6 105.44 80.5 105.44 77.32" style="fill:#fff"></polygon>
        <polygon points="105.44 130.47 101.8 132.58 101.8 135.76 105.44 133.65 105.44 130.47" style="fill:#fff">
        </polygon>
        <polygon points="105.44 112.48 101.8 114.59 101.8 117.77 105.44 115.66 105.44 112.48" style="fill:#fff">
        </polygon>
        <polygon points="105.44 118.35 101.8 120.45 101.8 123.63 105.44 121.52 105.44 118.35" style="fill:#fff">
        </polygon>
        <polygon points="105.44 106.62 101.8 108.73 101.8 111.91 105.44 109.8 105.44 106.62" style="fill:#fff">
        </polygon>
        <polygon points="113 267.18 109.36 269.28 109.36 272.46 113 270.35 113 267.18" style="fill:#fff"></polygon>
        <polygon points="105.44 71.46 101.8 73.56 101.8 76.74 105.44 74.64 105.44 71.46" style="fill:#fff">
        </polygon>
        <polygon points="113 261.31 109.36 263.42 109.36 266.6 113 264.49 113 261.31" style="fill:#fff"></polygon>
        <polygon points="113 255.45 109.36 257.56 109.36 260.74 113 258.63 113 255.45" style="fill:#fff"></polygon>
        <polygon points="113 249.59 109.36 251.7 109.36 254.88 113 252.77 113 249.59" style="fill:#fff"></polygon>
        <polygon points="113 273.04 109.36 275.14 109.36 278.32 113 276.21 113 273.04" style="fill:#fff"></polygon>
        <polygon points="105.44 65.6 101.8 67.7 101.8 70.88 105.44 68.78 105.44 65.6" style="fill:#fff"></polygon>
        <polygon points="113 278.9 109.36 281 109.36 284.18 113 282.07 113 278.9" style="fill:#fff"></polygon>
        <polygon points="113 291.03 109.36 293.13 109.36 296.31 113 294.2 113 291.03" style="fill:#fff"></polygon>
        <polygon points="113 285.17 109.36 287.27 109.36 290.45 113 288.34 113 285.17" style="fill:#fff"></polygon>
        <polygon points="113 214.43 109.36 216.53 109.36 219.71 113 217.6 113 214.43" style="fill:#fff"></polygon>
        <polygon points="174.27 168.39 170.63 170.49 170.63 173.67 174.27 171.57 174.27 168.39" style="fill:#fff">
        </polygon>
        <polygon points="174.27 180.11 170.63 182.22 170.63 185.39 174.27 183.29 174.27 180.11" style="fill:#fff">
        </polygon>
        <polygon points="174.27 174.25 170.63 176.35 170.63 179.53 174.27 177.43 174.27 174.25" style="fill:#fff">
        </polygon>
        <polygon points="174.27 156.67 170.63 158.77 170.63 161.95 174.27 159.85 174.27 156.67" style="fill:#fff">
        </polygon>
        <polygon points="174.27 209.42 170.63 211.52 170.63 214.7 174.27 212.59 174.27 209.42" style="fill:#fff">
        </polygon>
        <polygon points="174.27 162.53 170.63 164.63 170.63 167.81 174.27 165.71 174.27 162.53" style="fill:#fff">
        </polygon>
        <polygon points="174.27 203.56 170.63 205.66 170.63 208.84 174.27 206.73 174.27 203.56" style="fill:#fff">
        </polygon>
        <polygon points="174.27 185.97 170.63 188.08 170.63 191.25 174.27 189.15 174.27 185.97" style="fill:#fff">
        </polygon>
        <polygon points="174.27 197.69 170.63 199.8 170.63 202.98 174.27 200.87 174.27 197.69" style="fill:#fff">
        </polygon>
        <polygon points="174.27 191.83 170.63 193.94 170.63 197.12 174.27 195.01 174.27 191.83" style="fill:#fff">
        </polygon>
        <polygon points="113 102.26 109.36 104.36 109.36 107.54 113 105.43 113 102.26" style="fill:#fff"></polygon>
        <polygon points="174.27 103.51 170.63 105.62 170.63 108.8 174.27 106.69 174.27 103.51" style="fill:#fff">
        </polygon>
        <polygon points="174.27 115.23 170.63 117.34 170.63 120.52 174.27 118.41 174.27 115.23" style="fill:#fff">
        </polygon>
        <polygon points="174.27 109.37 170.63 111.48 170.63 114.66 174.27 112.55 174.27 109.37" style="fill:#fff">
        </polygon>
        <polygon points="174.27 97.65 170.63 99.76 170.63 102.93 174.27 100.83 174.27 97.65" style="fill:#fff">
        </polygon>
        <polygon points="174.27 91.38 170.63 93.49 170.63 96.67 174.27 94.56 174.27 91.38" style="fill:#fff">
        </polygon>
        <polygon points="174.27 138.68 170.63 140.78 170.63 143.96 174.27 141.86 174.27 138.68" style="fill:#fff">
        </polygon>
        <polygon points="174.27 132.82 170.63 134.92 170.63 138.1 174.27 136 174.27 132.82" style="fill:#fff">
        </polygon>
        <polygon points="174.27 144.54 170.63 146.64 170.63 149.82 174.27 147.72 174.27 144.54" style="fill:#fff">
        </polygon>
        <polygon points="174.27 121.1 170.63 123.2 170.63 126.38 174.27 124.27 174.27 121.1" style="fill:#fff">
        </polygon>
        <polygon points="174.27 126.96 170.63 129.06 170.63 132.24 174.27 130.13 174.27 126.96" style="fill:#fff">
        </polygon>
        <polygon points="174.27 150.4 170.63 152.5 170.63 155.68 174.27 153.58 174.27 150.4" style="fill:#fff">
        </polygon>
        <polygon points="174.27 215.75 170.63 217.85 170.63 221.03 174.27 218.93 174.27 215.75" style="fill:#fff">
        </polygon>
        <polygon points="113 67.09 109.36 69.19 109.36 72.37 113 70.27 113 67.09" style="fill:#fff"></polygon>
        <polygon points="113 61.23 109.36 63.33 109.36 66.51 113 64.41 113 61.23" style="fill:#fff"></polygon>
        <polygon points="174.27 280.22 170.63 282.32 170.63 285.5 174.27 283.39 174.27 280.22" style="fill:#fff">
        </polygon>
        <polygon points="174.27 286.08 170.63 288.18 170.63 291.36 174.27 289.26 174.27 286.08" style="fill:#fff">
        </polygon>
        <polygon points="174.27 291.94 170.63 294.04 170.63 297.22 174.27 295.12 174.27 291.94" style="fill:#fff">
        </polygon>
        <polygon points="113 96.39 109.36 98.5 109.36 101.68 113 99.57 113 96.39" style="fill:#fff"></polygon>
        <polygon points="113 90.53 109.36 92.64 109.36 95.82 113 93.71 113 90.53" style="fill:#fff"></polygon>
        <polygon points="113 84.67 109.36 86.78 109.36 89.95 113 87.85 113 84.67" style="fill:#fff"></polygon>
        <polygon points="113 78.81 109.36 80.92 109.36 84.09 113 81.99 113 78.81" style="fill:#fff"></polygon>
        <polygon points="113 72.95 109.36 75.06 109.36 78.23 113 76.13 113 72.95" style="fill:#fff"></polygon>
        <polygon points="174.27 233.33 170.63 235.43 170.63 238.61 174.27 236.51 174.27 233.33" style="fill:#fff">
        </polygon>
        <polygon points="174.27 245.05 170.63 247.16 170.63 250.33 174.27 248.23 174.27 245.05" style="fill:#fff">
        </polygon>
        <polygon points="174.27 239.19 170.63 241.29 170.63 244.47 174.27 242.37 174.27 239.19" style="fill:#fff">
        </polygon>
        <polygon points="174.27 227.47 170.63 229.57 170.63 232.75 174.27 230.65 174.27 227.47" style="fill:#fff">
        </polygon>
        <polygon points="174.27 221.61 170.63 223.71 170.63 226.89 174.27 224.79 174.27 221.61" style="fill:#fff">
        </polygon>
        <polygon points="174.27 268.5 170.63 270.6 170.63 273.78 174.27 271.67 174.27 268.5" style="fill:#fff">
        </polygon>
        <polygon points="174.27 274.36 170.63 276.46 170.63 279.64 174.27 277.53 174.27 274.36" style="fill:#fff">
        </polygon>
        <polygon points="174.27 262.63 170.63 264.74 170.63 267.92 174.27 265.81 174.27 262.63" style="fill:#fff">
        </polygon>
        <polygon points="174.27 256.77 170.63 258.88 170.63 262.06 174.27 259.95 174.27 256.77" style="fill:#fff">
        </polygon>
        <polygon points="174.27 250.91 170.63 253.02 170.63 256.19 174.27 254.09 174.27 250.91" style="fill:#fff">
        </polygon>
        <polygon points="377.25 239.49 373.6 237.38 373.6 240.56 377.25 242.66 377.25 239.49" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 245.35 373.6 243.24 373.6 246.42 377.25 248.53 377.25 245.35" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 233.63 373.6 231.52 373.6 234.7 377.25 236.8 377.25 233.63" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 227.16 373.6 225.06 373.6 228.24 377.25 230.34 377.25 227.16" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 221.3 373.6 219.19 373.6 222.37 377.25 224.48 377.25 221.3" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 263.23 373.6 261.12 373.6 264.3 377.25 266.4 377.25 263.23" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 150.5 373.6 148.4 373.6 151.57 377.25 153.68 377.25 150.5" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 274.95 373.6 272.84 373.6 276.02 377.25 278.13 377.25 274.95" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 269.09 373.6 266.98 373.6 270.16 377.25 272.26 377.25 269.09" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 215.44 373.6 213.33 373.6 216.51 377.25 218.62 377.25 215.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 257.36 373.6 255.26 373.6 258.44 377.25 260.54 377.25 257.36" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 156.36 373.6 154.26 373.6 157.44 377.25 159.54 377.25 156.36" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 140.27 366.05 138.17 366.05 141.34 369.69 143.45 369.69 140.27" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 179.8 373.6 177.7 373.6 180.88 377.25 182.98 377.25 179.8" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 173.94 373.6 171.84 373.6 175.02 377.25 177.12 377.25 173.94" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 162.22 373.6 160.12 373.6 163.29 377.25 165.4 377.25 162.22" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 209.58 373.6 207.47 373.6 210.65 377.25 212.76 377.25 209.58" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 280.81 373.6 278.7 373.6 281.88 377.25 283.99 377.25 280.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 203.72 373.6 201.61 373.6 204.79 377.25 206.9 377.25 203.72" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 197.85 373.6 195.75 373.6 198.93 377.25 201.03 377.25 197.85" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 191.53 373.6 189.42 373.6 192.6 377.25 194.7 377.25 191.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 185.66 373.6 183.56 373.6 186.74 377.25 188.84 377.25 185.66" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 251.27 373.6 249.16 373.6 252.34 377.25 254.44 377.25 251.27" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 104.7 366.05 102.59 366.05 105.77 369.69 107.88 369.69 104.7" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 98.84 366.05 96.73 366.05 99.91 369.69 102.02 369.69 98.84" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 92.98 366.05 90.87 366.05 94.05 369.69 96.15 369.69 92.98" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 110.56 366.05 108.45 366.05 111.63 369.69 113.74 369.69 110.56" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 87.11 366.05 85.01 366.05 88.19 369.69 90.29 369.69 87.11" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 134.41 366.05 132.31 366.05 135.48 369.69 137.59 369.69 134.41" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 81.25 366.05 79.15 366.05 82.33 369.69 84.43 369.69 81.25" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 128.14 366.05 126.04 366.05 129.22 369.69 131.32 369.69 128.14" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 122.28 366.05 120.18 366.05 123.36 369.69 125.46 369.69 122.28" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 116.42 366.05 114.32 366.05 117.49 369.69 119.6 369.69 116.42" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 63.26 366.05 61.16 366.05 64.34 369.69 66.44 369.69 63.26" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 39.82 366.05 37.72 366.05 40.9 369.69 43 369.69 39.82" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 45.68 366.05 43.58 366.05 46.76 369.69 48.86 369.69 45.68" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 33.96 366.05 31.86 366.05 35.03 369.69 37.14 369.69 33.96" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 292.53 373.6 290.43 373.6 293.6 377.25 295.71 377.25 292.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 75.39 366.05 73.29 366.05 76.47 369.69 78.57 369.69 75.39" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 51.54 366.05 49.44 366.05 52.62 369.69 54.72 369.69 51.54" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 286.67 373.6 284.56 373.6 287.74 377.25 289.85 377.25 286.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 69.13 366.05 67.02 366.05 70.2 369.69 72.3 369.69 69.13" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 57.4 366.05 55.3 366.05 58.48 369.69 60.58 369.69 57.4" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 168.08 373.6 165.98 373.6 169.16 377.25 171.26 377.25 168.08" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 249.72 381.16 247.61 381.16 250.79 384.8 252.89 384.8 249.72" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 243.85 381.16 241.75 381.16 244.93 384.8 247.03 384.8 243.85" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 237.99 381.16 235.89 381.16 239.07 384.8 241.17 384.8 237.99" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 219.81 381.16 217.7 381.16 220.88 384.8 222.98 384.8 219.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 231.53 381.16 229.42 381.16 232.6 384.8 234.71 384.8 231.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 279.31 381.16 277.21 381.16 280.39 384.8 282.49 384.8 279.31" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 267.59 381.16 265.49 381.16 268.67 384.8 270.77 384.8 267.59" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 273.45 381.16 271.35 381.16 274.53 384.8 276.63 384.8 273.45" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 261.73 381.16 259.63 381.16 262.81 384.8 264.91 384.8 261.73" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 255.63 381.16 253.53 381.16 256.71 384.8 258.81 384.8 255.63" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 225.67 381.16 223.56 381.16 226.74 384.8 228.84 384.8 225.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 172.45 381.16 170.35 381.16 173.52 384.8 175.63 384.8 172.45" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 184.17 381.16 182.07 381.16 185.25 384.8 187.35 384.8 184.17" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 178.31 381.16 176.21 381.16 179.38 384.8 181.49 384.8 178.31" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 166.59 381.16 164.49 381.16 167.66 384.8 169.77 384.8 166.59" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 213.94 381.16 211.84 381.16 215.02 384.8 217.12 384.8 213.94" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 160.73 381.16 158.62 381.16 161.8 384.8 163.91 384.8 160.73" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 202.22 381.16 200.12 381.16 203.3 384.8 205.4 384.8 202.22" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 208.08 381.16 205.98 381.16 209.16 384.8 211.26 384.8 208.08" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 190.03 381.16 187.93 381.16 191.11 384.8 193.21 384.8 190.03" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 195.89 381.16 193.79 381.16 196.97 384.8 199.07 384.8 195.89" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 297.43 384.8 296.9 381.16 294.79 381.16 297.43 384.8 297.43" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 103.2 373.6 101.1 373.6 104.28 377.25 106.38 377.25 103.2" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 109.07 373.6 106.96 373.6 110.14 377.25 112.24 377.25 109.07" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 114.93 373.6 112.82 373.6 116 377.25 118.11 377.25 114.93" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 97.34 373.6 95.24 373.6 98.42 377.25 100.52 377.25 97.34" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 85.62 373.6 83.52 373.6 86.7 377.25 88.8 377.25 85.62" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 91.48 373.6 89.38 373.6 92.56 377.25 94.66 377.25 91.48" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 138.78 373.6 136.67 373.6 139.85 377.25 141.96 377.25 138.78" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 120.79 373.6 118.68 373.6 121.86 377.25 123.97 377.25 120.79" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 132.51 373.6 130.41 373.6 133.58 377.25 135.69 377.25 132.51" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 126.65 373.6 124.55 373.6 127.72 377.25 129.83 377.25 126.65" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 61.77 373.6 59.67 373.6 62.85 377.25 64.95 377.25 61.77" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 44.19 373.6 42.09 373.6 45.26 377.25 47.37 377.25 44.19" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 50.05 373.6 47.95 373.6 51.12 377.25 53.23 377.25 50.05" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 38.33 373.6 36.22 373.6 39.4 377.25 41.51 377.25 38.33" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 291.04 381.16 288.93 381.16 292.11 384.8 294.21 384.8 291.04" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 144.64 373.6 142.53 373.6 145.71 377.25 147.82 377.25 144.64" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 67.63 373.6 65.53 373.6 68.71 377.25 70.81 377.25 67.63" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 55.91 373.6 53.81 373.6 56.98 377.25 59.09 377.25 55.91" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 79.76 373.6 77.66 373.6 80.84 377.25 82.94 377.25 79.76" style="fill:#e6e6e6">
        </polygon>
        <polygon points="377.25 73.49 373.6 71.39 373.6 74.57 377.25 76.67 377.25 73.49" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 285.18 381.16 283.07 381.16 286.25 384.8 288.35 384.8 285.18" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 53.04 358.49 50.93 358.49 54.11 362.14 56.21 362.14 53.04" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 224.89 358.49 222.79 358.49 225.96 362.14 228.07 362.14 224.89" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 218.42 358.49 216.32 358.49 219.5 362.14 221.6 362.14 218.42" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 212.56 358.49 210.46 358.49 213.64 362.14 215.74 362.14 212.56" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 206.7 358.49 204.6 358.49 207.78 362.14 209.88 362.14 206.7" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 230.75 358.49 228.65 358.49 231.82 362.14 233.93 362.14 230.75" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 248.63 358.49 246.53 358.49 249.7 362.14 251.81 362.14 248.63" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 236.61 358.49 234.51 358.49 237.69 362.14 239.79 362.14 236.61" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 200.84 358.49 198.74 358.49 201.92 362.14 204.02 362.14 200.84" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 254.49 358.49 252.39 358.49 255.56 362.14 257.67 362.14 254.49" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 242.53 358.49 240.43 358.49 243.61 362.14 245.71 362.14 242.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 260.35 358.49 258.25 358.49 261.43 362.14 263.53 362.14 260.35" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 194.98 358.49 192.88 358.49 196.06 362.14 198.16 362.14 194.98" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 159.35 358.49 157.24 358.49 160.42 362.14 162.52 362.14 159.35" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 141.76 358.49 139.66 358.49 142.84 362.14 144.94 362.14 141.76" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 165.21 358.49 163.1 358.49 166.28 362.14 168.38 362.14 165.21" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 147.62 358.49 145.52 358.49 148.7 362.14 150.8 362.14 147.62" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 153.49 358.49 151.38 358.49 154.56 362.14 156.66 362.14 153.49" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 171.07 358.49 168.96 358.49 172.14 362.14 174.25 362.14 171.07" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 189.12 358.49 187.02 358.49 190.19 362.14 192.3 362.14 189.12" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 182.79 358.49 180.69 358.49 183.86 362.14 185.97 362.14 182.79" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 176.93 358.49 174.82 358.49 178 362.14 180.11 362.14 176.93" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 266.21 358.49 264.11 358.49 267.29 362.14 269.39 362.14 266.21" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 137.32 277.19 135.22 277.19 138.39 280.83 140.5 280.83 137.32" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 131.05 277.19 128.95 277.19 132.13 280.83 134.23 280.83 131.05" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 143.18 277.19 141.08 277.19 144.25 280.83 146.36 280.83 143.18" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 125.19 277.19 123.09 277.19 126.27 280.83 128.37 280.83 125.19" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 119.33 277.19 117.22 277.19 120.4 280.83 122.51 280.83 119.33" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 149.04 277.19 146.94 277.19 150.12 280.83 152.22 280.83 149.04" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 166.62 277.19 164.52 277.19 167.7 280.83 169.8 280.83 166.62" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 160.76 277.19 158.66 277.19 161.84 280.83 163.94 280.83 160.76" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 107.61 277.19 105.5 277.19 108.68 280.83 110.79 280.83 107.61" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 154.9 277.19 152.8 277.19 155.98 280.83 158.08 280.83 154.9" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 135.9 358.49 133.8 358.49 136.98 362.14 139.08 362.14 135.9" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 146.13 366.05 144.03 366.05 147.21 369.69 149.31 369.69 146.13" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 289.65 358.49 287.55 358.49 290.73 362.14 292.83 362.14 289.65" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 297.43 362.14 295.52 358.49 293.41 358.49 296.59 359.95 297.43 362.14 297.43"
            style="fill:#e6e6e6"></polygon>
        <polygon points="362.14 277.93 358.49 275.83 358.49 279.01 362.14 281.11 362.14 277.93" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 272.07 358.49 269.97 358.49 273.15 362.14 275.25 362.14 272.07" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 95.89 277.19 93.78 277.19 96.96 280.83 99.06 280.83 95.89" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 101.75 277.19 99.64 277.19 102.82 280.83 104.92 280.83 101.75" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 78.3 277.19 76.2 277.19 79.38 280.83 81.48 280.83 78.3" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 90.02 277.19 87.92 277.19 91.1 280.83 93.2 280.83 90.02" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 84.16 277.19 82.06 277.19 85.24 280.83 87.34 280.83 84.16" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 283.79 358.49 281.69 358.49 284.87 362.14 286.97 362.14 283.79" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 229.26 366.05 227.15 366.05 230.33 369.69 232.44 369.69 229.26" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 235.12 366.05 233.01 366.05 236.19 369.69 238.3 369.69 235.12" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 216.93 366.05 214.83 366.05 218.01 369.69 220.11 369.69 216.93" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 222.79 366.05 220.69 366.05 223.87 369.69 225.97 369.69 222.79" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 211.07 366.05 208.97 366.05 212.15 369.69 214.25 369.69 211.07" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 240.98 366.05 238.88 366.05 242.05 369.69 244.16 369.69 240.98" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 264.72 366.05 262.61 366.05 265.79 369.69 267.9 369.69 264.72" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 258.86 366.05 256.75 366.05 259.93 369.69 262.04 369.69 258.86" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 246.9 366.05 244.8 366.05 247.97 369.69 250.08 369.69 246.9" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 253 366.05 250.89 366.05 254.07 369.69 256.18 369.69 253" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 181.3 366.05 179.19 366.05 182.37 369.69 184.47 369.69 181.3" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 205.21 366.05 203.1 366.05 206.28 369.69 208.39 369.69 205.21" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 169.57 366.05 167.47 366.05 170.65 369.69 172.75 369.69 169.57" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 157.85 366.05 155.75 366.05 158.93 369.69 161.03 369.69 157.85" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 175.44 366.05 173.33 366.05 176.51 369.69 178.61 369.69 175.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 151.99 366.05 149.89 366.05 153.07 369.69 155.17 369.69 151.99" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 163.71 366.05 161.61 366.05 164.79 369.69 166.89 369.69 163.71" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 193.49 366.05 191.38 366.05 194.56 369.69 196.67 369.69 193.49" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 130.04 358.49 127.94 358.49 131.12 362.14 133.22 362.14 130.04" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 172.48 277.19 170.38 277.19 173.56 280.83 175.66 280.83 172.48" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 270.58 366.05 268.48 366.05 271.65 369.69 273.76 369.69 270.58" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 199.35 366.05 197.25 366.05 200.42 369.69 202.53 369.69 199.35" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 88.61 358.49 86.5 358.49 89.68 362.14 91.79 362.14 88.61" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 94.47 358.49 92.36 358.49 95.54 362.14 97.65 362.14 94.47" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 76.89 358.49 74.78 358.49 77.96 362.14 80.06 362.14 76.89" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 82.75 358.49 80.64 358.49 83.82 362.14 85.92 362.14 82.75" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 71.03 358.49 68.92 358.49 72.1 362.14 74.2 362.14 71.03" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 100.33 358.49 98.23 358.49 101.41 362.14 103.51 362.14 100.33" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 123.77 358.49 121.67 358.49 124.85 362.14 126.95 362.14 123.77" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 276.44 366.05 274.34 366.05 277.51 369.69 279.62 369.69 276.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 106.19 358.49 104.09 358.49 107.27 362.14 109.37 362.14 106.19" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 112.05 358.49 109.95 358.49 113.13 362.14 115.23 362.14 112.05" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 117.91 358.49 115.81 358.49 118.99 362.14 121.09 362.14 117.91" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 29.59 358.49 27.49 358.49 30.67 362.14 32.77 362.14 29.59" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 294.02 366.05 291.92 366.05 295.1 369.69 297.2 369.69 294.02" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 282.3 366.05 280.2 366.05 283.38 369.69 285.48 369.69 282.3" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 288.16 366.05 286.06 366.05 289.24 369.69 291.34 369.69 288.16" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 35.45 358.49 33.35 358.49 36.53 362.14 38.63 362.14 35.45" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 47.17 358.49 45.07 358.49 48.25 362.14 50.35 362.14 47.17" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 58.9 358.49 56.79 358.49 59.97 362.14 62.08 362.14 58.9" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 41.31 358.49 39.21 358.49 42.39 362.14 44.49 362.14 41.31" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 154.87 381.16 152.76 381.16 155.94 384.8 158.04 384.8 154.87" style="fill:#e6e6e6">
        </polygon>
        <polygon points="362.14 64.76 358.49 62.65 358.49 65.83 362.14 67.94 362.14 64.76" style="fill:#e6e6e6">
        </polygon>
        <polygon points="369.69 187.16 366.05 185.05 366.05 188.23 369.69 190.34 369.69 187.16" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 195.62 461.9 193.51 461.9 196.69 465.54 198.79 465.54 195.62" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 189.75 461.9 187.65 461.9 190.83 465.54 192.93 465.54 189.75" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 183.49 461.9 181.38 461.9 184.56 465.54 186.66 465.54 183.49" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 177.63 461.9 175.52 461.9 178.7 465.54 180.8 465.54 177.63" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 171.76 461.9 169.66 461.9 172.84 465.54 174.94 465.54 171.76" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 165.9 461.9 163.8 461.9 166.98 465.54 169.08 465.54 165.9" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 224.92 461.9 222.82 461.9 226 465.54 228.1 465.54 224.92" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 219.06 461.9 216.96 461.9 220.13 465.54 222.24 465.54 219.06" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 213.2 461.9 211.09 461.9 214.27 465.54 216.38 465.54 213.2" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 207.34 461.9 205.23 461.9 208.41 465.54 210.52 465.54 207.34" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 201.48 461.9 199.37 461.9 202.55 465.54 204.66 465.54 201.48" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 154.18 461.9 152.08 461.9 155.26 465.54 157.36 465.54 154.18" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 160.04 461.9 157.94 461.9 161.12 465.54 163.22 465.54 160.04" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 118.61 461.9 116.51 461.9 119.69 465.54 121.79 465.54 118.61" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 124.47 461.9 122.37 461.9 125.55 465.54 127.65 465.54 124.47" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 106.89 461.9 104.78 461.9 107.96 465.54 110.07 465.54 106.89" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 112.75 461.9 110.64 461.9 113.82 465.54 115.93 465.54 112.75" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 130.74 461.9 128.63 461.9 131.81 465.54 133.92 465.54 130.74" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 230.78 461.9 228.68 461.9 231.86 465.54 233.96 465.54 230.78" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 148.32 461.9 146.22 461.9 149.4 465.54 151.5 465.54 148.32" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 142.46 461.9 140.36 461.9 143.53 465.54 145.64 465.54 142.46" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 136.6 461.9 134.5 461.9 137.67 465.54 139.78 465.54 136.6" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 90.8 454.35 88.69 454.35 91.87 457.99 93.98 457.99 90.8" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 67.36 454.35 65.25 454.35 68.43 457.99 70.53 457.99 67.36" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 101.03 461.9 98.92 461.9 102.1 465.54 104.21 465.54 101.03" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 126.37 454.35 124.27 454.35 127.45 457.99 129.55 457.99 126.37" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 73.22 454.35 71.11 454.35 74.29 457.99 76.39 457.99 73.22" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 149.01 381.16 146.9 381.16 150.08 384.8 152.18 384.8 149.01" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 84.94 454.35 82.83 454.35 86.01 457.99 88.12 457.99 84.94" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 120.1 454.35 118 454.35 121.18 457.99 123.28 457.99 120.1" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 102.52 454.35 100.42 454.35 103.59 457.99 105.7 457.99 102.52" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 114.24 454.35 112.14 454.35 115.32 457.99 117.42 457.99 114.24" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 108.38 454.35 106.28 454.35 109.46 457.99 111.56 457.99 108.38" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 297.43 465.54 295.48 461.9 293.37 461.9 296.55 463.43 297.43 465.54 297.43"
            style="fill:#e6e6e6"></polygon>
        <polygon points="465.54 255.03 461.9 252.93 461.9 256.1 465.54 258.21 465.54 255.03" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 260.31 461.9 258.21 461.9 261.38 465.54 263.49 465.54 260.31" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 236.64 461.9 234.54 461.9 237.72 465.54 239.82 465.54 236.64" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 266.17 461.9 264.07 461.9 267.25 465.54 269.35 465.54 266.17" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 242.5 461.9 240.4 461.9 243.58 465.54 245.68 465.54 242.5" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 249.17 461.9 247.06 461.9 250.24 465.54 252.35 465.54 249.17" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 283.75 461.9 281.65 461.9 284.83 465.54 286.93 465.54 283.75" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 289.62 461.9 287.51 461.9 290.69 465.54 292.79 465.54 289.62" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 277.89 461.9 275.79 461.9 278.97 465.54 281.07 465.54 277.89" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 272.03 461.9 269.93 461.9 273.11 465.54 275.21 465.54 272.03" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 96.66 454.35 94.56 454.35 97.73 457.99 99.84 457.99 96.66" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 164.41 469.45 162.31 469.45 165.49 473.1 167.59 473.1 164.41" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 158.55 469.45 156.45 469.45 159.63 473.1 161.73 473.1 158.55" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 152.69 469.45 150.59 469.45 153.76 473.1 155.87 473.1 152.69" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 140.97 469.45 138.86 469.45 142.04 473.1 144.15 473.1 140.97" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 146.83 469.45 144.72 469.45 147.9 473.1 150.01 473.1 146.83" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 176.13 469.45 174.03 469.45 177.21 473.1 179.31 473.1 176.13" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 187.85 469.45 185.75 469.45 188.93 473.1 191.03 473.1 187.85" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 170.27 469.45 168.17 469.45 171.35 473.1 173.45 473.1 170.27" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 181.99 469.45 179.89 469.45 183.07 473.1 185.17 473.1 181.99" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 135.11 469.45 133 469.45 136.18 473.1 138.28 473.1 135.11" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 81.95 469.45 79.85 469.45 83.03 473.1 85.13 473.1 81.95" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 93.67 469.45 91.57 469.45 94.75 473.1 96.85 473.1 93.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 87.81 469.45 85.71 469.45 88.89 473.1 90.99 473.1 87.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 194.12 469.45 192.02 469.45 195.2 473.1 197.3 473.1 194.12" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 99.53 469.45 97.43 469.45 100.61 473.1 102.71 473.1 99.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 76.09 469.45 73.99 469.45 77.17 473.1 79.27 473.1 76.09" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 117.12 469.45 115.01 469.45 118.19 473.1 120.3 473.1 117.12" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 105.39 469.45 103.29 469.45 106.47 473.1 108.57 473.1 105.39" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 122.98 469.45 120.87 469.45 124.05 473.1 126.16 473.1 122.98" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 128.84 469.45 126.73 469.45 129.91 473.1 132.02 473.1 128.84" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 111.26 469.45 109.15 469.45 112.33 473.1 114.43 473.1 111.26" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 89.31 461.9 87.2 461.9 90.38 465.54 92.48 465.54 89.31" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 282.26 469.45 280.16 469.45 283.34 473.1 285.44 473.1 282.26" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 293.98 469.45 291.88 469.45 295.06 473.1 297.16 473.1 293.98" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 288.12 469.45 286.02 469.45 289.2 473.1 291.3 473.1 288.12" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 264.68 469.45 262.57 469.45 265.75 473.1 267.86 473.1 264.68" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 270.54 469.45 268.44 469.45 271.61 473.1 273.72 473.1 270.54" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 276.4 469.45 274.3 469.45 277.48 473.1 279.58 473.1 276.4" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 83.44 461.9 81.34 461.9 84.52 465.54 86.62 465.54 83.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 95.17 461.9 93.06 461.9 96.24 465.54 98.34 465.54 95.17" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 77.58 461.9 75.48 461.9 78.66 465.54 80.76 465.54 77.58" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 199.98 469.45 197.88 469.45 201.06 473.1 203.16 473.1 199.98" style="fill:#e6e6e6">
        </polygon>
        <polygon points="465.54 71.72 461.9 69.62 461.9 72.8 465.54 74.9 465.54 71.72" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 223.43 469.45 221.32 469.45 224.5 473.1 226.61 473.1 223.43" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 217.57 469.45 215.46 469.45 218.64 473.1 220.75 473.1 217.57" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 211.71 469.45 209.6 469.45 212.78 473.1 214.88 473.1 211.71" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 229.29 469.45 227.18 469.45 230.36 473.1 232.47 473.1 229.29" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 205.84 469.45 203.74 469.45 206.92 473.1 209.02 473.1 205.84" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 241.01 469.45 238.91 469.45 242.09 473.1 244.19 473.1 241.01" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 235.15 469.45 233.04 469.45 236.22 473.1 238.33 473.1 235.15" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 246.87 469.45 244.77 469.45 247.95 473.1 250.05 473.1 246.87" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 253.53 469.45 251.43 469.45 254.61 473.1 256.71 473.1 253.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="473.1 259.4 469.45 257.29 469.45 260.47 473.1 262.57 473.1 259.4" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 79.08 454.35 76.97 454.35 80.15 457.99 82.25 457.99 79.08" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 216.19 446.79 214.08 446.79 217.26 450.43 219.36 450.43 216.19" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 246.29 446.79 244.19 446.79 247.37 450.43 249.47 450.43 246.29" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 240.43 446.79 238.33 446.79 241.51 450.43 243.61 450.43 240.43" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 227.91 446.79 225.8 446.79 228.98 450.43 231.09 450.43 227.91" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 222.04 446.79 219.94 446.79 223.12 450.43 225.22 450.43 222.04" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 233.77 446.79 231.66 446.79 234.84 450.43 236.95 450.43 233.77" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 269.16 446.79 267.05 446.79 270.23 450.43 272.34 450.43 269.16" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 151.31 446.79 149.2 446.79 152.38 450.43 154.49 450.43 151.31" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 251.57 446.79 249.47 446.79 252.65 450.43 254.75 450.43 251.57" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 257.44 446.79 255.33 446.79 258.51 450.43 260.61 450.43 257.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 263.3 446.79 261.19 446.79 264.37 450.43 266.48 450.43 263.3" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 280.88 446.79 278.78 446.79 281.95 450.43 284.06 450.43 280.88" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 174.75 446.79 172.65 446.79 175.83 450.43 177.93 450.43 174.75" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 168.89 446.79 166.79 446.79 169.97 450.43 172.07 450.43 168.89" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 163.03 446.79 160.93 446.79 164.1 450.43 166.21 450.43 163.03" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 181.02 446.79 178.91 446.79 182.09 450.43 184.2 450.43 181.02" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 157.17 446.79 155.06 446.79 158.24 450.43 160.35 450.43 157.17" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 204.46 446.79 202.36 446.79 205.54 450.43 207.64 450.43 204.46" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 210.32 446.79 208.22 446.79 211.4 450.43 213.5 450.43 210.32" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 198.6 446.79 196.5 446.79 199.68 450.43 201.78 450.43 198.6" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 186.88 446.79 184.78 446.79 187.96 450.43 190.06 450.43 186.88" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 192.74 446.79 190.64 446.79 193.81 450.43 195.92 450.43 192.74" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 275.02 446.79 272.92 446.79 276.09 450.43 278.2 450.43 275.02" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 113.43 381.16 111.33 381.16 114.51 384.8 116.61 384.8 113.43" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 107.57 381.16 105.47 381.16 108.65 384.8 110.75 384.8 107.57" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 95.85 381.16 93.75 381.16 96.92 384.8 99.03 384.8 95.85" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 101.71 381.16 99.61 381.16 102.79 384.8 104.89 384.8 101.71" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 286.74 446.79 284.64 446.79 287.81 450.43 289.92 450.43 286.74" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 89.99 381.16 87.89 381.16 91.06 384.8 93.17 384.8 89.99" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 136.88 381.16 134.77 381.16 137.95 384.8 140.06 384.8 136.88" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 143.15 381.16 141.04 381.16 144.22 384.8 146.32 384.8 143.15" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 131.02 381.16 128.91 381.16 132.09 384.8 134.19 384.8 131.02" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 125.16 381.16 123.05 381.16 126.23 384.8 128.33 384.8 125.16" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 119.29 381.16 117.19 381.16 120.37 384.8 122.47 384.8 119.29" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 48.56 381.16 46.45 381.16 49.63 384.8 51.73 384.8 48.56" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 42.7 381.16 40.59 381.16 43.77 384.8 45.87 384.8 42.7" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 132.23 454.35 130.13 454.35 133.31 457.99 135.41 457.99 132.23" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 54.42 381.16 52.31 381.16 55.49 384.8 57.6 384.8 54.42" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 84.13 381.16 82.03 381.16 85.2 384.8 87.31 384.8 84.13" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 292.6 446.79 290.5 446.79 293.68 450.43 295.78 450.43 292.6" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 77.86 381.16 75.76 381.16 78.94 384.8 81.04 384.8 77.86" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 72 381.16 69.9 381.16 73.08 384.8 75.18 384.8 72" style="fill:#e6e6e6"></polygon>
        <polygon points="384.8 66.14 381.16 64.03 381.16 67.21 384.8 69.32 384.8 66.14" style="fill:#e6e6e6">
        </polygon>
        <polygon points="384.8 60.28 381.16 58.17 381.16 61.35 384.8 63.46 384.8 60.28" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 220.55 454.35 218.45 454.35 221.63 457.99 223.73 457.99 220.55" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 214.69 454.35 212.59 454.35 215.77 457.99 217.87 457.99 214.69" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 202.97 454.35 200.87 454.35 204.04 457.99 206.15 457.99 202.97" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 226.41 454.35 224.31 454.35 227.49 457.99 229.59 457.99 226.41" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 208.83 454.35 206.73 454.35 209.91 457.99 212.01 457.99 208.83" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 250.66 454.35 248.56 454.35 251.74 457.99 253.84 457.99 250.66" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 197.11 454.35 195 454.35 198.18 457.99 200.29 457.99 197.11" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 244.8 454.35 242.7 454.35 245.87 457.99 247.98 457.99 244.8" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 232.27 454.35 230.17 454.35 233.35 457.99 235.45 457.99 232.27" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 238.13 454.35 236.03 454.35 239.21 457.99 241.31 457.99 238.13" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 173.26 454.35 171.15 454.35 174.33 457.99 176.44 457.99 173.26" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 155.68 454.35 153.57 454.35 156.75 457.99 158.85 457.99 155.68" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 149.81 454.35 147.71 454.35 150.89 457.99 152.99 457.99 149.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 161.54 454.35 159.43 454.35 162.61 457.99 164.72 457.99 161.54" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 143.95 454.35 141.85 454.35 145.03 457.99 147.13 457.99 143.95" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 138.09 454.35 135.99 454.35 139.17 457.99 141.27 457.99 138.09" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 191.25 454.35 189.14 454.35 192.32 457.99 194.43 457.99 191.25" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 167.4 454.35 165.29 454.35 168.47 457.99 170.58 457.99 167.4" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 185.39 454.35 183.28 454.35 186.46 457.99 188.56 457.99 185.39" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 179.12 454.35 177.01 454.35 180.19 457.99 182.3 457.99 179.12" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 255.94 454.35 253.84 454.35 257.02 457.99 259.12 457.99 255.94" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 86.43 446.79 84.33 446.79 87.5 450.43 89.61 450.43 86.43" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 104.01 446.79 101.91 446.79 105.09 450.43 107.19 450.43 104.01" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 109.87 446.79 107.77 446.79 110.95 450.43 113.05 450.43 109.87" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 145.45 446.79 143.34 446.79 146.52 450.43 148.63 450.43 145.45" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 115.73 446.79 113.63 446.79 116.81 450.43 118.91 450.43 115.73" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 92.29 446.79 90.19 446.79 93.37 450.43 95.47 450.43 92.29" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 98.15 446.79 96.05 446.79 99.23 450.43 101.33 450.43 98.15" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 139.59 446.79 137.48 446.79 140.66 450.43 142.76 450.43 139.59" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 133.72 446.79 131.62 446.79 134.8 450.43 136.9 450.43 133.72" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 122 446.79 119.9 446.79 123.08 450.43 125.18 450.43 122" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 127.86 446.79 125.76 446.79 128.94 450.43 131.04 450.43 127.86" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 68.85 446.79 66.74 446.79 69.92 450.43 72.03 450.43 68.85" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 279.39 454.35 277.28 454.35 280.46 457.99 282.56 457.99 279.39" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 285.25 454.35 283.14 454.35 286.32 457.99 288.43 457.99 285.25" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 273.52 454.35 271.42 454.35 274.6 457.99 276.7 457.99 273.52" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 291.11 454.35 289 454.35 292.18 457.99 294.29 457.99 291.11" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 267.67 454.35 265.56 454.35 268.74 457.99 270.84 457.99 267.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 74.71 446.79 72.61 446.79 75.78 450.43 77.89 450.43 74.71" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 80.57 446.79 78.47 446.79 81.64 450.43 83.75 450.43 80.57" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 261.8 454.35 259.7 454.35 262.88 457.99 264.98 457.99 261.8" style="fill:#e6e6e6">
        </polygon>
        <polygon points="450.43 62.99 446.79 60.88 446.79 64.06 450.43 66.17 450.43 62.99" style="fill:#e6e6e6">
        </polygon>
        <polygon points="457.99 297.43 457.99 296.97 454.35 294.87 454.35 297.43 457.99 297.43" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 113.47 277.19 111.36 277.19 114.54 280.83 116.65 280.83 113.47" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.42 297.43 128.89 295.39 128.89 297.43 132.42 297.43" style="fill:#e6e6e6"></polygon>
        <polygon points="124.98 63.33 121.33 61.23 121.33 64.41 124.98 66.51 124.98 63.33" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 291.64 128.89 289.53 128.89 292.71 132.53 294.81 132.53 291.64" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 69.19 121.33 67.09 121.33 70.27 124.98 72.37 124.98 69.19" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 285.37 128.89 283.26 128.89 286.44 132.53 288.55 132.53 285.37" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 98.5 121.33 96.39 121.33 99.57 124.98 101.68 124.98 98.5" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 279.51 128.89 277.4 128.89 280.58 132.53 282.69 132.53 279.51" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 92.64 121.33 90.53 121.33 93.71 124.98 95.82 124.98 92.64" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 104.36 121.33 102.26 121.33 105.43 124.98 107.54 124.98 104.36" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 80.92 121.33 78.81 121.33 81.99 124.98 84.09 124.98 80.92" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 75.06 121.33 72.95 121.33 76.13 124.98 78.23 124.98 75.06" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 86.78 121.33 84.67 121.33 87.85 124.98 89.95 124.98 86.78" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 232.62 128.89 230.52 128.89 233.69 132.53 235.8 132.53 232.62" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 238.48 128.89 236.38 128.89 239.56 132.53 241.66 132.53 238.48" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 226.76 128.89 224.66 128.89 227.83 132.53 229.94 132.53 226.76" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 244.34 128.89 242.24 128.89 245.42 132.53 247.52 132.53 244.34" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 220.9 128.89 218.79 128.89 221.97 132.53 224.08 132.53 220.9" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 250.2 128.89 248.1 128.89 251.28 132.53 253.38 132.53 250.2" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 267.79 128.89 265.68 128.89 268.86 132.53 270.96 132.53 267.79" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 273.65 128.89 271.54 128.89 274.72 132.53 276.82 132.53 273.65" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 261.93 128.89 259.82 128.89 263 132.53 265.1 132.53 261.93" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 256.06 128.89 253.96 128.89 257.14 132.53 259.24 132.53 256.06" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 204.81 121.33 202.71 121.33 205.88 124.98 207.99 124.98 204.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 198.95 121.33 196.84 121.33 200.02 124.98 202.13 124.98 198.95" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 193.09 121.33 190.98 121.33 194.16 124.98 196.27 124.98 193.09" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 215.04 128.89 212.93 128.89 216.11 132.53 218.22 132.53 215.04" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 187.23 121.33 185.12 121.33 188.3 124.98 190.41 124.98 187.23" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 110.22 121.33 108.12 121.33 111.3 124.98 113.4 124.98 110.22" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 175.1 121.33 172.99 121.33 176.17 124.98 178.28 124.98 175.1" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 210.67 121.33 208.57 121.33 211.75 124.98 213.85 124.98 210.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 228.25 121.33 226.15 121.33 229.33 124.98 231.43 124.98 228.25" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 222.39 121.33 220.29 121.33 223.47 124.98 225.57 124.98 222.39" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 216.53 121.33 214.43 121.33 217.6 124.98 219.71 124.98 216.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 181.37 121.33 179.26 121.33 182.44 124.98 184.54 124.98 181.37" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 128.21 121.33 126.11 121.33 129.28 124.98 131.39 124.98 128.21" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 134.07 121.33 131.97 121.33 135.15 124.98 137.25 124.98 134.07" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 122.35 121.33 120.25 121.33 123.42 124.98 125.53 124.98 122.35" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 169.24 121.33 167.13 121.33 170.31 124.98 172.41 124.98 169.24" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 139.93 121.33 137.83 121.33 141.01 124.98 143.11 124.98 139.93" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 116.08 121.33 113.98 121.33 117.16 124.98 119.26 124.98 116.08" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 157.51 121.33 155.41 121.33 158.59 124.98 160.69 124.98 157.51" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 163.38 121.33 161.27 121.33 164.45 124.98 166.55 124.98 163.38" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 145.79 121.33 143.69 121.33 146.87 124.98 148.97 124.98 145.79" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 151.65 121.33 149.55 121.33 152.73 124.98 154.83 124.98 151.65" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 205.6 202.03 203.5 202.03 206.68 205.67 208.78 205.67 205.6" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 270.07 202.03 267.97 202.03 271.15 205.67 273.25 205.67 270.07" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 275.94 202.03 273.83 202.03 277.01 205.67 279.11 205.67 275.94" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 264.21 202.03 262.11 202.03 265.29 205.67 267.39 205.67 264.21" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 252.49 202.03 250.39 202.03 253.57 205.67 255.67 205.67 252.49" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 258.35 202.03 256.25 202.03 259.43 205.67 261.53 205.67 258.35" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 281.8 202.03 279.69 202.03 282.87 205.67 284.97 205.67 281.8" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 73.56 128.89 71.46 128.89 74.64 132.53 76.74 132.53 73.56" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 287.66 202.03 285.55 202.03 288.73 205.67 290.83 205.67 287.66" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 67.7 128.89 65.6 128.89 68.78 132.53 70.88 132.53 67.7" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 79.42 128.89 77.32 128.89 80.5 132.53 82.6 132.53 79.42" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 293.92 202.03 291.82 202.03 295 205.67 297.1 205.67 293.92" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 211.47 202.03 209.36 202.03 212.54 205.67 214.64 205.67 211.47" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 234.11 121.33 232.01 121.33 235.19 124.98 237.29 124.98 234.11" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 193.41 202.03 191.31 202.03 194.49 205.67 196.59 205.67 193.41" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 209.18 128.89 207.07 128.89 210.25 132.53 212.35 132.53 209.18" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 246.63 202.03 244.53 202.03 247.71 205.67 249.81 205.67 246.63" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 199.27 202.03 197.17 202.03 200.35 205.67 202.45 205.67 199.27" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 223.19 202.03 221.08 202.03 224.26 205.67 226.37 205.67 223.19" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 234.91 202.03 232.81 202.03 235.98 205.67 238.09 205.67 234.91" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 240.77 202.03 238.67 202.03 241.84 205.67 243.95 205.67 240.77" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 229.05 202.03 226.94 202.03 230.12 205.67 232.23 205.67 229.05" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 217.32 202.03 215.22 202.03 218.4 205.67 220.5 205.67 217.32" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 179.47 128.89 177.36 128.89 180.54 132.53 182.64 132.53 179.47" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 167.74 128.89 165.64 128.89 168.82 132.53 170.92 132.53 167.74" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 173.6 128.89 171.5 128.89 174.68 132.53 176.78 132.53 173.6" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 161.88 128.89 159.78 128.89 162.96 132.53 165.06 132.53 161.88" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 156.02 128.89 153.92 128.89 157.1 132.53 159.2 132.53 156.02" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 185.73 128.89 183.63 128.89 186.81 132.53 188.91 132.53 185.73" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 203.32 128.89 201.21 128.89 204.39 132.53 206.49 132.53 203.32" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 197.46 128.89 195.35 128.89 198.53 132.53 200.63 132.53 197.46" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 191.59 128.89 189.49 128.89 192.67 132.53 194.77 132.53 191.59" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 150.16 128.89 148.06 128.89 151.24 132.53 153.34 132.53 150.16" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 91.14 128.89 89.04 128.89 92.22 132.53 94.32 132.53 91.14" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 108.73 128.89 106.62 128.89 109.8 132.53 111.91 132.53 108.73" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 102.87 128.89 100.76 128.89 103.94 132.53 106.05 132.53 102.87" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 114.59 128.89 112.48 128.89 115.66 132.53 117.77 132.53 114.59" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 85.28 128.89 83.18 128.89 86.36 132.53 88.46 132.53 85.28" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 97.01 128.89 94.9 128.89 98.08 132.53 100.18 132.53 97.01" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 126.72 128.89 124.61 128.89 127.79 132.53 129.9 132.53 126.72" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 120.45 128.89 118.35 128.89 121.52 132.53 123.63 132.53 120.45" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 132.58 128.89 130.47 128.89 133.65 132.53 135.76 132.53 132.58" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 138.44 128.89 136.34 128.89 139.51 132.53 141.62 132.53 138.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="132.53 144.3 128.89 142.2 128.89 145.37 132.53 147.48 132.53 144.3" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 123.07 31.29 125.18 31.29 128.35 34.94 126.25 34.94 123.07" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 103.59 23.74 105.69 23.74 108.87 27.38 106.77 27.38 103.59" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 264.61 31.29 266.71 31.29 269.89 34.94 267.79 34.94 264.61" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 127.44 23.74 129.54 23.74 132.72 27.38 130.62 27.38 127.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 109.45 23.74 111.55 23.74 114.73 27.38 112.63 27.38 109.45" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 115.72 23.74 117.82 23.74 121 27.38 118.9 27.38 115.72" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 168.47 23.74 170.57 23.74 173.75 27.38 171.64 27.38 168.47" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 162.6 23.74 164.71 23.74 167.89 27.38 165.78 27.38 162.6" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 156.74 23.74 158.85 23.74 162.03 27.38 159.92 27.38 156.74" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 145.02 23.74 147.13 23.74 150.3 27.38 148.2 27.38 145.02" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 150.88 23.74 152.99 23.74 156.16 27.38 154.06 27.38 150.88" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 139.16 23.74 141.26 23.74 144.44 27.38 142.34 27.38 139.16" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 121.58 23.74 123.68 23.74 126.86 27.38 124.76 27.38 121.58" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 288.05 31.29 290.16 31.29 293.33 34.94 291.23 34.94 288.05" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.35 297.43 34.94 297.09 34.94 293.91 31.29 296.02 31.29 297.43 34.35 297.43"
            style="fill:#e6e6e6"></polygon>
        <polygon points="34.94 282.19 31.29 284.3 31.29 287.48 34.94 285.37 34.94 282.19" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 97.73 23.74 99.83 23.74 103.01 27.38 100.91 27.38 97.73" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 270.47 31.29 272.57 31.29 275.75 34.94 273.65 34.94 270.47" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 276.33 31.29 278.44 31.29 281.61 34.94 279.51 34.94 276.33" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 86.01 23.74 88.11 23.74 91.29 27.38 89.19 27.38 86.01" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 91.87 23.74 93.97 23.74 97.15 27.38 95.05 27.38 91.87" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 80.14 23.74 82.25 23.74 85.43 27.38 83.32 27.38 80.14" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 74.28 23.74 76.39 23.74 79.57 27.38 77.46 27.38 74.28" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 133.3 23.74 135.4 23.74 138.58 27.38 136.48 27.38 133.3" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 263.12 23.74 265.22 23.74 268.4 27.38 266.3 27.38 263.12" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 257.26 23.74 259.36 23.74 262.54 27.38 260.43 27.38 257.26" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 245.53 23.74 247.64 23.74 250.82 27.38 248.71 27.38 245.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 268.98 23.74 271.08 23.74 274.26 27.38 272.16 27.38 268.98" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 239.67 23.74 241.78 23.74 244.96 27.38 242.85 27.38 239.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 251.4 23.74 253.5 23.74 256.68 27.38 254.57 27.38 251.4" style="fill:#e6e6e6">
        </polygon>
        <polygon points="24.21 297.43 27.38 295.6 27.38 292.42 23.74 294.52 23.74 297.43 24.21 297.43"
            style="fill:#e6e6e6"></polygon>
        <polygon points="27.38 286.56 23.74 288.66 23.74 291.84 27.38 289.74 27.38 286.56" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 280.7 23.74 282.8 23.74 285.98 27.38 283.88 27.38 280.7" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 274.84 23.74 276.94 23.74 280.12 27.38 278.02 27.38 274.84" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 215.76 23.74 217.86 23.74 221.04 27.38 218.94 27.38 215.76" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 192.32 23.74 194.42 23.74 197.6 27.38 195.5 27.38 192.32" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 198.18 23.74 200.28 23.74 203.46 27.38 201.36 27.38 198.18" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 180.59 23.74 182.7 23.74 185.88 27.38 183.77 27.38 180.59" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 204.04 23.74 206.14 23.74 209.32 27.38 207.22 27.38 204.04" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 186.46 23.74 188.56 23.74 191.74 27.38 189.63 27.38 186.46" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 227.48 23.74 229.59 23.74 232.76 27.38 230.66 27.38 227.48" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 221.62 23.74 223.72 23.74 226.9 27.38 224.8 27.38 221.62" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 233.81 23.74 235.92 23.74 239.09 27.38 236.99 27.38 233.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 174.73 23.74 176.84 23.74 180.02 27.38 177.91 27.38 174.73" style="fill:#e6e6e6">
        </polygon>
        <polygon points="27.38 209.9 23.74 212 23.74 215.18 27.38 213.08 27.38 209.9" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 187.95 31.29 190.05 31.29 193.23 34.94 191.13 34.94 187.95" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 87.5 31.29 89.6 31.29 92.78 34.94 90.68 34.94 87.5" style="fill:#e6e6e6"></polygon>
        <polygon points="34.94 93.36 31.29 95.46 31.29 98.64 34.94 96.54 34.94 93.36" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 81.64 31.29 83.74 31.29 86.92 34.94 84.82 34.94 81.64" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 99.22 31.29 101.33 31.29 104.5 34.94 102.4 34.94 99.22" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 75.78 31.29 77.88 31.29 81.06 34.94 78.96 34.94 75.78" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 105.08 31.29 107.19 31.29 110.36 34.94 108.26 34.94 105.08" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 69.92 31.29 72.02 31.29 75.2 34.94 73.09 34.94 69.92" style="fill:#e6e6e6"></polygon>
        <polygon points="205.67 187.55 202.03 185.45 202.03 188.63 205.67 190.73 205.67 187.55" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 117.21 31.29 119.31 31.29 122.49 34.94 120.39 34.94 117.21" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 111.35 31.29 113.45 31.29 116.63 34.94 114.53 34.94 111.35" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 245.84 121.33 243.73 121.33 246.91 124.98 249.01 124.98 245.84" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 257.56 121.33 255.45 121.33 258.63 124.98 260.74 124.98 257.56" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 251.7 121.33 249.59 121.33 252.77 124.98 254.88 124.98 251.7" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 128.93 31.29 131.04 31.29 134.22 34.94 132.11 34.94 128.93" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 269.28 121.33 267.18 121.33 270.35 124.98 272.46 124.98 269.28" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 263.42 121.33 261.31 121.33 264.49 124.98 266.6 124.98 263.42" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 287.27 121.33 285.17 121.33 288.34 124.98 290.45 124.98 287.27" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 293.13 121.33 291.03 121.33 294.2 124.98 296.31 124.98 293.13" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 275.14 121.33 273.04 121.33 276.21 124.98 278.32 124.98 275.14" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 281 121.33 278.9 121.33 282.07 124.98 284.18 124.98 281" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 146.51 31.29 148.62 31.29 151.8 34.94 149.69 34.94 146.51" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 229.44 31.29 231.55 31.29 234.73 34.94 232.62 34.94 229.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 223.11 31.29 225.22 31.29 228.4 34.94 226.29 34.94 223.11" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 217.25 31.29 219.36 31.29 222.53 34.94 220.43 34.94 217.25" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 205.53 31.29 207.63 31.29 210.81 34.94 208.71 34.94 205.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 211.39 31.29 213.5 31.29 216.68 34.94 214.57 34.94 211.39" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 199.67 31.29 201.77 31.29 204.95 34.94 202.85 34.94 199.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 252.89 31.29 254.99 31.29 258.17 34.94 256.07 34.94 252.89" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 247.03 31.29 249.13 31.29 252.31 34.94 250.21 34.94 247.03" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 235.31 31.29 237.41 31.29 240.59 34.94 238.48 34.94 235.31" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 241.17 31.29 243.27 31.29 246.45 34.94 244.34 34.94 241.17" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 170.37 31.29 172.47 31.29 175.65 34.94 173.54 34.94 170.37" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 164.1 31.29 166.2 31.29 169.38 34.94 167.28 34.94 164.1" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 152.38 31.29 154.48 31.29 157.66 34.94 155.56 34.94 152.38" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 158.24 31.29 160.34 31.29 163.52 34.94 161.42 34.94 158.24" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 258.75 31.29 260.85 31.29 264.03 34.94 261.93 34.94 258.75" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 193.81 31.29 195.91 31.29 199.09 34.94 196.99 34.94 193.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 140.65 31.29 142.76 31.29 145.94 34.94 143.83 34.94 140.65" style="fill:#e6e6e6">
        </polygon>
        <polygon points="124.98 239.97 121.33 237.87 121.33 241.05 124.98 243.15 124.98 239.97" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 182.09 31.29 184.19 31.29 187.37 34.94 185.27 34.94 182.09" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 176.23 31.29 178.33 31.29 181.51 34.94 179.41 34.94 176.23" style="fill:#e6e6e6">
        </polygon>
        <polygon points="34.94 134.79 31.29 136.9 31.29 140.08 34.94 137.97 34.94 134.79" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 213.92 277.19 211.81 277.19 214.99 280.83 217.1 280.83 213.92" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 292.01 269.63 289.91 269.63 293.08 273.28 295.19 273.28 292.01" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 37.23 217.14 35.13 217.14 38.3 220.78 40.41 220.78 37.23" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 72.39 217.14 70.29 217.14 73.47 220.78 75.57 220.78 72.39" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 286.15 269.63 284.05 269.63 287.22 273.28 289.33 273.28 286.15" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 54.81 217.14 52.71 217.14 55.89 220.78 57.99 220.78 54.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 66.53 217.14 64.43 217.14 67.61 220.78 69.71 220.78 66.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 60.67 217.14 58.57 217.14 61.75 220.78 63.85 220.78 60.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 43.09 217.14 40.99 217.14 44.16 220.78 46.27 220.78 43.09" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 48.95 217.14 46.85 217.14 50.02 220.78 52.13 220.78 48.95" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 274.02 269.63 271.92 269.63 275.1 273.28 277.2 273.28 274.02" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 279.88 269.63 277.78 269.63 280.96 273.28 283.06 273.28 279.88" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 232.99 269.63 230.89 269.63 234.07 273.28 236.17 273.28 232.99" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 227.13 269.63 225.03 269.63 228.21 273.28 230.31 273.28 227.13" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 238.85 269.63 236.75 269.63 239.93 273.28 242.03 273.28 238.85" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 215.41 269.63 213.31 269.63 216.49 273.28 218.59 273.28 215.41" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 268.16 269.63 266.06 269.63 269.23 273.28 271.34 273.28 268.16" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 181.69 202.03 179.59 202.03 182.77 205.67 184.87 205.67 181.69" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 262.3 269.63 260.19 269.63 263.37 273.28 265.48 273.28 262.3" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 256.44 269.63 254.33 269.63 257.51 273.28 259.62 273.28 256.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 250.58 269.63 248.47 269.63 251.65 273.28 253.75 273.28 250.58" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 244.72 269.63 242.61 269.63 245.79 273.28 247.89 273.28 244.72" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 143.13 217.14 141.03 217.14 144.21 220.78 146.31 220.78 143.13" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 166.98 217.14 164.88 217.14 168.06 220.78 170.16 220.78 166.98" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 161.12 217.14 159.02 217.14 162.2 220.78 164.3 220.78 161.12" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 155.26 217.14 153.16 217.14 156.34 220.78 158.44 220.78 155.26" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 148.99 217.14 146.89 217.14 150.07 220.78 152.17 220.78 148.99" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 202.15 217.14 200.04 217.14 203.22 220.78 205.33 220.78 202.15" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 172.84 217.14 170.74 217.14 173.92 220.78 176.02 220.78 172.84" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 190.43 217.14 188.32 217.14 191.5 220.78 193.6 220.78 190.43" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 78.25 217.14 76.15 217.14 79.33 220.78 81.43 220.78 78.25" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 184.56 217.14 182.46 217.14 185.64 220.78 187.74 220.78 184.56" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 178.71 217.14 176.6 217.14 179.78 220.78 181.88 220.78 178.71" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 196.29 217.14 194.18 217.14 197.36 220.78 199.47 220.78 196.29" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 96.25 217.14 94.14 217.14 97.32 220.78 99.42 220.78 96.25" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 102.11 217.14 100 217.14 103.18 220.78 105.28 220.78 102.11" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 84.12 217.14 82.01 217.14 85.19 220.78 87.29 220.78 84.12" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 89.98 217.14 87.87 217.14 91.05 220.78 93.16 220.78 89.98" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 107.97 217.14 105.86 217.14 109.04 220.78 111.14 220.78 107.97" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 125.55 217.14 123.45 217.14 126.62 220.78 128.73 220.78 125.55" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 113.83 217.14 111.72 217.14 114.9 220.78 117.01 220.78 113.83" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 131.41 217.14 129.31 217.14 132.49 220.78 134.59 220.78 131.41" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 137.27 217.14 135.17 217.14 138.35 220.78 140.45 220.78 137.27" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 119.69 217.14 117.58 217.14 120.76 220.78 122.87 220.78 119.69" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 209.55 269.63 207.45 269.63 210.62 273.28 212.73 273.28 209.55" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 266.67 277.19 264.56 277.19 267.74 280.83 269.84 280.83 266.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 243.22 277.19 241.12 277.19 244.3 280.83 246.4 280.83 243.22" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 260.81 277.19 258.7 277.19 261.88 280.83 263.98 280.83 260.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 249.08 277.19 246.98 277.19 250.16 280.83 252.26 280.83 249.08" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 254.94 277.19 252.84 277.19 256.02 280.83 258.12 280.83 254.94" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 272.53 277.19 270.42 277.19 273.6 280.83 275.7 280.83 272.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 290.52 277.19 288.41 277.19 291.59 280.83 293.69 280.83 290.52" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 297.43 280.83 296.38 277.19 294.27 277.19 297.43 280.83 297.43" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 284.25 277.19 282.14 277.19 285.32 280.83 287.43 280.83 284.25" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 278.39 277.19 276.28 277.19 279.46 280.83 281.57 280.83 278.39" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 208.06 277.19 205.95 277.19 209.13 280.83 211.24 280.83 208.06" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 237.36 277.19 235.26 277.19 238.44 280.83 240.54 280.83 237.36" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 196.34 277.19 194.23 277.19 197.41 280.83 199.51 280.83 196.34" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 190.07 277.19 187.96 277.19 191.14 280.83 193.25 280.83 190.07" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 73.94 269.63 71.83 269.63 75.01 273.28 77.11 273.28 73.94" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 184.21 277.19 182.1 277.19 185.28 280.83 187.38 280.83 184.21" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 202.2 277.19 200.09 277.19 203.27 280.83 205.37 280.83 202.2" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 178.34 277.19 176.24 277.19 179.42 280.83 181.52 280.83 178.34" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 225.64 277.19 223.54 277.19 226.71 280.83 228.82 280.83 225.64" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 231.5 277.19 229.4 277.19 232.57 280.83 234.68 280.83 231.5" style="fill:#e6e6e6">
        </polygon>
        <polygon points="280.83 219.78 277.19 217.68 277.19 220.85 280.83 222.96 280.83 219.78" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 91.52 269.63 89.41 269.63 92.59 273.28 94.7 273.28 91.52" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 162.26 269.63 160.15 269.63 163.33 273.28 165.43 273.28 162.26" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 168.12 269.63 166.01 269.63 169.19 273.28 171.29 273.28 168.12" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 150.53 269.63 148.43 269.63 151.61 273.28 153.71 273.28 150.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 173.98 269.63 171.87 269.63 175.05 273.28 177.16 273.28 173.98" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 156.4 269.63 154.29 269.63 157.47 273.28 159.57 273.28 156.4" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 197.83 269.63 195.72 269.63 198.9 273.28 201.01 273.28 197.83" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 191.97 269.63 189.86 269.63 193.04 273.28 195.15 273.28 191.97" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 144.67 269.63 142.57 269.63 145.75 273.28 147.85 273.28 144.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 185.7 269.63 183.6 269.63 186.77 273.28 188.88 273.28 185.7" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 179.84 269.63 177.74 269.63 180.91 273.28 183.02 273.28 179.84" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 203.69 269.63 201.59 269.63 204.76 273.28 206.87 273.28 203.69" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 103.24 269.63 101.14 269.63 104.31 273.28 106.42 273.28 103.24" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 97.38 269.63 95.28 269.63 98.45 273.28 100.56 273.28 97.38" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 138.81 269.63 136.71 269.63 139.89 273.28 141.99 273.28 138.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 85.66 269.63 83.55 269.63 86.73 273.28 88.83 273.28 85.66" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 79.8 269.63 77.69 269.63 80.87 273.28 82.97 273.28 79.8" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 109.1 269.63 107 269.63 110.17 273.28 112.28 273.28 109.1" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 126.68 269.63 124.58 269.63 127.76 273.28 129.86 273.28 126.68" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 114.96 269.63 112.86 269.63 116.04 273.28 118.14 273.28 114.96" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 132.95 269.63 130.85 269.63 134.03 273.28 136.13 273.28 132.95" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 120.82 269.63 118.72 269.63 121.9 273.28 124 273.28 120.82" style="fill:#e6e6e6">
        </polygon>
        <polygon points="273.28 221.27 269.63 219.17 269.63 222.35 273.28 224.45 273.28 221.27" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 262.72 209.58 260.62 209.58 263.79 213.23 265.9 213.23 262.72" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 286.16 209.58 284.06 209.58 287.24 213.23 289.34 213.23 286.16" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 280.3 209.58 278.2 209.58 281.38 213.23 283.48 213.23 280.3" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 268.58 209.58 266.48 209.58 269.65 213.23 271.76 213.23 268.58" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 274.44 209.58 272.34 209.58 275.52 213.23 277.62 213.23 274.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 292.02 209.58 289.92 209.58 293.1 213.23 295.2 213.23 292.02" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 40.22 202.03 38.11 202.03 41.29 205.67 43.39 205.67 40.22" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 51.94 202.03 49.83 202.03 53.01 205.67 55.12 205.67 51.94" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 34.35 202.03 32.25 202.03 35.43 205.67 37.53 205.67 34.35" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 28.49 202.03 26.39 202.03 29.57 205.67 31.67 205.67 28.49" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 46.08 202.03 43.97 202.03 47.15 205.67 49.25 205.67 46.08" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 227.55 209.58 225.45 209.58 228.63 213.23 230.73 213.23 227.55" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 215.83 209.58 213.73 209.58 216.91 213.23 219.01 213.23 215.83" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 221.69 209.58 219.59 209.58 222.77 213.23 224.87 213.23 221.69" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 203.64 209.58 201.54 209.58 204.72 213.23 206.82 213.23 203.64" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 209.97 209.58 207.87 209.58 211.05 213.23 213.15 213.23 209.97" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 245.14 209.58 243.03 209.58 246.21 213.23 248.31 213.23 245.14" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 251 209.58 248.89 209.58 252.07 213.23 254.18 213.23 251" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 256.86 209.58 254.75 209.58 257.93 213.23 260.04 213.23 256.86" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 239.28 209.58 237.17 209.58 240.35 213.23 242.45 213.23 239.28" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 233.41 209.58 231.31 209.58 234.49 213.23 236.59 213.23 233.41" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 134.4 202.03 132.29 202.03 135.47 205.67 137.57 205.67 134.4" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 152.39 202.03 150.28 202.03 153.46 205.67 155.56 205.67 152.39" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 122.67 202.03 120.57 202.03 123.75 205.67 125.85 205.67 122.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 146.53 202.03 144.42 202.03 147.6 205.67 149.7 205.67 146.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 197.78 209.58 195.68 209.58 198.85 213.23 200.96 213.23 197.78" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 128.53 202.03 126.43 202.03 129.61 205.67 131.71 205.67 128.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 140.26 202.03 138.15 202.03 141.33 205.67 143.44 205.67 140.26" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 175.83 202.03 173.73 202.03 176.91 205.67 179.01 205.67 175.83" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 158.25 202.03 156.14 202.03 159.32 205.67 161.43 205.67 158.25" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 169.97 202.03 167.87 202.03 171.04 205.67 173.15 205.67 169.97" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 164.11 202.03 162 202.03 165.18 205.67 167.29 205.67 164.11" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 87.51 202.03 85.41 202.03 88.58 205.67 90.69 205.67 87.51" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 81.24 202.03 79.14 202.03 82.32 205.67 84.42 205.67 81.24" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 57.8 202.03 55.69 202.03 58.87 205.67 60.98 205.67 57.8" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 116.81 202.03 114.71 202.03 117.89 205.67 119.99 205.67 116.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 69.52 202.03 67.42 202.03 70.59 205.67 72.7 205.67 69.52" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 63.66 202.03 61.55 202.03 64.73 205.67 66.84 205.67 63.66" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 75.38 202.03 73.28 202.03 76.45 205.67 78.56 205.67 75.38" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 93.37 202.03 91.27 202.03 94.44 205.67 96.55 205.67 93.37" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 110.95 202.03 108.85 202.03 112.03 205.67 114.13 205.67 110.95" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 105.09 202.03 102.99 202.03 106.17 205.67 108.27 205.67 105.09" style="fill:#e6e6e6">
        </polygon>
        <polygon points="205.67 99.23 202.03 97.13 202.03 100.31 205.67 102.41 205.67 99.23" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 168.48 209.58 166.37 209.58 169.55 213.23 171.65 213.23 168.48" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 32.86 209.58 30.76 209.58 33.94 213.23 36.04 213.23 32.86" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 297.43 220.78 296.39 217.14 294.29 217.14 297.43 220.78 297.43" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 290.53 217.14 288.43 217.14 291.61 220.78 293.71 220.78 290.53" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 284.67 217.14 282.57 217.14 285.75 220.78 287.85 220.78 284.67" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 278.81 217.14 276.71 217.14 279.88 220.78 281.99 220.78 278.81" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 38.72 209.58 36.62 209.58 39.8 213.23 41.9 213.23 38.72" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 272.95 217.14 270.85 217.14 274.02 220.78 276.13 220.78 272.95" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 56.3 209.58 54.2 209.58 57.38 213.23 59.48 213.23 56.3" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 50.44 209.58 48.34 209.58 51.52 213.23 53.62 213.23 50.44" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 44.58 209.58 42.48 209.58 45.66 213.23 47.76 213.23 44.58" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 231.92 217.14 229.82 217.14 233 220.78 235.1 220.78 231.92" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 237.78 217.14 235.68 217.14 238.86 220.78 240.96 220.78 237.78" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 226.06 217.14 223.96 217.14 227.14 220.78 229.24 220.78 226.06" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 62.17 209.58 60.06 209.58 63.24 213.23 65.34 213.23 62.17" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 214.34 217.14 212.24 217.14 215.41 220.78 217.52 220.78 214.34" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 220.2 217.14 218.1 217.14 221.28 220.78 223.38 220.78 220.2" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 267.09 217.14 264.98 217.14 268.16 220.78 270.27 220.78 267.09" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 261.23 217.14 259.12 217.14 262.3 220.78 264.4 220.78 261.23" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 255.37 217.14 253.26 217.14 256.44 220.78 258.54 220.78 255.37" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 249.5 217.14 247.4 217.14 250.58 220.78 252.68 220.78 249.5" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 243.64 217.14 241.54 217.14 244.72 220.78 246.82 220.78 243.64" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 174.34 209.58 172.23 209.58 175.41 213.23 177.51 213.23 174.34" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 156.75 209.58 154.65 209.58 157.83 213.23 159.93 213.23 156.75" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 132.9 209.58 130.8 209.58 133.98 213.23 136.08 213.23 132.9" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 144.63 209.58 142.52 209.58 145.7 213.23 147.8 213.23 144.63" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 162.62 209.58 160.51 209.58 163.69 213.23 165.79 213.23 162.62" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 138.76 209.58 136.66 209.58 139.84 213.23 141.94 213.23 138.76" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 150.89 209.58 148.79 209.58 151.97 213.23 154.07 213.23 150.89" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 186.06 209.58 183.96 209.58 187.13 213.23 189.24 213.23 186.06" style="fill:#e6e6e6">
        </polygon>
        <polygon points="220.78 208.01 217.14 205.91 217.14 209.08 220.78 211.19 220.78 208.01" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 180.2 209.58 178.09 209.58 181.27 213.23 183.38 213.23 180.2" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 191.92 209.58 189.82 209.58 192.99 213.23 195.1 213.23 191.92" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 97.74 209.58 95.63 209.58 98.81 213.23 100.92 213.23 97.74" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 68.03 209.58 65.92 209.58 69.1 213.23 71.2 213.23 68.03" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 91.88 209.58 89.77 209.58 92.95 213.23 95.06 213.23 91.88" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 85.61 209.58 83.51 209.58 86.68 213.23 88.79 213.23 85.61" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 79.75 209.58 77.64 209.58 80.82 213.23 82.93 213.23 79.75" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 73.89 209.58 71.78 209.58 74.96 213.23 77.07 213.23 73.89" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 115.32 209.58 113.22 209.58 116.39 213.23 118.5 213.23 115.32" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 127.04 209.58 124.94 209.58 128.12 213.23 130.22 213.23 127.04" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 103.6 209.58 101.5 209.58 104.67 213.23 106.78 213.23 103.6" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 121.18 209.58 119.08 209.58 122.26 213.23 124.36 213.23 121.18" style="fill:#e6e6e6">
        </polygon>
        <polygon points="213.23 109.46 209.58 107.36 209.58 110.53 213.23 112.64 213.23 109.46" style="fill:#e6e6e6">
        </polygon>
    </g>
</g>
<g id="freepik--Streetlights--inject-4">
    <g id="freepik--street-lights--inject-4">
        <path
            d="M442.93,233.09a.93.93,0,0,1-.93-.93v-189a.93.93,0,0,1,.93-.93c.51,0,.93.42.93,5.1v189C443.86,232.67,443.45,233.09,442.93,233.09Z"
            style="fill:#263238"></path>
        <path
            d="M442.93,90.9A.93.93,0,0,1,442,90c0-8.13-8.49-21.8-22.19-29.72l-7.56-4.36a.93.93,0,0,1,.93-1.61l7.55,4.36C435,66.89,443.86,81.33,443.86,90A.93.93,0,0,1,442.93,90.9Z"
            style="fill:#263238"></path>
        <path
            d="M410.81,48.52l-4.18-2.91c-3.32-2.31-8.69-2.65-12-.75-1.53.88-2.27,2-2.27,3.07,0,.4,0,2,0,2.34,0,1.25,1,2.5,3,3.41l6.58,3c3.68,1.7,8.51,2,10.79.69a2.27,2.27,0,0,0,1.24-2c0-.4,0-1.94,0-2.32C414,51.65,412.89,50,410.81,48.52Z"
            style="fill:#455a64"></path>
        <path
            d="M412.72,57.39c2.27-1.31,1.41-4.25-1.91-6.57l-4.18-2.9c-3.32-2.32-8.69-2.65-12-.75s-3,4.81.7,6.51l6.58,3C405.61,58.4,410.44,58.7,412.72,57.39Z"
            style="fill:#263238"></path>
        <path
            d="M413,55.39a1.36,1.36,0,0,1-.77,1.14,7.18,7.18,0,0,1-3.42.68,16.27,16.27,0,0,1-6.45-1.41l-6.58-3c-1.49-.68-2.36-1.58-2.4-2.46s.59-1.59,1.77-2.27a9.46,9.46,0,0,1,4.65-1.1,11.25,11.25,0,0,1,6.27,1.8l4.17,2.91C412,52.84,413,54.31,413,55.39Z"
            style="fill:#7A2E84"></path>
        <path
            d="M413,55.39a1.36,1.36,0,0,1-.77,1.14,7.18,7.18,0,0,1-3.42.68,16.27,16.27,0,0,1-6.45-1.41l-6.58-3c-1.49-.68-2.36-1.58-2.4-2.46s.59-1.59,1.77-2.27a9.46,9.46,0,0,1,4.65-1.1,11.25,11.25,0,0,1,6.27,1.8l4.17,2.91C412,52.84,413,54.31,413,55.39Z"
            style="fill:#fff;opacity:0.9"></path>
        <path
            d="M396.5,52.25a6.78,6.78,0,0,0,6.17,0c1.7-1,1.7-2.57,0-3.56a6.84,6.84,0,0,0-6.17,0C394.79,49.68,394.79,51.27,396.5,52.25Z"
            style="fill:#7A2E84;opacity:0.2"></path>
        <path d="M405.3,55a3.84,3.84,0,0,0,3.49,0,1.06,1.06,0,0,0,0-2,3.84,3.84,0,0,0-3.49,0A1.06,1.06,0,0,0,405.3,55Z"
            style="fill:#7A2E84;opacity:0.2"></path>
        <path
            d="M442.93,74.66a.93.93,0,0,0,.93-.93c0-8.13,8.49-21.81,22.2-29.72l7.55-4.37a.92.92,0,0,0,.34-1.27.94.94,0,0,0-1.27-.34l-7.55,4.37C450.84,50.64,442,65.08,442,73.73A.93.93,0,0,0,442.93,74.66Z"
            style="fill:#263238"></path>
        <path
            d="M475.05,32.27l4.18-2.9c3.33-2.32,8.69-2.65,12-.75,1.52.88,2.27,2,2.27,3.06,0,.41,0,2,0,2.34,0,1.26-1,2.51-2.95,3.41l-6.58,3c-3.68,1.69-8.51,2-10.78.69a2.28,2.28,0,0,1-1.25-2c0-.41,0-2,0-2.32C471.88,35.4,473,33.72,475.05,32.27Z"
            style="fill:#455a64"></path>
        <path
            d="M473.15,41.15c-2.28-1.32-1.42-4.26,1.9-6.57l4.18-2.91c3.33-2.31,8.69-2.65,12-.75s3,4.82-.71,6.51l-6.58,3C480.25,42.15,475.42,42.46,473.15,41.15Z"
            style="fill:#263238"></path>
        <path
            d="M472.87,39.14a1.36,1.36,0,0,0,.77,1.14,7.18,7.18,0,0,0,3.42.68,16.27,16.27,0,0,0,6.45-1.41l6.58-3c1.49-.68,2.36-1.58,2.4-2.46s-.59-1.59-1.77-2.27a9.46,9.46,0,0,0-4.65-1.1,11.25,11.25,0,0,0-6.27,1.8l-4.17,2.91C473.91,36.59,472.83,38.06,472.87,39.14Z"
            style="fill:#7A2E84"></path>
        <path
            d="M472.87,39.14a1.36,1.36,0,0,0,.77,1.14,7.18,7.18,0,0,0,3.42.68,16.27,16.27,0,0,0,6.45-1.41l6.58-3c1.49-.68,2.36-1.58,2.4-2.46s-.59-1.59-1.77-2.27a9.46,9.46,0,0,0-4.65-1.1,11.25,11.25,0,0,0-6.27,1.8l-4.17,2.91C473.91,36.59,472.83,38.06,472.87,39.14Z"
            style="fill:#fff;opacity:0.9"></path>
        <path
            d="M489.37,36a6.86,6.86,0,0,1-6.18,0c-1.7-1-1.7-2.58,0-3.56a6.8,6.8,0,0,1,6.18,0C491.07,33.43,491.07,35,489.37,36Z"
            style="fill:#7A2E84;opacity:0.2"></path>
        <path
            d="M480.56,38.76a3.88,3.88,0,0,1-3.48,0,1.06,1.06,0,0,1,0-2,3.88,3.88,0,0,1,3.48,0A1.06,1.06,0,0,1,480.56,38.76Z"
            style="fill:#7A2E84;opacity:0.2"></path>
        <path
            d="M448.66,219.85a2.84,2.84,0,0,0-1.68-2.34,9,9,0,0,0-8.1,0,2.84,2.84,0,0,0-1.68,2.34v74.91a2.84,2.84,0,0,0,1.68,2.34,9,9,0,0,0,8.1,0,2.84,2.84,0,0,0,1.68-2.34Z"
            style="fill:#37474f"></path>
        <path
            d="M438.21,294.71a10.4,10.4,0,0,1,9.44,0,2.87,2.87,0,0,1,0,5.45,10.46,10.46,0,0,1-9.44,0,2.88,2.88,0,0,1,0-5.45Z"
            style="fill:#37474f"></path>
    </g>
    <g id="freepik--street-lights--inject-4">
        <path d="M57.07,233.09a.93.93,0,0,0,.93-.93v-189a.93.93,0,1,0-1.86,0v189A.93.93,0,0,0,57.07,233.09Z"
            style="fill:#263238"></path>
        <path
            d="M57.07,90.9A.93.93,0,0,0,58,90c0-8.13,8.49-21.8,22.19-29.72l7.56-4.36a.93.93,0,0,0-.93-1.61l-7.55,4.36C65,66.89,56.14,81.33,56.14,90A.93.93,0,0,0,57.07,90.9Z"
            style="fill:#263238"></path>
        <path
            d="M89.19,48.52l4.18-2.91c3.32-2.31,8.69-2.65,12-.75,1.53.88,2.27,2,2.27,3.07,0,.4,0,2,0,2.34,0,1.25-1,2.5-2.95,3.41l-6.58,3c-3.68,1.7-8.51,2-10.79.69a2.27,2.27,0,0,1-1.24-2c0-.4,0-1.94,0-2.32C86,51.65,87.11,50,89.19,48.52Z"
            style="fill:#455a64"></path>
        <path
            d="M87.28,57.39c-2.27-1.31-1.41-4.25,1.91-6.57l4.18-2.9c3.32-2.32,8.69-2.65,12-.75s3,4.81-.7,6.51l-6.58,3C94.39,58.4,89.56,58.7,87.28,57.39Z"
            style="fill:#263238"></path>
        <path
            d="M87,55.39a1.36,1.36,0,0,0,.77,1.14,7.18,7.18,0,0,0,3.42.68,16.27,16.27,0,0,0,6.45-1.41l6.58-3c1.49-.68,2.36-1.58,2.4-2.46S106,48.72,104.86,48a9.46,9.46,0,0,0-4.65-1.1,11.25,11.25,0,0,0-6.27,1.8l-4.17,2.91C88.05,52.84,87,54.31,87,55.39Z"
            style="fill:#7A2E84"></path>
        <path
            d="M87,55.39a1.36,1.36,0,0,0,.77,1.14,7.18,7.18,0,0,0,3.42.68,16.27,16.27,0,0,0,6.45-1.41l6.58-3c1.49-.68,2.36-1.58,2.4-2.46S106,48.72,104.86,48a9.46,9.46,0,0,0-4.65-1.1,11.25,11.25,0,0,0-6.27,1.8l-4.17,2.91C88.05,52.84,87,54.31,87,55.39Z"
            style="fill:#fff;opacity:0.9"></path>
        <path
            d="M103.5,52.25a6.78,6.78,0,0,1-6.17,0c-1.7-1-1.7-2.57,0-3.56a6.84,6.84,0,0,1,6.17,0C105.21,49.68,105.21,51.27,103.5,52.25Z"
            style="fill:#7A2E84;opacity:0.2"></path>
        <path d="M94.7,55a3.84,3.84,0,0,1-3.49,0,1.06,1.06,0,0,1,0-2,3.84,3.84,0,0,1,3.49,0A1.06,1.06,0,0,1,94.7,55Z"
            style="fill:#7A2E84;opacity:0.2"></path>
        <path
            d="M57.07,74.66a.93.93,0,0,1-.93-.93c0-8.13-8.49-21.81-22.2-29.72l-7.55-4.37a.92.92,0,0,1-.34-1.27A.94.94,0,0,1,27.32,38l7.55,4.37C49.16,50.64,58,65.08,58,73.73A.93.93,0,0,1,57.07,74.66Z"
            style="fill:#263238"></path>
        <path
            d="M25,32.27l-4.18-2.9c-3.33-2.32-8.69-2.65-12-.75-1.52.88-2.27,2-2.27,3.06,0,.41,0,2,0,2.34,0,1.26,1,2.51,3,3.41l6.58,3c3.68,1.69,8.51,2,10.78.69a2.28,2.28,0,0,0,1.25-2c0-.41,0-2,0-2.32C28.12,35.4,27,33.72,25,32.27Z"
            style="fill:#455a64"></path>
        <path
            d="M26.85,41.15c2.28-1.32,1.42-4.26-1.9-6.57l-4.18-2.91c-3.33-2.31-8.69-2.65-12-.75s-3,4.82.71,6.51l6.58,3C19.75,42.15,24.58,42.46,26.85,41.15Z"
            style="fill:#263238"></path>
        <path
            d="M27.13,39.14a1.36,1.36,0,0,1-.77,1.14,7.18,7.18,0,0,1-3.42.68,16.27,16.27,0,0,1-6.45-1.41l-6.58-3c-1.49-.68-2.36-1.58-2.4-2.46s.59-1.59,1.77-2.27a9.46,9.46,0,0,1,4.65-1.1,11.25,11.25,0,0,1,6.27,1.8l4.17,2.91C26.09,36.59,27.17,38.06,27.13,39.14Z"
            style="fill:#7A2E84"></path>
        <path
            d="M27.13,39.14a1.36,1.36,0,0,1-.77,1.14,7.18,7.18,0,0,1-3.42.68,16.27,16.27,0,0,1-6.45-1.41l-6.58-3c-1.49-.68-2.36-1.58-2.4-2.46s.59-1.59,1.77-2.27a9.46,9.46,0,0,1,4.65-1.1,11.25,11.25,0,0,1,6.27,1.8l4.17,2.91C26.09,36.59,27.17,38.06,27.13,39.14Z"
            style="fill:#fff;opacity:0.9"></path>
        <path
            d="M10.63,36a6.86,6.86,0,0,0,6.18,0c1.7-1,1.7-2.58,0-3.56a6.8,6.8,0,0,0-6.18,0C8.93,33.43,8.93,35,10.63,36Z"
            style="fill:#7A2E84;opacity:0.2"></path>
        <path
            d="M19.44,38.76a3.88,3.88,0,0,0,3.48,0,1.06,1.06,0,0,0,0-2,3.88,3.88,0,0,0-3.48,0A1.06,1.06,0,0,0,19.44,38.76Z"
            style="fill:#7A2E84;opacity:0.2"></path>
        <path
            d="M51.34,219.85A2.84,2.84,0,0,1,53,217.51a9,9,0,0,1,8.1,0,2.84,2.84,0,0,1,1.68,2.34v74.91a2.84,2.84,0,0,1-1.68,2.34,9,9,0,0,1-8.1,0,2.84,2.84,0,0,1-1.68-2.34Z"
            style="fill:#37474f"></path>
        <path
            d="M61.79,294.71a10.4,10.4,0,0,0-9.44,0,2.87,2.87,0,0,0,0,5.45,10.46,10.46,0,0,0,9.44,0,2.88,2.88,0,0,0,0-5.45Z"
            style="fill:#37474f"></path>
    </g>
</g>
<g id="freepik--Floor--inject-4">
    <g id="freepik--floor--inject-4">
        <g id="freepik--floor--inject-4">
            <path id="freepik--floor--inject-4"
                d="M77.7,235.67c-95.16,58.61-95.16,153.64,0,212.26s249.45,58.62,344.6,0,95.16-153.65,0-212.26S172.85,177.05,77.7,235.67Z"
                style="fill:#f5f5f5"></path>
        </g>
        <path d="M338.08,201.82c-87.24-20.79-190-9.52-260.38,33.85C11.27,276.58-8.77,335.25,17.55,386.89Z"
            style="fill:#ebebeb"></path>
        <path
            d="M442.64,326.82l-79.74,46c-1.39.8-1.39,2.09,0,2.89l11.46,6.62a5.55,5.55,0,0,0,5,0l79.74-46c1.38-.8,1.38-2.1,0-2.9l-11.47-6.62A5.53,5.53,0,0,0,442.64,326.82Z"
            style="fill:#fff"></path>
        <path
            d="M412,309.12l-79.73,46c-1.39.8-1.39,2.1,0,2.9l11.46,6.62a5.55,5.55,0,0,0,5,0l79.73-46c1.39-.8,1.39-2.09,0-2.89l-11.46-6.62A5.55,5.55,0,0,0,412,309.12Z"
            style="fill:#fff"></path>
        <path
            d="M489.12,370.73l-65,37.53c-1.39.8-1.39,2.1,0,2.9l11.46,6.62a5.55,5.55,0,0,0,5,0l36.09-20.84A110.73,110.73,0,0,0,489.12,370.73Z"
            style="fill:#fff"></path>
        <path
            d="M209.88,287.24l11.46,6.62a5.55,5.55,0,0,0,5,0l79.73-46c1.39-.8,1.39-2.09,0-2.89l-11.46-6.62a5.55,5.55,0,0,0-5,0l-79.73,46C208.49,285.14,208.49,286.44,209.88,287.24Z"
            style="fill:#fff"></path>
        <path
            d="M301.69,340.35,313.15,347a5.55,5.55,0,0,0,5,0l79.74-46c1.38-.8,1.38-2.1,0-2.9l-11.46-6.61a5.55,5.55,0,0,0-5,0l-79.74,46C300.31,338.25,300.31,339.55,301.69,340.35Z"
            style="fill:#fff"></path>
        <path
            d="M489.72,351.14l-11.46-6.61a5.55,5.55,0,0,0-5,0l-79.73,46c-1.39.8-1.39,2.1,0,2.9L405,400.07a5.55,5.55,0,0,0,5,0l79.73-46C491.11,353.24,491.11,351.94,489.72,351.14Z"
            style="fill:#fff"></path>
        <path
            d="M367.3,280.33l-11.46-6.62a5.55,5.55,0,0,0-5,0l-79.73,46c-1.39.8-1.39,2.1,0,2.9l11.46,6.61a5.55,5.55,0,0,0,5,0l79.73-46C368.69,282.43,368.69,281.13,367.3,280.33Z"
            style="fill:#fff"></path>
        <path
            d="M257,311.56l79.74-46c1.38-.8,1.38-2.1,0-2.9L325.24,256a5.55,5.55,0,0,0-5,0l-79.74,46c-1.38.8-1.38,2.09,0,2.89l11.46,6.62A5.55,5.55,0,0,0,257,311.56Z"
            style="fill:#fff"></path>
    </g>
</g>
<g id="freepik--Shadows--inject-4">
    <path id="freepik--Shadow--inject-4"
        d="M430,301.89c2.39-1.38,2.39-3.62,0-5L329,238.57a9.57,9.57,0,0,0-8.66,0L61.71,387.89c-9.56,5.52-9.56,14.48,0,20l75,43.32c9.56,5.52,25.07,5.52,34.64,0Z"
        style="opacity:0.1"></path>
    <path id="freepik--shadow--inject-4"
        d="M84.69,320.32,19.8,357.73l4.87,2.87,64.9-37.47ZM62.47,339.75l.63.36,26-15-.63-.36Z" style="opacity:0.1">
    </path>
    <ellipse id="freepik--shadow--inject-4" cx="313.31" cy="431.2" rx="35.64" ry="20.57" style="opacity:0.1">
    </ellipse>
</g>
<g id="freepik--Sign--inject-4">
    <g id="freepik--bus-signal--inject-4">
        <polygon points="24.48 169.35 24.48 359.68 22.42 358.49 22.42 168.12 24.48 169.35" style="fill:#263238">
        </polygon>
        <polygon points="27.29 167.69 27.29 358.06 24.48 359.68 24.48 169.35 27.29 167.69" style="fill:#37474f">
        </polygon>
        <polygon points="27.29 167.69 24.48 169.35 22.42 168.12 25.23 166.5 27.29 167.69" style="fill:#455a64">
        </polygon>
        <path
            d="M13.79,181.88l25.55-14.75c.94-.55,1.71-.11,1.71,1v44.06a3.82,3.82,0,0,1-1.71,3L13.79,229.9c-.95.55-1.72.11-1.72-1V184.85A3.77,3.77,0,0,1,13.79,181.88Z"
            style="fill:#7A2E84"></path>
        <path
            d="M13.79,181.88l25.55-14.75c.94-.55,1.71-.11,1.71,1v44.06a3.82,3.82,0,0,1-1.71,3L13.79,229.9c-.95.55-1.72.11-1.72-1V184.85A3.77,3.77,0,0,1,13.79,181.88Z"
            style="fill:#fff;opacity:0.2"></path>
        <path
            d="M38.79,170v42.14a1.62,1.62,0,0,1-.59,1L14.33,227V184.85a1.67,1.67,0,0,1,.59-1L38.79,170m.75-1.3-25,14.43a2.33,2.33,0,0,0-1,1.68v43.44l25-14.43a2.33,2.33,0,0,0,1-1.68V168.74Z"
            style="fill:#fafafa"></path>
        <path
            d="M36.17,182.46l-1.05.6a.34.34,0,0,0-.15.26v2.43h0v1.08l-.45.25V179.3c0-1.38-1-1.94-2.16-1.25l-11.6,6.7a4.78,4.78,0,0,0-2.16,3.74v7.78l-.45.27v-1.08h0V193c0-.09-.06-.13-.15-.09l-1,.61a.31.31,0,0,0-.15.25V196c0,.35.24.49.54.31l.28-.16v.66c0,.33.23.46.51.3l.46-.27v5.49l-.06,0a1.3,1.3,0,0,0-.58,1v.19c0,.9.63,1.26,1.4.81l.29-.16v1.42c0,.24.17.34.38.22l1.81-1a.84.84,0,0,0,.38-.66v-1.42l8.68-5v1.42c0,.24.17.34.38.22l1.82-1a.83.83,0,0,0,.38-.66v-1.42l.29-.16a3.12,3.12,0,0,0,1.4-2.43v-.19c0-.38-.27-.53-.59-.34l-.06,0v-5.49l.46-.27a1.1,1.1,0,0,0,.51-.88v-.66l.28-.16a1.23,1.23,0,0,0,.55-.94v-2.23C36.32,182.45,36.25,182.41,36.17,182.46Zm-2.27,7.18a2,2,0,0,1-.9,1.57c-.5.28-.9,0-.9-.52a2,2,0,0,1,.9-1.57C33.5,188.84,33.9,189.07,33.9,189.64Zm-1.23-10.53c.31-.18.56,0,.56.33a1.25,1.25,0,0,1-.56,1c-.32.18-.57,0-.57-.33A1.23,1.23,0,0,1,32.67,179.11Zm.56,3.95v3.81a.59.59,0,0,1-.27.46l-6.12,3.54v-6.1l4.67-2.7C32.46,181.53,33.23,182,33.23,183.06ZM31.4,193.25l-9.68,5.59v-.45l9.68-5.59Zm0-2.62v.52l-9.68,5.59v-.52Zm0,1.57-9.68,5.59v-.45l9.68-5.59Zm-9.18-7a.29.29,0,0,1,.13-.22l8.42-4.87c.07,0,.13,0,.13.08v1.1a.29.29,0,0,1-.13.22l-8.42,4.86c-.07.05-.13,0-.13-.07Zm-1.76.92c.31-.18.56,0,.56.32a1.25,1.25,0,0,1-.56,1c-.31.18-.56,0-.56-.33A1.23,1.23,0,0,1,20.46,186.16Zm-.56,4.6a3.79,3.79,0,0,1,1.71-3l4.68-2.7v6.09l-6.13,3.54c-.15.09-.26,0-.26-.15Zm.22,5.8c.5-.29.91-.06.91.52a2,2,0,0,1-.91,1.56c-.49.29-.9.05-.9-.52A2,2,0,0,1,20.12,196.56Zm2.41,2.94c-.32.18-.59.12-.72-.11l9.51-5.49a1.77,1.77,0,0,1-.72.94Z"
            style="fill:#fff"></path>
        <path
            d="M17.16,221.59a.49.49,0,0,1-.05-.26v-5.84a.85.85,0,0,1,.05-.3.28.28,0,0,1,.15-.17l.94-.55c.74-.43,1.11-.11,1.11.95a3.45,3.45,0,0,1-.47,1.82v0a.43.43,0,0,1,.42.3,2,2,0,0,1,.16.91,3.56,3.56,0,0,1-.31,1.52,2.15,2.15,0,0,1-.89,1l-1,.55Q17.2,221.65,17.16,221.59Zm1.1-4.45a.58.58,0,0,0,.25-.33,2.27,2.27,0,0,0,.08-.66,1.2,1.2,0,0,0-.08-.53q-.07-.13-.24,0l-.38.21v1.55Zm0,2.75a.69.69,0,0,0,.29-.37,2.16,2.16,0,0,0,.09-.7,1.1,1.1,0,0,0-.09-.56c-.06-.09-.15-.1-.29,0l-.4.23v1.65Z"
            style="fill:#fafafa"></path>
        <path
            d="M20.27,219.43a1.77,1.77,0,0,1-.34-1.28v-4.37a.52.52,0,0,1,.3-.47l.22-.13c.2-.11.3-.07.3.13v4.27a1,1,0,0,0,.12.56.22.22,0,0,0,.33.05.84.84,0,0,0,.33-.43,2,2,0,0,0,.12-.7v-4.27a.53.53,0,0,1,.31-.48l.2-.12c.21-.12.31-.07.31.13v4.36a3.8,3.8,0,0,1-.34,1.67,2.29,2.29,0,0,1-.93,1.07C20.8,219.65,20.49,219.65,20.27,219.43Z"
            style="fill:#fafafa"></path>
        <path
            d="M23.31,218.06a.39.39,0,0,1-.37-.16.64.64,0,0,1-.06-.28A2.19,2.19,0,0,1,23,217a.65.65,0,0,1,.17-.37s.07,0,.13,0l.14,0a.41.41,0,0,0,.36,0,.8.8,0,0,0,.29-.31,1.09,1.09,0,0,0,.12-.55,1,1,0,0,0-.06-.39.42.42,0,0,0-.16-.2,1.13,1.13,0,0,0-.27-.13,1.19,1.19,0,0,1-.58-.52,2.54,2.54,0,0,1-.18-1.11,3.59,3.59,0,0,1,.31-1.5,2,2,0,0,1,.8-.94.89.89,0,0,1,.38-.12.46.46,0,0,1,.32.05.35.35,0,0,1,.09.28,2.88,2.88,0,0,1-.06.55q-.06.31-.15.36a.23.23,0,0,1-.15,0,.63.63,0,0,0-.35.06.62.62,0,0,0-.29.33,1.15,1.15,0,0,0-.08.41.75.75,0,0,0,.11.47.74.74,0,0,0,.32.21l.12.06a1,1,0,0,1,.53.5,2.51,2.51,0,0,1,.16,1,4.19,4.19,0,0,1-.13,1,3.14,3.14,0,0,1-.38.94,1.86,1.86,0,0,1-.64.64A1.08,1.08,0,0,1,23.31,218.06Z"
            style="fill:#fafafa"></path>
        <path
            d="M26.35,216.31a.38.38,0,0,1-.37-.16.54.54,0,0,1-.07-.29,2.59,2.59,0,0,1,.08-.58.65.65,0,0,1,.17-.37s.08,0,.14,0l.13,0a.43.43,0,0,0,.37,0,.85.85,0,0,0,.28-.31,1.09,1.09,0,0,0,.12-.55,1,1,0,0,0-.06-.39.44.44,0,0,0-.15-.21l-.27-.12a1.14,1.14,0,0,1-.58-.52,2.54,2.54,0,0,1-.18-1.11,3.59,3.59,0,0,1,.3-1.5,2,2,0,0,1,.81-.95,1,1,0,0,1,.38-.12.48.48,0,0,1,.31.06.35.35,0,0,1,.09.28,3,3,0,0,1-.06.55q-.06.3-.15.36a.31.31,0,0,1-.15,0,.59.59,0,0,0-.34.06.62.62,0,0,0-.29.33,1,1,0,0,0-.08.41.76.76,0,0,0,.1.47.89.89,0,0,0,.32.21l.13.05a1,1,0,0,1,.52.51,2.48,2.48,0,0,1,.16,1,4.7,4.7,0,0,1-.12,1,3.58,3.58,0,0,1-.39.94,1.78,1.78,0,0,1-.64.64A1.12,1.12,0,0,1,26.35,216.31Z"
            style="fill:#fafafa"></path>
        <path
            d="M28.86,214.64v-5.07l-.58.34c-.06,0-.09,0-.12,0a1.19,1.19,0,0,1,0-.34v-.29a1.76,1.76,0,0,1,0-.38.28.28,0,0,1,.12-.18l2-1.16c.05,0,.09,0,.12,0a1.35,1.35,0,0,1,0,.34v.29a1.87,1.87,0,0,1,0,.38.32.32,0,0,1-.12.18l-.6.34v5.07a.54.54,0,0,1-.3.48l-.22.12C29,214.88,28.86,214.84,28.86,214.64Z"
            style="fill:#fafafa"></path>
        <path
            d="M30.58,210.64c0-2.24.46-3.63,1.38-4.16a.66.66,0,0,1,1,.22,5.36,5.36,0,0,1,.35,2.35A8.84,8.84,0,0,1,33,211.8a2.49,2.49,0,0,1-1,1.41C31,213.74,30.58,212.88,30.58,210.64Zm1.69,1a2.56,2.56,0,0,0,.18-.76,11.48,11.48,0,0,0,.06-1.32,9.73,9.73,0,0,0-.06-1.25,1,1,0,0,0-.18-.55.21.21,0,0,0-.3,0,.75.75,0,0,0-.31.36,2.64,2.64,0,0,0-.18.76,11.48,11.48,0,0,0-.06,1.32,9.84,9.84,0,0,0,.06,1.25,1,1,0,0,0,.18.55.23.23,0,0,0,.31,0A.73.73,0,0,0,32.27,211.61Z"
            style="fill:#fafafa"></path>
        <path
            d="M33.83,211.77v-5.92a.93.93,0,0,1,.05-.32.46.46,0,0,1,.16-.18l.92-.53a.61.61,0,0,1,.74,0c.21.16.31.64.31,1.44a4.6,4.6,0,0,1-.18,1.39,2.69,2.69,0,0,1-.41.85,1.5,1.5,0,0,1-.41.4l-.36.21v2.18a.55.55,0,0,1-.32.48l-.18.11C33.94,212,33.83,212,33.83,211.77Zm1.09-4a.6.6,0,0,0,.21-.31,2.15,2.15,0,0,0,.09-.71,1.22,1.22,0,0,0-.09-.59q-.09-.13-.21-.06l-.28.16v1.67Z"
            style="fill:#fafafa"></path>
    </g>
</g>
<g id="freepik--Bus--inject-4">
    <g id="freepik--bus--inject-4">
        <g id="freepik--Cab--inject-4">
            <g id="freepik--percentage-box--inject-4">
                <path
                    d="M66.43,282.93l-6.86-4a1.6,1.6,0,0,0-1.61-.15c-.4.24-1.21.73-1.62,1a1.59,1.59,0,0,0-.66,1.47v16.47a5,5,0,0,0,2.25,3.91l6.87,4a1.57,1.57,0,0,0,1.59.16c.41-.23,1.22-.73,1.63-1a1.6,1.6,0,0,0,.67-1.47V286.84A5,5,0,0,0,66.43,282.93Z"
                    style="fill:#fafafa"></path>
                <path
                    d="M68.69,286.84v16.47a1.6,1.6,0,0,1-.67,1.47c-.39.22-1,.61-1.58.94a1.64,1.64,0,0,0,.61-1.44V287.81a4.56,4.56,0,0,0-.66-2.22l1.64-1A4.66,4.66,0,0,1,68.69,286.84Z"
                    style="fill:#e0e0e0"></path>
                <path
                    d="M57.93,301.6l6.87,4c1.24.72,2.25.14,2.25-1.3V287.81a5,5,0,0,0-2.25-3.91l-6.87-4c-1.24-.71-2.25-.13-2.25,1.31v16.47A5,5,0,0,0,57.93,301.6Z"
                    style="fill:#f5f5f5"></path>
            </g>
            <path
                d="M66.83,315.28a.57.57,0,0,0,.28-1.06l-4.78-2.76a.58.58,0,0,1-.28-.49V292.92a.57.57,0,0,0-.57-.57.56.56,0,0,0-.57.57V311a1.72,1.72,0,0,0,.86,1.48l4.77,2.76A.59.59,0,0,0,66.83,315.28Z"
                style="fill:#263238"></path>
            <path d="M212.91,394.53l-19.39-9s1.52-18.23,14.31-13.88S212.91,394.53,212.91,394.53Z" style="fill:#7A2E84">
            </path>
            <g style="opacity:0.5">
                <path d="M212.91,394.53l-19.39-9s1.52-18.23,14.31-13.88S212.91,394.53,212.91,394.53Z"></path>
            </g>
            <path
                d="M202.25,392.25l4.17-8.29-9.93-5.74h0c-3.16-1.82-7.36-1.61-12,1.06-9.8,5.66-17.74,20.25-17.75,32.6,0,6.47,2.18,11,5.67,13.1h0l.14.08h0L182.76,431l4.4-8.74C195.49,415.84,201.92,403.26,202.25,392.25Z"
                style="fill:#263238"></path>
            <path
                d="M212.59,397.35c0,10.64-5.91,23-13.82,29.78a.07.07,0,0,0,0,0,25.71,25.71,0,0,1-3.9,2.79c-9.8,5.67-17.75.24-17.75-12.11,0-9.32,4.54-19.95,11-27l.06-.05a28.36,28.36,0,0,1,6.71-5.53C204.65,379.58,212.59,385,212.59,397.35Z"
                style="fill:#37474f"></path>
            <path
                d="M194.84,392.69c6.24-3.6,11.3.15,11.3,8.38s-5.06,17.83-11.3,21.43-11.29-.15-11.29-8.38S188.6,396.29,194.84,392.69Z"
                style="fill:#455a64"></path>
            <path
                d="M194.84,399.86c3.24-1.87,5.86.08,5.86,4.35s-2.62,9.25-5.86,11.12S189,415.25,189,411,191.6,401.73,194.84,399.86Z"
                style="fill:#e0e0e0"></path>
            <path
                d="M196.71,399.78a5.2,5.2,0,0,1,1.29-.52c1.62.44,2.7,2.22,2.7,4.95a14.8,14.8,0,0,1-3.29,8.85,7.78,7.78,0,0,1-.7.47c-2.88,1.66-5.21-.07-5.21-3.87S193.83,401.45,196.71,399.78Z"
                style="fill:#f5f5f5"></path>
            <path
                d="M212.59,397.35c0,10.64-5.91,23-13.82,29.78A50.33,50.33,0,0,0,210,405.35c1.51-7.12.94-17.34-5.17-19.92s-14.17,2.86-16.72,5.34a28.36,28.36,0,0,1,6.71-5.53C204.65,379.58,212.59,385,212.59,397.35Z"
                style="fill:#455a64"></path>
            <path
                d="M153.13,424.11a2.74,2.74,0,0,0,4.1,2.56L170.45,419a8.29,8.29,0,0,1-.18-1.64c0-13.59,9.54-30.1,21.36-36.89a25.43,25.43,0,0,1,3.46-1.68h0c.52-.2,1-.38,1.51-.52h0c9.34-2.83,16.29,2.85,16.29,14.46v1.77l24.19-14v-133l-31.27,18.06-31.67,23.27L157,369.37Z"
                style="fill:#e0e0e0"></path>
            <path
                d="M153.13,424.11a2.74,2.74,0,0,0,4.1,2.56L170.45,419a8.29,8.29,0,0,1-.18-1.64c0-13.59,9.54-30.1,21.36-36.89a25.43,25.43,0,0,1,3.46-1.68h0c.52-.2,1-.38,1.51-.52h0c9.34-2.83,16.29,2.85,16.29,14.46v1.77l24.19-14V340.07l-81.38,47Z"
                style="fill:#7A2E84"></path>
            <path
                d="M153.13,424.11a2.74,2.74,0,0,0,4.1,2.56L170.45,419a8.29,8.29,0,0,1-.18-1.64c0-13.59,9.54-30.1,21.36-36.89a25.43,25.43,0,0,1,3.46-1.68h0c.52-.2,1-.38,1.51-.52h0c9.34-2.83,16.29,2.85,16.29,14.46v1.77l24.19-14V340.07l-81.38,47Z"
                style="opacity:0.2"></path>
            <path
                d="M180.12,355.62a9.14,9.14,0,0,0,4.13-7.16V298.33c0-2.63-1-4-2.18-3.13l-2.18,1.63a9.93,9.93,0,0,0-3.28,5.24l-11.86,59.54c-.36,1.79.65,2.51,2.23,1.59Z"
                style="fill:#455a64"></path>
            <path
                d="M182.22,297.59c0,.21,0,.46,0,.74v50.13a7.12,7.12,0,0,1-3.13,5.42l-12.2,7.05,11.65-58.47a8.07,8.07,0,0,1,2.52-4l1.13-.84m.56-2.67a1.19,1.19,0,0,0-.71.28l-2.18,1.63a9.93,9.93,0,0,0-3.28,5.24l-11.86,59.54c-.25,1.26.17,2,1,2a2.55,2.55,0,0,0,1.23-.4l13.14-7.58a9.14,9.14,0,0,0,4.13-7.16V298.33c0-2.09-.61-3.41-1.47-3.41Z"
                style="fill:#37474f"></path>
            <path
                d="M233.47,263V323a3.56,3.56,0,0,1-1.6,2.78l-2.1,1.21-36.14,20.86c-.89.51-1.61.1-1.61-.93v-57a4.22,4.22,0,0,1,1.47-3l12.1-9.31a31.62,31.62,0,0,1,3.07-2.06l19.51-11.27,3.2-1.85.5-.29C232.75,261.6,233.47,262,233.47,263Z"
                style="fill:#37474f"></path>
            <polygon points="229.77 322.69 195.72 342.35 195.72 290.15 207.05 280.72 229.77 267.6 229.77 322.69"
                style="fill:#455a64"></polygon>
            <polygon
                points="233.47 279.4 233.47 283.75 229.77 285.89 195.72 305.56 192.03 307.69 192.03 303.34 195.72 301.21 229.77 281.54 233.47 279.4"
                style="fill:#37474f"></polygon>
            <path
                d="M217.07,376v3.32c0,.68.47.95,1.06.61L231,372.5a2.36,2.36,0,0,0,1.07-1.85v-3.32c0-.68-.48-1-1.07-.62l-12.89,7.44A2.36,2.36,0,0,0,217.07,376Z"
                style="fill:#fff"></path>
            <path
                d="M156.89,369.35l-1-.33c-32.24-11.13-63.76-27.61-89-50.81-1.34-1.23-2.07-2-2.17-2.07h0l-3.84,54.73a3,3,0,0,0,1.36,2.55c26.89,22.93,58.3,39.78,92.24,53.24a2.71,2.71,0,0,1-1.35-2.55L157,369.37Z"
                style="fill:#7A2E84"></path>
            <g style="opacity:0.30000000000000004">
                <path
                    d="M156.89,369.35l-1-.33c-32.24-11.13-63.76-27.61-89-50.81-1.34-1.23-2.07-2-2.17-2.07h0l-3.84,54.73a3,3,0,0,0,1.36,2.55c26.89,22.93,58.3,39.78,92.24,53.24a2.71,2.71,0,0,1-1.35-2.55L157,369.37Z"
                    style="fill:#fff"></path>
            </g>
            <path
                d="M64.72,316.14S80,331.45,105.06,346.07s51.86,23.29,51.86,23.29l17.22-80.53-57.62-33.25L90,240.29l-8.08-4.68Z"
                style="fill:#455a64"></path>
            <g style="opacity:0.1">
                <path
                    d="M84.32,257.29,83,256.55l-.1-.05-.07,0L72.54,308.25c-.35,1.79.65,2.51,2.23,1.59l13.14-7.58a9.14,9.14,0,0,0,4.14-7.16V261.76Z"
                    style="fill:#fff"></path>
                <path
                    d="M120.25,278.06,113.16,274l-13.77-8v26.75c0,1.58,1.11,2.22,2.48,1.43L122,282.58l.07-.32A4,4,0,0,0,120.25,278.06Z"
                    style="fill:#fff"></path>
            </g>
            <path
                d="M64.72,316.14h0c.1.11.83.84,2.17,2.07,25.25,23.2,56.77,39.68,89,50.81l1,.33h0l17.22-80.53-57.62-33.25L90,240.29l-8.08-4.68Zm45.44,27.26a1.77,1.77,0,0,1,0-.33.68.68,0,0,1,0-.15.37.37,0,0,1,0-.15,3,3,0,0,1,.07-.32l2.68-11.2,11.66-47.67a2,2,0,0,1,3.13-1.35l37.38,21.58A4.22,4.22,0,0,1,167,308l-11.67,54.84a2.39,2.39,0,0,1-3.24,1.82c-2.85-1-6.8-2.55-10-3.84h0c-6.62-2.68-13.48-5.7-20-8.89-3.31-1.61-6.7-3.35-10.1-5.21a3.51,3.51,0,0,1-1.57-1.8,3.64,3.64,0,0,1-.29-1,.13.13,0,0,1,0-.06A2.42,2.42,0,0,1,110.16,343.4Zm-32.94-20c-2.51-2.06-5-4.15-7.31-6.26a4,4,0,0,1-.35-.36v0c-.11-.13-.22-.29-.33-.45a5.54,5.54,0,0,1-.84-3.85L80,257.92a1.92,1.92,0,0,1,2.92-1.42.6.6,0,0,1,.11.06l1.29.73L113.16,274l7.09,4.08a4.06,4.06,0,0,1,1.82,4.2l-11.59,47.57L107.82,341h0a2,2,0,0,1-3.15,1.6c-2.1-1.25-4.13-2.52-6.1-3.79a232.59,232.59,0,0,1-21.31-15.47h0Z"
                style="fill:#f5f5f5"></path>
            <path
                d="M166.5,300.13l-83.18-48a3.28,3.28,0,0,1-1.48-3.27l1.51-7.5a1.49,1.49,0,0,1,2.35-1.06l83.18,48.05a3.28,3.28,0,0,1,1.47,3.26l-1.51,7.5A1.48,1.48,0,0,1,166.5,300.13Z"
                style="fill:#455a64"></path>
            <path
                d="M110.25,342.63a3.9,3.9,0,0,0,1.82,4.11,305.38,305.38,0,0,0,40.05,17.94,2.38,2.38,0,0,0,3.24-1.82l.58-2.91c-8.08-5.88-27.71-19.9-42.78-28.6l-.18-.1Z"
                style="fill:#37474f"></path>
            <path
                d="M69.22,316.27a3.76,3.76,0,0,0,.69.83,230.82,230.82,0,0,0,34.76,25.53,2,2,0,0,0,3.09-1.33l2.73-11.47a262.86,262.86,0,0,0-36.55-16.65Z"
                style="fill:#37474f"></path>
            <path
                d="M59.5,368.62c.15-.16.29-.14.46.14,0,0,12.49,17.26,39.73,33.55C122.3,415.83,146.94,419,146.94,419c10.58,1,23.51-10.2,23.51-10.2l-1.77-1.3s-12.28,9.3-18.52,9.3c-5.38,0-24.6-2.45-50.69-17.18s-38-32.61-38-32.61A2.55,2.55,0,0,0,59.5,368.62Z"
                style="fill:#37474f"></path>
            <path
                d="M60,368.76S72.45,386,99.69,402.31C122.3,415.82,146.94,419,146.94,419c10.58,1,23.52-10.19,23.52-10.19h0v10.68s-12.94,11.15-23.52,10.19c0,0-24.64-3.16-47.25-16.68C72.45,396.7,60,379.43,60,379.43,57.81,375.75,58.69,366.54,60,368.76Z"
                style="fill:#455a64"></path>
            <path
                d="M140.4,384.72c-3.89-.92-7.4,1.71-7.85,5.88a8.65,8.65,0,0,0,6.37,9.21,6.32,6.32,0,0,0,7.85-5.88A8.79,8.79,0,0,0,140.4,384.72Z"
                style="fill:#fff"></path>
            <path
                d="M71.19,345.11c2.37,2.35,3.88,7.41,3.39,11.29s-2.71,5.1-5,2.73-3.76-7.43-3.39-11.3S68.83,342.75,71.19,345.11Z"
                style="fill:#fff"></path>
            <path
                d="M125.9,379.62A101.94,101.94,0,0,1,104.39,370c-1.07-.63-1.94-.14-1.94,1.1v1.58a4.38,4.38,0,0,0,1.94,3.4,102.12,102.12,0,0,0,21.51,9.63,1.6,1.6,0,0,0,2.16-1.63v-1.58A3.16,3.16,0,0,0,125.9,379.62Z"
                style="fill:#37474f"></path>
            <path
                d="M79.07,354.06v1.57a5.5,5.5,0,0,0,1.72,3.71A183.23,183.23,0,0,0,96.91,371.4c1,.69,1.89.22,1.89-1v-1.57a4.67,4.67,0,0,0-1.89-3.49,185.24,185.24,0,0,1-16.12-12.06C79.84,352.46,79.07,352.81,79.07,354.06Z"
                style="fill:#37474f"></path>
            <path
                d="M125.9,390.66A101.94,101.94,0,0,1,104.39,381c-1.07-.63-1.94-.14-1.94,1.1v1.58a4.38,4.38,0,0,0,1.94,3.4,102.12,102.12,0,0,0,21.51,9.63,1.6,1.6,0,0,0,2.16-1.63v-1.58A3.16,3.16,0,0,0,125.9,390.66Z"
                style="fill:#37474f"></path>
            <path
                d="M79.07,365.1v1.57a5.52,5.52,0,0,0,1.72,3.71,185.24,185.24,0,0,0,16.12,12.06c1,.69,1.89.22,1.89-1v-1.58a4.66,4.66,0,0,0-1.89-3.48A185.24,185.24,0,0,1,80.79,364.3C79.84,363.5,79.07,363.85,79.07,365.1Z"
                style="fill:#37474f"></path>
            <polygon
                points="81.94 235.6 174.14 288.82 205.83 265.59 237.1 247.53 144.87 194.28 113.63 212.31 81.94 235.6"
                style="fill:#7A2E84"></polygon>
            <polygon
                points="81.94 235.6 174.14 288.82 205.83 265.59 237.1 247.53 144.87 194.28 113.63 212.31 81.94 235.6"
                style="fill:#fff;opacity:0.30000000000000004"></polygon>
            <g id="freepik--percentage-box--inject-4">
                <path
                    d="M179.75,347.41l-6.86-4a1.6,1.6,0,0,0-1.61-.15c-.4.24-1.21.73-1.62,1a1.58,1.58,0,0,0-.67,1.46v16.48a5,5,0,0,0,2.26,3.9l6.86,4a1.61,1.61,0,0,0,1.6.16c.41-.24,1.22-.74,1.63-1a1.58,1.58,0,0,0,.67-1.46V351.31A5,5,0,0,0,179.75,347.41Z"
                    style="fill:#fafafa"></path>
                <path
                    d="M182,351.31v16.48a1.58,1.58,0,0,1-.67,1.46l-1.58.94a1.62,1.62,0,0,0,.61-1.43V352.28a4.59,4.59,0,0,0-.66-2.22l1.64-1A4.7,4.7,0,0,1,182,351.31Z"
                    style="fill:#e0e0e0"></path>
                <path
                    d="M171.25,366.07l6.86,4c1.25.72,2.26.14,2.26-1.3V352.28a5,5,0,0,0-2.26-3.9l-6.86-4c-1.25-.72-2.26-.14-2.26,1.3v16.48A5,5,0,0,0,171.25,366.07Z"
                    style="fill:#f5f5f5"></path>
            </g>
            <path
                d="M165.12,368.81a5.12,5.12,0,0,0-2.3,4c0,1.48,1,2.08,2.31,1.34a5.12,5.12,0,0,0,2.31-4C167.44,368.67,166.4,368.07,165.12,368.81Z"
                style="fill:#37474f"></path>
            <path
                d="M173.25,376.57a1.74,1.74,0,0,0,1.71-1.72V358.12a.58.58,0,0,0-.57-.57.57.57,0,0,0-.57.57v16.73a.56.56,0,0,1-.29.5.56.56,0,0,1-.57,0L165.41,371a.57.57,0,0,0-.78.21.58.58,0,0,0,.21.78l7.55,4.35A1.67,1.67,0,0,0,173.25,376.57Z"
                style="fill:#263238"></path>
        </g>
        <path
            d="M144.87,194.28,320.15,93.12a19.58,19.58,0,0,1,19.56,0L412.37,135a19.56,19.56,0,0,1,9.79,17V262.41a19.55,19.55,0,0,1-9.79,16.95L237.1,380.55V247.49Z"
            style="fill:#7A2E84"></path>
        <path
            d="M144.87,194.28,320.15,93.12a19.58,19.58,0,0,1,19.56,0L412.37,135a19.56,19.56,0,0,1,9.79,17V262.41a19.55,19.55,0,0,1-9.79,16.95L237.1,380.55V247.49Z"
            style="fill:#fff;opacity:0.30000000000000004"></path>
        <path d="M388.22,293.32l-19.39-9s1.52-18.23,14.31-13.88S388.22,293.32,388.22,293.32Z" style="fill:#7A2E84">
        </path>
        <g style="opacity:0.5">
            <path d="M388.22,293.32l-19.39-9s1.52-18.23,14.31-13.88S388.22,293.32,388.22,293.32Z"></path>
        </g>
        <path
            d="M377.55,291l4.17-8.29L371.8,277h0c-3.16-1.82-7.36-1.61-12,1.05-9.8,5.66-17.75,20.26-17.75,32.61,0,6.46,2.18,11,5.67,13.1h0l.14.08h0l10.18,5.88,4.4-8.74C370.8,314.62,377.23,302.05,377.55,291Z"
            style="fill:#263238"></path>
        <path
            d="M387.9,296.13c0,10.65-5.91,23-13.82,29.79l0,0a26.3,26.3,0,0,1-3.9,2.8c-9.8,5.66-17.76.24-17.75-12.11,0-9.33,4.54-19.95,11-27l.06-.06a28.65,28.65,0,0,1,6.71-5.53C380,278.37,387.9,283.79,387.9,296.13Z"
            style="fill:#37474f"></path>
        <path
            d="M370.15,291.48c6.24-3.61,11.3.15,11.3,8.38s-5.06,17.83-11.3,21.43-11.3-.15-11.3-8.39S363.91,295.08,370.15,291.48Z"
            style="fill:#455a64"></path>
        <path
            d="M370.15,298.65c3.24-1.87,5.86.07,5.86,4.35s-2.62,9.25-5.86,11.12-5.86-.08-5.86-4.35S366.91,300.52,370.15,298.65Z"
            style="fill:#e0e0e0"></path>
        <path
            d="M372,298.57a4.84,4.84,0,0,1,1.29-.52c1.62.44,2.7,2.21,2.7,4.95a14.77,14.77,0,0,1-3.29,8.84,6.22,6.22,0,0,1-.7.48c-2.88,1.66-5.21-.07-5.21-3.87S369.14,300.23,372,298.57Z"
            style="fill:#f5f5f5"></path>
        <path
            d="M387.9,296.13c0,10.65-5.91,23-13.82,29.79a50.31,50.31,0,0,0,11.25-21.79c1.5-7.12.94-17.33-5.17-19.92s-14.17,2.86-16.72,5.34a28.65,28.65,0,0,1,6.71-5.53C380,278.37,387.9,283.79,387.9,296.13Z"
            style="fill:#455a64"></path>
        <path
            d="M422.16,152.31V262.46a19.5,19.5,0,0,1-9.75,16.88l-24.2,14v-1.76c0-11.62-6.95-17.29-16.29-14.47h0c-.49.15-1,.32-1.5.52a24.44,24.44,0,0,0-3.47,1.68c-11.82,6.79-21.35,23.3-21.35,36.89a7.53,7.53,0,0,0,.18,1.64L237.1,380.55V247.49l175-101A6.7,6.7,0,0,1,422.16,152.31Z"
            style="fill:#e0e0e0"></path>
        <path
            d="M237.1,340.07v40.48l108.67-62.74a7.53,7.53,0,0,1-.18-1.64c0-13.59,9.53-30.1,21.35-36.89a24.44,24.44,0,0,1,3.47-1.68c.51-.2,1-.37,1.5-.52h0c9.34-2.82,16.29,2.85,16.29,14.47v1.76l24.2-14a19.5,19.5,0,0,0,9.75-16.88V233.23Z"
            style="fill:#7A2E84"></path>
        <path
            d="M237.1,340.07v40.48l108.67-62.74a7.53,7.53,0,0,1-.18-1.64c0-13.59,9.53-30.1,21.35-36.89a24.44,24.44,0,0,1,3.47-1.68c.51-.2,1-.37,1.5-.52h0c9.34-2.82,16.29,2.85,16.29,14.47v1.76l24.2-14a19.5,19.5,0,0,0,9.75-16.88V233.23Z"
            style="opacity:0.2"></path>
        <polygon
            points="207.92 176.01 277.35 135.93 296.28 146.86 296.28 148.22 226.86 188.3 207.92 177.37 207.92 176.01"
            style="fill:#7A2E84"></polygon>
        <polygon points="296.28 146.86 226.86 186.94 207.92 176.01 277.35 135.93 296.28 146.86" style="fill:#7A2E84">
        </polygon>
        <polygon points="296.28 146.86 226.86 186.94 207.92 176.01 277.35 136.43 296.28 146.86"
            style="fill:#fff;opacity:0.4"></polygon>
        <polygon points="296.28 146.86 226.86 186.94 226.86 188.3 296.28 148.22 296.28 146.86" style="opacity:0.15">
        </polygon>
        <polygon points="226.86 186.94 207.92 176.01 207.92 177.37 226.86 188.3 226.86 186.94" style="fill:#7A2E84">
        </polygon>
        <polygon
            points="226.86 186.96 296.28 146.88 315.21 157.81 315.21 161.45 245.79 199.25 226.86 188.32 226.86 186.96"
            style="fill:#ebebeb"></polygon>
        <polygon points="315.21 157.81 245.79 197.89 226.86 186.96 296.28 146.88 315.21 157.81" style="fill:#7A2E84">
        </polygon>
        <polygon points="315.21 157.81 245.79 197.89 226.86 186.96 296.28 146.88 315.21 157.81"
            style="fill:#fff;opacity:0.6000000000000001"></polygon>
        <polygon points="245.79 197.89 226.86 186.96 226.86 188.32 245.79 199.25 245.79 197.89" style="fill:#7A2E84">
        </polygon>
        <polygon points="245.79 197.89 226.86 186.96 226.86 188.32 245.79 199.25 245.79 197.89"
            style="fill:#fff;opacity:0.30000000000000004"></polygon>
        <polygon
            points="245.79 197.87 315.21 157.79 334.14 168.72 334.14 170.08 264.72 210.16 245.79 199.23 245.79 197.87"
            style="fill:#7A2E84"></polygon>
        <polygon points="334.14 168.72 264.72 208.8 245.79 197.87 315.21 157.79 334.14 168.72" style="fill:#7A2E84">
        </polygon>
        <polygon points="333.17 168.72 264.72 208.8 245.79 197.87 315.21 157.79 333.17 168.72"
            style="fill:#fff;opacity:0.4"></polygon>
        <polygon points="334.14 168.72 264.72 208.8 264.72 210.16 334.14 170.08 334.14 168.72"
            style="fill:#fff;opacity:0.15"></polygon>
        <polygon points="264.72 208.8 245.79 197.87 245.79 199.23 264.72 210.16 264.72 208.8" style="fill:#7A2E84">
        </polygon>
        <path
            d="M247.08,193.3l-12.35-7.12c-.74-.43-1.13-.9-.86-1.05a2.72,2.72,0,0,1,1.84.5l12.35,7.12c.74.43,1.12.9.86,1.05A2.72,2.72,0,0,1,247.08,193.3Z"
            style="fill:#455a64"></path>
        <path
            d="M252.48,190.19l-12.35-7.13c-.75-.42-1.13-.9-.86-1.05a2.75,2.75,0,0,1,1.83.5l12.35,7.13c.74.43,1.13.9.86,1.05A2.75,2.75,0,0,1,252.48,190.19Z"
            style="fill:#455a64"></path>
        <path
            d="M257.87,187.07,245.52,180c-.74-.43-1.13-.9-.86-1a2.69,2.69,0,0,1,1.83.5l12.35,7.12c.75.43,1.13.9.86,1A2.69,2.69,0,0,1,257.87,187.07Z"
            style="fill:#455a64"></path>
        <path
            d="M263.26,184l-12.35-7.12c-.74-.43-1.12-.9-.86-1.05a2.72,2.72,0,0,1,1.84.5l12.35,7.13c.74.42,1.13.89.86,1.05A2.75,2.75,0,0,1,263.26,184Z"
            style="fill:#455a64"></path>
        <path
            d="M268.66,180.84l-12.35-7.12c-.75-.43-1.13-.9-.86-1.05s1.09.07,1.83.5l12.35,7.12c.74.43,1.13.9.86,1.05A2.69,2.69,0,0,1,268.66,180.84Z"
            style="fill:#455a64"></path>
        <path
            d="M274.05,177.72,261.7,170.6c-.74-.43-1.13-.9-.86-1a2.69,2.69,0,0,1,1.83.5L275,177.17c.75.43,1.13.9.86,1.05S274.79,178.15,274.05,177.72Z"
            style="fill:#455a64"></path>
        <path
            d="M279.44,174.61l-12.35-7.12c-.74-.43-1.12-.9-.86-1.06a2.75,2.75,0,0,1,1.84.51l12.35,7.12c.74.43,1.13.9.86,1.05A2.72,2.72,0,0,1,279.44,174.61Z"
            style="fill:#455a64"></path>
        <path
            d="M284.84,171.49l-12.35-7.12c-.75-.43-1.13-.9-.86-1.05a2.69,2.69,0,0,1,1.83.5l12.35,7.12c.74.43,1.13.9.86,1.05S285.58,171.92,284.84,171.49Z"
            style="fill:#455a64"></path>
        <path
            d="M290.23,168.38l-12.35-7.13c-.74-.42-1.13-.9-.86-1.05a2.71,2.71,0,0,1,1.83.51l12.35,7.12c.75.43,1.13.9.86,1A2.76,2.76,0,0,1,290.23,168.38Z"
            style="fill:#455a64"></path>
        <path
            d="M295.62,165.26l-12.35-7.12c-.74-.43-1.12-.9-.85-1a2.71,2.71,0,0,1,1.83.5l12.35,7.12c.74.43,1.13.9.86,1A2.72,2.72,0,0,1,295.62,165.26Z"
            style="fill:#455a64"></path>
        <path
            d="M301,162.14,288.67,155c-.75-.43-1.13-.9-.86-1.05a2.75,2.75,0,0,1,1.83.5L302,161.6c.74.42,1.13.89.86,1.05A2.71,2.71,0,0,1,301,162.14Z"
            style="fill:#455a64"></path>
        <path
            d="M306.41,159l-12.35-7.12c-.74-.43-1.13-.9-.86-1s1.09.07,1.83.5l12.36,7.12c.74.43,1.12.9.85,1.05A2.71,2.71,0,0,1,306.41,159Z"
            style="fill:#455a64"></path>
        <path
            d="M242.11,318V258.06a3.55,3.55,0,0,1,1.6-2.78l76-43.89c.88-.51,1.6-.1,1.6.92v59.95a3.54,3.54,0,0,1-1.6,2.77l-76,43.87C242.83,319.41,242.11,319,242.11,318Z"
            style="fill:#37474f"></path>
        <polygon points="245.81 258.34 317.6 216.87 317.6 271.97 245.81 313.42 245.81 258.34" style="fill:#455a64">
        </polygon>
        <polygon points="279.86 234.39 283.56 232.26 283.56 295.9 279.86 298.04 279.86 234.39" style="fill:#37474f">
        </polygon>
        <polygon points="242.11 274.42 242.11 278.77 321.3 233.03 321.3 228.68 242.11 274.42" style="fill:#37474f">
        </polygon>
        <path
            d="M329.82,267.34V207.42a3.54,3.54,0,0,1,1.6-2.78l76-43.89c.89-.51,1.61-.1,1.61.93v59.94a3.56,3.56,0,0,1-1.61,2.78l-76,43.86C330.53,268.77,329.82,268.36,329.82,267.34Z"
            style="fill:#37474f"></path>
        <polygon points="333.52 207.7 405.31 166.23 405.31 221.34 333.52 262.78 333.52 207.7" style="fill:#455a64">
        </polygon>
        <polygon points="367.56 183.75 371.26 181.62 371.26 245.26 367.56 247.4 367.56 183.75" style="fill:#37474f">
        </polygon>
        <polygon points="329.82 223.78 329.82 228.13 409.01 182.39 409.01 178.04 329.82 223.78" style="fill:#37474f">
        </polygon>
        <path
            d="M392.38,274.79v3.32c0,.68.48.95,1.07.61l12.88-7.44a2.35,2.35,0,0,0,1.07-1.85v-3.31c0-.68-.48-1-1.07-.62l-12.89,7.44A2.33,2.33,0,0,0,392.38,274.79Z"
            style="fill:#fff"></path>
        <g style="opacity:0.2">
            <path
                d="M307.28,334.19a.37.37,0,0,1-.18,0,.37.37,0,0,1-.19-.32V313.3a.37.37,0,0,1,.19-.32l29.63-17.1a.33.33,0,0,1,.36,0,.35.35,0,0,1,.18.31v20.53a.38.38,0,0,1-.18.32l-29.63,17.11A.39.39,0,0,1,307.28,334.19Zm.36-20.68V333.2l28.9-16.69V296.82Zm29.27,3.21h0Z">
            </path>
        </g>
        <path
            d="M321.64,322.19l.88-.54,0-13.82-.91.53Zm-5.09,2.93.88-.53,0-13.82-.91.52Zm-5.09,2.93.89-.53,0-13.82-.9.53Zm2.55-1.46.88-.54,0-13.81-.9.52Zm5.09-2.94.88-.53,0-13.82-.9.52Zm12.72-21.16v13.83l.88-.54,0-13.81Zm-2.55,15.29.89-.53,0-13.82-.91.52Zm-5.08,2.94.88-.54,0-13.81-.9.52Zm2.54-1.47.88-.53,0-13.82-.9.52Z"
            style="opacity:0.30000000000000004"></path>
    </g>
</g>
<g id="freepik--Character--inject-4">
    <g id="freepik--character--inject-4">
        <g id="freepik--Bottom--inject-4">
            <polygon points="319.48 427.04 322.54 425.95 321.58 423.89 319.68 425.59 319.48 427.04"></polygon>
            <path
                d="M316.44,421.54s-.16,2-.19,2.58,2.58,2.59,3.23,2.92l.2-1.45a11,11,0,0,1,1.48,2.37,11.41,11.41,0,0,0,2.51,3.73c2.05,1.73,5.29,2.64,8.6,2.81s5.22-.6,6.17-1.3a2.17,2.17,0,0,0,1.05-2.37C339.26,430,316.44,421.54,316.44,421.54Z"
                style="fill:#263238"></path>
            <path
                d="M325.41,415l.06-1.14c.61,0,.65,1.64,1.52,3.1a29.44,29.44,0,0,0,4.57,6c3.31,3.1,6.27,5.06,7.75,6.46,2,1.87-1.6,4.72-7,4.33-2.68-.19-7.43-1.61-8.74-3.21s-2.1-4.07-3.15-5.24-3.34-2.36-4-3.76c-.36-.77-.14-2.55.11-4.06s.3-3.52,1.09-3.33l0,.71c.31.62,1,1.63,3.2,2C322,417.09,325.18,417.24,325.41,415Z"
                style="fill:#37474f"></path>
            <path
                d="M322.62,417a3,3,0,0,0,2.6-1.31s0,0,0,0a2.58,2.58,0,0,0,.66,2.2c1,1.14,6.92,9.18,6.92,9.18s-5.57-6.64-6.64-7.89c-1.59-1.85-2.09-2.08-3.57-2.15Z"
                style="opacity:0.15"></path>
            <path
                d="M323.93,419.1a.34.34,0,0,1-.37.29.33.33,0,0,1-.28-.37.33.33,0,0,1,.37-.29A.33.33,0,0,1,323.93,419.1Z"
                style="opacity:0.15"></path>
            <path d="M325.5,420.88a.33.33,0,0,1-.66-.08.33.33,0,0,1,.66.08Z" style="opacity:0.15"></path>
            <path
                d="M327.07,422.66a.33.33,0,0,1-.37.29.33.33,0,0,1-.29-.37.32.32,0,0,1,.37-.28A.33.33,0,0,1,327.07,422.66Z"
                style="opacity:0.15"></path>
            <path d="M328.63,424.45a.33.33,0,0,1-.37.28.33.33,0,1,1,.37-.28Z" style="opacity:0.15"></path>
            <path d="M330.2,426.23a.33.33,0,0,1-.37.28.33.33,0,1,1,.37-.28Z" style="opacity:0.15"></path>
            <path
                d="M323.59,419.19a.09.09,0,0,1-.08,0,.13.13,0,0,1,0-.18,5.43,5.43,0,0,1,3.77-1.41h0a.13.13,0,0,1,0,.26,5.18,5.18,0,0,0-3.56,1.34A.14.14,0,0,1,323.59,419.19Z"
                style="fill:#263238"></path>
            <path
                d="M325.16,421a.12.12,0,0,1-.08,0,.13.13,0,0,1,0-.19,5.49,5.49,0,0,1,3.76-1.41h0a.14.14,0,0,1,.12.14.13.13,0,0,1-.15.12,5.34,5.34,0,0,0-3.56,1.34A.13.13,0,0,1,325.16,421Z"
                style="fill:#263238"></path>
            <path
                d="M326.73,422.75a.1.1,0,0,1-.09,0,.12.12,0,0,1,0-.18,5.37,5.37,0,0,1,3.76-1.41h0a.13.13,0,1,1,0,.26,5.26,5.26,0,0,0-3.56,1.34A.1.1,0,0,1,326.73,422.75Z"
                style="fill:#263238"></path>
            <path
                d="M328.29,424.54l-.08,0a.14.14,0,0,1,0-.19A5.43,5.43,0,0,1,332,422.9h0a.14.14,0,0,1,.12.14.13.13,0,0,1-.14.12,5.31,5.31,0,0,0-3.56,1.34A.15.15,0,0,1,328.29,424.54Z"
                style="fill:#263238"></path>
            <path
                d="M329.86,426.32a.2.2,0,0,1-.08,0,.13.13,0,0,1,0-.19,5.39,5.39,0,0,1,3.76-1.41h0a.14.14,0,0,1,.12.14.14.14,0,0,1-.15.12,5.34,5.34,0,0,0-3.56,1.34A.13.13,0,0,1,329.86,426.32Z"
                style="fill:#263238"></path>
            <path
                d="M302.32,435a12.13,12.13,0,0,1-1.44,5.88,4.59,4.59,0,0,1-4.37,1.83,6.3,6.3,0,0,1-5.48-4.15,11.61,11.61,0,0,1-.24-6.17Z"
                style="fill:#263238"></path>
            <path
                d="M294.1,416.14c-.73.06-.92,3.56-1.31,7.07-.42,3.77-1.56,5.88-1.92,8.41-.49,3.52-.23,5.1,1,7.22s6.65,4.2,8.79,1.13c1.74-2.5,1.79-5.26,1.6-8.77s-.36-6.18-.24-8.94.28-5.2-.35-5.48c-.05.38-.09.88-.14,1.26s-.1,1.72-.51,1.73a5.44,5.44,0,0,1,0-1,1.19,1.19,0,0,0-.2-.85,1.39,1.39,0,0,0-.82-.35,17.87,17.87,0,0,0-2.18-.31,10,10,0,0,0-1.1,0,12.36,12.36,0,0,0-1.92.1.63.63,0,0,0-.39.36,1.35,1.35,0,0,0,0,.4,2.9,2.9,0,0,1-.09.72c0,.11-.1.24-.2.21s-.12-.12-.12-.21c0-.42,0-.73.06-1.23,0-.23,0-.54,0-.77S294.08,416.36,294.1,416.14Z"
                style="fill:#37474f"></path>
            <path d="M293.56,432.47a.26.26,0,0,0,.23.28.26.26,0,1,0,0-.51A.26.26,0,0,0,293.56,432.47Z"
                style="opacity:0.15"></path>
            <path d="M293.79,430a.26.26,0,1,0,.28-.23A.25.25,0,0,0,293.79,430Z" style="opacity:0.15"></path>
            <path d="M294,427.74a.26.26,0,1,0,.51.05.26.26,0,0,0-.23-.28A.26.26,0,0,0,294,427.74Z" style="opacity:0.15">
            </path>
            <path d="M294.21,425.48a.26.26,0,1,0,.28-.23A.26.26,0,0,0,294.21,425.48Z" style="opacity:0.15"></path>
            <path d="M300,425.78a.25.25,0,0,0,.23.28.26.26,0,0,0,.05-.51A.26.26,0,0,0,300,425.78Z" style="opacity:0.15">
            </path>
            <path
                d="M299.8,428.06a.25.25,0,0,0,.23.28.26.26,0,0,0,.28-.23.26.26,0,0,0-.23-.28A.25.25,0,0,0,299.8,428.06Z"
                style="opacity:0.15"></path>
            <path d="M299.58,430.36a.25.25,0,0,0,.24.27.25.25,0,1,0,0-.5A.26.26,0,0,0,299.58,430.36Z"
                style="opacity:0.15"></path>
            <path d="M299.36,432.79a.26.26,0,0,0,.23.28.26.26,0,1,0-.23-.28Z" style="opacity:0.15"></path>
            <polygon points="297.21 433.96 299.04 416.99 298.1 416.98 297.21 433.96" style="opacity:0.15"></polygon>
            <path
                d="M293.81,432.62h0a11.52,11.52,0,0,1,5.71.29.12.12,0,0,0,.17-.06.12.12,0,0,0-.06-.17,11.6,11.6,0,0,0-5.88-.31.13.13,0,0,0-.1.15A.12.12,0,0,0,293.81,432.62Z"
                style="fill:#263238"></path>
            <path
                d="M294,430.19h.07c1.29-.62,4.39-.31,5.68.3a.14.14,0,0,0,.18-.06.13.13,0,0,0-.06-.17c-1.36-.64-4.56-1-5.91-.31a.13.13,0,0,0-.06.18A.12.12,0,0,0,294,430.19Z"
                style="fill:#263238"></path>
            <path
                d="M294.25,427.9l.06,0c1.29-.62,4.39-.31,5.69.31a.13.13,0,0,0,.17-.06.14.14,0,0,0-.06-.18c-1.35-.64-4.55-.95-5.91-.3a.12.12,0,0,0-.06.17A.13.13,0,0,0,294.25,427.9Z"
                style="fill:#263238"></path>
            <path
                d="M294.46,425.63h.06c1.29-.62,4.39-.31,5.69.3a.12.12,0,0,0,.17-.06.13.13,0,0,0-.06-.17c-1.35-.64-4.55-1-5.91-.3a.13.13,0,0,0,0,.24Z"
                style="fill:#263238"></path>
            <path
                d="M296.29,331.32c-1.78,21.39-2.43,50.82-2.43,50.82-.16,1.62-1.73,5.86-1.95,15.63-.19,8.5.46,24.33.46,24.33s5.17,2.79,10,1.22c0,0,5.14-26.27,7-36.37,2-11.25,3.85-26.17,3.85-26.17l1.07,20.43s-.35,6.1-.18,10.36c.19,5,2.2,26.07,2.2,26.07s6.45,3.81,11.47,0c0,0,1.83-32.53,2-38.5.32-11.7,0-34.53-.32-49.65Z"
                style="fill:#263238"></path>
            <path
                d="M307,355.45q-.59,7.69-1.32,15.38c-.24,2.56-.49,5.13-.76,7.68l-.39,3.84-.2,1.92c-.07.64-.19,1.28-.28,1.91-.79,5.09-2,14.32-2.86,19.39s-1.79,10.14-2.78,15.19q.92-7.67,2-15.3c.74-5.09,1.88-14.32,2.69-19.4.09-.64.22-1.27.29-1.91l.21-1.91.44-3.83c.3-2.56.6-5.11.92-7.66Q306,363.1,307,355.45Z">
            </path>
            <path
                d="M326.33,352.93c.52,4.79.79,9.6,1,14.4s.36,9.63.16,14.44-.3,12.86-.5,17.67-.43,9.61-.74,14.41q-.09-7.22,0-14.43c.05-4.8.17-12.86.29-17.66l.1-3.61,0-.9v-2.69l-.06-7.21-.1-7.21C326.47,357.74,326.4,355.34,326.33,352.93Z">
            </path>
            <path d="M313.17,360.78l2.15-11.71s5.84-.82,8.84-3.48c0,0-1.94,3.52-7.45,4.88l-2.13,10.35-.34,20.39Z">
            </path>
        </g>
        <g id="freepik--Top--inject-4">
            <path
                d="M357.77,309.62c-1.28,1.08-2.59,2.75-4.76,4.67s-5.45,5.27-8.64,7.32-4.77,2.9-9-1.15A113.1,113.1,0,0,1,324.69,308l-.52-15.55c3.47.9,5.5,2.66,7.73,5.82,4.22,5.94,7.06,9.78,9.51,13.21,0,0,9.38-6,10.59-6.95a5.08,5.08,0,0,0,1.85-2.81,24.18,24.18,0,0,1,.87-2.76c.35-1,.49-1.32.89-2.52s.66-3.21.78-3.66,1-.49,1.68.7a4.66,4.66,0,0,1,.38,2.38c0,.73-.19,1.62,0,1.73s1.24-.46,2.26-.75,1.93-.78,3.09-.49a1.36,1.36,0,0,1,1,1.76,1.81,1.81,0,0,1-.58.73,1.43,1.43,0,0,1,1.12.29,1.57,1.57,0,0,1,.11,2,.92.92,0,0,1,.92.76c.15.67.11,1.35-.56,1.65,0,0,.57.11.62.43a1.66,1.66,0,0,1-.47,1.53,5.38,5.38,0,0,1-1.93.54s-.09.25-.72.61a15.64,15.64,0,0,1-2.12,1.27A13.55,13.55,0,0,0,357.77,309.62Z"
                style="fill:#ffa8a7"></path>
            <path
                d="M362.48,304.57a3.35,3.35,0,0,0,.86-.32c.26-.1.54-.17.82-.25.57-.14,1.14-.28,1.71-.44-.59.06-1.17.14-1.75.25a4.66,4.66,0,0,0-.87.23,3.22,3.22,0,0,1-.79.27,1.83,1.83,0,0,1-.8-.17,1.87,1.87,0,0,1-.71-.39,1.11,1.11,0,0,1-.18-.36.49.49,0,0,1,.06-.37,1,1,0,0,1,.5-.34,2.43,2.43,0,0,0,.61.09,2.8,2.8,0,0,0,1-.28l.88-.42c.58-.3,1.16-.59,1.72-.92-.61.23-1.2.48-1.8.73a6.37,6.37,0,0,1-1.78.64,2.61,2.61,0,0,1-.9-.17,4.17,4.17,0,0,1-.84-.43.76.76,0,0,1-.42-.73.72.72,0,0,1,.22-.45l.22-.05c.36-.07.74-.1,1.11-.17a4.15,4.15,0,0,0,1.09-.38,9.71,9.71,0,0,0,1.87-1.29,9.47,9.47,0,0,1-.95.6c-.33.18-.66.37-1,.52a4.59,4.59,0,0,1-1.05.33c-.36.06-.74.08-1.12.15l-.54.12c-.18,0-.24,0-.34-.17a1,1,0,0,1,.18-.94,3.52,3.52,0,0,1,1.77-1.24h0v0a1.7,1.7,0,0,1,.22-.45,4.12,4.12,0,0,1,.33-.4,2.59,2.59,0,0,0-.37.37,1.57,1.57,0,0,0-.27.43,3.27,3.27,0,0,0-1.9,1.21,1.71,1.71,0,0,0-.27.54.87.87,0,0,0,.06.63.62.62,0,0,0,.23.26l.05,0a4.15,4.15,0,0,1-1.74,5.22,4.92,4.92,0,0,0,1.88-1.36,4.06,4.06,0,0,0,.9-1.68l.22.3a.76.76,0,0,0,0,.15,1.39,1.39,0,0,0,.17.44,1.83,1.83,0,0,0,.79.5,3,3,0,0,0,.55.18.48.48,0,0,0-.07.24.71.71,0,0,0,.12.37,3.33,3.33,0,0,0,.51.55l.31.21a1.2,1.2,0,0,0,.36.13,3,3,0,0,0,.73,0l-.68-.21a1.3,1.3,0,0,1-.29-.14,1.39,1.39,0,0,1-.27-.21,4.6,4.6,0,0,1-.51-.46.59.59,0,0,1-.16-.49Zm-2.61-3.8h0Z"
                style="fill:#f28f8f"></path>
            <path
                d="M322.09,291c4.43.44,6.2,1.35,9.55,6.12s5.68,8.24,6.82,9.62c1.32,1.59,3.71,4.26,3.71,4.26l-.76.46a13.55,13.55,0,0,0-6.9,8.11c-.5.41-1.25,0-3.31-2.29-2.36-2.66-10.79-12.51-10.79-12.51Z"
                style="fill:#f0f0f0"></path>
            <path
                d="M342.69,310.67c-.33,0-.74-.32-1.06-.68a1,1,0,0,0-1.36-.18c-1.44.95-4.34,3.14-5.56,5.8-1.66,3.59-1.14,3.95-1.14,3.95s1.46,2.88,3.82,3.76,2.87,0,2.87,0a4.79,4.79,0,0,1-1.4-.36S337.84,315.31,342.69,310.67Z"
                style="fill:#e0e0e0"></path>
            <path
                d="M295.42,294.47s-3.69,3-2,10.56a108.15,108.15,0,0,1,2.32,14.87c.27,4-.19,17.29-.19,17.29,6,7.16,31,5.36,34.1-1.14,0,0,.39-26.18-1.86-35.15-1.28-5.08-3.81-8.43-5.74-9.87l-7.76-.75-7.73-.1Z"
                style="fill:#e6e6e6"></path>
            <g id="freepik--Head--inject-4">
                <path
                    d="M303.62,268.05a3.77,3.77,0,0,0-2.8,2.17c-.56,1-1,3,.4,8.48a22,22,0,0,0,2.53,6.1,2.7,2.7,0,0,0,1.56,1.29l0-4.22-.1-2.94a12.22,12.22,0,0,0,2.18-4.66,7.58,7.58,0,0,0-.24-3.83Z"
                    style="fill:#37474f"></path>
                <path
                    d="M303,268.18c.45-2.36,3.52-5.14,9.33-5.34,4.76-.16,7.51,1.52,9.11,4.33s.45,6.37.45,6.37L307,272.29Z"
                    style="fill:#37474f"></path>
                <path
                    d="M304.58,268.91a3.27,3.27,0,0,1-1.82,2.63,3.73,3.73,0,0,0-1.89,3.1,3.66,3.66,0,0,1,2-2.32,9.22,9.22,0,0,0,1.83-1.28s-.14,1.1-2,2.51a3.93,3.93,0,0,0-1.38,3.68,3.44,3.44,0,0,1,1.26-2.67c1.37-1.17,3.05-1.7,3-3.45A3,3,0,0,0,304.58,268.91Z"
                    style="fill:#e0e0e0"></path>
                <path
                    d="M301.39,283c1.64.89,3.2-.6,3.2-.6l.17,8.7s.14,1.69,2.79,3.21c3.75,2.16,5.38,2.69,7,5,1.29-3.72,2.75-5.82.38-8.71l0-2a13.51,13.51,0,0,0,2.63,0c1.94-.27,3.18-1.78,3.8-3.87a29.31,29.31,0,0,0,.27-13.35,4.48,4.48,0,0,0-1.56-2.62c-3.77-3-8.1-.94-11.36.26a6.07,6.07,0,0,1-4.07-.09c1.1,1.27,1.63,2.48,1.56,8.48a3.57,3.57,0,0,1-.85,1.07c-.72.6-1.27-1-1.85-1.63a2.44,2.44,0,0,0-3.81.8A4,4,0,0,0,301.39,283Z"
                    style="fill:#ffa8a7"></path>
                <path d="M312.09,273.66l-2.15.88a1.23,1.23,0,0,1,.65-1.56A1.14,1.14,0,0,1,312.09,273.66Z"
                    style="fill:#37474f"></path>
                <path d="M320.21,273.92l-2.25-.7a1.13,1.13,0,0,1,1.43-.8A1.25,1.25,0,0,1,320.21,273.92Z"
                    style="fill:#37474f"></path>
                <path d="M310.82,276a1,1,0,1,0,1.9,0,1,1,0,0,0-1.9,0Z" style="fill:#263238"></path>
                <path d="M317.89,275.74a1,1,0,1,0,.93-1A.86.86,0,0,0,317.89,275.74Z" style="fill:#263238"></path>
                <path d="M314.34,273.91,315,280l3.22-1.12A14.27,14.27,0,0,0,314.34,273.91Z" style="fill:#f28f8f">
                </path>
                <path
                    d="M306.09,276.89c.34,4.13,1.77,4.37,3.25,4.56,2,.25,2.89-.83,6.37-.95a7.92,7.92,0,0,1,4,1c.9.34,1.62.2,1.93-.6a13.75,13.75,0,0,0,.52-4.49,33.55,33.55,0,0,1,.06,6.78,7.34,7.34,0,0,1-1.93,4.59c-1.44,1.31-4.54,1.93-8.46,1.2s-5.45-2.3-6-3.66c-1.67-4.41-1.14-6.54-1.68-7.37S306.09,276.89,306.09,276.89Z"
                    style="fill:#37474f"></path>
                <path
                    d="M315.41,281.28c-2,0-2.81.42-2.81,2.25s0,2.61.79,2.69,1.53.12,1.54-.44a2.16,2.16,0,0,0-.17-1.24c-.32-.36-.21-.42.66-.43s.87.14.62.42a2.48,2.48,0,0,0-.13,1.26c0,.42.11.58,1.36.42s.88-1,.8-2.69C318,282.39,317.66,281.25,315.41,281.28Z"
                    style="fill:#ffa8a7"></path>
                <path d="M313.62,281.84l3.28.56a1.63,1.63,0,0,1-1.89,1.41A1.73,1.73,0,0,1,313.62,281.84Z"
                    style="fill:#b16668"></path>
                <path
                    d="M314,282.35a1.76,1.76,0,0,0-.4,0,1.7,1.7,0,0,0,1.38,1.44,1.4,1.4,0,0,0,.54,0A1.54,1.54,0,0,0,314,282.35Z"
                    style="fill:#f28f8f"></path>
            </g>
            <path d="M315.63,299.05s1.44-2.72,1.45-3.79l-1.72-1.79-.57,4.44Z" style="fill:#7A2E84"></path>
            <path d="M315.63,299.05s1.44-2.72,1.45-3.79l-1.72-1.79-.57,4.44Z" style="opacity:0.2"></path>
            <polygon points="313.26 298.07 310.32 296.05 307.85 297.69 312.37 300.03 313.26 298.07"
                style="fill:#7A2E84"></polygon>
            <polygon points="313.26 298.07 310.32 296.05 307.85 297.69 312.37 300.03 313.26 298.07" style="opacity:0.2">
            </polygon>
            <path
                d="M312.4,325.45c.29-9.51,1.18-21.62,1-23.94l1.62-.14a88.34,88.34,0,0,1,5.37,23.85c.06,2.16-2,6.86-3.5,6.91S312.36,326.85,312.4,325.45Z"
                style="fill:#7A2E84"></path>
            <path
                d="M312.4,325.45c.29-9.51,1.18-21.62,1-23.94l1.62-.14a88.34,88.34,0,0,1,5.37,23.85c.06,2.16-2,6.86-3.5,6.91S312.36,326.85,312.4,325.45Z"
                style="fill:#fff;opacity:0.1"></path>
            <path d="M315.18,301.7c-.05-.11-.1-.22-.14-.33h0l-1.62.14h0c0,.2,0,.44,0,.73A2.86,2.86,0,0,0,315.18,301.7Z"
                style="opacity:0.5"></path>
            <path
                d="M313.23,297.85a7,7,0,0,1,1.52-.05,3.65,3.65,0,0,1,.88,1.25,5.6,5.6,0,0,1-.59,2.32,2,2,0,0,1-1.62.14,3.35,3.35,0,0,1-1.15-1.56A3,3,0,0,1,313.23,297.85Z"
                style="fill:#7A2E84"></path>
            <path
                d="M313.23,297.85a7,7,0,0,1,1.52-.05,3.65,3.65,0,0,1,.88,1.25,5.6,5.6,0,0,1-.59,2.32,2,2,0,0,1-1.62.14,3.35,3.35,0,0,1-1.15-1.56A3,3,0,0,1,313.23,297.85Z"
                style="fill:#fff;opacity:0.1"></path>
            <path
                d="M296.85,293.92c1.94,3.86,2.55,9.26,1.82,14.4a13.31,13.31,0,0,1-3.52,7.67s.55,5.68.5,7.25-.3,15.49-.3,15.49,6.35,5.57,21,4.74l2.33-7.23,4.43,5.9a15.42,15.42,0,0,0,7-2.7s.12-20.17-.24-25.47-2.76-17.69-7.83-22.94l-4.94-.47a35.14,35.14,0,0,1,1.57,10.68,51.44,51.44,0,0,1-1.18,10.64s-6.46-6.87-8.92-10.51-7.19-9.21-7.19-9.21Z"
                style="fill:#455a64"></path>
            <path
                d="M317.54,311.88a10.44,10.44,0,0,1-.82,1.4,8.12,8.12,0,0,0-.86,1.33,1.28,1.28,0,0,0-.07.71l0,.81.09,1.62c.11,2.15.18,4.3.25,6.46s.11,4.3.13,6.46l0,1.61a2.42,2.42,0,0,0,.07.74,4.47,4.47,0,0,0,.36.68,26.2,26.2,0,0,0,2,2.54,19.94,19.94,0,0,1-2.23-2.36,4,4,0,0,1-.44-.73,3,3,0,0,1-.14-.85l-.11-1.62c-.13-2.15-.21-4.3-.27-6.46s-.11-4.3-.11-6.46v-2.42a3.19,3.19,0,0,1,0-.43,1.2,1.2,0,0,1,.13-.43,10.54,10.54,0,0,1,1-1.31A15.41,15.41,0,0,0,317.54,311.88Z"
                style="fill:#37474f"></path>
            <path d="M308.18,311.25a2.38,2.38,0,1,1-2.38-2.38A2.37,2.37,0,0,1,308.18,311.25Z" style="fill:#7A2E84">
            </path>
            <path
                d="M305.8,313.88a2.63,2.63,0,1,1,2.63-2.63A2.63,2.63,0,0,1,305.8,313.88Zm0-4.76a2.13,2.13,0,1,0,2.13,2.13A2.14,2.14,0,0,0,305.8,309.12Z"
                style="fill:#fafafa"></path>
            <path
                d="M313.26,297.85c-.05,0-.12.12-.18.12-1.11-.62-1.29-.82-1.59-.74-.57.15-1.93,2.49-2.27,3.25s-.28.75-1.31,0a18.52,18.52,0,0,1-4.66-4.6,13.83,13.83,0,0,1-1.82-3.76s1.21-1.62,1.56-2.24c.69-1.2,1-1.7,1.71-1.58l0,.72c.1,1.05,1.22,2.15,2.68,3.44s3.82,2.53,4.37,3.08A11,11,0,0,1,313.26,297.85Z"
                style="fill:#f5f5f5"></path>
            <path
                d="M318.59,298.81c-.17.42-1.49-2.95-2.16-2.89-.32,0-1.06.92-1.68,1.88l-.45,0a10.29,10.29,0,0,0,.72-2.55,38.82,38.82,0,0,0-.12-4.65l0-1.3c.18,0,.95,0,1.37,0a7.34,7.34,0,0,1,.9,1.33,17.22,17.22,0,0,1,1.4,4.48A11.07,11.07,0,0,1,318.59,298.81Z"
                style="fill:#f5f5f5"></path>
            <path
                d="M307.32,346.65l-.08-.06c-1.07-.68-2.08-1.48-3.12-2.21a7.37,7.37,0,0,0-1.27-.68c-.42-.17-.87-.24-1.31-.38s-.92-.4-1.4-.58a3,3,0,0,1-1.39-.91,8.29,8.29,0,0,1-1-1.52,9.81,9.81,0,0,1-.56-1.33c-2.32-.11-4.31,1.31-6,4.29.26.46.5.87.71,1.22,1.77,2.87,1.58,5.69,4.39,8.67A8.7,8.7,0,0,0,302,349.9a8.36,8.36,0,0,0,1-1.87s-.28-.47-.3-.56.05-.29.25-.31a2.09,2.09,0,0,1,1.07.35,3.85,3.85,0,0,0,1.21.53,4.19,4.19,0,0,0,1.12,0,2.66,2.66,0,0,0,1.41-.43C308.15,347.25,307.65,346.86,307.32,346.65Z"
                style="fill:#ffa8a7"></path>
            <path
                d="M282.51,330.81c2.05,3.31,6.48,8.75,8.77,12.46s6-4.29,6-4.29c-1.88-5.37-3.45-11.07-3.45-11.07s-4.11-2.51-7.9-1.45A4.13,4.13,0,0,0,282.51,330.81Z"
                style="fill:#ffa8a7"></path>
            <path
                d="M281.92,318.75c.91-3.52,4.16-14.38,5.23-17.52,1.42-4.17,3-5.27,8.27-6.76,4.32,4.51,2.53,15.78,2.53,15.78s-3.76,11.84-3.95,12.64,0,1.42-.8,2.07c-1.86-.89-10.83-1.49-12.32.36C279.49,323.58,281.3,321.13,281.92,318.75Z"
                style="fill:#f0f0f0"></path>
            <path
                d="M293.2,325c.49.27.11.73.36,1.64s.95,1.31.51,1.66a16,16,0,0,0-9.65.63c-2.25.83-1.91,1.92-1.91,1.92-.7.27-1.3-.77-1.38-2a20.1,20.1,0,0,1-.25-3.45C281.33,323.64,288.18,323.17,293.2,325Z"
                style="fill:#e0e0e0"></path>
            <path
                d="M296.38,353.16A8.7,8.7,0,0,0,302,349.9a7.79,7.79,0,0,0,1-1.78,8,8,0,0,1-2.06,2.44,4.54,4.54,0,0,1-4.22,1.32,5.23,5.23,0,0,1-2.55-2.13A11.27,11.27,0,0,0,296.38,353.16Z"
                style="fill:#f28f8f"></path>
            <g id="freepik--Cap--inject-4">
                <path
                    d="M321.21,269.28h-.07a21.46,21.46,0,0,0-13.47,2.84c-.14.07-.27.15-.4.23l-.11.07a13.22,13.22,0,0,0-4.37,4,2.84,2.84,0,0,0-2.22.13c-.07-.24-.43-2.23-.46-2.43-.57-4,.52-9.31,7.33-11.58,6.08-2,11.69-.18,13,3.57C320.73,266.92,321,268.43,321.21,269.28Z"
                    style="fill:#263238"></path>
                <path
                    d="M307,271.53a12.77,12.77,0,0,1,4.69-4.85c2.23-1.41,7-1.83,9.11-2,3.73-.22,4.68.51,4.77,1,0,.13.12.73.15.87a.54.54,0,0,1-.05.36c-.5.89-3.4,2.58-3.4,2.58-4.76-.94-10.53.25-15.12,2.83Z"
                    style="fill:#37474f"></path>
                <path
                    d="M307.16,272.41a24.6,24.6,0,0,1,15.12-2.83s2.9-1.69,3.4-2.58c.26-.49-.1-1.67-4.72-1.4-2.14.13-6.88.55-9.11,2A12.77,12.77,0,0,0,307.16,272.41Z"
                    style="fill:#263238"></path>
            </g>
        </g>
    </g>
</g>`,
];

export const officeChatWithMoovexLogo = [
  '500 500',
  `
<path fill="#e0e0e0" d="M351.93 266.24h-1.84V241.9h1.84z" />
<path fill="#263238" d="M370.48 293.64H164.83v-7.67h205.65z" />
<path fill="#fff" d="M370.48 293.64H164.83v-7.67h205.65z" opacity=".8" />
<path fill="#263238" d="M169.61 293.64h-65.78v-7.67h65.78z" />
<path fill="#fff" d="M169.61 293.64h-65.78v-7.67h65.78z" opacity=".6" />
<path
  fill="#ebebeb"
  d="M416.78 398.49h33.12v.25h-33.12zm-20.19-9.28h19.19v.25h-19.19zm-74.06 12h8.69v.25h-8.69zM52.46 390.89h43.19v.25H52.46zm52.1 0h6.33v.25h-6.33zm26.91 4.22h93.68v.25h-93.68z"
/>
<path fill="#e0e0e0" d="M79.13 100.32h1.8v140.37h-1.8zm112.05 0h1.8v140.37h-1.8z" />
<path
  fill="#ebebeb"
  d="M200.03 109.15H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.64H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3zm0 8.65H72.08l-2.7-6.3h133.35l-2.7 6.3z"
/>
<path
  fill="#e0e0e0"
  d="M69.38 238.89h133.35v3.6H69.38zM64.73 94.96h142.65v8.4H64.73zm1.46 84.56a1.45 1.45 0 0 1-1.45-1.45v-49a1.45 1.45 0 0 1 1.45-1.45 1.45 1.45 0 0 1 1.45 1.45v49a1.45 1.45 0 0 1-1.45 1.45z"
/>
<path fill="#e0e0e0" d="M65.67 101.68h1.05v29.1h-1.05z" />
<circle cx="380.09" cy="95.26" r="20.73" />
<path fill="#fff" d="M396.167 95.865a16.64 16.64 0 1 1-16.64-16.64 16.64 16.64 0 0 1 16.64 16.64z" opacity=".8" />
<path d="M377.8 96.1a1.69 1.69 0 0 1 0-2.39 1.71 1.71 0 0 1 2.39 0 1.69 1.69 0 1 1-2.39 2.39z" />
<path d="m378.69 94.33 9.83-.3.03 1.02-8.9.27-.96 15.48-1.01-.06 1.01-16.41z" />
<path fill="#263238" d="M86 404.59c0-.34-3.54-34.42 4.28-63.41l1 .26C83.52 370.25 87 404.15 87 404.49l-1 .1z" />
<path d="M94.48 348.53s-10.77 20-8.62 43.57c0 0 4.48-28.96 8.62-43.57z" />
<path d="M73.07 338.63s15.72 22.11 13 50.34c-.02.03-6.13-35.47-13-50.34z" />
<path
  d="M86 395.79s3.4-29.19-14.66-37.62c-.05 0 9.58 7.12 14.66 37.62zm1.85-54.16-.33.06a.87.87 0 0 0-.68 1.1l.4 1.45a.87.87 0 0 0 1.45.39l.54-.52a.88.88 0 0 1 1.43.33l.73 2a.87.87 0 0 0 1.27.45l1.68-1a.87.87 0 0 0 .18-1.35l-.27-.28a.88.88 0 0 1 .61-1.48h1.46a.87.87 0 0 0 .84-1l-.16-1.25a.87.87 0 0 0-1.25-.67l-.1.05a.88.88 0 0 1-1.18-1.14l.48-1.1a.87.87 0 0 0-.69-1.21l-1.55-.21a.87.87 0 0 0-1 .84.88.88 0 0 1-1.64.4l-.2-.36a.88.88 0 0 0-1.36-.21L87.36 338a.88.88 0 0 0 0 1.28l.92.85a.88.88 0 0 1-.43 1.5z"
/>
<path
  fill="#fff"
  d="m87.85 341.63-.33.06a.87.87 0 0 0-.68 1.1l.4 1.45a.87.87 0 0 0 1.45.39l.54-.52a.88.88 0 0 1 1.43.33l.73 2a.87.87 0 0 0 1.27.45l1.68-1a.87.87 0 0 0 .18-1.35l-.27-.28a.88.88 0 0 1 .61-1.48h1.46a.87.87 0 0 0 .84-1l-.16-1.25a.87.87 0 0 0-1.25-.67l-.1.05a.88.88 0 0 1-1.18-1.14l.48-1.1a.87.87 0 0 0-.69-1.21l-1.55-.21a.87.87 0 0 0-1 .84.88.88 0 0 1-1.64.4l-.2-.36a.88.88 0 0 0-1.36-.21L87.36 338a.88.88 0 0 0 0 1.28l.92.85a.88.88 0 0 1-.43 1.5z"
  opacity=".7"
/>
<path
  d="m89.29 388.28 1.26-9.75h-11l1.25 9.75A13.05 13.05 0 0 0 72 400.6a21.57 21.57 0 0 0 2.14 8.69 7.62 7.62 0 0 0 6.93 4.34h8a7.59 7.59 0 0 0 6.92-4.34 21.43 21.43 0 0 0 2.15-8.69 13 13 0 0 0-8.85-12.32z"
/>
<path
  fill="#fff"
  d="m89.29 388.28 1.26-9.75h-11l1.25 9.75A13.05 13.05 0 0 0 72 400.6a21.57 21.57 0 0 0 2.14 8.69 7.62 7.62 0 0 0 6.93 4.34h8a7.59 7.59 0 0 0 6.92-4.34 21.43 21.43 0 0 0 2.15-8.69 13 13 0 0 0-8.85-12.32z"
  opacity=".7"
/>
<path fill="#263238" d="M307.93 293.51v119.51h3.26l2.9-113.4h3.84v-6.11h-10z" />
<path fill="#263238" d="M310.82 413.02h3.11l4-119.5h-4.11l-3 119.5z" />
<path fill="#fff" d="M311.42 413.02h2.51l3.72-113.26h-3.51l-2.72 113.26z" opacity=".3" />
<path fill="#fff" d="M307.93 293.51v119.51h3.26l2.9-113.4h3.84v-6.11h-10z" opacity=".5" />
<path fill="#263238" d="M112.16 413.02h3.11l4-119.34h-4.11l-3 119.34z" />
<path fill="#fff" d="M112.16 413.02h3.11l4-119.34h-4.11l-3 119.34z" opacity=".3" />
<path fill="#263238" d="M162.27 293.68v119.34h-3.29l-3.87-113.55h-39.69l-2.9 113.55h-3.25V293.68h53z" />
<path fill="#fff" d="M162.27 293.68v119.34h-3.29l-3.87-113.55h-39.69l-2.9 113.55h-3.25V293.68h53z" opacity=".5" />
<path fill="#263238" d="M162.27 413.02h3.1l1-119.34h-4.1v119.34z" />
<path fill="#fff" d="M162.27 413.02h3.1l1-119.34h-4.1v119.34z" opacity=".3" />
<path fill="#263238" d="M317.93 293.68v5.8h35.84l3.87 113.54h3.29V293.68h-43z" />
<path fill="#fff" d="M317.93 293.68v5.8h35.84l3.87 113.54h3.29V293.68h-43z" opacity=".5" />
<path fill="none" d="M317.93 293.68v5.8h35.84l3.87 113.54h3.29V293.68h-43z" opacity=".3" />
<path fill="#263238" d="M360.93 413.02h3.11l1-119.34h-4.11v119.34z" />
<path fill="#fff" d="M360.93 413.02h3.11l1-119.34h-4.11v119.34z" opacity=".3" />
<path
  fill="#263238"
  d="M149.58 283.86v1.06a1 1 0 0 0 1 1h38a.92.92 0 0 0 .92-.91v-1a.92.92 0 0 0-.92-.92h-9.45a1.73 1.73 0 0 1-1.71-2l3.32-19.16h-21.6l-9.25 20.46a3.81 3.81 0 0 0-.31 1.47z"
/>
<path
  fill="#fff"
  d="M189.51 284v1a.91.91 0 0 1-.91.91h-38a1 1 0 0 1-1-1v-1.06a4 4 0 0 1 .1-.84 4.3 4.3 0 0 1 .23-.69l9.25-20.46h21.6L177.43 281a1.32 1.32 0 0 0 0 .34 1.72 1.72 0 0 0 1.37 1.65 1.42 1.42 0 0 0 .36 0h9.46a.91.91 0 0 1 .89 1.01z"
  opacity=".2"
/>
<path
  fill="#263238"
  d="m148.68 282.33 9.25-20.46h1.22l-9.25 20.46a3.81 3.81 0 0 0-.32 1.53v1.06a1 1 0 0 0 1 1h-1.22a1 1 0 0 1-1-1v-1.06a3.82 3.82 0 0 1 .32-1.53z"
/>
<path d="M159.15 261.87h21.6l-.85 4.89h-22.96l2.21-4.89z" opacity=".3" />
<path
  fill="#263238"
  d="M217 264h-92.15a3.37 3.37 0 0 1-3.37-3.37v-66.57a3.37 3.37 0 0 1 3.37-3.37H217a3.37 3.37 0 0 1 3.37 3.37v66.59A3.37 3.37 0 0 1 217 264z"
/>
<path
  fill="#fff"
  d="M217 264h-92.15a3.37 3.37 0 0 1-3.37-3.37v-66.57a3.37 3.37 0 0 1 3.37-3.37H217a3.37 3.37 0 0 1 3.37 3.37v66.59A3.37 3.37 0 0 1 217 264z"
  opacity=".2"
/>
<rect width="95.68" height="58.69" x="123.08" y="192.73" rx="1.83" />
<rect width="95.68" height="58.69" x="122.913" y="192.563" fill="#fff" stroke="#fff" rx="1.83" />
<path
  d="M122.81 190.69h2a3.37 3.37 0 0 0-3.37 3.37v66.59a3.37 3.37 0 0 0 3.37 3.37h-2a3.37 3.37 0 0 1-3.37-3.37v-66.59a3.37 3.37 0 0 1 3.37-3.37z"
/>
<path
  fill="#fff"
  d="M122.81 190.69h2a3.37 3.37 0 0 0-3.37 3.37v66.59a3.37 3.37 0 0 0 3.37 3.37h-2a3.37 3.37 0 0 1-3.37-3.37v-66.59a3.37 3.37 0 0 1 3.37-3.37z"
  opacity=".3"
/>
<path
  fill="#fff"
  d="M156.15 284v1a1 1 0 0 0 .95 1h31.5a.91.91 0 0 0 .91-.91v-1a.92.92 0 0 0-.91-.92h-9.46a1.47 1.47 0 0 1-.36 0H157.1a1 1 0 0 0-.95.83z"
  opacity=".2"
/>
<path d="M149.67 283h29.11a1.71 1.71 0 0 1-1.37-1.65h-27l-.74 1.65z" opacity=".2" />
<path
  fill="#263238"
  d="M221.78 283.6h2.76a.5.5 0 0 0 .52-.48v-2.66a.5.5 0 0 0-.52-.48h-2a.52.52 0 0 0-.51.36l-.77 2.65a.49.49 0 0 0 .52.61z"
/>
<path
  fill="#263238"
  d="M218 283.6h2.75a.51.51 0 0 0 .53-.48v-2.66a.51.51 0 0 0-.53-.48h-2a.52.52 0 0 0-.51.36l-.78 2.65a.49.49 0 0 0 .54.61z"
/>
<path
  fill="#263238"
  d="M214.17 283.6h2.76a.5.5 0 0 0 .52-.48v-2.66a.5.5 0 0 0-.52-.48h-2a.52.52 0 0 0-.51.36l-.77 2.65a.49.49 0 0 0 .52.61z"
/>
<path
  fill="#263238"
  d="M210.37 283.6h2.75a.51.51 0 0 0 .53-.48v-2.66a.51.51 0 0 0-.53-.48h-2a.52.52 0 0 0-.51.36l-.78 2.65a.49.49 0 0 0 .54.61z"
/>
<path
  fill="#263238"
  d="M206.56 283.6h2.76a.5.5 0 0 0 .52-.48v-2.66a.5.5 0 0 0-.52-.48h-2a.52.52 0 0 0-.51.36l-.77 2.65a.49.49 0 0 0 .52.61z"
/>
<path
  fill="#263238"
  d="M202.76 283.6h2.75a.51.51 0 0 0 .53-.48v-2.66a.51.51 0 0 0-.53-.48h-2a.52.52 0 0 0-.51.36l-.78 2.65a.49.49 0 0 0 .54.61z"
/>
<path
  fill="#263238"
  d="M199 283.6h2.76a.5.5 0 0 0 .52-.48v-2.66a.5.5 0 0 0-.52-.48h-2a.52.52 0 0 0-.51.36l-.77 2.65a.49.49 0 0 0 .52.61zm-3.85 0h2.75a.51.51 0 0 0 .53-.48v-2.66a.51.51 0 0 0-.53-.48h-2a.52.52 0 0 0-.51.36l-.78 2.65a.49.49 0 0 0 .54.61z"
/>
<path
  fill="#263238"
  d="M191.34 283.6h2.76a.5.5 0 0 0 .52-.48v-2.66a.5.5 0 0 0-.52-.48h-2a.52.52 0 0 0-.51.36l-.77 2.65a.49.49 0 0 0 .52.61z"
/>
<path
  fill="#263238"
  d="M187.54 283.6h2.75a.51.51 0 0 0 .53-.48v-2.66a.51.51 0 0 0-.53-.48h-2a.52.52 0 0 0-.5.36L187 283a.49.49 0 0 0 .54.6z"
/>
<path
  fill="#263238"
  d="M183.73 283.6h2.76a.5.5 0 0 0 .52-.48v-2.66a.5.5 0 0 0-.52-.48h-2a.52.52 0 0 0-.51.36l-.77 2.65a.49.49 0 0 0 .52.61z"
/>
<path
  fill="#263238"
  d="M179.93 283.6h2.75a.51.51 0 0 0 .53-.48v-2.66a.51.51 0 0 0-.53-.48h-2a.52.52 0 0 0-.5.36l-.78 2.65a.49.49 0 0 0 .53.61z"
/>
<path
  fill="#263238"
  d="M176.12 283.6h2.76a.5.5 0 0 0 .52-.48v-2.66a.5.5 0 0 0-.52-.48h-2a.52.52 0 0 0-.51.36l-.77 2.65a.49.49 0 0 0 .52.61z"
/>
<path
  fill="#263238"
  d="M172.32 283.6h2.75a.51.51 0 0 0 .53-.48v-2.66a.51.51 0 0 0-.53-.48h-2a.52.52 0 0 0-.5.36l-.78 2.65a.49.49 0 0 0 .53.61z"
/>
<path
  fill="#263238"
  d="M168.51 283.6h2.76a.5.5 0 0 0 .52-.48v-2.66a.5.5 0 0 0-.52-.48h-2a.52.52 0 0 0-.51.36L168 283a.49.49 0 0 0 .51.6z"
/>
<path
  fill="#263238"
  d="M165.74 283.88A2.2 2.2 0 0 0 168 286h57a2.2 2.2 0 0 0 2.29-2.09 2 2 0 0 0-.67-1.48 2.42 2.42 0 0 0-1.57-.61H168a2.59 2.59 0 0 0-.63.08 2.14 2.14 0 0 0-1.63 1.98z"
/>
<path
  fill="#fff"
  d="M165.74 283.88A2.2 2.2 0 0 0 168 286h57a2.2 2.2 0 0 0 2.29-2.09 2 2 0 0 0-.67-1.48 2.42 2.42 0 0 0-1.57-.61H168a2.59 2.59 0 0 0-.63.08 2.14 2.14 0 0 0-1.63 1.98z"
  opacity=".2"
/>
<path
  fill="#263238"
  d="M165.74 283.88A2.2 2.2 0 0 0 168 286h19.29a2.11 2.11 0 0 0 1.59-2 2.22 2.22 0 0 0 0-.37 2.06 2.06 0 0 0-.64-1.11 3.3 3.3 0 0 0-.49-.34l-.27-.12a2.37 2.37 0 0 0-.88-.16h-19.2a2.14 2.14 0 0 0-1.66 1.98zm178.99-38.4s7.36 91.55 7.42 92.07l4.66 54.58h10.13s.31-2.93.94-7.07c5.52-36.29 1.6-48.23 1.6-48.23s4.86-70.06 6.56-75.34c.17-.55-5.53-39-31.31-16.01z"
/>
<path
  d="M344.73 245.48s7.36 91.55 7.42 92.07l4.66 54.58h10.13s.31-2.93.94-7.07c5.52-36.29 1.6-48.23 1.6-48.23s4.86-70.06 6.56-75.34c.17-.55-5.53-39-31.31-16.01z"
  opacity=".2"
/>
<path fill="#263238" d="M344.79 244.21a32.66 32.66 0 0 0 14.09 19.09l7 4.43s36.43-35.11 4.46-42.81c-6.19-1.49-25.55 19.29-25.55 19.29z" />
<path fill="#ff8b7b" d="m436.1 383.17-6.36 4.29-5.95-7.64-6.44-8.27v-.01l7.48-5.13 1.02 1.51 5.01 7.46 5.24 7.79z" />
<path d="m430.86 375.38-7.07 4.44-6.44-8.27 7.66-4.81.84 1.18 5.01 7.46z" opacity=".2" />
<path
  fill="#263238"
  d="M394.07 279.57c.15 12.09 2.78 33.93 4.45 45.9 0 0 9 10.73 13.93 18.17L428 369.17l-9.56 6.2-30.44-32.8c-8.72-6.62-7.32-10.62-9.53-16.68-5.41-14.8-8.89-30.75-11.27-45.2-1.1-6.7-5.93-28.47-4.25-35 2.26-8.84 4.89-24.06 15.26-17.51 8.69 5.46 15.42 14.41 15.86 51.39z"
/>
<path d="m431.56 371.69-11.82 7.45-4.8-4.94 13.29-8.5 3.33 5.99z" />
<path
  fill="#263238"
  d="m428.49 387.73 4.81-8.43a.66.66 0 0 1 .85-.31l7.2 2.83a1.39 1.39 0 0 1 .73 1.82l-.07.13c-1.73 2.91-2.7 4.22-4.81 7.92-1.29 2.28-3.82 7.49-5.61 10.64s-5 1.54-4.53.07c2.08-6.58 1.75-10.27 1.21-13.19a2.18 2.18 0 0 1 .22-1.48z"
/>
<path
  d="M427.13 392.24c1-.35 1.76-2.25 2.06-3.34a.2.2 0 0 0-.07-.21.18.18 0 0 0-.22 0c-.32.17-3.07 1.61-3.17 2.69a.71.71 0 0 0 .29.65 1.69 1.69 0 0 0 .29.17 1.06 1.06 0 0 0 .82.04zm1.53-3c-.5 1.45-1.09 2.41-1.65 2.59a.8.8 0 0 1-.74-.18.25.25 0 0 1-.13-.27c.05-.58 1.43-1.53 2.52-2.14z"
/>
<path
  d="M429.1 389a.22.22 0 0 0 .1-.18.2.2 0 0 0-.12-.16c-.09-.06-2.25-1.27-3.43-.87a1.06 1.06 0 0 0-.65.61.72.72 0 0 0 .15.88 1.2 1.2 0 0 0 .21.13 5.4 5.4 0 0 0 3.74-.41zm-.55-.18c-1 .38-2.68.54-3.13.15-.07-.07-.15-.17-.05-.41a.68.68 0 0 1 .42-.39 4.67 4.67 0 0 1 2.7.62l.06.03z"
/>
<path
  fill="#ff8b7b"
  d="m324.66 281.35-6.72-.43s-4.71-33.86-5.16-35.21c-.62-2.46-4.39-21.34-5.88-26.16l.72-.11c-.8-2.48-.12-5.16 2.49-6s6.19.54 7 3c1.68 5 4.88 24 5.36 26.28a.88.88 0 0 1 0 .16c1.53 9.91 2.19 38.47 2.19 38.47z"
/>
<path
  fill="#ff8b7b"
  d="M324.66 281.35c0 3.08-2.8 4.67-4.82 4.88h-10.66l-.62-.15a.35.35 0 0 1-.14-.6l1.92-1.54c2.12-1.71 5-2.27 7.6-3l6.72.41z"
/>
<path d="M311.59 203.12c-10.91 5.25-3.29 27.12-3.29 27.12l13.41-1.24s1.33-15.86-.19-20.81c-1.61-5.19-4.71-8.48-9.93-5.07z" />
<path
  d="M315.63 229.55s-3-16-.06-19a8.76 8.76 0 0 1 2.87-1.42c3.59 1.55 2.85 6.72 2.85 6.72l.42 13.13c-1.71.27-6.08.57-6.08.57z"
  opacity=".2"
/>
<path
  d="M313.64 217.07c3.5 6.07 11 14.2 31 26.71l24.66-19c-8.29-9.91-13.46-16.51-23.58-37.9a7.6 7.6 0 0 0-5.09-4.23 7.5 7.5 0 0 0-5.48.83c-1.83 1.07-3.82 2.3-5.76 3.66a110.08 110.08 0 0 0-12.58 9.68c-2.76 2.55-5.52 5.47-7.49 7.61 0 0 0 .34.16 1.13a34.71 34.71 0 0 0 4.16 11.51z"
/>
<path
  d="M347.22 189.09c.33.85.66 1.71 1 2.46a101.64 101.64 0 0 0 5.63 11.36c-8 1.42-16.18-3-17.39-5.88-.77-1.75 6.76-6.77 10.76-7.94z"
  opacity=".2"
/>
<path
  d="m368.45 222.84 3.15 1.51c.25.12.2.49-.15.74l-26.72 20.39c-.25.19-.56.22-.69.08l-2.16-2.29c-.15-.15 0-.46.23-.68L367.83 223a.64.64 0 0 1 .62-.16z"
/>
<path
  fill="#fff"
  d="m368.45 222.84 3.15 1.51c.25.12.2.49-.15.74l-26.72 20.39c-.25.19-.56.22-.69.08l-2.16-2.29c-.15-.15 0-.46.23-.68L367.83 223a.64.64 0 0 1 .62-.16z"
  opacity=".6"
/>
<path d="M342.11 242.59 367.83 223" />
<path
  fill="#263238"
  d="m367.08 228.86.72-.57c.16-.11.21-.28.13-.36l-2.84-3c-.08-.09-.27-.07-.42.05l-.72.56c-.15.12-.2.28-.12.37l2.83 2.95a.32.32 0 0 0 .42 0zm-19.99 15.28.72-.57c.15-.11.21-.28.12-.37l-2.83-2.94a.34.34 0 0 0-.43.05l-.72.56c-.15.12-.21.29-.13.37l2.84 2.95c.08.09.27.07.43-.05z"
/>
<path
  fill="#ff8b7b"
  d="M317.22 173.92c2.33 4.66 7.24 12.69 12.15 13.22 0 0 2.86 7.05-2.5 20.08-11.58-2.47-10.08-10.4-10.08-10.4 3.69-4.56 1-7.81-2.22-10.35l2.65-12.55z"
/>
<path
  d="m327.68 208.74.41-1c5.5-13.38 2.68-21.14 2.55-21.45l-2.8.47.3.88c0 .07 2.41 6.44-2.07 18-8.95-2.37-8.43-9.88-8.38-10.14l-2 2.21c0 .09-1.83 8.06 10.87 10.77l1.12.26z"
/>
<path
  fill="#fff"
  d="m327.68 208.74.41-1c5.5-13.38 2.68-21.14 2.55-21.45l-2.8.47.3.88c0 .07 2.41 6.44-2.07 18-8.95-2.37-8.43-9.88-8.38-10.14l-2 2.21c0 .09-1.83 8.06 10.87 10.77l1.12.26z"
  opacity=".6"
/>
<path d="M316.93 175.29a21.28 21.28 0 0 1 3.67 8.24c.41 2.06-.79 6.27-3 6a14 14 0 0 0-3-3.08l2.33-11.16z" opacity=".2" />
<path fill="#263238" d="M303.29 197.51c-9.28-7.71-11.9-18.41-12-27.95 0-1.8.37-7.61 2.17-7.71 13.9-.8-1.84 13.15 9.83 35.66z" />
<path
  fill="#ff8b7b"
  d="M314.74 165.12c4.54 6.93 6.61 9.77 5.79 15.67-1.22 8.87-10.72 12.93-17.22 7.49-5.87-4.9-12.31-15.42-7.78-22.9a11.29 11.29 0 0 1 19.21-.26z"
/>
<path fill="#263238" d="M306.43 185.58s1.12-2.25 5.79-7.31c1.45 2.19 2 4.59-.36 7.19-1 1.43-3.34 1.58-5.14.34a3.15 3.15 0 0 1-.29-.22z" />
<path
  fill="#ff5652"
  d="M311.37 183a5.28 5.28 0 0 0-1.63 3.62 3.45 3.45 0 0 0 2.08-1.15 5.16 5.16 0 0 0 1.63-3.61 3.43 3.43 0 0 0-2.08 1.14z"
/>
<path
  fill="#fff"
  d="M306.59 185.31a1.73 1.73 0 0 0 1.71 0 29.87 29.87 0 0 0 3.63-4.9 1.85 1.85 0 0 0 .06-1.93 45.42 45.42 0 0 0-5.4 6.83z"
/>
<path fill="#ff5652" d="M302.23 178.73a18.88 18.88 0 0 1 .22 5.09 3 3 0 0 0 2.35-.91l-2.57-4.18z" />
<path
  fill="#263238"
  d="M304.77 171.79a.35.35 0 0 1-.2 0 3.13 3.13 0 0 0-2.82.47.39.39 0 0 1-.55-.05.37.37 0 0 1 0-.54 3.93 3.93 0 0 1 3.55-.62.43.43 0 0 1 .28.5.44.44 0 0 1-.26.24zm-9.24 6.99h-.07a.42.42 0 0 1-.42-.38 3.91 3.91 0 0 1 1.42-3.33.39.39 0 0 1 .55.08.42.42 0 0 1-.08.56 3.09 3.09 0 0 0-1.09 2.64.41.41 0 0 1-.31.43zm10.1-4.24c.4.54.47 1.18.09 1.46s-1 0-1.38-.51-.47-1.17-.09-1.45.97-.04 1.38.5zm-6.29 4.46c.4.54.48 1.18.09 1.46s-1 0-1.36-.51-.48-1.18-.09-1.46.96 0 1.36.51z"
/>
<path fill="#263238" d="m298.16 178.44-1.59.64s1.43.47 1.59-.64zm6.28-4.44-1.58.64s1.42.43 1.58-.64z" />
<path
  fill="#263238"
  d="M317.2 169.69c3.78 1.49 3.33 11.1 3.33 11.1-.15.37 4.12-5.31 1.72-18.62-1.6-8.87-16.92-11.75-28.24-1.12-2.22 2.07-.89 14.12 0 11.94 1-2.63 7.8-7.65 12-8.73-.44-.26 8.99 4.55 11.19 5.43z"
/>
<path
  fill="#263238"
  d="M316.43 162a4.59 4.59 0 0 0 .91-7.32 8.73 8.73 0 0 0-3.74-1.79 11.94 11.94 0 0 1-3.86-1.55c-1.12-.83-1.44-1.87-1.55-3.62a3.81 3.81 0 0 0-1.19 2.75c-1-.75-1.17-1.84-1.56-4.26a5.07 5.07 0 0 0-.51 4.17c-.74-.29-1.22-.82-1.55-3.17-1.23 3-.45 5.63.18 6.07a3.54 3.54 0 0 0-3.44 3 5.13 5.13 0 0 0 1.7 4.46 9.63 9.63 0 0 0 4.43 2.15 17.46 17.46 0 0 0 9.89-.63c0-.26.29-.26.29-.26z"
/>
<path
  fill="#ff8b7b"
  d="M321.86 168a6.11 6.11 0 0 1 .65 4.58c-.54 2.06-2.65 2-4 .54s-2.44-4-1.16-5.6a2.72 2.72 0 0 1 3.83-.39 2.8 2.8 0 0 1 .68.87zm-11.49 38.51-8.69 1.15.12 7.66s5.92-1.29 8.33-4.41l.24-4.4z"
/>
<path fill="#ff8b7b" d="m296.61 211.07-.4 5.66 5.59-1.41-.12-7.66-5.07 3.41z" />
<path d="M301.26 214.55a.51.51 0 0 0-.15.15l.15-.15z" opacity=".2" />
<path
  fill="#ff8b7b"
  d="M346.57 191.88c1.34 5.66 1.05 16.29.87 20.52a8.19 8.19 0 0 1-2.19 5.35c-1.66 1.73-4.46 3-9 1.09s-26.26-6.77-26.21-7.9l.22-4.37s13.17.42 27.3 2c.63-6.61-.64-15-.06-17.23.97-3.66 7.37-6.63 9.07.54z"
/>
<path d="M337.82 182.61c-3 2.2-3.37 18.83-3.37 18.83l15.32.31s0-11.09-1.3-14.34c-2.02-5.25-7.29-7.27-10.65-4.8z" />
<path fill="#ff8b7b" d="m366.2 405.84-7.8-.74-1.06-15.98 9.54-.49-.68 17.21z" />
<path d="m357.37 388.82.54 9.04 8.63-.6.58-8.72-9.75.28z" opacity=".2" />
<path
  fill="#263238"
  d="m356.83 402.81 10.19-.69a.88.88 0 0 1 .85.57l2.76 7.91a1.25 1.25 0 0 1-1.13 1.69c-3.58.18-5.29.09-9.81.4-2.76.19-9.86.95-13.67 1.21s-4.77-3.46-3.24-3.91c6.8-2 10.64-4.37 12.64-6.52a2 2 0 0 1 1.41-.66z"
/>
<path
  d="M355.71 404.29a.19.19 0 0 0 .14-.19.2.2 0 0 0-.13-.19c-.73-.25-4.35-1.45-5.21-.73a.57.57 0 0 0-.19.58 1.23 1.23 0 0 0 .62.91 3.31 3.31 0 0 0 2 .28 13 13 0 0 0 2.77-.66zm-4.55-.93a12.69 12.69 0 0 1 3.82.74c-1.78.54-3.19.63-3.83.24a.83.83 0 0 1-.43-.64.19.19 0 0 1 .06-.2.72.72 0 0 1 .38-.13v-.01z"
/>
<path
  d="M355.8 404.26a.21.21 0 0 0 0-.2c0-.16-1.31-3.73-3.29-3.28-.52.11-.66.39-.63.6 0 1 2.47 2.59 3.67 2.93h.08a.29.29 0 0 0 .17-.05zm-3-3.13c1.25-.13 2.16 1.78 2.52 2.59-1.24-.49-3-1.78-3-2.34 0-.11.1-.21.32-.23h.13l.03-.02zm16.75-6.59-14.6.72-1.62-6.45 16.96-1.1-.74 6.83z"
/>
<path fill="#ffc3bd" d="m184.08 405.23-7.36-1.68 3.63-16.36 9.81 3.39-6.08 14.65z" />
<path d="m192.43 384.9-10.73-4.23-2.34 10.99 9.09 2.86 3.98-9.62z" opacity=".2" />
<path fill="#ffc3bd" d="m214.6 405.23-7.47-1.05 3.07-19.33 10.06 2.55-5.66 17.83z" />
<path d="m222.03 381.54-11.05-3.3-1.72 12.33 9.49 1.68 3.28-10.71z" opacity=".2" />
<path
  d="M259.11 295.28s-42.55 4.94-44.46 22.53c-1.9 22.93-.79 16.44-6 69.43l12.61.7s12.83-43.34 11.1-60.56c14.13 0 46.48 1.24 51.18-11.51a56.76 56.76 0 0 0 3.35-20.2l-27.78-.39z"
/>
<path
  d="M259.11 295.28s-42.55 4.94-44.46 22.53c-1.9 22.93-.79 16.44-6 69.43l12.61.7s12.83-43.34 11.1-60.56c14.13 0 46.48 1.24 51.18-11.51a56.76 56.76 0 0 0 3.35-20.2l-27.78-.39z"
  opacity=".2"
/>
<path
  fill="#263238"
  d="m221.56 390.08-14.43-2.47.5-6.94 16.5 3.39-2.57 6.02zm-14.24 10.39 8.42 1.66a.64.64 0 0 1 .48.71l-.7 8a1.4 1.4 0 0 1-1.54 1.31c-2.92-.63-4.3-1.11-8-1.84-2.28-.45-7.49-1.55-10.66-1.9s-2.79-4.06-1.42-4.25c6.16-.82 9.66-1.81 12-3.36a1.85 1.85 0 0 1 1.42-.33z"
/>
<path
  d="M203.54 401.91a9.54 9.54 0 0 0 2 .06.15.15 0 0 0 .15-.11.21.21 0 0 0 0-.19c-.21-.21-2.1-2-3.07-1.8a.62.62 0 0 0-.49.42 1 1 0 0 0 .06 1 2 2 0 0 0 1.35.62zm1.61-.27c-1.39 0-2.37-.16-2.66-.57a.61.61 0 0 1 0-.64.32.32 0 0 1 .23-.22c.51-.11 1.65.73 2.43 1.43z"
/>
<path
  d="M205.55 402h.08a.2.2 0 0 0 .12-.13c0-.09.55-2.22-.09-3.07a.85.85 0 0 0-.7-.37.67.67 0 0 0-.72.42c-.31.79.55 2.54 1.22 3.11a.11.11 0 0 0 .09.04zm-.52-3.21a.51.51 0 0 1 .35.22 4 4 0 0 1 .09 2.46 3.56 3.56 0 0 1-.9-2.49c0-.1.11-.21.37-.2l.09.01zm39.16-103.51c-.33 0-56.2 5.75-56.27 24.7-2.15 14-9.07 67.26-9.07 67.26l11.81 3.86s18.46-37.33 18.17-61.76c15.37-4.41 55.13 3 59.83-9.74 3.85-10.42 1.77-24.32 1.77-24.32h-26.24z"
/>
<path
  fill="#263238"
  d="m191.35 392.47-13.98-4.59 1.19-6.06 15.61 5.32-2.82 5.33zm-14.14 7.08 8.44 1.76a.69.69 0 0 1 .47.77l-.66 8.76c-.12 1-.8 1.6-1.53 1.45-2.92-.67-4.3-1.19-8-2-2.28-.47-8.49-2-11.62-2.79s-2.43-4.81-1-4.83c6.19-.09 10.2-1.11 12.58-2.83a1.68 1.68 0 0 1 1.32-.29z"
/>
<path
  d="M173.74 401.44a9.83 9.83 0 0 0 1.65-1.13.2.2 0 0 0 .06-.19.18.18 0 0 0-.15-.12c-.29-.05-2.87-.38-3.54.36a.69.69 0 0 0-.14.63 1 1 0 0 0 .64.78 2.1 2.1 0 0 0 1.48-.33zm1.13-1.17c-1.09.86-2 1.27-2.47 1.12a.64.64 0 0 1-.39-.52.32.32 0 0 1 .07-.31c.35-.35 1.75-.38 2.79-.29z"
/>
<path
  d="m175.39 400.31.07-.06a.15.15 0 0 0 0-.16c0-.07-.88-2.12-1.89-2.43a.86.86 0 0 0-.78.12.67.67 0 0 0-.33.77c.21.82 1.94 1.72 2.83 1.78l.1-.02zm-2.33-2.31a.52.52 0 0 1 .42 0 4 4 0 0 1 1.54 1.93 3.6 3.6 0 0 1-2.21-1.47c-.06-.08 0-.24.18-.38l.07-.08z"
/>
<path
  fill="#ffc3bd"
  d="M273.12 242.05a110.07 110.07 0 0 1 2.16 27.32 8 8 0 0 1-5.35 7.24c-10.69 3.67-38.38 5.06-47.34 3.93l3.63-3.83s38-7.42 37.09-10.39c0 0-1.8-19-3-21.78l12.81-2.49z"
/>
<path fill="#ffc3bd" d="m227 276.79-6.44-4.21-6.67 4.52s5.08 4.37 9.87 3.25l3.24-3.56z" />
<path fill="#ffc3bd" d="m214.68 274.05-3.51 2.71a.39.39 0 0 0 .2.69l4.14.39 5-5.26-5.83 1.47z" />
<path
  fill="#ffc3bd"
  d="M244 236.94a5.81 5.81 0 0 1 4.32 7.09c-.34 1.36-11.19 26.72-11.72 27.57-3.58 8.76-9.92 8.18-18.59 8.48-6.88-.08-12 .5-18.74-1l1.65-3.6c4.75-.2 14.82-3.69 20.73-5.35a8 8 0 0 0 5.27-4.12c2.79-6 9.22-21.29 10.14-24.9a5.81 5.81 0 0 1 6.94-4.21v.04z"
/>
<path fill="#ffc3bd" d="m201.23 275.53-5.52-2.42-4.63 5.38s7.41 2.36 8.7.1l1.45-3.06z" />
<path
  fill="#ffc3bd"
  d="m189 277.63-1.36 1.28a.48.48 0 0 0 .5.79l3-1.21 4.63-5.38-4.88 3.08a12.33 12.33 0 0 0-1.89 1.44zm60.83-71.84 5.77 3.59 8.56 4.68a46.56 46.56 0 0 0 .53 6.47c.69 2.72 1.66 4.91 6.46 5.41 0 0 6.25 4.42-4.82 6.1s-14.36-3.3-14.36-3.3c3.64-4.74.15-16.9-2.14-22.95z"
/>
<path
  fill="#263238"
  d="M269.82 194.11c.2.66.71 1.12 1.15 1s.64-.75.44-1.41-.72-1.11-1.16-1-.63.75-.43 1.41zm-3.04-1.51a.36.36 0 0 0 .29-.25 3.42 3.42 0 0 1 2.18-2.07.41.41 0 0 0-.18-.8 4.23 4.23 0 0 0-2.76 2.58.42.42 0 0 0 .23.53.49.49 0 0 0 .24.01z"
/>
<path fill="#ed847e" d="M270.29 194.79a22.37 22.37 0 0 0 3.9 4.4 3.37 3.37 0 0 1-2.66 1.05l-1.24-5.45z" />
<path
  fill="#ffc3bd"
  d="M246.73 198.08c2.93 8 4.26 12.93 9.67 16a11.1 11.1 0 0 0 7.78 1.34 11.37 11.37 0 0 0 4.35-1.87 11.19 11.19 0 0 0 4.61-9.85c-.4-7.84-5.14-19.7-14.14-20.85a11.25 11.25 0 0 0-12.24 15.23h-.03z"
/>
<path d="M264.18 215.4a11.37 11.37 0 0 0 4.35-1.87c-.22.08-3 1.09-4.45.35l.1 1.52z" opacity=".2" />
<path
  fill="#263238"
  d="M242.86 204.75A61.87 61.87 0 0 0 253 216.32c2.82-.85 5.28-1.33 8.16-2 1.12-3.24 1.36-13.39 2.43-15.12s3.25-4 4.19-5.78a8 8 0 0 0-.6-7.91 10.86 10.86 0 0 0-6.83-4.37 15.55 15.55 0 0 0-13.43 3.68 8.46 8.46 0 0 0-3 5c-3.92 2.63-5.06 8.86-1.06 14.93z"
/>
<path fill="#263238" d="M243.47 185.71a9.93 9.93 0 0 0 .33 4.09 2.49 2.49 0 0 1-1.76-2.2c-.04-1 .51-1.49 1.43-1.89z" />
<path fill="#ffc3bd" d="M261 199.86a10 10 0 0 0 4.31 4.52c2.35 1.17 3.35-1 2.55-3.68-.74-2.38-2.81-5.88-5.14-5.92s-2.9 2.61-1.72 5.08z" />
<path
  fill="#263238"
  d="M283.78 228.44c-.75-2-4.49-4.37-8-4h-2.33a41.17 41.17 0 0 0-6.09.55 150 150 0 0 0-17 2.86c-2.58.68-5.07 1.54-7 2.28-2-.59-.19 16.86.19 38.31.18 10.19.46 20.26.72 27.2h42.66s-.58-12.89-.46-27.95c.05-9.04.4-31.02-2.69-39.25z"
/>
<path d="M242.6 258.24c.32 3.83.65 7.85 1 11.87 4.41-14.44 7.23-28.94 7.23-28.94l-8.23 17.07z" opacity=".2" />
<path
  fill="#263238"
  d="M239.34 231.8c-5.49 4.36-10.92 25.7-10.92 25.7l13.08 6.94c4.48-5.83 11.54-18.73 11.59-23.81.14-7.81-6.76-13.56-13.75-8.83zm-10.49 179.53a4.35 4.35 0 1 1-4.35-4.33 4.34 4.34 0 0 1 4.35 4.35v-.02zm64.89 0a4.35 4.35 0 1 0 4.35-4.35 4.35 4.35 0 0 0-4.35 4.35zm-36.68-1.39a4.35 4.35 0 1 0 4.35-4.35 4.35 4.35 0 0 0-4.35 4.35z"
/>
<path
  fill="#263238"
  d="M303.87 404.49a2 2 0 0 1-2 1.7l-41.67-.62-39 1a2 2 0 0 1-2-1.7 2.12 2.12 0 0 1 1.53-2.48l21.31-4.51a33.7 33.7 0 0 1 6.7-.68h22.9a33.38 33.38 0 0 1 6.69.68l24 4.17a2.11 2.11 0 0 1 1.54 2.44zm-50.33-45.83h15.43v38.51h-15.43z"
/>
<path d="M255.76 340.74h11v17.91h-11z" />
<path d="M255.76 340.74h11v17.91h-11z" opacity=".2" />
<path d="M255.76 340.74h11v17.91h-11z" opacity=".5" />
<path d="m255.76 346 11 2.77v-8.03h-11V346z" opacity=".5" />
<path d="M218.51 300.22h5.59v23.85h-5.59z" />
<path d="M218.51 300.22h5.59v23.85h-5.59z" opacity=".5" />
<path d="M252.13 340.74v-96.92a13.61 13.61 0 0 1 4.65-10.25l7.39-6.47a13.63 13.63 0 0 1 9-3.37h13.59l13 13.88v103.13h-47.63z" />
<path d="M212.38 320.68h60.9v20.06h-70.82a7.21 7.21 0 0 1-6.2-10.87 18.72 18.72 0 0 1 16.12-9.19z" />
<path
  fill="#fff"
  d="M299.78 237.62v103.13h-97.32a7.21 7.21 0 0 1-6.2-10.87 18.71 18.71 0 0 1 16.09-9.19H243a9.11 9.11 0 0 0 9.11-9.11v-67.76a13.58 13.58 0 0 1 4.65-10.24l7.39-6.47a13.58 13.58 0 0 1 9-3.37h13.59l13.04 13.88z"
  opacity=".7"
/>
<path
  d="M261 340.74v-96.92a13.64 13.64 0 0 1 4.65-10.25l7.39-6.47a13.63 13.63 0 0 1 9-3.37h7.7a13.63 13.63 0 0 1 9.93 4.29l5.31 5.66a13.6 13.6 0 0 1 3.7 9.33v87.35a10.38 10.38 0 0 1-10.38 10.38H261z"
/>
<path
  fill="#fff"
  d="M261 340.74v-96.92a13.64 13.64 0 0 1 4.65-10.25l7.39-6.47a13.63 13.63 0 0 1 9-3.37h7.7a13.63 13.63 0 0 1 9.93 4.29l5.31 5.66a13.6 13.6 0 0 1 3.7 9.33v87.35a10.38 10.38 0 0 1-10.38 10.38H261z"
  opacity=".5"
/>
<path
  d="M240.29 307.3a57.71 57.71 0 0 0-38 0 5.39 5.39 0 0 1-6.69-2.55c-1.14-2.41.39-5.53 3.49-6.62a67.27 67.27 0 0 1 44.38 0c3.1 1.08 4.63 4.21 3.49 6.62a5.4 5.4 0 0 1-6.67 2.55z"
/>
<path
  fill="#fff"
  d="M240.29 307.3a57.71 57.71 0 0 0-38 0 5.39 5.39 0 0 1-6.69-2.55c-1.14-2.41.39-5.53 3.49-6.62a67.27 67.27 0 0 1 44.38 0c3.1 1.08 4.63 4.21 3.49 6.62a5.4 5.4 0 0 1-6.67 2.55z"
  opacity=".7"
/>
<path
  fill="#fff"
  stroke="null"
  d="m295.874 126.64 41.177-.42a5.585 5.585 0 0 0 5.585-5.495V78.486a3.579 3.579 0 0 0 0-.794 5.495 5.495 0 0 0-5.51-4.641l-91.771.554a5.57 5.57 0 0 0-5.57 5.51v42.224a3.579 3.579 0 0 0 0 .794 5.495 5.495 0 0 0 5.51 4.641h37.253l7.382 23.119 5.944-23.253z"
/>
<path
  stroke="null"
  d="m290.065 153.21-8.01-25.08h-36.7a5.99 5.99 0 0 1-6.304-6.199v-42.21a6.364 6.364 0 0 1 6.289-6.258l91.8-.554a6.274 6.274 0 0 1 6.26 5.285 4.672 4.672 0 0 1 0 .914v42.224a6.364 6.364 0 0 1-6.304 6.244l-40.623.404-6.408 25.23zm-6.918-26.577 6.738 21.157 5.435-21.232 41.76-.42a4.836 4.836 0 0 0 4.837-4.776v-42.21a3.489 3.489 0 0 0 0-.688 4.746 4.746 0 0 0-4.747-3.998l-91.74.57a4.821 4.821 0 0 0-4.821 4.776v42.209a2.62 2.62 0 0 0 0 .689 4.732 4.732 0 0 0 4.731 3.998l37.807-.075z"
/>
<g stroke="null">
  <path
    fill="#fff"
    d="m347.87 126.43 41.85-.37a3.66 3.66 0 0 1 3.67 3.1 3.23 3.23 0 0 1 0 .53l-.05 28.2a3.73 3.73 0 0 1-3.72 3.68l-26.52.28c-5.69 8.15-15.1 9.44-15.1 9.44s5.31-5.39 6.28-9.39h-6.42a3.68 3.68 0 0 1-3.68-3.1 4.84 4.84 0 0 1 0-.53v-28.2a3.73 3.73 0 0 1 3.69-3.64z"
  />
  <path
    d="m346.57 172 1-1.05c.05-.05 4.68-4.79 6-8.53h-5.75a4.17 4.17 0 0 1-4.17-3.53 3.18 3.18 0 0 1 0-.61v-28.19a4.25 4.25 0 0 1 4.2-4.18l41.85-.37a4.1 4.1 0 0 1 4.22 4.14l-.05 28.2a4.25 4.25 0 0 1-4.21 4.17l-26.27.27a24.7 24.7 0 0 1-15.39 9.46l-1.43.22zm8.3-10.59-.15.62c-.72 3-3.67 6.61-5.31 8.44a23.82 23.82 0 0 0 13.32-8.9l.15-.21 26.77-.28a3.21 3.21 0 0 0 3.23-3.19l.05-28.19a3.44 3.44 0 0 0 0-.46 3.15 3.15 0 0 0-3.16-2.67l-41.86.37a3.22 3.22 0 0 0-3.23 3.19v28.19a3.44 3.44 0 0 0 0 .46 3.17 3.17 0 0 0 3.16 2.67l7.03-.04z"
  />
</g>
<path
  stroke="null"
  d="M349.86 139.47h15.15v1h-15.15zm4.72-7.38h27.66v1h-27.66zm13.21 7.38h19.38v1h-19.38zm-20.63 7.38h38.5v1h-38.5zm.16 7.38h10v1h-10z"
/>
<image
  xlink:href="data:image/png;base64,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"
  width="80.28"
  height="31.861"
  x="130.387"
  y="206.712"
  stroke="null"
  href="data:image/png;base64,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"
/>
`,
];

export const integrationMan = [
  '500 500',
  `
<path
  fill="#ebebeb"
  d="M416.78 398.49h33.12v.25h-33.12zM322.53 401.21h8.69v.25h-8.69zM396.59 389.21h19.19v.25h-19.19zM52.46 390.89h43.19v.25H52.46zM104.56 390.89h6.33v.25h-6.33zM131.47 395.11h93.68v.25h-93.68z"
/>
<path fill="#e6e6e6" d="M377.16 376.54h-81.48v-75.92h81.48z" />
<path fill="#e0e0e0" d="M374.6 382.57h-10.4v-3.63h10.4z" />
<path
  fill="#e6e6e6"
  d="M295.69 375.81H130.24v-75.19h165.45zM128 382.57h-25.4v-87.54H128z"
/>
<path
  fill="#f5f5f5"
  d="M287.62 372.3h-71.73v-65.69h71.73zM369.41 372.3h-71.73v-65.69h71.73zM205.05 372.3h-71.73v-65.69h71.73z"
/>
<path
  fill="#f0f0f0"
  d="M127.88 295v87.54h5.54v-2.08h241.16v2.08h5.55V295H127.88zm246.7 39.64h-76.21v-31.41h76.21v31.41zm-76.21 37.66v-32.95h76.21v32.95h-76.21zm-82.48-69.07h76.93v69.07h-76.93v-69.07zm-82.47 36.12h76.93v32.95h-76.93v-32.95zm0-36.12h76.93v31.44h-76.93v-31.44z"
/>
<path
  fill="#e6e6e6"
  d="M327.54 315.29h12a2.33 2.33 0 0 0 2.34-2.33 2.33 2.33 0 0 0-2.34-2.33h-12a2.33 2.33 0 0 0-2.33 2.33 2.33 2.33 0 0 0 2.33 2.33zM226.21 344.22v-12a2.33 2.33 0 0 0-2.33-2.33 2.33 2.33 0 0 0-2.34 2.33v12a2.33 2.33 0 0 0 2.34 2.33 2.33 2.33 0 0 0 2.33-2.33zM327.54 349h12a2.33 2.33 0 0 0 2.34-2.33 2.34 2.34 0 0 0-2.34-2.34h-12a2.33 2.33 0 0 0-2.33 2.34 2.33 2.33 0 0 0 2.33 2.33zM163.19 315.29h12a2.33 2.33 0 0 0 2.33-2.33 2.33 2.33 0 0 0-2.33-2.33h-12a2.33 2.33 0 0 0-2.33 2.33 2.33 2.33 0 0 0 2.33 2.33zM163.19 349h12a2.33 2.33 0 0 0 2.33-2.33 2.33 2.33 0 0 0-2.33-2.34h-12a2.33 2.33 0 0 0-2.33 2.34 2.33 2.33 0 0 0 2.33 2.33z"
/>
<path fill="#e0e0e0" d="M94.66 380.84H70.94V159.1h23.72z" />
<path
  fill="#e6e6e6"
  d="M52.46 157.16v225.62h18.47V157.16H52.46zM93.77 157.16v225.62h18.48V157.16H93.77z"
/>
<path
  fill="#f5f5f5"
  d="M68.72 157.16v225.62h46.66V157.16H68.72zm42.28 3.89v40.45H73.15v-40.45H111zM73.15 290.2v-40.46H111v40.46H73.15zm37.8 3.89v40.46h-37.8v-40.46h37.8zm-37.8-48.24V205.4H111v40.45H73.15zm0 133v-40.41H111v40.45l-37.85-.04z"
/>
<path fill="#ebebeb" d="M86.28 170.48h5.51v31.39h-5.51z" />
<path fill="#e6e6e6" d="M82.02 170.48h4.26v31.39h-4.26z" />
<path fill="#e0e0e0" d="M91.79 171.23h8.52v30.65h-8.52z" />
<path
  fill="#ebebeb"
  d="M100.31 171.23h4.26v30.65h-4.26zM73.49 171.23h5.68v30.65h-5.68z"
/>
<path fill="#fafafa" d="M79.18 171.23h2.84v30.65h-2.84z" />
<path fill="#e6e6e6" d="M91.79 245.84h-5.51v-31.39h5.51z" />
<path
  fill="#ebebeb"
  d="M96.05 245.84h-4.26v-31.39h4.26zM86.28 245.83h-8.52v-30.65h8.52z"
/>
<path fill="#e0e0e0" d="M77.76 245.83H73.5v-30.65h4.26z" />
<path fill="#ebebeb" d="M104.58 245.83H98.9v-30.65h5.68z" />
<path fill="#f0f0f0" d="M98.89 245.83h-2.84v-30.65h2.84z" />
<path fill="#e6e6e6" d="M91.79 290.57h-5.51v-31.39h5.51z" />
<path
  fill="#ebebeb"
  d="M96.05 290.57h-4.26v-31.39h4.26zM86.28 290.57h-8.52v-30.65h8.52z"
/>
<path fill="#e0e0e0" d="M77.76 290.57H73.5v-30.65h4.26z" />
<path fill="#ebebeb" d="M104.58 290.57H98.9v-30.65h5.68z" />
<path fill="#f0f0f0" d="M98.89 290.57h-2.84v-30.65h2.84z" />
<path fill="#ebebeb" d="M86.28 303.92h5.51v31.39h-5.51z" />
<path fill="#e6e6e6" d="M82.02 303.92h4.26v31.39h-4.26z" />
<path fill="#e0e0e0" d="M91.79 303.92h8.52v30.65h-8.52z" />
<path
  fill="#ebebeb"
  d="M100.31 303.92h4.26v30.65h-4.26zM73.49 303.92h5.68v30.65h-5.68z"
/>
<path fill="#fafafa" d="M79.18 303.92h2.84v30.65h-2.84z" />
<path fill="#e6e6e6" d="M91.79 380.04h-5.51v-31.39h5.51z" />
<path
  fill="#ebebeb"
  d="M96.05 380.04h-4.26v-31.39h4.26zM86.28 379.3h-8.52v-30.65h8.52z"
/>
<path fill="#e0e0e0" d="M77.76 379.3H73.5v-30.65h4.26z" />
<path fill="#fafafa" d="M104.58 379.3H98.9v-30.65h5.68z" />
<path fill="#f0f0f0" d="M98.89 379.3h-2.84v-30.65h2.84z" />
<path
  fill="#ebebeb"
  d="M408.88 335.9c-.1.11.44.85-1.74.53-5.35-.81-14.69-3-17.28-8.49-3.71-7.87 7.79-5 7.39-9s-13.48-3.33-14.87-9.23 7.49-3.09 7.6-6-10.11-1.09-12.14-7.45 5.7-1.68 4.82-4.33-9.54-14.62-4.84-16 12.64 10.9 15.7 12.64 5.78-8.29 9.43-4.06-2.14 19.05 2.51 21.93c3.47 2.14 2.49-3.76 7.06-2.66 6.22 1.5 4.13 23.43-3.64 32.12z"
/>
<path
  fill="#f5f5f5"
  d="M392.34 303.76a17.81 17.81 0 0 1 4.63.95 33.82 33.82 0 0 0-3.29-4.23.41.41 0 0 1 0-.57.4.4 0 0 1 .56 0 46.56 46.56 0 0 1 6.6 9.57 35.25 35.25 0 0 0-2.61-19.12.3.3 0 0 1 .54-.26c0 .1 4.58 9.57 2.52 20.22.55 1.05 1.1 2.16 1.65 3.36a76.33 76.33 0 0 1 4.53 13.32 27.37 27.37 0 0 0 3.16-12.11.29.29 0 0 1 .3-.29.29.29 0 0 1 .29.3 27.37 27.37 0 0 1-3.55 12.94 92.4 92.4 0 0 1 2 27.36.41.41 0 0 1-.43.37h-.05a.39.39 0 0 1-.31-.42 87.56 87.56 0 0 0-4.11-34.42 10.91 10.91 0 0 0-6.33-3.62.3.3 0 0 1-.25-.34.29.29 0 0 1 .34-.24 11.19 11.19 0 0 1 5.78 2.87 66.45 66.45 0 0 0-6.77-13.76 16.19 16.19 0 0 0-5.27-1.24.31.31 0 0 1-.27-.4.29.29 0 0 1 .34-.24z"
/>
<path
  fill="#e0e0e0"
  d="M415.75 338.94c4.45.08 12.05-4.05 15-8.07s-5.49-1.55-4.62-4.76 11.38-.84 13.32-5.43-5.64-3.53-5.34-5.88 8.16-1.87 10.68-6.75-4.39-2.15-3.3-4.17 9.74-10.54 6.12-12.31-11.75 7.09-14.47 8.08-3.35-5.13-6.89-2.2-.89 15.73-5.06 17.42c-3.1 1.26-1.78-4.61-5.35-3.13-6.21 2.59-1.9 27.16-.09 27.2z"
/>
<path
  fill="#ebebeb"
  stroke="null"
  d="M415.75 338.94c4.45.08 12.05-4.05 15-8.07s-5.49-1.55-4.62-4.76 11.38-.84 13.32-5.43-5.64-3.53-5.34-5.88 8.16-1.87 10.68-6.75-4.39-2.15-3.3-4.17 9.74-10.54 6.12-12.31-11.75 7.09-14.47 8.08-3.35-5.13-6.89-2.2-.89 15.73-5.06 17.42c-3.1 1.26-1.78-4.61-5.35-3.13-6.21 2.59-1.9 27.16-.09 27.2z"
  opacity=".3"
/>
<path
  fill="#f5f5f5"
  d="M417.22 333.59a.23.23 0 0 1-.16-.13 23.24 23.24 0 0 1-2-11.93.3.3 0 0 1 .32-.28.31.31 0 0 1 .28.32 23.67 23.67 0 0 0 1.8 11.35 91.06 91.06 0 0 1 6.78-14.35 31.31 31.31 0 0 1 4.16-17.46.3.3 0 0 1 .5.32 31 31 0 0 0-4.12 16.22 83.27 83.27 0 0 1 11.38-15.22.4.4 0 0 1 .56 0 .39.39 0 0 1 0 .56A77.93 77.93 0 0 0 428 314a23.39 23.39 0 0 1 8.42-1.49.31.31 0 0 1 .29.31.3.3 0 0 1-.3.29 22.8 22.8 0 0 0-9 1.75 94.58 94.58 0 0 0-4.85 8.33 10.08 10.08 0 0 1 8.31-1.46.29.29 0 0 1 .21.36.28.28 0 0 1-.36.21 9.56 9.56 0 0 0-8.78 2.13 80.39 80.39 0 0 0-8.63 32.64.4.4 0 0 1-.4.38.39.39 0 0 1-.38-.41 78.49 78.49 0 0 1 4.69-23.45z"
/>
<path
  fill="#f0f0f0"
  d="M403.22 382.43c-4.25-8-7-19.54-7-24.6a14.11 14.11 0 0 1 5.19-10.8h21.77a14.1 14.1 0 0 1 5.18 10.8c0 5.06-2.79 16.61-7 24.6h-18.14zM366 227.14v-.77l1.51-.84a11.29 11.29 0 0 0-.56-2.09h-1.73a8.46 8.46 0 0 0-.77-1.34l.89-1.47a10.19 10.19 0 0 0-1.54-1.54l-1.47.89a8.46 8.46 0 0 0-1.34-.77v-1.73a11.29 11.29 0 0 0-2.09-.56l-.84 1.51h-1.54l-.84-1.51a11.29 11.29 0 0 0-2.09.56v1.73a8.46 8.46 0 0 0-1.34.77l-1.48-.89a10.61 10.61 0 0 0-1.53 1.54l.89 1.47a7.75 7.75 0 0 0-.77 1.34h-1.73a10.56 10.56 0 0 0-.56 2.09l1.51.84v1.54l-1.51.84a10.56 10.56 0 0 0 .56 2.09h1.73a7.75 7.75 0 0 0 .77 1.34l-.89 1.48a11.06 11.06 0 0 0 1.53 1.53l1.48-.89a7.75 7.75 0 0 0 1.34.77v1.73a10.56 10.56 0 0 0 2.09.56l.84-1.51h1.54l.84 1.51a10.56 10.56 0 0 0 2.09-.56v-1.73a7.75 7.75 0 0 0 1.34-.77l1.47.89a10.61 10.61 0 0 0 1.54-1.53l-.89-1.48a8.46 8.46 0 0 0 .77-1.34h1.73a11.29 11.29 0 0 0 .56-2.09l-1.51-.84v-.77zm-8.71 5.92a5.92 5.92 0 1 1 5.92-5.92 5.92 5.92 0 0 1-5.96 5.92h.04zM354.62 248.51c0-.39 0-.77-.05-1.15l2.25-1.26a15.05 15.05 0 0 0-.82-3.1l-2.57.05a13.7 13.7 0 0 0-1.16-2l1.33-2.21a15.09 15.09 0 0 0-2.3-2.29l-2.21 1.32a13 13 0 0 0-2-1.15v-2.58a15.52 15.52 0 0 0-3.13-.84l-1.25 2.26a11.15 11.15 0 0 0-2.31 0l-1.25-2.26a15.52 15.52 0 0 0-3.13.84v2.58a13 13 0 0 0-2 1.15l-2.22-1.32a15.49 15.49 0 0 0-2.29 2.29l1.33 2.21a13.7 13.7 0 0 0-1.16 2l-2.58-.05a15.7 15.7 0 0 0-.84 3.13l2.26 1.26c0 .38-.05.76-.05 1.15s0 .77.05 1.15l-2.26 1.26a15.7 15.7 0 0 0 .84 3.13l2.58-.05a13.2 13.2 0 0 0 1.16 2l-1.33 2.21a15.49 15.49 0 0 0 2.29 2.29l2.22-1.32a12.26 12.26 0 0 0 2 1.15v2.58a15.52 15.52 0 0 0 3.13.84l1.25-2.26a11.15 11.15 0 0 0 2.31 0l1.25 2.26a15.52 15.52 0 0 0 3.13-.84v-2.58a12.26 12.26 0 0 0 2-1.15l2.21 1.32a15.09 15.09 0 0 0 2.3-2.29l-1.35-2.24a13.2 13.2 0 0 0 1.16-2l2.57.05a15.05 15.05 0 0 0 .84-3.13l-2.25-1.26c.03-.38.05-.76.05-1.15zm-13 5.14a5.14 5.14 0 1 1 5.14-5.14 5.14 5.14 0 0 1-5.18 5.14h.04zM152.16 208.87h-11.78a7.66 7.66 0 0 0-7.66 7.67v11.77a7.67 7.67 0 0 0 7.66 7.67h11.78a7.67 7.67 0 0 0 7.66-7.67v-11.77a7.66 7.66 0 0 0-7.66-7.67zm-5.89 22s-6.37-6.94-6.37-10.46a6.37 6.37 0 1 1 12.74 0c0 3.49-6.37 10.43-6.37 10.43v.03z"
/>
<path
  fill="#f0f0f0"
  d="M146.27 217.48a2.91 2.91 0 1 0 2.91 2.9 2.9 2.9 0 0 0-2.91-2.9zM390 121h-12.43a7.07 7.07 0 0 0-7.08 7.07v12.44a7.07 7.07 0 0 0 7.08 7.07H390a7.06 7.06 0 0 0 7.07-7.07V128a7.06 7.06 0 0 0-7.07-7zm1.66 9.09a5.84 5.84 0 0 1-1.13 1.09.08.08 0 0 0-.05.09 8 8 0 0 1-.08 1.39 9.11 9.11 0 0 1-.76 2.79 9.24 9.24 0 0 1-1.64 2.45 8.26 8.26 0 0 1-4.3 2.4 9.52 9.52 0 0 1-1.76.22 9.11 9.11 0 0 1-5-1.36h-.08a6.69 6.69 0 0 0 4.65-1.27 3.19 3.19 0 0 1-2.95-2.18 3.24 3.24 0 0 0 1.35 0 3.19 3.19 0 0 1-2.06-1.45 3.12 3.12 0 0 1-.48-1.66 3.23 3.23 0 0 0 1.37.38 3.22 3.22 0 0 1-1.29-1.91 3.06 3.06 0 0 1 .31-2.27 9.12 9.12 0 0 0 6.52 3.28 1.35 1.35 0 0 0-.06-.35 3.08 3.08 0 0 1 .43-2.06 3 3 0 0 1 2.12-1.38 3.09 3.09 0 0 1 2.73.87.17.17 0 0 0 .18.05 6.33 6.33 0 0 0 1.81-.69 3.2 3.2 0 0 1-1.25 1.63 5.93 5.93 0 0 0 1.74-.48l-.32.42z"
/>
<rect
  width="28.45"
  height="28.45"
  x="108.51"
  y="112.84"
  fill="#f0f0f0"
  rx="7.57"
/>
<path
  fill="#fff"
  d="M125.92 122.54v4a3 3 0 0 1-3 3h-3.83l-4.37 4.37v-4.37a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h8.2a3 3 0 0 1 3 3z"
/>
<path
  fill="#fff"
  d="M133.75 128.59v3.08a2.31 2.31 0 0 1-2.31 2.31v3.36l-3.36-3.34h-2.94a2.31 2.31 0 0 1-2.31-2.31v-3.08a2.31 2.31 0 0 1 2.31-2.32h6.3a2.31 2.31 0 0 1 2.31 2.3z"
/>
<path
  fill="#ebebeb"
  d="M122.75 122.79h-7.42a.34.34 0 1 1 0-.68h7.42a.34.34 0 0 1 0 .68zM122.75 124.52h-7.42a.34.34 0 1 1 0-.68h7.42a.34.34 0 1 1 0 .68zM120.68 126.25h-5.35a.34.34 0 1 1 0-.68h5.35a.34.34 0 1 1 0 .68z"
/>
<path
  d="M295.9 175.59h-1v-10.73a7.81 7.81 0 0 0-7.79-7.8h-19.75a8.81 8.81 0 0 1-8.8-8.8V140h1v8.28a7.81 7.81 0 0 0 7.8 7.8h19.75a8.8 8.8 0 0 1 8.79 8.8v10.71zM303 175.8h-13a4.76 4.76 0 0 0-4.76 4.75v13a4.76 4.76 0 0 0 4.76 4.75h13a4.76 4.76 0 0 0 4.76-4.75v-13a4.76 4.76 0 0 0-4.76-4.75z"
/>
<path
  fill="#fff"
  d="M303 175.8h-13a4.76 4.76 0 0 0-4.76 4.75v13a4.76 4.76 0 0 0 4.76 4.75h13a4.76 4.76 0 0 0 4.76-4.75v-13a4.76 4.76 0 0 0-4.76-4.75z"
  opacity=".4"
/>
<path
  fill="#fff"
  d="M296.4 177.92a8.94 8.94 0 1 0 8.93 8.93 8.95 8.95 0 0 0-8.93-8.93zm-1.42 1a10.13 10.13 0 0 0-2.08 3h-2.83a8 8 0 0 1 4.93-2.99l-.02-.01zm-5.52 3.84h3.06a12.21 12.21 0 0 0-.79 3.58v.21h-3.35a8.13 8.13 0 0 1 1.08-3.78v-.01zm.18 8.45a8.07 8.07 0 0 1-1.27-3.78h3.38a12.3 12.3 0 0 0 1 3.78h-3.11zm.66.88h2.87a9.6 9.6 0 0 0 2.16 2.73 8 8 0 0 1-5.03-2.72v-.01zm5.66 2.11a8.59 8.59 0 0 1-1.77-2.11H296l-.04 2.11zm0-3h-2.25a11.46 11.46 0 0 1-1.07-3.78H296l-.04 3.78zm0-4.66h-3.35a10.94 10.94 0 0 1 .86-3.79H296l-.04 3.79zm0-4.67h-2.08a8.72 8.72 0 0 1 2.08-2.65v2.65zm8.49 4.67h-3.36v-.21a11.9 11.9 0 0 0-.79-3.58h3.06a8 8 0 0 1 1.09 3.81v-.02zm-1.72-4.67h-2.82a10.35 10.35 0 0 0-2.09-3 8 8 0 0 1 4.91 3.02v-.02zm-5.89-2.64a8.55 8.55 0 0 1 2.08 2.64h-2.08v-2.64zm0 3.52h2.49a11 11 0 0 1 .87 3.79h-3.36v-3.79zm0 4.67h3.32a11.23 11.23 0 0 1-1.07 3.78h-2.25v-3.78zm0 6.77v-2.09h1.77a8.2 8.2 0 0 1-1.77 2.11v-.02zm.63.62a9.6 9.6 0 0 0 2.16-2.73h2.87a8 8 0 0 1-5.03 2.75v-.02zm5.69-3.61h-3.1a12.3 12.3 0 0 0 1-3.78h3.38a8 8 0 0 1-1.28 3.8v-.02z"
/>
<path
  d="M336.25 159h-1v-10.73a7.79 7.79 0 0 0-7.79-7.79h-47.13v-1h47.13a8.8 8.8 0 0 1 8.79 8.79V159z"
/>
<path
  d="M339.48 151.22h-13a4.76 4.76 0 0 0-4.76 4.75v13a4.76 4.76 0 0 0 4.76 4.75h13a4.76 4.76 0 0 0 4.76-4.75V156a4.76 4.76 0 0 0-4.76-4.78z"
/>
<path
  fill="#fff"
  d="M339.48 151.22h-13a4.76 4.76 0 0 0-4.76 4.75v13a4.76 4.76 0 0 0 4.76 4.75h13a4.76 4.76 0 0 0 4.76-4.75V156a4.76 4.76 0 0 0-4.76-4.78z"
  opacity=".4"
/>
<path
  fill="#fff"
  d="M334.5 156.26a5.46 5.46 0 1 0-.77 8.36 1.2 1.2 0 0 0 .34.66l3.39 3.39a1.22 1.22 0 1 0 1.73-1.73l-3.39-3.39a1.2 1.2 0 0 0-.67-.34 5.46 5.46 0 0 0-.63-6.95zm-1.16 6.56a3.83 3.83 0 1 1 0-5.41 3.82 3.82 0 0 1 0 5.41z"
  opacity=".9"
/>
<path d="M279.21 122.44h60.32v1h-60.32z" />
<path
  d="M349.07 105.28h-12.95a4.75 4.75 0 0 0-4.75 4.76V123a4.75 4.75 0 0 0 4.75 4.76h12.95a4.76 4.76 0 0 0 4.76-4.76v-13a4.76 4.76 0 0 0-4.76-4.72z"
/>
<path
  fill="#fff"
  d="M349.07 105.28h-12.95a4.75 4.75 0 0 0-4.75 4.76V123a4.75 4.75 0 0 0 4.75 4.76h12.95a4.76 4.76 0 0 0 4.76-4.76v-13a4.76 4.76 0 0 0-4.76-4.72z"
  opacity=".4"
/>
<g fill="#fff" opacity=".5">
  <path
    d="M339.44 122.94a1.69 1.69 0 1 1-1.69-1.69 1.68 1.68 0 0 1 1.69 1.69zM346 122.94a1.69 1.69 0 1 1-1.69-1.69 1.68 1.68 0 0 1 1.69 1.69z"
  />
</g>
<path
  fill="#fff"
  d="M345.72 120.39h-9.82a.46.46 0 0 1-.43-.32l-2.06-6.83a.44.44 0 0 1 .07-.4.45.45 0 0 1 .36-.18h13.94a.47.47 0 0 1 .37.18.47.47 0 0 1 .07.4l-2.07 6.83a.45.45 0 0 1-.43.32zm-9.48-.9h9.15l1.79-5.93h-12.74l1.8 5.93z"
/>
<path
  fill="#fff"
  d="M347.78 113.56h-.12a.45.45 0 0 1-.31-.56l.79-2.75a1.73 1.73 0 0 1 1.66-1.25h1.56a.45.45 0 1 1 0 .9h-1.56a.83.83 0 0 0-.79.6l-.79 2.75a.46.46 0 0 1-.44.31z"
/>
<path
  d="M297 109.08h-19.62v-1H297a7.79 7.79 0 0 0 7.79-7.79V89.56h1v10.73a8.8 8.8 0 0 1-8.79 8.79z"
/>
<rect width="22.56" height="22.56" x="294.05" y="72.43" rx="4.4" />
<rect
  width="22.56"
  height="22.56"
  x="294.05"
  y="72.43"
  fill="#fff"
  opacity=".4"
  rx="4.4"
/>
<path
  fill="#fff"
  d="M313.88 86.07c0 .24 0 1.09-.05 1.33h-7.71v-3.68h1.05L305 81.54l-2.18 2.18h1.05v3.68h-7.24v-1a3.87 3.87 0 0 1 3.5-3.85v-.15A4.54 4.54 0 0 1 309 81a5.29 5.29 0 0 1 .81.08 5 5 0 0 1 4.07 4.99z"
/>
<path d="M250.65 83.46h1v20.55h-1z" />
<path
  d="M257.63 63.86h-12.95a4.76 4.76 0 0 0-4.76 4.76v12.95a4.76 4.76 0 0 0 4.76 4.76h12.95a4.75 4.75 0 0 0 4.75-4.76V68.62a4.75 4.75 0 0 0-4.75-4.76z"
/>
<path
  fill="#fff"
  d="M257.63 63.86h-12.95a4.76 4.76 0 0 0-4.76 4.76v12.95a4.76 4.76 0 0 0 4.76 4.76h12.95a4.75 4.75 0 0 0 4.75-4.76V68.62a4.75 4.75 0 0 0-4.75-4.76z"
  opacity=".4"
/>
<path
  d="M253.23 76.57v-.44l.91-.36a5.6 5.6 0 0 0-.16-1.23l-1-.11a4.75 4.75 0 0 0-.33-.81l.61-.77a6.52 6.52 0 0 0-.75-1l-.9.39a5.22 5.22 0 0 0-.7-.54l.14-1a5.27 5.27 0 0 0-1.14-.48l-.58.79L249 71h-.43l-.37-.92a6.27 6.27 0 0 0-1.22.16l-.11 1a4.56 4.56 0 0 0-.82.34l-.77-.62a6 6 0 0 0-1 .76l.39.9a5.35 5.35 0 0 0-.53.7l-1-.15a6.35 6.35 0 0 0-.47 1.14l.79.59c0 .14-.06.28-.08.43a3.25 3.25 0 0 0 0 .44l-.92.36a5.6 5.6 0 0 0 .16 1.23l1 .11a5.73 5.73 0 0 0 .33.81l-.61.77a6.52 6.52 0 0 0 .75 1l.91-.39a4.57 4.57 0 0 0 .69.54l-.14 1a5.47 5.47 0 0 0 1.14.47l.58-.79.44.08h.44l.36.91a5.51 5.51 0 0 0 1.22-.16l.11-1a4.56 4.56 0 0 0 .82-.34l.77.61a5.42 5.42 0 0 0 1-.75l-.39-.9a5.15 5.15 0 0 0 .53-.7l1 .15a6.35 6.35 0 0 0 .47-1.14l-.79-.59c-.07-.19-.04-.34-.02-.48zM248 77.86a2 2 0 1 1 2.2-1.69 2 2 0 0 1-2.2 1.69z"
/>
<path
  fill="#fff"
  d="M253.23 76.57v-.44l.91-.36a5.6 5.6 0 0 0-.16-1.23l-1-.11a4.75 4.75 0 0 0-.33-.81l.61-.77a6.52 6.52 0 0 0-.75-1l-.9.39a5.22 5.22 0 0 0-.7-.54l.14-1a5.27 5.27 0 0 0-1.14-.48l-.58.79L249 71h-.43l-.37-.92a6.27 6.27 0 0 0-1.22.16l-.11 1a4.56 4.56 0 0 0-.82.34l-.77-.62a6 6 0 0 0-1 .76l.39.9a5.35 5.35 0 0 0-.53.7l-1-.15a6.35 6.35 0 0 0-.47 1.14l.79.59c0 .14-.06.28-.08.43a3.25 3.25 0 0 0 0 .44l-.92.36a5.6 5.6 0 0 0 .16 1.23l1 .11a5.73 5.73 0 0 0 .33.81l-.61.77a6.52 6.52 0 0 0 .75 1l.91-.39a4.57 4.57 0 0 0 .69.54l-.14 1a5.47 5.47 0 0 0 1.14.47l.58-.79.44.08h.44l.36.91a5.51 5.51 0 0 0 1.22-.16l.11-1a4.56 4.56 0 0 0 .82-.34l.77.61a5.42 5.42 0 0 0 1-.75l-.39-.9a5.15 5.15 0 0 0 .53-.7l1 .15a6.35 6.35 0 0 0 .47-1.14l-.79-.59c-.07-.19-.04-.34-.02-.48zM248 77.86a2 2 0 1 1 2.2-1.69 2 2 0 0 1-2.2 1.69z"
/>
<g fill="#fff" opacity=".5">
  <path
    d="M257.33 73.52a2.55 2.55 0 0 1-1.17-4.82v1.61a1.19 1.19 0 0 0 .35.83 1.16 1.16 0 0 0 .82.34 1.17 1.17 0 0 0 1.17-1.17V68.7a2.55 2.55 0 0 1-1.17 4.82z"
  />
  <path
    d="M256.17 79.89v-7.08a1.16 1.16 0 0 1 1.16-1.17 1.16 1.16 0 0 1 1.16 1.17v7.08a1.16 1.16 0 0 1-1.16 1.16 1.16 1.16 0 0 1-1.16-1.16z"
  />
</g>
<path
  d="M207.79 175.59h-1v-10.73a8.81 8.81 0 0 1 8.8-8.8h19.74a7.81 7.81 0 0 0 7.8-7.8V140h1v8.28a8.81 8.81 0 0 1-8.8 8.8h-19.74a7.81 7.81 0 0 0-7.8 7.8v10.71z"
/>
<path
  d="M213.27 174.33h-13a4.76 4.76 0 0 0-4.76 4.76V192a4.75 4.75 0 0 0 4.76 4.75h13A4.75 4.75 0 0 0 218 192v-12.91a4.76 4.76 0 0 0-4.73-4.76z"
/>
<path
  fill="#fff"
  d="M213.27 174.33h-13a4.76 4.76 0 0 0-4.76 4.76V192a4.75 4.75 0 0 0 4.76 4.75h13A4.75 4.75 0 0 0 218 192v-12.91a4.76 4.76 0 0 0-4.73-4.76z"
  opacity=".4"
/>
<path
  fill="#fff"
  d="M214.85 190.94a1.45 1.45 0 1 1-1.45-1.45 1.45 1.45 0 0 1 1.45 1.45zM208.43 190.94a1.45 1.45 0 1 1-1.45-1.45 1.45 1.45 0 0 1 1.45 1.45zM202 190.94a1.46 1.46 0 1 1-1.46-1.45 1.45 1.45 0 0 1 1.46 1.45z"
/>
<path
  fill="#fff"
  d="M213.73 193.84h-13.57a2.82 2.82 0 0 1-2.82-2.82v-.16a2.82 2.82 0 0 1 2.82-2.82h13.57a2.82 2.82 0 0 1 2.82 2.82v.14a2.82 2.82 0 0 1-2.82 2.84zm-13.57-4.9a1.92 1.92 0 0 0-1.92 1.92v.14a1.92 1.92 0 0 0 1.92 1.92h13.57a1.92 1.92 0 0 0 1.92-1.92v-.16a1.92 1.92 0 0 0-1.92-1.92l-13.57.02z"
/>
<path
  fill="#fff"
  d="M213.6 188.91a.9.9 0 0 1-.9-.9v-2.85l-5.7-5.95-3.27 1.07a.9.9 0 0 1-.56-1.71l3.8-1.25a.89.89 0 0 1 .93.23l6.39 6.62a.9.9 0 0 1 .25.62V188a.9.9 0 0 1-.94.91z"
/>
<path
  fill="#fff"
  d="M203.16 182.12a.45.45 0 0 1-.45-.45v-2.24a.45.45 0 1 1 .9 0v2.24a.45.45 0 0 1-.45.45z"
/>
<path
  fill="#fff"
  d="M202.46 183.81a.44.44 0 0 1-.32-.13 1.43 1.43 0 0 1-.42-1 1.45 1.45 0 0 1 2.89 0 1.48 1.48 0 0 1-.38 1 .45.45 0 0 1-.67-.61.51.51 0 0 0 .15-.37.55.55 0 0 0-.55-.54.54.54 0 0 0-.54.54.57.57 0 0 0 .16.39.45.45 0 0 1 0 .63.44.44 0 0 1-.32.09z"
/>
<path
  d="M207.55 178.22a.36.36 0 1 1-.36-.35.36.36 0 0 1 .36.35zM213.89 184.84a.36.36 0 1 1-.36-.36.36.36 0 0 1 .36.36z"
/>
<path fill="#fff" d="M201.8 184.81h2.73v2.73h-2.73z" opacity=".4" />
<path
  d="M216 109.08h-19.65a8.8 8.8 0 0 1-8.8-8.79V89.56h1v10.73a7.8 7.8 0 0 0 7.8 7.79H216v1z"
/>
<rect width="22.46" height="22.46" x="178.7" y="71.4" rx="4.76" />
<rect
  width="22.46"
  height="22.46"
  x="178.7"
  y="71.4"
  fill="#fff"
  opacity=".4"
  rx="4.76"
/>
<path
  fill="#fff"
  d="M189.93 76c2 0 3 1.58 3 3.54s-1.05 3.54-3 3.54-3-1.59-3-3.54 1.07-3.54 3-3.54zM197.75 89.27h-15.64a.48.48 0 0 1-.33-.14l1-2.74a4.47 4.47 0 0 1 4.2-2.93h5.9a4.46 4.46 0 0 1 4.2 2.93l1 2.74a.48.48 0 0 1-.33.14z"
/>
<path
  d="M170.58 159h-1v-10.73a8.8 8.8 0 0 1 8.8-8.79h47.12v1h-47.12a7.8 7.8 0 0 0-7.8 7.79V159z"
/>
<rect width="22.46" height="22.46" x="159.24" y="151.07" rx="4.76" />
<rect
  width="22.46"
  height="22.46"
  x="159.24"
  y="151.07"
  fill="#fff"
  opacity=".4"
  rx="4.76"
/>
<path
  fill="#fff"
  d="M163.06 164.35h2.79v5.37h-2.79zM170.97 162.54h2.79v7.18h-2.79z"
  opacity=".6"
/>
<path
  fill="#fff"
  d="M166.87 160.73h2.79v8.99h-2.79zM174.94 158.92h2.79v10.8h-2.79z"
/>
<path d="M168.95 122.44h60.32v1h-60.32z" />
<path
  d="M170.88 105h-12.95a4.76 4.76 0 0 0-4.76 4.76v12.95a4.76 4.76 0 0 0 4.76 4.76h12.95a4.75 4.75 0 0 0 4.75-4.76v-12.92a4.75 4.75 0 0 0-4.75-4.79z"
/>
<path
  fill="#fff"
  d="M170.88 105h-12.95a4.76 4.76 0 0 0-4.76 4.76v12.95a4.76 4.76 0 0 0 4.76 4.76h12.95a4.75 4.75 0 0 0 4.75-4.76v-12.92a4.75 4.75 0 0 0-4.75-4.79z"
  opacity=".4"
/>
<path
  d="M164.9 108v2.08a6.25 6.25 0 0 1 3.53 1.46l1.47-1.47a8.28 8.28 0 0 0-5-2.07z"
/>
<path
  fill="#fff"
  d="M164.9 108v2.08a6.25 6.25 0 0 1 3.53 1.46l1.47-1.47a8.28 8.28 0 0 0-5-2.07z"
  opacity=".6"
/>
<path
  d="M163.89 122.47a6.21 6.21 0 0 1-5.7-5.7h-2.08a8.3 8.3 0 0 0 7.78 7.78v-2.08z"
/>
<path
  fill="#fff"
  d="M163.89 122.47a6.21 6.21 0 0 1-5.7-5.7h-2.08a8.3 8.3 0 0 0 7.78 7.78v-2.08z"
  opacity=".8"
/>
<path
  d="M158.19 115.76a6.22 6.22 0 0 1 5.7-5.7V108a8.3 8.3 0 0 0-7.78 7.78l2.08-.02z"
/>
<path
  fill="#fff"
  d="M158.19 115.76a6.22 6.22 0 0 1 5.7-5.7V108a8.3 8.3 0 0 0-7.78 7.78l2.08-.02z"
  opacity=".7"
/>
<path
  fill="#fff"
  d="m170.61 110.76-1.47 1.47a6.23 6.23 0 0 1-4.24 10.24v2.08a8.3 8.3 0 0 0 5.71-13.79z"
/>
<path
  d="m217.47 104.13 2.81-.12 3.95 43.61h-3c-1.49-.14-1.84-1.82-2.25-5l-2.76-30.45c-.64-7.17.59-8.04 1.25-8.04z"
/>
<path
  d="m217.47 104.13 2.81-.12 3.95 43.61h-3c-1.49-.14-1.84-1.82-2.25-5l-2.76-30.45c-.64-7.17.59-8.04 1.25-8.04z"
  opacity=".3"
/>
<path
  d="M222 147.62h59.11a1.15 1.15 0 0 0 1.05-1.37l-3.69-40.88a1.44 1.44 0 0 0-1.31-1.36H218a1.15 1.15 0 0 0-1.06 1.36l3.7 40.88a1.43 1.43 0 0 0 1.36 1.37z"
/>
<path d="M224.22 142.45h53.68l-2.98-34.03h-53.68l2.98 34.03z" />
<path
  fill="#263238"
  d="M225 145.12h52.89a2.45 2.45 0 0 0 2.48-2.72l-2.95-33.82a3 3 0 0 0-3-2.71h-52.89a2.44 2.44 0 0 0-2.48 2.71L222 142.4a3 3 0 0 0 3 2.72z"
/>
<path fill="#fff" d="M224.22 143.45h53.68l-2.98-34.03h-53.68l2.98 34.03z" />
<path d="m221.24 108.42.27 3.05h53.68l-.27-3.05h-53.68z" />
<path
  fill="#fff"
  d="M223.71 109.78a.55.55 0 0 1-.56.61.68.68 0 0 1-.67-.61.56.56 0 0 1 .56-.62.69.69 0 0 1 .67.62zM225.33 109.78a.55.55 0 0 1-.56.61.68.68 0 0 1-.67-.61.56.56 0 0 1 .56-.62.69.69 0 0 1 .67.62zM227 109.78a.55.55 0 0 1-.56.61.68.68 0 0 1-.67-.61.56.56 0 0 1 .56-.62.69.69 0 0 1 .67.62z"
/>
<rect width="62.81" height="3.33" x="221.39" y="147.74" rx="1.28" />
<path
  d="M245.29 147.74h62.29v.76a2.57 2.57 0 0 1-2.57 2.57h-57.15a2.57 2.57 0 0 1-2.57-2.57v-.76z"
/>
<path
  fill="#fff"
  d="M245.29 147.74h62.29v.76a2.57 2.57 0 0 1-2.57 2.57h-57.15a2.57 2.57 0 0 1-2.57-2.57v-.76z"
  opacity=".3"
/>
<path
  d="M271.36 147.83a1.67 1.67 0 0 0 1.67 1.66h7.62a1.66 1.66 0 0 0 1.66-1.66h-10.95z"
  opacity=".3"
/>
<path
  fill="#FFAC8D"
  d="m193.28 215.42-6.44-1.87a8.51 8.51 0 0 0-1.93-.41l-4.32-.18-3.53-1.48a1.34 1.34 0 0 0-2 1l-.23 2.38a1.36 1.36 0 0 0 .57 1.23l5.2 3.64 7.27-1.22 6.52 3.15.77-5.66-1.88-.58zM306.72 217.18l6.52-1.59a9.05 9.05 0 0 1 1.94-.33h4.32l3.59-1.32a1.33 1.33 0 0 1 2 1.09l.13 2.39a1.34 1.34 0 0 1-.61 1.2l-5.36 3.42-7.25-1.53-6.65 2.87-.52-5.68 1.89-.52zM233.84 398.44l-1.54 14.15-7.73-.82.79-15.43 8.48 2.1z"
/>
<path
  d="M220.93 411.91a3.29 3.29 0 0 1-2.26-.77.69.69 0 0 1 .07-.8.94.94 0 0 1 .62-.39c1.33-.26 3.95 1.5 4.06 1.58a.18.18 0 0 1 .08.2.19.19 0 0 1-.16.14 12.94 12.94 0 0 1-2.41.04zm-1.14-1.61a1 1 0 0 0-.35 0 .52.52 0 0 0-.39.23c-.15.22-.11.33-.06.4.32.54 2.29.7 3.77.63a8.53 8.53 0 0 0-2.97-1.26z"
/>
<path
  d="M223.31 411.87a.11.11 0 0 1-.08 0c-.9-.48-2.66-2.32-2.42-3.19 0-.21.21-.46.72-.47a1.36 1.36 0 0 1 1 .4c.94.89 1 3 1 3.12a.18.18 0 0 1-.09.16l-.13-.02zm-1.68-3.32h-.1c-.34 0-.37.14-.39.19-.09.52 1.05 1.94 2 2.59a4.36 4.36 0 0 0-.85-2.48 1 1 0 0 0-.63-.28l-.03-.02z"
/>
<path
  fill="#263238"
  d="m224.22 410.83 8.54.65a.68.68 0 0 1 .64.58l1 7.07a1.16 1.16 0 0 1-1 1.31h-.25c-3.07-.29-5.8-.66-9.63-.94-4.53-.34-3.42.29-8.75 0-3.21-.19-3.52-3.88-2.15-4 6.28-.32 7.07-2.15 9.64-4.19a2.79 2.79 0 0 1 1.96-.48z"
/>
<path
  d="m224.92 404.9 5.77-.21 2.36.98-.32 2.99-7.99-.47.18-3.29z"
  opacity=".2"
/>
<path
  d="m253.44 255.89-14.83 88.69-3.61 62.19-11.61-.2a414.48 414.48 0 0 1-1.87-67.06c1.81-32.93 9.47-71.44 10.32-82.42l4.29-7.58 8.54 1.07 8.77 5.31z"
/>
<path
  fill="#FFAC8D"
  d="m275.81 414.22 6.6-.75s-.19-2.72-.52-7.11c-.07-1-.15-2-.23-3.17l-7.58 1.35H274c0 .17.07.34.1.5.16.89.33 1.71.47 2.5.75 4.13 1.24 6.68 1.24 6.68z"
/>
<path
  d="M283.66 411.12a.21.21 0 0 1-.18-.13.19.19 0 0 1 .06-.2c.11-.09 2.56-2.09 3.92-1.94a1 1 0 0 1 .65.33.7.7 0 0 1 .14.8c-.25.47-1.22.81-2.18 1a15 15 0 0 1-2.41.14zm.55-.35c1.48-.06 3.43-.39 3.71-1 0-.07.07-.19-.1-.39a.51.51 0 0 0-.41-.2 1.45 1.45 0 0 0-.36 0 8.81 8.81 0 0 0-2.84 1.59z"
/>
<path
  d="M283.56 411.12a.16.16 0 0 1-.11-.15c0-.1-.15-2.23.71-3.2a1.34 1.34 0 0 1 1-.48c.52 0 .72.19.77.4.31.85-1.28 2.84-2.14 3.4a.1.1 0 0 1-.07 0 .15.15 0 0 1-.16.03zm1.5-3.47a1 1 0 0 0-.59.34 4.4 4.4 0 0 0-.64 2.55c.87-.73 1.87-2.25 1.74-2.76 0 0-.07-.18-.4-.15h-.11v.02z"
/>
<path
  fill="#263238"
  d="m282.19 410.33-6.74 1a.7.7 0 0 0-.58.65l-.39 7.14a1.14 1.14 0 0 0 1.07 1.22 1 1 0 0 0 .25 0c3-.56 4-.82 7.8-1.44 4.49-.74 3.44 0 8.73-.81 3.18-.49 3.17-4.19 1.79-4.15-6.29.27-11.27-3.75-11.93-3.61z"
/>
<path
  d="m274.54 407.55 7.35-1.19c-.07-1-.15-2-.23-3.17l-7.58 1.35v.51c.15.89.32 1.71.46 2.5zM249.89 276.49l-4 23.71c-1.19-17 .4-37.23.4-37.23l3.6 13.52z"
  opacity=".2"
/>
<path
  d="M266.16 253.68s9.42 68.44 12.93 86.05c3.12 15.64 3.69 65.11 3.69 65.11L272.45 406s-5.9-27.22-7.85-46.36c-.68-6.68-.49-12.28-1.1-15.72-.81-4.54-27.15-77.84-22.25-89.41l24.91-.83z"
/>
<path
  fill="#263238"
  d="M231.44 244.5a50.77 50.77 0 0 0 .25-8.92c-2.37-28.3-3.22-30-3-35a2.19 2.19 0 0 1 1.47-2c19.58-6.66 34.81-3.5 39.23-1 5.89 3.32 3.54 6.87 3.47 7.88-.57 8.39-5.19 23.94-5.29 37.55 0 2 .2 6.8.33 9.46a2.19 2.19 0 0 1-1.75 2.25c-4.39.91-23.65 1.15-27.26 1-3.45-.12-5.72-.33-7.17-.52a2.18 2.18 0 0 1-1.83-2.64c.56-2.39 1.38-6.29 1.55-8.06z"
/>
<path
  fill="#FFAC8D"
  d="M255 181.39c-.74 4.38-.44 10.81 2.69 13.66 0 0-.06 4.46-12.3 9.58-4.62-6.28-1.34-9.25-1.34-9.25 4.87-1.28 3.69-3.27 2.76-6.65l8.19-7.34z"
/>
<path
  d="m251.67 184.34-4.82 4.39a13.86 13.86 0 0 1 .48 2.39c1.87-.31 4.76-2 5.11-4a5.89 5.89 0 0 0-.77-2.78z"
  opacity=".2"
/>
<path
  fill="#FFAC8D"
  d="M260.52 173.75c-1.78 7.21-2.39 10.29-6.76 13.35-6.58 4.62-15 .84-15.45-6.76-.36-6.84 2.64-17.52 10.31-19.07a10.14 10.14 0 0 1 11.9 12.48z"
/>
<path
  fill="#263238"
  d="M248 172.82c-.12.59-.52 1-.9 1s-.62-.62-.51-1.21.52-1 .9-.95.6.59.51 1.16zM241.36 171.66c-.11.6-.52 1-.9 1s-.62-.62-.51-1.21.52-1 .9-.94.62.55.51 1.15z"
/>
<path
  fill="#CC7C65"
  d="M243.71 173.75a16.15 16.15 0 0 1-2.82 3.4 2.61 2.61 0 0 0 2.05.79l.77-4.19z"
/>
<path
  fill="#263238"
  d="M245.74 180.86a5.39 5.39 0 0 1-.89-.1.17.17 0 0 1-.14-.2.17.17 0 0 1 .21-.14 4.81 4.81 0 0 0 4.17-1.14.18.18 0 0 1 .26.25 5 5 0 0 1-3.61 1.33zM251.17 171.91a.34.34 0 0 1-.37-.19 4.18 4.18 0 0 0-2.81-1.84.36.36 0 0 1-.3-.41.35.35 0 0 1 .4-.29 4.8 4.8 0 0 1 3.34 2.23.36.36 0 0 1-.16.47.23.23 0 0 1-.1.03zM240.19 169.35a.36.36 0 0 1-.35-.11.35.35 0 0 1 0-.5 3.48 3.48 0 0 1 3.13-.93.33.33 0 0 1 .26.4.35.35 0 0 1-.42.26 2.81 2.81 0 0 0-2.45.77.34.34 0 0 1-.17.11zM259 194.61l-1.29-.22-7.17 3.91-2.22.08-4.26-3.62-1.43.34a25.27 25.27 0 0 0-.74 12.71l2.41 12.1 2.52 13.25.54-1.22 2-4.56 2.74-5.2 5-12.72 1.42-5.24a22.23 22.23 0 0 0 .43-9.6l.05-.01z"
/>
<path
  d="M251.27 198.39c-7.69.07-8.54-2.76-8.54-2.76V195s-2.32 4.37 4.35 5.14 11.12-2.39 12.07-4.29c-.74.96-2.73 2.5-7.88 2.54z"
  opacity=".2"
/>
<path
  fill="#263238"
  d="M260.24 163.84a6.62 6.62 0 0 0-1.61-3.12 2.29 2.29 0 0 0-3.18-.07 6.38 6.38 0 0 0-5.26-2.14 5.74 5.74 0 0 0-4.51 2.92c-.89 1.65-3.7 2.23-5.56 2.42 1.22 1.23 4.24 2 5.75 1.17-.37.58-2.06.89-2.75 1a9.65 9.65 0 0 0 3.63 1.29 3.24 3.24 0 0 0 3.24-1.66 2.51 2.51 0 0 0 .33 3 2.54 2.54 0 0 0 3 .48 1.43 1.43 0 0 1-1-1.47 1.67 1.67 0 0 1 1.16-1.54 3.56 3.56 0 0 0 1.27 2.37c.66.51 1.24.72 1.65 1.45s-.08 2.5-1.39 2.38c.59.63 3 .4 3.27-.42a7.32 7.32 0 0 1-3.62 4.93 4.62 4.62 0 0 1 1.4.3 2 2 0 0 1 1.27.91 2.85 2.85 0 0 1-.09 2.18 45.6 45.6 0 0 1-2.16 5.44 8.16 8.16 0 0 0 5.39-4.69 5.49 5.49 0 0 0 3.69-5.57 7.1 7.1 0 0 0 2.28-4 3.07 3.07 0 0 0-2.3-3.38 3.55 3.55 0 0 0-.54-3.6 2.41 2.41 0 0 0-3.36-.58z"
/>
<path
  fill="#FFAC8D"
  d="M260.22 179a5 5 0 0 1-3 2.34c-1.69.45-2.52-1.08-2-2.68.45-1.43 1.87-3.39 3.57-3.16a2.25 2.25 0 0 1 1.84 2.6 2.15 2.15 0 0 1-.41.9z"
/>
<path
  fill="#263238"
  d="m257 173.81-4.92-.84c-.41-1.26-2.19-1.56-2.94-1.69s-2.66-.45-3.42.76l-1.71-.3c-.32-1.38-2.2-1.71-3-1.84s-3.35-.57-3.71 1.51a3.42 3.42 0 0 0 6.7 1.15 2 2 0 0 0 0-.34l1.47.25a2.66 2.66 0 0 0-.08.33 3.42 3.42 0 0 0 6.7 1.14 2.75 2.75 0 0 0 0-.49l4.76.82a2.82 2.82 0 0 1 1.67.94l.35-.3a3.29 3.29 0 0 0-1.87-1.1zm-16.76.72a2.78 2.78 0 0 1-2.46-3c.2-1.14 1.14-1.48 3.17-1.14s2.81 1 2.61 2.13a2.78 2.78 0 0 1-3.34 2.01h.02zm8.11 1.38a2.77 2.77 0 0 1-2.45-3c.19-1.14 1.14-1.48 3.17-1.13s2.8 1 2.61 2.12a2.78 2.78 0 0 1-3.35 2.01h.02zM192 214.46a61.6 61.6 0 0 0 22.6 1.54 56.61 56.61 0 0 1 15.6-17.5L233 209s-8.34 13.25-15.09 16.3c-5.35 2.42-21.4-1.89-27.84-3.79a16.15 16.15 0 0 1 1.93-7.05zM308.43 215.64a61.69 61.69 0 0 1-22.59 1 56.43 56.43 0 0 0-15.21-17.84l-3 10.43s8.05 13.44 14.74 16.63c5.29 2.53 21.43-1.43 27.91-3.18a16.23 16.23 0 0 0-1.85-7.04zM242.76 192.79v2.84s.6 3.08 8.29 3 8.59-3.71 8.59-3.71v-2.06a2.34 2.34 0 0 0-2.78-2.33 36.9 36.9 0 0 1-11.46 0 2.34 2.34 0 0 0-2.64 2.26z"
/>

`,
];
